import {
  InfiniteData,
  UseInfiniteQueryOptions,
  UseMutationOptions,
  UseQueryOptions,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseQueryOptions,
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery,
} from "@tanstack/react-query"

import { publicFetcher } from "./fetcher"

export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** Date (isoformat) */
  Date: { input: string; output: string }
  /** Date with time and offset (isoformat) */
  DateTime: { input: string; output: string }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](https://ecma-international.org/wp-content/uploads/ECMA-404_2nd_edition_december_2017.pdf). */
  JSON: { input: any; output: any }
  Upload: { input: any; output: any }
  /** Represents NULL values */
  Void: { input: any; output: any }
}

export type AiModel = {
  __typename?: "AIModel"
  name: Scalars["String"]["output"]
  provider: AiProvider
  tokenLimit: Scalars["Int"]["output"]
}

export enum AiProvider {
  Anthropic = "ANTHROPIC",
  Openai = "OPENAI",
}

export type AddRate = {
  __typename?: "AddRate"
  op: OpType
  rate: CustomRate
}

export type AddRateInput = {
  chargeClass: ChargeClass
  chargePeriod: ChargePeriod
  chargeType: ChargeType
  name?: InputMaybe<Scalars["String"]["input"]>
  price: Scalars["Float"]["input"]
  rateUnit: RateUnit
  transactionType?: InputMaybe<TransactionType>
}

export type AddRateSubRateOverrideProperty = AddRate | OverrideProperty | SubRate

export type AddScenarioResponse = Error | ScenarioRef

export type AddSystemInput =
  | { lite: SystemLiteInput; system?: never }
  | { lite?: never; system: SystemInput }

export type AdminBidsTable = {
  __typename?: "AdminBidsTable"
  rows: Array<AdminBidsTableRow>
  view: AdminBidsTableView
}

export type AdminBidsTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminBidsTableViewArgs = {
  filterBy?: InputMaybe<AdminBidsTableFilter>
  sortBy?: InputMaybe<Array<AdminBidsTableSort>>
}

export enum AdminBidsTableAttr {
  AssetManager = "ASSET_MANAGER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingOwnerExtraPaymentsUsd = "BUILDING_OWNER_EXTRA_PAYMENTS_USD",
  BuildingOwnerName = "BUILDING_OWNER_NAME",
  BuildingOwnerNoiLifetimeUsd = "BUILDING_OWNER_NOI_LIFETIME_USD",
  BuildingOwnerPid = "BUILDING_OWNER_PID",
  BundlePid = "BUNDLE_PID",
  City = "CITY",
  CreatedAt = "CREATED_AT",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExtraPaymentsNotes = "EXTRA_PAYMENTS_NOTES",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinproductType = "FINPRODUCT_TYPE",
  IncentivesNotes = "INCENTIVES_NOTES",
  InterconnectionCostNonUtilityUsd = "INTERCONNECTION_COST_NON_UTILITY_USD",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  InterconnectionCostUtilityMaxUsd = "INTERCONNECTION_COST_UTILITY_MAX_USD",
  InterconnectionCostUtilityMinUsd = "INTERCONNECTION_COST_UTILITY_MIN_USD",
  InterconnectionNotes = "INTERCONNECTION_NOTES",
  IsAwarded = "IS_AWARDED",
  IsCustom = "IS_CUSTOM",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Name = "NAME",
  OtherNotes = "OTHER_NOTES",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PvSizeKwAc = "PV_SIZE_KW_AC",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  PvTypes = "PV_TYPES",
  RecOwner = "REC_OWNER",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  SiteName = "SITE_NAME",
  SitePid = "SITE_PID",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  TermYears = "TERM_YEARS",
  UtilityId = "UTILITY_ID",
  UtilityName = "UTILITY_NAME",
  UtilityShortName = "UTILITY_SHORT_NAME",
  ZipCode = "ZIP_CODE",
}

export type AdminBidsTableFilter = {
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  biddingClosedAt?: InputMaybe<DatePred>
  biddingOpenAt?: InputMaybe<DatePred>
  buildingOwnerName?: InputMaybe<StringPred>
  buildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  bundlePid?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  createdAt?: InputMaybe<DatePred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  financierName?: InputMaybe<StringPred>
  financierPid?: InputMaybe<StringPred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  interconnectionCostNonUtilityUsd?: InputMaybe<FloatPred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  interconnectionCostUtilityMaxUsd?: InputMaybe<FloatPred>
  interconnectionCostUtilityMinUsd?: InputMaybe<FloatPred>
  isAwarded?: InputMaybe<BoolPred>
  isCustom?: InputMaybe<BoolPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pvSizeKwAc?: InputMaybe<FloatPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  sitePid?: InputMaybe<StringPred>
  state?: InputMaybe<UsStateMultiPred>
  termYears?: InputMaybe<FloatPred>
  utilityName?: InputMaybe<StringPred>
  utilityShortName?: InputMaybe<StringPred>
}

export type AdminBidsTableRow = {
  __typename?: "AdminBidsTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  buildingOwnerName: Scalars["String"]["output"]
  buildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  buildingOwnerPid: Scalars["String"]["output"]
  bundlePid: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  isAwarded: Scalars["Boolean"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  pvTypes: Array<PvType>
  recOwner: RecOwner
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  siteName?: Maybe<Scalars["String"]["output"]>
  sitePid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  termYears?: Maybe<Scalars["Int"]["output"]>
  utilityId?: Maybe<Scalars["Int"]["output"]>
  utilityName?: Maybe<Scalars["String"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type AdminBidsTableSort = {
  attr: AdminBidsTableAttr
  order: SortOrder
}

export type AdminBidsTableStats = {
  __typename?: "AdminBidsTableStats"
  buildingOwnerNames: Array<Scalars["String"]["output"]>
  financierNames: Array<Scalars["String"]["output"]>
}

export type AdminBidsTableView = {
  __typename?: "AdminBidsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AdminBidsTableStats
}

export type AdminBundleTable = {
  __typename?: "AdminBundleTable"
  rows: Array<AdminBundleTableRow>
  view: AdminBundleTableView
}

export type AdminBundleTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminBundleTableViewArgs = {
  filterBy?: InputMaybe<AdminBundleTableFilter>
  sortBy?: InputMaybe<Array<AdminBundleTableSort>>
}

export enum AdminBundleTableAttr {
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidReviewMeetingDate = "BID_REVIEW_MEETING_DATE",
  BundleName = "BUNDLE_NAME",
  CodDate = "COD_DATE",
  ContractSignedDate = "CONTRACT_SIGNED_DATE",
  CreatedAt = "CREATED_AT",
  CustomReason = "CUSTOM_REASON",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinproductType = "FINPRODUCT_TYPE",
  LeDevFee = "LE_DEV_FEE",
  NtpDate = "NTP_DATE",
  PortfolioName = "PORTFOLIO_NAME",
  PortfolioPid = "PORTFOLIO_PID",
  PreBidMeetingDate = "PRE_BID_MEETING_DATE",
  PvKw = "PV_KW",
  Reason = "REASON",
  ReceiverName = "RECEIVER_NAME",
  ReceiverPid = "RECEIVER_PID",
  SiteName = "SITE_NAME",
  SitePid = "SITE_PID",
  State = "STATE",
}

export type AdminBundleTableFilter = {
  bundleName?: InputMaybe<StringPred>
  customReason?: InputMaybe<StringPred>
  financierName?: InputMaybe<StringPred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<IntPred>
  leDevFee?: InputMaybe<FloatPred>
  portfolioName?: InputMaybe<StringPred>
  pvKw?: InputMaybe<FloatPred>
  reason?: InputMaybe<CloseReasonPred>
  receiverName?: InputMaybe<StringPred>
  state?: InputMaybe<BundleStatePred>
}

export type AdminBundleTableRow = {
  __typename?: "AdminBundleTableRow"
  bidReviewMeetingDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  bundleName: Scalars["String"]["output"]
  codDate?: Maybe<Scalars["Date"]["output"]>
  contractSignedDate?: Maybe<Scalars["Date"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  customReason?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  leDevFee?: Maybe<Scalars["Float"]["output"]>
  ntpDate?: Maybe<Scalars["Date"]["output"]>
  portfolioName: Scalars["String"]["output"]
  portfolioPid: Scalars["String"]["output"]
  preBidMeetingDate?: Maybe<Scalars["Date"]["output"]>
  pvKw?: Maybe<Scalars["Float"]["output"]>
  reason?: Maybe<CloseReason>
  receiverName: Scalars["String"]["output"]
  receiverPid: Scalars["String"]["output"]
  siteName?: Maybe<Scalars["String"]["output"]>
  sitePid: Scalars["String"]["output"]
  state?: Maybe<BundleState>
}

export type AdminBundleTableSort = {
  attr: AdminBundleTableAttr
  order: SortOrder
}

export type AdminBundleTableView = {
  __typename?: "AdminBundleTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type AdminChangelog = {
  __typename?: "AdminChangelog"
  changedBy?: Maybe<UserRef>
  columnName?: Maybe<Scalars["String"]["output"]>
  columnType?: Maybe<ChangelogType>
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  isNew: Scalars["Boolean"]["output"]
  newVal?: Maybe<Scalars["JSON"]["output"]>
  objectId?: Maybe<Scalars["Int"]["output"]>
  oldVal?: Maybe<Scalars["JSON"]["output"]>
  source?: Maybe<ChangeSourceType>
  sourceId?: Maybe<Scalars["String"]["output"]>
  tableName: Scalars["String"]["output"]
  transactionId: Scalars["String"]["output"]
}

export type AdminFinProduct = {
  __typename?: "AdminFinProduct"
  activeOverrides: Array<FinmodelInputOverride>
  createdAt: Scalars["DateTime"]["output"]
  csPrices?: Maybe<Array<CsPrice>>
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  financier: OrgRef
  finmodelInputOverrides: Array<FinmodelInputOverride>
  id: Scalars["Int"]["output"]
  includeStorage: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  srecToInvestor: Scalars["Boolean"]["output"]
  status?: Maybe<FinProductStatus>
  targetOrg?: Maybe<Org>
  targetSite?: Maybe<SiteRef>
  type: FinProductType
}

export type AdminFinRel = {
  __typename?: "AdminFinRel"
  createdAt: Scalars["DateTime"]["output"]
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  finproduct: AdminFinProduct
  id: Scalars["Int"]["output"]
  recvr: Org
}

export type AdminHelioscopeMutations = {
  __typename?: "AdminHelioscopeMutations"
  updateHelioscopeAssumptions: Helioscope
}

export type AdminHelioscopeMutationsUpdateHelioscopeAssumptionsArgs = {
  assumptions: HelioscopeAssumptionsInput
  helioscopePid: Scalars["String"]["input"]
}

export type AdminInvitation = {
  __typename?: "AdminInvitation"
  createdBy: UserRef
  dateCreated: Scalars["DateTime"]["output"]
  expiresAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  isClaimed: Scalars["Boolean"]["output"]
  isExpired: Scalars["Boolean"]["output"]
  org: Org
  pid: Scalars["String"]["output"]
  portfolio?: Maybe<PortfolioRef>
  targetUser: UserRef
}

export type AdminMarketplaceTable = {
  __typename?: "AdminMarketplaceTable"
  rows: Array<AdminMarketplaceTableRow>
  view: AdminMarketplaceTableView
}

export type AdminMarketplaceTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminMarketplaceTableViewArgs = {
  filterBy?: InputMaybe<AdminMarketplaceTableFilter>
  sortBy?: InputMaybe<Array<AdminMarketplaceTableSort>>
}

export enum AdminMarketplaceTableAttr {
  AssetManager = "ASSET_MANAGER",
  AwardedTo = "AWARDED_TO",
  AwardedToDeveloperActual = "AWARDED_TO_DEVELOPER_ACTUAL",
  AwardedToDeveloperDate = "AWARDED_TO_DEVELOPER_DATE",
  AwardedToDeveloperEstimated = "AWARDED_TO_DEVELOPER_ESTIMATED",
  BiddingClosedActual = "BIDDING_CLOSED_ACTUAL",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingClosedDate = "BIDDING_CLOSED_DATE",
  BiddingClosedEstimated = "BIDDING_CLOSED_ESTIMATED",
  BiddingOpenedActual = "BIDDING_OPENED_ACTUAL",
  BiddingOpenedDate = "BIDDING_OPENED_DATE",
  BiddingOpenedEstimated = "BIDDING_OPENED_ESTIMATED",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidsPresentedActual = "BIDS_PRESENTED_ACTUAL",
  BidsPresentedDate = "BIDS_PRESENTED_DATE",
  BidsPresentedEstimated = "BIDS_PRESENTED_ESTIMATED",
  BidCount = "BID_COUNT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BidReviewMeetingDate = "BID_REVIEW_MEETING_DATE",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingType = "BUILDING_TYPE",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  CodActual = "COD_ACTUAL",
  CodDate = "COD_DATE",
  CodEstimated = "COD_ESTIMATED",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsProgramApprovedActual = "CS_PROGRAM_APPROVED_ACTUAL",
  CsProgramApprovedDate = "CS_PROGRAM_APPROVED_DATE",
  CsProgramApprovedEstimated = "CS_PROGRAM_APPROVED_ESTIMATED",
  CsProgramSubmittedActual = "CS_PROGRAM_SUBMITTED_ACTUAL",
  CsProgramSubmittedDate = "CS_PROGRAM_SUBMITTED_DATE",
  CsProgramSubmittedEstimated = "CS_PROGRAM_SUBMITTED_ESTIMATED",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  FinproductType = "FINPRODUCT_TYPE",
  HubspotRecordId = "HUBSPOT_RECORD_ID",
  IsAwarded = "IS_AWARDED",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  IxApprovedActual = "IX_APPROVED_ACTUAL",
  IxApprovedDate = "IX_APPROVED_DATE",
  IxApprovedEstimated = "IX_APPROVED_ESTIMATED",
  IxSubmittedActual = "IX_SUBMITTED_ACTUAL",
  IxSubmittedDate = "IX_SUBMITTED_DATE",
  IxSubmittedEstimated = "IX_SUBMITTED_ESTIMATED",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  LeaseSignedActual = "LEASE_SIGNED_ACTUAL",
  LeaseSignedDate = "LEASE_SIGNED_DATE",
  LeaseSignedEstimated = "LEASE_SIGNED_ESTIMATED",
  Longitude = "LONGITUDE",
  LumenFeeUsdPerWatt = "LUMEN_FEE_USD_PER_WATT",
  LumenRevenue = "LUMEN_REVENUE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NoiLifetimeUsd = "NOI_LIFETIME_USD",
  NtpActual = "NTP_ACTUAL",
  NtpDate = "NTP_DATE",
  NtpEstimated = "NTP_ESTIMATED",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  OpsOwnerEmail = "OPS_OWNER_EMAIL",
  OpsOwnerPid = "OPS_OWNER_PID",
  OrgName = "ORG_NAME",
  OrgSlug = "ORG_SLUG",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  Pid = "PID",
  PortfolioName = "PORTFOLIO_NAME",
  PreBidMeetingActual = "PRE_BID_MEETING_ACTUAL",
  PreBidMeetingDate = "PRE_BID_MEETING_DATE",
  PreBidMeetingEstimated = "PRE_BID_MEETING_ESTIMATED",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  RofoSigned = "ROFO_SIGNED",
  RofoSignedActual = "ROFO_SIGNED_ACTUAL",
  RofoSignedDate = "ROFO_SIGNED_DATE",
  RofoSignedEstimated = "ROFO_SIGNED_ESTIMATED",
  RoofCondition = "ROOF_CONDITION",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalesOwnerEmail = "SALES_OWNER_EMAIL",
  SalesOwnerPid = "SALES_OWNER_PID",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  UtilityShortName = "UTILITY_SHORT_NAME",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type AdminMarketplaceTableFilter = {
  assetManager?: InputMaybe<StringPred>
  awardedTo?: InputMaybe<StringPred>
  awardedToDeveloperActual?: InputMaybe<DatePred>
  awardedToDeveloperDate?: InputMaybe<DatePred>
  awardedToDeveloperEstimated?: InputMaybe<DatePred>
  bidCount?: InputMaybe<IntPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  bidReviewMeetingDate?: InputMaybe<DatePred>
  biddingClosedActual?: InputMaybe<DatePred>
  biddingClosedAt?: InputMaybe<DatePred>
  biddingClosedDate?: InputMaybe<DatePred>
  biddingClosedEstimated?: InputMaybe<DatePred>
  biddingOpenAt?: InputMaybe<DatePred>
  biddingOpenedActual?: InputMaybe<DatePred>
  biddingOpenedDate?: InputMaybe<DatePred>
  biddingOpenedEstimated?: InputMaybe<DatePred>
  bidsPresentedActual?: InputMaybe<DatePred>
  bidsPresentedDate?: InputMaybe<DatePred>
  bidsPresentedEstimated?: InputMaybe<DatePred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingType?: InputMaybe<BuildingTypePred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  codActual?: InputMaybe<DatePred>
  codDate?: InputMaybe<DatePred>
  codEstimated?: InputMaybe<DatePred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  csProgramApprovedActual?: InputMaybe<DatePred>
  csProgramApprovedDate?: InputMaybe<DatePred>
  csProgramApprovedEstimated?: InputMaybe<DatePred>
  csProgramSubmittedActual?: InputMaybe<DatePred>
  csProgramSubmittedDate?: InputMaybe<DatePred>
  csProgramSubmittedEstimated?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  isAwarded?: InputMaybe<BoolPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  ixApprovedActual?: InputMaybe<DatePred>
  ixApprovedDate?: InputMaybe<DatePred>
  ixApprovedEstimated?: InputMaybe<DatePred>
  ixSubmittedActual?: InputMaybe<DatePred>
  ixSubmittedDate?: InputMaybe<DatePred>
  ixSubmittedEstimated?: InputMaybe<DatePred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  leaseSignedActual?: InputMaybe<DatePred>
  leaseSignedDate?: InputMaybe<DatePred>
  leaseSignedEstimated?: InputMaybe<DatePred>
  longitude?: InputMaybe<FloatPred>
  lumenFeeUsdPerWatt?: InputMaybe<FloatPred>
  lumenRevenue?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  noiLifetimeUsd?: InputMaybe<FloatPred>
  ntpActual?: InputMaybe<DatePred>
  ntpDate?: InputMaybe<DatePred>
  ntpEstimated?: InputMaybe<DatePred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  opsOwnerEmail?: InputMaybe<StringPred>
  orgName?: InputMaybe<StringPred>
  orgSlug?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  portfolioName?: InputMaybe<StringPred>
  preBidMeetingActual?: InputMaybe<DatePred>
  preBidMeetingDate?: InputMaybe<DatePred>
  preBidMeetingEstimated?: InputMaybe<DatePred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  rofoSigned?: InputMaybe<DatePred>
  rofoSignedActual?: InputMaybe<DatePred>
  rofoSignedDate?: InputMaybe<DatePred>
  rofoSignedEstimated?: InputMaybe<DatePred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  salesOwnerEmail?: InputMaybe<StringPred>
  search?: InputMaybe<SearchPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  usableRoofSqft?: InputMaybe<FloatPred>
  utilityShortName?: InputMaybe<StringPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type AdminMarketplaceTableRow = {
  __typename?: "AdminMarketplaceTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  awardedTo?: Maybe<Scalars["String"]["output"]>
  awardedToDeveloperActual?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperDate?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperEstimated?: Maybe<Scalars["Date"]["output"]>
  bidCount: Scalars["Int"]["output"]
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  bidReviewMeetingDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedActual?: Maybe<Scalars["Date"]["output"]>
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingClosedDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenedActual?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedDate?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedEstimated?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedActual?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedDate?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedEstimated?: Maybe<Scalars["Date"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  codActual?: Maybe<Scalars["Date"]["output"]>
  codDate?: Maybe<Scalars["Date"]["output"]>
  codEstimated?: Maybe<Scalars["Date"]["output"]>
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csProgramApprovedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  estimatedCod?: Maybe<Scalars["Date"]["output"]>
  estimatedNtp?: Maybe<Scalars["Date"]["output"]>
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  finproductType: FinProductType
  hubspotRecordId?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  isAwarded: Scalars["Boolean"]["output"]
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  ixApprovedActual?: Maybe<Scalars["Date"]["output"]>
  ixApprovedDate?: Maybe<Scalars["Date"]["output"]>
  ixApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  leaseSignedActual?: Maybe<Scalars["Date"]["output"]>
  leaseSignedDate?: Maybe<Scalars["Date"]["output"]>
  leaseSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  longitude: Scalars["Float"]["output"]
  lumenFeeUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  lumenRevenue?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  noiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  ntpActual?: Maybe<Scalars["Date"]["output"]>
  ntpDate?: Maybe<Scalars["Date"]["output"]>
  ntpEstimated?: Maybe<Scalars["Date"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  opsOwnerEmail?: Maybe<Scalars["String"]["output"]>
  opsOwnerPid?: Maybe<Scalars["String"]["output"]>
  orgName: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  portfolioName: Scalars["String"]["output"]
  preBidMeetingActual?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingDate?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingEstimated?: Maybe<Scalars["Date"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  rofoSigned?: Maybe<Scalars["Date"]["output"]>
  rofoSignedActual?: Maybe<Scalars["Date"]["output"]>
  rofoSignedDate?: Maybe<Scalars["Date"]["output"]>
  rofoSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  salesOwnerEmail?: Maybe<Scalars["String"]["output"]>
  salesOwnerPid?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type AdminMarketplaceTableSort = {
  attr: AdminMarketplaceTableAttr
  order: SortOrder
}

export type AdminMarketplaceTableStats = {
  __typename?: "AdminMarketplaceTableStats"
  assetManagers: Array<Scalars["String"]["output"]>
  bidPackageNames: Array<Scalars["String"]["output"]>
  buildingOwners: Array<Scalars["String"]["output"]>
  financiers: Array<Scalars["String"]["output"]>
  opsOwners: Array<Scalars["String"]["output"]>
  portfolios: Array<Scalars["String"]["output"]>
  salesOwners: Array<Scalars["String"]["output"]>
  siteStates: Array<Scalars["String"]["output"]>
}

export type AdminMarketplaceTableView = {
  __typename?: "AdminMarketplaceTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AdminMarketplaceTableStats
}

export type AdminMutation = {
  __typename?: "AdminMutation"
  bundleRows: BundleRowMutations
  draftSite: DraftSiteMutations
  etb: EtbMutations
  etbMeter: EtbMeterMutations
  finmodel: FinmodelMutations
  finproduct: FinProductMutations
  googleApi: GoogleApiMutations
  helioscopes: AdminHelioscopeMutations
  hostingCapacityMaps: HostingCapacityMapMutations
  marketplace: MarketplaceMutations
  note: AdminNoteMutations
  openInvite: AdminOpenInviteMutations
  orgs: AdminOrgMutations
  portfolio: PortfolioMutations
  queue: QueueMutations
  scenario: ScenarioMutations
  site: SiteMutations
  tariff: TariffMutations
  todos: TodoMutations
  user: AdminUserMutations
  utility: UtilityMutations
}

export type AdminMutationEtbArgs = {
  etbId: Scalars["Int"]["input"]
}

export type AdminMutationScenarioArgs = {
  scenarioPid: Scalars["String"]["input"]
}

export type AdminNote = {
  __typename?: "AdminNote"
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  hiddenFromCustomers: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  text: Scalars["String"]["output"]
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  trashedBy?: Maybe<UserRef>
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedBy?: Maybe<UserRef>
}

export type AdminNoteMutations = {
  __typename?: "AdminNoteMutations"
  edit: AdminNote
  new: AdminNote
  trash: AdminNote
}

export type AdminNoteMutationsEditArgs = {
  hiddenFromCustomers: Scalars["Boolean"]["input"]
  notePid: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
}

export type AdminNoteMutationsNewArgs = {
  hiddenFromCustomers: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
  text: Scalars["String"]["input"]
}

export type AdminNoteMutationsTrashArgs = {
  notePid: Scalars["String"]["input"]
}

export type AdminOpenInvite = {
  __typename?: "AdminOpenInvite"
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  expiresAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  isExpired: Scalars["Boolean"]["output"]
  pid: Scalars["String"]["output"]
  portfolio: PortfolioRef
  url: Scalars["String"]["output"]
}

export type AdminOpenInviteMutations = {
  __typename?: "AdminOpenInviteMutations"
  new: AdminOpenInvite
  setExpiresAt: AdminOpenInvite
}

export type AdminOpenInviteMutationsNewArgs = {
  portfolioPid: Scalars["String"]["input"]
}

export type AdminOpenInviteMutationsSetExpiresAtArgs = {
  expiresAt: Scalars["DateTime"]["input"]
  id: Scalars["Int"]["input"]
}

export type AdminOrg = {
  __typename?: "AdminOrg"
  InvestorProfile?: Maybe<InvestorProfile>
  allowedEmailDomains?: Maybe<Array<Scalars["String"]["output"]>>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  description?: Maybe<Scalars["String"]["output"]>
  financing: Array<AdminFinRel>
  finmodelDepsUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  finproducts: Array<AdminFinProduct>
  id: Scalars["Int"]["output"]
  irrFlavor: IrrType
  labels: Array<SiteLabel>
  logoUrl: Scalars["String"]["output"]
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  overrides: Array<FinmodelInputOverride>
  pid: Scalars["String"]["output"]
  portfolios: Array<PortfolioRef>
  rawSlug: Scalars["String"]["output"]
  resultTable: ResultTable
  slug: Scalars["String"]["output"]
  slugNum: Scalars["Int"]["output"]
  users: Array<AdminUser>
}

export type AdminOrgMutations = {
  __typename?: "AdminOrgMutations"
  finrelToggle: AdminFinRel
  setAllowedEmailDomains: AdminOrg
  setLogo: AdminOrg
  setLogomark: AdminOrg
  setName: AdminOrg
  setSlug: AdminOrg
}

export type AdminOrgMutationsFinrelToggleArgs = {
  enable: Scalars["Boolean"]["input"]
  finproductId: Scalars["Int"]["input"]
  orgPid: Scalars["String"]["input"]
}

export type AdminOrgMutationsSetAllowedEmailDomainsArgs = {
  allowedEmailDomains?: InputMaybe<Array<Scalars["String"]["input"]>>
  pid: Scalars["String"]["input"]
}

export type AdminOrgMutationsSetLogoArgs = {
  pid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type AdminOrgMutationsSetLogomarkArgs = {
  pid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type AdminOrgMutationsSetNameArgs = {
  name: Scalars["String"]["input"]
  pid: Scalars["String"]["input"]
}

export type AdminOrgMutationsSetSlugArgs = {
  pid: Scalars["String"]["input"]
  slug: Scalars["String"]["input"]
}

export type AdminPortfolio = {
  __typename?: "AdminPortfolio"
  logoUrl?: Maybe<Scalars["String"]["output"]>
  minKw?: Maybe<Scalars["Float"]["output"]>
  minKwSetBy?: Maybe<Scalars["String"]["output"]>
  minKwSetDate?: Maybe<Scalars["DateTime"]["output"]>
  name: Scalars["String"]["output"]
  numSites: Scalars["Int"]["output"]
  org: AdminOrg
  overrides: Array<FinmodelInputOverride>
  pid: Scalars["String"]["output"]
  siteRefs: Array<SiteRef>
  /** @deprecated Too slow to use */
  sites: Array<Maybe<Site>>
  title: Scalars["String"]["output"]
  users: Array<AdminUser>
  view: AdminPortfolioView
  views: Array<ViewType>
}

export type AdminPortfolioSitesArgs = {
  sitePids: Array<Scalars["String"]["input"]>
}

export type AdminPortfolioView = {
  __typename?: "AdminPortfolioView"
  sitePids: Array<Scalars["String"]["output"]>
}

export type AdminQuery = {
  __typename?: "AdminQuery"
  activeAdmins: Array<UserRef>
  allBids: AdminBidsTable
  allSites: AdminSitesTable
  buildingData: BuildingData
  bundleRowParentDocuments: Array<SiteDocuments>
  bundleRows: AdminBundleTable
  changelogs: ChangelogQuery
  costarPropertyTypes: Array<Scalars["String"]["output"]>
  currentUser: AuthUser
  draftSite: DraftSite
  draftSites: Array<Maybe<DraftSite>>
  energy: EnergyProduction
  financierOrgs: Array<AdminOrg>
  finmodelSettings: FinmodelSettings
  finproduct: AdminFinProduct
  hostingCapacityMaps: HostingCapacityMapQuery
  listDraftSites: Array<DraftSite>
  marketplace: AdminMarketplaceTable
  myDraftSites: Array<DraftSite>
  openInvites: Array<AdminOpenInvite>
  org: AdminOrg
  orgBySlug?: Maybe<AdminOrg>
  orgs: Array<AdminOrg>
  policies: PolicyQuery
  portfolio?: Maybe<AdminPortfolio>
  portfolios: Array<PortfolioRow>
  schemaVersion: SchemaVersion
  search: Array<SearchSiteRow>
  searchForOwnerName: Array<CostarSearch>
  site?: Maybe<Site>
  sites: Array<Maybe<Site>>
  sitesByOwnerName: Array<Site>
  sitesInPortfolios: Array<Site>
  tariffRateId: Scalars["Int"]["output"]
  tariffs: AdminTariffQuery
  thirdPartySuppliers: Array<ThirdPartySupplier>
  user?: Maybe<AdminUser>
  users: Array<AdminUser>
}

export type AdminQueryBuildingDataArgs = {
  id: Scalars["Int"]["input"]
}

export type AdminQueryBundleRowParentDocumentsArgs = {
  bundleParentRowIds: Array<Scalars["Int"]["input"]>
  includeTags: Array<DocumentTag>
}

export type AdminQueryDraftSiteArgs = {
  draftSitePid: Scalars["String"]["input"]
}

export type AdminQueryDraftSitesArgs = {
  draftSitePids: Array<Scalars["String"]["input"]>
}

export type AdminQueryFinproductArgs = {
  finproductId: Scalars["Int"]["input"]
}

export type AdminQueryListDraftSitesArgs = {
  filterBy?: InputMaybe<DraftSiteFilter>
}

export type AdminQueryOpenInvitesArgs = {
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
}

export type AdminQueryOrgArgs = {
  orgPid: Scalars["String"]["input"]
}

export type AdminQueryOrgBySlugArgs = {
  pid?: InputMaybe<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type AdminQueryPortfolioArgs = {
  pid: Scalars["String"]["input"]
}

export type AdminQuerySearchArgs = {
  q: Scalars["String"]["input"]
}

export type AdminQuerySearchForOwnerNameArgs = {
  q: Scalars["String"]["input"]
}

export type AdminQuerySiteArgs = {
  pid: Scalars["String"]["input"]
}

export type AdminQuerySitesArgs = {
  sitePids: Array<Scalars["String"]["input"]>
}

export type AdminQuerySitesByOwnerNameArgs = {
  name: Scalars["String"]["input"]
}

export type AdminQuerySitesInPortfoliosArgs = {
  portfolioPids: Array<Scalars["String"]["input"]>
  statuses: Array<SiteStatus>
}

export type AdminQueryTariffRateIdArgs = {
  tariffParentId: Scalars["Int"]["input"]
}

export type AdminQueryUserArgs = {
  userId: Scalars["Int"]["input"]
}

export type AdminScenario = {
  __typename?: "AdminScenario"
  activeEtbReport?: Maybe<EtbReport>
  allowMulticonnect: Scalars["Boolean"]["output"]
  configs: Array<ScenarioConfig>
  createdBy?: Maybe<UserRef>
  dateCreated: Scalars["DateTime"]["output"]
  etbs: Array<EtbReport>
  helioscope?: Maybe<Helioscope>
  hiddenFromCustomers: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  includeStorage: Scalars["Boolean"]["output"]
  isMultifamily: Scalars["Boolean"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  isRecommended: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export type AdminSiteLabelMutations = {
  __typename?: "AdminSiteLabelMutations"
  applyLabelToSite?: Maybe<Error>
  changeSiteLabelColor: ChangeSiteLabelColorResponse
  createAndApplySiteLabel: CreateAndApplySiteLabelResponse
  deleteLabel?: Maybe<Error>
  removeLabel?: Maybe<Scalars["Void"]["output"]>
  renameLabel: RenameSiteLabelResponse
}

export type AdminSiteLabelMutationsApplyLabelToSiteArgs = {
  input: ApplyLabelToSiteInput
}

export type AdminSiteLabelMutationsChangeSiteLabelColorArgs = {
  input: ChangeSiteLabelColorInput
}

export type AdminSiteLabelMutationsCreateAndApplySiteLabelArgs = {
  input: CreateAndApplySiteLabelInput
}

export type AdminSiteLabelMutationsDeleteLabelArgs = {
  input: DeleteLabelInput
}

export type AdminSiteLabelMutationsRemoveLabelArgs = {
  input: RemoveLabelInput
}

export type AdminSiteLabelMutationsRenameLabelArgs = {
  input: RenameLabelInput
}

export type AdminSitesTable = {
  __typename?: "AdminSitesTable"
  rows: Array<AdminSitesTableRow>
  view: AdminSitesTableView
}

export type AdminSitesTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AdminSitesTableViewArgs = {
  filterBy?: InputMaybe<AdminSitesTableFilter>
  sortBy?: InputMaybe<Array<AdminSitesTableSort>>
}

export enum AdminSitesTableAttr {
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingType = "BUILDING_TYPE",
  CarportMaxPvKw = "CARPORT_MAX_PV_KW",
  City = "CITY",
  CreatedAt = "CREATED_AT",
  CustomerId = "CUSTOMER_ID",
  Latitude = "LATITUDE",
  Longitude = "LONGITUDE",
  Metering = "METERING",
  Name = "NAME",
  OrgName = "ORG_NAME",
  OrgPid = "ORG_PID",
  OrgSlug = "ORG_SLUG",
  ParcelFootprintSqft = "PARCEL_FOOTPRINT_SQFT",
  PortfolioName = "PORTFOLIO_NAME",
  PortfolioPid = "PORTFOLIO_PID",
  RoofMaxPvKw = "ROOF_MAX_PV_KW",
  RoofSqft = "ROOF_SQFT",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  Status = "STATUS",
  StatusCustomReason = "STATUS_CUSTOM_REASON",
  StatusReason = "STATUS_REASON",
  StreetAddress = "STREET_ADDRESS",
  UtilityId = "UTILITY_ID",
  UtilityName = "UTILITY_NAME",
  UtilityShortName = "UTILITY_SHORT_NAME",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type AdminSitesTableFilter = {
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingType?: InputMaybe<BuildingTypePred>
  carportMaxPvKw?: InputMaybe<FloatPred>
  city?: InputMaybe<StringPred>
  createdAt?: InputMaybe<DatePred>
  metering?: InputMaybe<MeteringPred>
  orgName?: InputMaybe<StringPred>
  orgSlug?: InputMaybe<StringPred>
  parcelFootprintSqft?: InputMaybe<FloatPred>
  portfolioName?: InputMaybe<StringPred>
  portfolioPid?: InputMaybe<StringPred>
  roofMaxPvKw?: InputMaybe<FloatPred>
  roofSqft?: InputMaybe<FloatPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  status?: InputMaybe<SiteStatusPred>
  utilityName?: InputMaybe<StringPred>
  utilityShortName?: InputMaybe<StringPred>
  yearBuilt?: InputMaybe<FloatPred>
}

export type AdminSitesTableRow = {
  __typename?: "AdminSitesTableRow"
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingType?: Maybe<BuildingType>
  carportMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  city: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  customerId?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
  metering?: Maybe<Metering>
  name?: Maybe<Scalars["String"]["output"]>
  orgName: Scalars["String"]["output"]
  orgPid: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  parcelFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  portfolioName: Scalars["String"]["output"]
  portfolioPid: Scalars["String"]["output"]
  roofMaxPvKw: Scalars["Float"]["output"]
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  status: SiteStatus
  statusCustomReason?: Maybe<Scalars["String"]["output"]>
  statusReason?: Maybe<StatusReason>
  streetAddress: Scalars["String"]["output"]
  utilityId?: Maybe<Scalars["Int"]["output"]>
  utilityName?: Maybe<Scalars["String"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type AdminSitesTableSort = {
  attr: AdminSitesTableAttr
  order: SortOrder
}

export type AdminSitesTableStats = {
  __typename?: "AdminSitesTableStats"
  cities: Array<Scalars["String"]["output"]>
  orgNames: Array<Scalars["String"]["output"]>
  portfolios: Array<Scalars["String"]["output"]>
  utilityNames: Array<Scalars["String"]["output"]>
}

export type AdminSitesTableView = {
  __typename?: "AdminSitesTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AdminSitesTableStats
}

export type AdminTariffQuery = {
  __typename?: "AdminTariffQuery"
  searchGenabilityByUtilityName: Array<Utility>
  tariff?: Maybe<Tariff>
  utilities: Array<Utility>
  utility?: Maybe<Utility>
}

export type AdminTariffQuerySearchGenabilityByUtilityNameArgs = {
  name: Scalars["String"]["input"]
}

export type AdminTariffQueryTariffArgs = {
  id: Scalars["Int"]["input"]
}

export type AdminTariffQueryUtilitiesArgs = {
  zipCode?: InputMaybe<Scalars["String"]["input"]>
}

export type AdminTariffQueryUtilityArgs = {
  id: Scalars["Int"]["input"]
}

export type AdminUser = {
  __typename?: "AdminUser"
  affiliation?: Maybe<Scalars["String"]["output"]>
  avatarUrl?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  email: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  isAdmin: Scalars["Boolean"]["output"]
  isEnabled: Scalars["Boolean"]["output"]
  lastSeenAt?: Maybe<Scalars["DateTime"]["output"]>
  licenseAgreements: Array<LicenseAgreement>
  meetingSchedulingUrl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  org?: Maybe<Org>
  pageViews: Array<AdminUserPageView>
  pid: Scalars["String"]["output"]
  portfoliosWithRole: Array<PortfolioRef>
  unclaimedInvitations: Array<AdminInvitation>
}

export type AdminUserError = AdminUser | Error

export type AdminUserMutations = {
  __typename?: "AdminUserMutations"
  addToPortfolio: AdminUser
  giveMeAMagicLink: MagicLink
  inviteToPortfolio?: Maybe<Scalars["Void"]["output"]>
  new: NewUserResponse
  removeFromPortfolio: AdminUser
  removeOrgMembership: AdminUser
  setAvatar: AdminUser
  setIsEnabled: AdminUser
  setMeetingSchedulingUrl: AdminUserError
  setName: AdminUser
  updateOrgMembership: AdminUser
}

export type AdminUserMutationsAddToPortfolioArgs = {
  portfolioPid: Scalars["String"]["input"]
  sendEmail: Scalars["Boolean"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsGiveMeAMagicLinkArgs = {
  email: Scalars["String"]["input"]
}

export type AdminUserMutationsInviteToPortfolioArgs = {
  email: Scalars["String"]["input"]
  orgPid: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type AdminUserMutationsNewArgs = {
  email: Scalars["String"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
  orgPid: Scalars["String"]["input"]
  portfolioPids: Array<Scalars["String"]["input"]>
  sendInvite: Scalars["Boolean"]["input"]
}

export type AdminUserMutationsRemoveFromPortfolioArgs = {
  portfolioPid: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsRemoveOrgMembershipArgs = {
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetAvatarArgs = {
  upload: Scalars["Upload"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetIsEnabledArgs = {
  isEnabled: Scalars["Boolean"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetMeetingSchedulingUrlArgs = {
  url: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserMutationsSetNameArgs = {
  id: Scalars["Int"]["input"]
  name?: InputMaybe<Scalars["String"]["input"]>
}

export type AdminUserMutationsUpdateOrgMembershipArgs = {
  orgPid: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type AdminUserPageView = {
  __typename?: "AdminUserPageView"
  createdAt: Scalars["DateTime"]["output"]
  pathname: Scalars["String"]["output"]
}

export type AllMilestonesInput = {
  awardedToDeveloper?: InputMaybe<ProjectMilestoneInput>
  biddingClosed?: InputMaybe<ProjectMilestoneInput>
  biddingOpened?: InputMaybe<ProjectMilestoneInput>
  bidsPresented?: InputMaybe<ProjectMilestoneInput>
  cod?: InputMaybe<ProjectMilestoneInput>
  csProgramApproved?: InputMaybe<ProjectMilestoneInput>
  csProgramSubmitted?: InputMaybe<ProjectMilestoneInput>
  ixApproved?: InputMaybe<ProjectMilestoneInput>
  ixSubmitted?: InputMaybe<ProjectMilestoneInput>
  leaseSigned?: InputMaybe<ProjectMilestoneInput>
  ntp?: InputMaybe<ProjectMilestoneInput>
  preBidMeeting?: InputMaybe<ProjectMilestoneInput>
  rofoSigned?: InputMaybe<ProjectMilestoneInput>
}

export type Allocation = {
  label: Scalars["String"]["input"]
  pct: Scalars["Float"]["input"]
}

export type ApplyLabelToSiteInput = {
  labelPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type ApplyLabelToSitesInput = {
  siteLabelPid: Scalars["String"]["input"]
  sitePids: Array<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type AttachFileResponse = DuplicatesAttachment | Error | Site

export type Attachment = {
  __typename?: "Attachment"
  contentType: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  csvPeek?: Maybe<Array<Array<Scalars["String"]["output"]>>>
  downloadHref: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  isEtb?: Maybe<Scalars["Boolean"]["output"]>
  isRoofImageCandidate: Scalars["Boolean"]["output"]
  isTrashable: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  size: Scalars["Int"]["output"]
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type AuthUser = {
  __typename?: "AuthUser"
  email?: Maybe<Scalars["String"]["output"]>
  hasGoogleAccessToken: Scalars["Boolean"]["output"]
  isAdmin: Scalars["Boolean"]["output"]
  isAuthenticated: Scalars["Boolean"]["output"]
  meetingSchedulingUrl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  org?: Maybe<Org>
  orgs: Array<Org>
  pid?: Maybe<Scalars["String"]["output"]>
}

export type AuthUserError = AuthUser | Error

export type AwardedProjectTable = {
  __typename?: "AwardedProjectTable"
  rows: Array<AwardedProjectTableRow>
  view: AwardedProjectTableView
}

export type AwardedProjectTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type AwardedProjectTableViewArgs = {
  filterBy?: InputMaybe<AwardedProjectTableFilter>
  sortBy?: InputMaybe<Array<AwardedProjectTableSort>>
}

export enum AwardedProjectTableAttr {
  AwardedToDeveloperActual = "AWARDED_TO_DEVELOPER_ACTUAL",
  AwardedToDeveloperDate = "AWARDED_TO_DEVELOPER_DATE",
  AwardedToDeveloperEstimated = "AWARDED_TO_DEVELOPER_ESTIMATED",
  BiddingClosedActual = "BIDDING_CLOSED_ACTUAL",
  BiddingClosedDate = "BIDDING_CLOSED_DATE",
  BiddingClosedEstimated = "BIDDING_CLOSED_ESTIMATED",
  BiddingOpenedActual = "BIDDING_OPENED_ACTUAL",
  BiddingOpenedDate = "BIDDING_OPENED_DATE",
  BiddingOpenedEstimated = "BIDDING_OPENED_ESTIMATED",
  BidsPresentedActual = "BIDS_PRESENTED_ACTUAL",
  BidsPresentedDate = "BIDS_PRESENTED_DATE",
  BidsPresentedEstimated = "BIDS_PRESENTED_ESTIMATED",
  BidPackagePid = "BID_PACKAGE_PID",
  BundlePid = "BUNDLE_PID",
  City = "CITY",
  CodActual = "COD_ACTUAL",
  CodDate = "COD_DATE",
  CodEstimated = "COD_ESTIMATED",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsProgramApprovedActual = "CS_PROGRAM_APPROVED_ACTUAL",
  CsProgramApprovedDate = "CS_PROGRAM_APPROVED_DATE",
  CsProgramApprovedEstimated = "CS_PROGRAM_APPROVED_ESTIMATED",
  CsProgramSubmittedActual = "CS_PROGRAM_SUBMITTED_ACTUAL",
  CsProgramSubmittedDate = "CS_PROGRAM_SUBMITTED_DATE",
  CsProgramSubmittedEstimated = "CS_PROGRAM_SUBMITTED_ESTIMATED",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  IxApprovedActual = "IX_APPROVED_ACTUAL",
  IxApprovedDate = "IX_APPROVED_DATE",
  IxApprovedEstimated = "IX_APPROVED_ESTIMATED",
  IxSubmittedActual = "IX_SUBMITTED_ACTUAL",
  IxSubmittedDate = "IX_SUBMITTED_DATE",
  IxSubmittedEstimated = "IX_SUBMITTED_ESTIMATED",
  LeaseSignedActual = "LEASE_SIGNED_ACTUAL",
  LeaseSignedDate = "LEASE_SIGNED_DATE",
  LeaseSignedEstimated = "LEASE_SIGNED_ESTIMATED",
  LumenRevenue = "LUMEN_REVENUE",
  Name = "NAME",
  NtpActual = "NTP_ACTUAL",
  NtpDate = "NTP_DATE",
  NtpEstimated = "NTP_ESTIMATED",
  OrgName = "ORG_NAME",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PreBidMeetingActual = "PRE_BID_MEETING_ACTUAL",
  PreBidMeetingDate = "PRE_BID_MEETING_DATE",
  PreBidMeetingEstimated = "PRE_BID_MEETING_ESTIMATED",
  PvSizeKwAc = "PV_SIZE_KW_AC",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  PvTypes = "PV_TYPES",
  RofoSignedActual = "ROFO_SIGNED_ACTUAL",
  RofoSignedDate = "ROFO_SIGNED_DATE",
  RofoSignedEstimated = "ROFO_SIGNED_ESTIMATED",
  SitePid = "SITE_PID",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  ZipCode = "ZIP_CODE",
}

export type AwardedProjectTableFilter = {
  awardedToDeveloperActual?: InputMaybe<DatePred>
  awardedToDeveloperDate?: InputMaybe<DatePred>
  awardedToDeveloperEstimated?: InputMaybe<DatePred>
  bidPackagePid?: InputMaybe<StringPred>
  biddingClosedActual?: InputMaybe<DatePred>
  biddingClosedDate?: InputMaybe<DatePred>
  biddingClosedEstimated?: InputMaybe<DatePred>
  biddingOpenedActual?: InputMaybe<DatePred>
  biddingOpenedDate?: InputMaybe<DatePred>
  biddingOpenedEstimated?: InputMaybe<DatePred>
  bidsPresentedActual?: InputMaybe<DatePred>
  bidsPresentedDate?: InputMaybe<DatePred>
  bidsPresentedEstimated?: InputMaybe<DatePred>
  bundlePid?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  codActual?: InputMaybe<DatePred>
  codDate?: InputMaybe<DatePred>
  codEstimated?: InputMaybe<DatePred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  csProgramApprovedActual?: InputMaybe<DatePred>
  csProgramApprovedDate?: InputMaybe<DatePred>
  csProgramApprovedEstimated?: InputMaybe<DatePred>
  csProgramSubmittedActual?: InputMaybe<DatePred>
  csProgramSubmittedDate?: InputMaybe<DatePred>
  csProgramSubmittedEstimated?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  id?: InputMaybe<StringPred>
  ixApprovedActual?: InputMaybe<DatePred>
  ixApprovedDate?: InputMaybe<DatePred>
  ixApprovedEstimated?: InputMaybe<DatePred>
  ixSubmittedActual?: InputMaybe<DatePred>
  ixSubmittedDate?: InputMaybe<DatePred>
  ixSubmittedEstimated?: InputMaybe<DatePred>
  leaseSignedActual?: InputMaybe<DatePred>
  leaseSignedDate?: InputMaybe<DatePred>
  leaseSignedEstimated?: InputMaybe<DatePred>
  lumenRevenue?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  ntpActual?: InputMaybe<DatePred>
  ntpDate?: InputMaybe<DatePred>
  ntpEstimated?: InputMaybe<DatePred>
  orgName?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  preBidMeetingActual?: InputMaybe<DatePred>
  preBidMeetingDate?: InputMaybe<DatePred>
  preBidMeetingEstimated?: InputMaybe<DatePred>
  pvSizeKwAc?: InputMaybe<FloatPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  rofoSignedActual?: InputMaybe<DatePred>
  rofoSignedDate?: InputMaybe<DatePred>
  rofoSignedEstimated?: InputMaybe<DatePred>
  search?: InputMaybe<SearchPred>
  sitePid?: InputMaybe<StringPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
}

export type AwardedProjectTableRow = {
  __typename?: "AwardedProjectTableRow"
  awardedToDeveloperActual?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperDate?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperEstimated?: Maybe<Scalars["Date"]["output"]>
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedActual?: Maybe<Scalars["Date"]["output"]>
  biddingClosedDate?: Maybe<Scalars["Date"]["output"]>
  biddingClosedEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedActual?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedDate?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedEstimated?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedActual?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedDate?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedEstimated?: Maybe<Scalars["Date"]["output"]>
  bundlePid: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  codActual?: Maybe<Scalars["Date"]["output"]>
  codDate?: Maybe<Scalars["Date"]["output"]>
  codEstimated?: Maybe<Scalars["Date"]["output"]>
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csProgramApprovedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  ixApprovedActual?: Maybe<Scalars["Date"]["output"]>
  ixApprovedDate?: Maybe<Scalars["Date"]["output"]>
  ixApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedDate?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  leaseSignedActual?: Maybe<Scalars["Date"]["output"]>
  leaseSignedDate?: Maybe<Scalars["Date"]["output"]>
  leaseSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  lumenRevenue?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  ntpActual?: Maybe<Scalars["Date"]["output"]>
  ntpDate?: Maybe<Scalars["Date"]["output"]>
  ntpEstimated?: Maybe<Scalars["Date"]["output"]>
  orgName: Scalars["String"]["output"]
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  preBidMeetingActual?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingDate?: Maybe<Scalars["Date"]["output"]>
  preBidMeetingEstimated?: Maybe<Scalars["Date"]["output"]>
  pvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  pvTypes: Array<PvType>
  rofoSignedActual?: Maybe<Scalars["Date"]["output"]>
  rofoSignedDate?: Maybe<Scalars["Date"]["output"]>
  rofoSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  sitePid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type AwardedProjectTableSort = {
  attr: AwardedProjectTableAttr
  order: SortOrder
}

export type AwardedProjectTableStats = {
  __typename?: "AwardedProjectTableStats"
  buildingOwners: Array<Scalars["String"]["output"]>
}

export type AwardedProjectTableView = {
  __typename?: "AwardedProjectTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: AwardedProjectTableStats
}

export type BmConfig = {
  __typename?: "BMConfig"
  annualCostUsd?: Maybe<Scalars["Float"]["output"]>
  annualCostUsdProvider?: Maybe<Provider>
  annualKwh?: Maybe<Scalars["Float"]["output"]>
  annualKwhProvider?: Maybe<Provider>
  annualMaxKw?: Maybe<Scalars["Float"]["output"]>
  annualMaxKwProvider?: Maybe<Provider>
  bauMeter?: Maybe<BauMeter>
  bauTariff?: Maybe<Tariff>
  bauTariffFailure?: Maybe<GuessTariffFailure>
  bauTariffProvider?: Maybe<Provider>
  children: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  doeReferenceType: BuildingType
  id: Scalars["Int"]["output"]
  intervals: Array<BillingIntervals>
  loadCategory: LoadCategory
  meter: BillingMeter
  meterPid: Scalars["String"]["output"]
  months: Array<BillingMonth>
  opCount: Scalars["Int"]["output"]
  parent?: Maybe<BmConfig>
  pid: Scalars["String"]["output"]
  postBatteryTariff?: Maybe<Tariff>
  postBatteryTariffProvider?: Maybe<Provider>
  postSolarTariff?: Maybe<Tariff>
  postSolarTariffProvider?: Maybe<Provider>
  supplyUtility?: Maybe<ThirdPartySupplier>
  supplyUtilityProvider?: Maybe<Provider>
  utility?: Maybe<Utility>
  utilityProvider?: Maybe<Provider>
}

export type BattAssumptions = {
  __typename?: "BattAssumptions"
  battChemName: Scalars["String"]["output"]
}

export type BatteryConfig = {
  __typename?: "BatteryConfig"
  charge: CleanIntervals
  chargeStrategy: ChargeStrategy
  createdAt: Scalars["DateTime"]["output"]
  discharge: CleanIntervals
  dischargeStrategy: DischargeStrategy
  equipmentCost?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  laborCost?: Maybe<Scalars["Float"]["output"]>
  meter: PostBatteryMeter
  sizeKw: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  vendor: BatteryVendor
}

export type BatteryProduct = {
  __typename?: "BatteryProduct"
  equipmentCost?: Maybe<Scalars["Float"]["output"]>
  laborCost?: Maybe<Scalars["Float"]["output"]>
  sizeKw: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  vendor?: Maybe<BatteryVendor>
}

export type BatterySpec = {
  __typename?: "BatterySpec"
  charge: CleanIntervals
  createdAt: Scalars["DateTime"]["output"]
  discharge: CleanIntervals
  document?: Maybe<Document>
  etbMeterName: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  meter: BillingMeter
  notes?: Maybe<Scalars["String"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  soc: CleanIntervals
  system: System
}

export type BatterySpecInput = {
  documentPid?: InputMaybe<Scalars["String"]["input"]>
  etbMeterName: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  notes: Scalars["String"]["input"]
  sizeKwDc: Scalars["Float"]["input"]
  sizeKwh: Scalars["Float"]["input"]
  upload?: InputMaybe<Scalars["Upload"]["input"]>
}

export type BatterySpecLite = {
  __typename?: "BatterySpecLite"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  notes: Scalars["String"]["output"]
  sizeKwDc: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  systemLite: SystemLite
}

export type BatterySpecLiteInput = {
  notes: Scalars["String"]["input"]
  sizeKw: Scalars["Float"]["input"]
  sizeKwh: Scalars["Float"]["input"]
}

export type BatterySystem = {
  __typename?: "BatterySystem"
  assumptions: BattAssumptions
  sizeKw: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
  vendor: BatteryVendor
}

export type BatterySystem2 = {
  __typename?: "BatterySystem2"
  notes?: Maybe<Scalars["String"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
}

export enum BatteryVendor {
  Byd = "BYD",
  Socomec = "SOCOMEC",
  SolArk = "SOL_ARK",
  Tesla = "TESLA",
}

export type BauMeter = {
  __typename?: "BauMeter"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  archivedReason?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  documentBillingMonths: Array<DocumentBillingMonth>
  formattedBill: FormattedBills
  formattedPostBill: FormattedBills
  hasTruth: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  importsKwh: Scalars["Float"]["output"]
  intervals: Zoned
  label: Scalars["String"]["output"]
  loadCategory: LoadCategory
  loadOrigin: LoadOrigin
  meterSource: MeterSource
  /** @deprecated use document_billing_months */
  nameThatTariff: Array<ResultForTariff>
  nameThatTariffDetail?: Maybe<NameThatTariffDetail>
  pid: Scalars["String"]["output"]
  possibleTariffs: Array<Tariff>
  postBatteryTariff?: Maybe<Tariff>
  postBatteryTariffSetBy?: Maybe<UserRef>
  postSolarTariff?: Maybe<Tariff>
  postSolarTariffSetBy?: Maybe<UserRef>
  postTariff: Tariff
  rollup: Array<DailyRollup>
  tariff: Tariff
  tariffSetBy?: Maybe<UserRef>
  tariffUsdPerKwh: Scalars["Float"]["output"]
  tariffsUnderHumanControl: Scalars["Boolean"]["output"]
  testCustomTariff: FormattedBills
  totalCost: Scalars["Float"]["output"]
  underHumanControl: Scalars["Boolean"]["output"]
  userVisibleLabel: Scalars["String"]["output"]
  utility: Utility
}

export type BauMeterNameThatTariffDetailArgs = {
  documentBillingMonthId: Scalars["Int"]["input"]
  tariffId: Scalars["Int"]["input"]
}

export type BauMeterPossibleTariffsArgs = {
  includeCustom?: Scalars["Boolean"]["input"]
  preferred?: Scalars["Boolean"]["input"]
}

export type BauMeterTestCustomTariffArgs = {
  cfg: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type BestCommunitySolarSite = {
  __typename?: "BestCommunitySolarSite"
  city?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  noiCsMax?: Maybe<Scalars["Float"]["output"]>
  pid: Scalars["String"]["output"]
  state?: Maybe<Scalars["String"]["output"]>
  streetAddress?: Maybe<Scalars["String"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export type BidAwardedPred = {
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type BidPackage = {
  __typename?: "BidPackage"
  bidReview?: Maybe<BidReview>
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  documents: Array<Document>
  financiers: Array<OrgRef>
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  row?: Maybe<BidPackageRow>
  state: BundleState
  totalRows: Scalars["Int"]["output"]
  type: FinProductType
}

export type BidPackageRowArgs = {
  pid: Scalars["String"]["input"]
}

export type BidPackageRow = {
  __typename?: "BidPackageRow"
  closeCustomReason?: Maybe<Scalars["String"]["output"]>
  closeReason?: Maybe<PackageRowCloseReason>
  closedAt?: Maybe<Scalars["DateTime"]["output"]>
  marketplaceStatus?: Maybe<MarketplaceStatus>
  site?: Maybe<RevampSite>
  status?: Maybe<PackageRowStatus>
}

export type BidPackageSitesTable = {
  __typename?: "BidPackageSitesTable"
  rows: Array<BidPackageSitesTableRow>
  view: BidPackageSitesTableView
}

export type BidPackageSitesTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type BidPackageSitesTableViewArgs = {
  filterBy?: InputMaybe<BidPackageSitesTableFilter>
  sortBy?: InputMaybe<Array<BidPackageSitesTableSort>>
}

export enum BidPackageSitesTableAttr {
  AssetManager = "ASSET_MANAGER",
  AwardedBidPvSizeKwAc = "AWARDED_BID_PV_SIZE_KW_AC",
  AwardedBidPvSizeKwDc = "AWARDED_BID_PV_SIZE_KW_DC",
  AwardedBidPvTypes = "AWARDED_BID_PV_TYPES",
  AwardedDeveloper = "AWARDED_DEVELOPER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidCount = "BID_COUNT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingType = "BUILDING_TYPE",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsNoiAvg = "CS_NOI_AVG",
  CsNoiLifetimeUsd = "CS_NOI_LIFETIME_USD",
  CsNoiMax = "CS_NOI_MAX",
  CsNoiMin = "CS_NOI_MIN",
  CsNpv = "CS_NPV",
  CsRoofRentEscalator = "CS_ROOF_RENT_ESCALATOR",
  CsRoofRentY1Usd = "CS_ROOF_RENT_Y1_USD",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  FinancierCount = "FINANCIER_COUNT",
  FinancingType = "FINANCING_TYPE",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  Longitude = "LONGITUDE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NoiLifetimeUsd = "NOI_LIFETIME_USD",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  Pid = "PID",
  PpaNoiAvg = "PPA_NOI_AVG",
  PpaNoiLifetimeUsd = "PPA_NOI_LIFETIME_USD",
  PpaNoiMax = "PPA_NOI_MAX",
  PpaNoiMin = "PPA_NOI_MIN",
  PpaRoofRentEscalator = "PPA_ROOF_RENT_ESCALATOR",
  PpaRoofRentY1Usd = "PPA_ROOF_RENT_Y1_USD",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  RoofCondition = "ROOF_CONDITION",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SiteLabels = "SITE_LABELS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type BidPackageSitesTableFilter = {
  assetManager?: InputMaybe<StringPred>
  awardedBidPvSizeKwAc?: InputMaybe<FloatPred>
  awardedBidPvSizeKwDc?: InputMaybe<FloatPred>
  awardedDeveloper?: InputMaybe<StringPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingType?: InputMaybe<BuildingTypePred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  csNoiLifetimeUsd?: InputMaybe<FloatPred>
  csNpv?: InputMaybe<FloatPred>
  csRoofRentEscalator?: InputMaybe<FloatPred>
  csRoofRentY1Usd?: InputMaybe<FloatPred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  financingType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  longitude?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  noiLifetimeUsd?: InputMaybe<FloatPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  ppaNoiLifetimeUsd?: InputMaybe<FloatPred>
  ppaRoofRentEscalator?: InputMaybe<FloatPred>
  ppaRoofRentY1Usd?: InputMaybe<FloatPred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  usableRoofSqft?: InputMaybe<FloatPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type BidPackageSitesTableRow = {
  __typename?: "BidPackageSitesTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  awardedBidPvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  awardedBidPvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  awardedBidPvTypes?: Maybe<Array<PvType>>
  awardedDeveloper?: Maybe<Scalars["String"]["output"]>
  bidCount?: Maybe<Scalars["Float"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csNoiAvg?: Maybe<Scalars["Float"]["output"]>
  csNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  csNoiMax?: Maybe<Scalars["Float"]["output"]>
  csNoiMin?: Maybe<Scalars["Float"]["output"]>
  csNpv?: Maybe<Scalars["Float"]["output"]>
  csRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  csRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  estimatedCod?: Maybe<Scalars["Date"]["output"]>
  estimatedNtp?: Maybe<Scalars["Date"]["output"]>
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  financierCount?: Maybe<Scalars["Float"]["output"]>
  financingType: FinProductType
  id: Scalars["Int"]["output"]
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  noiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  ppaNoiAvg?: Maybe<Scalars["Float"]["output"]>
  ppaNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  ppaNoiMax?: Maybe<Scalars["Float"]["output"]>
  ppaNoiMin?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  siteLabels: Array<SiteLabel>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type BidPackageSitesTableSort = {
  attr: BidPackageSitesTableAttr
  order: SortOrder
}

export type BidPackageSitesTableStats = {
  __typename?: "BidPackageSitesTableStats"
  awardedFinanciers: Array<Scalars["String"]["output"]>
}

export type BidPackageSitesTableView = {
  __typename?: "BidPackageSitesTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: BidPackageSitesTableStats
}

export type BidReview = {
  __typename?: "BidReview"
  recommendedBidPids: Array<Scalars["String"]["output"]>
  reports: Array<BidReviewReportStats>
}

export type BidReviewReportStats = {
  __typename?: "BidReviewReportStats"
  avgRoofRentY1Usd: Scalars["Float"]["output"]
  bidders: Scalars["Int"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  properties: Scalars["Int"]["output"]
  report: PackageBidReport
  uniqueBids: Scalars["Int"]["output"]
}

export type BidSpec = {
  __typename?: "BidSpec"
  cs?: Maybe<CsBidSpec>
  optOut?: Maybe<InvestorBidSpecOptOut>
  ppa?: Maybe<PpaBidSpec>
}

export type BidSpecInput =
  | { cs: CsBidSpecInput; ppa?: never }
  | { cs?: never; ppa: PpaBidSpecInput }

export type BidSpecsTable = {
  __typename?: "BidSpecsTable"
  rows: Array<BidSpecsTableRow>
  view: BidSpecsTableView
}

export type BidSpecsTableRowsArgs = {
  keys: Array<Scalars["String"]["input"]>
}

export type BidSpecsTableViewArgs = {
  filterBy?: InputMaybe<BidSpecsTableFilter>
  sortBy?: InputMaybe<Array<BidSpecsTableSort>>
}

export enum BidSpecsTableAttr {
  AssetManager = "ASSET_MANAGER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidName = "BID_NAME",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingType = "BUILDING_TYPE",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsRoofRentEscalator = "CS_ROOF_RENT_ESCALATOR",
  CsRoofRentY1Usd = "CS_ROOF_RENT_Y1_USD",
  CsTermYears = "CS_TERM_YEARS",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  FinancingType = "FINANCING_TYPE",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  Longitude = "LONGITUDE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PpaPriceEscalator = "PPA_PRICE_ESCALATOR",
  PpaPriceY1Usd = "PPA_PRICE_Y1_USD",
  PpaRoofRentEscalator = "PPA_ROOF_RENT_ESCALATOR",
  PpaRoofRentY1Usd = "PPA_ROOF_RENT_Y1_USD",
  PpaTermYears = "PPA_TERM_YEARS",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  RecOwner = "REC_OWNER",
  RoofCondition = "ROOF_CONDITION",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SiteLabels = "SITE_LABELS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  Type = "TYPE",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type BidSpecsTableFilter = {
  assetManager?: InputMaybe<StringPred>
  bidName?: InputMaybe<StringPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingType?: InputMaybe<BuildingTypePred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csRoofRentEscalator?: InputMaybe<FloatPred>
  csRoofRentY1Usd?: InputMaybe<FloatPred>
  csTermYears?: InputMaybe<FloatPred>
  financingType?: InputMaybe<FinProductTypePred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  longitude?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  ppaPriceEscalator?: InputMaybe<FloatPred>
  ppaPriceY1Usd?: InputMaybe<FloatPred>
  ppaRoofRentEscalator?: InputMaybe<FloatPred>
  ppaRoofRentY1Usd?: InputMaybe<FloatPred>
  ppaTermYears?: InputMaybe<FloatPred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  recOwner?: InputMaybe<RecOwnerPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  type?: InputMaybe<FinProductTypePred>
  usableRoofSqft?: InputMaybe<FloatPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type BidSpecsTableRow = {
  __typename?: "BidSpecsTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidName?: Maybe<Scalars["String"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  csRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  csSystem?: Maybe<SystemLite>
  csTermYears?: Maybe<Scalars["Int"]["output"]>
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  financingType: FinProductType
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  itcPercentageAssumption?: Maybe<Scalars["Float"]["output"]>
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  ppaPriceEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaPriceY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaSystem?: Maybe<System>
  ppaTermYears?: Maybe<Scalars["Int"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  recOwner?: Maybe<RecOwner>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  siteLabels: Array<SiteLabel>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  type: FinProductType
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type BidSpecsTableSort = {
  attr: BidSpecsTableAttr
  order: SortOrder
}

export type BidSpecsTableView = {
  __typename?: "BidSpecsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["String"]["output"]>
}

export type BillGroup = {
  __typename?: "BillGroup"
  group: Scalars["String"]["output"]
  items: Array<GroupedLineItem>
}

export type BillMonth = {
  __typename?: "BillMonth"
  end?: Maybe<Scalars["DateTime"]["output"]>
  lineItems: Array<LineItemCharge>
  peakKw?: Maybe<Scalars["Float"]["output"]>
  start: Scalars["DateTime"]["output"]
  totalCostUsd: Scalars["Float"]["output"]
  totalKwh: Scalars["Float"]["output"]
}

export type BillSection = {
  __typename?: "BillSection"
  costs: Array<Maybe<CostItemTaxItem>>
  name: Scalars["String"]["output"]
  rates: Array<DecodedRate>
}

export type BillSuggestion = {
  __typename?: "BillSuggestion"
  cleanSuggestion: Bill_
  conversation: Conversation
  createdAt: Scalars["DateTime"]["output"]
  document: Document
  id: Scalars["Int"]["output"]
  suggestion: Bill_
}

export enum BillType {
  Combined = "COMBINED",
  Delivery = "DELIVERY",
  Supply = "SUPPLY",
}

export type Bill_ = {
  __typename?: "Bill_"
  billingAccountNumber?: Maybe<Scalars["String"]["output"]>
  billingAddress?: Maybe<Scalars["String"]["output"]>
  billingPeriodEnd: Scalars["String"]["output"]
  billingPeriodStart: Scalars["String"]["output"]
  customerName?: Maybe<Scalars["String"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  meters: Array<Meter_>
  serviceIdentifier?: Maybe<Scalars["String"]["output"]>
  utilityId?: Maybe<Scalars["Int"]["output"]>
  utilityName: Scalars["String"]["output"]
}

export type BillingIntervalView = {
  __typename?: "BillingIntervalView"
  createdBy?: Maybe<UserRef>
  document: Document
  end?: Maybe<Scalars["Date"]["output"]>
  id: Scalars["Int"]["output"]
  numbers?: Maybe<Array<Scalars["Float"]["output"]>>
  start?: Maybe<Scalars["Date"]["output"]>
  timeZone: Scalars["String"]["output"]
  timestamps?: Maybe<Array<Scalars["DateTime"]["output"]>>
  units: Units
}

export type BillingIntervals = {
  __typename?: "BillingIntervals"
  configs: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  document: Document
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  numbersColumn: Scalars["Int"]["output"]
  timeZone: Scalars["String"]["output"]
  timestampColumn: Scalars["Int"]["output"]
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  trashedBy?: Maybe<UserRef>
  units: Units
}

export type BillingIntervalsExtraction = {
  documentPid: Scalars["String"]["input"]
  hasHeader: Scalars["Boolean"]["input"]
  meterColumns: Array<MeterColumn>
  timeZone: TimeZoneChoice
  timestampColumn: Scalars["Int"]["input"]
  units: Units
}

export type BillingMeter = {
  __typename?: "BillingMeter"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  archivedReason?: Maybe<Scalars["String"]["output"]>
  bauMeterPid?: Maybe<Scalars["String"]["output"]>
  config: BmConfig
  configs: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  disabledBy?: Maybe<UserRef>
  disabledReason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  label: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  site: SiteRef
  supplyUtilityMeterId?: Maybe<Scalars["String"]["output"]>
  utilityMeterId?: Maybe<Scalars["String"]["output"]>
  view: BillingMeterView
}

export type BillingMeterMutations = {
  __typename?: "BillingMeterMutations"
  addIntervals?: Maybe<Scalars["Void"]["output"]>
  addMeter: BillingMeter
  addMonthlies?: Maybe<Scalars["Void"]["output"]>
  editAnnual: BillingMeter
  editArchived: BillingMeter
  editBauTariff: BillingMeter
  editDisabled: BillingMeter
  editDoeReferenceType: BillingMeter
  editLabel: BillingMeter
  editMonth: BillingMeter
  editTenantDetails?: Maybe<Scalars["Void"]["output"]>
  moveDocumentBillingMonth?: Maybe<Scalars["Void"]["output"]>
  removeIntervals?: Maybe<Scalars["Void"]["output"]>
  removeMonth: BillingMeter
}

export type BillingMeterMutationsAddIntervalsArgs = {
  input: BillingIntervalsExtraction
}

export type BillingMeterMutationsAddMeterArgs = {
  doeReferenceType?: InputMaybe<BuildingType>
  label?: InputMaybe<Scalars["String"]["input"]>
  loadCategory: LoadCategory
  tariffPid?: InputMaybe<Scalars["String"]["input"]>
}

export type BillingMeterMutationsAddMonthliesArgs = {
  input: MonthlyExtraction
}

export type BillingMeterMutationsEditAnnualArgs = {
  costUsd?: InputMaybe<Scalars["Float"]["input"]>
  kw?: InputMaybe<Scalars["Float"]["input"]>
  kwh?: InputMaybe<Scalars["Float"]["input"]>
  meterPid: Scalars["String"]["input"]
}

export type BillingMeterMutationsEditArchivedArgs = {
  archived: Scalars["Boolean"]["input"]
  meterPid: Scalars["String"]["input"]
}

export type BillingMeterMutationsEditBauTariffArgs = {
  meterPid: Scalars["String"]["input"]
  tariffPid: Scalars["String"]["input"]
}

export type BillingMeterMutationsEditDisabledArgs = {
  disabled: Scalars["Boolean"]["input"]
  meterPid: Scalars["String"]["input"]
}

export type BillingMeterMutationsEditDoeReferenceTypeArgs = {
  doeReferenceType: BuildingType
  meterPid: Scalars["String"]["input"]
}

export type BillingMeterMutationsEditLabelArgs = {
  label?: InputMaybe<Scalars["String"]["input"]>
  meterPid: Scalars["String"]["input"]
  supplyUtilityMeterId?: InputMaybe<Scalars["String"]["input"]>
  utilityMeterId?: InputMaybe<Scalars["String"]["input"]>
}

export type BillingMeterMutationsEditMonthArgs = {
  end: Scalars["Date"]["input"]
  meterPid: Scalars["String"]["input"]
  peakKw?: InputMaybe<Scalars["Float"]["input"]>
  start: Scalars["Date"]["input"]
  supplyCostUsd?: InputMaybe<Scalars["Float"]["input"]>
  totalCostUsd?: InputMaybe<Scalars["Float"]["input"]>
  totalKwh: Scalars["Float"]["input"]
  transmissionCostUsd?: InputMaybe<Scalars["Float"]["input"]>
}

export type BillingMeterMutationsEditTenantDetailsArgs = {
  input: MfUnitBreakdownInput
  meterPid: Scalars["String"]["input"]
}

export type BillingMeterMutationsMoveDocumentBillingMonthArgs = {
  dbmId: Scalars["Int"]["input"]
  fromMeterPid?: InputMaybe<Scalars["String"]["input"]>
  kind: BillType
  toMeterPid?: InputMaybe<Scalars["String"]["input"]>
}

export type BillingMeterMutationsRemoveIntervalsArgs = {
  intervalsId: Scalars["Int"]["input"]
  meterPid: Scalars["String"]["input"]
}

export type BillingMeterMutationsRemoveMonthArgs = {
  meterPid: Scalars["String"]["input"]
  monthId: Scalars["Int"]["input"]
}

export type BillingMeterView = {
  __typename?: "BillingMeterView"
  calc2: ProjectedE2Error
  doeReferenceType: BuildingType
  fullYear8760?: Maybe<Zoned8760>
  intervals: Array<BillingIntervalView>
  isArchived: Scalars["Boolean"]["output"]
  isDisabled: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  months: Array<BillingMonthView>
  name: Scalars["String"]["output"]
  numBills: Scalars["Int"]["output"]
  numIntervals: Scalars["Int"]["output"]
  peakAnnualKw?: Maybe<FancyFloat>
  supplyUtilityMeterId?: Maybe<Scalars["String"]["output"]>
  tariff?: Maybe<Tariff>
  tenantDetails?: Maybe<TenantDetails>
  totalAnnualKwh?: Maybe<FancyFloat>
  utility?: Maybe<UtilityRef>
  utilityMeterId?: Maybe<Scalars["String"]["output"]>
  weekdayRollup?: Maybe<Array<Scalars["Float"]["output"]>>
  weekendRollup?: Maybe<Array<Scalars["Float"]["output"]>>
  weeklyRollup?: Maybe<Array<Scalars["Float"]["output"]>>
}

export type BillingMonth = {
  __typename?: "BillingMonth"
  configs: Array<BmConfig>
  createdAt: Scalars["DateTime"]["output"]
  deliveryProvider?: Maybe<Provider>
  end: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  peakKw?: Maybe<Scalars["Float"]["output"]>
  provider?: Maybe<Provider>
  start: Scalars["Date"]["output"]
  supplyCostUsd?: Maybe<Scalars["Float"]["output"]>
  supplyProvider?: Maybe<Provider>
  totalCostUsd?: Maybe<Scalars["Float"]["output"]>
  totalKwh: Scalars["Float"]["output"]
  transmissionCostUsd?: Maybe<Scalars["Float"]["output"]>
}

export type BillingMonthView = {
  __typename?: "BillingMonthView"
  end: Scalars["Date"]["output"]
  id?: Maybe<Scalars["Int"]["output"]>
  peakKw?: Maybe<FancyFloat>
  provider?: Maybe<Provider>
  start: Scalars["Date"]["output"]
  supplyCostUsd?: Maybe<FancyFloat>
  supplyProvider?: Maybe<Provider>
  totalCostUsd?: Maybe<FancyFloat>
  transmissionCostUsd?: Maybe<FancyFloat>
  usageKwh: FancyFloat
}

export type BoolPred = {
  value: Scalars["Boolean"]["input"]
}

export type BoxplotStats = {
  __typename?: "BoxplotStats"
  average: Scalars["Float"]["output"]
  max: Scalars["Float"]["output"]
  median: Scalars["Float"]["output"]
  min: Scalars["Float"]["output"]
  q1: Scalars["Float"]["output"]
  q3: Scalars["Float"]["output"]
}

export type BuildingData = {
  __typename?: "BuildingData"
  affordableType?: Maybe<Scalars["String"]["output"]>
  avgSqft1Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqft2Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqft3Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqft4Bd?: Maybe<Scalars["Int"]["output"]>
  avgSqftStudio?: Maybe<Scalars["Int"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintGeojson?: Maybe<Scalars["JSON"]["output"]>
  buildingOpex?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  capRate?: Maybe<Scalars["Float"]["output"]>
  changelog: BuildingDataChangelog
  city: Scalars["String"]["output"]
  contactAddress?: Maybe<Scalars["String"]["output"]>
  contactCity?: Maybe<Scalars["String"]["output"]>
  contactPhone?: Maybe<Scalars["String"]["output"]>
  contactState?: Maybe<Scalars["String"]["output"]>
  contactZipCode?: Maybe<Scalars["String"]["output"]>
  costarPropertyType: Scalars["String"]["output"]
  costarSecondaryType?: Maybe<Scalars["String"]["output"]>
  county: Scalars["String"]["output"]
  createdBy?: Maybe<UserRef>
  dateCreated?: Maybe<Scalars["DateTime"]["output"]>
  electricPowerRating?: Maybe<Scalars["String"]["output"]>
  electricUtility?: Maybe<Scalars["String"]["output"]>
  energyStar?: Maybe<Scalars["String"]["output"]>
  fullAddress: Scalars["String"]["output"]
  gasUtility?: Maybe<Scalars["String"]["output"]>
  hasPool?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  lastSalePrice?: Maybe<Scalars["Int"]["output"]>
  latitude: Scalars["Float"]["output"]
  leedCertified?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  numBathrooms?: Maybe<Scalars["Float"]["output"]>
  numBedrooms?: Maybe<Scalars["Int"]["output"]>
  numElevators?: Maybe<Scalars["Int"]["output"]>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnits?: Maybe<Scalars["Int"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numVacantUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  occupancyRate?: Maybe<Scalars["Float"]["output"]>
  ownerFirstName?: Maybe<Scalars["String"]["output"]>
  ownerLastName?: Maybe<Scalars["String"]["output"]>
  ownerName?: Maybe<Scalars["String"]["output"]>
  parcelNumberMax?: Maybe<Scalars["String"]["output"]>
  parcelNumberMin?: Maybe<Scalars["String"]["output"]>
  parentCompany?: Maybe<Scalars["String"]["output"]>
  propertyName?: Maybe<Scalars["String"]["output"]>
  rentType?: Maybe<Scalars["String"]["output"]>
  reonomyAssetType?: Maybe<Scalars["String"]["output"]>
  reonomyPropertyId?: Maybe<Scalars["String"]["output"]>
  reportedContactName?: Maybe<Scalars["String"]["output"]>
  reportedOwnerAddress?: Maybe<Scalars["String"]["output"]>
  reportedOwnerCity?: Maybe<Scalars["String"]["output"]>
  reportedOwnerName?: Maybe<Scalars["String"]["output"]>
  reportedOwnerPhone?: Maybe<Scalars["String"]["output"]>
  reportedOwnerState?: Maybe<Scalars["String"]["output"]>
  reportedOwnerZipCode?: Maybe<Scalars["String"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sites: Array<SiteRef>
  source: Scalars["String"]["output"]
  sourceId?: Maybe<Scalars["String"]["output"]>
  sqft?: Maybe<Scalars["Int"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  taxIdPrintFormat?: Maybe<Scalars["String"]["output"]>
  tenancy?: Maybe<Scalars["String"]["output"]>
  totalBuildings?: Maybe<Scalars["Int"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  yearRenovated?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
  zoning?: Maybe<Scalars["String"]["output"]>
}

export type BuildingDataChangelogArgs = {
  fields: Array<BuildingDataChangelogColumn>
}

export type BuildingDataAmendments = {
  __typename?: "BuildingDataAmendments"
  assetManager?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<BuildingType>
  customerId?: Maybe<Scalars["String"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  mfUnits?: Maybe<CleanMultifamilyUnits>
  name?: Maybe<Scalars["String"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
}

export type BuildingDataAmendmentsInput = {
  assetManager?: InputMaybe<Scalars["String"]["input"]>
  customerId?: InputMaybe<Scalars["String"]["input"]>
  doeReferenceType: BuildingType
  latitude: Scalars["Float"]["input"]
  longitude: Scalars["Float"]["input"]
  multifamilyUnits?: InputMaybe<MultifamilyUnitsInput>
  name?: InputMaybe<Scalars["String"]["input"]>
  numberOfStories?: InputMaybe<Scalars["Int"]["input"]>
  roofSqft?: InputMaybe<Scalars["Float"]["input"]>
  sqft?: InputMaybe<Scalars["Float"]["input"]>
  yearBuilt?: InputMaybe<Scalars["Int"]["input"]>
}

export type BuildingDataChangelog = {
  __typename?: "BuildingDataChangelog"
  all: Array<BuildingDataChangelogColumnBaseWrapper>
}

export enum BuildingDataChangelogColumn {
  AddressSha256 = "addressSha256",
  AffordableType = "affordableType",
  AvgSqft1Bd = "avgSqft1Bd",
  AvgSqft2Bd = "avgSqft2Bd",
  AvgSqft3Bd = "avgSqft3Bd",
  AvgSqft4Bd = "avgSqft4Bd",
  AvgSqftStudio = "avgSqftStudio",
  BuildingClass = "buildingClass",
  BuildingOpex = "buildingOpex",
  CapRate = "capRate",
  City = "city",
  ContactAddress = "contactAddress",
  ContactCity = "contactCity",
  ContactPhone = "contactPhone",
  ContactState = "contactState",
  ContactZipCode = "contactZipCode",
  CostarPropertyType = "costarPropertyType",
  CostarSecondaryType = "costarSecondaryType",
  County = "county",
  CreatedByUserId = "createdByUserId",
  CsvImportRowId = "csvImportRowId",
  DateCreated = "dateCreated",
  DoeReferenceType = "doeReferenceType",
  ElectricPowerRating = "electricPowerRating",
  ElectricUtility = "electricUtility",
  EnergyStar = "energyStar",
  FootprintStr = "footprintStr",
  GasUtility = "gasUtility",
  HasPool = "hasPool",
  Id = "id",
  LastSalePrice = "lastSalePrice",
  Latitude = "latitude",
  LeedCertified = "leedCertified",
  Longitude = "longitude",
  NumBathrooms = "numBathrooms",
  NumBedrooms = "numBedrooms",
  NumElevators = "numElevators",
  NumParkingSpaces = "numParkingSpaces",
  NumStories = "numStories",
  NumUnits1Bd = "numUnits1Bd",
  NumUnits2Bd = "numUnits2Bd",
  NumUnits3Bd = "numUnits3Bd",
  NumUnits4Bd = "numUnits4Bd",
  NumUnitsStudio = "numUnitsStudio",
  NumUnitsTotal = "numUnitsTotal",
  NumVacantUnits1Bd = "numVacantUnits1Bd",
  NumVacantUnits2Bd = "numVacantUnits2Bd",
  NumVacantUnits3Bd = "numVacantUnits3Bd",
  NumVacantUnits4Bd = "numVacantUnits4Bd",
  NumVacantUnitsStudio = "numVacantUnitsStudio",
  OwnerFirstName = "ownerFirstName",
  OwnerLastName = "ownerLastName",
  OwnerName = "ownerName",
  ParcelNumberMax = "parcelNumberMax",
  ParcelNumberMin = "parcelNumberMin",
  ParentCompany = "parentCompany",
  PropertyName = "propertyName",
  RentType = "rentType",
  ReonomyAssetType = "reonomyAssetType",
  ReonomyPropertyId = "reonomyPropertyId",
  ReportedContactName = "reportedContactName",
  ReportedOwnerAddress = "reportedOwnerAddress",
  ReportedOwnerCity = "reportedOwnerCity",
  ReportedOwnerName = "reportedOwnerName",
  ReportedOwnerPhone = "reportedOwnerPhone",
  ReportedOwnerState = "reportedOwnerState",
  ReportedOwnerZipCode = "reportedOwnerZipCode",
  RoofSqft = "roofSqft",
  Source = "source",
  SourceId = "sourceId",
  Sqft = "sqft",
  State = "state",
  StreetAddress = "streetAddress",
  TaxIdPrintFormat = "taxIdPrintFormat",
  Tenancy = "tenancy",
  TotalBuildings = "totalBuildings",
  YearBuilt = "yearBuilt",
  YearRenovated = "yearRenovated",
  ZipCode = "zipCode",
  Zoning = "zoning",
}

export type BuildingDataChangelogColumnBaseWrapper = {
  __typename?: "BuildingDataChangelogColumnBaseWrapper"
  column: BuildingDataChangelogColumn
  obj?: Maybe<Changelog>
}

export type BuildingDataError = BuildingData | Error

export type BuildingDataLookupInput = {
  csvImportPid: Scalars["String"]["input"]
}

export type BuildingFootprintFailure = {
  __typename?: "BuildingFootprintFailure"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type BuildingFootprintFailureFinmodelFailureGuessTariffFailureLoadEstimateFailureParcelDataFailure =

    | BuildingFootprintFailure
    | FinmodelFailure
    | GuessTariffFailure
    | LoadEstimateFailure
    | ParcelDataFailure

export enum BuildingOccupancyType {
  MultipleThirdPartyTenants = "MULTIPLE_THIRD_PARTY_TENANTS",
  OwnerOccupied = "OWNER_OCCUPIED",
  SingleThirdPartyTenant = "SINGLE_THIRD_PARTY_TENANT",
}

export type BuildingOccupancyTypeInput = {
  value: BuildingOccupancyType
}

export type BuildingOwnerEconomics = {
  __typename?: "BuildingOwnerEconomics"
  noiAnnual?: Maybe<Scalars["Float"]["output"]>
  noiLifetime?: Maybe<Scalars["Float"]["output"]>
  noiYearOne?: Maybe<Scalars["Float"]["output"]>
}

export enum BuildingSuperType {
  Commercial = "COMMERCIAL",
  Residential = "RESIDENTIAL",
}

export type BuildingSuperTypeCondition = {
  __typename?: "BuildingSuperTypeCondition"
  buildingSuperType: BuildingSuperType
}

export enum BuildingType {
  ColdStorage = "COLD_STORAGE",
  DataCenter = "DATA_CENTER",
  FullServiceRestaurant = "FULL_SERVICE_RESTAURANT",
  Hospital = "HOSPITAL",
  Hotel = "HOTEL",
  Industrial = "INDUSTRIAL",
  Multifamily = "MULTIFAMILY",
  Office = "OFFICE",
  Outpatient = "OUTPATIENT",
  ParkingLot = "PARKING_LOT",
  PrimarySchool = "PRIMARY_SCHOOL",
  QuickServiceRestaurant = "QUICK_SERVICE_RESTAURANT",
  RetailStandalone = "RETAIL_STANDALONE",
  RetailStripMall = "RETAIL_STRIP_MALL",
  SecondarySchool = "SECONDARY_SCHOOL",
  SingleFamilyDetached = "SINGLE_FAMILY_DETACHED",
  Supermarket = "SUPERMARKET",
  Warehouse = "WAREHOUSE",
}

export type BuildingTypeInput = {
  value: BuildingType
}

export type BuildingTypeMappings = {
  __typename?: "BuildingTypeMappings"
  coldStorage: Array<Scalars["String"]["output"]>
  dataCenter: Array<Scalars["String"]["output"]>
  fullServiceRestaurant: Array<Scalars["String"]["output"]>
  hospital: Array<Scalars["String"]["output"]>
  hotel: Array<Scalars["String"]["output"]>
  industrial: Array<Scalars["String"]["output"]>
  multifamily: Array<Scalars["String"]["output"]>
  office: Array<Scalars["String"]["output"]>
  outpatient: Array<Scalars["String"]["output"]>
  parkingLot: Array<Scalars["String"]["output"]>
  primarySchool: Array<Scalars["String"]["output"]>
  quickServiceRestaurant: Array<Scalars["String"]["output"]>
  retailStandalone: Array<Scalars["String"]["output"]>
  retailStripMall: Array<Scalars["String"]["output"]>
  secondarySchool: Array<Scalars["String"]["output"]>
  singleFamilyDetached: Array<Scalars["String"]["output"]>
  supermarket: Array<Scalars["String"]["output"]>
  warehouse: Array<Scalars["String"]["output"]>
}

export type BuildingTypePred = {
  value: Array<InputMaybe<BuildingType>>
}

export type Bundle = {
  __typename?: "Bundle"
  archived: Scalars["Boolean"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  canDelete: Scalars["Boolean"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  documents: Array<Document>
  downloadTheBigZipHref: Scalars["String"]["output"]
  financier: BundleOrg
  hasParent: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  note?: Maybe<Scalars["String"]["output"]>
  optedOut: Scalars["Boolean"]["output"]
  pid: Scalars["String"]["output"]
  pricingNote?: Maybe<Scalars["String"]["output"]>
  recvr: BundleOrg
  rows: Array<BundleRow>
  state?: Maybe<BundleState>
  stats: BundleStats
  type: FinProductType
}

export type Bundle2 = {
  __typename?: "Bundle2"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  awardStatus?: Maybe<BundleAwardStatusSummary>
  bidReports?: Maybe<Array<PackageBidReport>>
  bidSubmissionStatus: BundleBidSubmissionSummary
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  documents: Array<Document>
  downloadBundleDocsZipHref: Scalars["String"]["output"]
  downloadBundleDotXlsxHref: Scalars["String"]["output"]
  downloadHelioscopesDotZipHref?: Maybe<Scalars["String"]["output"]>
  financier: BundleOrg
  hasVisibleReports: Scalars["Boolean"]["output"]
  lastViewed?: Maybe<Scalars["DateTime"]["output"]>
  name: Scalars["String"]["output"]
  note?: Maybe<Scalars["String"]["output"]>
  opsOwner?: Maybe<UserRef>
  optOut?: Maybe<InvestorOptOut>
  parentRef?: Maybe<BundleParentRef>
  pid: Scalars["String"]["output"]
  pricingNote?: Maybe<Scalars["String"]["output"]>
  recvr: BundleOrg
  rows: Array<BundleRow2>
  state: BundleState
  totalBids: Scalars["Int"]["output"]
  type: FinProductType
}

export enum BundleAwardStatus {
  Awarded = "AWARDED",
  BiddingStillOpen = "BIDDING_STILL_OPEN",
  NotAwarded = "NOT_AWARDED",
  Pending = "PENDING",
}

export type BundleAwardStatusSummary = {
  __typename?: "BundleAwardStatusSummary"
  awardStatus: BundleAwardStatus
  awardedBidCount?: Maybe<Scalars["Int"]["output"]>
  totalPossibleAwards?: Maybe<Scalars["Int"]["output"]>
}

export enum BundleBidSubmissionStatus {
  InProgress = "IN_PROGRESS",
  NotStarted = "NOT_STARTED",
  OptedOut = "OPTED_OUT",
  Submitted = "SUBMITTED",
}

export type BundleBidSubmissionSummary = {
  __typename?: "BundleBidSubmissionSummary"
  bidStatus: BundleBidSubmissionStatus
  submittedBidCount?: Maybe<Scalars["Int"]["output"]>
  totalRequestedBids?: Maybe<Scalars["Int"]["output"]>
}

export type BundleEdit = {
  __typename?: "BundleEdit"
  archiveBundle?: Maybe<Scalars["Void"]["output"]>
  removeBundle?: Maybe<Scalars["Void"]["output"]>
  removeSite?: Maybe<Scalars["Void"]["output"]>
  setBiddingClosedAt?: Maybe<Scalars["Void"]["output"]>
  setBiddingOpenAt?: Maybe<Scalars["Void"]["output"]>
  setName?: Maybe<Scalars["Void"]["output"]>
  setNote?: Maybe<Scalars["Void"]["output"]>
  upsertSite: BundleRow
}

export type BundleEditArchiveBundleArgs = {
  archive: Scalars["Boolean"]["input"]
}

export type BundleEditRemoveSiteArgs = {
  sitePid: Scalars["String"]["input"]
}

export type BundleEditSetBiddingClosedAtArgs = {
  biddingClosedAt?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type BundleEditSetBiddingOpenAtArgs = {
  biddingOpenAt?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type BundleEditSetNameArgs = {
  name: Scalars["String"]["input"]
}

export type BundleEditSetNoteArgs = {
  note: Scalars["String"]["input"]
}

export type BundleEditUpsertSiteArgs = {
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  scenarioPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type BundleMutation = {
  __typename?: "BundleMutation"
  create: Bundle
  createParent: BundleParent
  edit: BundleEdit
  editParent: BundleParentEdit
}

export type BundleMutationCreateArgs = {
  biddingClosedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  biddingOpenAt?: InputMaybe<Scalars["DateTime"]["input"]>
  financierPid: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  note?: InputMaybe<Scalars["String"]["input"]>
  type: FinProductType
}

export type BundleMutationCreateParentArgs = {
  biddingClosedAt?: InputMaybe<Scalars["DateTime"]["input"]>
  biddingOpenAt?: InputMaybe<Scalars["DateTime"]["input"]>
  name: Scalars["String"]["input"]
  note?: InputMaybe<Scalars["String"]["input"]>
  pricingNote?: InputMaybe<Scalars["String"]["input"]>
  type: FinProductType
}

export type BundleMutationEditArgs = {
  pid: Scalars["String"]["input"]
}

export type BundleMutationEditParentArgs = {
  pid: Scalars["String"]["input"]
}

export type BundleOrg = {
  __typename?: "BundleOrg"
  logoUrl: Scalars["String"]["output"]
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  orgUsers: Array<OrgUser>
  pid: Scalars["String"]["output"]
  profile?: Maybe<InvestorProfile>
}

export type BundleParent = {
  __typename?: "BundleParent"
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  bundles: Array<Bundle2>
  canAddNewBids: Scalars["Boolean"]["output"]
  canEditBids: Scalars["Boolean"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  customReports: Array<CustomBidReport>
  documents: Array<Document>
  hiddenFromFinancier?: Maybe<Scalars["DateTime"]["output"]>
  hiddenFromRecvr?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  note?: Maybe<Scalars["String"]["output"]>
  opsOwner?: Maybe<UserRef>
  pid: Scalars["String"]["output"]
  pricingNote?: Maybe<Scalars["String"]["output"]>
  publicUrl: Scalars["String"]["output"]
  recvr: Org
  rows: Array<BundleParentRow>
  showAllBidsReport: Scalars["Boolean"]["output"]
  state: BundleState
  totalPvSizeKwDc: Scalars["Float"]["output"]
  type: FinProductType
}

export type BundleParentEdit = {
  __typename?: "BundleParentEdit"
  addEtb: EtbExtract
  addFinancier: Bundle
  addFinanciers?: Maybe<Scalars["Void"]["output"]>
  addSpec: BidSpec
  addSystem: SystemUnion
  archiveSpec?: Maybe<Scalars["Void"]["output"]>
  awardRow?: Maybe<Scalars["Void"]["output"]>
  createCustomBidReport: CustomBidReport
  editCustomBidReport: CustomBidReportEdit
  editSpec: BidSpec
  removeSite?: Maybe<Scalars["Void"]["output"]>
  setBidReviewMeeting?: Maybe<Scalars["Void"]["output"]>
  setBiddingClosedAt?: Maybe<Scalars["Void"]["output"]>
  setBiddingOpenAt?: Maybe<Scalars["Void"]["output"]>
  setCanAddNewBids?: Maybe<Scalars["Void"]["output"]>
  setCanEditBids?: Maybe<Scalars["Void"]["output"]>
  setHiddenFromFinancier?: Maybe<Scalars["Void"]["output"]>
  setHiddenFromRecvr?: Maybe<Scalars["Void"]["output"]>
  setName?: Maybe<Scalars["Void"]["output"]>
  setNote?: Maybe<Scalars["Void"]["output"]>
  setOpsOwner?: Maybe<Scalars["Void"]["output"]>
  setPreBidMeeting?: Maybe<Scalars["Void"]["output"]>
  setPricingNote?: Maybe<Scalars["Void"]["output"]>
  setRowNotes?: Maybe<Scalars["Void"]["output"]>
  setShowAllBidsReport?: Maybe<Scalars["Void"]["output"]>
  upsertSite?: Maybe<Scalars["Void"]["output"]>
}

export type BundleParentEditAddEtbArgs = {
  sitePid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type BundleParentEditAddFinancierArgs = {
  financierPid: Scalars["String"]["input"]
}

export type BundleParentEditAddFinanciersArgs = {
  financierPids: Array<Scalars["String"]["input"]>
}

export type BundleParentEditAddSpecArgs = {
  input: BidSpecInput
  sitePid: Scalars["String"]["input"]
}

export type BundleParentEditAddSystemArgs = {
  input: AddSystemInput
  sitePid: Scalars["String"]["input"]
}

export type BundleParentEditArchiveSpecArgs = {
  archive: Scalars["Boolean"]["input"]
  specPid: Scalars["String"]["input"]
}

export type BundleParentEditAwardRowArgs = {
  financierPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type BundleParentEditCreateCustomBidReportArgs = {
  buildingOwnerNotes?: InputMaybe<Scalars["String"]["input"]>
  developerNotes?: InputMaybe<Scalars["String"]["input"]>
  name: Scalars["String"]["input"]
  visibleToBuildingOwners?: Scalars["Boolean"]["input"]
  visibleToDevelopers?: Scalars["Boolean"]["input"]
}

export type BundleParentEditEditCustomBidReportArgs = {
  pid: Scalars["String"]["input"]
}

export type BundleParentEditEditSpecArgs = {
  input: BidSpecInput
  sitePid: Scalars["String"]["input"]
  specPid: Scalars["String"]["input"]
}

export type BundleParentEditRemoveSiteArgs = {
  sitePid: Scalars["String"]["input"]
}

export type BundleParentEditSetBidReviewMeetingArgs = {
  milestone: MilestoneInput
}

export type BundleParentEditSetBiddingClosedAtArgs = {
  biddingClosedAt?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type BundleParentEditSetBiddingOpenAtArgs = {
  biddingOpenAt?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type BundleParentEditSetCanAddNewBidsArgs = {
  can: Scalars["Boolean"]["input"]
}

export type BundleParentEditSetCanEditBidsArgs = {
  can: Scalars["Boolean"]["input"]
}

export type BundleParentEditSetHiddenFromFinancierArgs = {
  hidden: Scalars["Boolean"]["input"]
}

export type BundleParentEditSetHiddenFromRecvrArgs = {
  hidden: Scalars["Boolean"]["input"]
}

export type BundleParentEditSetNameArgs = {
  name: Scalars["String"]["input"]
}

export type BundleParentEditSetNoteArgs = {
  note?: InputMaybe<Scalars["String"]["input"]>
}

export type BundleParentEditSetOpsOwnerArgs = {
  opsOwnerPid?: InputMaybe<Scalars["String"]["input"]>
}

export type BundleParentEditSetPreBidMeetingArgs = {
  milestone: MilestoneInput
}

export type BundleParentEditSetPricingNoteArgs = {
  pricingNote?: InputMaybe<Scalars["String"]["input"]>
}

export type BundleParentEditSetRowNotesArgs = {
  notes?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type BundleParentEditSetShowAllBidsReportArgs = {
  value: Scalars["Boolean"]["input"]
}

export type BundleParentEditUpsertSiteArgs = {
  projectParams: ProjectParamsInput
  sitePid: Scalars["String"]["input"]
}

export type BundleParentRef = {
  __typename?: "BundleParentRef"
  pid: Scalars["String"]["output"]
}

export type BundleParentRow = {
  __typename?: "BundleParentRow"
  awardedFinancier?: Maybe<Org>
  closeCustomReason?: Maybe<Scalars["String"]["output"]>
  closeReason?: Maybe<PackageRowCloseReason>
  closedAt?: Maybe<Scalars["DateTime"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  hubspotRecordId?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  lumenFeeUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  lumenRevenue?: Maybe<Scalars["Float"]["output"]>
  marketplaceStatus?: Maybe<MarketplaceStatus>
  milestoneSummary: MilestoneSummary
  notes?: Maybe<Scalars["String"]["output"]>
  opsOwner?: Maybe<UserRef>
  parent: BundleParent
  portfolio?: Maybe<PortfolioRef>
  recommendedBid?: Maybe<InvestorBid>
  salesOwner?: Maybe<UserRef>
  scenario?: Maybe<ScenarioRef>
  site: SiteRef
  specs: Array<BidSpec>
  status?: Maybe<PackageRowStatus>
}

export type BundleParentRowError = BundleParentRow | Error

export type BundleRow = {
  __typename?: "BundleRow"
  financing?: Maybe<RevampFinancing>
  helioscope?: Maybe<Helioscope>
  helioscopes: Array<Helioscope>
  id: Scalars["Int"]["output"]
  reason?: Maybe<CloseReason>
  result?: Maybe<Result>
  scenario?: Maybe<RevampScenario>
  site: RevampSite
  state?: Maybe<BundleState>
  systems: Array<BundleSystem>
}

export type BundleRow2 = {
  __typename?: "BundleRow2"
  bids: Array<InvestorBid>
  canAddNewBids: Scalars["Boolean"]["output"]
  customReason?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  optOut?: Maybe<InvestorOptOut>
  ppaType?: Maybe<PpaProductType>
  reason?: Maybe<CloseReason>
  site: RevampSite
  specs: Array<BidSpec>
  state?: Maybe<BundleState>
}

export type BundleRowMutations = {
  __typename?: "BundleRowMutations"
  setBidReviewMeetingDate: BundleRow
  setCloseReason?: Maybe<Scalars["Void"]["output"]>
  setCodDate: BundleRow
  setContractSignedDate: BundleRow
  setNtpDate: BundleRow
  setPreBidMeetingDate: BundleRow
}

export type BundleRowMutationsSetBidReviewMeetingDateArgs = {
  bidReviewMeetingDate?: InputMaybe<Scalars["Date"]["input"]>
  id: Scalars["Int"]["input"]
}

export type BundleRowMutationsSetCloseReasonArgs = {
  bundleRowId: Scalars["Int"]["input"]
  customReason?: InputMaybe<Scalars["String"]["input"]>
  reason?: InputMaybe<CloseReason>
}

export type BundleRowMutationsSetCodDateArgs = {
  codDate?: InputMaybe<Scalars["Date"]["input"]>
  id: Scalars["Int"]["input"]
}

export type BundleRowMutationsSetContractSignedDateArgs = {
  contractSignedDate?: InputMaybe<Scalars["Date"]["input"]>
  id: Scalars["Int"]["input"]
}

export type BundleRowMutationsSetNtpDateArgs = {
  id: Scalars["Int"]["input"]
  ntpDate?: InputMaybe<Scalars["Date"]["input"]>
}

export type BundleRowMutationsSetPreBidMeetingDateArgs = {
  id: Scalars["Int"]["input"]
  preBidMeetingDate?: InputMaybe<Scalars["Date"]["input"]>
}

export enum BundleState {
  Closed = "CLOSED",
  Open = "OPEN",
  Preview = "PREVIEW",
}

export type BundleStatePred = {
  value?: InputMaybe<BundleState>
}

export type BundleStats = {
  __typename?: "BundleStats"
  capex?: Maybe<Scalars["Float"]["output"]>
  numSites: Scalars["Int"]["output"]
  postTaxItcDeprIrr?: Maybe<Scalars["Float"]["output"]>
  pvSizeKw: Scalars["Float"]["output"]
}

export type BundleSystem = {
  __typename?: "BundleSystem"
  battery: Array<BatterySystem2>
  pv: Array<PvSystem2>
  totalPvKw: Scalars["Float"]["output"]
}

export type BuyBox = {
  __typename?: "BuyBox"
  btmMinPortfolioSize?: Maybe<Scalars["Float"]["output"]>
  btmMinProjectSize?: Maybe<Scalars["Float"]["output"]>
  btmSeekingProjects?: Maybe<Scalars["Boolean"]["output"]>
  ftmMinPortfolioSize?: Maybe<Scalars["Float"]["output"]>
  ftmMinProjectSize?: Maybe<Scalars["Float"]["output"]>
  ftmSeekingProjects?: Maybe<Scalars["Boolean"]["output"]>
  state?: Maybe<UsState>
  utilityProgramNotes?: Maybe<Scalars["String"]["output"]>
}

export type BuyBoxInput = {
  btmMinPortfolioSize?: InputMaybe<Scalars["Float"]["input"]>
  btmMinProjectSize?: InputMaybe<Scalars["Float"]["input"]>
  btmSeekingProjects?: InputMaybe<Scalars["Boolean"]["input"]>
  ftmMinPortfolioSize?: InputMaybe<Scalars["Float"]["input"]>
  ftmMinProjectSize?: InputMaybe<Scalars["Float"]["input"]>
  ftmSeekingProjects?: InputMaybe<Scalars["Boolean"]["input"]>
  state?: InputMaybe<UsState>
  utilityProgramNotes?: InputMaybe<Scalars["String"]["input"]>
}

export type CsBidSpec = {
  __typename?: "CSBidSpec"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  itcPercentageAssumption?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  note?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  recOwner?: Maybe<RecOwner>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  site: SiteRef
  systemLite?: Maybe<SystemLite>
  termYears?: Maybe<Scalars["Int"]["output"]>
  type: FinProductType
}

export type CsBidSpecInput = {
  buildingOwnerExtraPaymentsUsd?: InputMaybe<Array<Scalars["Float"]["input"]>>
  interconnectionCostNonUtilityUsd?: InputMaybe<Scalars["Float"]["input"]>
  interconnectionCostUtilityMaxUsd?: InputMaybe<Scalars["Float"]["input"]>
  itcPercentageAssumption?: InputMaybe<Scalars["Float"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  roofRentEscalator?: InputMaybe<Scalars["Float"]["input"]>
  roofRentY1Usd?: InputMaybe<Scalars["Float"]["input"]>
  systemLitePid?: InputMaybe<Scalars["String"]["input"]>
  termYears?: InputMaybe<Scalars["Int"]["input"]>
}

export type CsFinProductInput = {
  financierId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  prices: Array<CsPriceInput>
  status?: InputMaybe<FinProductStatus>
  targetOrgId?: InputMaybe<Scalars["Int"]["input"]>
  targetSiteId?: InputMaybe<Scalars["Int"]["input"]>
  targetSystemId?: InputMaybe<Scalars["Int"]["input"]>
}

export type CsInvestorBid = {
  __typename?: "CSInvestorBid"
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  estimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financier: OrgRef
  finproduct: AdminFinProduct
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionRepriceProcessNotes?: Maybe<Scalars["String"]["output"]>
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  recOwner: RecOwner
  result?: Maybe<RevampCs>
  roofRentEscalator: Scalars["Float"]["output"]
  roofRentY1Usd: Scalars["Float"]["output"]
  site: RevampSite
  spec?: Maybe<CsBidSpec>
  status?: Maybe<InvestorBidStatus>
  systemLite: SystemLite
  tariffProvision?: Maybe<Scalars["Boolean"]["output"]>
  termYears: Scalars["Int"]["output"]
}

export type CsInvestorBidInput = {
  bundleRowId: Scalars["Int"]["input"]
  estimatedAwardDate: Scalars["Date"]["input"]
  estimatedCod: Scalars["Date"]["input"]
  estimatedNtp: Scalars["Date"]["input"]
  extraPaymentsNotes?: InputMaybe<Scalars["String"]["input"]>
  extraPaymentsUsd: Array<Scalars["Float"]["input"]>
  incentivesNotes?: InputMaybe<Scalars["String"]["input"]>
  interconnectionCostNonUtilityUsd: Scalars["Float"]["input"]
  interconnectionCostUtilityMaxUsd: Scalars["Float"]["input"]
  interconnectionNotes?: InputMaybe<Scalars["String"]["input"]>
  interconnectionRepriceProcessNotes?: InputMaybe<Scalars["String"]["input"]>
  itcPercentageAssumption: Scalars["Float"]["input"]
  name: Scalars["String"]["input"]
  otherNotes?: InputMaybe<Scalars["String"]["input"]>
  recOwner: RecOwner
  roofRentEscalator: Scalars["Float"]["input"]
  roofRentY1Usd: Scalars["Float"]["input"]
  sitePid: Scalars["String"]["input"]
  specPid?: InputMaybe<Scalars["String"]["input"]>
  systemLitePid: Scalars["String"]["input"]
  tariffProvision: Scalars["Boolean"]["input"]
  termYears: Scalars["Int"]["input"]
}

export enum CsLeaseProjectionMethdology {
  Quartiles = "QUARTILES",
}

export type CsLeaseProjections = {
  __typename?: "CSLeaseProjections"
  annualRentLowerRangeUsd: Scalars["Int"]["output"]
  annualRentUpperRangeUsd: Scalars["Int"]["output"]
  methodology: CsLeaseProjectionMethdology
  systemSizeKw: Scalars["Int"]["output"]
}

export type CsPrice = {
  __typename?: "CSPrice"
  escalator: Scalars["Float"]["output"]
  maxPvKw: Scalars["Float"]["output"]
  minPvKw: Scalars["Float"]["output"]
  pvType?: Maybe<PvType>
  state?: Maybe<UsState>
  termYears: Scalars["Float"]["output"]
  usdPerKwPerYear: Scalars["Float"]["output"]
  utility: RevampUtility
}

export type CsPriceInput = {
  escalator: Scalars["Float"]["input"]
  extraPaymentsSeriesUsd?: InputMaybe<Array<Scalars["Float"]["input"]>>
  maxPvKw: Scalars["Float"]["input"]
  minPvKw: Scalars["Float"]["input"]
  pvType?: InputMaybe<PvType>
  state?: InputMaybe<Scalars["String"]["input"]>
  termYears: Scalars["Float"]["input"]
  usdPerKwPerYear: Scalars["Float"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type CsSiteBidReport = {
  __typename?: "CSSiteBidReport"
  awarded: Scalars["Boolean"]["output"]
  awardedPid?: Maybe<Scalars["String"]["output"]>
  bids: Array<CsInvestorBid>
  itcPercentageAssumption?: Maybe<BoxplotStats>
  noi?: Maybe<BoxplotStats>
  npv?: Maybe<BoxplotStats>
  roofRentEscalator?: Maybe<BoxplotStats>
  site: RevampSite
  systemSize?: Maybe<BoxplotStats>
  totalBids: Scalars["Int"]["output"]
  y1RoofRent?: Maybe<BoxplotStats>
}

export type ChangeLogEntry = {
  __typename?: "ChangeLogEntry"
  changedAt: Scalars["DateTime"]["output"]
  columnType: ChangelogType
  newValue?: Maybe<Scalars["JSON"]["output"]>
  oldValue?: Maybe<Scalars["JSON"]["output"]>
  source?: Maybe<ChangeSourceType>
  sourceId?: Maybe<Scalars["String"]["output"]>
}

export type ChangeSiteLabelColorInput = {
  newLabelColor: LabelColor
  siteLabelPid: Scalars["String"]["input"]
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type ChangeSiteLabelColorOutput = {
  __typename?: "ChangeSiteLabelColorOutput"
  label: SiteLabel
}

export type ChangeSiteLabelColorResponse = ChangeSiteLabelColorOutput | Error

export enum ChangeSourceType {
  AutoSet = "AUTO_SET",
  ThirdParty = "THIRD_PARTY",
  User = "USER",
}

export type Changelog = {
  __typename?: "Changelog"
  field?: Maybe<Scalars["String"]["output"]>
  newVal?: Maybe<Scalars["JSON"]["output"]>
  oldVal?: Maybe<Scalars["JSON"]["output"]>
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedBy?: Maybe<UserRef>
}

export type ChangelogQuery = {
  __typename?: "ChangelogQuery"
  site: Array<AdminChangelog>
}

export type ChangelogQuerySiteArgs = {
  sitePid: Scalars["String"]["input"]
}

export enum ChangelogType {
  Array = "ARRAY",
  Bool = "BOOL",
  Date = "DATE",
  Datetime = "DATETIME",
  Float = "FLOAT",
  Int = "INT",
  Str = "STR",
}

export enum ChargeCategory {
  Demand = "DEMAND",
  Energy = "ENERGY",
  Fixed = "FIXED",
  Nbc = "NBC",
  Tax = "TAX",
}

export enum ChargeClass {
  AfterTax = "AFTER_TAX",
  Contracted = "CONTRACTED",
  Distribution = "DISTRIBUTION",
  NetExcess = "NET_EXCESS",
  NonBypassable = "NON_BYPASSABLE",
  Other = "OTHER",
  Supply = "SUPPLY",
  Tax = "TAX",
  Transmission = "TRANSMISSION",
  UserAdjusted = "USER_ADJUSTED",
}

export enum ChargePeriod {
  Annually = "ANNUALLY",
  Daily = "DAILY",
  Hourly = "HOURLY",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
}

export enum ChargeStrategy {
  ExportAvoidance = "EXPORT_AVOIDANCE",
  LowestTou = "LOWEST_TOU",
  PeakShaving = "PEAK_SHAVING",
}

export enum ChargeType {
  ConsumptionBased = "CONSUMPTION_BASED",
  DemandBased = "DEMAND_BASED",
  FixedPrice = "FIXED_PRICE",
  Formula = "FORMULA",
  Maximum = "MAXIMUM",
  Minimum = "MINIMUM",
  NetExcessGeneration = "NET_EXCESS_GENERATION",
  Quantity = "QUANTITY",
  Tax = "TAX",
}

export type ChargeTypeCost = {
  __typename?: "ChargeTypeCost"
  chargeType?: Maybe<ChargeType>
  costUsd: Scalars["Float"]["output"]
}

export enum ChargeUnit {
  BillingCycle = "BILLING_CYCLE",
  Kw = "KW",
  Kwh = "KWH",
}

export enum ChargerInstallType {
  NewBuild = "NEW_BUILD",
  Retrofit = "RETROFIT",
}

export enum ChargerLocation {
  Garage = "GARAGE",
  Surface = "SURFACE",
}

export type ClaimOpenInviteInput = {
  email: Scalars["String"]["input"]
  pid: Scalars["String"]["input"]
}

export type CleanIntervals = {
  __typename?: "CleanIntervals"
  Year: Scalars["Int"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  kwh8760: Array<Scalars["Float"]["output"]>
  maxKw: Scalars["Float"]["output"]
  timeZone: Scalars["String"]["output"]
  totalKwh: Scalars["Float"]["output"]
  units: Units
  year: Scalars["Int"]["output"]
}

export type CleanMeter = {
  __typename?: "CleanMeter"
  address?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  dirtyIntervals?: Maybe<DirtyIntervals>
  id: Scalars["Int"]["output"]
  label: Scalars["String"]["output"]
  siteRef: SiteRef
  source: MeterSource
  tariff?: Maybe<Tariff>
  utility?: Maybe<Utility>
}

export type CleanMeterQuery = {
  __typename?: "CleanMeterQuery"
  all: Array<CleanMeter>
  one: CleanMeter
}

export type CleanMeterQueryOneArgs = {
  id: Scalars["String"]["input"]
  source: MeterSource
}

export type CleanMultifamilyUnits = {
  __typename?: "CleanMultifamilyUnits"
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
}

export type CleanRowData = {
  __typename?: "CleanRowData"
  assetManager?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  customerId?: Maybe<Scalars["String"]["output"]>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: UsState
  streetAddress: Scalars["String"]["output"]
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export type ClearDrawingsInput = {
  sitePid: Scalars["String"]["input"]
}

export enum CloseReason {
  BuildingSold = "BUILDING_SOLD",
  DisqualifiedDueToRoofAge = "DISQUALIFIED_DUE_TO_ROOF_AGE",
  FailedContractNegotiations = "FAILED_CONTRACT_NEGOTIATIONS",
  IneligibleForProgram = "INELIGIBLE_FOR_PROGRAM",
  Lost = "LOST",
  OptOut = "OPT_OUT",
  Other = "OTHER",
  WentOffPlatform = "WENT_OFF_PLATFORM",
  Won = "WON",
}

export type CloseReasonPred = {
  value?: InputMaybe<CloseReason>
}

export enum CoStarPropertyType {
  Flex = "FLEX",
  HealthCare = "HEALTH_CARE",
  Hospitality = "HOSPITALITY",
  Industrial = "INDUSTRIAL",
  Land = "LAND",
  Multifamily = "MULTIFAMILY",
  Office = "OFFICE",
  Retail = "RETAIL",
  ShoppingCenter = "SHOPPING_CENTER",
  SingleFamily = "SINGLE_FAMILY",
  Specialty = "SPECIALTY",
  SportsEntertainment = "SPORTS_ENTERTAINMENT",
  Student = "STUDENT",
}

export enum CoStarSecondaryType {
  Agricultural = "AGRICULTURAL",
  AirplaneHangar = "AIRPLANE_HANGAR",
  Airport = "AIRPORT",
  AmusementPark = "AMUSEMENT_PARK",
  Apartments = "APARTMENTS",
  ApartmentsStudent = "APARTMENTS_STUDENT",
  AssistedLiving = "ASSISTED_LIVING",
  AutoDealership = "AUTO_DEALERSHIP",
  AutoRepair = "AUTO_REPAIR",
  AutoSalvageFacility = "AUTO_SALVAGE_FACILITY",
  Bank = "BANK",
  Bar = "BAR",
  BarNightclub = "BAR_NIGHTCLUB",
  BaseballField = "BASEBALL_FIELD",
  BedAndBreakfast = "BED_AND_BREAKFAST",
  BowlingAlley = "BOWLING_ALLEY",
  CarWash = "CAR_WASH",
  Casino = "CASINO",
  CementGravelPlant = "CEMENT_GRAVEL_PLANT",
  CemeteryMausoleum = "CEMETERY_MAUSOLEUM",
  ChemicalOilRefinery = "CHEMICAL_OIL_REFINERY",
  Commercial = "COMMERCIAL",
  CongregateSeniorHousing = "CONGREGATE_SENIOR_HOUSING",
  ContinuingCareRetirementCommunity = "CONTINUING_CARE_RETIREMENT_COMMUNITY",
  ContractorStorageYard = "CONTRACTOR_STORAGE_YARD",
  ConvenienceStore = "CONVENIENCE_STORE",
  CorrectionalFacility = "CORRECTIONAL_FACILITY",
  DayCareCenter = "DAY_CARE_CENTER",
  DepartmentStore = "DEPARTMENT_STORE",
  Distribution = "DISTRIBUTION",
  Dormitory = "DORMITORY",
  DormitoryStudent = "DORMITORY_STUDENT",
  DriveInMovie = "DRIVE_IN_MOVIE",
  DrugStore = "DRUG_STORE",
  FastFood = "FAST_FOOD",
  Flex = "FLEX",
  FoodProcessing = "FOOD_PROCESSING",
  Freestanding = "FREESTANDING",
  FuneralHome = "FUNERAL_HOME",
  GardenCenter = "GARDEN_CENTER",
  GeneralRetail = "GENERAL_RETAIL",
  GolfCourseDrivingRange = "GOLF_COURSE_DRIVING_RANGE",
  HealthCare = "HEALTH_CARE",
  HealthClub = "HEALTH_CLUB",
  HorseStables = "HORSE_STABLES",
  Hospital = "HOSPITAL",
  Hospitality = "HOSPITALITY",
  Hostel = "HOSTEL",
  Hotel = "HOTEL",
  HotelCasino = "HOTEL_CASINO",
  Industrial = "INDUSTRIAL",
  IndustrialLiveWorkUnit = "INDUSTRIAL_LIVE_WORK_UNIT",
  Land = "LAND",
  Landfill = "LANDFILL",
  LightDistribution = "LIGHT_DISTRIBUTION",
  LightManufacturing = "LIGHT_MANUFACTURING",
  LodgeMeetingHall = "LODGE_MEETING_HALL",
  LoftCreativeSpace = "LOFT_CREATIVE_SPACE",
  Lumberyard = "LUMBERYARD",
  ManufacturedHousingMobileHomePark = "MANUFACTURED_HOUSING_MOBILE_HOME_PARK",
  ManufacturedHousingMobileHomeParkStudent = "MANUFACTURED_HOUSING_MOBILE_HOME_PARK_STUDENT",
  Manufacturing = "MANUFACTURING",
  Marina = "MARINA",
  Medical = "MEDICAL",
  Motel = "MOTEL",
  MovieRadioTvStudio = "MOVIE_RADIO_TV_STUDIO",
  MovieTheatre = "MOVIE_THEATRE",
  Multifamily = "MULTIFAMILY",
  OfficeBuilding = "OFFICE_BUILDING",
  OfficeLiveWorkUnit = "OFFICE_LIVE_WORK_UNIT",
  OfficeResidential = "OFFICE_RESIDENTIAL",
  ParkingGarage = "PARKING_GARAGE",
  ParkingLot = "PARKING_LOT",
  PoliceFireStation = "POLICE_FIRE_STATION",
  PostOffice = "POST_OFFICE",
  PublicLibrary = "PUBLIC_LIBRARY",
  Quickservice = "QUICKSERVICE",
  QuickService = "QUICK_SERVICE",
  RaceTrack = "RACE_TRACK",
  RadioTvTransmissionFacilities = "RADIO_TV_TRANSMISSION_FACILITIES",
  RailroadYard = "RAILROAD_YARD",
  RecyclingCenter = "RECYCLING_CENTER",
  RefrigerationColdStorage = "REFRIGERATION_COLD_STORAGE",
  RehabilitationCenter = "REHABILITATION_CENTER",
  ReligiousFacility = "RELIGIOUS_FACILITY",
  Residential = "RESIDENTIAL",
  ResidentialIncome = "RESIDENTIAL_INCOME",
  Restaurant = "RESTAURANT",
  Retail = "RETAIL",
  RetailBuilding = "RETAIL_BUILDING",
  RD = "R_D",
  Schools = "SCHOOLS",
  SelfStorage = "SELF_STORAGE",
  Service = "SERVICE",
  ServicedApartment = "SERVICED_APARTMENT",
  ServiceStation = "SERVICE_STATION",
  Shelter = "SHELTER",
  Shipyard = "SHIPYARD",
  Showroom = "SHOWROOM",
  SingleRoomOccupancyHotel = "SINGLE_ROOM_OCCUPANCY_HOTEL",
  SkatingRink = "SKATING_RINK",
  SkilledNursingFacility = "SKILLED_NURSING_FACILITY",
  SororityFraternityHouse = "SORORITY_FRATERNITY_HOUSE",
  Specialty = "SPECIALTY",
  SportsEntertainment = "SPORTS_ENTERTAINMENT",
  Storefront = "STOREFRONT",
  StorefrontRetailOffice = "STOREFRONT_RETAIL_OFFICE",
  StorefrontRetailResidential = "STOREFRONT_RETAIL_RESIDENTIAL",
  Supermarket = "SUPERMARKET",
  SwimmingPool = "SWIMMING_POOL",
  TelecomHotelDataHosting = "TELECOM_HOTEL_DATA_HOSTING",
  TheaterConcertHall = "THEATER_CONCERT_HALL",
  TrailerCamperPark = "TRAILER_CAMPER_PARK",
  TruckStop = "TRUCK_STOP",
  TruckTerminal = "TRUCK_TERMINAL",
  Unknown = "UNKNOWN",
  UtilitySubstation = "UTILITY_SUBSTATION",
  VeterinarianKennel = "VETERINARIAN_KENNEL",
  Warehouse = "WAREHOUSE",
  WaterRetentionFacility = "WATER_RETENTION_FACILITY",
  WaterTreatmentFacility = "WATER_TREATMENT_FACILITY",
  WineryVineyard = "WINERY_VINEYARD",
}

export type ColumnMappings = {
  __typename?: "ColumnMappings"
  assetManagerColumnId?: Maybe<Scalars["String"]["output"]>
  buildingTypeColumnId?: Maybe<Scalars["String"]["output"]>
  cityColumnId?: Maybe<Scalars["String"]["output"]>
  customerIdColumnId?: Maybe<Scalars["String"]["output"]>
  latitudeColumnId?: Maybe<Scalars["String"]["output"]>
  longitudeColumnId?: Maybe<Scalars["String"]["output"]>
  nameColumnId?: Maybe<Scalars["String"]["output"]>
  numStoriesColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits1BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits2BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits3BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnits4BdColumnId?: Maybe<Scalars["String"]["output"]>
  numUnitsStudioColumnId?: Maybe<Scalars["String"]["output"]>
  numUnitsTotalColumnId?: Maybe<Scalars["String"]["output"]>
  sqftColumnId?: Maybe<Scalars["String"]["output"]>
  stateColumnId?: Maybe<Scalars["String"]["output"]>
  streetAddressColumnId?: Maybe<Scalars["String"]["output"]>
  yearBuiltColumnId?: Maybe<Scalars["String"]["output"]>
  zipCodeColumnId?: Maybe<Scalars["String"]["output"]>
}

export type ColumnMappingsInput = {
  assetManagerColumnId?: InputMaybe<Scalars["String"]["input"]>
  buildingTypeColumnId?: InputMaybe<Scalars["String"]["input"]>
  cityColumnId?: InputMaybe<Scalars["String"]["input"]>
  customerIdColumnId?: InputMaybe<Scalars["String"]["input"]>
  latitudeColumnId?: InputMaybe<Scalars["String"]["input"]>
  longitudeColumnId?: InputMaybe<Scalars["String"]["input"]>
  mfColumnMappings?: InputMaybe<MfColumnMappings>
  nameColumnId?: InputMaybe<Scalars["String"]["input"]>
  numStoriesColumnId?: InputMaybe<Scalars["String"]["input"]>
  sqftColumnId?: InputMaybe<Scalars["String"]["input"]>
  stateColumnId?: InputMaybe<Scalars["String"]["input"]>
  streetAddressColumnId?: InputMaybe<Scalars["String"]["input"]>
  yearBuiltColumnId?: InputMaybe<Scalars["String"]["input"]>
  zipCodeColumnId?: InputMaybe<Scalars["String"]["input"]>
}

export enum ConnectionType {
  Connected = "CONNECTED",
  FullBallast = "FULL_BALLAST",
  Hybrid = "HYBRID",
}

export type ConserviceSearch = {
  __typename?: "ConserviceSearch"
  count: Scalars["Int"]["output"]
  matched: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
}

export type Conversation = {
  __typename?: "Conversation"
  createdAt: Scalars["DateTime"]["output"]
  document?: Maybe<Document>
  id: Scalars["Int"]["output"]
  model: Scalars["String"]["output"]
  transcript?: Maybe<Array<Exchange>>
  user?: Maybe<UserRef>
}

export type Coordinate = {
  lat: Scalars["Float"]["input"]
  lng: Scalars["Float"]["input"]
}

export type CostCalculation = {
  __typename?: "CostCalculation"
  postSolarCosts: CostSummary_
  preSolarCosts: CostSummary_
}

export type CostItem = {
  __typename?: "CostItem"
  chargeCategory?: Maybe<ChargeCategory>
  chargeClass: ChargeClass
  chargeType: ChargeType
  cost: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
  rate: Scalars["Float"]["output"]
  rateId: Scalars["Int"]["output"]
  rateObj: DecodedRate
  volume: Scalars["Float"]["output"]
}

export type CostItemTaxItem = CostItem | TaxItem

export type CostSummary = {
  __typename?: "CostSummary"
  dateCreated: Scalars["DateTime"]["output"]
  demandCost: Scalars["Float"]["output"]
  endDate: Scalars["DateTime"]["output"]
  energyCost: Scalars["Float"]["output"]
  exportBenefit: Scalars["Float"]["output"]
  fixedCost: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  nbcCost: Scalars["Float"]["output"]
  startDate: Scalars["DateTime"]["output"]
  tariff?: Maybe<TariffRate>
  totalCost: Scalars["Float"]["output"]
  totalEnergyUsage: Scalars["Float"]["output"]
  usingHybridNem3ExportRate: Scalars["Boolean"]["output"]
}

export type CostSummary_ = {
  __typename?: "CostSummary_"
  demandCost: Scalars["Float"]["output"]
  endDate: Scalars["DateTime"]["output"]
  energyCost: Scalars["Float"]["output"]
  exportBenefit: Scalars["Float"]["output"]
  fixedCost: Scalars["Float"]["output"]
  nbcCost: Scalars["Float"]["output"]
  startDate: Scalars["DateTime"]["output"]
  tariff: Tariff
  totalCost: Scalars["Float"]["output"]
  totalEnergyUsage: Scalars["Float"]["output"]
  usingHybridNem3ExportRate: Scalars["Boolean"]["output"]
}

export type CostarSearch = {
  __typename?: "CostarSearch"
  countSitesInPortfolio: Scalars["Int"]["output"]
  countSitesNotInPortfolio: Scalars["Int"]["output"]
  ownerName: Scalars["String"]["output"]
  primaryState: Scalars["String"]["output"]
}

export enum CounselApproval {
  External = "EXTERNAL",
  Internal = "INTERNAL",
  InternalAndExternal = "INTERNAL_AND_EXTERNAL",
  NotRequired = "NOT_REQUIRED",
}

export type CounselApprovalPred = {
  value: Array<InputMaybe<CounselApproval>>
}

export type CreateAndApplySiteLabelInput = {
  labelColor?: LabelColor
  labelName: Scalars["String"]["input"]
  sitePids: Array<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type CreateAndApplySiteLabelOutput = {
  __typename?: "CreateAndApplySiteLabelOutput"
  label: SiteLabel
}

export type CreateAndApplySiteLabelResponse = CreateAndApplySiteLabelOutput | Error

export type CreateCsvImportSitesInput = {
  csvImportPid: Scalars["String"]["input"]
}

export type CreateDraftInput = {
  bcc?: InputMaybe<Scalars["String"]["input"]>
  body: Scalars["String"]["input"]
  subject: Scalars["String"]["input"]
  to: Scalars["String"]["input"]
}

export type CsvImport = {
  __typename?: "CsvImport"
  buildingTypeMappings: BuildingTypeMappings
  buildingTypes: Array<Scalars["String"]["output"]>
  columnIds: Array<Scalars["String"]["output"]>
  columnMappings: ColumnMappings
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  fileName?: Maybe<Scalars["String"]["output"]>
  guessedBuildingTypeMappings: BuildingTypeMappings
  guessedSchema?: Maybe<CsvSchema>
  id: Scalars["Int"]["output"]
  labels: Array<SiteLabel>
  pid: Scalars["String"]["output"]
  portfolio: PortfolioRef
  rawCsvWithPidsHref: Scalars["String"]["output"]
  rowStats: CsvImportStats
  rows: Array<CsvImportRow>
}

export type CsvImportError = CsvImport | Error

export type CsvImportQuery = {
  __typename?: "CsvImportQuery"
  all: Array<CsvImport>
  one: CsvImport
}

export type CsvImportQueryOneArgs = {
  pid: Scalars["String"]["input"]
}

export type CsvImportRow = {
  __typename?: "CsvImportRow"
  amendments?: Maybe<BuildingDataAmendments>
  buildingData?: Maybe<BuildingData>
  clean?: Maybe<CleanRowData>
  dirty: DirtyRowData
  droppedAt?: Maybe<Scalars["DateTime"]["output"]>
  errors: Array<RowValidationError>
  id: Scalars["Int"]["output"]
  rawCells: Array<RawCsvCell>
  site?: Maybe<SiteRef>
  warnings: Array<RowValidationWarning>
}

export type CsvImportStats = {
  __typename?: "CsvImportStats"
  imported: Scalars["Int"]["output"]
  total: Scalars["Int"]["output"]
}

export type CsvSchema = {
  __typename?: "CsvSchema"
  org?: Maybe<Org>
  origin: SchemaOrigin
  pid: Scalars["String"]["output"]
}

export type CurrencyValue = {
  __typename?: "CurrencyValue"
  usd: Scalars["Float"]["output"]
}

export type CustomBidReport = {
  __typename?: "CustomBidReport"
  bids: Array<InvestorBid>
  buildingOwnerNotes?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  notes: Scalars["String"]["output"]
  parent: BundleParent
  pid: Scalars["String"]["output"]
  visibleToBuildingOwners: Scalars["Boolean"]["output"]
  visibleToDevelopers: Scalars["Boolean"]["output"]
}

export type CustomBidReportEdit = {
  __typename?: "CustomBidReportEdit"
  delete?: Maybe<Scalars["Void"]["output"]>
  removeBid?: Maybe<Scalars["Void"]["output"]>
  setBuildingOwnerNotes?: Maybe<Scalars["Void"]["output"]>
  setDeveloperNotes?: Maybe<Scalars["Void"]["output"]>
  setName?: Maybe<Scalars["Void"]["output"]>
  setVisibleToBuildingOwners?: Maybe<Scalars["Void"]["output"]>
  setVisibleToDevelopers?: Maybe<Scalars["Void"]["output"]>
  upsertBid?: Maybe<Scalars["Void"]["output"]>
}

export type CustomBidReportEditRemoveBidArgs = {
  bidPid: Scalars["String"]["input"]
}

export type CustomBidReportEditSetBuildingOwnerNotesArgs = {
  value: Scalars["String"]["input"]
}

export type CustomBidReportEditSetDeveloperNotesArgs = {
  value: Scalars["String"]["input"]
}

export type CustomBidReportEditSetNameArgs = {
  value: Scalars["String"]["input"]
}

export type CustomBidReportEditSetVisibleToBuildingOwnersArgs = {
  value: Scalars["Boolean"]["input"]
}

export type CustomBidReportEditSetVisibleToDevelopersArgs = {
  value: Scalars["Boolean"]["input"]
}

export type CustomBidReportEditUpsertBidArgs = {
  bidPid: Scalars["String"]["input"]
}

export type CustomRate = {
  __typename?: "CustomRate"
  chargeClass: ChargeClass
  chargePeriod: ChargePeriod
  chargeType: ChargeType
  name?: Maybe<Scalars["String"]["output"]>
  price: Scalars["Float"]["output"]
  rateUnit: RateUnit
  transactionType?: Maybe<TransactionType>
}

export type CustomTariff = {
  __typename?: "CustomTariff"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  billCalc: Array<OpsBillCalc>
  code: Scalars["String"]["output"]
  createdBy: UserRef
  customerClass: Scalars["String"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  hasNetMetering: Scalars["Boolean"]["output"]
  hasTouRates: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  opBased: Scalars["Boolean"]["output"]
  ops?: Maybe<Array<AddRateSubRateOverrideProperty>>
  parent?: Maybe<Tariff>
  postOpDetails: TariffDetails
  preOpDetails?: Maybe<TariffDetails>
  previewDetails?: Maybe<TariffDetails>
  site: SiteRef
  source?: Maybe<TariffRate>
  startDate: Scalars["DateTime"]["output"]
  utility: Utility
}

export type CustomTariffBillCalcArgs = {
  addRateOps: Array<AddRateInput>
  bauMeterPid: Scalars["String"]["input"]
  propertyOps: Array<OverridePropertyInput>
  subRateOps: Array<SubRateInput>
}

export type CustomTariffPreviewDetailsArgs = {
  addRateOps: Array<AddRateInput>
  propertyOps: Array<OverridePropertyInput>
  subRateOps: Array<SubRateInput>
}

export type CustomTariffMutations = {
  __typename?: "CustomTariffMutations"
  create: CustomTariff
  createFromScratch: CustomTariff
  update: CustomTariff
}

export type CustomTariffMutationsCreateArgs = {
  addRateOps: Array<AddRateInput>
  name: Scalars["String"]["input"]
  propertyOps: Array<OverridePropertyInput>
  rateId: Scalars["Int"]["input"]
  subRateOps: Array<SubRateInput>
}

export type CustomTariffMutationsCreateFromScratchArgs = {
  addRateOps: Array<AddRateInput>
  name: Scalars["String"]["input"]
  tariffClass: TariffClass
  utilityPid: Scalars["String"]["input"]
}

export type CustomTariffMutationsUpdateArgs = {
  addRateOps: Array<AddRateInput>
  customTariffId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  propertyOps: Array<OverridePropertyInput>
  subRateOps: Array<SubRateInput>
}

export type DailyRollup = {
  __typename?: "DailyRollup"
  days: Array<Scalars["String"]["output"]>
  numbers: Array<Scalars["Float"]["output"]>
  season: Scalars["String"]["output"]
}

export type DateInput = {
  value: Scalars["Date"]["input"]
}

export type DatePred = {
  endDate?: InputMaybe<Scalars["Date"]["input"]>
  isEmpty?: InputMaybe<Scalars["Boolean"]["input"]>
  startDate?: InputMaybe<Scalars["Date"]["input"]>
}

export type DayIntervals = {
  __typename?: "DayIntervals"
  battDischarge: Array<Scalars["Float"]["output"]>
  gridToBldg: Array<Scalars["Float"]["output"]>
  pvToBldg: Array<Scalars["Float"]["output"]>
}

export type DecodedRate = {
  __typename?: "DecodedRate"
  chargeClass: ChargeClass
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
}

export type DeleteLabelInput = {
  labelPid: Scalars["String"]["input"]
}

export type DeleteSiteLabelInput = {
  siteLabelPid: Scalars["String"]["input"]
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type Delta = {
  __typename?: "Delta"
  a: Scalars["Float"]["output"]
  b: Scalars["Float"]["output"]
  diff: Scalars["Float"]["output"]
  pct?: Maybe<Scalars["Float"]["output"]>
}

export type DirtyIntervals = {
  __typename?: "DirtyIntervals"
  intervals: Array<Maybe<Scalars["Float"]["output"]>>
  rollup: Array<DailyRollup>
  timestampStrings: Array<Scalars["String"]["output"]>
  timestamps: Array<Scalars["Float"]["output"]>
  totalKwh: Scalars["Float"]["output"]
  units: Units
}

export type DirtyRowData = {
  __typename?: "DirtyRowData"
  assetManager?: Maybe<Scalars["String"]["output"]>
  buildingType?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  customerId?: Maybe<Scalars["String"]["output"]>
  latitude?: Maybe<Scalars["String"]["output"]>
  longitude?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  numStories?: Maybe<Scalars["String"]["output"]>
  numUnits1Bd?: Maybe<Scalars["String"]["output"]>
  numUnits2Bd?: Maybe<Scalars["String"]["output"]>
  numUnits3Bd?: Maybe<Scalars["String"]["output"]>
  numUnits4Bd?: Maybe<Scalars["String"]["output"]>
  numUnitsStudio?: Maybe<Scalars["String"]["output"]>
  numUnitsTotal?: Maybe<Scalars["String"]["output"]>
  sqft?: Maybe<Scalars["String"]["output"]>
  state?: Maybe<Scalars["String"]["output"]>
  streetAddress?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["String"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export enum DischargeStrategy {
  PeakShaving = "PEAK_SHAVING",
  PeakTou = "PEAK_TOU",
}

export type DispatchStrategy = {
  __typename?: "DispatchStrategy"
  charge: ChargeStrategy
  discharge: DischargeStrategy
}

export type Document = {
  __typename?: "Document"
  belongsToBundleParent: Scalars["Boolean"]["output"]
  canDelete: Scalars["Boolean"]["output"]
  contentType: Scalars["String"]["output"]
  csvPeek?: Maybe<Array<Array<Scalars["String"]["output"]>>>
  dateCreated: Scalars["DateTime"]["output"]
  downloadHref: Scalars["String"]["output"]
  fileName: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  ownerEmail: Scalars["String"]["output"]
  ownerName: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  tag?: Maybe<DocumentTag>
  viewHref: Scalars["String"]["output"]
}

export type DocumentBillingMonth = {
  __typename?: "DocumentBillingMonth"
  createdAt: Scalars["DateTime"]["output"]
  document: Document
  end: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  kind: BillType
  lineItems: Array<DocumentBillingMonthLineItem>
  meterId: Scalars["String"]["output"]
  peakKw?: Maybe<Scalars["Float"]["output"]>
  serviceAddress?: Maybe<Scalars["String"]["output"]>
  site: SiteRef
  start: Scalars["Date"]["output"]
  supplyCostUsd?: Maybe<Scalars["Float"]["output"]>
  supplyUtilityName?: Maybe<Scalars["String"]["output"]>
  tariffLabel?: Maybe<Scalars["String"]["output"]>
  totalCostUsd?: Maybe<Scalars["Float"]["output"]>
  totalKwh: Scalars["Float"]["output"]
  transmissionCostUsd?: Maybe<Scalars["Float"]["output"]>
  utilityName: Scalars["String"]["output"]
}

export type DocumentBillingMonthLineItem = {
  __typename?: "DocumentBillingMonthLineItem"
  chargeType?: Maybe<ChargeType>
  createdAt: Scalars["DateTime"]["output"]
  documentBillingMonth?: Maybe<DocumentBillingMonth>
  end: Scalars["Date"]["output"]
  id: Scalars["Int"]["output"]
  meterId?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  perUnitPriceUsd?: Maybe<Scalars["Float"]["output"]>
  start: Scalars["Date"]["output"]
  totalCostUsd: Scalars["Float"]["output"]
  usage?: Maybe<Scalars["Float"]["output"]>
}

export type DocumentMutationResponse = Document | Error

export type DocumentMutations = {
  __typename?: "DocumentMutations"
  deleteDocument?: Maybe<Error>
  setDocumentTag?: Maybe<DocumentMutationResponse>
  uploadDocument: DocumentMutationResponse
}

export type DocumentMutationsDeleteDocumentArgs = {
  documentPid: Scalars["String"]["input"]
}

export type DocumentMutationsSetDocumentTagArgs = {
  bundleParentPid?: InputMaybe<Scalars["String"]["input"]>
  bundlePid?: InputMaybe<Scalars["String"]["input"]>
  pid: Scalars["String"]["input"]
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  tag?: InputMaybe<DocumentTag>
}

export type DocumentMutationsUploadDocumentArgs = {
  bundleParentPid?: InputMaybe<Scalars["String"]["input"]>
  bundlePid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  tag?: InputMaybe<Scalars["String"]["input"]>
  upload: Scalars["Upload"]["input"]
}

export type DocumentParseRequest = {
  __typename?: "DocumentParseRequest"
  createdAt: Scalars["DateTime"]["output"]
  document: Document
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  results: Array<ParseResult>
  status: ParseStatus
}

export enum DocumentTag {
  CreditReport = "CREDIT_REPORT",
  EpcBuildQuote = "EPC__BUILD_QUOTE",
  EpcContract = "EPC__CONTRACT",
  EpcCosts = "EPC__COSTS",
  EpcDesign = "EPC__DESIGN",
  EpcEmr = "EPC__EMR",
  EpcFinancial = "EPC__FINANCIAL",
  EpcLicense = "EPC__LICENSE",
  EpcOther = "EPC__OTHER",
  EpcProduction = "EPC__PRODUCTION",
  EpcSchedule = "EPC__SCHEDULE",
  ExecutedRoofLease = "EXECUTED_ROOF_LEASE",
  Incentives = "INCENTIVES",
  InterconnectionApplication = "INTERCONNECTION__APPLICATION",
  InterconnectionOther = "INTERCONNECTION__OTHER",
  InterconnectionResult = "INTERCONNECTION__RESULT",
  InvestorBid = "INVESTOR__BID",
  InvestorOther = "INVESTOR__OTHER",
  PermitApplication = "PERMIT__APPLICATION",
  PermitOther = "PERMIT__OTHER",
  PermitResult = "PERMIT__RESULT",
  PpaContract = "PPA__CONTRACT",
  PpaOther = "PPA__OTHER",
  PpaTermSheet = "PPA__TERM_SHEET",
  Production_8760 = "PRODUCTION__8760",
  ProductionHelioscope = "PRODUCTION__HELIOSCOPE",
  ProductionOther = "PRODUCTION__OTHER",
  ProductionWeather = "PRODUCTION__WEATHER",
  SiteBlueprint = "SITE__BLUEPRINT",
  SiteElectricalDiagrams = "SITE__ELECTRICAL_DIAGRAMS",
  SiteEnergy = "SITE__ENERGY",
  SiteOther = "SITE__OTHER",
  SiteRoof = "SITE__ROOF",
  SiteRoofWarranty = "SITE__ROOF_WARRANTY",
  SiteStructuralDrawings = "SITE__STRUCTURAL_DRAWINGS",
  SiteWiringInstructions = "SITE__WIRING_INSTRUCTIONS",
  TermSheet = "TERM_SHEET",
}

export type DoeReferenceTypeMappingsInput = {
  coldStorage: Array<Scalars["String"]["input"]>
  dataCenter: Array<Scalars["String"]["input"]>
  fullServiceRestaurant: Array<Scalars["String"]["input"]>
  hospital: Array<Scalars["String"]["input"]>
  hotel: Array<Scalars["String"]["input"]>
  industrial: Array<Scalars["String"]["input"]>
  multifamily: Array<Scalars["String"]["input"]>
  office: Array<Scalars["String"]["input"]>
  outpatient: Array<Scalars["String"]["input"]>
  parkingLot: Array<Scalars["String"]["input"]>
  primarySchool: Array<Scalars["String"]["input"]>
  quickServiceRestaurant: Array<Scalars["String"]["input"]>
  retailStandalone: Array<Scalars["String"]["input"]>
  retailStripMall: Array<Scalars["String"]["input"]>
  secondarySchool: Array<Scalars["String"]["input"]>
  singleFamilyDetached: Array<Scalars["String"]["input"]>
  supermarket: Array<Scalars["String"]["input"]>
  warehouse: Array<Scalars["String"]["input"]>
}

export type DraftEmailInput = {
  bcc?: InputMaybe<Scalars["String"]["input"]>
  htmlBody: Scalars["String"]["input"]
  plaintextBody: Scalars["String"]["input"]
  subject: Scalars["String"]["input"]
  to: Scalars["String"]["input"]
}

export type DraftSite = {
  __typename?: "DraftSite"
  avgSqft1Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqft2Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqft3Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqft4Bd?: Maybe<Scalars["Float"]["output"]>
  avgSqftStudio?: Maybe<Scalars["Float"]["output"]>
  canReify: Scalars["Boolean"]["output"]
  capRate?: Maybe<Scalars["Float"]["output"]>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city?: Maybe<Scalars["String"]["output"]>
  costarPropertyType?: Maybe<Scalars["String"]["output"]>
  county?: Maybe<Scalars["String"]["output"]>
  createdBy: UserRef
  dateCreated: Scalars["DateTime"]["output"]
  dateUpdated?: Maybe<Scalars["DateTime"]["output"]>
  doeReferenceType?: Maybe<BuildingType>
  errors: Array<ValidationError>
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Float"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Float"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Float"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Float"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Float"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits1Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits2Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits3Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnits4Bd?: Maybe<Scalars["Float"]["output"]>
  numVacantUnitsStudio?: Maybe<Scalars["Float"]["output"]>
  ownedBy: UserRef
  pid: Scalars["String"]["output"]
  portfolioPid?: Maybe<Scalars["String"]["output"]>
  propertyName?: Maybe<Scalars["String"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state?: Maybe<UsState>
  streetAddress?: Maybe<Scalars["String"]["output"]>
  timeZone?: Maybe<Scalars["String"]["output"]>
  totalBuildings?: Maybe<Scalars["Int"]["output"]>
  updatedBy?: Maybe<UserRef>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode?: Maybe<Scalars["String"]["output"]>
}

export type DraftSiteFilter = {
  portfolioPids?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export type DraftSiteInputs = {
  avgSqft1Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqft2Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqft3Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqft4Bd?: InputMaybe<Scalars["Float"]["input"]>
  avgSqftStudio?: InputMaybe<Scalars["Float"]["input"]>
  capRate?: InputMaybe<Scalars["Float"]["input"]>
  city?: InputMaybe<Scalars["String"]["input"]>
  costarPropertyType?: InputMaybe<Scalars["String"]["input"]>
  doeReferenceType?: InputMaybe<BuildingType>
  latitude?: InputMaybe<Scalars["Float"]["input"]>
  longitude?: InputMaybe<Scalars["Float"]["input"]>
  numParkingSpaces?: InputMaybe<Scalars["Int"]["input"]>
  numStories?: InputMaybe<Scalars["Float"]["input"]>
  numUnits1Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnits2Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnits3Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnits4Bd?: InputMaybe<Scalars["Float"]["input"]>
  numUnitsStudio?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits1Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits2Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits3Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnits4Bd?: InputMaybe<Scalars["Float"]["input"]>
  numVacantUnitsStudio?: InputMaybe<Scalars["Float"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  propertyName?: InputMaybe<Scalars["String"]["input"]>
  roofSqft?: InputMaybe<Scalars["Float"]["input"]>
  sqft?: InputMaybe<Scalars["Float"]["input"]>
  state?: InputMaybe<UsState>
  streetAddress?: InputMaybe<Scalars["String"]["input"]>
  totalBuildings?: InputMaybe<Scalars["Int"]["input"]>
  yearBuilt?: InputMaybe<Scalars["Int"]["input"]>
  zipCode?: InputMaybe<Scalars["String"]["input"]>
}

export type DraftSiteMutations = {
  __typename?: "DraftSiteMutations"
  new: DraftSite
  reify: NewSite
  save: DraftSite
  trash?: Maybe<Scalars["Void"]["output"]>
}

export type DraftSiteMutationsNewArgs = {
  inputs: DraftSiteInputs
}

export type DraftSiteMutationsReifyArgs = {
  draftSitePid: Scalars["String"]["input"]
}

export type DraftSiteMutationsSaveArgs = {
  draftSitePid: Scalars["String"]["input"]
  inputs: DraftSiteInputs
}

export type DraftSiteMutationsTrashArgs = {
  draftSitePids: Array<Scalars["String"]["input"]>
}

export type DuplicateInvestorBidInput = {
  bidPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type DuplicatesAttachment = {
  __typename?: "DuplicatesAttachment"
  attachment: Attachment
}

export type E2Error = {
  __typename?: "E2Error"
  msg: Scalars["String"]["output"]
}

export type EiaGridEsc = {
  __typename?: "EIAGridEsc"
  cagrBlended: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  eiaId: Scalars["Int"]["output"]
  fromYear: Scalars["Int"]["output"]
  toYear: Scalars["Int"]["output"]
  updatedAt: Scalars["DateTime"]["output"]
}

export type EspmAccount = {
  __typename?: "ESPMAccount"
  createdAt: Scalars["DateTime"]["output"]
  externalAccountId: Scalars["Int"]["output"]
  externalData: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  properties: Array<EspmProperty>
  xml: Scalars["String"]["output"]
}

export type EspmConsumption = {
  __typename?: "ESPMConsumption"
  costUsd?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  end: Scalars["DateTime"]["output"]
  espmMeter: EspmMeter
  externalConsumptionId: Scalars["String"]["output"]
  externalData: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  start: Scalars["DateTime"]["output"]
  usageKwh: Scalars["Float"]["output"]
  xml: Scalars["String"]["output"]
}

export type EspmMeter = {
  __typename?: "ESPMMeter"
  billingMeter?: Maybe<BillingMeter>
  createdAt: Scalars["DateTime"]["output"]
  espmConsumptions: Array<EspmConsumption>
  espmProperty: EspmProperty
  externalData: Scalars["String"]["output"]
  externalMeterId: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  meterType: Scalars["String"]["output"]
  unitOfMeasure: Scalars["String"]["output"]
  xml: Scalars["String"]["output"]
}

export type EspmProperty = {
  __typename?: "ESPMProperty"
  accounts: Array<EspmAccount>
  createdAt: Scalars["DateTime"]["output"]
  espmMeters: Array<EspmMeter>
  externalData: Scalars["String"]["output"]
  externalPropertyId: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  lastUpdatedAt: Scalars["DateTime"]["output"]
  site?: Maybe<SiteRef>
  xml: Scalars["String"]["output"]
}

export type EtbBattery = {
  __typename?: "ETBBattery"
  etbMeterId: Scalars["Int"]["output"]
  etbMeterName: Scalars["String"]["output"]
  sizeKwDc: Scalars["Float"]["output"]
  sizeKwh: Scalars["Float"]["output"]
}

export type EtbCosts = {
  __typename?: "ETBCosts"
  averageLoadFactor: Scalars["Float"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  demandCostAfter: Scalars["Float"]["output"]
  demandCostBefore: Scalars["Float"]["output"]
  demandCostSavings: Scalars["Float"]["output"]
  energyConsumptionKwhYear1: Scalars["Float"]["output"]
  energyCostAfter: Scalars["Float"]["output"]
  energyCostBefore: Scalars["Float"]["output"]
  energyCostSavings: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  netCost: Scalars["Float"]["output"]
  netEnergyConsumptionKwhYear1: Scalars["Float"]["output"]
  pvDegradationRate: Scalars["Float"]["output"]
  pvGenerationKwhYear1: Scalars["Float"]["output"]
  pvGenerationPercentExported: Scalars["Float"]["output"]
  pvKwhPerKwDc: Scalars["Float"]["output"]
  pvNetCost: Scalars["Float"]["output"]
  pvPowerRatingKwAc: Scalars["Float"]["output"]
  pvPowerRatingKwDc: Scalars["Float"]["output"]
  pvSavingsPerKwh: Scalars["Float"]["output"]
  pvTotalCost: Scalars["Float"]["output"]
  storageCapacityKwh: Scalars["Float"]["output"]
  storageConsumptionKwhYear1: Scalars["Float"]["output"]
  storageDegradationRate: Scalars["Float"]["output"]
  storageDischargeYear1: Scalars["Float"]["output"]
  storageMaxDischargePowerKw: Scalars["Float"]["output"]
  storageNetCost: Scalars["Float"]["output"]
  storageSavingsPerKw: Scalars["Float"]["output"]
  storageSavingsPerKwh: Scalars["Float"]["output"]
  storageTotalCost: Scalars["Float"]["output"]
  storageTwoHourPowerRatingKw: Scalars["Float"]["output"]
  totalCost: Scalars["Float"]["output"]
  totalCostAfter: Scalars["Float"]["output"]
  totalCostBefore: Scalars["Float"]["output"]
  totalCostSavings: Scalars["Float"]["output"]
  totalIncentiveSavings: Scalars["Float"]["output"]
  utilityCostPerKwh: Scalars["Float"]["output"]
}

export type EtbExtract = {
  __typename?: "ETBExtract"
  battery: Array<EtbBattery>
  document: Document
  id: Scalars["Int"]["output"]
  pv: Array<Etbpv>
}

export type EtbMeter = {
  __typename?: "ETBMeter"
  bauMeter?: Maybe<BauMeter>
  city: Scalars["String"]["output"]
  costs: EtbCosts
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pv: Array<EtbpvArray>
  pvType?: Maybe<PvType>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  tariffAfter?: Maybe<Tariff>
  tariffBefore?: Maybe<Tariff>
  tariffEffectiveDateAfter: Scalars["DateTime"]["output"]
  tariffEffectiveDateBefore: Scalars["DateTime"]["output"]
  tariffFullDescriptionAfter: Scalars["String"]["output"]
  tariffFullDescriptionBefore: Scalars["String"]["output"]
  tariffShortDescriptionAfter: Scalars["String"]["output"]
  tariffShortDescriptionBefore: Scalars["String"]["output"]
  utility?: Maybe<Utility>
  utilityName: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type EtbMeterMutations = {
  __typename?: "ETBMeterMutations"
  setBauMeter: EtbMeter
  setPvType: EtbMeter
  setTariffAfter: EtbMeter
  setTariffBefore: EtbMeter
  setUtility: EtbMeter
}

export type EtbMeterMutationsSetBauMeterArgs = {
  bauMeterId?: InputMaybe<Scalars["Int"]["input"]>
  id: Scalars["Int"]["input"]
}

export type EtbMeterMutationsSetPvTypeArgs = {
  id: Scalars["Int"]["input"]
  pvType?: InputMaybe<PvType>
}

export type EtbMeterMutationsSetTariffAfterArgs = {
  id: Scalars["Int"]["input"]
  tariffAfterId?: InputMaybe<Scalars["Int"]["input"]>
}

export type EtbMeterMutationsSetTariffBeforeArgs = {
  id: Scalars["Int"]["input"]
  tariffBeforeId?: InputMaybe<Scalars["Int"]["input"]>
}

export type EtbMeterMutationsSetUtilityArgs = {
  id: Scalars["Int"]["input"]
  utilityId?: InputMaybe<Scalars["Int"]["input"]>
}

export type EtbMutations = {
  __typename?: "ETBMutations"
  setProjectName: EtbReport
}

export type EtbMutationsSetProjectNameArgs = {
  name: Scalars["String"]["input"]
}

export type Etbpv = {
  __typename?: "ETBPV"
  etbMeterId: Scalars["Int"]["output"]
  etbMeterName: Scalars["String"]["output"]
  sizeKwAc: Scalars["Float"]["output"]
  sizeKwDc: Scalars["Float"]["output"]
}

export type EtbpvArray = {
  __typename?: "ETBPVArray"
  azimuth: Scalars["Float"]["output"]
  cost: Scalars["Float"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  degradationRate: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  meter: EtbMeter
  powerRatingKwAc: Scalars["Float"]["output"]
  powerRatingKwDc: Scalars["Float"]["output"]
  tilt: Scalars["Float"]["output"]
}

export type EtbReport = {
  __typename?: "ETBReport"
  attachment?: Maybe<Attachment>
  batteryKw?: Maybe<Scalars["Float"]["output"]>
  batteryKwh?: Maybe<Scalars["Float"]["output"]>
  carportPvKw?: Maybe<Scalars["Float"]["output"]>
  combinedCosts?: Maybe<EtbCosts>
  costCalculation?: Maybe<CostCalculation>
  dateCreated: Scalars["DateTime"]["output"]
  discountRate: Scalars["Float"]["output"]
  document?: Maybe<Document>
  electricityEscalationRate: Scalars["Float"]["output"]
  federalIncomeTaxRate: Scalars["Float"]["output"]
  groundPvKw?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  meters: Array<EtbMeter>
  ownerSector: Scalars["String"]["output"]
  projectName: Scalars["String"]["output"]
  proposalDate: Scalars["DateTime"]["output"]
  roofPvKw?: Maybe<Scalars["Float"]["output"]>
  scenario?: Maybe<EtbScenarioRef>
  site: SiteRef
  solarLocation?: Maybe<SolarLocation>
  stateIncomeTaxRate: Scalars["Float"]["output"]
  taxType: Scalars["String"]["output"]
  transactions: Array<EtbTransaction>
}

export type EtbReportRef = {
  __typename?: "ETBReportRef"
  id: Scalars["Int"]["output"]
  projectName: Scalars["String"]["output"]
}

export type EtbScenarioRef = {
  __typename?: "ETBScenarioRef"
  includeStorage: Scalars["Boolean"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export type EtbSeries = {
  __typename?: "ETBSeries"
  name: Scalars["String"]["output"]
  series: Array<Scalars["Float"]["output"]>
}

export type EtbTransaction = {
  __typename?: "ETBTransaction"
  dateCreated: Scalars["DateTime"]["output"]
  demandSavingsTerm: Scalars["Float"]["output"]
  energySavingsTerm: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  irr10Year?: Maybe<Scalars["Float"]["output"]>
  irr20Year?: Maybe<Scalars["Float"]["output"]>
  irrTerm?: Maybe<Scalars["Float"]["output"]>
  lcoeAfter: Scalars["Float"]["output"]
  lcoeBefore: Scalars["Float"]["output"]
  lcoePv: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
  netCost: Scalars["Float"]["output"]
  npvTerm: Scalars["Float"]["output"]
  paybackYears?: Maybe<Scalars["Float"]["output"]>
  ppaEscalationRate?: Maybe<Scalars["Float"]["output"]>
  ppaStartingRate?: Maybe<Scalars["Float"]["output"]>
  ppaTerm?: Maybe<Scalars["Float"]["output"]>
  pvGenerationKwhTerm: Scalars["Float"]["output"]
  roiTerm?: Maybe<Scalars["Float"]["output"]>
  series: Array<EtbSeries>
  storageConsumptionKwh: Scalars["Float"]["output"]
  storageDischargeKwhTerm: Scalars["Float"]["output"]
  termYears: Scalars["Int"]["output"]
  totalCost: Scalars["Float"]["output"]
  totalIncentives: Scalars["Float"]["output"]
  totalSavingsTerm: Scalars["Float"]["output"]
  upfrontCost?: Maybe<Scalars["Float"]["output"]>
}

export type EvButtonMutations = {
  __typename?: "EVButtonMutations"
  press?: Maybe<Scalars["Void"]["output"]>
}

export type EvButtonMutationsPressArgs = {
  button: Scalars["String"]["input"]
}

export type EvCalc = {
  __typename?: "EVCalc"
  chargerLocation: ChargerLocation
  costPerKwhSeries: CleanIntervals
  createdAt: Scalars["DateTime"]["output"]
  dayRates: Array<Scalars["Float"]["output"]>
  downloadHourlyRatesHref: Scalars["String"]["output"]
  downloadXlsxHref: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  incentives: Array<EvIncentive>
  installCosts: Array<EvLineItem>
  markupUsdPerKwh: Scalars["Float"]["output"]
  npv: Scalars["Float"]["output"]
  numChargers: Scalars["Int"]["output"]
  optIters: Array<EvOptIter>
  optimalNumChargers: Scalars["Int"]["output"]
  outputs: EvOutputs
  parkingRatio?: Maybe<Scalars["Float"]["output"]>
  pid: Scalars["String"]["output"]
  projectInputs: EvProjectInputs
  propertyInputs: EvPropertyInputs
  seasonalDayRates: Array<SeasonalDayRate>
  site: SiteRef
  tariffRate: TariffRate
  timeZone: Scalars["String"]["output"]
  utility: UtilityRef
  utilityCostPerKwhSeries: CleanIntervals
  xlsx?: Maybe<Scalars["String"]["output"]>
  year3Expenses: Array<EvLineItem>
  yr3Cashflow?: Maybe<Scalars["Float"]["output"]>
  yr3NumEvs?: Maybe<Scalars["Float"]["output"]>
  yr3Revenue?: Maybe<Scalars["Float"]["output"]>
}

export type EvCalcMutations = {
  __typename?: "EVCalcMutations"
  create: EvCalc
}

export type EvIncentive = {
  __typename?: "EVIncentive"
  calculation: Scalars["String"]["output"]
  eligibleAreas: Scalars["String"]["output"]
  incentiveAmount: Scalars["String"]["output"]
  incentiveCap: Scalars["String"]["output"]
  programConstraints: Scalars["String"]["output"]
  programName: Scalars["String"]["output"]
  state?: Maybe<Scalars["String"]["output"]>
  url: Scalars["String"]["output"]
}

export type EvLineItem = {
  __typename?: "EVLineItem"
  label: Scalars["String"]["output"]
  value: Scalars["Float"]["output"]
}

export type EvOptIter = {
  __typename?: "EVOptIter"
  npv: Scalars["Float"]["output"]
  numChargers: Scalars["Float"]["output"]
}

export type EvOutputs = {
  __typename?: "EVOutputs"
  breakevenYear: Scalars["Float"]["output"]
  capexUsd: Scalars["Float"]["output"]
  cashflowSeries: Array<Scalars["Float"]["output"]>
  incentiveUsd: Scalars["Float"]["output"]
  irr?: Maybe<Scalars["Float"]["output"]>
  npv: Scalars["Float"]["output"]
  numChargersDemandedSeries: Array<Scalars["Float"]["output"]>
  numEvSeries: Array<Scalars["Float"]["output"]>
  revenueSeries: Array<Scalars["Float"]["output"]>
  yr0NumTenantEvs: Scalars["Float"]["output"]
}

export type EvOverrideMutations = {
  __typename?: "EVOverrideMutations"
  update?: Maybe<Scalars["Void"]["output"]>
}

export type EvOverrideMutationsUpdateArgs = {
  chargerKw?: InputMaybe<Scalars["Float"]["input"]>
  chargerLocation?: InputMaybe<ChargerLocation>
  cmsUsdPerChargerPerYr?: InputMaybe<Scalars["Float"]["input"]>
  demandUsdPerKw?: InputMaybe<Scalars["Float"]["input"]>
  discountRate?: InputMaybe<Scalars["Float"]["input"]>
  evGrowthPct?: InputMaybe<Scalars["Float"]["input"]>
  highEnergyUsdPerKwh?: InputMaybe<Scalars["Float"]["input"]>
  incentiveCapNumChargers?: InputMaybe<Scalars["Int"]["input"]>
  incentivePct?: InputMaybe<Scalars["Float"]["input"]>
  installCostUsd?: InputMaybe<Scalars["Float"]["input"]>
  installType?: InputMaybe<ChargerInstallType>
  lowEnergyUsdPerKwh?: InputMaybe<Scalars["Float"]["input"]>
  maxEvAdoptionPct?: InputMaybe<Scalars["Float"]["input"]>
  maxUtilization?: InputMaybe<Scalars["Float"]["input"]>
  milesDrivenPerYear?: InputMaybe<Scalars["Float"]["input"]>
  milesPerKwh?: InputMaybe<Scalars["Float"]["input"]>
  numChargers?: InputMaybe<Scalars["Float"]["input"]>
  omUsdPerChargerPerYr?: InputMaybe<Scalars["Float"]["input"]>
  onPeakChargingPct?: InputMaybe<Scalars["Float"]["input"]>
  onSiteChargingPct?: InputMaybe<Scalars["Float"]["input"]>
  projectStartDate?: InputMaybe<Scalars["DateTime"]["input"]>
  rateManagementUsdPerChargerPerYr?: InputMaybe<Scalars["Float"]["input"]>
  salesTaxPct?: InputMaybe<Scalars["Float"]["input"]>
  termYears?: InputMaybe<Scalars["Int"]["input"]>
  transactionFeePct?: InputMaybe<Scalars["Float"]["input"]>
  usdPerKwhMarkup?: InputMaybe<Scalars["Float"]["input"]>
  yr0NumTenantEvs?: InputMaybe<Scalars["Int"]["input"]>
}

export type EvOverrideQueries = {
  __typename?: "EVOverrideQueries"
  current?: Maybe<EvOverrides>
  defaults: EvProjectInputs
}

export type EvOverrides = {
  __typename?: "EVOverrides"
  chargerKw?: Maybe<Scalars["Float"]["output"]>
  chargerLocation?: Maybe<ChargerLocation>
  cmsUsdPerChargerPerYr?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  demandUsdPerKw?: Maybe<Scalars["Float"]["output"]>
  discountRate?: Maybe<Scalars["Float"]["output"]>
  evGrowthPct?: Maybe<Scalars["Float"]["output"]>
  highEnergyUsdPerKwh?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  incentiveCapNumChargers?: Maybe<Scalars["Int"]["output"]>
  incentivePct?: Maybe<Scalars["Float"]["output"]>
  installCostUsd?: Maybe<Scalars["Float"]["output"]>
  installType?: Maybe<ChargerInstallType>
  lowEnergyUsdPerKwh?: Maybe<Scalars["Float"]["output"]>
  maxEvAdoptionPct?: Maybe<Scalars["Float"]["output"]>
  maxUtilization?: Maybe<Scalars["Float"]["output"]>
  milesDrivenPerYear?: Maybe<Scalars["Float"]["output"]>
  milesPerKwh?: Maybe<Scalars["Float"]["output"]>
  numChargers?: Maybe<Scalars["Float"]["output"]>
  omUsdPerChargerPerYr?: Maybe<Scalars["Float"]["output"]>
  onPeakChargingPct?: Maybe<Scalars["Float"]["output"]>
  onSiteChargingPct?: Maybe<Scalars["Float"]["output"]>
  parent?: Maybe<EvOverrides>
  projectStartDate?: Maybe<Scalars["DateTime"]["output"]>
  rateManagementUsdPerChargerPerYr?: Maybe<Scalars["Float"]["output"]>
  salesTaxPct?: Maybe<Scalars["Float"]["output"]>
  termYears?: Maybe<Scalars["Int"]["output"]>
  transactionFeePct?: Maybe<Scalars["Float"]["output"]>
  usdPerKwhMarkup?: Maybe<Scalars["Float"]["output"]>
  user: UserRef
  yr0NumTenantEvs?: Maybe<Scalars["Int"]["output"]>
}

export type EvProjectInputs = {
  __typename?: "EVProjectInputs"
  chargerKw: Scalars["Float"]["output"]
  chargerLocation: ChargerLocation
  cmsUsdPerChargerPerYr: Scalars["Float"]["output"]
  demandUsdPerKw?: Maybe<Scalars["Float"]["output"]>
  discountRate: Scalars["Float"]["output"]
  evGrowthPct?: Maybe<Scalars["Float"]["output"]>
  highEnergyUsdPerKwh: Scalars["Float"]["output"]
  incentiveCapNumChargers?: Maybe<Scalars["Int"]["output"]>
  incentivePct: Scalars["Float"]["output"]
  installCostUsd?: Maybe<Scalars["Float"]["output"]>
  installType: ChargerInstallType
  lowEnergyUsdPerKwh: Scalars["Float"]["output"]
  maxEvAdoptionPct: Scalars["Float"]["output"]
  maxUtilization: Scalars["Float"]["output"]
  milesDrivenPerYear: Scalars["Float"]["output"]
  milesPerKwh: Scalars["Float"]["output"]
  numChargers?: Maybe<Scalars["Float"]["output"]>
  omUsdPerChargerPerYr: Scalars["Float"]["output"]
  onPeakChargingPct: Scalars["Float"]["output"]
  onSiteChargingPct: Scalars["Float"]["output"]
  projectStartDate: Scalars["DateTime"]["output"]
  rateManagementUsdPerChargerPerYr: Scalars["Float"]["output"]
  salesTaxPct: Scalars["Float"]["output"]
  termYears: Scalars["Int"]["output"]
  transactionFeePct: Scalars["Float"]["output"]
  usdPerKwhMarkup: Scalars["Float"]["output"]
  yr0NumTenantEvs?: Maybe<Scalars["Int"]["output"]>
}

export type EvPropertyInputs = {
  __typename?: "EVPropertyInputs"
  address: Scalars["String"]["output"]
  dataYear: Scalars["Int"]["output"]
  evGrowthRates: Array<Scalars["Float"]["output"]>
  evGrowthYears: Array<Scalars["Int"]["output"]>
  numEvs: Scalars["Int"]["output"]
  numHouseholds: Scalars["Int"]["output"]
  numParkingSpaces: Scalars["Int"]["output"]
  numUnits?: Maybe<Scalars["Int"]["output"]>
  numVehicles?: Maybe<Scalars["Int"]["output"]>
  pid: Scalars["String"]["output"]
}

export type EnergyProduction = {
  __typename?: "EnergyProduction"
  currentTime: Scalars["String"]["output"]
  kwhAllTime: Scalars["Float"]["output"]
  kwhPerDay: Array<SolarPerDay>
  kwhToday: Scalars["Float"]["output"]
  projectedNextInterval: Scalars["Float"]["output"]
  sites: Array<SolarSite>
}

export enum EnergyThing {
  CarportSolar = "CARPORT_SOLAR",
  GroundmountSolar = "GROUNDMOUNT_SOLAR",
  RooftopSolar = "ROOFTOP_SOLAR",
  Storage = "STORAGE",
}

export type EnergyThings = {
  __typename?: "EnergyThings"
  canCarportSolar?: Maybe<Scalars["Boolean"]["output"]>
  canGroundmountSolar?: Maybe<Scalars["Boolean"]["output"]>
  canRooftopSolar: Scalars["Boolean"]["output"]
  canStorage: Scalars["Boolean"]["output"]
}

export type EnergyThingsPred = {
  value: Array<EnergyThing>
}

export type Error = {
  __typename?: "Error"
  message: Scalars["String"]["output"]
}

export type Exchange = {
  __typename?: "Exchange"
  messages: Array<Message>
  response: Response
}

export type Experience = {
  __typename?: "Experience"
  btmAwardedPvKw?: Maybe<Scalars["Float"]["output"]>
  btmEnergizedPvKw?: Maybe<Scalars["Float"]["output"]>
  ftmAwardedPvKw?: Maybe<Scalars["Float"]["output"]>
  ftmEnergizedPvKw?: Maybe<Scalars["Float"]["output"]>
  state?: Maybe<UsState>
}

export type ExperienceInput = {
  btmAwardedPvKw?: InputMaybe<Scalars["Float"]["input"]>
  btmEnergizedPvKw?: InputMaybe<Scalars["Float"]["input"]>
  ftmAwardedPvKw?: InputMaybe<Scalars["Float"]["input"]>
  ftmEnergizedPvKw?: InputMaybe<Scalars["Float"]["input"]>
  state?: InputMaybe<UsState>
}

export type ExtractBillLineItemsInput = {
  documentBillingMonthId: Scalars["Int"]["input"]
}

export type FailureDetails = {
  __typename?: "FailureDetails"
  description: Scalars["String"]["output"]
  label: Scalars["String"]["output"]
}

export type FancyFloat = {
  __typename?: "FancyFloat"
  number: Scalars["Float"]["output"]
  source: FancySource
}

export enum FancySource {
  Ab802 = "AB802",
  Document = "DOCUMENT",
  Espm = "ESPM",
  Estimate = "ESTIMATE",
  Placeholder = "PLACEHOLDER",
  User = "USER",
}

export type FieldChangeLogHistory = {
  __typename?: "FieldChangeLogHistory"
  history: Array<ChangeLogEntry>
  latest?: Maybe<ChangeLogEntry>
}

export type FileContent = {
  __typename?: "FileContent"
  file: RawFile
  type: Scalars["String"]["output"]
}

export type FinProductMutations = {
  __typename?: "FinProductMutations"
  createCsFinproduct: AdminFinProduct
  createLoanFinproduct: AdminFinProduct
  createPpaFinproduct: AdminFinProduct
  editCsFinproductPrices: AdminFinProduct
  setDisabled: AdminFinProduct
  setIncludeStorage: AdminFinProduct
  setName: AdminFinProduct
  setStatus: AdminFinProduct
}

export type FinProductMutationsCreateCsFinproductArgs = {
  input: CsFinProductInput
}

export type FinProductMutationsCreateLoanFinproductArgs = {
  input: LoanFinProductInput
}

export type FinProductMutationsCreatePpaFinproductArgs = {
  input: PpaFinProductInput
}

export type FinProductMutationsEditCsFinproductPricesArgs = {
  id: Scalars["Int"]["input"]
  input: Array<CsPriceInput>
}

export type FinProductMutationsSetDisabledArgs = {
  disabled: Scalars["Boolean"]["input"]
  id: Scalars["Int"]["input"]
}

export type FinProductMutationsSetIncludeStorageArgs = {
  id: Scalars["Int"]["input"]
  includeStorage: Scalars["Boolean"]["input"]
}

export type FinProductMutationsSetNameArgs = {
  id: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
}

export type FinProductMutationsSetStatusArgs = {
  id: Scalars["Int"]["input"]
  status?: InputMaybe<FinProductStatus>
}

export type FinProductRef = {
  __typename?: "FinProductRef"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  type: FinProductType
}

export enum FinProductStatus {
  Estimated = "ESTIMATED",
  Final = "FINAL",
  Indicative = "INDICATIVE",
}

export enum FinProductType {
  Cs = "CS",
  Lease = "LEASE",
  Loan = "LOAN",
  Ppa = "PPA",
  Self = "SELF",
}

export type FinProductTypePred = {
  value: Array<InputMaybe<FinProductType>>
}

export type FinancierProjectTable = {
  __typename?: "FinancierProjectTable"
  rows: Array<FinancierProjectTableRow>
  view: FinancierProjectTableView
}

export type FinancierProjectTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type FinancierProjectTableViewArgs = {
  filterBy?: InputMaybe<FinancierProjectTableFilter>
  sortBy?: InputMaybe<Array<FinancierProjectTableSort>>
}

export enum FinancierProjectTableAttr {
  BidStatuses = "BID_STATUSES",
  BundleBiddingClosedAt = "BUNDLE_BIDDING_CLOSED_AT",
  BundleBiddingOpenAt = "BUNDLE_BIDDING_OPEN_AT",
  BundleName = "BUNDLE_NAME",
  BundlePid = "BUNDLE_PID",
  BundleRowCloseCustomReason = "BUNDLE_ROW_CLOSE_CUSTOM_REASON",
  BundleRowCloseReason = "BUNDLE_ROW_CLOSE_REASON",
  BundleRowIsClosed = "BUNDLE_ROW_IS_CLOSED",
  BundleRowState = "BUNDLE_ROW_STATE",
  BundleType = "BUNDLE_TYPE",
  City = "CITY",
  Name = "NAME",
  OptedOut = "OPTED_OUT",
  OrgName = "ORG_NAME",
  SitePid = "SITE_PID",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  ZipCode = "ZIP_CODE",
}

export type FinancierProjectTableFilter = {
  bundleBiddingClosedAt?: InputMaybe<DatePred>
  bundleBiddingOpenAt?: InputMaybe<DatePred>
  bundleName?: InputMaybe<StringPred>
  bundlePid?: InputMaybe<StringPred>
  bundleRowCloseCustomReason?: InputMaybe<StringPred>
  bundleRowCloseReason?: InputMaybe<CloseReasonPred>
  bundleRowIsClosed?: InputMaybe<BoolPred>
  bundleRowState?: InputMaybe<BundleStatePred>
  bundleType?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  id?: InputMaybe<StringPred>
  name?: InputMaybe<StringPred>
  optedOut?: InputMaybe<BoolPred>
  orgName?: InputMaybe<StringPred>
  search?: InputMaybe<SearchPred>
  sitePid?: InputMaybe<StringPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
}

export type FinancierProjectTableRow = {
  __typename?: "FinancierProjectTableRow"
  bidStatuses: Array<InvestorBidStatus>
  bundleBiddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  bundleBiddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  bundleName: Scalars["String"]["output"]
  bundlePid: Scalars["String"]["output"]
  bundleRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  bundleRowCloseReason?: Maybe<CloseReason>
  bundleRowIsClosed: Scalars["Boolean"]["output"]
  bundleRowState?: Maybe<BundleState>
  bundleType: FinProductType
  city: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  optedOut: Scalars["Boolean"]["output"]
  orgName: Scalars["String"]["output"]
  sitePid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type FinancierProjectTableSort = {
  attr: FinancierProjectTableAttr
  order: SortOrder
}

export type FinancierProjectTableStats = {
  __typename?: "FinancierProjectTableStats"
  buildingOwners: Array<Scalars["String"]["output"]>
}

export type FinancierProjectTableView = {
  __typename?: "FinancierProjectTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
  stats: FinancierProjectTableStats
}

export type FinancingThings = {
  __typename?: "FinancingThings"
  canCommunitySolar?: Maybe<Scalars["Boolean"]["output"]>
  canLease?: Maybe<Scalars["Boolean"]["output"]>
  canLoan: Scalars["Boolean"]["output"]
  canPpa?: Maybe<Scalars["Boolean"]["output"]>
  canSelfInvest: Scalars["Boolean"]["output"]
}

export type FinancingThingsPred = {
  value: Array<FinProductType>
}

export type Finmodel = {
  __typename?: "Finmodel"
  buildingOwnerNoiAnnualUsd: Scalars["Float"]["output"]
  buildingOwnerNoiLifetimeUsd: Scalars["Float"]["output"]
  co2EmissionsReductionTonnes?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  failure: Array<FinmodelFailureRef>
  finproduct: AdminFinProduct
  fmvNum: Scalars["Int"]["output"]
  fmvStr: Scalars["String"]["output"]
  gridMeters: Array<GridMeter>
  id: Scalars["Int"]["output"]
  inputs: Scalars["JSON"]["output"]
  leDevFee: Scalars["Float"]["output"]
  leDevFeePct: Scalars["Float"]["output"]
  lux?: Maybe<Lux>
  pid: Scalars["String"]["output"]
  postTaxItcDeprIrr?: Maybe<Scalars["Float"]["output"]>
  preTaxIrr?: Maybe<Scalars["Float"]["output"]>
  pvSizeKw: Scalars["Float"]["output"]
  scenario?: Maybe<ScenarioRef>
  site: SiteRef
  storageSizeKw: Scalars["Float"]["output"]
  storageSizeKwh: Scalars["Float"]["output"]
  type: FinProductType
}

export type FinmodelCost = {
  __typename?: "FinmodelCost"
  items: Array<LineItem>
  tariffs: Array<RevampTariff>
  totalCostUsd: Scalars["Float"]["output"]
  totalKwh: Scalars["Float"]["output"]
  usdPerKwh: Scalars["Float"]["output"]
}

export type FinmodelFailure = {
  __typename?: "FinmodelFailure"
  createdAt: Scalars["DateTime"]["output"]
  finmodel?: Maybe<Finmodel>
  finproduct?: Maybe<AdminFinProduct>
  fmv: Scalars["Int"]["output"]
  id: Scalars["Int"]["output"]
  isCs: Scalars["Boolean"]["output"]
  isLux: Scalars["Boolean"]["output"]
  isPvopt: Scalars["Boolean"]["output"]
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  scenario: ScenarioRef
  site: SiteRef
  source?: Maybe<FinmodelSource>
}

export type FinmodelFailureRef = {
  __typename?: "FinmodelFailureRef"
  id: Scalars["Int"]["output"]
}

export type FinmodelInputOverride = {
  __typename?: "FinmodelInputOverride"
  createdBy?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  dateTrashed?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  inputName: Scalars["String"]["output"]
  inputValue: Scalars["String"]["output"]
  source: FinmodelInputOverrideSource
}

export type FinmodelInputOverrideError = Error | FinmodelInputOverride

export enum FinmodelInputOverrideSource {
  FinancingOrg = "FINANCING_ORG",
  Finproduct = "FINPRODUCT",
  Portfolio = "PORTFOLIO",
  Site = "SITE",
}

export type FinmodelMutationInput = { gridEsc: Scalars["Float"]["input"] }

export type FinmodelMutations = {
  __typename?: "FinmodelMutations"
  addOverride: FinmodelInputOverrideError
  deleteOverride?: Maybe<FinmodelInputOverride>
}

export type FinmodelMutationsAddOverrideArgs = {
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  inputName: Scalars["String"]["input"]
  inputValue: Scalars["String"]["input"]
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}

export type FinmodelMutationsDeleteOverrideArgs = {
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  inputName: Scalars["String"]["input"]
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}

export type FinmodelSettings = {
  __typename?: "FinmodelSettings"
  possibleOverrides: Array<Overridable>
}

export type FinmodelSource = EtbReportRef | LuxRef | PVoptRef | ReoptRef

export type FinmodelTable = {
  __typename?: "FinmodelTable"
  rows: Array<FinmodelTableRow>
  view: FinmodelTableView
}

export type FinmodelTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type FinmodelTableViewArgs = {
  filterBy?: InputMaybe<FinmodelTableFilter>
  sortBy?: InputMaybe<Array<FinmodelTableSort>>
}

export enum FinmodelTableAttr {
  BuildingOwnerNoiLifetimeUsd = "BUILDING_OWNER_NOI_LIFETIME_USD",
  CreatedAt = "CREATED_AT",
  FmvStr = "FMV_STR",
  Name = "NAME",
  Pid = "PID",
  ScenarioIncludeStorage = "SCENARIO_INCLUDE_STORAGE",
  ScenarioName = "SCENARIO_NAME",
  ScenarioPid = "SCENARIO_PID",
  ScenarioSolarLocation = "SCENARIO_SOLAR_LOCATION",
  Type = "TYPE",
}

export type FinmodelTableFilter = {
  buildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  scenarioPid?: InputMaybe<ScenarioPred>
}

export type FinmodelTableRow = {
  __typename?: "FinmodelTableRow"
  buildingOwnerNoiLifetimeUsd: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  fmvStr: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  scenarioIncludeStorage: Scalars["Boolean"]["output"]
  scenarioName: Scalars["String"]["output"]
  scenarioPid: Scalars["String"]["output"]
  scenarioSolarLocation: SolarLocation
  type: FinProductType
}

export type FinmodelTableSort = {
  attr: FinmodelTableAttr
  order: SortOrder
}

export type FinmodelTableView = {
  __typename?: "FinmodelTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type FloatInput = {
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type FloatPred = {
  gte?: InputMaybe<Scalars["Float"]["input"]>
  lte?: InputMaybe<Scalars["Float"]["input"]>
  missing?: Scalars["Boolean"]["input"]
}

export type Footprint = {
  __typename?: "Footprint"
  bounds?: Maybe<Scalars["JSON"]["output"]>
  carportShape?: Maybe<Scalars["JSON"]["output"]>
  carportShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  carportShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  carportShapeUpdatedBy?: Maybe<UserRef>
  geocodedLocation: GeocodedLocation
  groundmountShape?: Maybe<Scalars["JSON"]["output"]>
  groundmountShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  groundmountShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  groundmountShapeUpdatedBy?: Maybe<UserRef>
  keepoutsShape?: Maybe<Scalars["JSON"]["output"]>
  keepoutsShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  keepoutsShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  keepoutsShapeUpdatedBy?: Maybe<UserRef>
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
  obstructionShape?: Maybe<Scalars["JSON"]["output"]>
  obstructionShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  parcelShape?: Maybe<Scalars["JSON"]["output"]>
  parcelShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  parcelShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  parcelShapeUpdatedBy?: Maybe<UserRef>
  roofSetbackShape?: Maybe<Scalars["JSON"]["output"]>
  roofSetbackShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  roofSetbackShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  roofSetbackShapeUpdatedBy?: Maybe<UserRef>
  roofShape?: Maybe<Scalars["JSON"]["output"]>
  roofShapeGeojson?: Maybe<Scalars["JSON"]["output"]>
  roofShapeUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>
  roofShapeUpdatedBy?: Maybe<UserRef>
}

export type FootprintError = Error | Footprint

export enum FootprintStrategy {
  AllBuildingsOnParcel = "ALL_BUILDINGS_ON_PARCEL",
  ClosestBuilding = "CLOSEST_BUILDING",
}

export type FormattedBill = {
  __typename?: "FormattedBill"
  charges: Array<BillSection>
  exports: Array<BillSection>
  kwhCharge: Scalars["Float"]["output"]
  kwhSupplyCharge: Scalars["Float"]["output"]
  month: Scalars["String"]["output"]
}

export type FormattedBills = {
  __typename?: "FormattedBills"
  bills: Array<FormattedBill>
  rate?: Maybe<TariffRate>
}

export type Function = {
  __typename?: "Function"
  arguments: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export enum GaugeRazzleDazzle {
  Cold = "COLD",
  Fire = "FIRE",
  Hot = "HOT",
  Warm = "WARM",
}

export type GeocodedLocation = {
  __typename?: "GeocodedLocation"
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
}

export type GeographicIncentives = {
  __typename?: "GeographicIncentives"
  inEnergyCommunity: Scalars["Boolean"]["output"]
  inLowIncomeCommunity: Scalars["Boolean"]["output"]
}

export type GmailSendAs = {
  __typename?: "GmailSendAs"
  displayName: Scalars["String"]["output"]
  sendAsEmail: Scalars["String"]["output"]
  signature: Scalars["String"]["output"]
}

export type GoogleApiMutations = {
  __typename?: "GoogleApiMutations"
  /** @deprecated use draft_email */
  createDraft?: Maybe<Scalars["Void"]["output"]>
  draftEmail?: Maybe<Scalars["Void"]["output"]>
}

export type GoogleApiMutationsCreateDraftArgs = {
  draftParams: CreateDraftInput
}

export type GoogleApiMutationsDraftEmailArgs = {
  draftParams: DraftEmailInput
}

export type GoogleApiQuery = {
  __typename?: "GoogleApiQuery"
  sendAs: GmailSendAs
}

export type GridMeter = {
  __typename?: "GridMeter"
  bauMeter?: Maybe<BauMeter>
  costs: CostCalculation
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  loadCategory: LoadCategory
  postBattery?: Maybe<MeterCalc>
  postSolar: MeterCalc
  preSolar: MeterCalc
}

export type GroupedLineItem = {
  __typename?: "GroupedLineItem"
  cost: Scalars["Float"]["output"]
  group?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  rate: Scalars["Float"]["output"]
  unit?: Maybe<ChargeUnit>
  usage: Scalars["Float"]["output"]
}

export type GuessTariffFailure = {
  __typename?: "GuessTariffFailure"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  loadCategory: LoadCategory
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type HeartbeatInput = {
  dummy?: InputMaybe<Scalars["String"]["input"]>
}

export type HelioPvSpec = {
  __typename?: "HelioPVSpec"
  pvType: PvType
  sizeKw: Scalars["Float"]["output"]
}

export type Helioscope = {
  __typename?: "Helioscope"
  acNameplateKw?: Maybe<Scalars["Float"]["output"]>
  allocations?: Maybe<Scalars["JSON"]["output"]>
  annualProductionAcKwh: Scalars["Float"]["output"]
  carportIsMax: Scalars["Boolean"]["output"]
  carportPvKw: Scalars["Float"]["output"]
  carportPvSixHighKw: Scalars["Float"]["output"]
  carportPvThreeHighKw: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  dcNameplateKw?: Maybe<Scalars["Float"]["output"]>
  groundPvKw: Scalars["Float"]["output"]
  id: Scalars["Int"]["output"]
  inverterType?: Maybe<Scalars["String"]["output"]>
  isTrashed: Scalars["Boolean"]["output"]
  loadRatio?: Maybe<Scalars["Float"]["output"]>
  moduleType?: Maybe<Scalars["String"]["output"]>
  monthlyProductionAcKwh?: Maybe<Array<Scalars["Float"]["output"]>>
  notes?: Maybe<Scalars["String"]["output"]>
  pdf: Attachment
  pdfHref: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  productionCsv?: Maybe<Attachment>
  pvKw: Scalars["Float"]["output"]
  pvSpecs: Array<HelioPvSpec>
  rackingConnectionType?: Maybe<ConnectionType>
  rackingManufacturer?: Maybe<Scalars["String"]["output"]>
  rackingTiltDegrees?: Maybe<Scalars["Float"]["output"]>
  roofImage: Attachment
  roofImageHref: Scalars["String"]["output"]
  roofIsMax: Scalars["Boolean"]["output"]
  roofPvKw: Scalars["Float"]["output"]
  site: SiteRef
  systemProductivityKwhPerKw?: Maybe<Scalars["Float"]["output"]>
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  trashedBy?: Maybe<UserRef>
}

export type Helioscope2 = {
  __typename?: "Helioscope2"
  acNameplateKw?: Maybe<Scalars["Float"]["output"]>
  annualProductionAcKwh?: Maybe<Scalars["Float"]["output"]>
  carportPvSixHighKw?: Maybe<Scalars["Float"]["output"]>
  carportPvThreeHighKw?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  dcNameplateKw?: Maybe<Scalars["Float"]["output"]>
  groundPvKw?: Maybe<Scalars["Float"]["output"]>
  id: Scalars["Int"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  ownerOrg: Org
  pdf: Document
  pid: Scalars["String"]["output"]
  productionCsv?: Maybe<Document>
  roofImage: Document
  roofPvKw?: Maybe<Scalars["Float"]["output"]>
  site: SiteRef
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  trashedBy?: Maybe<UserRef>
}

export type HelioscopeAssumptionsInput = {
  acNameplateKw?: InputMaybe<Scalars["Float"]["input"]>
  dcNameplateKw?: InputMaybe<Scalars["Float"]["input"]>
  inverterType?: InputMaybe<Scalars["String"]["input"]>
  moduleType?: InputMaybe<Scalars["String"]["input"]>
  notes?: InputMaybe<Scalars["String"]["input"]>
  rackingConnectionType?: InputMaybe<ConnectionType>
  rackingManufacturer?: InputMaybe<Scalars["String"]["input"]>
  rackingTiltDegrees?: InputMaybe<Scalars["Float"]["input"]>
}

export type HostingCapacityMap = {
  __typename?: "HostingCapacityMap"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  requiresLogin: Scalars["Boolean"]["output"]
  types: Array<HostingCapacityMapType>
  url: Scalars["String"]["output"]
  utility: Utility
}

export type HostingCapacityMapInputs = {
  requiresLogin: Scalars["Boolean"]["input"]
  types: Array<HostingCapacityMapType>
  url: Scalars["String"]["input"]
}

export type HostingCapacityMapMutations = {
  __typename?: "HostingCapacityMapMutations"
  create?: Maybe<Scalars["Void"]["output"]>
  delete?: Maybe<Scalars["Void"]["output"]>
  update?: Maybe<Scalars["Void"]["output"]>
}

export type HostingCapacityMapMutationsCreateArgs = {
  inputs: HostingCapacityMapInputs
  utilityPid: Scalars["String"]["input"]
}

export type HostingCapacityMapMutationsDeleteArgs = {
  mapId: Scalars["Int"]["input"]
}

export type HostingCapacityMapMutationsUpdateArgs = {
  inputs: HostingCapacityMapInputs
  mapId: Scalars["Int"]["input"]
}

export type HostingCapacityMapQuery = {
  __typename?: "HostingCapacityMapQuery"
  all: Array<HostingCapacityMap>
}

export enum HostingCapacityMapType {
  AssetMap = "ASSET_MAP",
  Der = "DER",
  Load = "LOAD",
  Storage = "STORAGE",
}

export enum IrrType {
  PostTaxItcDeprIrr = "POST_TAX_ITC_DEPR_IRR",
  PreTaxIrr = "PRE_TAX_IRR",
  PreTaxItcIrr = "PRE_TAX_ITC_IRR",
}

export type IrRs = {
  __typename?: "IRRs"
  postTaxItcDepr?: Maybe<Scalars["Float"]["output"]>
  postTaxItcDeprMultiple?: Maybe<Scalars["Float"]["output"]>
  preTax?: Maybe<Scalars["Float"]["output"]>
  preTaxMultiple?: Maybe<Scalars["Float"]["output"]>
}

export type ImageContent = {
  __typename?: "ImageContent"
  imageUrl: ImageUrl
  type: Scalars["String"]["output"]
}

export type ImageUrl = {
  __typename?: "ImageUrl"
  url: Scalars["String"]["output"]
}

export enum InputType {
  Bool = "BOOL",
  Datetime = "DATETIME",
  Float = "FLOAT",
  Int = "INT",
  List = "LIST",
  String = "STRING",
}

export type IntInput = {
  value?: InputMaybe<Scalars["Int"]["input"]>
}

export type IntPred = {
  gte?: InputMaybe<Scalars["Int"]["input"]>
  lte?: InputMaybe<Scalars["Int"]["input"]>
  missing?: Scalars["Boolean"]["input"]
}

export type IntegerValue = {
  __typename?: "IntegerValue"
  integer: Scalars["Int"]["output"]
}

export type InvestorBid = {
  __typename?: "InvestorBid"
  canEdit: Scalars["Boolean"]["output"]
  cs?: Maybe<CsInvestorBid>
  ppa?: Maybe<PpaInvestorBid>
}

export type InvestorBidInput =
  | { cs: CsInvestorBidInput; ppa?: never }
  | { cs?: never; ppa: PpaInvestorBidInput }

export type InvestorBidSpecOptOut = {
  __typename?: "InvestorBidSpecOptOut"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  customReason?: Maybe<Scalars["String"]["output"]>
  reason?: Maybe<SpecOptOutReason>
}

export enum InvestorBidStatus {
  InProgress = "IN_PROGRESS",
  Submitted = "SUBMITTED",
  Unset = "UNSET",
}

export type InvestorBidsTable = {
  __typename?: "InvestorBidsTable"
  rows: Array<InvestorBidsTableRow>
  view: InvestorBidsTableView
}

export type InvestorBidsTableRowsArgs = {
  keys: Array<Scalars["String"]["input"]>
}

export type InvestorBidsTableViewArgs = {
  filterBy?: InputMaybe<InvestorBidsTableFilter>
  sortBy?: InputMaybe<Array<InvestorBidsTableSort>>
}

export enum InvestorBidsTableAttr {
  AssetManager = "ASSET_MANAGER",
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidName = "BID_NAME",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingLegalName = "BUILDING_LEGAL_NAME",
  BuildingOwnerExtraPaymentsUsd = "BUILDING_OWNER_EXTRA_PAYMENTS_USD",
  BuildingType = "BUILDING_TYPE",
  BundleParentPid = "BUNDLE_PARENT_PID",
  BundleRowPid = "BUNDLE_ROW_PID",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  ConstructionEmail = "CONSTRUCTION_EMAIL",
  CounselApproval = "COUNSEL_APPROVAL",
  County = "COUNTY",
  CsBuildingOwnerNoiLifetimeUsd = "CS_BUILDING_OWNER_NOI_LIFETIME_USD",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  CsRoofRentEscalator = "CS_ROOF_RENT_ESCALATOR",
  CsRoofRentNpv = "CS_ROOF_RENT_NPV",
  CsRoofRentY1Usd = "CS_ROOF_RENT_Y1_USD",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExternalLeaseApprovers = "EXTERNAL_LEASE_APPROVERS",
  ExtraPaymentsNotes = "EXTRA_PAYMENTS_NOTES",
  FinancierLogomarkUrl = "FINANCIER_LOGOMARK_URL",
  FinancierLogoUrl = "FINANCIER_LOGO_URL",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinancingType = "FINANCING_TYPE",
  IncentivesNotes = "INCENTIVES_NOTES",
  InterconnectionCostNonUtilityUsd = "INTERCONNECTION_COST_NON_UTILITY_USD",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  InterconnectionCostUtilityMaxUsd = "INTERCONNECTION_COST_UTILITY_MAX_USD",
  InterconnectionCostUtilityMinUsd = "INTERCONNECTION_COST_UTILITY_MIN_USD",
  InterconnectionNotes = "INTERCONNECTION_NOTES",
  InterconnectionRepriceProcessNotes = "INTERCONNECTION_REPRICE_PROCESS_NOTES",
  IsAwardedBid = "IS_AWARDED_BID",
  IsFannieMaeLender = "IS_FANNIE_MAE_LENDER",
  IsFmGlobalInsurer = "IS_FM_GLOBAL_INSURER",
  IsRecommendedBid = "IS_RECOMMENDED_BID",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Latitude = "LATITUDE",
  LeaseApprovers = "LEASE_APPROVERS",
  LeaseLegalOwnerName = "LEASE_LEGAL_OWNER_NAME",
  LeasePropertyLegalDescription = "LEASE_PROPERTY_LEGAL_DESCRIPTION",
  LeaseSignatory = "LEASE_SIGNATORY",
  Longitude = "LONGITUDE",
  Name = "NAME",
  NeedsTenantApproval = "NEEDS_TENANT_APPROVAL",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  OtherNotes = "OTHER_NOTES",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PpaBuildingOwnerNoiLifetimeUsd = "PPA_BUILDING_OWNER_NOI_LIFETIME_USD",
  PpaOfftakerLifetimeSavingsUsd = "PPA_OFFTAKER_LIFETIME_SAVINGS_USD",
  PpaPriceEscalator = "PPA_PRICE_ESCALATOR",
  PpaPriceY1Usd = "PPA_PRICE_Y1_USD",
  PpaRoofRentEscalator = "PPA_ROOF_RENT_ESCALATOR",
  PpaRoofRentY1Usd = "PPA_ROOF_RENT_Y1_USD",
  PpaYearOneOfftakerSavingsUsd = "PPA_YEAR_ONE_OFFTAKER_SAVINGS_USD",
  PpaYearOneRoofRentalFee = "PPA_YEAR_ONE_ROOF_RENTAL_FEE",
  PropertyFundName = "PROPERTY_FUND_NAME",
  PropertyInsurer = "PROPERTY_INSURER",
  PropertyLenders = "PROPERTY_LENDERS",
  PropertySiteVisitContacts = "PROPERTY_SITE_VISIT_CONTACTS",
  RecOwner = "REC_OWNER",
  RoofCondition = "ROOF_CONDITION",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofRightsHolder = "ROOF_RIGHTS_HOLDER",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SignatureBlocks = "SIGNATURE_BLOCKS",
  SiteLabels = "SITE_LABELS",
  SitePid = "SITE_PID",
  Sqft = "SQFT",
  State = "STATE",
  StreetAddress = "STREET_ADDRESS",
  TariffProvision = "TARIFF_PROVISION",
  TermYears = "TERM_YEARS",
  Type = "TYPE",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  YearBuilt = "YEAR_BUILT",
  ZipCode = "ZIP_CODE",
}

export type InvestorBidsTableFilter = {
  assetManager?: InputMaybe<StringPred>
  bidName?: InputMaybe<StringPred>
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingLegalName?: InputMaybe<StringPred>
  buildingOwnerExtraPaymentsUsd?: InputMaybe<FloatPred>
  buildingType?: InputMaybe<BuildingTypePred>
  bundleParentPid?: InputMaybe<StringPred>
  bundleRowPid?: InputMaybe<StringPred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  constructionEmail?: InputMaybe<StringPred>
  counselApproval?: InputMaybe<CounselApprovalPred>
  county?: InputMaybe<StringPred>
  csBuildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  csRoofRentEscalator?: InputMaybe<FloatPred>
  csRoofRentNpv?: InputMaybe<FloatPred>
  csRoofRentY1Usd?: InputMaybe<FloatPred>
  financierName?: InputMaybe<StringPred>
  financierPid?: InputMaybe<StringPred>
  financingType?: InputMaybe<FinProductTypePred>
  interconnectionCostNonUtilityUsd?: InputMaybe<FloatPred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  interconnectionCostUtilityMaxUsd?: InputMaybe<FloatPred>
  interconnectionCostUtilityMinUsd?: InputMaybe<FloatPred>
  isAwardedBid?: InputMaybe<BidAwardedPred>
  isFannieMaeLender?: InputMaybe<BoolPred>
  isFmGlobalInsurer?: InputMaybe<BoolPred>
  isRecommendedBid?: InputMaybe<BidAwardedPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  latitude?: InputMaybe<FloatPred>
  leaseLegalOwnerName?: InputMaybe<StringPred>
  leasePropertyLegalDescription?: InputMaybe<StringPred>
  leaseSignatory?: InputMaybe<StringPred>
  longitude?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  needsTenantApproval?: InputMaybe<BoolPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pid?: InputMaybe<StringPred>
  ppaBuildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  ppaOfftakerLifetimeSavingsUsd?: InputMaybe<FloatPred>
  ppaPriceEscalator?: InputMaybe<FloatPred>
  ppaPriceY1Usd?: InputMaybe<FloatPred>
  ppaRoofRentEscalator?: InputMaybe<FloatPred>
  ppaRoofRentY1Usd?: InputMaybe<FloatPred>
  ppaYearOneOfftakerSavingsUsd?: InputMaybe<FloatPred>
  ppaYearOneRoofRentalFee?: InputMaybe<FloatPred>
  propertyFundName?: InputMaybe<StringPred>
  propertyInsurer?: InputMaybe<StringPred>
  propertyLenders?: InputMaybe<StringPred>
  recOwner?: InputMaybe<RecOwnerPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofRightsHolder?: InputMaybe<RoofRightsHolderPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<FloatPred>
  salePlans?: InputMaybe<StringPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  sitePid?: InputMaybe<StringPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  streetAddress?: InputMaybe<StringPred>
  termYears?: InputMaybe<FloatPred>
  type?: InputMaybe<FinProductTypePred>
  usableRoofSqft?: InputMaybe<FloatPred>
  yearBuilt?: InputMaybe<IntPred>
}

export type InvestorBidsTableRow = {
  __typename?: "InvestorBidsTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidName?: Maybe<Scalars["String"]["output"]>
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  buildingType?: Maybe<BuildingType>
  bundleParentPid: Scalars["String"]["output"]
  bundleRowPid: Scalars["String"]["output"]
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  county: Scalars["String"]["output"]
  csBuildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  csRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  csRoofRentNpv?: Maybe<Scalars["Float"]["output"]>
  csRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  csSystem?: Maybe<SystemLite>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financierLogoUrl: Scalars["String"]["output"]
  financierLogomarkUrl?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  financingType: FinProductType
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionRepriceProcessNotes?: Maybe<Scalars["String"]["output"]>
  isAwardedBid?: Maybe<Scalars["Boolean"]["output"]>
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  isRecommendedBid?: Maybe<Scalars["Boolean"]["output"]>
  itcPercentageAssumption: Scalars["Float"]["output"]
  latitude: Scalars["Float"]["output"]
  leaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  longitude: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pid: Scalars["String"]["output"]
  ppaBuildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  ppaOfftakerLifetimeSavingsUsd?: Maybe<Scalars["Float"]["output"]>
  ppaPriceEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaPriceY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaRoofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  ppaSystem?: Maybe<System>
  ppaYearOneOfftakerSavingsUsd?: Maybe<Scalars["Float"]["output"]>
  ppaYearOneRoofRentalFee?: Maybe<Scalars["Float"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  recOwner: RecOwner
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
  siteLabels: Array<SiteLabel>
  sitePid: Scalars["String"]["output"]
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  tariffProvision?: Maybe<Scalars["Boolean"]["output"]>
  termYears: Scalars["Int"]["output"]
  type: FinProductType
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type InvestorBidsTableSort = {
  attr: InvestorBidsTableAttr
  order: SortOrder
}

export type InvestorBidsTableStats = {
  __typename?: "InvestorBidsTableStats"
  financiers: Array<Scalars["String"]["output"]>
  siteNames: Array<Scalars["String"]["output"]>
  siteStates: Array<Scalars["String"]["output"]>
  siteStreetAddresses: Array<Scalars["String"]["output"]>
}

export type InvestorBidsTableView = {
  __typename?: "InvestorBidsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["String"]["output"]>
  stats: InvestorBidsTableStats
}

export type InvestorDetails = {
  __typename?: "InvestorDetails"
  capex?: Maybe<Scalars["Float"]["output"]>
  investorXlsxHref: Scalars["String"]["output"]
  irrs: IrRs
}

export type InvestorOptOut = {
  __typename?: "InvestorOptOut"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  customReason?: Maybe<Scalars["String"]["output"]>
  reason?: Maybe<InvestorOptOutReason>
}

export enum InvestorOptOutReason {
  EconomicsInsufficient = "ECONOMICS_INSUFFICIENT",
  NotAPriority = "NOT_A_PRIORITY",
  Other = "OTHER",
  TooSmall = "TOO_SMALL",
  UnsupportedMarkets = "UNSUPPORTED_MARKETS",
}

export type InvestorProfile = {
  __typename?: "InvestorProfile"
  buyBoxes: Array<BuyBox>
  committedFunding?: Maybe<Scalars["String"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  description?: Maybe<Scalars["String"]["output"]>
  distinguishingFeatures?: Maybe<Scalars["String"]["output"]>
  experiences: Array<Experience>
  hq?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  investorBacking?: Maybe<Scalars["String"]["output"]>
  longTermOwnershipApproach?: Maybe<Scalars["String"]["output"]>
  managementTeam: Array<Scalars["String"]["output"]>
  subscriptionMgmtApproach?: Maybe<Scalars["String"]["output"]>
  website?: Maybe<Scalars["String"]["output"]>
  yearFounded?: Maybe<Scalars["Int"]["output"]>
}

export type InvestorProfileMutations = {
  __typename?: "InvestorProfileMutations"
  updateBuyBox?: Maybe<Scalars["Void"]["output"]>
  updateProfile?: Maybe<Scalars["Void"]["output"]>
}

export type InvestorProfileMutationsUpdateBuyBoxArgs = {
  buyBoxes: Array<BuyBoxInput>
}

export type InvestorProfileMutationsUpdateProfileArgs = {
  committedFunding?: InputMaybe<Scalars["String"]["input"]>
  description?: InputMaybe<Scalars["String"]["input"]>
  distinguishingFeatures?: InputMaybe<Scalars["String"]["input"]>
  experiences: Array<ExperienceInput>
  hq?: InputMaybe<Scalars["String"]["input"]>
  investorBacking?: InputMaybe<Scalars["String"]["input"]>
  longTermOwnershipApproach?: InputMaybe<Scalars["String"]["input"]>
  managementTeam: Array<Scalars["String"]["input"]>
  subscriptionMgmtApproach?: InputMaybe<Scalars["String"]["input"]>
  website?: InputMaybe<Scalars["String"]["input"]>
  yearFounded?: InputMaybe<Scalars["Int"]["input"]>
}

export type InviteToOrgInput = {
  email: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  orgSlug: Scalars["String"]["input"]
}

export type InviteToPortfolioInput = {
  email: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  orgSlug: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type IterBattery = {
  __typename?: "IterBattery"
  product: BatteryProduct
  strategy: DispatchStrategy
}

export type IterPv = {
  __typename?: "IterPV"
  productionKwh: Scalars["Float"]["output"]
  pvType: PvType
  sizeKw: Scalars["Float"]["output"]
}

export type Iteration = {
  __typename?: "Iteration"
  cashPurchaseNpv: Scalars["Float"]["output"]
  marginalCo2Averted?: Maybe<Scalars["Float"]["output"]>
  meters: Array<MeterIteration>
  metric: Scalars["Float"]["output"]
  postTaxItcDeprIrr?: Maybe<Scalars["Float"]["output"]>
  preTaxIrr?: Maybe<Scalars["Float"]["output"]>
}

export type Jurisdiction = {
  __typename?: "Jurisdiction"
  name: Scalars["String"]["output"]
  scope: JurisdictionScope
}

export enum JurisdictionScope {
  County = "COUNTY",
  Federal = "FEDERAL",
  Municipality = "MUNICIPALITY",
  Region = "REGION",
  State = "STATE",
  Utility = "UTILITY",
}

export type KwhFlow = {
  __typename?: "KwhFlow"
  batteryChargeKwh: Scalars["Float"]["output"]
  batteryDischargeKwh: Scalars["Float"]["output"]
  bauLoadKwh: Scalars["Float"]["output"]
  exportsKwh: Scalars["Float"]["output"]
  importsKwh: Scalars["Float"]["output"]
  pvProductionKwh: Scalars["Float"]["output"]
  pvToLoadKwh: Scalars["Float"]["output"]
}

export enum LabelColor {
  Accent_1 = "ACCENT_1",
  Accent_2 = "ACCENT_2",
  Accent_3 = "ACCENT_3",
  BrandPrimary = "BRAND_PRIMARY",
  BrandSecondary = "BRAND_SECONDARY",
  Error = "ERROR",
  Neutral = "NEUTRAL",
  Success = "SUCCESS",
}

export enum LeaseType {
  GrossLease = "GROSS_LEASE",
  NetLease = "NET_LEASE",
  NnnLease = "NNN_LEASE",
  NnLease = "NN_LEASE",
}

export type LeaseTypeInput = {
  value: LeaseType
}

export type LicenseAgreement = {
  __typename?: "LicenseAgreement"
  acceptedAt: Scalars["DateTime"]["output"]
  forOrg?: Maybe<Org>
  id: Scalars["Int"]["output"]
  remoteIp?: Maybe<Scalars["String"]["output"]>
  user: UserRef
  version: Scalars["Int"]["output"]
}

export enum LicenseAgreementType {
  SelectInvest = "SELECT_INVEST",
  SelectOffers = "SELECT_OFFERS",
}

export type LineItem = {
  __typename?: "LineItem"
  name: Scalars["String"]["output"]
  usd: Scalars["Float"]["output"]
}

export type LineItemCharge = {
  __typename?: "LineItemCharge"
  chargeType?: Maybe<ChargeType>
  costUsd: Scalars["Float"]["output"]
}

export type LineItem_ = {
  __typename?: "LineItem_"
  costUsd?: Maybe<Scalars["Float"]["output"]>
  id?: Maybe<Scalars["Int"]["output"]>
  label: Scalars["String"]["output"]
  rate?: Maybe<Scalars["Float"]["output"]>
  unit?: Maybe<Scalars["String"]["output"]>
  volume?: Maybe<Scalars["Float"]["output"]>
}

export enum LoadCategory {
  CommercialTenants = "COMMERCIAL_TENANTS",
  MfCombined = "MF_COMBINED",
  MfHouse = "MF_HOUSE",
  MfTenants = "MF_TENANTS",
}

export type LoadEstimateFailure = {
  __typename?: "LoadEstimateFailure"
  dateCreated: Scalars["DateTime"]["output"]
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  exception?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  site: SiteRef
}

export enum LoadOrigin {
  Merge = "MERGE",
  MeterIntervals = "METER_INTERVALS",
  ScaledAnnually = "SCALED_ANNUALLY",
  ScaledMonthly = "SCALED_MONTHLY",
  StockEstimate = "STOCK_ESTIMATE",
}

export type LoadOriginPred = {
  value: Array<InputMaybe<LoadOrigin>>
}

export type LoanEconomics = {
  __typename?: "LoanEconomics"
  flows?: Maybe<LoanRecvrCashflows>
  interestPct: Scalars["Float"]["output"]
  loanRecvrXlsxHref: Scalars["String"]["output"]
  loanTermYears: Scalars["Int"]["output"]
  ownershipTermYears: Scalars["Int"]["output"]
  product: LoanFinProduct
  srecToInvestor: Scalars["Boolean"]["output"]
}

export type LoanFinProduct = {
  __typename?: "LoanFinProduct"
  financierName: Scalars["String"]["output"]
  loanDealerFeePct: Scalars["Float"]["output"]
  loanInterestPct: Scalars["Float"]["output"]
  loanTermYears: Scalars["Int"]["output"]
  productName: Scalars["String"]["output"]
}

export type LoanFinProductInput = {
  constructionLoanInterestRate: Scalars["Float"]["input"]
  financierId: Scalars["Int"]["input"]
  investorDiscountRate: Scalars["Float"]["input"]
  loanDealerFeePct: Scalars["Float"]["input"]
  loanInterestPct: Scalars["Float"]["input"]
  loanSpecialPayment: Scalars["Boolean"]["input"]
  loanTermYears: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  status?: InputMaybe<FinProductStatus>
  targetOrgId?: InputMaybe<Scalars["Int"]["input"]>
  targetSiteId?: InputMaybe<Scalars["Int"]["input"]>
  targetSystemId?: InputMaybe<Scalars["Int"]["input"]>
}

export type LoanRecvrCashflows = {
  __typename?: "LoanRecvrCashflows"
  greenLeaseTenantFlows?: Maybe<TenantCashflows>
  monthlyPayment: Scalars["Float"]["output"]
  netCashflowPerYear: Array<Scalars["Float"]["output"]>
  totalCapex: Scalars["Float"]["output"]
  totalItc: Scalars["Float"]["output"]
  totalLoanFunding: Scalars["Float"]["output"]
  totalLoanPayments: Scalars["Float"]["output"]
  totalNet: Scalars["Float"]["output"]
  totalOpex: Scalars["Float"]["output"]
  totalRevenue: Scalars["Float"]["output"]
  totalUtilitySavings: Scalars["Float"]["output"]
}

export type LogPageViewInput = {
  pathname: Scalars["String"]["input"]
  referrer?: InputMaybe<Scalars["String"]["input"]>
  route: Scalars["String"]["input"]
  routeParams: Scalars["JSON"]["input"]
  title: Scalars["String"]["input"]
  url: Scalars["String"]["input"]
}

export type Lux = {
  __typename?: "Lux"
  battKw: Scalars["Float"]["output"]
  battKwh: Scalars["Float"]["output"]
  carportPvSixHighKw: Scalars["Float"]["output"]
  carportPvThreeHighKw: Scalars["Float"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  etbReport?: Maybe<EtbReport>
  finmodel?: Maybe<Finmodel>
  fmvNum: Scalars["Int"]["output"]
  fmvStr: Scalars["String"]["output"]
  goal: PVoptGoal
  id: Scalars["Int"]["output"]
  isMultimeter: Scalars["Boolean"]["output"]
  iterations: Array<Iteration>
  maxOffsetPct?: Maybe<Scalars["Float"]["output"]>
  meterSet: MeterSet
  meters: Array<LuxMeter>
  postLuxYear: Scalars["Int"]["output"]
  pvKw: Scalars["Float"]["output"]
  roofPvKw: Scalars["Float"]["output"]
  scenario: ScenarioRef
  site: SiteRef
}

export type LuxMeter = {
  __typename?: "LuxMeter"
  bauMeter: BauMeter
  bauTariff: TariffRate
  createdAt: Scalars["DateTime"]["output"]
  dayIntervals: DayIntervals
  gridMeter?: Maybe<GridMeter>
  id: Scalars["Int"]["output"]
  lux: Lux
  postBatteryMeter?: Maybe<PostBatteryMeter>
  postSolarMeter?: Maybe<PostSolarMeter>
}

export type LuxRef = {
  __typename?: "LuxRef"
  id: Scalars["Int"]["output"]
}

export type MfUnitBreakdownInput = {
  numUnits1Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits2Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits3Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits4Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnitsStudio?: InputMaybe<Scalars["Int"]["input"]>
}

export type MagicLink = {
  __typename?: "MagicLink"
  city: Scalars["String"]["output"]
  country: Scalars["String"]["output"]
  dateCreated: Scalars["DateTime"]["output"]
  expiresAt: Scalars["DateTime"]["output"]
  href: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  latitude?: Maybe<Scalars["Float"]["output"]>
  longitude?: Maybe<Scalars["Float"]["output"]>
  pid: Scalars["String"]["output"]
  region: Scalars["String"]["output"]
  remoteAddr: Scalars["String"]["output"]
  tz: Scalars["String"]["output"]
  user: UserRef
  userAgent: Scalars["String"]["output"]
}

export type MapSolarPanel = {
  __typename?: "MapSolarPanel"
  angle: Scalars["Float"]["output"]
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
}

export type MapView = {
  __typename?: "MapView"
  lat: Scalars["Float"]["output"]
  lon: Scalars["Float"]["output"]
  pid: Scalars["String"]["output"]
}

export type MarketplaceMutations = {
  __typename?: "MarketplaceMutations"
  updateBundleParentRow: BundleParentRowError
}

export type MarketplaceMutationsUpdateBundleParentRowArgs = {
  bundleParentRowId: Scalars["Int"]["input"]
  inputs: MarketplaceRowInputs
}

export type MarketplaceRowInputs = {
  hubspotRecordId?: InputMaybe<Scalars["String"]["input"]>
  lumenFeeUsdPerWatt?: InputMaybe<Scalars["Float"]["input"]>
  lumenRevenue?: InputMaybe<Scalars["Float"]["input"]>
  milestones?: InputMaybe<AllMilestonesInput>
  opsOwnerPid?: InputMaybe<Scalars["String"]["input"]>
  salesOwnerPid?: InputMaybe<Scalars["String"]["input"]>
}

export type MarketplaceSiteSearchTerm = {
  __typename?: "MarketplaceSiteSearchTerm"
  address: Scalars["String"]["output"]
  packagePid: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  propertyName?: Maybe<Scalars["String"]["output"]>
}

export enum MarketplaceStatus {
  CollectingBids = "COLLECTING_BIDS",
  NegotiatingContracts = "NEGOTIATING_CONTRACTS",
  PendingCod = "PENDING_COD",
  PendingNtp = "PENDING_NTP",
  ReviewingBids = "REVIEWING_BIDS",
  Shipped = "SHIPPED",
}

export type Message = {
  __typename?: "Message"
  content: Array<TextContentImageContentFileContent>
  functionCall?: Maybe<Scalars["String"]["output"]>
  role: Role
  toolCalls?: Maybe<Array<ToolCall>>
}

export type MeterCalc = {
  __typename?: "MeterCalc"
  costSummary: CostSummary
  createdAt: Scalars["DateTime"]["output"]
  exports: CleanIntervals
  id: Scalars["Int"]["output"]
  imports: CleanIntervals
  pvProduction: CleanIntervals
  tariffRate: TariffRate
}

export type MeterColumn = {
  columnNumber: Scalars["Int"]["input"]
  meterPid: Scalars["String"]["input"]
}

export type MeterIteration = {
  __typename?: "MeterIteration"
  battery?: Maybe<IterBattery>
  bauMeterId: Scalars["Int"]["output"]
  costSummary: SlimCostSummary
  marginalCo2Averted?: Maybe<Scalars["Float"]["output"]>
  pv: Array<IterPv>
  totalPvKw: Scalars["Float"]["output"]
}

export type MeterSet = {
  __typename?: "MeterSet"
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  id: Scalars["Int"]["output"]
  intervalsBauXlsxHref?: Maybe<Scalars["String"]["output"]>
  loadKwh?: Maybe<Scalars["Float"]["output"]>
  loadMaxKw?: Maybe<Scalars["Float"]["output"]>
  loadOrigin?: Maybe<LoadOrigin>
  meterSources: Array<MeterSource>
  meters: Array<BauMeter>
  pid: Scalars["String"]["output"]
  rollup: Array<DailyRollup>
  totalCost: Scalars["Float"]["output"]
}

export enum MeterSource {
  Bill = "BILL",
  Comstock = "COMSTOCK",
  Merge = "MERGE",
  Resstock = "RESSTOCK",
  Upload = "UPLOAD",
  UtilityApi = "UTILITY_API",
}

export type Meter_ = {
  __typename?: "Meter_"
  id?: Maybe<Scalars["Int"]["output"]>
  lineItems: Array<LineItem_>
  maxKw?: Maybe<Scalars["Float"]["output"]>
  meterId: Scalars["String"]["output"]
  peakKw?: Maybe<Scalars["Float"]["output"]>
  serviceAccount?: Maybe<Scalars["String"]["output"]>
  serviceAddress?: Maybe<Scalars["String"]["output"]>
  tariffLabel: Scalars["String"]["output"]
  tariffParentId?: Maybe<Scalars["Int"]["output"]>
  totalCostUsd?: Maybe<Scalars["Float"]["output"]>
  totalKwh?: Maybe<Scalars["Float"]["output"]>
}

export enum Metering {
  MasterMetered = "MASTER_METERED",
  SubMetered = "SUB_METERED",
  UtilityMetered = "UTILITY_METERED",
  UtilityMeteredCommonsRubs = "UTILITY_METERED_COMMONS_RUBS",
}

export type MeteringInput = {
  value: Metering
}

export type MeteringPred = {
  value: Array<InputMaybe<Metering>>
}

export type MfColumnMappings =
  | {
      individualUnitsColumnMappings: MfIndividualUnitColumnMappings
      numUnitsTotalColumnId?: never
    }
  | {
      individualUnitsColumnMappings?: never
      numUnitsTotalColumnId: Scalars["String"]["input"]
    }

export type MfIndividualUnitColumnMappings = {
  numUnits1BdColumnId?: InputMaybe<Scalars["String"]["input"]>
  numUnits2BdColumnId?: InputMaybe<Scalars["String"]["input"]>
  numUnits3BdColumnId?: InputMaybe<Scalars["String"]["input"]>
  numUnits4BdColumnId?: InputMaybe<Scalars["String"]["input"]>
  numUnitsStudioColumnId?: InputMaybe<Scalars["String"]["input"]>
}

export type MilestoneInput = {
  date: Scalars["Date"]["input"]
  status: MilestoneStatus
}

export enum MilestoneStatus {
  Complete = "COMPLETE",
  Estimated = "ESTIMATED",
}

export type MilestoneSummary = {
  __typename?: "MilestoneSummary"
  awardedToDeveloperActual?: Maybe<Scalars["Date"]["output"]>
  awardedToDeveloperEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingClosedActual?: Maybe<Scalars["Date"]["output"]>
  biddingClosedEstimated?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedActual?: Maybe<Scalars["Date"]["output"]>
  biddingOpenedEstimated?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedActual?: Maybe<Scalars["Date"]["output"]>
  bidsPresentedEstimated?: Maybe<Scalars["Date"]["output"]>
  codActual?: Maybe<Scalars["Date"]["output"]>
  codEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  csProgramSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixApprovedActual?: Maybe<Scalars["Date"]["output"]>
  ixApprovedEstimated?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedActual?: Maybe<Scalars["Date"]["output"]>
  ixSubmittedEstimated?: Maybe<Scalars["Date"]["output"]>
  leaseSignedActual?: Maybe<Scalars["Date"]["output"]>
  leaseSignedEstimated?: Maybe<Scalars["Date"]["output"]>
  ntpActual?: Maybe<Scalars["Date"]["output"]>
  ntpEstimated?: Maybe<Scalars["Date"]["output"]>
  rofoSignedActual?: Maybe<Scalars["Date"]["output"]>
  rofoSignedEstimated?: Maybe<Scalars["Date"]["output"]>
}

export enum MilestoneType {
  AwardedToDeveloper = "AWARDED_TO_DEVELOPER",
  BiddingClosed = "BIDDING_CLOSED",
  BiddingOpened = "BIDDING_OPENED",
  BidsPresented = "BIDS_PRESENTED",
  Cod = "COD",
  CsProgramApproved = "CS_PROGRAM_APPROVED",
  CsProgramSubmitted = "CS_PROGRAM_SUBMITTED",
  IxApproved = "IX_APPROVED",
  IxSubmitted = "IX_SUBMITTED",
  LeaseSigned = "LEASE_SIGNED",
  Ntp = "NTP",
  PreBidMeeting = "PRE_BID_MEETING",
  RofoSigned = "ROFO_SIGNED",
}

export type MonthlyBill2 = {
  __typename?: "MonthlyBill2"
  end: Scalars["Date"]["output"]
  sections: Array<BillGroup>
  start: Scalars["Date"]["output"]
}

export type MonthlyExtraction = {
  costColumn?: InputMaybe<Scalars["Int"]["input"]>
  documentPid: Scalars["String"]["input"]
  hasHeader: Scalars["Boolean"]["input"]
  kwColumn?: InputMaybe<Scalars["Int"]["input"]>
  kwhColumn: Scalars["Int"]["input"]
  meterPid: Scalars["String"]["input"]
  timestampColumn: Scalars["Int"]["input"]
}

export type MoreDetails = {
  __typename?: "MoreDetails"
  cashPurchaseNpv: Scalars["Float"]["output"]
  failureId?: Maybe<Scalars["Int"]["output"]>
  finmodelInputs: Scalars["JSON"]["output"]
  finmodelOutputs: Scalars["JSON"]["output"]
  lineage: Array<RevampFinmodel>
  luxId?: Maybe<Scalars["Int"]["output"]>
  pvCostPerWatt?: Maybe<Scalars["Float"]["output"]>
  storageCostPerKwh?: Maybe<Scalars["Float"]["output"]>
  totalInstallCost?: Maybe<Scalars["Float"]["output"]>
}

export type MultifamilyIndividualUnits = {
  numUnits1Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits2Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits3Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnits4Bd?: InputMaybe<Scalars["Int"]["input"]>
  numUnitsStudio?: InputMaybe<Scalars["Int"]["input"]>
}

export type MultifamilyUnitsInput =
  | { individualUnits: MultifamilyIndividualUnits; numUnitsTotal?: never }
  | { individualUnits?: never; numUnitsTotal: Scalars["Int"]["input"] }

export type Mutation = {
  __typename?: "Mutation"
  acceptLicenseAgreement?: Maybe<Error>
  addHelioscope: Helioscope2
  addLabelToCsvImport: CsvImportError
  admin: AdminMutation
  amendCsvImportRow: CsvImportRow
  applyLabelToSites?: Maybe<Error>
  archiveSite: RevampSiteError
  billingMeters: BillingMeterMutations
  buildingData: PublicBuildingDataMutations
  changeSiteLabelColor: ChangeSiteLabelColorResponse
  claimOpenInvite: AuthUserError
  createAndApplyLabelToCsvImport: CsvImportError
  createAndApplySiteLabel: CreateAndApplySiteLabelResponse
  createThirdPartySupplier: ThirdPartySupplier
  customTariffs: CustomTariffMutations
  deleteLabelAndRemoveFromCsvImport: CsvImportError
  deleteSiteLabel?: Maybe<Error>
  documents: DocumentMutations
  dropCsvImportRow: CsvImportRow
  evButton: EvButtonMutations
  evCalc: EvCalcMutations
  evOverrides: EvOverrideMutations
  finalizeEnergyPageUpload?: Maybe<Scalars["Void"]["output"]>
  finmodel: PublicFinmodelMutations
  inviteToOrg: Org
  inviteToPortfolio: PortfolioError
  logPageView?: Maybe<Error>
  newCsvImport: CsvImportError
  newEvCalc: EvCalc
  orgBySlug: OrgMutations
  recordUserEvent?: Maybe<Error>
  removeLabelFromCsvImport: CsvImportError
  removeLabelFromSites?: Maybe<Error>
  renameSiteLabel: RenameSiteLabelResponse
  requestBids?: Maybe<Scalars["Void"]["output"]>
  saveSiteShapes?: Maybe<Scalars["Void"]["output"]>
  setCsvImportRowBuildingData: CsvImportRow
  setCsvImportSchema: CsvImportError
  setIsBehindTheMeter?: Maybe<Scalars["Void"]["output"]>
  setMetering?: Maybe<Scalars["Void"]["output"]>
  setMyName?: Maybe<Error>
  setOrgSettings: OrgError
  setPackageRowStatus?: Maybe<Scalars["Void"]["output"]>
  setPropertyName: SetPropertyNameResponse
  setSiteShapes: RevampSite
  setTargetUtility?: Maybe<Scalars["Void"]["output"]>
  siteConfig: SiteConfigMutations
  siteDetails: SiteDetailsMutations
  tasks: PublicTaskMutations
  unsetCsvImportRowBuildingData: CsvImportRow
  updateCsvImportColumnMappings: CsvImportError
  updateDoeReferenceTypeMappings: CsvImportError
  updatePropertyData?: Maybe<Scalars["Void"]["output"]>
}

export type MutationAcceptLicenseAgreementArgs = {
  agreementType: LicenseAgreementType
  version: Scalars["Int"]["input"]
}

export type MutationAddHelioscopeArgs = {
  bundlePid?: InputMaybe<Scalars["String"]["input"]>
  carportPvSixHighKw?: InputMaybe<Scalars["Float"]["input"]>
  carportPvThreeHighKw?: InputMaybe<Scalars["Float"]["input"]>
  groundPvKw?: InputMaybe<Scalars["Float"]["input"]>
  productionCsv?: InputMaybe<Scalars["Upload"]["input"]>
  reportPdf: Scalars["Upload"]["input"]
  roofPvKw?: InputMaybe<Scalars["Float"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type MutationAddLabelToCsvImportArgs = {
  csvImportPid: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}

export type MutationAmendCsvImportRowArgs = {
  amendments: BuildingDataAmendmentsInput
  rowId: Scalars["Int"]["input"]
}

export type MutationApplyLabelToSitesArgs = {
  input: ApplyLabelToSitesInput
}

export type MutationArchiveSiteArgs = {
  reason: StatusReason
  sitePid: Scalars["String"]["input"]
}

export type MutationBillingMetersArgs = {
  sitePid: Scalars["String"]["input"]
}

export type MutationChangeSiteLabelColorArgs = {
  input: ChangeSiteLabelColorInput
}

export type MutationClaimOpenInviteArgs = {
  input: ClaimOpenInviteInput
}

export type MutationCreateAndApplyLabelToCsvImportArgs = {
  csvImportPid: Scalars["String"]["input"]
  labelColor?: LabelColor
  labelName: Scalars["String"]["input"]
}

export type MutationCreateAndApplySiteLabelArgs = {
  input: CreateAndApplySiteLabelInput
}

export type MutationCreateThirdPartySupplierArgs = {
  name: Scalars["String"]["input"]
}

export type MutationCustomTariffsArgs = {
  sitePid: Scalars["String"]["input"]
}

export type MutationDeleteLabelAndRemoveFromCsvImportArgs = {
  csvImportPid: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}

export type MutationDeleteSiteLabelArgs = {
  input: DeleteSiteLabelInput
}

export type MutationDropCsvImportRowArgs = {
  rowId: Scalars["Int"]["input"]
}

export type MutationEvButtonArgs = {
  sitePid: Scalars["String"]["input"]
}

export type MutationEvCalcArgs = {
  sitePid: Scalars["String"]["input"]
}

export type MutationEvOverridesArgs = {
  sitePid: Scalars["String"]["input"]
}

export type MutationFinalizeEnergyPageUploadArgs = {
  sitePid: Scalars["String"]["input"]
}

export type MutationInviteToOrgArgs = {
  input: InviteToOrgInput
}

export type MutationInviteToPortfolioArgs = {
  input: InviteToPortfolioInput
}

export type MutationLogPageViewArgs = {
  input: LogPageViewInput
}

export type MutationNewCsvImportArgs = {
  portfolioPid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type MutationNewEvCalcArgs = {
  markupUsdPerKwh: Scalars["Float"]["input"]
  numChargers: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type MutationOrgBySlugArgs = {
  slug: Scalars["String"]["input"]
}

export type MutationRecordUserEventArgs = {
  input: RecordUserEventInput
}

export type MutationRemoveLabelFromCsvImportArgs = {
  csvImportPid: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}

export type MutationRemoveLabelFromSitesArgs = {
  input: RemoveLabelFromSitesInput
}

export type MutationRenameSiteLabelArgs = {
  input: RenameSiteLabelInput
}

export type MutationRequestBidsArgs = {
  input: RequestBidsInput
}

export type MutationSaveSiteShapesArgs = {
  input: SaveSiteShapesInput
}

export type MutationSetCsvImportRowBuildingDataArgs = {
  buildingDataId: Scalars["Int"]["input"]
  rowId: Scalars["Int"]["input"]
}

export type MutationSetCsvImportSchemaArgs = {
  csvImportPid: Scalars["String"]["input"]
  schemaPid: Scalars["String"]["input"]
}

export type MutationSetIsBehindTheMeterArgs = {
  isBehindTheMeter?: InputMaybe<Scalars["Boolean"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type MutationSetMeteringArgs = {
  input: SetMeteringInput
}

export type MutationSetMyNameArgs = {
  name: Scalars["String"]["input"]
}

export type MutationSetOrgSettingsArgs = {
  irrFlavor: IrrType
  orgPid: Scalars["String"]["input"]
}

export type MutationSetPackageRowStatusArgs = {
  bundleParentPid: Scalars["String"]["input"]
  closeReason?: InputMaybe<PackageRowCloseReason>
  closed?: InputMaybe<Scalars["Boolean"]["input"]>
  customCloseReason?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
  status?: InputMaybe<PackageRowStatus>
}

export type MutationSetPropertyNameArgs = {
  propertyName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type MutationSetSiteShapesArgs = {
  input: SetSiteShapesInput
}

export type MutationSetTargetUtilityArgs = {
  input: SetTargetUtilityInput
}

export type MutationSiteDetailsArgs = {
  sitePid: Scalars["String"]["input"]
}

export type MutationUnsetCsvImportRowBuildingDataArgs = {
  rowId: Scalars["Int"]["input"]
}

export type MutationUpdateCsvImportColumnMappingsArgs = {
  columnMappings: ColumnMappingsInput
  pid: Scalars["String"]["input"]
}

export type MutationUpdateDoeReferenceTypeMappingsArgs = {
  csvImportPid: Scalars["String"]["input"]
  mappings: DoeReferenceTypeMappingsInput
}

export type MutationUpdatePropertyDataArgs = {
  input: UpdatePropertyDataInput
  sourceId?: InputMaybe<Scalars["String"]["input"]>
  sourceType?: InputMaybe<ChangeSourceType>
}

export type NameThatTariffDetail = {
  __typename?: "NameThatTariffDetail"
  groups: Array<BillGroup>
  result: NameThatTariffResult
  tariff: Tariff
}

export type NameThatTariffResult = {
  __typename?: "NameThatTariffResult"
  actual: BillMonth
  delta: TariffDeltas
  document: Document
  expected: BillMonth
  notTheCorrectRateVersion: Scalars["Boolean"]["output"]
  rate: TariffRate
}

export type NewSite = {
  __typename?: "NewSite"
  dateCreated: Scalars["DateTime"]["output"]
  pid: Scalars["String"]["output"]
}

export type NewUserResponse = AdminUser | Error

export type Note = {
  __typename?: "Note"
  createdAt: Scalars["DateTime"]["output"]
  createdBy: UserRef
  pid: Scalars["String"]["output"]
  text: Scalars["String"]["output"]
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedBy?: Maybe<UserRef>
}

export type NumberValue = {
  __typename?: "NumberValue"
  number: Scalars["Float"]["output"]
}

export enum OfferStatus {
  Estimated = "ESTIMATED",
  Final = "FINAL",
  PpaContract = "PPA_CONTRACT",
  TermSheet = "TERM_SHEET",
  Unavailable = "UNAVAILABLE",
  Verified = "VERIFIED",
}

export enum OpType {
  Add = "ADD",
  OverrideProperty = "OVERRIDE_PROPERTY",
  Sub = "SUB",
}

export type OpenInvite = {
  __typename?: "OpenInvite"
  isExpired: Scalars["Boolean"]["output"]
  orgSlug: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  portfolio: PortfolioAccess
}

export type OpenInviteError = Error | OpenInvite

export type OpsBillCalc = {
  __typename?: "OpsBillCalc"
  details: Array<BillGroup>
  end: Scalars["Date"]["output"]
  start: Scalars["Date"]["output"]
  summary: Array<ChargeTypeCost>
}

export type OptOutInput =
  | { bundlePid: Scalars["String"]["input"]; bundleRowId?: never }
  | { bundlePid?: never; bundleRowId: Scalars["Int"]["input"] }

export type Org = {
  __typename?: "Org"
  allLabels: Array<SiteLabel>
  awardedProjects: AwardedProjectTable
  bestCsSite?: Maybe<BestCommunitySolarSite>
  bid?: Maybe<InvestorBid>
  bidPackage?: Maybe<BidPackage>
  bidPackageBids: InvestorBidsTable
  bidPackageSites: BidPackageSitesTable
  bidPackageSpecs: BidSpecsTable
  bidPackages: Array<BidPackage>
  bundles: Array<Bundle2>
  csvImports: CsvImportQuery
  currentUserPermissions: Array<Permission>
  description?: Maybe<Scalars["String"]["output"]>
  financierProjects: FinancierProjectTable
  finproducts: Array<FinProductRef>
  inactivityTimeoutMs?: Maybe<Scalars["Int"]["output"]>
  investorProfile: InvestorProfile
  irrFlavor: IrrType
  isDeveloper: Scalars["Boolean"]["output"]
  /** @deprecated use is_developer */
  isFinancier: Scalars["Boolean"]["output"]
  logoUrl?: Maybe<Scalars["String"]["output"]>
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  mapView: Array<MapView>
  marketplaceSiteSearchTerms: Array<MarketplaceSiteSearchTerm>
  name: Scalars["String"]["output"]
  orgUsers: Array<OrgUser>
  pid: Scalars["String"]["output"]
  portfolioPdfReportHref?: Maybe<Scalars["String"]["output"]>
  portfolios: Array<PortfolioRef>
  /** @deprecated use is_developer */
  revampIsFinancier: Scalars["Boolean"]["output"]
  shine: ShineOrg
  site?: Maybe<RevampSite>
  siteBids: SiteBidsTable
  siteFromPortfolioBuildingData?: Maybe<SiteRef>
  siteSearchTerms: Array<SiteSearchTerm>
  sites: OrgSiteTable
  slug: Scalars["String"]["output"]
  unclaimedInvites: Array<AdminInvitation>
  userRoles: Array<UserRole>
  users: Array<UserRef>
}

export type OrgBidArgs = {
  pid: Scalars["String"]["input"]
}

export type OrgBidPackageArgs = {
  pid: Scalars["String"]["input"]
}

export type OrgSiteArgs = {
  pid: Scalars["String"]["input"]
}

export type OrgSiteBidsArgs = {
  sitePid: Scalars["String"]["input"]
}

export type OrgSiteFromPortfolioBuildingDataArgs = {
  buildingDataId: Scalars["Int"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type OrgError = Error | Org

export type OrgMutations = {
  __typename?: "OrgMutations"
  awardInvestorBid?: Maybe<Scalars["Void"]["output"]>
  bundle: BundleMutation
  createPortfolio?: Maybe<Error>
  financierBundle: PublicBundleMutations
  flags: SiteFlagMutations
  investorProfile: InvestorProfileMutations
  recommendInvestorBid?: Maybe<Scalars["Void"]["output"]>
  roles: UserRoleMutations
  setIsFavorite?: Maybe<Error>
  setStatus?: Maybe<Error>
}

export type OrgMutationsAwardInvestorBidArgs = {
  bidPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}

export type OrgMutationsCreatePortfolioArgs = {
  name: Scalars["String"]["input"]
}

export type OrgMutationsFinancierBundleArgs = {
  bundlePid: Scalars["String"]["input"]
}

export type OrgMutationsRecommendInvestorBidArgs = {
  bidPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}

export type OrgMutationsSetIsFavoriteArgs = {
  isFavorite: Scalars["Boolean"]["input"]
  sitePids: Array<Scalars["String"]["input"]>
}

export type OrgMutationsSetStatusArgs = {
  customReason?: InputMaybe<Scalars["String"]["input"]>
  reason?: InputMaybe<StatusReason>
  sitePids: Array<Scalars["String"]["input"]>
  status: SiteStatus
}

export type OrgRef = {
  __typename?: "OrgRef"
  logoUrl: Scalars["String"]["output"]
  logomarkUrl?: Maybe<Scalars["String"]["output"]>
  name: Scalars["String"]["output"]
  orgSlug: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  profile?: Maybe<InvestorProfile>
}

export type OrgSiteTable = {
  __typename?: "OrgSiteTable"
  rows: Array<OrgSiteTableRow>
  view: OrgSiteTableView
}

export type OrgSiteTableRowsArgs = {
  keys: Array<Scalars["String"]["input"]>
}

export type OrgSiteTableViewArgs = {
  filterBy?: InputMaybe<OrgSiteTableFilter>
  sortBy?: InputMaybe<Array<OrgSiteTableSort>>
}

export enum OrgSiteTableAttr {
  AssetManager = "ASSET_MANAGER",
  BauCo2EmissionsTons = "BAU_CO2_EMISSIONS_TONS",
  BauCo2EmissionsTonsPerMwh = "BAU_CO2_EMISSIONS_TONS_PER_MWH",
  BuildingClass = "BUILDING_CLASS",
  BuildingFootprintCount = "BUILDING_FOOTPRINT_COUNT",
  BuildingFootprintRoofSqftError = "BUILDING_FOOTPRINT_ROOF_SQFT_ERROR",
  BuildingFootprintSqft = "BUILDING_FOOTPRINT_SQFT",
  BuildingSqftRoofSqftError = "BUILDING_SQFT_ROOF_SQFT_ERROR",
  BuildingType = "BUILDING_TYPE",
  CarportMaxPvKw = "CARPORT_MAX_PV_KW",
  CbsaName = "CBSA_NAME",
  City = "CITY",
  Co2EmissionsReductionTonnesPpaMax = "CO2_EMISSIONS_REDUCTION_TONNES_PPA_MAX",
  Co2EmissionsReductionTonnesSelfMax = "CO2_EMISSIONS_REDUCTION_TONNES_SELF_MAX",
  CostPerKwhPpaMax = "COST_PER_KWH_PPA_MAX",
  County = "COUNTY",
  CustomerId = "CUSTOMER_ID",
  ExistingSolarDetectionScore = "EXISTING_SOLAR_DETECTION_SCORE",
  GpvLoanMax = "GPV_LOAN_MAX",
  GpvPpaMax = "GPV_PPA_MAX",
  GpvSelfMax = "GPV_SELF_MAX",
  GroundMaxPvKw = "GROUND_MAX_PV_KW",
  IncludeStoragePpaMax = "INCLUDE_STORAGE_PPA_MAX",
  IncludeStorageSelfMax = "INCLUDE_STORAGE_SELF_MAX",
  InEnergyCommunity = "IN_ENERGY_COMMUNITY",
  InLowIncomeCommunity = "IN_LOW_INCOME_COMMUNITY",
  IrrSelfMax = "IRR_SELF_MAX",
  IsBidding = "IS_BIDDING",
  IsFavorite = "IS_FAVORITE",
  Latitude = "LATITUDE",
  LeaseType = "LEASE_TYPE",
  LeDevFeeLoanMax = "LE_DEV_FEE_LOAN_MAX",
  LeDevFeePpaMax = "LE_DEV_FEE_PPA_MAX",
  LeDevFeeSelfMax = "LE_DEV_FEE_SELF_MAX",
  LifetimeCapexSelfMax = "LIFETIME_CAPEX_SELF_MAX",
  LifetimeUtilitySavingsPpaMax = "LIFETIME_UTILITY_SAVINGS_PPA_MAX",
  LifetimeUtilitySavingsSelfMax = "LIFETIME_UTILITY_SAVINGS_SELF_MAX",
  LoadKwh = "LOAD_KWH",
  LoadOrigin = "LOAD_ORIGIN",
  LoadUsd = "LOAD_USD",
  LoadUsdPerKwh = "LOAD_USD_PER_KWH",
  Longitude = "LONGITUDE",
  MarketplaceClosedAt = "MARKETPLACE_CLOSED_AT",
  MarketplaceCloseCustomReason = "MARKETPLACE_CLOSE_CUSTOM_REASON",
  MarketplaceCloseReason = "MARKETPLACE_CLOSE_REASON",
  MarketplaceStatus = "MARKETPLACE_STATUS",
  Metering = "METERING",
  MeterCount = "METER_COUNT",
  MortgageLender = "MORTGAGE_LENDER",
  Name = "NAME",
  NoiCsMax = "NOI_CS_MAX",
  NoiLeaseMax = "NOI_LEASE_MAX",
  NoiLoanMax = "NOI_LOAN_MAX",
  NoiPpaMax = "NOI_PPA_MAX",
  NoiRangeMax = "NOI_RANGE_MAX",
  NoiRangeMin = "NOI_RANGE_MIN",
  NoiSelfMax = "NOI_SELF_MAX",
  NumStories = "NUM_STORIES",
  NumUnitsTotal = "NUM_UNITS_TOTAL",
  OccupancyType = "OCCUPANCY_TYPE",
  OwnerName = "OWNER_NAME",
  Portfolio = "PORTFOLIO",
  PpaEscPpaMax = "PPA_ESC_PPA_MAX",
  PpaOfftaker = "PPA_OFFTAKER",
  PpaSignatory = "PPA_SIGNATORY",
  PvSizeKwCsMax = "PV_SIZE_KW_CS_MAX",
  PvSizeKwPpaMax = "PV_SIZE_KW_PPA_MAX",
  PvSizeKwSelfMax = "PV_SIZE_KW_SELF_MAX",
  RoofCondition = "ROOF_CONDITION",
  RoofMaxPvKw = "ROOF_MAX_PV_KW",
  RoofReplacedYr = "ROOF_REPLACED_YR",
  RoofSqft = "ROOF_SQFT",
  SalePlannedYear = "SALE_PLANNED_YEAR",
  SalePlans = "SALE_PLANS",
  SiteLabels = "SITE_LABELS",
  SolarLocationPpaMax = "SOLAR_LOCATION_PPA_MAX",
  SolarLocationSelfMax = "SOLAR_LOCATION_SELF_MAX",
  SoleTariffName = "SOLE_TARIFF_NAME",
  Sqft = "SQFT",
  State = "STATE",
  Status = "STATUS",
  StatusCustomReason = "STATUS_CUSTOM_REASON",
  StatusReason = "STATUS_REASON",
  StorageSizeKwhPpaMax = "STORAGE_SIZE_KWH_PPA_MAX",
  StorageSizeKwhSelfMax = "STORAGE_SIZE_KWH_SELF_MAX",
  StorageSizeKwPpaMax = "STORAGE_SIZE_KW_PPA_MAX",
  StorageSizeKwSelfMax = "STORAGE_SIZE_KW_SELF_MAX",
  StreetAddress = "STREET_ADDRESS",
  TenantInterest = "TENANT_INTEREST",
  TenantLeaseEnds = "TENANT_LEASE_ENDS",
  TenantLeaseTerm = "TENANT_LEASE_TERM",
  UsableRoofSqft = "USABLE_ROOF_SQFT",
  UtilityCagr = "UTILITY_CAGR",
  UtilityName = "UTILITY_NAME",
  UtilityShortName = "UTILITY_SHORT_NAME",
  YearBuilt = "YEAR_BUILT",
  YearOneOfftakerSavingsPpaMax = "YEAR_ONE_OFFTAKER_SAVINGS_PPA_MAX",
  ZipCode = "ZIP_CODE",
}

export type OrgSiteTableFilter = {
  assetManager?: InputMaybe<StringPred>
  bauCo2EmissionsTons?: InputMaybe<FloatPred>
  bauCo2EmissionsTonsPerMwh?: InputMaybe<FloatPred>
  buildingClass?: InputMaybe<StringPred>
  buildingFootprintCount?: InputMaybe<IntPred>
  buildingFootprintRoofSqftError?: InputMaybe<FloatPred>
  buildingFootprintSqft?: InputMaybe<FloatPred>
  buildingSqftRoofSqftError?: InputMaybe<FloatPred>
  buildingType?: InputMaybe<BuildingTypePred>
  carportMaxPvKw?: InputMaybe<FloatPred>
  cbsaName?: InputMaybe<StringPred>
  city?: InputMaybe<StringPred>
  co2EmissionsReductionTonnesPpaMax?: InputMaybe<FloatPred>
  co2EmissionsReductionTonnesSelfMax?: InputMaybe<FloatPred>
  costPerKwhPpaMax?: InputMaybe<FloatPred>
  county?: InputMaybe<StringPred>
  energyThings?: InputMaybe<EnergyThingsPred>
  existingSolarDetectionScore?: InputMaybe<IntPred>
  financingThings?: InputMaybe<FinancingThingsPred>
  flagSummary?: InputMaybe<SiteFlagSummaryPred>
  gpvLoanMax?: InputMaybe<FloatPred>
  gpvPpaMax?: InputMaybe<FloatPred>
  gpvSelfMax?: InputMaybe<FloatPred>
  groundMaxPvKw?: InputMaybe<FloatPred>
  inEnergyCommunity?: InputMaybe<BoolPred>
  inLowIncomeCommunity?: InputMaybe<BoolPred>
  includeStoragePpaMax?: InputMaybe<BoolPred>
  includeStorageSelfMax?: InputMaybe<BoolPred>
  irrSelfMax?: InputMaybe<FloatPred>
  isBidding?: InputMaybe<BoolPred>
  isFavorite?: InputMaybe<BoolPred>
  latitude?: InputMaybe<FloatPred>
  leDevFeeLoanMax?: InputMaybe<FloatPred>
  leDevFeePpaMax?: InputMaybe<FloatPred>
  leDevFeeSelfMax?: InputMaybe<FloatPred>
  lifetimeCapexSelfMax?: InputMaybe<FloatPred>
  lifetimeUtilitySavingsPpaMax?: InputMaybe<FloatPred>
  lifetimeUtilitySavingsSelfMax?: InputMaybe<FloatPred>
  loadKwh?: InputMaybe<FloatPred>
  loadOrigin?: InputMaybe<LoadOriginPred>
  loadUsd?: InputMaybe<FloatPred>
  loadUsdPerKwh?: InputMaybe<FloatPred>
  longitude?: InputMaybe<FloatPred>
  marketplaceStatus?: InputMaybe<PackageRowStatusPred>
  meterCount?: InputMaybe<FloatPred>
  metering?: InputMaybe<MeteringPred>
  noiCsMax?: InputMaybe<FloatPred>
  noiLeaseMax?: InputMaybe<FloatPred>
  noiLoanMax?: InputMaybe<FloatPred>
  noiPpaMax?: InputMaybe<FloatPred>
  noiSelfMax?: InputMaybe<FloatPred>
  numStories?: InputMaybe<IntPred>
  numUnitsTotal?: InputMaybe<IntPred>
  ownerName?: InputMaybe<StringPred>
  pid?: InputMaybe<StringPred>
  portfolio?: InputMaybe<StringPred>
  ppaEscPpaMax?: InputMaybe<FloatPred>
  pvSizeKwCsMax?: InputMaybe<FloatPred>
  pvSizeKwPpaMax?: InputMaybe<FloatPred>
  pvSizeKwSelfMax?: InputMaybe<FloatPred>
  roofMaxPvKw?: InputMaybe<FloatPred>
  roofReplacedYr?: InputMaybe<FloatPred>
  roofSqft?: InputMaybe<FloatPred>
  salePlannedYear?: InputMaybe<IntPred>
  salePlans?: InputMaybe<YesNoUnsurePred>
  search?: InputMaybe<SearchPred>
  siteLabels?: InputMaybe<SiteLabelNamesPred>
  solarLocationPpaMax?: InputMaybe<SolarLocationPred>
  solarLocationSelfMax?: InputMaybe<SolarLocationPred>
  sqft?: InputMaybe<FloatPred>
  state?: InputMaybe<UsStateMultiPred>
  status?: InputMaybe<SiteStatusPred>
  statusReason?: InputMaybe<StringPred>
  storageSizeKwPpaMax?: InputMaybe<FloatPred>
  storageSizeKwSelfMax?: InputMaybe<FloatPred>
  storageSizeKwhPpaMax?: InputMaybe<FloatPred>
  storageSizeKwhSelfMax?: InputMaybe<FloatPred>
  tenantInterest?: InputMaybe<YesNoUnsurePred>
  usableRoofSqft?: InputMaybe<FloatPred>
  utilityCagr?: InputMaybe<FloatPred>
  utilityName?: InputMaybe<StringPred>
  yearBuilt?: InputMaybe<IntPred>
  yearOneOfftakerSavingsPpaMax?: InputMaybe<FloatPred>
}

export type OrgSiteTableRow = {
  __typename?: "OrgSiteTableRow"
  assetManager?: Maybe<Scalars["String"]["output"]>
  bauCo2EmissionsTons?: Maybe<Scalars["Float"]["output"]>
  bauCo2EmissionsTonsPerMwh?: Maybe<Scalars["Float"]["output"]>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintRoofSqftError?: Maybe<Scalars["Float"]["output"]>
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingSqftRoofSqftError?: Maybe<Scalars["Float"]["output"]>
  buildingType?: Maybe<BuildingType>
  carportMaxPvKw: Scalars["Float"]["output"]
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  co2EmissionsReductionTonnesPpaMax?: Maybe<Scalars["Float"]["output"]>
  co2EmissionsReductionTonnesSelfMax?: Maybe<Scalars["Float"]["output"]>
  costPerKwhPpaMax?: Maybe<Scalars["Float"]["output"]>
  county: Scalars["String"]["output"]
  customerId?: Maybe<Scalars["String"]["output"]>
  energyThings?: Maybe<EnergyThings>
  existingSolarDetectionScore?: Maybe<Scalars["Int"]["output"]>
  financingThings?: Maybe<FinancingThings>
  flagSummary?: Maybe<SiteFlagSummary>
  footprint?: Maybe<Footprint>
  gpvLoanMax?: Maybe<Scalars["Float"]["output"]>
  gpvPpaMax?: Maybe<Scalars["Float"]["output"]>
  gpvSelfMax?: Maybe<Scalars["Float"]["output"]>
  groundMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  inEnergyCommunity: Scalars["Boolean"]["output"]
  inLowIncomeCommunity: Scalars["Boolean"]["output"]
  includeStoragePpaMax?: Maybe<Scalars["Boolean"]["output"]>
  includeStorageSelfMax?: Maybe<Scalars["Boolean"]["output"]>
  irrSelfMax?: Maybe<Scalars["Float"]["output"]>
  isBidding: Scalars["Boolean"]["output"]
  isFavorite: Scalars["Boolean"]["output"]
  latitude: Scalars["Float"]["output"]
  leDevFeeLoanMax?: Maybe<Scalars["Float"]["output"]>
  leDevFeePpaMax?: Maybe<Scalars["Float"]["output"]>
  leDevFeeSelfMax?: Maybe<Scalars["Float"]["output"]>
  leaseType?: Maybe<LeaseType>
  lifetimeCapexSelfMax?: Maybe<Scalars["Float"]["output"]>
  lifetimeUtilitySavingsPpaMax?: Maybe<Scalars["Float"]["output"]>
  lifetimeUtilitySavingsSelfMax?: Maybe<Scalars["Float"]["output"]>
  loadKwh?: Maybe<Scalars["Float"]["output"]>
  loadOrigin?: Maybe<LoadOrigin>
  loadUsd?: Maybe<Scalars["Float"]["output"]>
  loadUsdPerKwh?: Maybe<Scalars["Float"]["output"]>
  longitude: Scalars["Float"]["output"]
  marketplaceCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  marketplaceCloseReason?: Maybe<PackageRowCloseReason>
  marketplaceClosedAt?: Maybe<Scalars["String"]["output"]>
  marketplaceStatus?: Maybe<PackageRowStatus>
  meterCount: Scalars["Int"]["output"]
  metering?: Maybe<Metering>
  mortgageLender?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  noiCsMax?: Maybe<Scalars["Float"]["output"]>
  noiLeaseMax?: Maybe<Scalars["Float"]["output"]>
  noiLoanMax?: Maybe<Scalars["Float"]["output"]>
  noiPpaMax?: Maybe<Scalars["Float"]["output"]>
  noiRangeMax?: Maybe<Scalars["Float"]["output"]>
  noiRangeMin?: Maybe<Scalars["Float"]["output"]>
  noiSelfMax?: Maybe<Scalars["Float"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  occupancyType?: Maybe<BuildingOccupancyType>
  ownerName?: Maybe<Scalars["String"]["output"]>
  physicalCheck?: Maybe<PhysicalCheck>
  pid: Scalars["String"]["output"]
  portfolio: Scalars["String"]["output"]
  ppaEscPpaMax?: Maybe<Scalars["Float"]["output"]>
  ppaOfftaker?: Maybe<PpaOfftaker>
  ppaSignatory?: Maybe<Scalars["String"]["output"]>
  pvSizeKwCsMax?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwPpaMax?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwSelfMax?: Maybe<Scalars["Float"]["output"]>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofMaxPvKw: Scalars["Float"]["output"]
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  siteLabels: Array<SiteLabel>
  solarLocationPpaMax?: Maybe<SolarLocation>
  solarLocationSelfMax?: Maybe<SolarLocation>
  soleTariffCode?: Maybe<Scalars["String"]["output"]>
  soleTariffName?: Maybe<Scalars["String"]["output"]>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  status: SiteStatus
  statusCustomReason?: Maybe<Scalars["String"]["output"]>
  statusReason?: Maybe<StatusReason>
  storageSizeKwPpaMax?: Maybe<Scalars["Float"]["output"]>
  storageSizeKwSelfMax?: Maybe<Scalars["Float"]["output"]>
  storageSizeKwhPpaMax?: Maybe<Scalars["Float"]["output"]>
  storageSizeKwhSelfMax?: Maybe<Scalars["Float"]["output"]>
  streetAddress: Scalars["String"]["output"]
  tenantInterest?: Maybe<YesNoUnsure>
  tenantLeaseEnds?: Maybe<Scalars["DateTime"]["output"]>
  tenantLeaseTerm?: Maybe<Scalars["String"]["output"]>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  utilityCagr?: Maybe<Scalars["Float"]["output"]>
  utilityCagrFromYear?: Maybe<Scalars["Int"]["output"]>
  utilityCagrToYear?: Maybe<Scalars["Int"]["output"]>
  utilityName?: Maybe<Scalars["String"]["output"]>
  utilityShortName?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  yearOneOfftakerSavingsPpaMax?: Maybe<Scalars["Float"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type OrgSiteTableSort = {
  attr: OrgSiteTableAttr
  order: SortOrder
}

export type OrgSiteTableStats = {
  __typename?: "OrgSiteTableStats"
  annualNoi: Scalars["Float"]["output"]
  assetManagers: Array<Scalars["String"]["output"]>
  buildingClasses: Array<Scalars["String"]["output"]>
  buildingTypes: Array<BuildingType>
  cashAnnualNoi: Scalars["Float"]["output"]
  cashCo2EmissionsReductionTonnes: Scalars["Float"]["output"]
  cashMaxPvSizeKw: Scalars["Float"]["output"]
  cbsaNames: Array<Scalars["String"]["output"]>
  co2EmissionsReductionTonnes: Scalars["Float"]["output"]
  counties: Array<Scalars["String"]["output"]>
  coveredStates: Array<Scalars["String"]["output"]>
  csAnnualNoi: Scalars["Float"]["output"]
  csMaxPvSizeKw: Scalars["Float"]["output"]
  maxPvSizeKw: Scalars["Float"]["output"]
  ownerNames: Array<Scalars["String"]["output"]>
  portfolios: Array<Scalars["String"]["output"]>
  ppaAnnualNoi: Scalars["Float"]["output"]
  ppaCo2EmissionsReductionTonnes: Scalars["Float"]["output"]
  ppaMaxPvSizeKw: Scalars["Float"]["output"]
  utilityNames: Array<Scalars["String"]["output"]>
}

export type OrgSiteTableView = {
  __typename?: "OrgSiteTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["String"]["output"]>
  stats: OrgSiteTableStats
}

export type OrgUser = {
  __typename?: "OrgUser"
  user: UserRef
  userRoles: Array<UserRole>
}

export type Overridable = {
  __typename?: "Overridable"
  name: Scalars["String"]["output"]
  type: InputType
}

export type OverrideProperty = {
  __typename?: "OverrideProperty"
  keyName: Scalars["String"]["output"]
  op: OpType
  propertyValue: Scalars["String"]["output"]
}

export type OverridePropertyInput = {
  keyName: Scalars["String"]["input"]
  propertyValue: Scalars["String"]["input"]
}

export type PpaBidSpec = {
  __typename?: "PPABidSpec"
  archivedAt?: Maybe<Scalars["DateTime"]["output"]>
  archivedBy?: Maybe<UserRef>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  itcPercentageAssumption?: Maybe<Scalars["Float"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  note?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  ppaPriceEscalator?: Maybe<Scalars["Float"]["output"]>
  ppaPriceY1Usd?: Maybe<Scalars["Float"]["output"]>
  recOwner?: Maybe<RecOwner>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  site: SiteRef
  system?: Maybe<System>
  termYears?: Maybe<Scalars["Int"]["output"]>
  type: FinProductType
}

export type PpaBidSpecInput = {
  buildingOwnerExtraPaymentsUsd?: InputMaybe<Array<Scalars["Float"]["input"]>>
  interconnectionCostNonUtilityUsd?: InputMaybe<Scalars["Float"]["input"]>
  interconnectionCostUtilityMaxUsd?: InputMaybe<Scalars["Float"]["input"]>
  itcPercentageAssumption?: InputMaybe<Scalars["Float"]["input"]>
  name?: InputMaybe<Scalars["String"]["input"]>
  note?: InputMaybe<Scalars["String"]["input"]>
  ppaPriceEscalator?: InputMaybe<Scalars["Float"]["input"]>
  ppaPriceY1Usd?: InputMaybe<Scalars["Float"]["input"]>
  recOwner?: InputMaybe<RecOwner>
  roofRentEscalator?: InputMaybe<Scalars["Float"]["input"]>
  roofRentY1Usd?: InputMaybe<Scalars["Float"]["input"]>
  systemPid?: InputMaybe<Scalars["String"]["input"]>
  termYears?: InputMaybe<Scalars["Int"]["input"]>
}

export type PpaEconomics = {
  __typename?: "PPAEconomics"
  offtakerXlsxHref: Scalars["String"]["output"]
  ppaCostPerKwh: Scalars["Float"]["output"]
  ppaEsc?: Maybe<Scalars["Float"]["output"]>
  ppaTermYears: Scalars["Int"]["output"]
  ppaType: PpaProductType
  product: PpaFinProduct
  roofRent?: Maybe<RoofRentEconomics>
  srecToInvestor: Scalars["Boolean"]["output"]
  tenantFlows?: Maybe<TenantCashflows>
}

export type PpaFinProduct = {
  __typename?: "PPAFinProduct"
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  ppaEscalator: Scalars["Float"]["output"]
  productName: Scalars["String"]["output"]
  srecToInvestor: Scalars["Boolean"]["output"]
}

export type PpaFinProductInput = {
  financierId: Scalars["Int"]["input"]
  name: Scalars["String"]["input"]
  ppaEsc: Scalars["Float"]["input"]
  ppaTermTwoYearsTenantPpaWithSiteLease: Scalars["Float"]["input"]
  ppaTermYearsOwnerPpa: Scalars["Float"]["input"]
  ppaTermYearsTenantPpaWithSiteLease: Scalars["Float"]["input"]
  srecToInvestor: Scalars["Boolean"]["input"]
  status?: InputMaybe<FinProductStatus>
  targetIrrOwnerPpa: Scalars["Float"]["input"]
  targetIrrTenantPpaWithSiteLease: Scalars["Float"]["input"]
  targetOrgId?: InputMaybe<Scalars["Int"]["input"]>
  targetSiteId?: InputMaybe<Scalars["Int"]["input"]>
  targetSystemId?: InputMaybe<Scalars["Int"]["input"]>
}

export type PpaInvestorBid = {
  __typename?: "PPAInvestorBid"
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  errorClass?: Maybe<Scalars["String"]["output"]>
  errorMessage?: Maybe<Scalars["String"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  financier: OrgRef
  finproduct: AdminFinProduct
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionRepriceProcessNotes?: Maybe<Scalars["String"]["output"]>
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  ppaPriceEscalator: Scalars["Float"]["output"]
  ppaPriceY1Usd: Scalars["Float"]["output"]
  recOwner: RecOwner
  result?: Maybe<RevampFinmodel>
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  site: RevampSite
  spec?: Maybe<PpaBidSpec>
  status?: Maybe<InvestorBidStatus>
  system: System
  tariffProvision?: Maybe<Scalars["Boolean"]["output"]>
  termYears: Scalars["Int"]["output"]
}

export type PpaInvestorBidInput = {
  bundleRowId: Scalars["Int"]["input"]
  estimatedCod: Scalars["Date"]["input"]
  estimatedNtp: Scalars["Date"]["input"]
  extraPaymentsNotes?: InputMaybe<Scalars["String"]["input"]>
  extraPaymentsUsd: Array<Scalars["Float"]["input"]>
  incentivesNotes?: InputMaybe<Scalars["String"]["input"]>
  interconnectionCostNonUtilityUsd: Scalars["Float"]["input"]
  interconnectionCostUtilityMaxUsd: Scalars["Float"]["input"]
  interconnectionNotes?: InputMaybe<Scalars["String"]["input"]>
  interconnectionRepriceProcessNotes?: InputMaybe<Scalars["String"]["input"]>
  itcPercentageAssumption: Scalars["Float"]["input"]
  name: Scalars["String"]["input"]
  otherNotes?: InputMaybe<Scalars["String"]["input"]>
  ppaPriceEscalator: Scalars["Float"]["input"]
  ppaPriceY1Usd: Scalars["Float"]["input"]
  recOwner: RecOwner
  roofRentEscalator: Scalars["Float"]["input"]
  roofRentY1Usd: Scalars["Float"]["input"]
  sitePid: Scalars["String"]["input"]
  specPid?: InputMaybe<Scalars["String"]["input"]>
  systemPid: Scalars["String"]["input"]
  tariffProvision: Scalars["Boolean"]["input"]
  termYears: Scalars["Int"]["input"]
}

export enum PpaOfftaker {
  PropertyOwner = "PROPERTY_OWNER",
  Tenant = "TENANT",
}

export type PpaOfftakerInput = {
  value: PpaOfftaker
}

export enum PpaProductType {
  OwnerPpa = "OWNER_PPA",
  TenantPpaWithSiteLease = "TENANT_PPA_WITH_SITE_LEASE",
}

export type PpaSiteBidReport = {
  __typename?: "PPASiteBidReport"
  awarded: Scalars["Boolean"]["output"]
  awardedPid?: Maybe<Scalars["String"]["output"]>
  bids: Array<PpaInvestorBid>
  itcPercentageAssumption?: Maybe<BoxplotStats>
  noi?: Maybe<BoxplotStats>
  npv?: Maybe<BoxplotStats>
  ppaPriceEscalator?: Maybe<BoxplotStats>
  site: RevampSite
  systemSize?: Maybe<BoxplotStats>
  totalBids: Scalars["Int"]["output"]
  y1RoofRent?: Maybe<BoxplotStats>
}

export type PvAllocation = {
  __typename?: "PVAllocation"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  meter: BillingMeter
  percentage: Scalars["Int"]["output"]
  pvSpec: PvSpec
}

export type PvAllocationInput = {
  meterPid: Scalars["String"]["input"]
  percentage: Scalars["Int"]["input"]
}

export type PvConfig = {
  __typename?: "PVConfig"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  meter: PostSolarMeter
  origin: ProductionOrigin
  production: CleanIntervals
  productionKwh: Scalars["Float"]["output"]
  pvType: PvType
  sizeKw: Scalars["Float"]["output"]
}

export type PvProductionSource = {
  __typename?: "PVProductionSource"
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  origin: ProductionOrigin
}

export type PvSpec = {
  __typename?: "PVSpec"
  allocations: Array<PvAllocation>
  createdAt: Scalars["DateTime"]["output"]
  etbMeterId?: Maybe<Scalars["Int"]["output"]>
  helioscope2Id?: Maybe<Scalars["Int"]["output"]>
  helioscopePdf?: Maybe<Document>
  id: Scalars["Int"]["output"]
  productionCsv?: Maybe<Document>
  productionSource?: Maybe<PvProductionSource>
  pvTypes: Array<PvType>
  roofImage?: Maybe<Document>
  sizeKwAc?: Maybe<Scalars["Float"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  system?: Maybe<System>
  systemLite?: Maybe<SystemLite>
}

export type PvSpecInput = {
  allocations?: InputMaybe<Array<PvAllocationInput>>
  etbMeterId?: InputMaybe<Scalars["Int"]["input"]>
  helioscope2Id?: InputMaybe<Scalars["Int"]["input"]>
  helioscopePid?: InputMaybe<Scalars["String"]["input"]>
  pvTypes: Array<PvType>
  sizeKwAc: Scalars["Float"]["input"]
  sizeKwDc: Scalars["Float"]["input"]
}

export type PvSystem = {
  __typename?: "PVSystem"
  sizeKw: Scalars["Float"]["output"]
  type: PvType
}

export type PvSystem2 = {
  __typename?: "PVSystem2"
  sizeKwAc?: Maybe<Scalars["Float"]["output"]>
  sizeKwDc: Scalars["Float"]["output"]
  types: Array<PvType>
}

export enum PvType {
  CarportSixHigh = "CARPORT_SIX_HIGH",
  CarportThreeHigh = "CARPORT_THREE_HIGH",
  Ground = "GROUND",
  Roof = "ROOF",
}

export enum PVoptGoal {
  ForceKw = "FORCE_KW",
  MaxCashPurchaseNpv = "MAX_CASH_PURCHASE_NPV",
}

export type PVoptRef = {
  __typename?: "PVoptRef"
  id: Scalars["Int"]["output"]
}

export type PackageBidReport = {
  __typename?: "PackageBidReport"
  cs?: Maybe<Array<CsSiteBidReport>>
  name?: Maybe<Scalars["String"]["output"]>
  notes?: Maybe<Scalars["String"]["output"]>
  pid?: Maybe<Scalars["String"]["output"]>
  ppa?: Maybe<Array<PpaSiteBidReport>>
  totalBids: Scalars["Int"]["output"]
  totalDevelopers: Scalars["Int"]["output"]
  visible: Scalars["Boolean"]["output"]
}

export enum PackageRowCloseReason {
  BuildingSold = "BUILDING_SOLD",
  FailedContractNegotiations = "FAILED_CONTRACT_NEGOTIATIONS",
  IneligibleForProgram = "INELIGIBLE_FOR_PROGRAM",
  NoBids = "NO_BIDS",
  Other = "OTHER",
  RoofAge = "ROOF_AGE",
  UnattractiveEconomics = "UNATTRACTIVE_ECONOMICS",
  WentOffPlatform = "WENT_OFF_PLATFORM",
}

export enum PackageRowStatus {
  CollectingBids = "COLLECTING_BIDS",
  DevelopingProject = "DEVELOPING_PROJECT",
  NegotiatingContracts = "NEGOTIATING_CONTRACTS",
  PreparingLaunch = "PREPARING_LAUNCH",
  ReviewingBids = "REVIEWING_BIDS",
  Shipped = "SHIPPED",
  VettingInterest = "VETTING_INTEREST",
}

export type PackageRowStatusPred = {
  value: Array<InputMaybe<PackageRowStatus>>
}

export type ParcelDataFailure = {
  __typename?: "ParcelDataFailure"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type ParseResult = {
  __typename?: "ParseResult"
  kind?: Maybe<BillType>
  parse: DocumentBillingMonth
  target?: Maybe<BillingMeter>
}

export enum ParseStatus {
  Failure = "FAILURE",
  Pending = "PENDING",
  Running = "RUNNING",
  Success = "SUCCESS",
}

export type Period = {
  __typename?: "Period"
  fromDayOfWeek: Scalars["Int"]["output"]
  fromHour?: Maybe<Scalars["Int"]["output"]>
  fromMinute?: Maybe<Scalars["Int"]["output"]>
  toDayOfWeek: Scalars["Int"]["output"]
  toHour?: Maybe<Scalars["Int"]["output"]>
  toMinute?: Maybe<Scalars["Int"]["output"]>
}

export enum Permission {
  CreatePortfolios = "CREATE_PORTFOLIOS",
  EditOwners = "EDIT_OWNERS",
  EditViewers = "EDIT_VIEWERS",
  OverrideFinmodel = "OVERRIDE_FINMODEL",
  ViewSites = "VIEW_SITES",
}

export type PhysicalCheck = {
  __typename?: "PhysicalCheck"
  badRoof?: Maybe<Scalars["Boolean"]["output"]>
  carportIsGood: Scalars["Boolean"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  existingSolar?: Maybe<Scalars["Boolean"]["output"]>
  groundmountIsGood: Scalars["Boolean"]["output"]
  roofIsGood: Scalars["Boolean"]["output"]
  unobstructedFlatRoof?: Maybe<Scalars["Boolean"]["output"]>
}

export type PhysicalCheckPolicyCheckRevampFinmodelFailureRevampFinmodelRevampCsViability =

    | PhysicalCheck
    | PolicyCheck
    | RevampCs
    | RevampFinmodel
    | RevampFinmodelFailure
    | Viability

export enum PhysicalCheckSource {
  Ab802 = "AB802",
  Buildzoom = "BUILDZOOM",
  Costar = "COSTAR",
  HumanInputHighConfidence = "HUMAN_INPUT_HIGH_CONFIDENCE",
  HumanInputLowConfidence = "HUMAN_INPUT_LOW_CONFIDENCE",
  Verisk = "VERISK",
}

export type Policy = {
  __typename?: "Policy"
  application: PolicyApplication
  conditions: Array<PolicyCondition>
  description: Scalars["String"]["output"]
  endDate?: Maybe<Scalars["Date"]["output"]>
  jurisdiction: Jurisdiction
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  publicDescription: Scalars["String"]["output"]
  publicName: Scalars["String"]["output"]
  rules: Array<Rule>
  sources: Array<Source>
  startDate?: Maybe<Scalars["Date"]["output"]>
  status: PolicyStatus
  userVisible: Scalars["Boolean"]["output"]
}

export type PolicyApplication = {
  __typename?: "PolicyApplication"
  status: PolicyApplicationStatus
}

export enum PolicyApplicationStatus {
  Full = "FULL",
  No = "NO",
  Partial = "PARTIAL",
  UnclearPolicy = "UNCLEAR_POLICY",
  Unknown = "UNKNOWN",
}

export type PolicyCheck = {
  __typename?: "PolicyCheck"
  createdAt: Scalars["DateTime"]["output"]
  disqualReason?: Maybe<PolicyReason>
  isGood: Scalars["Boolean"]["output"]
  productType?: Maybe<FinProductType>
  violatedPolicy?: Maybe<Policy>
  violatedPolicyPid?: Maybe<Scalars["String"]["output"]>
}

export type PolicyCondition = BuildingSuperTypeCondition | VnemEligibilityCondition

export type PolicyQuery = {
  __typename?: "PolicyQuery"
  all: Array<Policy>
  policy?: Maybe<Policy>
}

export type PolicyQueryPolicyArgs = {
  policyPid: Scalars["String"]["input"]
}

export enum PolicyReason {
  CsNotAllowed = "CS_NOT_ALLOWED",
  CsNotFeasible = "CS_NOT_FEASIBLE",
  CsStatusUnknown = "CS_STATUS_UNKNOWN",
  PpasNotAllowed = "PPAS_NOT_ALLOWED",
  PpaStatusUnknown = "PPA_STATUS_UNKNOWN",
}

export enum PolicyStatus {
  Active = "ACTIVE",
  Ended = "ENDED",
  Planned = "PLANNED",
}

export type PolicyViolation = {
  __typename?: "PolicyViolation"
  policy: Policy
  value: RuleValue
  violatedRule: Rule
}

export type Portfolio = {
  __typename?: "Portfolio"
  logoUrl?: Maybe<Scalars["String"]["output"]>
  org: Org
  pid: Scalars["String"]["output"]
  shine: ShinePortfolio
  title: Scalars["String"]["output"]
  users: Array<UserRef>
}

export type PortfolioAccess = {
  __typename?: "PortfolioAccess"
  defaultView?: Maybe<Scalars["Void"]["output"]>
  pid: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type PortfolioError = Error | Portfolio

export type PortfolioMutations = {
  __typename?: "PortfolioMutations"
  addSitesByOwnerName: Scalars["Int"]["output"]
  new: PortfolioRow
  removeUserFromPortfolio: AdminPortfolio
  rename: AdminPortfolio
  setPortfolioMinKw: PortfolioRow
}

export type PortfolioMutationsAddSitesByOwnerNameArgs = {
  names: Array<Scalars["String"]["input"]>
  portfolioPid: Scalars["String"]["input"]
}

export type PortfolioMutationsNewArgs = {
  createEponymousOrg: Scalars["Boolean"]["input"]
  createOpenInvite?: Scalars["Boolean"]["input"]
  orgPid?: InputMaybe<Scalars["String"]["input"]>
  title: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type PortfolioMutationsRemoveUserFromPortfolioArgs = {
  portfolioPid: Scalars["String"]["input"]
  userId: Scalars["Int"]["input"]
}

export type PortfolioMutationsRenameArgs = {
  newName: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type PortfolioMutationsSetPortfolioMinKwArgs = {
  minKw?: InputMaybe<Scalars["Float"]["input"]>
  portfolioPid: Scalars["String"]["input"]
}

export type PortfolioRef = {
  __typename?: "PortfolioRef"
  pid: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
}

export type PortfolioRow = {
  __typename?: "PortfolioRow"
  logoUrl?: Maybe<Scalars["String"]["output"]>
  minKw?: Maybe<Scalars["Float"]["output"]>
  minKwSetBy?: Maybe<Scalars["String"]["output"]>
  minKwSetDate?: Maybe<Scalars["DateTime"]["output"]>
  numSites: Scalars["Int"]["output"]
  org: AdminOrg
  pid: Scalars["String"]["output"]
  title: Scalars["String"]["output"]
  views: Array<ViewType>
}

export type PortfolioSite = {
  __typename?: "PortfolioSite"
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingType: Scalars["String"]["output"]
  city: Scalars["String"]["output"]
  closestSites: Array<RevampSite>
  county: Scalars["String"]["output"]
  documentsV0: Array<Document>
  doeReferenceType?: Maybe<BuildingType>
  footprint: Footprint
  fullAddress: Scalars["String"]["output"]
  hasIntervalDownload: Scalars["Boolean"]["output"]
  incentives: GeographicIncentives
  includeStorage: Scalars["Boolean"]["output"]
  isBehindTheMeter?: Maybe<Scalars["Boolean"]["output"]>
  isFavorite?: Maybe<Scalars["Boolean"]["output"]>
  labels: Array<SiteLabel>
  latitude: Scalars["Float"]["output"]
  longitude: Scalars["Float"]["output"]
  notes: Array<Note>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numberOfBuildings?: Maybe<Scalars["Float"]["output"]>
  occupancyRate?: Maybe<Scalars["Float"]["output"]>
  pid: Scalars["String"]["output"]
  primaryScenario?: Maybe<Scenario>
  probableUtilities: Array<UtilityRef>
  propertyName?: Maybe<Scalars["String"]["output"]>
  roofMaxKw?: Maybe<Scalars["Float"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  scenarios: Array<Scenario>
  shine: ShineSite
  solarLocation?: Maybe<SolarLocation>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  status?: Maybe<SiteStatus>
  statusDisplayText?: Maybe<Scalars["String"]["output"]>
  streetAddress: Scalars["String"]["output"]
  utilityName?: Maybe<Scalars["String"]["output"]>
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type PortfolioSiteClosestSitesArgs = {
  num?: Scalars["Int"]["input"]
  withinFt?: Scalars["Int"]["input"]
}

export type PostBatteryMeter = {
  __typename?: "PostBatteryMeter"
  batt?: Maybe<BatteryConfig>
  bauMeter?: Maybe<BauMeter>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  postSolarMeter?: Maybe<PostSolarMeter>
  tariff: TariffRate
  year: Scalars["Int"]["output"]
}

export type PostSolarMeter = {
  __typename?: "PostSolarMeter"
  bauMeter: BauMeter
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  pv: Array<PvConfig>
  tariff: TariffRate
  year: Scalars["Int"]["output"]
}

export enum ProductionOrigin {
  Bid = "BID",
  Etb = "ETB",
  Helioscope = "HELIOSCOPE",
  Pvwatts = "PVWATTS",
}

export type ProjectMilestoneInput = {
  actual?: InputMaybe<Scalars["Date"]["input"]>
  estimated?: InputMaybe<Scalars["Date"]["input"]>
}

export type ProjectParamsInput = {
  hubspotDealId?: InputMaybe<Scalars["String"]["input"]>
  lumenFeeUsdPerWatt?: InputMaybe<Scalars["Float"]["input"]>
  lumenRevenue?: InputMaybe<Scalars["Float"]["input"]>
  opsOwnerUserPid?: InputMaybe<Scalars["String"]["input"]>
  rofoSigned?: InputMaybe<Scalars["Date"]["input"]>
  salesOwnerUserPid?: InputMaybe<Scalars["String"]["input"]>
}

export type Projected = {
  __typename?: "Projected"
  annualCostUsd: Scalars["Float"]["output"]
  annualKwh: Scalars["Float"]["output"]
  costAndKwhDownloadHref: Scalars["String"]["output"]
  kwh8760: Zoned8760
  monthlyBills: Array<MonthlyBill2>
  monthlyCostUsd: Array<Scalars["Float"]["output"]>
  monthlyUsageKwh: Array<Scalars["Float"]["output"]>
  peakKw: Scalars["Float"]["output"]
  tariff: Tariff
  year: Scalars["Int"]["output"]
}

export type ProjectedE2Error = E2Error | Projected

export type Provider = {
  __typename?: "Provider"
  aiModel?: Maybe<AiModel>
  createdAt: Scalars["DateTime"]["output"]
  document?: Maybe<Document>
  documentBillingMonth?: Maybe<DocumentBillingMonth>
  espmConsumption?: Maybe<EspmConsumption>
  id: Scalars["Int"]["output"]
  user?: Maybe<UserRef>
}

export type PublicBuildingDataMutations = {
  __typename?: "PublicBuildingDataMutations"
  createFromGooglePlace: BuildingDataError
  createSite: SiteRefError
  updateCoords: BuildingDataError
}

export type PublicBuildingDataMutationsCreateFromGooglePlaceArgs = {
  placeId: Scalars["String"]["input"]
}

export type PublicBuildingDataMutationsCreateSiteArgs = {
  amendments: BuildingDataAmendmentsInput
  buildingDataId: Scalars["Int"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type PublicBuildingDataMutationsUpdateCoordsArgs = {
  buildingDataId: Scalars["Int"]["input"]
  latitude: Scalars["Float"]["input"]
  longitude: Scalars["Float"]["input"]
}

export type PublicBundleMutations = {
  __typename?: "PublicBundleMutations"
  addEtb: EtbExtract
  addInvestorBid: InvestorBid
  addSystem: SystemUnion
  archiveInvestorBid?: Maybe<Scalars["Void"]["output"]>
  duplicateInvestorBid: InvestorBid
  editInvestorBid: InvestorBid
  setMilestone?: Maybe<Scalars["Void"]["output"]>
  submitBids?: Maybe<Scalars["Void"]["output"]>
  toggleOptOut?: Maybe<Scalars["Void"]["output"]>
  toggleSpecOptOut?: Maybe<Scalars["Void"]["output"]>
}

export type PublicBundleMutationsAddEtbArgs = {
  sitePid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type PublicBundleMutationsAddInvestorBidArgs = {
  input: InvestorBidInput
}

export type PublicBundleMutationsAddSystemArgs = {
  input: AddSystemInput
  sitePid: Scalars["String"]["input"]
}

export type PublicBundleMutationsArchiveInvestorBidArgs = {
  archive: Scalars["Boolean"]["input"]
  bidPid: Scalars["String"]["input"]
}

export type PublicBundleMutationsDuplicateInvestorBidArgs = {
  input: DuplicateInvestorBidInput
}

export type PublicBundleMutationsEditInvestorBidArgs = {
  bidPid: Scalars["String"]["input"]
  input: InvestorBidInput
}

export type PublicBundleMutationsSetMilestoneArgs = {
  milestoneInput: ProjectMilestoneInput
  milestoneType: MilestoneType
  sitePid: Scalars["String"]["input"]
}

export type PublicBundleMutationsSubmitBidsArgs = {
  pricingTermsAgreed: Scalars["Boolean"]["input"]
}

export type PublicBundleMutationsToggleOptOutArgs = {
  customReason?: InputMaybe<Scalars["String"]["input"]>
  input: OptOutInput
  optOut: Scalars["Boolean"]["input"]
  reason?: InputMaybe<InvestorOptOutReason>
}

export type PublicBundleMutationsToggleSpecOptOutArgs = {
  bidSpecPid: Scalars["String"]["input"]
  customReason?: InputMaybe<Scalars["String"]["input"]>
  optOut: Scalars["Boolean"]["input"]
  reason?: InputMaybe<SpecOptOutReason>
}

export type PublicFinmodelMutations = {
  __typename?: "PublicFinmodelMutations"
  addOverride: FinmodelInputOverrideError
  deleteOverride?: Maybe<FinmodelInputOverrideError>
}

export type PublicFinmodelMutationsAddOverrideArgs = {
  overrideInput: FinmodelMutationInput
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}

export type PublicFinmodelMutationsDeleteOverrideArgs = {
  inputName: Scalars["String"]["input"]
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid?: InputMaybe<Scalars["String"]["input"]>
}

export type PublicTariff = {
  __typename?: "PublicTariff"
  closedDate?: Maybe<Scalars["DateTime"]["output"]>
  code: Scalars["String"]["output"]
  customTariffId?: Maybe<Scalars["Int"]["output"]>
  customerClass: Scalars["String"]["output"]
  customerCount?: Maybe<Scalars["Int"]["output"]>
  customerLikelihood: Scalars["Float"]["output"]
  hasNetMetering: Scalars["Boolean"]["output"]
  hasTouRates: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  isClosed: Scalars["Boolean"]["output"]
  isNem2: Scalars["Boolean"]["output"]
  isPreferred?: Maybe<Scalars["Boolean"]["output"]>
  isPrimaryConnection: Scalars["Boolean"]["output"]
  latestRateId?: Maybe<Scalars["Int"]["output"]>
  masterTariffId?: Maybe<Scalars["Int"]["output"]>
  maxMonthlyKw?: Maybe<Scalars["Float"]["output"]>
  maxMonthlyKwh?: Maybe<Scalars["Float"]["output"]>
  minMonthlyKw?: Maybe<Scalars["Float"]["output"]>
  minMonthlyKwh?: Maybe<Scalars["Float"]["output"]>
  name: Scalars["String"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  requiresPv?: Maybe<Scalars["Boolean"]["output"]>
  requiresStorage?: Maybe<Scalars["Boolean"]["output"]>
  tariffType?: Maybe<Scalars["String"]["output"]>
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  utility: Utility
}

export type PublicTaskMutations = {
  __typename?: "PublicTaskMutations"
  enqueue: TaskError
}

export type PublicTaskMutationsEnqueueArgs = {
  params: TaskParamsInput
}

export type PublicTaskQueries = {
  __typename?: "PublicTaskQueries"
  one: TaskError
}

export type PublicTaskQueriesOneArgs = {
  taskId: Scalars["Int"]["input"]
}

export type Query = {
  __typename?: "Query"
  admin: AdminQuery
  /** @deprecated use admin.active_admins */
  adminUsers: Array<UserRef>
  bidReports: Array<CustomBidReport>
  bundleDetail?: Maybe<Bundle2>
  bundleParentDetail: BundleParent
  bundleParents: Array<BundleParent>
  bundleRowDetail?: Maybe<BundleRow2>
  bundleRowForFinancier?: Maybe<BundleRow>
  bundlesForFinancier: Array<Bundle>
  bundlesForFinancier2: Array<Bundle2>
  currentUser: AuthUser
  customTariff: CustomTariff
  customTariffs: Array<PublicTariff>
  eventOccurred: Scalars["Boolean"]["output"]
  googleApi: GoogleApiQuery
  isAwardee: Scalars["Boolean"]["output"]
  openInvite: OpenInviteError
  org?: Maybe<Org>
  orgBySlug?: Maybe<Org>
  orgLabels: Array<SiteLabel>
  orgLogo?: Maybe<Scalars["String"]["output"]>
  orgSiteDocuments: Array<SiteDocuments>
  portfolio?: Maybe<Portfolio>
  portfolios: Array<PortfolioAccess>
  schemaVersion: SchemaVersion
  tariffs2: Array<PublicTariff>
  tasks: PublicTaskQueries
  thirdPartySuppliers: Array<ThirdPartySupplier>
  utilitiesByName: UtilityListResponse
  utilitiesForState: UtilityListResponse
  utilitiesForZip: UtilityListResponse
}

export type QueryBundleDetailArgs = {
  bundlePid: Scalars["String"]["input"]
  slug: Scalars["String"]["input"]
}

export type QueryBundleParentDetailArgs = {
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}

export type QueryBundleParentsArgs = {
  orgSlug: Scalars["String"]["input"]
}

export type QueryBundleRowDetailArgs = {
  bundlePid: Scalars["String"]["input"]
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type QueryBundleRowForFinancierArgs = {
  bundlePid: Scalars["String"]["input"]
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type QueryBundlesForFinancierArgs = {
  slug: Scalars["String"]["input"]
}

export type QueryBundlesForFinancier2Args = {
  slug: Scalars["String"]["input"]
}

export type QueryCustomTariffArgs = {
  customTariffId: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type QueryCustomTariffsArgs = {
  sitePid: Scalars["String"]["input"]
  utilityPid: Scalars["String"]["input"]
}

export type QueryEventOccurredArgs = {
  event: UserEventType
}

export type QueryIsAwardeeArgs = {
  bundlePid: Scalars["String"]["input"]
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type QueryOpenInviteArgs = {
  pid: Scalars["String"]["input"]
}

export type QueryOrgArgs = {
  pid: Scalars["String"]["input"]
}

export type QueryOrgBySlugArgs = {
  slug: Scalars["String"]["input"]
}

export type QueryOrgLabelsArgs = {
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryOrgLogoArgs = {
  pid: Scalars["String"]["input"]
}

export type QueryOrgSiteDocumentsArgs = {
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryPortfolioArgs = {
  pid: Scalars["String"]["input"]
}

export type QueryTariffs2Args = {
  utilityPid: Scalars["String"]["input"]
}

export type QueryUtilitiesByNameArgs = {
  name: Scalars["String"]["input"]
}

export type QueryUtilitiesForStateArgs = {
  state: Scalars["String"]["input"]
}

export type QueryUtilitiesForZipArgs = {
  zipCode: Scalars["String"]["input"]
}

export type QueueMutations = {
  __typename?: "QueueMutations"
  boost?: Maybe<Scalars["Void"]["output"]>
}

export type QueueMutationsBoostArgs = {
  orgPid: Scalars["String"]["input"]
}

export enum RecOwner {
  Investor = "INVESTOR",
  OwnerOrTenant = "OWNER_OR_TENANT",
}

export type RecOwnerPred = {
  value: Array<InputMaybe<RecOwner>>
}

export type Rate = {
  __typename?: "Rate"
  applicabilityKey?: Maybe<Scalars["String"]["output"]>
  applicabilityValues?: Maybe<Array<Scalars["String"]["output"]>>
  applicableBands: Array<RateBand>
  bands: Array<RateBand>
  chargeClass: Scalars["String"]["output"]
  chargePeriod: ChargePeriod
  chargeType?: Maybe<ChargeType>
  classes: Array<ChargeClass>
  groupName?: Maybe<Scalars["String"]["output"]>
  isDemandCharge: Scalars["Boolean"]["output"]
  isFixedPrice: Scalars["Boolean"]["output"]
  isQuantity: Scalars["Boolean"]["output"]
  isTou: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  quantityKey?: Maybe<Scalars["String"]["output"]>
  season?: Maybe<Season>
  tariffRateId: Scalars["Int"]["output"]
  tou?: Maybe<TimeOfUse>
  transactionType: TransactionType
  variableLimitValue?: Maybe<TariffPropertyKey>
}

export type RateBand = {
  __typename?: "RateBand"
  applicabilityValue?: Maybe<Scalars["String"]["output"]>
  calculationFactor?: Maybe<Scalars["Float"]["output"]>
  consumptionUpperLimit?: Maybe<Scalars["Float"]["output"]>
  demandUpperLimit?: Maybe<Scalars["Float"]["output"]>
  hasConsumptionLimit?: Maybe<Scalars["Boolean"]["output"]>
  isCredit: Scalars["Boolean"]["output"]
  price: Scalars["Float"]["output"]
  propertyUpperLimit?: Maybe<Scalars["Float"]["output"]>
  rateUnit: RateUnit
  tariffRateBandId: Scalars["Int"]["output"]
}

export enum RateUnit {
  CostPerUnit = "COST_PER_UNIT",
  Percentage = "PERCENTAGE",
}

export type RawCsvCell = {
  __typename?: "RawCsvCell"
  columnId: Scalars["String"]["output"]
  value?: Maybe<Scalars["String"]["output"]>
}

export type RawFile = {
  __typename?: "RawFile"
  fileData: Scalars["String"]["output"]
  filename: Scalars["String"]["output"]
}

export enum RbacRole {
  Owner = "OWNER",
  PrimaryContact = "PRIMARY_CONTACT",
  Viewer = "VIEWER",
}

export type RecordUserEventInput = {
  event: UserEventType
  properties?: InputMaybe<Scalars["JSON"]["input"]>
}

export type RemoveLabelFromSitesInput = {
  siteLabelPid: Scalars["String"]["input"]
  sitePids: Array<Scalars["String"]["input"]>
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type RemoveLabelInput = {
  labelPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type RenameLabelInput = {
  labelName: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}

export type RenameSiteLabelInput = {
  newLabelName: Scalars["String"]["input"]
  siteLabelPid: Scalars["String"]["input"]
  slug?: InputMaybe<Scalars["String"]["input"]>
}

export type RenameSiteLabelOutput = {
  __typename?: "RenameSiteLabelOutput"
  label: SiteLabel
}

export type RenameSiteLabelResponse = Error | RenameSiteLabelOutput

export type ReonomyOwnerLookupInput = {
  ownerId: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
}

export type ReoptRef = {
  __typename?: "ReoptRef"
  pid: Scalars["String"]["output"]
}

export type RequestBidsInput = {
  sitePid: Scalars["String"]["input"]
}

export type Response = {
  __typename?: "Response"
  choices: Array<ResponseChoice>
  created: Scalars["Float"]["output"]
  id: Scalars["String"]["output"]
  model: Scalars["String"]["output"]
  object: Scalars["String"]["output"]
  responseMs: Scalars["Int"]["output"]
  usage?: Maybe<Usage>
}

export type ResponseChoice = {
  __typename?: "ResponseChoice"
  finishReason: Scalars["String"]["output"]
  index: Scalars["Int"]["output"]
  message: Message
}

export type Result = {
  __typename?: "Result"
  createdAt: Scalars["DateTime"]["output"]
  financing: RevampFinancing
  helioscope?: Maybe<Helioscope>
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  result?: Maybe<PhysicalCheckPolicyCheckRevampFinmodelFailureRevampFinmodelRevampCsViability>
  salesPdfReportHref?: Maybe<Scalars["String"]["output"]>
  scenario: RevampScenario
}

export type ResultConfig = {
  __typename?: "ResultConfig"
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  finproduct: AdminFinProduct
  finrelDisabledAt?: Maybe<Scalars["DateTime"]["output"]>
}

export type ResultForTariff = {
  __typename?: "ResultForTariff"
  currentlyActive: Scalars["Boolean"]["output"]
  medianCostDelta?: Maybe<Scalars["Float"]["output"]>
  results: Array<NameThatTariffResult>
  tariff: Tariff
}

export type ResultTable = {
  __typename?: "ResultTable"
  rows: Array<ResultTableRow>
  view: ResultTableView
}

export type ResultTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type ResultTableViewArgs = {
  filterBy?: InputMaybe<ResultTableFilter>
  sortBy?: InputMaybe<Array<ResultTableSort>>
}

export enum ResultTableAttr {
  CreatedAt = "CREATED_AT",
  FailureFmv = "FAILURE_FMV",
  FailureId = "FAILURE_ID",
  FailureMessage = "FAILURE_MESSAGE",
  FailureName = "FAILURE_NAME",
  FinancierName = "FINANCIER_NAME",
  FinancierPid = "FINANCIER_PID",
  FinmodelFmv = "FINMODEL_FMV",
  FinmodelId = "FINMODEL_ID",
  FinmodelNoi = "FINMODEL_NOI",
  FinproductName = "FINPRODUCT_NAME",
  FinproductType = "FINPRODUCT_TYPE",
  Pid = "PID",
  PolicyCheckIsGood = "POLICY_CHECK_IS_GOOD",
  PortfolioPid = "PORTFOLIO_PID",
  ScenarioIncludeStorage = "SCENARIO_INCLUDE_STORAGE",
  ScenarioName = "SCENARIO_NAME",
  ScenarioPid = "SCENARIO_PID",
  ScenarioSolarLocation = "SCENARIO_SOLAR_LOCATION",
  SiteCity = "SITE_CITY",
  SiteHiddenFromCustomers = "SITE_HIDDEN_FROM_CUSTOMERS",
  SiteName = "SITE_NAME",
  SitePid = "SITE_PID",
  SiteState = "SITE_STATE",
  SiteStatus = "SITE_STATUS",
  SiteStreetAddress = "SITE_STREET_ADDRESS",
}

export type ResultTableFilter = {
  finmodelNoi?: InputMaybe<FloatPred>
  finproductType?: InputMaybe<FinProductTypePred>
  portfolioPid?: InputMaybe<StringPred>
  scenarioIncludeStorage?: InputMaybe<BoolPred>
  scenarioSolarLocation?: InputMaybe<SolarLocationPred>
}

export type ResultTableRow = {
  __typename?: "ResultTableRow"
  createdAt: Scalars["DateTime"]["output"]
  failureFmv?: Maybe<Scalars["String"]["output"]>
  failureId?: Maybe<Scalars["Int"]["output"]>
  failureMessage?: Maybe<Scalars["String"]["output"]>
  failureName?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  finmodelFmv?: Maybe<Scalars["String"]["output"]>
  finmodelId?: Maybe<Scalars["Int"]["output"]>
  finmodelNoi?: Maybe<Scalars["Float"]["output"]>
  finproductName: Scalars["String"]["output"]
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  physicalCheckCarportIsGood?: Maybe<Scalars["Boolean"]["output"]>
  physicalCheckGroundmountIsGood?: Maybe<Scalars["Boolean"]["output"]>
  physicalCheckRoofIsGood?: Maybe<Scalars["Boolean"]["output"]>
  pid: Scalars["String"]["output"]
  policyCheckIsGood?: Maybe<Scalars["Boolean"]["output"]>
  portfolioPid: Scalars["String"]["output"]
  scenarioIncludeStorage: Scalars["Boolean"]["output"]
  scenarioName: Scalars["String"]["output"]
  scenarioPid: Scalars["String"]["output"]
  scenarioSolarLocation: SolarLocation
  siteCity: Scalars["String"]["output"]
  siteHiddenFromCustomers: Scalars["Boolean"]["output"]
  siteName?: Maybe<Scalars["String"]["output"]>
  sitePid: Scalars["String"]["output"]
  siteState: Scalars["String"]["output"]
  siteStatus: SiteStatus
  siteStreetAddress: Scalars["String"]["output"]
}

export type ResultTableSort = {
  attr: ResultTableAttr
  order: SortOrder
}

export type ResultTableView = {
  __typename?: "ResultTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type RevampCs = {
  __typename?: "RevampCS"
  buildingOwner: BuildingOwnerEconomics
  createdAt: Scalars["DateTime"]["output"]
  financing: RevampFinancing
  goal?: Maybe<PVoptGoal>
  id: Scalars["Int"]["output"]
  leaseProjections?: Maybe<CsLeaseProjections>
  pricing: CsPrice
  roofRent?: Maybe<RoofRentEconomics>
  systems: Array<RevampSystem>
  termYears: Scalars["Int"]["output"]
}

export type RevampDer = {
  __typename?: "RevampDer"
  averageDayKwhFlow: Array<KwhFlow>
  totalKwhFlow: KwhFlow
}

export type RevampEmissions = {
  __typename?: "RevampEmissions"
  bauAverageDayCo2Tons: Array<Scalars["Float"]["output"]>
  bauCo2Tons: Scalars["Float"]["output"]
  derAverageDayCo2Tons: Array<Scalars["Float"]["output"]>
  derCo2Tons: Scalars["Float"]["output"]
}

export type RevampFinancing = {
  __typename?: "RevampFinancing"
  financierLogo?: Maybe<Scalars["String"]["output"]>
  financierLogomark?: Maybe<Scalars["String"]["output"]>
  financierName: Scalars["String"]["output"]
  financierPid: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  isThirdParty: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  status: FinProductStatus
  type: FinProductType
}

export type RevampFinmodel = {
  __typename?: "RevampFinmodel"
  bauCostPerYear: Array<Scalars["Float"]["output"]>
  buildingOwner: BuildingOwnerEconomics
  buildingOwnerXlsx?: Maybe<Scalars["String"]["output"]>
  buildingOwnerXlsxHref?: Maybe<Scalars["String"]["output"]>
  commOpDate: Scalars["DateTime"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  derCostPerYear: Array<Scalars["Float"]["output"]>
  emissions?: Maybe<RevampEmissions>
  financing: RevampFinancing
  fmvStr: Scalars["String"]["output"]
  goal?: Maybe<PVoptGoal>
  id: Scalars["Int"]["output"]
  importReductionPct: Scalars["Float"]["output"]
  intervalsAndCostsXlsxHref: Scalars["String"]["output"]
  investorDetails?: Maybe<InvestorDetails>
  isGreenLease: Scalars["Boolean"]["output"]
  isVnem: Scalars["Boolean"]["output"]
  itcAssumptions: RevampItcAssumptions
  iterations: Array<RevampIteration>
  loan?: Maybe<LoanEconomics>
  meters: Array<RevampMeter>
  moreDetails?: Maybe<MoreDetails>
  offerStatus: OfferStatus
  pid: Scalars["String"]["output"]
  ppa?: Maybe<PpaEconomics>
  scenario: RevampScenario
  selfInvest?: Maybe<SelfInvestEconomics>
  systems: Array<RevampSystem>
  thirdPartySupplier?: Maybe<ThirdPartySupplier>
  totalPvExportKwh?: Maybe<Scalars["Float"]["output"]>
  totalPvProductionKwh: Scalars["Float"]["output"]
  type: FinProductType
  utilityCosts: UtilityCost
}

export type RevampFinmodelFailure = {
  __typename?: "RevampFinmodelFailure"
  createdAt: Scalars["DateTime"]["output"]
  details: FailureDetails
  fmvStr: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
}

export type RevampItcAssumptions = {
  __typename?: "RevampItcAssumptions"
  domesticMaterialsAdder: Scalars["Boolean"]["output"]
  inEnergyCommunity: Scalars["Boolean"]["output"]
  inLowIncomeCommunity: Scalars["Boolean"]["output"]
  rate: Scalars["Float"]["output"]
}

export type RevampIteration = {
  __typename?: "RevampIteration"
  cashPurchaseNpv: Scalars["Float"]["output"]
  marginalCo2Averted?: Maybe<Scalars["Float"]["output"]>
  pvKw: Scalars["Float"]["output"]
  storagePvKw?: Maybe<Scalars["Float"]["output"]>
  storagePvKwh?: Maybe<Scalars["Float"]["output"]>
}

export type RevampMeter = {
  __typename?: "RevampMeter"
  bau: RevampDer
  der?: Maybe<RevampDer>
  loadCategory: LoadCategory
  meterSource: MeterSource
  name: Scalars["String"]["output"]
}

export type RevampScenario = {
  __typename?: "RevampScenario"
  includeStorage: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export type RevampSite = {
  __typename?: "RevampSite"
  activeResults: Array<Result>
  assetManager?: Maybe<Scalars["String"]["output"]>
  bidPackages: Array<BidPackage>
  biddingConfigResult?: Maybe<Result>
  billingMeters: Array<BillingMeter>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingData?: Maybe<BuildingData>
  carportMaxPvKw: Scalars["Float"]["output"]
  cbsaName?: Maybe<Scalars["String"]["output"]>
  city: Scalars["String"]["output"]
  county: Scalars["String"]["output"]
  customTariff?: Maybe<CustomTariff>
  customTariffs: Array<CustomTariff>
  documentParseRequests: Array<DocumentParseRequest>
  documents: Array<Document>
  doeReferenceType?: Maybe<BuildingType>
  energyThings?: Maybe<EnergyThings>
  evCalc?: Maybe<EvCalc>
  evOverrides: EvOverrideQueries
  feasibility: SolarFeasibility
  fieldHistory: SiteFieldChangeLog
  financingThings?: Maybe<FinancingThings>
  flags: Array<SiteFlag>
  footprint: Footprint
  fullAddress: Scalars["String"]["output"]
  /** Solar financing feasibility */
  gaugeStatus?: Maybe<GaugeRazzleDazzle>
  gridEscalator?: Maybe<Scalars["Float"]["output"]>
  groundAvailableSqft?: Maybe<Scalars["Float"]["output"]>
  groundmountMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  hasSubmittedEnergyData: Scalars["Boolean"]["output"]
  hideBuildingFootprint: Scalars["Boolean"]["output"]
  highlightedResults: Array<Result>
  impliedCarportLinearFt?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqftExplanation: RoofSqftExplanation
  isBehindTheMeter?: Maybe<Scalars["Boolean"]["output"]>
  isEnergyCommunity: Scalars["Boolean"]["output"]
  isFavorite: Scalars["Boolean"]["output"]
  isLowIncomeCommunity?: Maybe<Scalars["Boolean"]["output"]>
  isMultifamily: Scalars["Boolean"]["output"]
  isRecalculating: Scalars["Boolean"]["output"]
  keepoutsFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  labels: Array<SiteLabel>
  latitude: Scalars["Float"]["output"]
  leaseType?: Maybe<LeaseType>
  longitude: Scalars["Float"]["output"]
  marketplaceStatus?: Maybe<MarketplaceStatus>
  maxPvKwPolicyLimited: Scalars["Boolean"]["output"]
  meterSet?: Maybe<MeterSet>
  metering?: Maybe<Metering>
  mortgageLender?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  notes: Array<Note>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  occupancyType?: Maybe<BuildingOccupancyType>
  physicalCheck: PhysicalCheck
  pid: Scalars["String"]["output"]
  policies: Array<Policy>
  ppaType?: Maybe<PpaProductType>
  probableUtilities: Array<UtilityRef>
  recommendedResult?: Maybe<Result>
  result?: Maybe<Result>
  resultPerLocation: Array<Result>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofMaxPvKw: Scalars["Float"]["output"]
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  scenarios: Array<RevampScenario>
  selectedConfig?: Maybe<SiteConfig>
  selectedConfigResult?: Maybe<Result>
  selectedResults: Array<Result>
  shine: ShineSite
  siteDetails: SiteDetails
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  status?: Maybe<SiteStatus>
  statusDisplayText?: Maybe<Scalars["String"]["output"]>
  streetAddress: Scalars["String"]["output"]
  targetUtility?: Maybe<Utility>
  tenantInterest?: Maybe<YesNoUnsure>
  tenantLeaseEnds?: Maybe<Scalars["Date"]["output"]>
  tenantLeaseTerm?: Maybe<Scalars["String"]["output"]>
  thirdPartySupplier?: Maybe<ThirdPartySupplier>
  usableCarportFt?: Maybe<Scalars["Float"]["output"]>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  usingBillingMeters?: Maybe<Scalars["DateTime"]["output"]>
  visuals: SiteVisuals
  vnemAllowed: Scalars["Boolean"]["output"]
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type RevampSiteCustomTariffArgs = {
  tariffId: Scalars["Int"]["input"]
}

export type RevampSiteResultArgs = {
  pid: Scalars["String"]["input"]
}

export type RevampSiteError = Error | RevampSite

export type RevampSystem = BatterySystem | PvSystem

export type RevampTariff = {
  __typename?: "RevampTariff"
  code: Scalars["String"]["output"]
  endDate?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  startDate: Scalars["DateTime"]["output"]
  utility: RevampUtility
}

export type RevampUtility = {
  __typename?: "RevampUtility"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  shortName: Scalars["String"]["output"]
}

export type RevertToEstimatesInput = {
  sitePid: Scalars["String"]["input"]
}

export enum Role {
  Assistant = "ASSISTANT",
  System = "SYSTEM",
  User = "USER",
}

export type RoofRentEconomics = {
  __typename?: "RoofRentEconomics"
  annualUsd: Scalars["Float"]["output"]
  discountRate: Scalars["Float"]["output"]
  lifetimeUsd: Scalars["Float"]["output"]
  npv: Scalars["Float"]["output"]
  roofRentPerYear: Array<Scalars["Float"]["output"]>
  usdPerSqft: Scalars["Float"]["output"]
}

export enum RoofRightsHolder {
  BuildingOwner = "BUILDING_OWNER",
  Other = "OTHER",
  Tenant = "TENANT",
}

export type RoofRightsHolderPred = {
  value: Array<InputMaybe<RoofRightsHolder>>
}

export enum RoofSqftExplanation {
  NoUsableRoofInfo = "NO_USABLE_ROOF_INFO",
  RoofDrawingNoKeepouts = "ROOF_DRAWING_NO_KEEPOUTS",
  RoofDrawingWithKeepouts = "ROOF_DRAWING_WITH_KEEPOUTS",
  SlopedRoofDrawingNoKeepouts = "SLOPED_ROOF_DRAWING_NO_KEEPOUTS",
  SlopedRoofDrawingWithKeepouts = "SLOPED_ROOF_DRAWING_WITH_KEEPOUTS",
  SlopedUsableRoofManuallySet = "SLOPED_USABLE_ROOF_MANUALLY_SET",
  SlopedUsableRoofPctDefault = "SLOPED_USABLE_ROOF_PCT_DEFAULT",
  SlopedUsableRoofPctManuallySet = "SLOPED_USABLE_ROOF_PCT_MANUALLY_SET",
  UsableRoofManuallySet = "USABLE_ROOF_MANUALLY_SET",
  UsableRoofPctDefault = "USABLE_ROOF_PCT_DEFAULT",
  UsableRoofPctManuallySet = "USABLE_ROOF_PCT_MANUALLY_SET",
}

export type RowValidationError = {
  __typename?: "RowValidationError"
  message: Scalars["String"]["output"]
  type: RowValidationErrorType
}

export enum RowValidationErrorType {
  AddressNotFound = "ADDRESS_NOT_FOUND",
  CostarValidationFailed = "COSTAR_VALIDATION_FAILED",
  DuplicateAddressInFile = "DUPLICATE_ADDRESS_IN_FILE",
  InvalidLatLon = "INVALID_LAT_LON",
  InvalidSqft = "INVALID_SQFT",
  MissingRequiredField = "MISSING_REQUIRED_FIELD",
  SiteAlreadyExists = "SITE_ALREADY_EXISTS",
  UnsupportedBuildingType = "UNSUPPORTED_BUILDING_TYPE",
}

export type RowValidationWarning = {
  __typename?: "RowValidationWarning"
  message: Scalars["String"]["output"]
  type: RowValidationWarningType
}

export enum RowValidationWarningType {
  AddressMismatch = "ADDRESS_MISMATCH",
  InvalidYearBuilt = "INVALID_YEAR_BUILT",
  MaxDistanceExceeded = "MAX_DISTANCE_EXCEEDED",
}

export type Rule = {
  __typename?: "Rule"
  application: RuleApplication
  conditions: Array<PolicyCondition>
  description: Scalars["String"]["output"]
  id: Scalars["String"]["output"]
  units?: Maybe<RuleValueUnits>
  value: RuleValue
}

export type RuleApplication = {
  __typename?: "RuleApplication"
  detail?: Maybe<Scalars["String"]["output"]>
  status: RuleApplicationStatus
}

export enum RuleApplicationStatus {
  Full = "FULL",
  No = "NO",
  Partial = "PARTIAL",
  Unknown = "UNKNOWN",
}

export type RuleValue =
  | CurrencyValue
  | IntegerValue
  | NumberValue
  | TextValue
  | YesNoValue

export enum RuleValueUnits {
  Dollars = "DOLLARS",
  Kw = "KW",
  Percentage = "PERCENTAGE",
  Years = "YEARS",
}

export type SaveSiteShapesInput = {
  coordinates?: InputMaybe<Coordinate>
  geometries: SiteGeojsonShapes
  sitePid: Scalars["String"]["input"]
}

export type Scenario = {
  __typename?: "Scenario"
  canBecomePrimary: Scalars["Boolean"]["output"]
  includeStorage: Scalars["Boolean"]["output"]
  isPrimary: Scalars["Boolean"]["output"]
  loadCategory: LoadCategory
  meterSet?: Maybe<MeterSet>
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  possibleTariffs: Array<TariffRef>
  solarLocation: SolarLocation
}

export type ScenarioConfig = {
  __typename?: "ScenarioConfig"
  battery?: Maybe<BatteryProduct>
  carportKw?: Maybe<Scalars["Float"]["output"]>
  createdAt: Scalars["DateTime"]["output"]
  etb?: Maybe<EtbReport>
  finproduct?: Maybe<AdminFinProduct>
  finproductType?: Maybe<FinProductType>
  goal: PVoptGoal
  groundKw?: Maybe<Scalars["Float"]["output"]>
  helioscope?: Maybe<Helioscope>
  id: Scalars["Int"]["output"]
  roofImage?: Maybe<Attachment>
  roofKw?: Maybe<Scalars["Float"]["output"]>
  scenario: ScenarioRef
  site: SiteRef
}

export type ScenarioMutations = {
  __typename?: "ScenarioMutations"
  removeConfig?: Maybe<Scalars["Void"]["output"]>
  setConfig: AdminScenario
  setEtb: AdminScenario
  setHelioscope: AdminScenario
  setName: Site
  setPrimary: Site
  setPvoptGoal: AdminScenario
  toggleMulticonnect: AdminScenario
  toggleVisibility: AdminScenario
}

export type ScenarioMutationsRemoveConfigArgs = {
  scenarioConfigId: Scalars["Int"]["input"]
}

export type ScenarioMutationsSetConfigArgs = {
  carportKw?: InputMaybe<Scalars["Float"]["input"]>
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
  goal?: InputMaybe<PVoptGoal>
  groundKw?: InputMaybe<Scalars["Float"]["input"]>
  helioscopePid?: InputMaybe<Scalars["String"]["input"]>
  roofKw?: InputMaybe<Scalars["Float"]["input"]>
}

export type ScenarioMutationsSetEtbArgs = {
  etbId?: InputMaybe<Scalars["Int"]["input"]>
}

export type ScenarioMutationsSetHelioscopeArgs = {
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
  helioscopePid?: InputMaybe<Scalars["String"]["input"]>
}

export type ScenarioMutationsSetNameArgs = {
  name: Scalars["String"]["input"]
}

export type ScenarioMutationsSetPvoptGoalArgs = {
  carportKw?: InputMaybe<Scalars["Float"]["input"]>
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
  finproductType?: InputMaybe<FinProductType>
  groundKw?: InputMaybe<Scalars["Float"]["input"]>
  pvoptGoal: PVoptGoal
  roofKw?: InputMaybe<Scalars["Float"]["input"]>
}

export type ScenarioMutationsToggleMulticonnectArgs = {
  allow: Scalars["Boolean"]["input"]
}

export type ScenarioMutationsToggleVisibilityArgs = {
  hidden: Scalars["Boolean"]["input"]
}

export type ScenarioPred = {
  value?: InputMaybe<Scalars["String"]["input"]>
}

export type ScenarioRef = {
  __typename?: "ScenarioRef"
  includeStorage: Scalars["Boolean"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  solarLocation: SolarLocation
}

export enum SchemaOrigin {
  Costar = "COSTAR",
  Custom = "CUSTOM",
  Reonomy = "REONOMY",
}

export type SchemaVersion = {
  __typename?: "SchemaVersion"
  version: Scalars["String"]["output"]
}

export type SearchPred = {
  value: Scalars["String"]["input"]
}

export type SearchSiteRow = {
  __typename?: "SearchSiteRow"
  fullAddress: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  portfolio?: Maybe<PortfolioRef>
}

export type Season = {
  __typename?: "Season"
  seasonFromDay: Scalars["Int"]["output"]
  seasonFromMonth: Scalars["Int"]["output"]
  seasonToDay: Scalars["Int"]["output"]
  seasonToMonth: Scalars["Int"]["output"]
}

export type SeasonalDayRate = {
  __typename?: "SeasonalDayRate"
  dayRates: Array<Scalars["Float"]["output"]>
  endMonth: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  startMonth: Scalars["Int"]["output"]
}

export type SelfInvestCashflows = {
  __typename?: "SelfInvestCashflows"
  greenLeaseTenantFlows?: Maybe<TenantCashflows>
  netCashflowPerYear: Array<Scalars["Float"]["output"]>
  totalCapex: Scalars["Float"]["output"]
  totalItc: Scalars["Float"]["output"]
  totalNet: Scalars["Float"]["output"]
  totalOpex: Scalars["Float"]["output"]
  totalRevenue: Scalars["Float"]["output"]
  totalUtilitySavings: Scalars["Float"]["output"]
}

export type SelfInvestEconomics = {
  __typename?: "SelfInvestEconomics"
  discountRate: Scalars["Float"]["output"]
  flows?: Maybe<SelfInvestCashflows>
  irrs: IrRs
  npv: Scalars["Float"]["output"]
  product: SelfInvestFinProduct
  selfInvestXlsxHref: Scalars["String"]["output"]
  srecToInvestor: Scalars["Boolean"]["output"]
  termYears: Scalars["Int"]["output"]
}

export type SelfInvestFinProduct = {
  __typename?: "SelfInvestFinProduct"
  financierName: Scalars["String"]["output"]
  productName: Scalars["String"]["output"]
}

export type SetBauMeterLabelInput = {
  bauMeterId: Scalars["Int"]["input"]
  label: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SetBauMeterTariffInput = {
  bauMeterId: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
  slot: TariffSlot
  tariffParentId: Scalars["Int"]["input"]
}

export type SetMeteringInput = {
  metering: Metering
  sitePid: Scalars["String"]["input"]
}

export type SetPropertyNameResponse = Error | PortfolioSite

export type SetSiteShapesInput = {
  shapes: SiteShapes
  sitePid: Scalars["String"]["input"]
}

export type SetTargetUtilityInput = {
  sitePid: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type ShapeInfo = {
  coordinates: Array<Array<Coordinate>>
  setbackFt?: InputMaybe<Scalars["Float"]["input"]>
}

export enum ShineDuration {
  Daily = "DAILY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export type ShineOrg = {
  __typename?: "ShineOrg"
  siteRefs: Array<ShineSiteRef>
  stats?: Maybe<ShineStats>
  status: ShineStatus
  units: Array<ShineUnit>
}

export type ShineOrgUnitsArgs = {
  duration: ShineDuration
}

export type ShinePortfolio = {
  __typename?: "ShinePortfolio"
  siteRefs: Array<ShineSiteRef>
  stats?: Maybe<ShineStats>
  status: ShineStatus
  units: Array<ShineUnit>
}

export type ShinePortfolioUnitsArgs = {
  duration: ShineDuration
}

export type ShineSite = {
  __typename?: "ShineSite"
  stats?: Maybe<ShineStats>
  status: ShineStatus
  units: Array<ShineUnit>
}

export type ShineSiteUnitsArgs = {
  duration: ShineDuration
}

export type ShineSiteRef = {
  __typename?: "ShineSiteRef"
  lat: Scalars["Float"]["output"]
  lon: Scalars["Float"]["output"]
  monthlyGrossRevenue: Scalars["Float"]["output"]
  pid: Scalars["String"]["output"]
  status: ShineStatus
}

export type ShineStats = {
  __typename?: "ShineStats"
  numProperties: Scalars["Int"]["output"]
  pvKwInstalled: Scalars["Float"]["output"]
  totalCo2ReducedTonnes: Scalars["Float"]["output"]
  totalGrossRevenue: Scalars["Float"]["output"]
  totalPvProductionKwh: Scalars["Float"]["output"]
}

export enum ShineStatus {
  NotSoShiny = "NOT_SO_SHINY",
  Shiny = "SHINY",
}

/** Aggregated statistics for a Shine site or portfolio over a given time period starting from the Commercial Operation Date. */
export type ShineUnit = {
  __typename?: "ShineUnit"
  actualGrossRevenue: Scalars["Float"]["output"]
  actualPvProductionKwh: Scalars["Float"]["output"]
  co2EmissionsReductionTonnes: Scalars["Float"]["output"]
  duration: ShineDuration
  expectedGrossRevenue: Scalars["Float"]["output"]
  expectedPvProductionKwh: Scalars["Float"]["output"]
  start: Scalars["Date"]["output"]
}

export type Site = {
  __typename?: "Site"
  activeMeters?: Maybe<MeterSet>
  activeResults: Array<Result>
  attachment: Attachment
  attachments: Array<Attachment>
  bauMeters: Array<BauMeter>
  billSuggestions: Array<BillSuggestion>
  buildingClass?: Maybe<Scalars["String"]["output"]>
  buildingData?: Maybe<BuildingData>
  buildingFootprintCount?: Maybe<Scalars["Int"]["output"]>
  buildingFootprintNeedsReview: Scalars["Boolean"]["output"]
  buildingFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  buildingType: Scalars["String"]["output"]
  capRate?: Maybe<Scalars["Float"]["output"]>
  carportMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  cbsaId?: Maybe<Scalars["String"]["output"]>
  cbsaName?: Maybe<Scalars["String"]["output"]>
  changelog: SiteChangelog
  city: Scalars["String"]["output"]
  cleanMeters: CleanMeterQuery
  closestSites: Array<RevampSite>
  computedCarportMaxPvKw: Scalars["Float"]["output"]
  computedGroundMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  computedRoofMaxPvKw: Scalars["Float"]["output"]
  conserviceSearch: Array<ConserviceSearch>
  costarPropertyType?: Maybe<CoStarPropertyType>
  costarSecondaryType?: Maybe<CoStarSecondaryType>
  county: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  currentPolicyChecks: Array<PolicyCheck>
  currentStatus?: Maybe<SiteStatusChange>
  customTariffs: Array<CustomTariff>
  customerId?: Maybe<Scalars["String"]["output"]>
  dateTargetUtilitySet?: Maybe<Scalars["DateTime"]["output"]>
  displayName?: Maybe<Scalars["String"]["output"]>
  documentsV0: Array<Document>
  doeReferenceType?: Maybe<BuildingType>
  espm?: Maybe<EspmProperty>
  etbReport?: Maybe<EtbReport>
  etbReports: Array<EtbReport>
  etbScenarioOptions: Array<EtbScenarioRef>
  evCalc?: Maybe<EvCalc>
  existingSolarDetectionScore?: Maybe<Scalars["Int"]["output"]>
  explainCarportHeuristic: Scalars["String"]["output"]
  explainCarportParkingSpaceHeuristic: Scalars["String"]["output"]
  explainGroundHeuristic: Scalars["String"]["output"]
  explainRoofHeuristic: Scalars["String"]["output"]
  explainSlopedHeuristic: Scalars["String"]["output"]
  failures: Array<BuildingFootprintFailureFinmodelFailureGuessTariffFailureLoadEstimateFailureParcelDataFailure>
  finmodel: RevampFinmodel
  finmodelTable: FinmodelTable
  footprint: Footprint
  fullAddress: Scalars["String"]["output"]
  groundAvailableSqft?: Maybe<Scalars["Float"]["output"]>
  groundMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  hasIntervalDownload: Scalars["Boolean"]["output"]
  hasRoofImage: Scalars["Boolean"]["output"]
  helioscopes: Array<Helioscope>
  hiddenFromCustomers: Scalars["Boolean"]["output"]
  hideFakePanels: Scalars["Boolean"]["output"]
  id: Scalars["Int"]["output"]
  impliedCarportLinearFt?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  impliedUsableRoofSqftExplanation: RoofSqftExplanation
  incentives: GeographicIncentives
  includeStorage: Scalars["Boolean"]["output"]
  isBehindTheMeter?: Maybe<Scalars["Boolean"]["output"]>
  isEnergyCommunity: Scalars["Boolean"]["output"]
  isFavorite?: Maybe<Scalars["Boolean"]["output"]>
  isLowIncomeCommunity?: Maybe<Scalars["Boolean"]["output"]>
  isMultifamily: Scalars["Boolean"]["output"]
  labels: Array<SiteLabel>
  latitude: Scalars["Float"]["output"]
  leaseType?: Maybe<LeaseType>
  longitude: Scalars["Float"]["output"]
  lux: Lux
  mappedDoeReferenceType: Scalars["String"]["output"]
  meterSet: MeterSet
  metering?: Maybe<Metering>
  meteringSetBy?: Maybe<UserRef>
  meteringSetDate?: Maybe<Scalars["DateTime"]["output"]>
  mortgageLender?: Maybe<Scalars["String"]["output"]>
  notes: Array<AdminNote>
  numParkingSpaces?: Maybe<Scalars["Int"]["output"]>
  numStories?: Maybe<Scalars["Int"]["output"]>
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
  numberOfBuildings?: Maybe<Scalars["Float"]["output"]>
  occupancyRate?: Maybe<Scalars["Float"]["output"]>
  occupancyType?: Maybe<BuildingOccupancyType>
  orgSlug?: Maybe<Scalars["String"]["output"]>
  overrides: Array<FinmodelInputOverride>
  parcelFootprintSqft?: Maybe<Scalars["Float"]["output"]>
  physicalCheck: PhysicalCheck
  pid: Scalars["String"]["output"]
  policies: Array<Policy>
  policyViolations: Array<PolicyViolation>
  portfolio?: Maybe<AdminPortfolio>
  possibleTariffs: Array<Tariff>
  previewBuildingFootprints: FootprintError
  primaryScenario?: Maybe<AdminScenario>
  probableUtilities: Array<Utility>
  propertyName?: Maybe<Scalars["String"]["output"]>
  result: Result
  resultConfig: Array<ResultConfig>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofImage?: Maybe<Attachment>
  roofKeepoutsSqft?: Maybe<Scalars["Float"]["output"]>
  roofMaxKw?: Maybe<Scalars["Float"]["output"]>
  roofMaxPvKw?: Maybe<Scalars["Float"]["output"]>
  roofObstructionsSqft?: Maybe<Scalars["Float"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofSqft?: Maybe<Scalars["Float"]["output"]>
  roofUsableSqft?: Maybe<Scalars["Float"]["output"]>
  scenario?: Maybe<AdminScenario>
  scenarios: Array<AdminScenario>
  setbackRoofSqft?: Maybe<Scalars["Float"]["output"]>
  shine: ShineSite
  slopedRoof?: Maybe<Scalars["Boolean"]["output"]>
  solarLocation?: Maybe<SolarLocation>
  sqft?: Maybe<Scalars["Float"]["output"]>
  state: Scalars["String"]["output"]
  staticMapUrl: Scalars["String"]["output"]
  status?: Maybe<SiteStatus>
  statusCheck: Array<StatusCheck>
  statusCheckPassed: Scalars["Boolean"]["output"]
  statusDisplayText?: Maybe<Scalars["String"]["output"]>
  streetAddress: Scalars["String"]["output"]
  targetUtility: Utility
  targetUtilitySetBy?: Maybe<UserRef>
  tariffDetail: TariffDetails
  thirdPartySupplier?: Maybe<ThirdPartySupplier>
  timeZone: Scalars["String"]["output"]
  todos: Array<TodoItem>
  usableCarportFt?: Maybe<Scalars["Float"]["output"]>
  usableRoofPct?: Maybe<Scalars["Float"]["output"]>
  usableRoofSqft?: Maybe<Scalars["Float"]["output"]>
  usingBillingMeters?: Maybe<Scalars["DateTime"]["output"]>
  utilityByLabel?: Maybe<Utility>
  utilityName?: Maybe<Scalars["String"]["output"]>
  visuals: SiteVisuals
  yearBuilt?: Maybe<Scalars["Int"]["output"]>
  zipCode: Scalars["String"]["output"]
}

export type SiteAttachmentArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteChangelogArgs = {
  fields: Array<SiteChangelogColumn>
}

export type SiteClosestSitesArgs = {
  num?: Scalars["Int"]["input"]
  withinFt?: Scalars["Int"]["input"]
}

export type SiteConserviceSearchArgs = {
  onlyHouse: Scalars["Boolean"]["input"]
}

export type SiteEtbReportArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteFinmodelArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteLuxArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteMeterSetArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteNotesArgs = {
  hiddenFromCustomers?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SitePossibleTariffsArgs = {
  includeCustom?: Scalars["Boolean"]["input"]
  includeUnpreferred?: Scalars["Boolean"]["input"]
  loadCategory?: InputMaybe<LoadCategory>
  preferred?: Scalars["Boolean"]["input"]
}

export type SitePreviewBuildingFootprintsArgs = {
  strategy: FootprintStrategy
}

export type SiteResultArgs = {
  id: Scalars["Int"]["input"]
}

export type SiteScenarioArgs = {
  pid: Scalars["String"]["input"]
}

export type SiteTariffDetailArgs = {
  tariffParentId: Scalars["Int"]["input"]
}

export type SiteUtilityByLabelArgs = {
  label: Scalars["String"]["input"]
}

export type SiteBidsTable = {
  __typename?: "SiteBidsTable"
  rows: Array<SiteBidsTableRow>
  view: SiteBidsTableView
}

export type SiteBidsTableRowsArgs = {
  keys: Array<Scalars["Int"]["input"]>
}

export type SiteBidsTableViewArgs = {
  filterBy?: InputMaybe<SiteBidsTableFilter>
  sortBy?: InputMaybe<Array<SiteBidsTableSort>>
}

export enum SiteBidsTableAttr {
  BiddingClosedAt = "BIDDING_CLOSED_AT",
  BiddingOpenAt = "BIDDING_OPEN_AT",
  BidPackageName = "BID_PACKAGE_NAME",
  BidPackagePid = "BID_PACKAGE_PID",
  BuildingOwnerExtraPaymentsUsd = "BUILDING_OWNER_EXTRA_PAYMENTS_USD",
  BuildingOwnerNoiLifetimeUsd = "BUILDING_OWNER_NOI_LIFETIME_USD",
  BundlePid = "BUNDLE_PID",
  CsEstimatedAwardDate = "CS_ESTIMATED_AWARD_DATE",
  EstimatedCod = "ESTIMATED_COD",
  EstimatedNtp = "ESTIMATED_NTP",
  ExtraPaymentsNotes = "EXTRA_PAYMENTS_NOTES",
  FinproductType = "FINPRODUCT_TYPE",
  IncentivesNotes = "INCENTIVES_NOTES",
  InterconnectionCostNonUtilityUsd = "INTERCONNECTION_COST_NON_UTILITY_USD",
  InterconnectionCostUsdPerWatt = "INTERCONNECTION_COST_USD_PER_WATT",
  InterconnectionCostUtilityMaxUsd = "INTERCONNECTION_COST_UTILITY_MAX_USD",
  InterconnectionCostUtilityMinUsd = "INTERCONNECTION_COST_UTILITY_MIN_USD",
  InterconnectionNotes = "INTERCONNECTION_NOTES",
  IsAwarded = "IS_AWARDED",
  IsCustom = "IS_CUSTOM",
  ItcPercentageAssumption = "ITC_PERCENTAGE_ASSUMPTION",
  Name = "NAME",
  OtherNotes = "OTHER_NOTES",
  PackageRowClosedAt = "PACKAGE_ROW_CLOSED_AT",
  PackageRowCloseCustomReason = "PACKAGE_ROW_CLOSE_CUSTOM_REASON",
  PackageRowCloseReason = "PACKAGE_ROW_CLOSE_REASON",
  PackageRowIsClosed = "PACKAGE_ROW_IS_CLOSED",
  PackageRowStatus = "PACKAGE_ROW_STATUS",
  PvSizeKwAc = "PV_SIZE_KW_AC",
  PvSizeKwDc = "PV_SIZE_KW_DC",
  PvTypes = "PV_TYPES",
  RecOwner = "REC_OWNER",
  RoofRentEscalator = "ROOF_RENT_ESCALATOR",
  RoofRentY1Usd = "ROOF_RENT_Y1_USD",
  TermYears = "TERM_YEARS",
}

export type SiteBidsTableFilter = {
  bidPackageName?: InputMaybe<StringPred>
  bidPackagePid?: InputMaybe<StringPred>
  biddingClosedAt?: InputMaybe<DatePred>
  biddingOpenAt?: InputMaybe<DatePred>
  buildingOwnerNoiLifetimeUsd?: InputMaybe<FloatPred>
  bundlePid?: InputMaybe<StringPred>
  csEstimatedAwardDate?: InputMaybe<DatePred>
  estimatedCod?: InputMaybe<DatePred>
  estimatedNtp?: InputMaybe<DatePred>
  finproductType?: InputMaybe<FinProductTypePred>
  id?: InputMaybe<StringPred>
  interconnectionCostNonUtilityUsd?: InputMaybe<FloatPred>
  interconnectionCostUsdPerWatt?: InputMaybe<FloatPred>
  interconnectionCostUtilityMaxUsd?: InputMaybe<FloatPred>
  interconnectionCostUtilityMinUsd?: InputMaybe<FloatPred>
  isAwarded?: InputMaybe<BoolPred>
  isCustom?: InputMaybe<BoolPred>
  itcPercentageAssumption?: InputMaybe<FloatPred>
  name?: InputMaybe<StringPred>
  packageRowClosedAt?: InputMaybe<DatePred>
  packageRowIsClosed?: InputMaybe<BoolPred>
  packageRowStatus?: InputMaybe<PackageRowStatusPred>
  pvSizeKwAc?: InputMaybe<FloatPred>
  pvSizeKwDc?: InputMaybe<FloatPred>
  roofRentEscalator?: InputMaybe<FloatPred>
  roofRentY1Usd?: InputMaybe<FloatPred>
  termYears?: InputMaybe<FloatPred>
}

export type SiteBidsTableRow = {
  __typename?: "SiteBidsTableRow"
  bidPackageName: Scalars["String"]["output"]
  bidPackagePid: Scalars["String"]["output"]
  biddingClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  biddingOpenAt?: Maybe<Scalars["DateTime"]["output"]>
  buildingOwnerExtraPaymentsUsd?: Maybe<Array<Scalars["Float"]["output"]>>
  buildingOwnerNoiLifetimeUsd?: Maybe<Scalars["Float"]["output"]>
  bundlePid: Scalars["String"]["output"]
  csEstimatedAwardDate?: Maybe<Scalars["DateTime"]["output"]>
  estimatedCod: Scalars["Date"]["output"]
  estimatedNtp: Scalars["Date"]["output"]
  extraPaymentsNotes?: Maybe<Scalars["String"]["output"]>
  finproductType: FinProductType
  id: Scalars["Int"]["output"]
  incentivesNotes?: Maybe<Scalars["String"]["output"]>
  interconnectionCostNonUtilityUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUsdPerWatt?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMaxUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionCostUtilityMinUsd?: Maybe<Scalars["Float"]["output"]>
  interconnectionNotes?: Maybe<Scalars["String"]["output"]>
  isAwarded: Scalars["Boolean"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  itcPercentageAssumption: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  otherNotes?: Maybe<Scalars["String"]["output"]>
  packageRowCloseCustomReason?: Maybe<Scalars["String"]["output"]>
  packageRowCloseReason?: Maybe<PackageRowCloseReason>
  packageRowClosedAt?: Maybe<Scalars["DateTime"]["output"]>
  packageRowIsClosed: Scalars["Boolean"]["output"]
  packageRowStatus?: Maybe<PackageRowStatus>
  pvSizeKwAc?: Maybe<Scalars["Float"]["output"]>
  pvSizeKwDc?: Maybe<Scalars["Float"]["output"]>
  pvTypes: Array<PvType>
  recOwner: RecOwner
  roofRentEscalator?: Maybe<Scalars["Float"]["output"]>
  roofRentY1Usd?: Maybe<Scalars["Float"]["output"]>
  termYears?: Maybe<Scalars["Int"]["output"]>
}

export type SiteBidsTableSort = {
  attr: SiteBidsTableAttr
  order: SortOrder
}

export type SiteBidsTableView = {
  __typename?: "SiteBidsTableView"
  count: Scalars["Int"]["output"]
  keys: Array<Scalars["Int"]["output"]>
}

export type SiteChangelog = {
  __typename?: "SiteChangelog"
  all: Array<SiteChangelogColumnBaseWrapper>
}

export enum SiteChangelogColumn {
  Tsvector2 = "Tsvector2",
  Ab802GuessedAt = "ab802GuessedAt",
  AddressSha256 = "addressSha256",
  AllowableSolarLocations = "allowableSolarLocations",
  AllowableSolarLocationsOther = "allowableSolarLocationsOther",
  AssetManager = "assetManager",
  BiddingConfigId = "biddingConfigId",
  BuildingClass = "buildingClass",
  BuildingDataId = "buildingDataId",
  BuildingFootprintCount = "buildingFootprintCount",
  BuildingFootprintSetbackSqft = "buildingFootprintSetbackSqft",
  BuildingFootprintSetbackStr = "buildingFootprintSetbackStr",
  BuildingFootprintSetbackStrUpdatedAt = "buildingFootprintSetbackStrUpdatedAt",
  BuildingFootprintSetbackStrUpdatedByUserId = "buildingFootprintSetbackStrUpdatedByUserId",
  BuildingFootprintSqft = "buildingFootprintSqft",
  BuildingFootprintUpdatedAt = "buildingFootprintUpdatedAt",
  BuildingFootprintUpdatedByUserId = "buildingFootprintUpdatedByUserId",
  CapRate = "capRate",
  CapRateUpdatedAt = "capRateUpdatedAt",
  CarportFootprintFt = "carportFootprintFt",
  CarportFootprintStr = "carportFootprintStr",
  CarportFootprintStrUpdatedAt = "carportFootprintStrUpdatedAt",
  CarportFootprintUpdatedByUserId = "carportFootprintUpdatedByUserId",
  CarportMaxPvKw = "carportMaxPvKw",
  CarportMaxPvKwDateUpdated = "carportMaxPvKwDateUpdated",
  CarportMaxPvKwUserIdUpdated = "carportMaxPvKwUserIdUpdated",
  CbsaId = "cbsaId",
  CbsaName = "cbsaName",
  City = "city",
  CostarPropertyType = "costarPropertyType",
  CostarSecondaryType = "costarSecondaryType",
  County = "county",
  CreatedByUserId = "createdByUserId",
  CurrentStatusId = "currentStatusId",
  CustomerId = "customerId",
  DateCreated = "dateCreated",
  DateDoeReferenceTypeUpdated = "dateDoeReferenceTypeUpdated",
  DateMeteringUpdated = "dateMeteringUpdated",
  DateTargetUtilitySet = "dateTargetUtilitySet",
  DoeReferenceType = "doeReferenceType",
  DoeReferenceTypeUpdatedByUserId = "doeReferenceTypeUpdatedByUserId",
  EnergyThingsId = "energyThingsId",
  EvCalcId = "evCalcId",
  EvOverridesId = "evOverridesId",
  ExistingSolarDetectionScore = "existingSolarDetectionScore",
  FinalKeepoutsFootprintSqft = "finalKeepoutsFootprintSqft",
  FinancingThingsId = "financingThingsId",
  FinmodelDepsUpdatedAt = "finmodelDepsUpdatedAt",
  FinmodelInputOverridesUpdatedAt = "finmodelInputOverridesUpdatedAt",
  FinmodelVersion = "finmodelVersion",
  FinmodelVersionNum = "finmodelVersionNum",
  FinmodelVersionSetAt = "finmodelVersionSetAt",
  FinmodelVersionSetByUserId = "finmodelVersionSetByUserId",
  FlagSummaryId = "flagSummaryId",
  FootprintStr = "footprintStr",
  GeocodeResponseId = "geocodeResponseId",
  GroundAvailableSqft = "groundAvailableSqft",
  GroundAvailableSqftDateUpdated = "groundAvailableSqftDateUpdated",
  GroundAvailableSqftUserIdUpdated = "groundAvailableSqftUserIdUpdated",
  GroundMaxPvKw = "groundMaxPvKw",
  GroundMaxPvKwDateUpdated = "groundMaxPvKwDateUpdated",
  GroundMaxPvKwUserIdUpdated = "groundMaxPvKwUserIdUpdated",
  GroundmountFootprintSqft = "groundmountFootprintSqft",
  GroundmountFootprintStr = "groundmountFootprintStr",
  GroundmountFootprintStrUpdatedAt = "groundmountFootprintStrUpdatedAt",
  GroundmountFootprintUpdatedByUserId = "groundmountFootprintUpdatedByUserId",
  HiddenFromCustomers = "hiddenFromCustomers",
  HideFakePanels = "hideFakePanels",
  Id = "id",
  IsBehindTheMeter = "isBehindTheMeter",
  IsMultifamily = "isMultifamily",
  KeepoutsFootprintSqft = "keepoutsFootprintSqft",
  KeepoutsFootprintStr = "keepoutsFootprintStr",
  KeepoutsFootprintStrUpdatedAt = "keepoutsFootprintStrUpdatedAt",
  KeepoutsFootprintUpdatedByUserId = "keepoutsFootprintUpdatedByUserId",
  Latitude = "latitude",
  LeaseType = "leaseType",
  LeaseTypeUpdatedAt = "leaseTypeUpdatedAt",
  Longitude = "longitude",
  Metering = "metering",
  MeteringUpdatedByUserId = "meteringUpdatedByUserId",
  MetersId = "metersId",
  MetersUpdatedAt = "metersUpdatedAt",
  MortgageLender = "mortgageLender",
  Name = "name_",
  NumParkingSpaces = "numParkingSpaces",
  NumStories = "numStories",
  OccupancyPct = "occupancyPct",
  OccupancyType = "occupancyType",
  OccupancyTypeUpdatedAt = "occupancyTypeUpdatedAt",
  ParcelFootprintSqft = "parcelFootprintSqft",
  ParcelFootprintStr = "parcelFootprintStr",
  ParcelFootprintStrUpdatedAt = "parcelFootprintStrUpdatedAt",
  ParcelFootprintUpdatedByUserId = "parcelFootprintUpdatedByUserId",
  ParentSiteId = "parentSiteId",
  PhysicalCheckId = "physicalCheckId",
  PhysicalCheckUpdatedAt = "physicalCheckUpdatedAt",
  Pid = "pid",
  PortfolioId = "portfolioId",
  PortfolioUpdatedAt = "portfolioUpdatedAt",
  PpaOfftaker = "ppaOfftaker",
  PpaSignatory = "ppaSignatory",
  PrimaryScenarioId = "primaryScenarioId",
  PrimaryScenarioSetById = "primaryScenarioSetById",
  ProcessedObstructionsSqft = "processedObstructionsSqft",
  ProcessedObstructionsStr = "processedObstructionsStr",
  ProcessedObstructionsUpdatedAt = "processedObstructionsUpdatedAt",
  PvwattsUpdatedAt = "pvwattsUpdatedAt",
  ResultGridId = "resultGridId",
  RofoSigned = "rofoSigned",
  RoofImageId = "roofImageId",
  RoofMaxPvKw = "roofMaxPvKw",
  RoofMaxPvKwDateUpdated = "roofMaxPvKwDateUpdated",
  RoofMaxPvKwUserIdUpdated = "roofMaxPvKwUserIdUpdated",
  RoofSqft = "roofSqft",
  RoofSqftUpdatedAt = "roofSqftUpdatedAt",
  SelectedConfigId = "selectedConfigId",
  SiteDataOrigin = "siteDataOrigin",
  SiteDetailsId = "siteDetailsId",
  SlopedRoof = "slopedRoof",
  SlopedRoofUpdatedAt = "slopedRoofUpdatedAt",
  SlopedRoofUpdatedByUserId = "slopedRoofUpdatedByUserId",
  Sqft = "sqft",
  SqftUpdatedAt = "sqftUpdatedAt",
  State = "state",
  StreetAddress = "streetAddress",
  TargetUtilityId = "targetUtilityId",
  TargetUtilitySetByUserId = "targetUtilitySetByUserId",
  TenantInterest = "tenantInterest",
  TenantLeaseEnds = "tenantLeaseEnds",
  TenantLeaseTerm = "tenantLeaseTerm",
  ThirdPartySupplierId = "thirdPartySupplierId",
  ThirdPartySupplierSetByUserId = "thirdPartySupplierSetByUserId",
  TimeZone = "timeZone",
  UsableCarportFt = "usableCarportFt",
  UsableCarportFtUpdatedAt = "usableCarportFtUpdatedAt",
  UsableCarportFtUpdatedByUserId = "usableCarportFtUpdatedByUserId",
  UsableRoofPct = "usableRoofPct",
  UsableRoofPctUpdatedAt = "usableRoofPctUpdatedAt",
  UsableRoofPctUpdatedByUserId = "usableRoofPctUpdatedByUserId",
  UsableRoofSqft = "usableRoofSqft",
  UsableRoofSqftUpdatedAt = "usableRoofSqftUpdatedAt",
  UsableRoofSqftUpdatedByUserId = "usableRoofSqftUpdatedByUserId",
  UsingBillingMeters = "usingBillingMeters",
  YearBuilt = "yearBuilt",
  ZipCode = "zipCode",
  ZipCodeUpdatedAt = "zipCodeUpdatedAt",
}

export type SiteChangelogColumnBaseWrapper = {
  __typename?: "SiteChangelogColumnBaseWrapper"
  column: SiteChangelogColumn
  obj?: Maybe<Changelog>
}

export type SiteConfig = {
  __typename?: "SiteConfig"
  createdAt?: Maybe<Scalars["DateTime"]["output"]>
  createdBy?: Maybe<UserRef>
  financing: RevampFinancing
  scenario: RevampScenario
}

export type SiteConfigMutations = {
  __typename?: "SiteConfigMutations"
  updateSelectedConfig?: Maybe<Scalars["Void"]["output"]>
}

export type SiteConfigMutationsUpdateSelectedConfigArgs = {
  finproductId: Scalars["Int"]["input"]
  scenarioPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteDataInput = {
  assetManager?: InputMaybe<StringInput>
  buildingType?: InputMaybe<BuildingTypeInput>
  carportMaxPvKw?: InputMaybe<FloatInput>
  county?: InputMaybe<StringInput>
  customerId?: InputMaybe<StringInput>
  groundAvailableSqft?: InputMaybe<FloatInput>
  groundMaxPvKw?: InputMaybe<FloatInput>
  lastSalePrice?: InputMaybe<FloatInput>
  leaseType?: InputMaybe<LeaseTypeInput>
  metering?: InputMaybe<MeteringInput>
  mortgageLender?: InputMaybe<StringInput>
  name?: InputMaybe<StringInput>
  numParkingSpaces?: InputMaybe<IntInput>
  numStories?: InputMaybe<IntInput>
  occupancyType?: InputMaybe<BuildingOccupancyTypeInput>
  parentCompany?: InputMaybe<StringInput>
  ppaOfftaker?: InputMaybe<PpaOfftakerInput>
  ppaSignatory?: InputMaybe<StringInput>
  roofCondition?: InputMaybe<StringInput>
  roofMaxPvKw?: InputMaybe<FloatInput>
  roofReplacedYr?: InputMaybe<IntInput>
  roofSqft?: InputMaybe<FloatInput>
  salePlannedYear?: InputMaybe<IntInput>
  salePlans?: InputMaybe<YesNoUnsureInput>
  slopedRoof?: InputMaybe<YesNoUnsureInput>
  sqft?: InputMaybe<FloatInput>
  targetUtilityPid?: InputMaybe<StringInput>
  tenantInterest?: InputMaybe<YesNoUnsureInput>
  tenantLeaseEnds?: InputMaybe<DateInput>
  tenantLeaseTerm?: InputMaybe<StringInput>
  thirdPartySupplierPid?: InputMaybe<StringInput>
  totalBuildings?: InputMaybe<IntInput>
  usableRoofPct?: InputMaybe<FloatInput>
  yearBuilt?: InputMaybe<IntInput>
  yearRenovated?: InputMaybe<IntInput>
}

export type SiteDetails = {
  __typename?: "SiteDetails"
  buildingLegalName?: Maybe<Scalars["String"]["output"]>
  constructionEmail?: Maybe<Scalars["String"]["output"]>
  counselApproval?: Maybe<CounselApproval>
  createdAt: Scalars["DateTime"]["output"]
  externalLeaseApprovers?: Maybe<Array<Scalars["String"]["output"]>>
  fieldHistory?: Maybe<SiteDetailsFieldChangeLog>
  id: Scalars["Int"]["output"]
  isFannieMaeLender?: Maybe<Scalars["Boolean"]["output"]>
  isFmGlobalInsurer?: Maybe<Scalars["Boolean"]["output"]>
  lastEditedBy?: Maybe<UserRef>
  leaseApprovers: Array<Scalars["String"]["output"]>
  leaseLegalOwnerName?: Maybe<Scalars["String"]["output"]>
  leasePropertyLegalDescription?: Maybe<Scalars["String"]["output"]>
  leaseSignatory?: Maybe<Scalars["String"]["output"]>
  needsTenantApproval?: Maybe<Scalars["Boolean"]["output"]>
  propertyFundName?: Maybe<Scalars["String"]["output"]>
  propertyInsurer?: Maybe<Scalars["String"]["output"]>
  propertyLenders?: Maybe<Scalars["String"]["output"]>
  propertySiteVisitContacts?: Maybe<Array<Scalars["String"]["output"]>>
  roofCondition?: Maybe<Scalars["String"]["output"]>
  roofReplacedYr?: Maybe<Scalars["Int"]["output"]>
  roofRightsHolder?: Maybe<RoofRightsHolder>
  salePlannedYear?: Maybe<Scalars["Int"]["output"]>
  salePlans?: Maybe<Scalars["String"]["output"]>
  signatureBlocks?: Maybe<Array<Scalars["String"]["output"]>>
}

export type SiteDetailsFieldChangeLog = {
  __typename?: "SiteDetailsFieldChangeLog"
  buildingLegalName: FieldChangeLogHistory
  constructionEmail: FieldChangeLogHistory
  counselApproval: FieldChangeLogHistory
  externalLeaseApprovers: FieldChangeLogHistory
  isFannieMaeLender: FieldChangeLogHistory
  isFmGlobalInsurer: FieldChangeLogHistory
  leaseApprovers: FieldChangeLogHistory
  leaseLegalOwnerName: FieldChangeLogHistory
  leasePropertyLegalDescription: FieldChangeLogHistory
  leaseSignatory: FieldChangeLogHistory
  needsTenantApproval: FieldChangeLogHistory
  propertyFundName: FieldChangeLogHistory
  propertyInsurer: FieldChangeLogHistory
  propertyLenders: FieldChangeLogHistory
  propertySiteVisitContacts: FieldChangeLogHistory
  roofCondition: FieldChangeLogHistory
  roofReplacedYr: FieldChangeLogHistory
  roofRightsHolder: FieldChangeLogHistory
  salePlannedYear: FieldChangeLogHistory
  salePlans: FieldChangeLogHistory
  signatureBlocks: FieldChangeLogHistory
}

export type SiteDetailsMutations = {
  __typename?: "SiteDetailsMutations"
  updateDetails?: Maybe<Scalars["Void"]["output"]>
}

export type SiteDetailsMutationsUpdateDetailsArgs = {
  input: UpdateDetailsInput
  sourceId?: InputMaybe<Scalars["String"]["input"]>
  sourceType?: InputMaybe<ChangeSourceType>
}

export type SiteDocuments = {
  __typename?: "SiteDocuments"
  documents: Array<Document>
  sitePid: Scalars["String"]["output"]
}

export type SiteFieldChangeLog = {
  __typename?: "SiteFieldChangeLog"
  leaseType: FieldChangeLogHistory
  occupancyType: FieldChangeLogHistory
  targetUtilityId: FieldChangeLogHistory
  tenantLeaseTerm: FieldChangeLogHistory
}

export type SiteFlag = {
  __typename?: "SiteFlag"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  resolvedAt?: Maybe<Scalars["DateTime"]["output"]>
  site: SiteRef
  type: SiteFlagType
}

export type SiteFlagMutations = {
  __typename?: "SiteFlagMutations"
  resolveSiteFlag?: Maybe<Error>
}

export type SiteFlagMutationsResolveSiteFlagArgs = {
  flagType: SiteFlagType
  sitePid: Scalars["String"]["input"]
}

export type SiteFlagSummary = {
  __typename?: "SiteFlagSummary"
  duplicateAddressFound?: Maybe<Scalars["Boolean"]["output"]>
  existingSolarLikely?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  improbableEnergyCosts?: Maybe<Scalars["Boolean"]["output"]>
  tariffNotFound?: Maybe<Scalars["Boolean"]["output"]>
  utilityNotFound?: Maybe<Scalars["Boolean"]["output"]>
}

export type SiteFlagSummaryPred = {
  value: Array<SiteFlagType>
}

export enum SiteFlagType {
  DuplicateAddressFound = "DUPLICATE_ADDRESS_FOUND",
  ExistingSolarLikely = "EXISTING_SOLAR_LIKELY",
  ImprobableEnergyCosts = "IMPROBABLE_ENERGY_COSTS",
  TariffNotFound = "TARIFF_NOT_FOUND",
  UtilityNotFound = "UTILITY_NOT_FOUND",
}

export type SiteGeojsonShapes = {
  carport?: InputMaybe<Scalars["String"]["input"]>
  groundmount?: InputMaybe<Scalars["String"]["input"]>
  keepouts?: InputMaybe<Scalars["String"]["input"]>
  parcel?: InputMaybe<Scalars["String"]["input"]>
  roof?: InputMaybe<Scalars["String"]["input"]>
  roofSetbackFt?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteLabel = {
  __typename?: "SiteLabel"
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  description: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
  perms: SiteLabelPerms
  pid: Scalars["String"]["output"]
  sites: Array<Scalars["String"]["output"]>
  themeColor: LabelColor
}

export type SiteLabelNamesPred = {
  value: Array<Scalars["String"]["input"]>
}

export type SiteLabelPerms = {
  __typename?: "SiteLabelPerms"
  canAdd: Scalars["Boolean"]["output"]
  canRemove: Scalars["Boolean"]["output"]
}

export type SiteMutations = {
  __typename?: "SiteMutations"
  addEtb: Site
  addHelioscope: Helioscope
  addScenario: AddScenarioResponse
  attachFile: AttachFileResponse
  clearDrawings?: Maybe<Scalars["Void"]["output"]>
  deleteBuildingFootprint: Site
  deleteParcelFootprint: Site
  findBuildingFootprints?: Maybe<Scalars["Void"]["output"]>
  labels: AdminSiteLabelMutations
  linkConserviceAddresses?: Maybe<Error>
  new: Site
  newEvCalc: EvCalc
  revertToEstimates?: Maybe<Scalars["Void"]["output"]>
  setBadRoof: Site
  setBauMeterLabel: Site
  setBauMeterTariff: Site
  setBuildingClass?: Maybe<Scalars["Void"]["output"]>
  setCapRate: Site
  setCarportMaxPvKw: Site
  setCostarPropertyType: Site
  setCostarSecondaryType: Site
  setCustomerId?: Maybe<Scalars["Void"]["output"]>
  setDoeReferenceType: Site
  setExistingSolar: Site
  setGroundAvailableSqft: Site
  setGroundMaxPvKw: Site
  setHelioscopeAllocation?: Maybe<Scalars["Void"]["output"]>
  setLatitude?: Maybe<Scalars["Void"]["output"]>
  setLeaseType?: Maybe<Scalars["Void"]["output"]>
  setLongitude?: Maybe<Scalars["Void"]["output"]>
  setMetering?: Maybe<Scalars["Void"]["output"]>
  setNumParkingSpaces: Site
  setNumStories: Site
  setOccupancyType?: Maybe<Scalars["Void"]["output"]>
  setPortfolio: Site
  setRoofImage: Site
  setRoofMaxPvKw: Site
  setRoofSqft: Site
  setSiteHiddenFromCustomers: Site
  setSlopedRoof: Site
  setSqft: Site
  setStatus: Site
  setTargetUtility: Site
  setThirdPartySupplier: Site
  setUnobstructedFlatRoof: Site
  setUnobstructedFlatRoofSqft: Site
  setUsableCarportFt: Site
  setUsableRoofPct: Site
  setUsableRoofSqft: Site
  setYearBuilt: Site
  setZipCode: Site
  toggleFinproduct?: Maybe<Scalars["Void"]["output"]>
  toggleHideFakePanels?: Maybe<Scalars["Void"]["output"]>
  trashAttachment: Site
  trashHelioscope: Site
  turnOffBillingMeters?: Maybe<Scalars["Void"]["output"]>
  /** @deprecated to be replaced by uploadHelioscope */
  uploadHelioscopePdf: UploadHelioscopePdfResponse
}

export type SiteMutationsAddEtbArgs = {
  carportPvKw?: InputMaybe<Scalars["Float"]["input"]>
  loadOrigin: LoadOrigin
  makeActive: Scalars["Boolean"]["input"]
  roofPvKw?: InputMaybe<Scalars["Float"]["input"]>
  scenarioPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}

export type SiteMutationsAddHelioscopeArgs = {
  carportIsMax: Scalars["Boolean"]["input"]
  carportPvSixHighKw: Scalars["Float"]["input"]
  carportPvThreeHighKw: Scalars["Float"]["input"]
  groundPvKw: Scalars["Float"]["input"]
  pdfId: Scalars["Int"]["input"]
  productionCsvId: Scalars["Int"]["input"]
  roofImageId: Scalars["Int"]["input"]
  roofIsMax: Scalars["Boolean"]["input"]
  roofPvKw: Scalars["Float"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsAddScenarioArgs = {
  includeStorage: Scalars["Boolean"]["input"]
  loadCategory: LoadCategory
  name?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
  solarLocation: SolarLocation
}

export type SiteMutationsAttachFileArgs = {
  pid: Scalars["String"]["input"]
  tag?: InputMaybe<Scalars["String"]["input"]>
  upload: Scalars["Upload"]["input"]
}

export type SiteMutationsClearDrawingsArgs = {
  input: ClearDrawingsInput
}

export type SiteMutationsDeleteBuildingFootprintArgs = {
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsDeleteParcelFootprintArgs = {
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsFindBuildingFootprintsArgs = {
  sitePid: Scalars["String"]["input"]
  strategy: FootprintStrategy
}

export type SiteMutationsLinkConserviceAddressesArgs = {
  conserviceAddresses: Array<Scalars["String"]["input"]>
  orgPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsNewArgs = {
  buildingDataId: Scalars["Int"]["input"]
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
}

export type SiteMutationsNewEvCalcArgs = {
  markupUsdPerKwh: Scalars["Float"]["input"]
  numChargers: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsRevertToEstimatesArgs = {
  input: RevertToEstimatesInput
}

export type SiteMutationsSetBadRoofArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetBauMeterLabelArgs = {
  input: SetBauMeterLabelInput
}

export type SiteMutationsSetBauMeterTariffArgs = {
  input: SetBauMeterTariffInput
}

export type SiteMutationsSetBuildingClassArgs = {
  buildingClass?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetCapRateArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetCarportMaxPvKwArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetCostarPropertyTypeArgs = {
  sitePid: Scalars["String"]["input"]
  value: CoStarPropertyType
}

export type SiteMutationsSetCostarSecondaryTypeArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<CoStarSecondaryType>
}

export type SiteMutationsSetCustomerIdArgs = {
  customerId?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetDoeReferenceTypeArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<BuildingType>
}

export type SiteMutationsSetExistingSolarArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetGroundAvailableSqftArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetGroundMaxPvKwArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetHelioscopeAllocationArgs = {
  allocations: Array<Allocation>
  helioscopeId: Scalars["Int"]["input"]
}

export type SiteMutationsSetLatitudeArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetLeaseTypeArgs = {
  leaseType?: InputMaybe<LeaseType>
  sitePids: Array<Scalars["String"]["input"]>
}

export type SiteMutationsSetLongitudeArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetMeteringArgs = {
  metering?: InputMaybe<Metering>
  sitePids: Array<Scalars["String"]["input"]>
}

export type SiteMutationsSetNumParkingSpacesArgs = {
  numParkingSpaces?: InputMaybe<Scalars["Int"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetNumStoriesArgs = {
  numStories?: InputMaybe<Scalars["Int"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetOccupancyTypeArgs = {
  occupancyType?: InputMaybe<BuildingOccupancyType>
  sitePids: Array<Scalars["String"]["input"]>
}

export type SiteMutationsSetPortfolioArgs = {
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetRoofImageArgs = {
  attachmentId?: InputMaybe<Scalars["Int"]["input"]>
  pid: Scalars["String"]["input"]
}

export type SiteMutationsSetRoofMaxPvKwArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Float"]["input"]>
}

export type SiteMutationsSetRoofSqftArgs = {
  sitePid: Scalars["String"]["input"]
  sourceId?: InputMaybe<Scalars["String"]["input"]>
  sourceType?: InputMaybe<ChangeSourceType>
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetSiteHiddenFromCustomersArgs = {
  hiddenFromCustomers: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsSetSlopedRoofArgs = {
  sitePid: Scalars["String"]["input"]
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetSqftArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetStatusArgs = {
  customReason?: InputMaybe<Scalars["String"]["input"]>
  reason?: InputMaybe<StatusReason>
  sitePid: Scalars["String"]["input"]
  status: SiteStatus
  unixtimeSec?: InputMaybe<Scalars["Int"]["input"]>
}

export type SiteMutationsSetTargetUtilityArgs = {
  sitePid: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type SiteMutationsSetThirdPartySupplierArgs = {
  sitePid: Scalars["String"]["input"]
  thirdPartySupplierId?: InputMaybe<Scalars["Int"]["input"]>
}

export type SiteMutationsSetUnobstructedFlatRoofArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetUnobstructedFlatRoofSqftArgs = {
  sitePid: Scalars["String"]["input"]
  source: PhysicalCheckSource
  value?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type SiteMutationsSetUsableCarportFtArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetUsableRoofPctArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetUsableRoofSqftArgs = {
  sitePid: Scalars["String"]["input"]
  sourceId?: InputMaybe<Scalars["String"]["input"]>
  sourceType?: InputMaybe<ChangeSourceType>
  value: Scalars["Float"]["input"]
}

export type SiteMutationsSetYearBuiltArgs = {
  sitePid: Scalars["String"]["input"]
  yearBuilt?: InputMaybe<Scalars["Int"]["input"]>
}

export type SiteMutationsSetZipCodeArgs = {
  sitePid: Scalars["String"]["input"]
  value: Scalars["String"]["input"]
}

export type SiteMutationsToggleFinproductArgs = {
  enabled: Scalars["Boolean"]["input"]
  finproductId: Scalars["Int"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsToggleHideFakePanelsArgs = {
  hide: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsTrashAttachmentArgs = {
  attachmentId: Scalars["Int"]["input"]
  pid: Scalars["String"]["input"]
}

export type SiteMutationsTrashHelioscopeArgs = {
  helioscopePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsTurnOffBillingMetersArgs = {
  sitePid: Scalars["String"]["input"]
}

export type SiteMutationsUploadHelioscopePdfArgs = {
  reportPdf: Scalars["Upload"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type SiteRef = {
  __typename?: "SiteRef"
  buildingType?: Maybe<BuildingType>
  city: Scalars["String"]["output"]
  lat: Scalars["Float"]["output"]
  lon: Scalars["Float"]["output"]
  name?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  state: Scalars["String"]["output"]
  streetAddress: Scalars["String"]["output"]
  zipCode: Scalars["String"]["output"]
}

export type SiteRefError = Error | SiteRef

export type SiteSearchTerm = {
  __typename?: "SiteSearchTerm"
  address: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  propertyName?: Maybe<Scalars["String"]["output"]>
}

export type SiteShapes = {
  carport?: InputMaybe<ShapeInfo>
  groundmount?: InputMaybe<ShapeInfo>
  keepouts?: InputMaybe<ShapeInfo>
  parcel?: InputMaybe<ShapeInfo>
  roof?: InputMaybe<ShapeInfo>
}

export enum SiteStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  OnHold = "ON_HOLD",
}

export type SiteStatusChange = {
  __typename?: "SiteStatusChange"
  createdBy: UserRef
  customReason?: Maybe<Scalars["String"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  displayText: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  status: SiteStatus
  statusDisplayText: Scalars["String"]["output"]
  statusReasonDisplayText?: Maybe<Scalars["String"]["output"]>
}

export type SiteStatusPred = {
  value?: InputMaybe<SiteStatus>
}

export type SiteVisuals = {
  __typename?: "SiteVisuals"
  solarPanels: Array<MapSolarPanel>
}

export type SlimCostSummary = {
  __typename?: "SlimCostSummary"
  demandCost: Scalars["Float"]["output"]
  energyCost: Scalars["Float"]["output"]
  exportBenefit: Scalars["Float"]["output"]
  fixedCost: Scalars["Float"]["output"]
  nbcCost: Scalars["Float"]["output"]
  totalCost: Scalars["Float"]["output"]
  totalEnergyUsage: Scalars["Float"]["output"]
}

export type SolarFeasibility = {
  __typename?: "SolarFeasibility"
  economics?: Maybe<GaugeRazzleDazzle>
  physical?: Maybe<GaugeRazzleDazzle>
}

export enum SolarLocation {
  CarportOnly = "CARPORT_ONLY",
  Ground = "GROUND",
  RoofAndCarport = "ROOF_AND_CARPORT",
  RoofOnly = "ROOF_ONLY",
}

export type SolarLocationPred = {
  value: Array<InputMaybe<SolarLocation>>
}

export type SolarPerDay = {
  __typename?: "SolarPerDay"
  day: Scalars["Date"]["output"]
  kwh: Scalars["Float"]["output"]
}

export type SolarSite = {
  __typename?: "SolarSite"
  daysActive: Scalars["Int"]["output"]
  kwhLifetime: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
}

export enum SortOrder {
  Asc = "ASC",
  Desc = "DESC",
}

export type Source = {
  __typename?: "Source"
  text?: Maybe<Scalars["String"]["output"]>
  url?: Maybe<Scalars["String"]["output"]>
}

export enum SpecOptOutReason {
  Other = "OTHER",
}

export enum Status {
  Canceled = "CANCELED",
  Failure = "FAILURE",
  Pending = "PENDING",
  Running = "RUNNING",
  Success = "SUCCESS",
}

export type StatusCheck = {
  __typename?: "StatusCheck"
  desc: Scalars["String"]["output"]
  hint: Scalars["String"]["output"]
  status: Scalars["Boolean"]["output"]
}

export enum StatusReason {
  BuildingWillBeSoldSoon = "BUILDING_WILL_BE_SOLD_SOON",
  Duplicate = "DUPLICATE",
  HighRiseWithBusyRoof = "HIGH_RISE_WITH_BUSY_ROOF",
  InsufficientFinancialReturn = "INSUFFICIENT_FINANCIAL_RETURN",
  Other = "OTHER",
  PpasNotAllowed = "PPAS_NOT_ALLOWED",
  RoofNeedsReplacing = "ROOF_NEEDS_REPLACING",
  SolarInstalled = "SOLAR_INSTALLED",
  SystemSizeTooSmall = "SYSTEM_SIZE_TOO_SMALL",
}

export type StringInput = {
  value: Scalars["String"]["input"]
}

export type StringPred = {
  value: Array<InputMaybe<Scalars["String"]["input"]>>
}

export type SubRate = {
  __typename?: "SubRate"
  chargeClass?: Maybe<ChargeClass>
  op: OpType
  rateId?: Maybe<Scalars["Int"]["output"]>
}

export type SubRateInput = {
  chargeClass?: InputMaybe<ChargeClass>
  rateId?: InputMaybe<Scalars["Int"]["input"]>
}

export type System = {
  __typename?: "System"
  batterySpecs: Array<BatterySpec>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  pvSpecs: Array<PvSpec>
  totalPvSizeKw: Scalars["Float"]["output"]
}

export type SystemInput = {
  battery: Array<BatterySpecInput>
  pv: Array<PvSpecInput>
}

export type SystemLite = {
  __typename?: "SystemLite"
  batterySpecs: Array<BatterySpecLite>
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  pid: Scalars["String"]["output"]
  pvSpecs: Array<PvSpec>
  totalPvSizeKw: Scalars["Float"]["output"]
}

export type SystemLiteInput = {
  battery: Array<BatterySpecLiteInput>
  pv: Array<PvSpecInput>
}

export type SystemUnion = {
  __typename?: "SystemUnion"
  lite?: Maybe<SystemLite>
  system?: Maybe<System>
}

export type Tariff = {
  __typename?: "Tariff"
  closedDate?: Maybe<Scalars["DateTime"]["output"]>
  code: Scalars["String"]["output"]
  customerClass: Scalars["String"]["output"]
  customerCount?: Maybe<Scalars["Int"]["output"]>
  customerLikelihood: Scalars["Float"]["output"]
  hasNetMetering: Scalars["Boolean"]["output"]
  hasTouRates: Scalars["Boolean"]["output"]
  history?: Maybe<TariffHistory>
  id: Scalars["Int"]["output"]
  isCustom: Scalars["Boolean"]["output"]
  isPreferred?: Maybe<Scalars["Boolean"]["output"]>
  isPrimaryConnection: Scalars["Boolean"]["output"]
  masterTariffId?: Maybe<Scalars["Int"]["output"]>
  maxMonthlyKw?: Maybe<Scalars["Float"]["output"]>
  maxMonthlyKwh?: Maybe<Scalars["Float"]["output"]>
  minMonthlyKw?: Maybe<Scalars["Float"]["output"]>
  minMonthlyKwh?: Maybe<Scalars["Float"]["output"]>
  name: Scalars["String"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
  rateDetails: Array<TariffDetails>
  requiresPv?: Maybe<Scalars["Boolean"]["output"]>
  requiresStorage?: Maybe<Scalars["Boolean"]["output"]>
  tariffType?: Maybe<Scalars["String"]["output"]>
  trashedAt?: Maybe<Scalars["DateTime"]["output"]>
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>
  utility: Utility
}

export enum TariffClass {
  General = "GENERAL",
  Residential = "RESIDENTIAL",
  SpecialUse = "SPECIAL_USE",
}

export type TariffDeltas = {
  __typename?: "TariffDeltas"
  kw?: Maybe<Delta>
  kwh: Delta
  usd: Delta
}

export type TariffDetails = {
  __typename?: "TariffDetails"
  allRates: Array<Rate>
  properties: Array<TariffProperty>
  rates: Array<Rate>
  rawJson: Scalars["JSON"]["output"]
  tariff: Tariff
  usingHybridNem3ExportRate: Scalars["Boolean"]["output"]
  version?: Maybe<TariffVersion>
}

export type TariffHistory = {
  __typename?: "TariffHistory"
  dateCreated: Scalars["DateTime"]["output"]
  dateLastUpdated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  parent: Tariff
  versions: Array<TariffVersion>
}

export type TariffMutations = {
  __typename?: "TariffMutations"
  archiveCustomTariff?: Maybe<Scalars["Void"]["output"]>
  createCustomTariff: Tariff
  fetchTariffVersion?: Maybe<Scalars["Void"]["output"]>
  setFields?: Maybe<Tariff>
}

export type TariffMutationsArchiveCustomTariffArgs = {
  customTariffId: Scalars["Int"]["input"]
}

export type TariffMutationsCreateCustomTariffArgs = {
  cfg: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  utilityId: Scalars["Int"]["input"]
}

export type TariffMutationsFetchTariffVersionArgs = {
  effectiveOn: Scalars["DateTime"]["input"]
  masterTariffId: Scalars["Int"]["input"]
}

export type TariffMutationsSetFieldsArgs = {
  id: Scalars["Int"]["input"]
  isPreferred?: InputMaybe<Scalars["Boolean"]["input"]>
  notes?: InputMaybe<Scalars["String"]["input"]>
  requiresPv?: InputMaybe<Scalars["Boolean"]["input"]>
  requiresStorage?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type TariffProperty = {
  __typename?: "TariffProperty"
  dataType: Scalars["String"]["output"]
  formulaDetail?: Maybe<Scalars["String"]["output"]>
  keyName: Scalars["String"]["output"]
  propertyValue?: Maybe<Scalars["String"]["output"]>
  propertyValues: Array<Scalars["String"]["output"]>
}

export type TariffPropertyKey = {
  __typename?: "TariffPropertyKey"
  formulaDetail?: Maybe<Scalars["String"]["output"]>
  keyName: Scalars["String"]["output"]
}

export type TariffRate = {
  __typename?: "TariffRate"
  closedDate?: Maybe<Scalars["DateTime"]["output"]>
  dateCreated: Scalars["DateTime"]["output"]
  dateLastUpdated: Scalars["DateTime"]["output"]
  endDate?: Maybe<Scalars["DateTime"]["output"]>
  id: Scalars["Int"]["output"]
  isPrimaryConnection: Scalars["Boolean"]["output"]
  masterTariffId?: Maybe<Scalars["Int"]["output"]>
  parent: Tariff
  startDate: Scalars["DateTime"]["output"]
  tariffId?: Maybe<Scalars["Int"]["output"]>
  utility: Utility
}

export type TariffRef = {
  __typename?: "TariffRef"
  code: Scalars["String"]["output"]
  customerClass: Scalars["String"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
}

export enum TariffSlot {
  Bau = "BAU",
  PostBattery = "POST_BATTERY",
  PostSolar = "POST_SOLAR",
}

export type TariffVersion = {
  __typename?: "TariffVersion"
  effectiveDate: Scalars["DateTime"]["output"]
  endDate?: Maybe<Scalars["DateTime"]["output"]>
  isDownloaded: Scalars["Boolean"]["output"]
  tariffId?: Maybe<Scalars["Int"]["output"]>
}

export type Task = {
  __typename?: "Task"
  createdAt: Scalars["DateTime"]["output"]
  exceptionMsg?: Maybe<Scalars["String"]["output"]>
  exceptionName?: Maybe<Scalars["String"]["output"]>
  executionMs?: Maybe<Scalars["Int"]["output"]>
  finishedAt?: Maybe<Scalars["DateTime"]["output"]>
  hash: Scalars["Int"]["output"]
  hostname?: Maybe<Scalars["String"]["output"]>
  id: Scalars["Int"]["output"]
  insertionHash: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  org?: Maybe<Org>
  payload: Scalars["JSON"]["output"]
  priority: Scalars["Int"]["output"]
  queue: TaskQueue
  retries: Scalars["Int"]["output"]
  retryable: Scalars["Boolean"]["output"]
  site?: Maybe<SiteRef>
  startedAt?: Maybe<Scalars["DateTime"]["output"]>
  status: Status
}

export type TaskError = Error | Task

export type TaskParamsInput =
  | {
      buildingDataLookup: BuildingDataLookupInput
      createCsvImportSites?: never
      extractBillLineItems?: never
      heartbeat?: never
      reonomyOwnerLookup?: never
    }
  | {
      buildingDataLookup?: never
      createCsvImportSites: CreateCsvImportSitesInput
      extractBillLineItems?: never
      heartbeat?: never
      reonomyOwnerLookup?: never
    }
  | {
      buildingDataLookup?: never
      createCsvImportSites?: never
      extractBillLineItems: ExtractBillLineItemsInput
      heartbeat?: never
      reonomyOwnerLookup?: never
    }
  | {
      buildingDataLookup?: never
      createCsvImportSites?: never
      extractBillLineItems?: never
      heartbeat: HeartbeatInput
      reonomyOwnerLookup?: never
    }
  | {
      buildingDataLookup?: never
      createCsvImportSites?: never
      extractBillLineItems?: never
      heartbeat?: never
      reonomyOwnerLookup: ReonomyOwnerLookupInput
    }

export enum TaskQueue {
  Default = "DEFAULT",
  Lux = "LUX",
}

export type TaxItem = {
  __typename?: "TaxItem"
  cost: Scalars["Float"]["output"]
  name: Scalars["String"]["output"]
  percentage: Scalars["Float"]["output"]
  subtotal: Scalars["Float"]["output"]
  taxId: Scalars["Int"]["output"]
}

export type TenantCashflows = {
  __typename?: "TenantCashflows"
  discountRate: Scalars["Float"]["output"]
  netCashflowPerYear: Array<Scalars["Float"]["output"]>
  npv: Scalars["Float"]["output"]
  totalCapex: Scalars["Float"]["output"]
  totalNet: Scalars["Float"]["output"]
  totalOpex: Scalars["Float"]["output"]
  totalUtilitySavings: Scalars["Float"]["output"]
}

export type TenantDetails = {
  __typename?: "TenantDetails"
  numUnits1Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits2Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits3Bd?: Maybe<Scalars["Int"]["output"]>
  numUnits4Bd?: Maybe<Scalars["Int"]["output"]>
  numUnitsStudio?: Maybe<Scalars["Int"]["output"]>
  numUnitsTotal?: Maybe<Scalars["Int"]["output"]>
}

export type TextContent = {
  __typename?: "TextContent"
  text: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export type TextContentImageContentFileContent =
  | FileContent
  | ImageContent
  | TextContent

export type TextValue = {
  __typename?: "TextValue"
  text: Scalars["String"]["output"]
}

export type ThirdPartySupplier = {
  __typename?: "ThirdPartySupplier"
  dateCreated: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
}

export type TimeOfUse = {
  __typename?: "TimeOfUse"
  season?: Maybe<Season>
  touName: Scalars["String"]["output"]
  touPeriods: Array<Period>
  touType?: Maybe<Scalars["String"]["output"]>
}

export enum TimeZoneChoice {
  Local = "LOCAL",
  Utc = "UTC",
}

export type TodoItem = {
  __typename?: "TodoItem"
  completedAt?: Maybe<Scalars["DateTime"]["output"]>
  completedBy?: Maybe<UserRef>
  content: Scalars["String"]["output"]
  createdAt: Scalars["DateTime"]["output"]
  createdBy?: Maybe<UserRef>
  id: Scalars["Int"]["output"]
  index: Scalars["Int"]["output"]
  section: TodoSection
  site: SiteRef
  updatedAt: Scalars["DateTime"]["output"]
  updatedBy?: Maybe<UserRef>
}

export type TodoMutations = {
  __typename?: "TodoMutations"
  add?: Maybe<Scalars["Void"]["output"]>
  delete?: Maybe<Scalars["Void"]["output"]>
  setComplete?: Maybe<Scalars["Void"]["output"]>
  setContent?: Maybe<Scalars["Void"]["output"]>
  setSection?: Maybe<Scalars["Void"]["output"]>
  setSectionIndex?: Maybe<Scalars["Void"]["output"]>
  setSectionName?: Maybe<Scalars["Void"]["output"]>
}

export type TodoMutationsAddArgs = {
  content: Scalars["String"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type TodoMutationsDeleteArgs = {
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetCompleteArgs = {
  complete: Scalars["Boolean"]["input"]
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetContentArgs = {
  content: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetSectionArgs = {
  index: Scalars["Int"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  todoItemId: Scalars["Int"]["input"]
}

export type TodoMutationsSetSectionIndexArgs = {
  index: Scalars["Int"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type TodoMutationsSetSectionNameArgs = {
  newName: Scalars["String"]["input"]
  sectionName: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}

export type TodoSection = {
  __typename?: "TodoSection"
  createdAt: Scalars["DateTime"]["output"]
  id: Scalars["Int"]["output"]
  index: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  site: SiteRef
}

export type ToolCall = {
  __typename?: "ToolCall"
  function: Function
  id: Scalars["String"]["output"]
  type: Scalars["String"]["output"]
}

export enum TransactionType {
  Buy = "BUY",
  BuyImport = "BUY_IMPORT",
  Net = "NET",
  Sell = "SELL",
  SellExport = "SELL_EXPORT",
}

export enum UsState {
  Ak = "AK",
  Al = "AL",
  Ar = "AR",
  Az = "AZ",
  Ca = "CA",
  Co = "CO",
  Ct = "CT",
  Dc = "DC",
  De = "DE",
  Fl = "FL",
  Ga = "GA",
  Hi = "HI",
  Ia = "IA",
  Id = "ID",
  Il = "IL",
  In = "IN",
  Ks = "KS",
  Ky = "KY",
  La = "LA",
  Ma = "MA",
  Md = "MD",
  Me = "ME",
  Mi = "MI",
  Mn = "MN",
  Mo = "MO",
  Ms = "MS",
  Mt = "MT",
  Nc = "NC",
  Nd = "ND",
  Ne = "NE",
  Nh = "NH",
  Nj = "NJ",
  Nm = "NM",
  Nv = "NV",
  Ny = "NY",
  Oh = "OH",
  Ok = "OK",
  Or = "OR",
  Pa = "PA",
  Pr = "PR",
  Ri = "RI",
  Sc = "SC",
  Sd = "SD",
  Tn = "TN",
  Tx = "TX",
  Ut = "UT",
  Va = "VA",
  Vt = "VT",
  Wa = "WA",
  Wi = "WI",
  Wv = "WV",
  Wy = "WY",
}

export type UsStateMultiPred = {
  value: Array<InputMaybe<UsState>>
}

export enum Units {
  Kw = "KW",
  Kwh = "KWH",
  Tons = "TONS",
  TonsPerKwh = "TONS_PER_KWH",
  Usd = "USD",
  UsdPerKwh = "USD_PER_KWH",
}

export type UpdateDetailsInput = {
  buildingLegalName?: InputMaybe<Scalars["String"]["input"]>
  constructionEmail?: InputMaybe<Scalars["String"]["input"]>
  counselApproval?: InputMaybe<CounselApproval>
  externalLeaseApprovers?: InputMaybe<Array<Scalars["String"]["input"]>>
  isFannieMaeLender?: InputMaybe<Scalars["Boolean"]["input"]>
  isFmGlobalInsurer?: InputMaybe<Scalars["Boolean"]["input"]>
  leaseApprovers?: InputMaybe<Array<Scalars["String"]["input"]>>
  leaseLegalOwnerName?: InputMaybe<Scalars["String"]["input"]>
  leasePropertyLegalDescription?: InputMaybe<Scalars["String"]["input"]>
  leaseSignatory?: InputMaybe<Scalars["String"]["input"]>
  needsTenantApproval?: InputMaybe<Scalars["Boolean"]["input"]>
  propertyFundName?: InputMaybe<Scalars["String"]["input"]>
  propertyInsurer?: InputMaybe<Scalars["String"]["input"]>
  propertyLenders?: InputMaybe<Scalars["String"]["input"]>
  propertySiteVisitContacts?: InputMaybe<Array<Scalars["String"]["input"]>>
  roofCondition?: InputMaybe<Scalars["String"]["input"]>
  roofReplacedYr?: InputMaybe<Scalars["Int"]["input"]>
  roofReportDocId?: InputMaybe<Scalars["Int"]["input"]>
  roofRightsHolder?: InputMaybe<RoofRightsHolder>
  salePlannedYear?: InputMaybe<Scalars["Int"]["input"]>
  salePlans?: InputMaybe<Scalars["String"]["input"]>
  signatureBlocks?: InputMaybe<Array<Scalars["String"]["input"]>>
}

export type UpdatePropertyDataInput = {
  data: SiteDataInput
  sitePids: Array<Scalars["String"]["input"]>
}

export type UploadHelioscopePdfResponse = {
  __typename?: "UploadHelioscopePdfResponse"
  reportPdf: Attachment
  roofImage: Attachment
}

export type Usage = {
  __typename?: "Usage"
  completionTokens: Scalars["Int"]["output"]
  promptTokens: Scalars["Int"]["output"]
  totalTokens: Scalars["Int"]["output"]
}

export enum UserEventType {
  BuildingOwnerOnboarded = "BUILDING_OWNER_ONBOARDED",
  ClickedButton = "CLICKED_BUTTON",
  DownloadedBauEnergyUsageXlsx = "DOWNLOADED_BAU_ENERGY_USAGE_XLSX",
  DownloadedCashFlowXlsx = "DOWNLOADED_CASH_FLOW_XLSX",
  DownloadedEnergyUsageXlsx = "DOWNLOADED_ENERGY_USAGE_XLSX",
  EnergyDataTourViewed = "ENERGY_DATA_TOUR_VIEWED",
  KickedOffEnergyDataForm = "KICKED_OFF_ENERGY_DATA_FORM",
  OfftakerExperienceOnboarded = "OFFTAKER_EXPERIENCE_ONBOARDED",
  OfftakerProductTourViewed = "OFFTAKER_PRODUCT_TOUR_VIEWED",
  PdfGenerated = "PDF_GENERATED",
  PricingTermsAgreed = "PRICING_TERMS_AGREED",
  QualificationTourViewed = "QUALIFICATION_TOUR_VIEWED",
  SharedEnergyDataForm = "SHARED_ENERGY_DATA_FORM",
  StartedSharingEnergyData = "STARTED_SHARING_ENERGY_DATA",
  StartedSubmittingEnergyData = "STARTED_SUBMITTING_ENERGY_DATA",
  SubmittedEnergyData = "SUBMITTED_ENERGY_DATA",
}

export type UserRef = {
  __typename?: "UserRef"
  avatarUrl?: Maybe<Scalars["String"]["output"]>
  email: Scalars["String"]["output"]
  isAdmin: Scalars["Boolean"]["output"]
  meetingSchedulingUrl?: Maybe<Scalars["String"]["output"]>
  name?: Maybe<Scalars["String"]["output"]>
  pid: Scalars["String"]["output"]
}

export type UserRole = {
  __typename?: "UserRole"
  org?: Maybe<Org>
  portfolio?: Maybe<PortfolioRef>
  role: RbacRole
  user: UserRef
}

export type UserRoleInput = {
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  role: RbacRole
  userPid: Scalars["String"]["input"]
}

export type UserRoleMutations = {
  __typename?: "UserRoleMutations"
  grantRole?: Maybe<Error>
  revokeRole?: Maybe<Error>
}

export type UserRoleMutationsGrantRoleArgs = {
  input: UserRoleInput
}

export type UserRoleMutationsRevokeRoleArgs = {
  input: UserRoleInput
}

export type Utility = {
  __typename?: "Utility"
  dateCreated: Scalars["DateTime"]["output"]
  dateTariffsRefreshed?: Maybe<Scalars["DateTime"]["output"]>
  eiaGridEsc?: Maybe<EiaGridEsc>
  hostingCapacityMaps: Array<HostingCapacityMap>
  id: Scalars["Int"]["output"]
  isPreferred?: Maybe<Scalars["Boolean"]["output"]>
  lseId: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  notes?: Maybe<Scalars["String"]["output"]>
  numTariffs?: Maybe<Scalars["Int"]["output"]>
  ownership: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  shortName: Scalars["String"]["output"]
  tariffs: Array<Tariff>
  utilityApiName?: Maybe<Scalars["String"]["output"]>
}

export type UtilityCost = {
  __typename?: "UtilityCost"
  bau: FinmodelCost
  der: FinmodelCost
}

export type UtilityList = {
  __typename?: "UtilityList"
  refs: Array<UtilityRef>
}

export type UtilityListResponse = Error | UtilityList

export type UtilityMutations = {
  __typename?: "UtilityMutations"
  setIsPreferred: Utility
  setNotes: Utility
  setUtilityApiName: Utility
}

export type UtilityMutationsSetIsPreferredArgs = {
  id: Scalars["Int"]["input"]
  isPreferred?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type UtilityMutationsSetNotesArgs = {
  id: Scalars["Int"]["input"]
  notes?: InputMaybe<Scalars["String"]["input"]>
}

export type UtilityMutationsSetUtilityApiNameArgs = {
  id: Scalars["Int"]["input"]
  utilityApiName?: InputMaybe<Scalars["String"]["input"]>
}

export type UtilityRef = {
  __typename?: "UtilityRef"
  id: Scalars["Int"]["output"]
  name: Scalars["String"]["output"]
  pid: Scalars["String"]["output"]
  shortName: Scalars["String"]["output"]
}

export type ValidationError = {
  __typename?: "ValidationError"
  message: Scalars["String"]["output"]
  name: Scalars["String"]["output"]
}

export type Viability = {
  __typename?: "Viability"
  createdAt: Scalars["DateTime"]["output"]
  disabledAt?: Maybe<Scalars["DateTime"]["output"]>
  hasStorage?: Maybe<Scalars["Boolean"]["output"]>
  id: Scalars["Int"]["output"]
  isAllowed: Scalars["Boolean"]["output"]
  level: ViabilityLevel
  loadCategory?: Maybe<LoadCategory>
  notes?: Maybe<Scalars["String"]["output"]>
  org?: Maybe<Org>
  physicalSource?: Maybe<PhysicalCheckSource>
  policyDbVersion?: Maybe<Scalars["String"]["output"]>
  productType?: Maybe<FinProductType>
  reason?: Maybe<ViabilityReason>
  site?: Maybe<SiteRef>
  solarLocation?: Maybe<SolarLocation>
  type: ViabilityType
  violatedPolicyPid?: Maybe<Scalars["String"]["output"]>
}

export enum ViabilityLevel {
  Global = "GLOBAL",
  Org = "ORG",
  Site = "SITE",
}

export enum ViabilityReason {
  Bad = "BAD",
  CannotModel = "CANNOT_MODEL",
  ExistingSolar = "EXISTING_SOLAR",
  NoSpace = "NO_SPACE",
  PolicyNotAllowed = "POLICY_NOT_ALLOWED",
  PolicyNotFeasible = "POLICY_NOT_FEASIBLE",
  PolicyUnknown = "POLICY_UNKNOWN",
  SpaceUnknown = "SPACE_UNKNOWN",
}

export enum ViabilityType {
  Admin = "ADMIN",
  Capability = "CAPABILITY",
  Physical = "PHYSICAL",
  Policy = "POLICY",
}

export enum ViewType {
  Investor = "INVESTOR",
  Offtaker = "OFFTAKER",
}

export type VnemEligibilityCondition = {
  __typename?: "VnemEligibilityCondition"
  vnemEligibilityRequired: Scalars["Boolean"]["output"]
}

export enum YesNoUnsure {
  No = "NO",
  Unsure = "UNSURE",
  Yes = "YES",
}

export type YesNoUnsureInput = {
  value: YesNoUnsure
}

export type YesNoUnsurePred = {
  value: Array<InputMaybe<YesNoUnsure>>
}

export type YesNoValue = {
  __typename?: "YesNoValue"
  yes: Scalars["Boolean"]["output"]
}

export type Zoned = {
  __typename?: "Zoned"
  kwh8760: Array<Scalars["Float"]["output"]>
  maxKw: Scalars["Float"]["output"]
  timeZone: Scalars["String"]["output"]
  totalKwh: Scalars["Float"]["output"]
  units: Units
  year: Scalars["Int"]["output"]
}

export type Zoned8760 = {
  __typename?: "Zoned8760"
  intervals: Array<Scalars["Float"]["output"]>
  start: Scalars["DateTime"]["output"]
  timeZone: Scalars["String"]["output"]
  year: Scalars["Int"]["output"]
}

export type AuthUserFragment = {
  __typename?: "AuthUser"
  pid?: string | null
  isAuthenticated: boolean
  isAdmin: boolean
  email?: string | null
  name?: string | null
  org?: {
    __typename?: "Org"
    pid: string
    name: string
    logoUrl?: string | null
    irrFlavor: IrrType
  } | null
}

export type SiteLabelRefFragment = {
  __typename?: "SiteLabel"
  pid: string
  name: string
  themeColor: LabelColor
  sites: Array<string>
}

export type SiteLabelDetailFragment = {
  __typename?: "SiteLabel"
  pid: string
  name: string
  themeColor: LabelColor
  sites: Array<string>
  createdBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  perms: { __typename?: "SiteLabelPerms"; canAdd: boolean; canRemove: boolean }
}

export type PolicyBriefFragment = {
  __typename?: "Policy"
  pid: string
  name: string
  publicName: string
  description: string
  publicDescription: string
  userVisible: boolean
  sources: Array<{ __typename?: "Source"; text?: string | null; url?: string | null }>
  application: { __typename?: "PolicyApplication"; status: PolicyApplicationStatus }
}

export type BundleFragment = {
  __typename?: "Bundle"
  pid: string
  createdAt: string
  name: string
  note?: string | null
  state?: BundleState | null
  optedOut: boolean
  biddingOpenAt?: string | null
  biddingClosedAt?: string | null
  hasParent: boolean
  canDelete: boolean
  archived: boolean
  type: FinProductType
  downloadTheBigZipHref: string
  recvr: { __typename?: "BundleOrg"; pid: string; name: string }
  stats: {
    __typename?: "BundleStats"
    numSites: number
    capex?: number | null
    postTaxItcDeprIrr?: number | null
    pvSizeKw: number
  }
  documents: Array<{
    __typename?: "Document"
    canDelete: boolean
    contentType: string
    dateCreated: string
    fileName: string
    ownerName: string
    pid: string
    tag?: DocumentTag | null
    downloadHref: string
    belongsToBundleParent: boolean
  }>
}

export type BundleRowFragment = {
  __typename?: "BundleRow"
  id: number
  site: {
    __typename?: "RevampSite"
    pid: string
    name?: string | null
    isFavorite: boolean
    isBehindTheMeter?: boolean | null
    isEnergyCommunity: boolean
    isLowIncomeCommunity?: boolean | null
    streetAddress: string
    city: string
    state: string
    zipCode: string
    county: string
    fullAddress: string
    metering?: Metering | null
    assetManager?: string | null
    vnemAllowed: boolean
    doeReferenceType?: BuildingType | null
    usingBillingMeters?: string | null
    numParkingSpaces?: number | null
    yearBuilt?: number | null
    numStories?: number | null
    sqft?: number | null
    roofSqft?: number | null
    usableRoofSqft?: number | null
    usableCarportFt?: number | null
    impliedCarportLinearFt?: number | null
    impliedUsableRoofSqft?: number | null
    impliedUsableRoofSqftExplanation: RoofSqftExplanation
    groundAvailableSqft?: number | null
    hideBuildingFootprint: boolean
    keepoutsFootprintSqft?: number | null
    roofMaxPvKw: number
    carportMaxPvKw: number
    groundmountMaxPvKw?: number | null
    maxPvKwPolicyLimited: boolean
    isMultifamily: boolean
    occupancyType?: BuildingOccupancyType | null
    leaseType?: LeaseType | null
    tenantLeaseTerm?: string | null
    tenantLeaseEnds?: string | null
    tenantInterest?: YesNoUnsure | null
    mortgageLender?: string | null
    buildingClass?: string | null
    hasSubmittedEnergyData: boolean
    billingMeters: Array<{
      __typename?: "BillingMeter"
      pid: string
      bauMeterPid?: string | null
      view: {
        __typename?: "BillingMeterView"
        name: string
        isArchived: boolean
        calc2:
          | { __typename: "E2Error" }
          | { __typename: "Projected"; annualKwh: number }
      }
    }>
    selectedConfig?: {
      __typename?: "SiteConfig"
      createdAt?: string | null
      createdBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      scenario: {
        __typename?: "RevampScenario"
        pid: string
        name: string
        loadCategory: LoadCategory
        solarLocation: SolarLocation
        includeStorage: boolean
      }
      financing: {
        __typename?: "RevampFinancing"
        id: number
        name: string
        type: FinProductType
        financierName: string
        financierPid: string
        financierLogo?: string | null
        financierLogomark?: string | null
        isThirdParty: boolean
      }
    } | null
    documents: Array<{
      __typename?: "Document"
      pid: string
      downloadHref: string
      fileName: string
      tag?: DocumentTag | null
    }>
    energyThings?: {
      __typename?: "EnergyThings"
      canRooftopSolar: boolean
      canCarportSolar?: boolean | null
      canGroundmountSolar?: boolean | null
      canStorage: boolean
    } | null
    financingThings?: {
      __typename?: "FinancingThings"
      canSelfInvest: boolean
      canLoan: boolean
      canPpa?: boolean | null
      canCommunitySolar?: boolean | null
    } | null
    physicalCheck: {
      __typename?: "PhysicalCheck"
      existingSolar?: boolean | null
      unobstructedFlatRoof?: boolean | null
      badRoof?: boolean | null
    }
    siteDetails: {
      __typename?: "SiteDetails"
      leaseApprovers: Array<string>
      externalLeaseApprovers?: Array<string> | null
      needsTenantApproval?: boolean | null
      roofRightsHolder?: RoofRightsHolder | null
      propertyLenders?: string | null
      propertyInsurer?: string | null
      constructionEmail?: string | null
      propertySiteVisitContacts?: Array<string> | null
      leasePropertyLegalDescription?: string | null
      leaseLegalOwnerName?: string | null
      signatureBlocks?: Array<string> | null
      isFannieMaeLender?: boolean | null
      isFmGlobalInsurer?: boolean | null
      roofReplacedYr?: number | null
      roofCondition?: string | null
      salePlans?: string | null
      buildingLegalName?: string | null
      propertyFundName?: string | null
      leaseSignatory?: string | null
      counselApproval?: CounselApproval | null
    }
    notes: Array<{ __typename?: "Note"; text: string }>
    buildingData?: {
      __typename?: "BuildingData"
      numStories?: number | null
      numUnits?: number | null
      yearBuilt?: number | null
      sqft?: number | null
      roofSqft?: number | null
      numParkingSpaces?: number | null
      occupancyRate?: number | null
      totalBuildings?: number | null
      yearRenovated?: number | null
      parentCompany?: string | null
      lastSalePrice?: number | null
      leedCertified?: string | null
      energyStar?: string | null
      buildingOpex?: string | null
      capRate?: number | null
    } | null
    footprint: {
      __typename?: "Footprint"
      latitude: number
      longitude: number
      bounds?: any | null
      obstructionShape?: any | null
      roofShape?: any | null
      roofShapeGeojson?: any | null
      roofShapeUpdatedAt?: string | null
      roofSetbackShape?: any | null
      roofSetbackShapeGeojson?: any | null
      roofSetbackShapeUpdatedAt?: string | null
      carportShape?: any | null
      carportShapeGeojson?: any | null
      carportShapeUpdatedAt?: string | null
      groundmountShape?: any | null
      groundmountShapeGeojson?: any | null
      groundmountShapeUpdatedAt?: string | null
      keepoutsShape?: any | null
      keepoutsShapeGeojson?: any | null
      keepoutsShapeUpdatedAt?: string | null
      roofShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      roofSetbackShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      carportShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      groundmountShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      keepoutsShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }
    thirdPartySupplier?: {
      __typename?: "ThirdPartySupplier"
      pid: string
      name: string
    } | null
    meterSet?: { __typename?: "MeterSet"; loadOrigin?: LoadOrigin | null } | null
    targetUtility?: {
      __typename?: "Utility"
      name: string
      pid: string
      id: number
      eiaGridEsc?: {
        __typename?: "EIAGridEsc"
        cagrBlended: number
        fromYear: number
        toYear: number
      } | null
      hostingCapacityMaps: Array<{
        __typename?: "HostingCapacityMap"
        url: string
        requiresLogin: boolean
        types: Array<HostingCapacityMapType>
      }>
    } | null
  }
  result?: {
    __typename?: "Result"
    id: number
    pid: string
    createdAt: string
    salesPdfReportHref?: string | null
    result?:
      | {
          __typename: "PhysicalCheck"
          createdAt: string
          roofIsGood: boolean
          carportIsGood: boolean
          existingSolar?: boolean | null
          badRoof?: boolean | null
          groundmountIsGood: boolean
        }
      | {
          __typename: "PolicyCheck"
          createdAt: string
          productType?: FinProductType | null
          isGood: boolean
          disqualReason?: PolicyReason | null
        }
      | {
          __typename: "RevampCS"
          id: number
          termYears: number
          createdAt: string
          goal?: PVoptGoal | null
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          financing: {
            __typename?: "RevampFinancing"
            id: number
            name: string
            type: FinProductType
            financierName: string
            financierPid: string
            financierLogo?: string | null
            financierLogomark?: string | null
            isThirdParty: boolean
          }
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            npv: number
            discountRate: number
            roofRentPerYear: Array<number>
          } | null
          pricing: {
            __typename?: "CSPrice"
            usdPerKwPerYear: number
            escalator: number
            minPvKw: number
            maxPvKw: number
            utility: { __typename?: "RevampUtility"; id: number; name: string }
          }
          leaseProjections?: {
            __typename?: "CSLeaseProjections"
            systemSizeKw: number
            annualRentLowerRangeUsd: number
            annualRentUpperRangeUsd: number
            methodology: CsLeaseProjectionMethdology
          } | null
        }
      | {
          __typename: "RevampFinmodel"
          commOpDate: string
          id: number
          pid: string
          createdAt: string
          type: FinProductType
          intervalsAndCostsXlsxHref: string
          buildingOwnerXlsxHref?: string | null
          offerStatus: OfferStatus
          fmvStr: string
          totalPvProductionKwh: number
          totalPvExportKwh?: number | null
          bauCostPerYear: Array<number>
          derCostPerYear: Array<number>
          goal?: PVoptGoal | null
          isVnem: boolean
          isGreenLease: boolean
          investorDetails?: {
            __typename?: "InvestorDetails"
            capex?: number | null
            investorXlsxHref: string
            irrs: { __typename?: "IRRs"; postTaxItcDepr?: number | null }
          } | null
          itcAssumptions: {
            __typename?: "RevampItcAssumptions"
            rate: number
            inLowIncomeCommunity: boolean
            inEnergyCommunity: boolean
            domesticMaterialsAdder: boolean
          }
          iterations: Array<{
            __typename?: "RevampIteration"
            cashPurchaseNpv: number
            pvKw: number
            marginalCo2Averted?: number | null
            storagePvKw?: number | null
            storagePvKwh?: number | null
          }>
          meters: Array<{
            __typename?: "RevampMeter"
            loadCategory: LoadCategory
            meterSource: MeterSource
            name: string
            bau: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
            }
            der?: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
              averageDayKwhFlow: Array<{
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }>
            } | null
          }>
          emissions?: {
            __typename?: "RevampEmissions"
            bauCo2Tons: number
            derCo2Tons: number
            bauAverageDayCo2Tons: Array<number>
            derAverageDayCo2Tons: Array<number>
          } | null
          thirdPartySupplier?: {
            __typename?: "ThirdPartySupplier"
            pid: string
            name: string
          } | null
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          ppa?: {
            __typename: "PPAEconomics"
            ppaType: PpaProductType
            ppaCostPerKwh: number
            ppaTermYears: number
            ppaEsc?: number | null
            srecToInvestor: boolean
            offtakerXlsxHref: string
            product: {
              __typename?: "PPAFinProduct"
              productName: string
              financierName: string
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              roofRentPerYear: Array<number>
            } | null
            tenantFlows?: {
              __typename?: "TenantCashflows"
              npv: number
              discountRate: number
              totalUtilitySavings: number
              totalCapex: number
              totalOpex: number
              totalNet: number
              netCashflowPerYear: Array<number>
            } | null
          } | null
          loan?: {
            __typename: "LoanEconomics"
            loanRecvrXlsxHref: string
            loanTermYears: number
            ownershipTermYears: number
            interestPct: number
            srecToInvestor: boolean
            product: {
              __typename?: "LoanFinProduct"
              productName: string
              financierName: string
              loanDealerFeePct: number
            }
            flows?: {
              __typename?: "LoanRecvrCashflows"
              monthlyPayment: number
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalLoanFunding: number
              totalLoanPayments: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          selfInvest?: {
            __typename: "SelfInvestEconomics"
            npv: number
            discountRate: number
            selfInvestXlsxHref: string
            termYears: number
            srecToInvestor: boolean
            irrs: {
              __typename?: "IRRs"
              postTaxItcDepr?: number | null
              postTaxItcDeprMultiple?: number | null
            }
            product: {
              __typename?: "SelfInvestFinProduct"
              productName: string
              financierName: string
            }
            flows?: {
              __typename?: "SelfInvestCashflows"
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          utilityCosts: {
            __typename?: "UtilityCost"
            bau: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
            der: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
          }
        }
      | {
          __typename: "RevampFinmodelFailure"
          id: number
          createdAt: string
          fmvStr: string
          details: { __typename?: "FailureDetails"; label: string; description: string }
        }
      | {
          __typename: "Viability"
          isAllowed: boolean
          reason?: ViabilityReason | null
          level: ViabilityLevel
          viabilityType: ViabilityType
        }
      | null
    scenario: {
      __typename?: "RevampScenario"
      pid: string
      name: string
      solarLocation: SolarLocation
      loadCategory: LoadCategory
      includeStorage: boolean
    }
    financing: {
      __typename?: "RevampFinancing"
      id: number
      name: string
      type: FinProductType
      financierName: string
      financierPid: string
      financierLogo?: string | null
      financierLogomark?: string | null
      isThirdParty: boolean
      status: FinProductStatus
    }
    helioscope?: {
      __typename?: "Helioscope"
      pid: string
      roofPvKw: number
      carportPvKw: number
      groundPvKw: number
      systemProductivityKwhPerKw?: number | null
      roofImageHref: string
      pdfHref: string
      dcNameplateKw?: number | null
      acNameplateKw?: number | null
      loadRatio?: number | null
      moduleType?: string | null
      inverterType?: string | null
      rackingTiltDegrees?: number | null
      rackingManufacturer?: string | null
      rackingConnectionType?: ConnectionType | null
      notes?: string | null
      roofImage: {
        __typename?: "Attachment"
        id: number
        name: string
        downloadHref: string
      }
      pdf: {
        __typename?: "Attachment"
        downloadHref: string
        contentType: string
        name: string
        id: number
      }
    } | null
  } | null
}

export type BundleTableRowFragment = {
  __typename?: "BundleRow"
  id: number
  state?: BundleState | null
  reason?: CloseReason | null
  site: {
    __typename?: "RevampSite"
    pid: string
    name?: string | null
    fullAddress: string
    streetAddress: string
    city: string
    state: string
    zipCode: string
    doeReferenceType?: BuildingType | null
    yearBuilt?: number | null
    sqft?: number | null
    roofSqft?: number | null
    roofMaxPvKw: number
    numStories?: number | null
    buildingClass?: string | null
    isLowIncomeCommunity?: boolean | null
    isEnergyCommunity: boolean
    targetUtility?: {
      __typename?: "Utility"
      name: string
      hostingCapacityMaps: Array<{
        __typename?: "HostingCapacityMap"
        url: string
        requiresLogin: boolean
        types: Array<HostingCapacityMapType>
      }>
    } | null
    siteDetails: {
      __typename?: "SiteDetails"
      roofReplacedYr?: number | null
      roofCondition?: string | null
    }
  }
  helioscope?: {
    __typename?: "Helioscope"
    pdfHref: string
    systemProductivityKwhPerKw?: number | null
  } | null
  result?: {
    __typename?: "Result"
    id: number
    result?:
      | { __typename: "PhysicalCheck" }
      | { __typename: "PolicyCheck" }
      | {
          __typename: "RevampCS"
          id: number
          termYears: number
          goal?: PVoptGoal | null
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
          } | null
        }
      | {
          __typename: "RevampFinmodel"
          buildingOwnerXlsxHref?: string | null
          commOpDate: string
          goal?: PVoptGoal | null
          investorDetails?: {
            __typename?: "InvestorDetails"
            capex?: number | null
            investorXlsxHref: string
            irrs: { __typename?: "IRRs"; postTaxItcDepr?: number | null }
          } | null
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiAnnual?: number | null
          }
          utilityCosts: {
            __typename?: "UtilityCost"
            der: {
              __typename?: "FinmodelCost"
              totalKwh: number
              usdPerKwh: number
              tariffs: Array<{
                __typename?: "RevampTariff"
                name: string
                code: string
              }>
            }
          }
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          ppa?: {
            __typename: "PPAEconomics"
            ppaType: PpaProductType
            ppaCostPerKwh: number
            ppaTermYears: number
            ppaEsc?: number | null
            srecToInvestor: boolean
            offtakerXlsxHref: string
            roofRent?: { __typename?: "RoofRentEconomics"; annualUsd: number } | null
            product: {
              __typename?: "PPAFinProduct"
              productName: string
              financierName: string
            }
          } | null
          loan?: {
            __typename: "LoanEconomics"
            loanRecvrXlsxHref: string
            loanTermYears: number
            ownershipTermYears: number
            interestPct: number
            product: {
              __typename?: "LoanFinProduct"
              productName: string
              financierName: string
              loanDealerFeePct: number
            }
          } | null
        }
      | { __typename: "RevampFinmodelFailure" }
      | { __typename: "Viability" }
      | null
  } | null
}

export type SiteMeterSetFragment = {
  __typename?: "RevampSite"
  meterSet?: {
    __typename?: "MeterSet"
    intervalsBauXlsxHref?: string | null
    loadKwh?: number | null
    loadMaxKw?: number | null
    loadOrigin?: LoadOrigin | null
    totalCost: number
    rollup: Array<{
      __typename?: "DailyRollup"
      season: string
      days: Array<string>
      numbers: Array<number>
    }>
    meters: Array<{
      __typename?: "BauMeter"
      id: number
      pid: string
      userVisibleLabel: string
      loadOrigin: LoadOrigin
      loadCategory: LoadCategory
      tariffUsdPerKwh: number
      totalCost: number
      importsKwh: number
      formattedBill: {
        __typename?: "FormattedBills"
        rate?: {
          __typename?: "TariffRate"
          tariffId?: number | null
          startDate: string
          endDate?: string | null
        } | null
        bills: Array<{
          __typename?: "FormattedBill"
          month: string
          kwhSupplyCharge: number
          kwhCharge: number
          charges: Array<{
            __typename?: "BillSection"
            name: string
            rates: Array<{
              __typename?: "DecodedRate"
              id: number
              name: string
              chargeClass: ChargeClass
            }>
            costs: Array<
              | {
                  __typename: "CostItem"
                  name: string
                  rateId: number
                  chargeType: ChargeType
                  chargeCategory?: ChargeCategory | null
                  volume: number
                  rate: number
                  cost: number
                  rateObj: {
                    __typename?: "DecodedRate"
                    id: number
                    name: string
                    chargeClass: ChargeClass
                  }
                }
              | {
                  __typename: "TaxItem"
                  taxId: number
                  subtotal: number
                  cost: number
                  percentage: number
                }
              | null
            >
          }>
          exports: Array<{
            __typename?: "BillSection"
            name: string
            rates: Array<{
              __typename?: "DecodedRate"
              id: number
              name: string
              chargeClass: ChargeClass
            }>
            costs: Array<
              | {
                  __typename: "CostItem"
                  name: string
                  rateId: number
                  chargeType: ChargeType
                  chargeCategory?: ChargeCategory | null
                  volume: number
                  rate: number
                  cost: number
                  rateObj: {
                    __typename?: "DecodedRate"
                    id: number
                    name: string
                    chargeClass: ChargeClass
                  }
                }
              | {
                  __typename: "TaxItem"
                  taxId: number
                  subtotal: number
                  cost: number
                  percentage: number
                }
              | null
            >
          }>
        }>
      }
      tariff: { __typename?: "Tariff"; id: number; name: string; code: string }
      rollup: Array<{
        __typename?: "DailyRollup"
        season: string
        days: Array<string>
        numbers: Array<number>
      }>
      intervals: {
        __typename?: "Zoned"
        maxKw: number
        year: number
        units: Units
        totalKwh: number
      }
    }>
  } | null
}

export type SiteBauMeterFragment = {
  __typename?: "BauMeter"
  id: number
  pid: string
  userVisibleLabel: string
  loadOrigin: LoadOrigin
  loadCategory: LoadCategory
  tariffUsdPerKwh: number
  totalCost: number
  importsKwh: number
  formattedBill: {
    __typename?: "FormattedBills"
    rate?: {
      __typename?: "TariffRate"
      tariffId?: number | null
      startDate: string
      endDate?: string | null
    } | null
    bills: Array<{
      __typename?: "FormattedBill"
      month: string
      kwhSupplyCharge: number
      kwhCharge: number
      charges: Array<{
        __typename?: "BillSection"
        name: string
        rates: Array<{
          __typename?: "DecodedRate"
          id: number
          name: string
          chargeClass: ChargeClass
        }>
        costs: Array<
          | {
              __typename: "CostItem"
              name: string
              rateId: number
              chargeType: ChargeType
              chargeCategory?: ChargeCategory | null
              volume: number
              rate: number
              cost: number
              rateObj: {
                __typename?: "DecodedRate"
                id: number
                name: string
                chargeClass: ChargeClass
              }
            }
          | {
              __typename: "TaxItem"
              taxId: number
              subtotal: number
              cost: number
              percentage: number
            }
          | null
        >
      }>
      exports: Array<{
        __typename?: "BillSection"
        name: string
        rates: Array<{
          __typename?: "DecodedRate"
          id: number
          name: string
          chargeClass: ChargeClass
        }>
        costs: Array<
          | {
              __typename: "CostItem"
              name: string
              rateId: number
              chargeType: ChargeType
              chargeCategory?: ChargeCategory | null
              volume: number
              rate: number
              cost: number
              rateObj: {
                __typename?: "DecodedRate"
                id: number
                name: string
                chargeClass: ChargeClass
              }
            }
          | {
              __typename: "TaxItem"
              taxId: number
              subtotal: number
              cost: number
              percentage: number
            }
          | null
        >
      }>
    }>
  }
  tariff: { __typename?: "Tariff"; id: number; name: string; code: string }
  rollup: Array<{
    __typename?: "DailyRollup"
    season: string
    days: Array<string>
    numbers: Array<number>
  }>
  intervals: {
    __typename?: "Zoned"
    maxKw: number
    year: number
    units: Units
    totalKwh: number
  }
}

export type ShineStatsFragment = {
  __typename?: "ShineStats"
  numProperties: number
  pvKwInstalled: number
  totalCo2ReducedTonnes: number
  totalGrossRevenue: number
  totalPvProductionKwh: number
}

export type ShineUnitFragment = {
  __typename?: "ShineUnit"
  duration: ShineDuration
  start: string
  actualPvProductionKwh: number
  expectedPvProductionKwh: number
  actualGrossRevenue: number
  expectedGrossRevenue: number
  co2EmissionsReductionTonnes: number
}

export type DirtyRowDataFragment = {
  __typename?: "DirtyRowData"
  name?: string | null
  assetManager?: string | null
  customerId?: string | null
  numStories?: string | null
  streetAddress?: string | null
  city?: string | null
  state?: string | null
  zipCode?: string | null
  buildingType?: string | null
  sqft?: string | null
  yearBuilt?: string | null
}

export type CleanRowDataFragment = {
  __typename?: "CleanRowData"
  customerId?: string | null
  streetAddress: string
  city: string
  state: UsState
  zipCode?: string | null
  buildingType?: string | null
  sqft?: number | null
}

export type CsvImportRowFragment = {
  __typename?: "CsvImportRow"
  id: number
  site?: { __typename?: "SiteRef"; pid: string; name?: string | null } | null
  dirty: {
    __typename?: "DirtyRowData"
    name?: string | null
    assetManager?: string | null
    customerId?: string | null
    numStories?: string | null
    streetAddress?: string | null
    city?: string | null
    state?: string | null
    zipCode?: string | null
    buildingType?: string | null
    sqft?: string | null
    yearBuilt?: string | null
  }
}

export type CsvImportLabelsFragment = {
  __typename?: "CsvImport"
  pid: string
  labels: Array<{
    __typename?: "SiteLabel"
    pid: string
    themeColor: LabelColor
    name: string
  }>
}

export type BillingMeterOptionFragment = {
  __typename?: "BillingMeter"
  pid: string
  bauMeterPid?: string | null
  view: {
    __typename?: "BillingMeterView"
    name: string
    isArchived: boolean
    calc2: { __typename: "E2Error" } | { __typename: "Projected"; annualKwh: number }
  }
}

export type BillingMeterFragment = {
  __typename?: "BillingMeter"
  id: number
  pid: string
  view: {
    __typename?: "BillingMeterView"
    name: string
    utilityMeterId?: string | null
    supplyUtilityMeterId?: string | null
    doeReferenceType: BuildingType
    loadCategory: LoadCategory
    isDisabled: boolean
    isArchived: boolean
    numBills: number
    numIntervals: number
    weeklyRollup?: Array<number> | null
    utility?: {
      __typename?: "UtilityRef"
      pid: string
      name: string
      shortName: string
    } | null
    tariff?: {
      __typename?: "Tariff"
      id: number
      pid: string
      name: string
      code: string
    } | null
    tenantDetails?: {
      __typename?: "TenantDetails"
      numUnitsTotal?: number | null
      numUnitsStudio?: number | null
      numUnits1Bd?: number | null
      numUnits2Bd?: number | null
      numUnits3Bd?: number | null
      numUnits4Bd?: number | null
    } | null
    totalAnnualKwh?: {
      __typename?: "FancyFloat"
      source: FancySource
      number: number
    } | null
    peakAnnualKw?: {
      __typename?: "FancyFloat"
      source: FancySource
      number: number
    } | null
    months: Array<{
      __typename?: "BillingMonthView"
      id?: number | null
      start: string
      end: string
      usageKwh: { __typename?: "FancyFloat"; source: FancySource; number: number }
      peakKw?: { __typename?: "FancyFloat"; source: FancySource; number: number } | null
      totalCostUsd?: {
        __typename?: "FancyFloat"
        source: FancySource
        number: number
      } | null
      supplyCostUsd?: {
        __typename?: "FancyFloat"
        source: FancySource
        number: number
      } | null
      transmissionCostUsd?: {
        __typename?: "FancyFloat"
        source: FancySource
        number: number
      } | null
      provider?: {
        __typename?: "Provider"
        id: number
        createdAt: string
        user?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        document?: {
          __typename?: "Document"
          pid: string
          fileName: string
          contentType: string
          downloadHref: string
          viewHref: string
        } | null
        espmConsumption?: {
          __typename?: "ESPMConsumption"
          id: number
          createdAt: string
          lastUpdatedAt: string
          externalConsumptionId: string
          externalData: string
          start: string
          end: string
          usageKwh: number
          costUsd?: number | null
        } | null
      } | null
      supplyProvider?: {
        __typename?: "Provider"
        id: number
        createdAt: string
        user?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        document?: {
          __typename?: "Document"
          pid: string
          fileName: string
          contentType: string
          downloadHref: string
          viewHref: string
        } | null
        espmConsumption?: {
          __typename?: "ESPMConsumption"
          id: number
          createdAt: string
          lastUpdatedAt: string
          externalConsumptionId: string
          externalData: string
          start: string
          end: string
          usageKwh: number
          costUsd?: number | null
        } | null
      } | null
    }>
    calc2:
      | { __typename: "E2Error"; msg: string }
      | {
          __typename: "Projected"
          year: number
          annualKwh: number
          peakKw: number
          annualCostUsd: number
          monthlyUsageKwh: Array<number>
          monthlyCostUsd: Array<number>
          costAndKwhDownloadHref: string
          kwh8760: {
            __typename?: "Zoned8760"
            timeZone: string
            start: string
            year: number
          }
          tariff: {
            __typename?: "Tariff"
            id: number
            pid: string
            name: string
            code: string
          }
          monthlyBills: Array<{
            __typename?: "MonthlyBill2"
            start: string
            end: string
            sections: Array<{
              __typename?: "BillGroup"
              group: string
              items: Array<{
                __typename?: "GroupedLineItem"
                cost: number
                usage: number
                name: string
                rate: number
                group?: string | null
                unit?: ChargeUnit | null
              }>
            }>
          }>
        }
    intervals: Array<{
      __typename?: "BillingIntervalView"
      id: number
      start?: string | null
      end?: string | null
      timeZone: string
      units: Units
      numbers?: Array<number> | null
      timestamps?: Array<string> | null
      document: {
        __typename?: "Document"
        id: number
        pid: string
        fileName: string
        downloadHref: string
      }
    }>
  }
}

export type BillingMeterProjectedFragment = {
  __typename?: "Projected"
  year: number
  annualKwh: number
  peakKw: number
  annualCostUsd: number
  monthlyUsageKwh: Array<number>
  monthlyCostUsd: Array<number>
  costAndKwhDownloadHref: string
  kwh8760: { __typename?: "Zoned8760"; timeZone: string; start: string; year: number }
  tariff: { __typename?: "Tariff"; id: number; pid: string; name: string; code: string }
  monthlyBills: Array<{
    __typename?: "MonthlyBill2"
    start: string
    end: string
    sections: Array<{
      __typename?: "BillGroup"
      group: string
      items: Array<{
        __typename?: "GroupedLineItem"
        cost: number
        usage: number
        name: string
        rate: number
        group?: string | null
        unit?: ChargeUnit | null
      }>
    }>
  }>
}

export type BillGroupFragment = {
  __typename?: "BillGroup"
  group: string
  items: Array<{
    __typename?: "GroupedLineItem"
    cost: number
    usage: number
    name: string
    rate: number
    group?: string | null
    unit?: ChargeUnit | null
  }>
}

export type GroupedLineItemFragment = {
  __typename?: "GroupedLineItem"
  cost: number
  usage: number
  name: string
  rate: number
  group?: string | null
  unit?: ChargeUnit | null
}

export type BillingIntervalViewFragment = {
  __typename?: "BillingIntervalView"
  id: number
  start?: string | null
  end?: string | null
  timeZone: string
  units: Units
  numbers?: Array<number> | null
  timestamps?: Array<string> | null
  document: {
    __typename?: "Document"
    id: number
    pid: string
    fileName: string
    downloadHref: string
  }
}

export type BillingMonthViewFragment = {
  __typename?: "BillingMonthView"
  id?: number | null
  start: string
  end: string
  usageKwh: { __typename?: "FancyFloat"; source: FancySource; number: number }
  peakKw?: { __typename?: "FancyFloat"; source: FancySource; number: number } | null
  totalCostUsd?: {
    __typename?: "FancyFloat"
    source: FancySource
    number: number
  } | null
  supplyCostUsd?: {
    __typename?: "FancyFloat"
    source: FancySource
    number: number
  } | null
  transmissionCostUsd?: {
    __typename?: "FancyFloat"
    source: FancySource
    number: number
  } | null
  provider?: {
    __typename?: "Provider"
    id: number
    createdAt: string
    user?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    document?: {
      __typename?: "Document"
      pid: string
      fileName: string
      contentType: string
      downloadHref: string
      viewHref: string
    } | null
    espmConsumption?: {
      __typename?: "ESPMConsumption"
      id: number
      createdAt: string
      lastUpdatedAt: string
      externalConsumptionId: string
      externalData: string
      start: string
      end: string
      usageKwh: number
      costUsd?: number | null
    } | null
  } | null
  supplyProvider?: {
    __typename?: "Provider"
    id: number
    createdAt: string
    user?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    document?: {
      __typename?: "Document"
      pid: string
      fileName: string
      contentType: string
      downloadHref: string
      viewHref: string
    } | null
    espmConsumption?: {
      __typename?: "ESPMConsumption"
      id: number
      createdAt: string
      lastUpdatedAt: string
      externalConsumptionId: string
      externalData: string
      start: string
      end: string
      usageKwh: number
      costUsd?: number | null
    } | null
  } | null
}

export type FancyFloatFragment = {
  __typename?: "FancyFloat"
  source: FancySource
  number: number
}

export type ProviderFragment = {
  __typename?: "Provider"
  id: number
  createdAt: string
  user?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  document?: {
    __typename?: "Document"
    pid: string
    fileName: string
    contentType: string
    downloadHref: string
    viewHref: string
  } | null
  espmConsumption?: {
    __typename?: "ESPMConsumption"
    id: number
    createdAt: string
    lastUpdatedAt: string
    externalConsumptionId: string
    externalData: string
    start: string
    end: string
    usageKwh: number
    costUsd?: number | null
  } | null
}

export type PublicTariffFragment = {
  __typename?: "PublicTariff"
  id: number
  pid: string
  name: string
  code: string
  tariffType?: string | null
  isPreferred?: boolean | null
  isNem2: boolean
  isClosed: boolean
  isPrimaryConnection: boolean
  customTariffId?: number | null
  notes?: string | null
  updatedAt?: string | null
  trashedAt?: string | null
  requiresPv?: boolean | null
  requiresStorage?: boolean | null
  hasTouRates: boolean
  hasNetMetering: boolean
  customerLikelihood: number
  customerCount?: number | null
  customerClass: string
  minMonthlyKw?: number | null
  maxMonthlyKw?: number | null
  minMonthlyKwh?: number | null
  maxMonthlyKwh?: number | null
  latestRateId?: number | null
}

export type BasicBundleParentFragment = {
  __typename?: "BundleParent"
  id: number
  createdAt: string
  pid: string
  name: string
  type: FinProductType
  note?: string | null
  pricingNote?: string | null
  state: BundleState
  biddingOpenAt?: string | null
  biddingClosedAt?: string | null
  canAddNewBids: boolean
  canEditBids: boolean
  hiddenFromRecvr?: string | null
  hiddenFromFinancier?: string | null
  showAllBidsReport: boolean
  opsOwner?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  recvr: { __typename?: "Org"; pid: string; name: string }
}

export type BundleParentFragment = {
  __typename?: "BundleParent"
  id: number
  createdAt: string
  pid: string
  name: string
  type: FinProductType
  note?: string | null
  pricingNote?: string | null
  state: BundleState
  biddingOpenAt?: string | null
  biddingClosedAt?: string | null
  canAddNewBids: boolean
  canEditBids: boolean
  hiddenFromRecvr?: string | null
  hiddenFromFinancier?: string | null
  showAllBidsReport: boolean
  bundles: Array<{
    __typename?: "Bundle2"
    name: string
    pid: string
    financier: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
  }>
  rows: Array<{
    __typename?: "BundleParentRow"
    notes?: string | null
    status?: PackageRowStatus | null
    closedAt?: string | null
    closeReason?: PackageRowCloseReason | null
    closeCustomReason?: string | null
    specs: Array<{
      __typename?: "BidSpec"
      ppa?: {
        __typename: "PPABidSpec"
        id: number
        pid: string
        name?: string | null
        termYears?: number | null
        note?: string | null
        archivedAt?: string | null
        ppaPriceY1Usd?: number | null
        ppaPriceEscalator?: number | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        itcPercentageAssumption?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        recOwner?: RecOwner | null
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        system?: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        } | null
      } | null
      cs?: {
        __typename: "CSBidSpec"
        id: number
        pid: string
        name?: string | null
        termYears?: number | null
        note?: string | null
        archivedAt?: string | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        itcPercentageAssumption?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        recOwner?: RecOwner | null
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        systemLite?: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        } | null
      } | null
      optOut?: {
        __typename: "InvestorBidSpecOptOut"
        createdAt: string
        archivedAt?: string | null
        reason?: SpecOptOutReason | null
        customReason?: string | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      } | null
    }>
    site: {
      __typename?: "SiteRef"
      pid: string
      name?: string | null
      streetAddress: string
      city: string
      state: string
      zipCode: string
    }
    scenario?: {
      __typename?: "ScenarioRef"
      pid: string
      name: string
      solarLocation: SolarLocation
      includeStorage: boolean
    } | null
    awardedFinancier?: {
      __typename?: "Org"
      pid: string
      name: string
      logoUrl?: string | null
      logomarkUrl?: string | null
    } | null
    recommendedBid?: {
      __typename?: "InvestorBid"
      ppa?: { __typename?: "PPAInvestorBid"; pid: string } | null
      cs?: { __typename?: "CSInvestorBid"; pid: string } | null
    } | null
  }>
  documents: Array<{
    __typename?: "Document"
    id: number
    pid: string
    tag?: DocumentTag | null
    fileName: string
    contentType: string
    dateCreated: string
    downloadHref: string
    canDelete: boolean
    ownerName: string
  }>
  opsOwner?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  recvr: { __typename?: "Org"; pid: string; name: string }
}

export type CustomBidReportFragment = {
  __typename?: "CustomBidReport"
  pid: string
  name: string
  notes: string
  buildingOwnerNotes?: string | null
  visibleToDevelopers: boolean
  visibleToBuildingOwners: boolean
  bids: Array<{
    __typename?: "InvestorBid"
    ppa?: {
      __typename?: "PPAInvestorBid"
      pid: string
      financier: { __typename?: "OrgRef"; orgSlug: string }
    } | null
    cs?: {
      __typename?: "CSInvestorBid"
      pid: string
      financier: { __typename?: "OrgRef"; orgSlug: string }
    } | null
  }>
}

export type DocumentParseRequestFragment = {
  __typename?: "DocumentParseRequest"
  id: number
  createdAt: string
  status: ParseStatus
  errorClass?: string | null
  errorMessage?: string | null
  document: {
    __typename?: "Document"
    id: number
    pid: string
    fileName: string
    contentType: string
    downloadHref: string
    viewHref: string
    ownerName: string
    ownerEmail: string
    dateCreated: string
  }
  results: Array<{
    __typename?: "ParseResult"
    kind?: BillType | null
    parse: {
      __typename?: "DocumentBillingMonth"
      id: number
      start: string
      end: string
      totalKwh: number
      peakKw?: number | null
      totalCostUsd?: number | null
      supplyCostUsd?: number | null
      transmissionCostUsd?: number | null
      meterId: string
      tariffLabel?: string | null
      kind: BillType
    }
    target?: {
      __typename?: "BillingMeter"
      id: number
      pid: string
      label: string
      utilityMeterId?: string | null
    } | null
  }>
}

export type BundleListItemFragment = {
  __typename?: "Bundle2"
  pid: string
  name: string
  type: FinProductType
  note?: string | null
  pricingNote?: string | null
  state: BundleState
  archivedAt?: string | null
  lastViewed?: string | null
  biddingOpenAt?: string | null
  biddingClosedAt?: string | null
  hasVisibleReports: boolean
  totalBids: number
  optOut?: {
    __typename: "InvestorOptOut"
    createdAt: string
    archivedAt?: string | null
    reason?: InvestorOptOutReason | null
    customReason?: string | null
    createdBy: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }
    archivedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  } | null
  recvr: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
  financier: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
  bidSubmissionStatus: {
    __typename?: "BundleBidSubmissionSummary"
    bidStatus: BundleBidSubmissionStatus
    submittedBidCount?: number | null
    totalRequestedBids?: number | null
  }
  awardStatus?: {
    __typename?: "BundleAwardStatusSummary"
    awardStatus: BundleAwardStatus
    awardedBidCount?: number | null
    totalPossibleAwards?: number | null
  } | null
}

export type BidReportFragment = {
  __typename?: "PackageBidReport"
  pid?: string | null
  name?: string | null
  notes?: string | null
  visible: boolean
  totalDevelopers: number
  totalBids: number
  cs?: Array<{
    __typename: "CSSiteBidReport"
    awarded: boolean
    awardedPid?: string | null
    totalBids: number
    site: {
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      isFavorite: boolean
      streetAddress: string
      city: string
      state: string
      zipCode: string
      county: string
      fullAddress: string
    }
    bids: Array<{
      __typename: "CSInvestorBid"
      name?: string | null
      pid: string
      termYears: number
      roofRentEscalator: number
      roofRentY1Usd: number
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      itcPercentageAssumption: number
      estimatedAwardDate?: string | null
      estimatedCod: string
      estimatedNtp: string
      recOwner: RecOwner
      tariffProvision?: boolean | null
      incentivesNotes?: string | null
      interconnectionNotes?: string | null
      interconnectionRepriceProcessNotes?: string | null
      extraPaymentsNotes?: string | null
      otherNotes?: string | null
      financier: {
        __typename?: "OrgRef"
        pid: string
        name: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }
      result?: {
        __typename?: "RevampCS"
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiLifetime?: number | null
        }
      } | null
    }>
    noi?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    y1RoofRent?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    systemSize?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    itcPercentageAssumption?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    roofRentEscalator?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    npv?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
  }> | null
  ppa?: Array<{
    __typename: "PPASiteBidReport"
    awarded: boolean
    awardedPid?: string | null
    totalBids: number
    site: {
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      isFavorite: boolean
      streetAddress: string
      city: string
      state: string
      zipCode: string
      county: string
      fullAddress: string
    }
    bids: Array<{
      __typename: "PPAInvestorBid"
      name?: string | null
      pid: string
      termYears: number
      roofRentEscalator?: number | null
      roofRentY1Usd?: number | null
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      itcPercentageAssumption: number
      estimatedCod: string
      estimatedNtp: string
      recOwner: RecOwner
      tariffProvision?: boolean | null
      incentivesNotes?: string | null
      interconnectionNotes?: string | null
      interconnectionRepriceProcessNotes?: string | null
      extraPaymentsNotes?: string | null
      otherNotes?: string | null
      financier: {
        __typename?: "OrgRef"
        pid: string
        name: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }
      result?: {
        __typename?: "RevampFinmodel"
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiLifetime?: number | null
        }
      } | null
    }>
    noi?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    y1RoofRent?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    systemSize?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    itcPercentageAssumption?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    ppaPriceEscalator?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
    npv?: {
      __typename?: "BoxplotStats"
      min: number
      q1: number
      median: number
      q3: number
      max: number
      average: number
    } | null
  }> | null
}

export type CsSiteBidReportFragment = {
  __typename: "CSSiteBidReport"
  awarded: boolean
  awardedPid?: string | null
  totalBids: number
  site: {
    __typename?: "RevampSite"
    pid: string
    name?: string | null
    isFavorite: boolean
    streetAddress: string
    city: string
    state: string
    zipCode: string
    county: string
    fullAddress: string
  }
  bids: Array<{
    __typename: "CSInvestorBid"
    name?: string | null
    pid: string
    termYears: number
    roofRentEscalator: number
    roofRentY1Usd: number
    buildingOwnerExtraPaymentsUsd?: Array<number> | null
    interconnectionCostUsdPerWatt?: number | null
    interconnectionCostUtilityMinUsd?: number | null
    interconnectionCostUtilityMaxUsd?: number | null
    interconnectionCostNonUtilityUsd?: number | null
    itcPercentageAssumption: number
    estimatedAwardDate?: string | null
    estimatedCod: string
    estimatedNtp: string
    recOwner: RecOwner
    tariffProvision?: boolean | null
    incentivesNotes?: string | null
    interconnectionNotes?: string | null
    interconnectionRepriceProcessNotes?: string | null
    extraPaymentsNotes?: string | null
    otherNotes?: string | null
    financier: {
      __typename?: "OrgRef"
      pid: string
      name: string
      logoUrl: string
      logomarkUrl?: string | null
      profile?: {
        __typename?: "InvestorProfile"
        hq?: string | null
        yearFounded?: number | null
        website?: string | null
        description?: string | null
        committedFunding?: string | null
        distinguishingFeatures?: string | null
        investorBacking?: string | null
        managementTeam: Array<string>
        longTermOwnershipApproach?: string | null
        subscriptionMgmtApproach?: string | null
        experiences: Array<{
          __typename?: "Experience"
          state?: UsState | null
          ftmEnergizedPvKw?: number | null
          ftmAwardedPvKw?: number | null
          btmEnergizedPvKw?: number | null
          btmAwardedPvKw?: number | null
        }>
        buyBoxes: Array<{
          __typename?: "BuyBox"
          state?: UsState | null
          ftmMinPortfolioSize?: number | null
          ftmMinProjectSize?: number | null
          ftmSeekingProjects?: boolean | null
          btmMinPortfolioSize?: number | null
          btmMinProjectSize?: number | null
          btmSeekingProjects?: boolean | null
        }>
      } | null
    }
    result?: {
      __typename?: "RevampCS"
      buildingOwner: {
        __typename?: "BuildingOwnerEconomics"
        noiLifetime?: number | null
      }
    } | null
  }>
  noi?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  y1RoofRent?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  systemSize?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  itcPercentageAssumption?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  roofRentEscalator?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  npv?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
}

export type PpaSiteBidReportFragment = {
  __typename: "PPASiteBidReport"
  awarded: boolean
  awardedPid?: string | null
  totalBids: number
  site: {
    __typename?: "RevampSite"
    pid: string
    name?: string | null
    isFavorite: boolean
    streetAddress: string
    city: string
    state: string
    zipCode: string
    county: string
    fullAddress: string
  }
  bids: Array<{
    __typename: "PPAInvestorBid"
    name?: string | null
    pid: string
    termYears: number
    roofRentEscalator?: number | null
    roofRentY1Usd?: number | null
    buildingOwnerExtraPaymentsUsd?: Array<number> | null
    interconnectionCostUsdPerWatt?: number | null
    interconnectionCostUtilityMinUsd?: number | null
    interconnectionCostUtilityMaxUsd?: number | null
    interconnectionCostNonUtilityUsd?: number | null
    itcPercentageAssumption: number
    estimatedCod: string
    estimatedNtp: string
    recOwner: RecOwner
    tariffProvision?: boolean | null
    incentivesNotes?: string | null
    interconnectionNotes?: string | null
    interconnectionRepriceProcessNotes?: string | null
    extraPaymentsNotes?: string | null
    otherNotes?: string | null
    financier: {
      __typename?: "OrgRef"
      pid: string
      name: string
      logoUrl: string
      logomarkUrl?: string | null
      profile?: {
        __typename?: "InvestorProfile"
        hq?: string | null
        yearFounded?: number | null
        website?: string | null
        description?: string | null
        committedFunding?: string | null
        distinguishingFeatures?: string | null
        investorBacking?: string | null
        managementTeam: Array<string>
        longTermOwnershipApproach?: string | null
        subscriptionMgmtApproach?: string | null
        experiences: Array<{
          __typename?: "Experience"
          state?: UsState | null
          ftmEnergizedPvKw?: number | null
          ftmAwardedPvKw?: number | null
          btmEnergizedPvKw?: number | null
          btmAwardedPvKw?: number | null
        }>
        buyBoxes: Array<{
          __typename?: "BuyBox"
          state?: UsState | null
          ftmMinPortfolioSize?: number | null
          ftmMinProjectSize?: number | null
          ftmSeekingProjects?: boolean | null
          btmMinPortfolioSize?: number | null
          btmMinProjectSize?: number | null
          btmSeekingProjects?: boolean | null
        }>
      } | null
    }
    result?: {
      __typename?: "RevampFinmodel"
      buildingOwner: {
        __typename?: "BuildingOwnerEconomics"
        noiLifetime?: number | null
      }
    } | null
  }>
  noi?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  y1RoofRent?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  systemSize?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  itcPercentageAssumption?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  ppaPriceEscalator?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
  npv?: {
    __typename?: "BoxplotStats"
    min: number
    q1: number
    median: number
    q3: number
    max: number
    average: number
  } | null
}

export type BoxplotStatsFragment = {
  __typename?: "BoxplotStats"
  min: number
  q1: number
  median: number
  q3: number
  max: number
  average: number
}

export type BundleDetailFragment = {
  __typename?: "Bundle2"
  downloadBundleDocsZipHref: string
  downloadHelioscopesDotZipHref?: string | null
  downloadBundleDotXlsxHref: string
  pid: string
  name: string
  type: FinProductType
  note?: string | null
  pricingNote?: string | null
  state: BundleState
  archivedAt?: string | null
  lastViewed?: string | null
  biddingOpenAt?: string | null
  biddingClosedAt?: string | null
  hasVisibleReports: boolean
  totalBids: number
  opsOwner?: {
    __typename?: "UserRef"
    meetingSchedulingUrl?: string | null
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  parentRef?: { __typename?: "BundleParentRef"; pid: string } | null
  documents: Array<{
    __typename?: "Document"
    canDelete: boolean
    contentType: string
    dateCreated: string
    fileName: string
    ownerName: string
    pid: string
    tag?: DocumentTag | null
    downloadHref: string
    viewHref: string
    belongsToBundleParent: boolean
  }>
  rows: Array<{
    __typename?: "BundleRow2"
    id: number
    ppaType?: PpaProductType | null
    state?: BundleState | null
    reason?: CloseReason | null
    customReason?: string | null
    notes?: string | null
    site: {
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      fullAddress: string
      streetAddress: string
      city: string
      state: string
      zipCode: string
      county: string
      cbsaName?: string | null
      doeReferenceType?: BuildingType | null
      yearBuilt?: number | null
      isEnergyCommunity: boolean
      isLowIncomeCommunity?: boolean | null
      sqft?: number | null
      roofSqft?: number | null
      roofMaxPvKw: number
      numStories?: number | null
      buildingClass?: string | null
      buildingData?: { __typename?: "BuildingData"; ownerName?: string | null } | null
      siteDetails: {
        __typename?: "SiteDetails"
        roofReplacedYr?: number | null
        roofCondition?: string | null
      }
      targetUtility?: {
        __typename?: "Utility"
        pid: string
        name: string
        hostingCapacityMaps: Array<{
          __typename?: "HostingCapacityMap"
          url: string
          requiresLogin: boolean
          types: Array<HostingCapacityMapType>
        }>
      } | null
    }
    optOut?: {
      __typename: "InvestorOptOut"
      createdAt: string
      archivedAt?: string | null
      reason?: InvestorOptOutReason | null
      customReason?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
    bids: Array<{
      __typename?: "InvestorBid"
      ppa?: {
        __typename: "PPAInvestorBid"
        pid: string
        name?: string | null
        termYears: number
        ppaPriceY1Usd: number
        ppaPriceEscalator: number
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedCod: string
        estimatedNtp: string
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        recOwner: RecOwner
        tariffProvision?: boolean | null
        otherNotes?: string | null
        extraPaymentsNotes?: string | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        status?: InvestorBidStatus | null
        spec?: { __typename?: "PPABidSpec"; pid: string } | null
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        system: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }
        result?: {
          __typename: "RevampFinmodel"
          id: number
          pid: string
          createdAt: string
          type: FinProductType
          intervalsAndCostsXlsxHref: string
          buildingOwnerXlsxHref?: string | null
          offerStatus: OfferStatus
          fmvStr: string
          totalPvProductionKwh: number
          totalPvExportKwh?: number | null
          bauCostPerYear: Array<number>
          derCostPerYear: Array<number>
          goal?: PVoptGoal | null
          isVnem: boolean
          isGreenLease: boolean
          thirdPartySupplier?: {
            __typename?: "ThirdPartySupplier"
            pid: string
            name: string
          } | null
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          ppa?: {
            __typename: "PPAEconomics"
            ppaType: PpaProductType
            ppaCostPerKwh: number
            ppaTermYears: number
            ppaEsc?: number | null
            srecToInvestor: boolean
            offtakerXlsxHref: string
            product: {
              __typename?: "PPAFinProduct"
              productName: string
              financierName: string
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              roofRentPerYear: Array<number>
            } | null
            tenantFlows?: {
              __typename?: "TenantCashflows"
              npv: number
              discountRate: number
              totalUtilitySavings: number
              totalCapex: number
              totalOpex: number
              totalNet: number
              netCashflowPerYear: Array<number>
            } | null
          } | null
          loan?: {
            __typename: "LoanEconomics"
            loanRecvrXlsxHref: string
            loanTermYears: number
            ownershipTermYears: number
            interestPct: number
            srecToInvestor: boolean
            product: {
              __typename?: "LoanFinProduct"
              productName: string
              financierName: string
              loanDealerFeePct: number
            }
            flows?: {
              __typename?: "LoanRecvrCashflows"
              monthlyPayment: number
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalLoanFunding: number
              totalLoanPayments: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          selfInvest?: {
            __typename: "SelfInvestEconomics"
            npv: number
            discountRate: number
            selfInvestXlsxHref: string
            termYears: number
            srecToInvestor: boolean
            irrs: {
              __typename?: "IRRs"
              postTaxItcDepr?: number | null
              postTaxItcDeprMultiple?: number | null
            }
            product: {
              __typename?: "SelfInvestFinProduct"
              productName: string
              financierName: string
            }
            flows?: {
              __typename?: "SelfInvestCashflows"
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          meters: Array<{
            __typename?: "RevampMeter"
            name: string
            loadCategory: LoadCategory
            meterSource: MeterSource
            bau: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
            }
            der?: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
              averageDayKwhFlow: Array<{
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }>
            } | null
          }>
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          utilityCosts: {
            __typename?: "UtilityCost"
            bau: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
            der: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
          }
        } | null
      } | null
      cs?: {
        __typename: "CSInvestorBid"
        pid: string
        name?: string | null
        termYears: number
        roofRentEscalator: number
        roofRentY1Usd: number
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedAwardDate?: string | null
        estimatedCod: string
        estimatedNtp: string
        recOwner: RecOwner
        tariffProvision?: boolean | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        extraPaymentsNotes?: string | null
        otherNotes?: string | null
        status?: InvestorBidStatus | null
        spec?: { __typename?: "CSBidSpec"; pid: string } | null
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        systemLite: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        }
        result?: {
          __typename: "RevampCS"
          id: number
          termYears: number
          createdAt: string
          goal?: PVoptGoal | null
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          financing: {
            __typename?: "RevampFinancing"
            id: number
            name: string
            type: FinProductType
            financierName: string
            financierPid: string
            financierLogo?: string | null
            financierLogomark?: string | null
            isThirdParty: boolean
          }
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            npv: number
            discountRate: number
            roofRentPerYear: Array<number>
          } | null
          pricing: {
            __typename?: "CSPrice"
            usdPerKwPerYear: number
            escalator: number
            minPvKw: number
            maxPvKw: number
            utility: { __typename?: "RevampUtility"; id: number; name: string }
          }
          leaseProjections?: {
            __typename?: "CSLeaseProjections"
            systemSizeKw: number
            annualRentLowerRangeUsd: number
            annualRentUpperRangeUsd: number
            methodology: CsLeaseProjectionMethdology
          } | null
        } | null
      } | null
    }>
    specs: Array<{
      __typename?: "BidSpec"
      ppa?: {
        __typename: "PPABidSpec"
        id: number
        pid: string
        name?: string | null
        termYears?: number | null
        note?: string | null
        archivedAt?: string | null
        ppaPriceY1Usd?: number | null
        ppaPriceEscalator?: number | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        itcPercentageAssumption?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        recOwner?: RecOwner | null
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        system?: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        } | null
      } | null
      cs?: {
        __typename: "CSBidSpec"
        id: number
        pid: string
        name?: string | null
        termYears?: number | null
        note?: string | null
        archivedAt?: string | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        itcPercentageAssumption?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        recOwner?: RecOwner | null
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        systemLite?: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        } | null
      } | null
      optOut?: {
        __typename: "InvestorBidSpecOptOut"
        createdAt: string
        archivedAt?: string | null
        reason?: SpecOptOutReason | null
        customReason?: string | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      } | null
    }>
  }>
  bidReports?: Array<{
    __typename?: "PackageBidReport"
    pid?: string | null
    name?: string | null
    notes?: string | null
    visible: boolean
    totalDevelopers: number
    totalBids: number
    cs?: Array<{
      __typename: "CSSiteBidReport"
      awarded: boolean
      awardedPid?: string | null
      totalBids: number
      site: {
        __typename?: "RevampSite"
        pid: string
        name?: string | null
        isFavorite: boolean
        streetAddress: string
        city: string
        state: string
        zipCode: string
        county: string
        fullAddress: string
      }
      bids: Array<{
        __typename: "CSInvestorBid"
        name?: string | null
        pid: string
        termYears: number
        roofRentEscalator: number
        roofRentY1Usd: number
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedAwardDate?: string | null
        estimatedCod: string
        estimatedNtp: string
        recOwner: RecOwner
        tariffProvision?: boolean | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        extraPaymentsNotes?: string | null
        otherNotes?: string | null
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        result?: {
          __typename?: "RevampCS"
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiLifetime?: number | null
          }
        } | null
      }>
      noi?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      y1RoofRent?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      systemSize?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      itcPercentageAssumption?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      roofRentEscalator?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      npv?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
    }> | null
    ppa?: Array<{
      __typename: "PPASiteBidReport"
      awarded: boolean
      awardedPid?: string | null
      totalBids: number
      site: {
        __typename?: "RevampSite"
        pid: string
        name?: string | null
        isFavorite: boolean
        streetAddress: string
        city: string
        state: string
        zipCode: string
        county: string
        fullAddress: string
      }
      bids: Array<{
        __typename: "PPAInvestorBid"
        name?: string | null
        pid: string
        termYears: number
        roofRentEscalator?: number | null
        roofRentY1Usd?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedCod: string
        estimatedNtp: string
        recOwner: RecOwner
        tariffProvision?: boolean | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        extraPaymentsNotes?: string | null
        otherNotes?: string | null
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        result?: {
          __typename?: "RevampFinmodel"
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiLifetime?: number | null
          }
        } | null
      }>
      noi?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      y1RoofRent?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      systemSize?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      itcPercentageAssumption?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      ppaPriceEscalator?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
      npv?: {
        __typename?: "BoxplotStats"
        min: number
        q1: number
        median: number
        q3: number
        max: number
        average: number
      } | null
    }> | null
  }> | null
  optOut?: {
    __typename: "InvestorOptOut"
    createdAt: string
    archivedAt?: string | null
    reason?: InvestorOptOutReason | null
    customReason?: string | null
    createdBy: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }
    archivedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  } | null
  recvr: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
  financier: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
  bidSubmissionStatus: {
    __typename?: "BundleBidSubmissionSummary"
    bidStatus: BundleBidSubmissionStatus
    submittedBidCount?: number | null
    totalRequestedBids?: number | null
  }
  awardStatus?: {
    __typename?: "BundleAwardStatusSummary"
    awardStatus: BundleAwardStatus
    awardedBidCount?: number | null
    totalPossibleAwards?: number | null
  } | null
}

export type BundleDetailRowFragment = {
  __typename?: "BundleRow2"
  id: number
  ppaType?: PpaProductType | null
  state?: BundleState | null
  reason?: CloseReason | null
  customReason?: string | null
  notes?: string | null
  optOut?: {
    __typename: "InvestorOptOut"
    createdAt: string
    archivedAt?: string | null
    reason?: InvestorOptOutReason | null
    customReason?: string | null
    createdBy: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }
    archivedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  } | null
  bids: Array<{
    __typename?: "InvestorBid"
    ppa?: {
      __typename: "PPAInvestorBid"
      pid: string
      name?: string | null
      termYears: number
      ppaPriceY1Usd: number
      ppaPriceEscalator: number
      roofRentY1Usd?: number | null
      roofRentEscalator?: number | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      itcPercentageAssumption: number
      estimatedCod: string
      estimatedNtp: string
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      recOwner: RecOwner
      tariffProvision?: boolean | null
      otherNotes?: string | null
      extraPaymentsNotes?: string | null
      incentivesNotes?: string | null
      interconnectionNotes?: string | null
      interconnectionRepriceProcessNotes?: string | null
      status?: InvestorBidStatus | null
      spec?: { __typename?: "PPABidSpec"; pid: string } | null
      financier: {
        __typename?: "OrgRef"
        pid: string
        name: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }
      system: {
        __typename?: "System"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpec"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes?: string | null
          etbMeterName: string
          document?: {
            __typename?: "Document"
            id: number
            pid: string
            fileName: string
            downloadHref: string
          } | null
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      }
      result?: {
        __typename: "RevampFinmodel"
        id: number
        pid: string
        createdAt: string
        type: FinProductType
        intervalsAndCostsXlsxHref: string
        buildingOwnerXlsxHref?: string | null
        offerStatus: OfferStatus
        fmvStr: string
        totalPvProductionKwh: number
        totalPvExportKwh?: number | null
        bauCostPerYear: Array<number>
        derCostPerYear: Array<number>
        goal?: PVoptGoal | null
        isVnem: boolean
        isGreenLease: boolean
        thirdPartySupplier?: {
          __typename?: "ThirdPartySupplier"
          pid: string
          name: string
        } | null
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        ppa?: {
          __typename: "PPAEconomics"
          ppaType: PpaProductType
          ppaCostPerKwh: number
          ppaTermYears: number
          ppaEsc?: number | null
          srecToInvestor: boolean
          offtakerXlsxHref: string
          product: {
            __typename?: "PPAFinProduct"
            productName: string
            financierName: string
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            roofRentPerYear: Array<number>
          } | null
          tenantFlows?: {
            __typename?: "TenantCashflows"
            npv: number
            discountRate: number
            totalUtilitySavings: number
            totalCapex: number
            totalOpex: number
            totalNet: number
            netCashflowPerYear: Array<number>
          } | null
        } | null
        loan?: {
          __typename: "LoanEconomics"
          loanRecvrXlsxHref: string
          loanTermYears: number
          ownershipTermYears: number
          interestPct: number
          srecToInvestor: boolean
          product: {
            __typename?: "LoanFinProduct"
            productName: string
            financierName: string
            loanDealerFeePct: number
          }
          flows?: {
            __typename?: "LoanRecvrCashflows"
            monthlyPayment: number
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalLoanFunding: number
            totalLoanPayments: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        selfInvest?: {
          __typename: "SelfInvestEconomics"
          npv: number
          discountRate: number
          selfInvestXlsxHref: string
          termYears: number
          srecToInvestor: boolean
          irrs: {
            __typename?: "IRRs"
            postTaxItcDepr?: number | null
            postTaxItcDeprMultiple?: number | null
          }
          product: {
            __typename?: "SelfInvestFinProduct"
            productName: string
            financierName: string
          }
          flows?: {
            __typename?: "SelfInvestCashflows"
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        meters: Array<{
          __typename?: "RevampMeter"
          name: string
          loadCategory: LoadCategory
          meterSource: MeterSource
          bau: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
          }
          der?: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
            averageDayKwhFlow: Array<{
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }>
          } | null
        }>
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        utilityCosts: {
          __typename?: "UtilityCost"
          bau: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
          der: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
        }
      } | null
    } | null
    cs?: {
      __typename: "CSInvestorBid"
      pid: string
      name?: string | null
      termYears: number
      roofRentEscalator: number
      roofRentY1Usd: number
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      itcPercentageAssumption: number
      estimatedAwardDate?: string | null
      estimatedCod: string
      estimatedNtp: string
      recOwner: RecOwner
      tariffProvision?: boolean | null
      incentivesNotes?: string | null
      interconnectionNotes?: string | null
      interconnectionRepriceProcessNotes?: string | null
      extraPaymentsNotes?: string | null
      otherNotes?: string | null
      status?: InvestorBidStatus | null
      spec?: { __typename?: "CSBidSpec"; pid: string } | null
      financier: {
        __typename?: "OrgRef"
        pid: string
        name: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }
      systemLite: {
        __typename?: "SystemLite"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpecLite"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes: string
        }>
      }
      result?: {
        __typename: "RevampCS"
        id: number
        termYears: number
        createdAt: string
        goal?: PVoptGoal | null
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
        }
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        roofRent?: {
          __typename?: "RoofRentEconomics"
          lifetimeUsd: number
          annualUsd: number
          usdPerSqft: number
          npv: number
          discountRate: number
          roofRentPerYear: Array<number>
        } | null
        pricing: {
          __typename?: "CSPrice"
          usdPerKwPerYear: number
          escalator: number
          minPvKw: number
          maxPvKw: number
          utility: { __typename?: "RevampUtility"; id: number; name: string }
        }
        leaseProjections?: {
          __typename?: "CSLeaseProjections"
          systemSizeKw: number
          annualRentLowerRangeUsd: number
          annualRentUpperRangeUsd: number
          methodology: CsLeaseProjectionMethdology
        } | null
      } | null
    } | null
  }>
  specs: Array<{
    __typename?: "BidSpec"
    ppa?: {
      __typename: "PPABidSpec"
      id: number
      pid: string
      name?: string | null
      termYears?: number | null
      note?: string | null
      archivedAt?: string | null
      ppaPriceY1Usd?: number | null
      ppaPriceEscalator?: number | null
      roofRentY1Usd?: number | null
      roofRentEscalator?: number | null
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      itcPercentageAssumption?: number | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      recOwner?: RecOwner | null
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      system?: {
        __typename?: "System"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpec"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes?: string | null
          etbMeterName: string
          document?: {
            __typename?: "Document"
            id: number
            pid: string
            fileName: string
            downloadHref: string
          } | null
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      } | null
    } | null
    cs?: {
      __typename: "CSBidSpec"
      id: number
      pid: string
      name?: string | null
      termYears?: number | null
      note?: string | null
      archivedAt?: string | null
      roofRentY1Usd?: number | null
      roofRentEscalator?: number | null
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      itcPercentageAssumption?: number | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      recOwner?: RecOwner | null
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      systemLite?: {
        __typename?: "SystemLite"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpecLite"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes: string
        }>
      } | null
    } | null
    optOut?: {
      __typename: "InvestorBidSpecOptOut"
      createdAt: string
      archivedAt?: string | null
      reason?: SpecOptOutReason | null
      customReason?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
  }>
}

export type BidSpecFragment = {
  __typename?: "BidSpec"
  ppa?: {
    __typename: "PPABidSpec"
    id: number
    pid: string
    name?: string | null
    termYears?: number | null
    note?: string | null
    archivedAt?: string | null
    ppaPriceY1Usd?: number | null
    ppaPriceEscalator?: number | null
    roofRentY1Usd?: number | null
    roofRentEscalator?: number | null
    buildingOwnerExtraPaymentsUsd?: Array<number> | null
    itcPercentageAssumption?: number | null
    interconnectionCostUsdPerWatt?: number | null
    interconnectionCostUtilityMinUsd?: number | null
    interconnectionCostUtilityMaxUsd?: number | null
    interconnectionCostNonUtilityUsd?: number | null
    recOwner?: RecOwner | null
    archivedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    system?: {
      __typename?: "System"
      id: number
      pid: string
      createdAt: string
      totalPvSizeKw: number
      pvSpecs: Array<{
        __typename?: "PVSpec"
        id: number
        createdAt: string
        pvTypes: Array<PvType>
        sizeKwDc: number
        sizeKwAc?: number | null
        helioscope2Id?: number | null
        etbMeterId?: number | null
        helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
        roofImage?: { __typename?: "Document"; viewHref: string } | null
        productionCsv?: { __typename?: "Document"; downloadHref: string } | null
        productionSource?: {
          __typename?: "PVProductionSource"
          id: number
          origin: ProductionOrigin
        } | null
        allocations: Array<{
          __typename?: "PVAllocation"
          id: number
          createdAt: string
          percentage: number
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      }>
      batterySpecs: Array<{
        __typename?: "BatterySpec"
        id: number
        sizeKwh: number
        sizeKwDc: number
        notes?: string | null
        etbMeterName: string
        document?: {
          __typename?: "Document"
          id: number
          pid: string
          fileName: string
          downloadHref: string
        } | null
        meter: {
          __typename?: "BillingMeter"
          pid: string
          view: { __typename?: "BillingMeterView"; name: string }
        }
      }>
    } | null
  } | null
  cs?: {
    __typename: "CSBidSpec"
    id: number
    pid: string
    name?: string | null
    termYears?: number | null
    note?: string | null
    archivedAt?: string | null
    roofRentY1Usd?: number | null
    roofRentEscalator?: number | null
    buildingOwnerExtraPaymentsUsd?: Array<number> | null
    itcPercentageAssumption?: number | null
    interconnectionCostUsdPerWatt?: number | null
    interconnectionCostUtilityMinUsd?: number | null
    interconnectionCostUtilityMaxUsd?: number | null
    interconnectionCostNonUtilityUsd?: number | null
    recOwner?: RecOwner | null
    archivedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    systemLite?: {
      __typename?: "SystemLite"
      id: number
      pid: string
      createdAt: string
      totalPvSizeKw: number
      pvSpecs: Array<{
        __typename?: "PVSpec"
        id: number
        createdAt: string
        pvTypes: Array<PvType>
        sizeKwDc: number
        sizeKwAc?: number | null
        helioscope2Id?: number | null
        etbMeterId?: number | null
        helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
        roofImage?: { __typename?: "Document"; viewHref: string } | null
        productionCsv?: { __typename?: "Document"; downloadHref: string } | null
        productionSource?: {
          __typename?: "PVProductionSource"
          id: number
          origin: ProductionOrigin
        } | null
        allocations: Array<{
          __typename?: "PVAllocation"
          id: number
          createdAt: string
          percentage: number
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      }>
      batterySpecs: Array<{
        __typename?: "BatterySpecLite"
        id: number
        sizeKwh: number
        sizeKwDc: number
        notes: string
      }>
    } | null
  } | null
  optOut?: {
    __typename: "InvestorBidSpecOptOut"
    createdAt: string
    archivedAt?: string | null
    reason?: SpecOptOutReason | null
    customReason?: string | null
    createdBy: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }
    archivedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  } | null
}

export type PpaBidSpecFragment = {
  __typename: "PPABidSpec"
  id: number
  pid: string
  name?: string | null
  termYears?: number | null
  note?: string | null
  archivedAt?: string | null
  ppaPriceY1Usd?: number | null
  ppaPriceEscalator?: number | null
  roofRentY1Usd?: number | null
  roofRentEscalator?: number | null
  buildingOwnerExtraPaymentsUsd?: Array<number> | null
  itcPercentageAssumption?: number | null
  interconnectionCostUsdPerWatt?: number | null
  interconnectionCostUtilityMinUsd?: number | null
  interconnectionCostUtilityMaxUsd?: number | null
  interconnectionCostNonUtilityUsd?: number | null
  recOwner?: RecOwner | null
  archivedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  system?: {
    __typename?: "System"
    id: number
    pid: string
    createdAt: string
    totalPvSizeKw: number
    pvSpecs: Array<{
      __typename?: "PVSpec"
      id: number
      createdAt: string
      pvTypes: Array<PvType>
      sizeKwDc: number
      sizeKwAc?: number | null
      helioscope2Id?: number | null
      etbMeterId?: number | null
      helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
      roofImage?: { __typename?: "Document"; viewHref: string } | null
      productionCsv?: { __typename?: "Document"; downloadHref: string } | null
      productionSource?: {
        __typename?: "PVProductionSource"
        id: number
        origin: ProductionOrigin
      } | null
      allocations: Array<{
        __typename?: "PVAllocation"
        id: number
        createdAt: string
        percentage: number
        meter: {
          __typename?: "BillingMeter"
          pid: string
          view: { __typename?: "BillingMeterView"; name: string }
        }
      }>
    }>
    batterySpecs: Array<{
      __typename?: "BatterySpec"
      id: number
      sizeKwh: number
      sizeKwDc: number
      notes?: string | null
      etbMeterName: string
      document?: {
        __typename?: "Document"
        id: number
        pid: string
        fileName: string
        downloadHref: string
      } | null
      meter: {
        __typename?: "BillingMeter"
        pid: string
        view: { __typename?: "BillingMeterView"; name: string }
      }
    }>
  } | null
}

export type CsBidSpecFragment = {
  __typename: "CSBidSpec"
  id: number
  pid: string
  name?: string | null
  termYears?: number | null
  note?: string | null
  archivedAt?: string | null
  roofRentY1Usd?: number | null
  roofRentEscalator?: number | null
  buildingOwnerExtraPaymentsUsd?: Array<number> | null
  itcPercentageAssumption?: number | null
  interconnectionCostUsdPerWatt?: number | null
  interconnectionCostUtilityMinUsd?: number | null
  interconnectionCostUtilityMaxUsd?: number | null
  interconnectionCostNonUtilityUsd?: number | null
  recOwner?: RecOwner | null
  archivedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  systemLite?: {
    __typename?: "SystemLite"
    id: number
    pid: string
    createdAt: string
    totalPvSizeKw: number
    pvSpecs: Array<{
      __typename?: "PVSpec"
      id: number
      createdAt: string
      pvTypes: Array<PvType>
      sizeKwDc: number
      sizeKwAc?: number | null
      helioscope2Id?: number | null
      etbMeterId?: number | null
      helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
      roofImage?: { __typename?: "Document"; viewHref: string } | null
      productionCsv?: { __typename?: "Document"; downloadHref: string } | null
      productionSource?: {
        __typename?: "PVProductionSource"
        id: number
        origin: ProductionOrigin
      } | null
      allocations: Array<{
        __typename?: "PVAllocation"
        id: number
        createdAt: string
        percentage: number
        meter: {
          __typename?: "BillingMeter"
          pid: string
          view: { __typename?: "BillingMeterView"; name: string }
        }
      }>
    }>
    batterySpecs: Array<{
      __typename?: "BatterySpecLite"
      id: number
      sizeKwh: number
      sizeKwDc: number
      notes: string
    }>
  } | null
}

export type InvestorBidFragment = {
  __typename?: "InvestorBid"
  ppa?: {
    __typename: "PPAInvestorBid"
    pid: string
    name?: string | null
    termYears: number
    ppaPriceY1Usd: number
    ppaPriceEscalator: number
    roofRentY1Usd?: number | null
    roofRentEscalator?: number | null
    interconnectionCostUsdPerWatt?: number | null
    interconnectionCostUtilityMinUsd?: number | null
    interconnectionCostUtilityMaxUsd?: number | null
    interconnectionCostNonUtilityUsd?: number | null
    itcPercentageAssumption: number
    estimatedCod: string
    estimatedNtp: string
    buildingOwnerExtraPaymentsUsd?: Array<number> | null
    recOwner: RecOwner
    tariffProvision?: boolean | null
    otherNotes?: string | null
    extraPaymentsNotes?: string | null
    incentivesNotes?: string | null
    interconnectionNotes?: string | null
    interconnectionRepriceProcessNotes?: string | null
    status?: InvestorBidStatus | null
    spec?: { __typename?: "PPABidSpec"; pid: string } | null
    financier: {
      __typename?: "OrgRef"
      pid: string
      name: string
      logoUrl: string
      logomarkUrl?: string | null
      profile?: {
        __typename?: "InvestorProfile"
        hq?: string | null
        yearFounded?: number | null
        website?: string | null
        description?: string | null
        committedFunding?: string | null
        distinguishingFeatures?: string | null
        investorBacking?: string | null
        managementTeam: Array<string>
        longTermOwnershipApproach?: string | null
        subscriptionMgmtApproach?: string | null
        experiences: Array<{
          __typename?: "Experience"
          state?: UsState | null
          ftmEnergizedPvKw?: number | null
          ftmAwardedPvKw?: number | null
          btmEnergizedPvKw?: number | null
          btmAwardedPvKw?: number | null
        }>
        buyBoxes: Array<{
          __typename?: "BuyBox"
          state?: UsState | null
          ftmMinPortfolioSize?: number | null
          ftmMinProjectSize?: number | null
          ftmSeekingProjects?: boolean | null
          btmMinPortfolioSize?: number | null
          btmMinProjectSize?: number | null
          btmSeekingProjects?: boolean | null
        }>
      } | null
    }
    system: {
      __typename?: "System"
      id: number
      pid: string
      createdAt: string
      totalPvSizeKw: number
      pvSpecs: Array<{
        __typename?: "PVSpec"
        id: number
        createdAt: string
        pvTypes: Array<PvType>
        sizeKwDc: number
        sizeKwAc?: number | null
        helioscope2Id?: number | null
        etbMeterId?: number | null
        helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
        roofImage?: { __typename?: "Document"; viewHref: string } | null
        productionCsv?: { __typename?: "Document"; downloadHref: string } | null
        productionSource?: {
          __typename?: "PVProductionSource"
          id: number
          origin: ProductionOrigin
        } | null
        allocations: Array<{
          __typename?: "PVAllocation"
          id: number
          createdAt: string
          percentage: number
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      }>
      batterySpecs: Array<{
        __typename?: "BatterySpec"
        id: number
        sizeKwh: number
        sizeKwDc: number
        notes?: string | null
        etbMeterName: string
        document?: {
          __typename?: "Document"
          id: number
          pid: string
          fileName: string
          downloadHref: string
        } | null
        meter: {
          __typename?: "BillingMeter"
          pid: string
          view: { __typename?: "BillingMeterView"; name: string }
        }
      }>
    }
    result?: {
      __typename: "RevampFinmodel"
      id: number
      pid: string
      createdAt: string
      type: FinProductType
      intervalsAndCostsXlsxHref: string
      buildingOwnerXlsxHref?: string | null
      offerStatus: OfferStatus
      fmvStr: string
      totalPvProductionKwh: number
      totalPvExportKwh?: number | null
      bauCostPerYear: Array<number>
      derCostPerYear: Array<number>
      goal?: PVoptGoal | null
      isVnem: boolean
      isGreenLease: boolean
      thirdPartySupplier?: {
        __typename?: "ThirdPartySupplier"
        pid: string
        name: string
      } | null
      buildingOwner: {
        __typename?: "BuildingOwnerEconomics"
        noiYearOne?: number | null
        noiLifetime?: number | null
        noiAnnual?: number | null
      }
      ppa?: {
        __typename: "PPAEconomics"
        ppaType: PpaProductType
        ppaCostPerKwh: number
        ppaTermYears: number
        ppaEsc?: number | null
        srecToInvestor: boolean
        offtakerXlsxHref: string
        product: {
          __typename?: "PPAFinProduct"
          productName: string
          financierName: string
        }
        roofRent?: {
          __typename?: "RoofRentEconomics"
          lifetimeUsd: number
          annualUsd: number
          usdPerSqft: number
          roofRentPerYear: Array<number>
        } | null
        tenantFlows?: {
          __typename?: "TenantCashflows"
          npv: number
          discountRate: number
          totalUtilitySavings: number
          totalCapex: number
          totalOpex: number
          totalNet: number
          netCashflowPerYear: Array<number>
        } | null
      } | null
      loan?: {
        __typename: "LoanEconomics"
        loanRecvrXlsxHref: string
        loanTermYears: number
        ownershipTermYears: number
        interestPct: number
        srecToInvestor: boolean
        product: {
          __typename?: "LoanFinProduct"
          productName: string
          financierName: string
          loanDealerFeePct: number
        }
        flows?: {
          __typename?: "LoanRecvrCashflows"
          monthlyPayment: number
          totalRevenue: number
          totalUtilitySavings: number
          totalOpex: number
          totalCapex: number
          totalItc: number
          totalLoanFunding: number
          totalLoanPayments: number
          totalNet: number
          netCashflowPerYear: Array<number>
          greenLeaseTenantFlows?: {
            __typename?: "TenantCashflows"
            totalNet: number
            netCashflowPerYear: Array<number>
            totalCapex: number
            totalOpex: number
            totalUtilitySavings: number
            npv: number
            discountRate: number
          } | null
        } | null
      } | null
      selfInvest?: {
        __typename: "SelfInvestEconomics"
        npv: number
        discountRate: number
        selfInvestXlsxHref: string
        termYears: number
        srecToInvestor: boolean
        irrs: {
          __typename?: "IRRs"
          postTaxItcDepr?: number | null
          postTaxItcDeprMultiple?: number | null
        }
        product: {
          __typename?: "SelfInvestFinProduct"
          productName: string
          financierName: string
        }
        flows?: {
          __typename?: "SelfInvestCashflows"
          totalRevenue: number
          totalUtilitySavings: number
          totalOpex: number
          totalCapex: number
          totalItc: number
          totalNet: number
          netCashflowPerYear: Array<number>
          greenLeaseTenantFlows?: {
            __typename?: "TenantCashflows"
            totalNet: number
            netCashflowPerYear: Array<number>
            totalCapex: number
            totalOpex: number
            totalUtilitySavings: number
            npv: number
            discountRate: number
          } | null
        } | null
      } | null
      meters: Array<{
        __typename?: "RevampMeter"
        name: string
        loadCategory: LoadCategory
        meterSource: MeterSource
        bau: {
          __typename?: "RevampDer"
          totalKwhFlow: {
            __typename?: "KwhFlow"
            bauLoadKwh: number
            importsKwh: number
            exportsKwh: number
            pvProductionKwh: number
            pvToLoadKwh: number
            batteryChargeKwh: number
            batteryDischargeKwh: number
          }
        }
        der?: {
          __typename?: "RevampDer"
          totalKwhFlow: {
            __typename?: "KwhFlow"
            bauLoadKwh: number
            importsKwh: number
            exportsKwh: number
            pvProductionKwh: number
            pvToLoadKwh: number
            batteryChargeKwh: number
            batteryDischargeKwh: number
          }
          averageDayKwhFlow: Array<{
            __typename?: "KwhFlow"
            bauLoadKwh: number
            importsKwh: number
            exportsKwh: number
            pvProductionKwh: number
            pvToLoadKwh: number
            batteryChargeKwh: number
            batteryDischargeKwh: number
          }>
        } | null
      }>
      systems: Array<
        | {
            __typename: "BatterySystem"
            vendor: BatteryVendor
            sizeKw: number
            sizeKwh: number
            assumptions: { __typename?: "BattAssumptions"; battChemName: string }
          }
        | { __typename: "PVSystem"; type: PvType; sizeKw: number }
      >
      utilityCosts: {
        __typename?: "UtilityCost"
        bau: {
          __typename?: "FinmodelCost"
          totalKwh: number
          totalCostUsd: number
          usdPerKwh: number
          items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
          tariffs: Array<{
            __typename?: "RevampTariff"
            id: number
            name: string
            code: string
            startDate: string
            endDate?: string | null
            utility: {
              __typename?: "RevampUtility"
              id: number
              name: string
              shortName: string
            }
          }>
        }
        der: {
          __typename?: "FinmodelCost"
          totalKwh: number
          totalCostUsd: number
          usdPerKwh: number
          items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
          tariffs: Array<{
            __typename?: "RevampTariff"
            id: number
            name: string
            code: string
            startDate: string
            endDate?: string | null
            utility: {
              __typename?: "RevampUtility"
              id: number
              name: string
              shortName: string
            }
          }>
        }
      }
    } | null
  } | null
  cs?: {
    __typename: "CSInvestorBid"
    pid: string
    name?: string | null
    termYears: number
    roofRentEscalator: number
    roofRentY1Usd: number
    buildingOwnerExtraPaymentsUsd?: Array<number> | null
    interconnectionCostUsdPerWatt?: number | null
    interconnectionCostUtilityMinUsd?: number | null
    interconnectionCostUtilityMaxUsd?: number | null
    interconnectionCostNonUtilityUsd?: number | null
    itcPercentageAssumption: number
    estimatedAwardDate?: string | null
    estimatedCod: string
    estimatedNtp: string
    recOwner: RecOwner
    tariffProvision?: boolean | null
    incentivesNotes?: string | null
    interconnectionNotes?: string | null
    interconnectionRepriceProcessNotes?: string | null
    extraPaymentsNotes?: string | null
    otherNotes?: string | null
    status?: InvestorBidStatus | null
    spec?: { __typename?: "CSBidSpec"; pid: string } | null
    financier: {
      __typename?: "OrgRef"
      pid: string
      name: string
      logoUrl: string
      logomarkUrl?: string | null
      profile?: {
        __typename?: "InvestorProfile"
        hq?: string | null
        yearFounded?: number | null
        website?: string | null
        description?: string | null
        committedFunding?: string | null
        distinguishingFeatures?: string | null
        investorBacking?: string | null
        managementTeam: Array<string>
        longTermOwnershipApproach?: string | null
        subscriptionMgmtApproach?: string | null
        experiences: Array<{
          __typename?: "Experience"
          state?: UsState | null
          ftmEnergizedPvKw?: number | null
          ftmAwardedPvKw?: number | null
          btmEnergizedPvKw?: number | null
          btmAwardedPvKw?: number | null
        }>
        buyBoxes: Array<{
          __typename?: "BuyBox"
          state?: UsState | null
          ftmMinPortfolioSize?: number | null
          ftmMinProjectSize?: number | null
          ftmSeekingProjects?: boolean | null
          btmMinPortfolioSize?: number | null
          btmMinProjectSize?: number | null
          btmSeekingProjects?: boolean | null
        }>
      } | null
    }
    systemLite: {
      __typename?: "SystemLite"
      id: number
      pid: string
      createdAt: string
      totalPvSizeKw: number
      pvSpecs: Array<{
        __typename?: "PVSpec"
        id: number
        createdAt: string
        pvTypes: Array<PvType>
        sizeKwDc: number
        sizeKwAc?: number | null
        helioscope2Id?: number | null
        etbMeterId?: number | null
        helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
        roofImage?: { __typename?: "Document"; viewHref: string } | null
        productionCsv?: { __typename?: "Document"; downloadHref: string } | null
        productionSource?: {
          __typename?: "PVProductionSource"
          id: number
          origin: ProductionOrigin
        } | null
        allocations: Array<{
          __typename?: "PVAllocation"
          id: number
          createdAt: string
          percentage: number
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      }>
      batterySpecs: Array<{
        __typename?: "BatterySpecLite"
        id: number
        sizeKwh: number
        sizeKwDc: number
        notes: string
      }>
    }
    result?: {
      __typename: "RevampCS"
      id: number
      termYears: number
      createdAt: string
      goal?: PVoptGoal | null
      systems: Array<
        | {
            __typename: "BatterySystem"
            vendor: BatteryVendor
            sizeKw: number
            sizeKwh: number
            assumptions: { __typename?: "BattAssumptions"; battChemName: string }
          }
        | { __typename: "PVSystem"; type: PvType; sizeKw: number }
      >
      financing: {
        __typename?: "RevampFinancing"
        id: number
        name: string
        type: FinProductType
        financierName: string
        financierPid: string
        financierLogo?: string | null
        financierLogomark?: string | null
        isThirdParty: boolean
      }
      buildingOwner: {
        __typename?: "BuildingOwnerEconomics"
        noiYearOne?: number | null
        noiLifetime?: number | null
        noiAnnual?: number | null
      }
      roofRent?: {
        __typename?: "RoofRentEconomics"
        lifetimeUsd: number
        annualUsd: number
        usdPerSqft: number
        npv: number
        discountRate: number
        roofRentPerYear: Array<number>
      } | null
      pricing: {
        __typename?: "CSPrice"
        usdPerKwPerYear: number
        escalator: number
        minPvKw: number
        maxPvKw: number
        utility: { __typename?: "RevampUtility"; id: number; name: string }
      }
      leaseProjections?: {
        __typename?: "CSLeaseProjections"
        systemSizeKw: number
        annualRentLowerRangeUsd: number
        annualRentUpperRangeUsd: number
        methodology: CsLeaseProjectionMethdology
      } | null
    } | null
  } | null
}

export type CsInvestorBidFragment = {
  __typename: "CSInvestorBid"
  pid: string
  name?: string | null
  termYears: number
  roofRentEscalator: number
  roofRentY1Usd: number
  buildingOwnerExtraPaymentsUsd?: Array<number> | null
  interconnectionCostUsdPerWatt?: number | null
  interconnectionCostUtilityMinUsd?: number | null
  interconnectionCostUtilityMaxUsd?: number | null
  interconnectionCostNonUtilityUsd?: number | null
  itcPercentageAssumption: number
  estimatedAwardDate?: string | null
  estimatedCod: string
  estimatedNtp: string
  recOwner: RecOwner
  tariffProvision?: boolean | null
  incentivesNotes?: string | null
  interconnectionNotes?: string | null
  interconnectionRepriceProcessNotes?: string | null
  extraPaymentsNotes?: string | null
  otherNotes?: string | null
  status?: InvestorBidStatus | null
  spec?: { __typename?: "CSBidSpec"; pid: string } | null
  financier: {
    __typename?: "OrgRef"
    pid: string
    name: string
    logoUrl: string
    logomarkUrl?: string | null
    profile?: {
      __typename?: "InvestorProfile"
      hq?: string | null
      yearFounded?: number | null
      website?: string | null
      description?: string | null
      committedFunding?: string | null
      distinguishingFeatures?: string | null
      investorBacking?: string | null
      managementTeam: Array<string>
      longTermOwnershipApproach?: string | null
      subscriptionMgmtApproach?: string | null
      experiences: Array<{
        __typename?: "Experience"
        state?: UsState | null
        ftmEnergizedPvKw?: number | null
        ftmAwardedPvKw?: number | null
        btmEnergizedPvKw?: number | null
        btmAwardedPvKw?: number | null
      }>
      buyBoxes: Array<{
        __typename?: "BuyBox"
        state?: UsState | null
        ftmMinPortfolioSize?: number | null
        ftmMinProjectSize?: number | null
        ftmSeekingProjects?: boolean | null
        btmMinPortfolioSize?: number | null
        btmMinProjectSize?: number | null
        btmSeekingProjects?: boolean | null
      }>
    } | null
  }
  systemLite: {
    __typename?: "SystemLite"
    id: number
    pid: string
    createdAt: string
    totalPvSizeKw: number
    pvSpecs: Array<{
      __typename?: "PVSpec"
      id: number
      createdAt: string
      pvTypes: Array<PvType>
      sizeKwDc: number
      sizeKwAc?: number | null
      helioscope2Id?: number | null
      etbMeterId?: number | null
      helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
      roofImage?: { __typename?: "Document"; viewHref: string } | null
      productionCsv?: { __typename?: "Document"; downloadHref: string } | null
      productionSource?: {
        __typename?: "PVProductionSource"
        id: number
        origin: ProductionOrigin
      } | null
      allocations: Array<{
        __typename?: "PVAllocation"
        id: number
        createdAt: string
        percentage: number
        meter: {
          __typename?: "BillingMeter"
          pid: string
          view: { __typename?: "BillingMeterView"; name: string }
        }
      }>
    }>
    batterySpecs: Array<{
      __typename?: "BatterySpecLite"
      id: number
      sizeKwh: number
      sizeKwDc: number
      notes: string
    }>
  }
  result?: {
    __typename: "RevampCS"
    id: number
    termYears: number
    createdAt: string
    goal?: PVoptGoal | null
    systems: Array<
      | {
          __typename: "BatterySystem"
          vendor: BatteryVendor
          sizeKw: number
          sizeKwh: number
          assumptions: { __typename?: "BattAssumptions"; battChemName: string }
        }
      | { __typename: "PVSystem"; type: PvType; sizeKw: number }
    >
    financing: {
      __typename?: "RevampFinancing"
      id: number
      name: string
      type: FinProductType
      financierName: string
      financierPid: string
      financierLogo?: string | null
      financierLogomark?: string | null
      isThirdParty: boolean
    }
    buildingOwner: {
      __typename?: "BuildingOwnerEconomics"
      noiYearOne?: number | null
      noiLifetime?: number | null
      noiAnnual?: number | null
    }
    roofRent?: {
      __typename?: "RoofRentEconomics"
      lifetimeUsd: number
      annualUsd: number
      usdPerSqft: number
      npv: number
      discountRate: number
      roofRentPerYear: Array<number>
    } | null
    pricing: {
      __typename?: "CSPrice"
      usdPerKwPerYear: number
      escalator: number
      minPvKw: number
      maxPvKw: number
      utility: { __typename?: "RevampUtility"; id: number; name: string }
    }
    leaseProjections?: {
      __typename?: "CSLeaseProjections"
      systemSizeKw: number
      annualRentLowerRangeUsd: number
      annualRentUpperRangeUsd: number
      methodology: CsLeaseProjectionMethdology
    } | null
  } | null
}

export type SystemLiteFragment = {
  __typename?: "SystemLite"
  id: number
  pid: string
  createdAt: string
  totalPvSizeKw: number
  pvSpecs: Array<{
    __typename?: "PVSpec"
    id: number
    createdAt: string
    pvTypes: Array<PvType>
    sizeKwDc: number
    sizeKwAc?: number | null
    helioscope2Id?: number | null
    etbMeterId?: number | null
    helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
    roofImage?: { __typename?: "Document"; viewHref: string } | null
    productionCsv?: { __typename?: "Document"; downloadHref: string } | null
    productionSource?: {
      __typename?: "PVProductionSource"
      id: number
      origin: ProductionOrigin
    } | null
    allocations: Array<{
      __typename?: "PVAllocation"
      id: number
      createdAt: string
      percentage: number
      meter: {
        __typename?: "BillingMeter"
        pid: string
        view: { __typename?: "BillingMeterView"; name: string }
      }
    }>
  }>
  batterySpecs: Array<{
    __typename?: "BatterySpecLite"
    id: number
    sizeKwh: number
    sizeKwDc: number
    notes: string
  }>
}

export type PpaInvestorBidFragment = {
  __typename: "PPAInvestorBid"
  pid: string
  name?: string | null
  termYears: number
  ppaPriceY1Usd: number
  ppaPriceEscalator: number
  roofRentY1Usd?: number | null
  roofRentEscalator?: number | null
  interconnectionCostUsdPerWatt?: number | null
  interconnectionCostUtilityMinUsd?: number | null
  interconnectionCostUtilityMaxUsd?: number | null
  interconnectionCostNonUtilityUsd?: number | null
  itcPercentageAssumption: number
  estimatedCod: string
  estimatedNtp: string
  buildingOwnerExtraPaymentsUsd?: Array<number> | null
  recOwner: RecOwner
  tariffProvision?: boolean | null
  otherNotes?: string | null
  extraPaymentsNotes?: string | null
  incentivesNotes?: string | null
  interconnectionNotes?: string | null
  interconnectionRepriceProcessNotes?: string | null
  status?: InvestorBidStatus | null
  spec?: { __typename?: "PPABidSpec"; pid: string } | null
  financier: {
    __typename?: "OrgRef"
    pid: string
    name: string
    logoUrl: string
    logomarkUrl?: string | null
    profile?: {
      __typename?: "InvestorProfile"
      hq?: string | null
      yearFounded?: number | null
      website?: string | null
      description?: string | null
      committedFunding?: string | null
      distinguishingFeatures?: string | null
      investorBacking?: string | null
      managementTeam: Array<string>
      longTermOwnershipApproach?: string | null
      subscriptionMgmtApproach?: string | null
      experiences: Array<{
        __typename?: "Experience"
        state?: UsState | null
        ftmEnergizedPvKw?: number | null
        ftmAwardedPvKw?: number | null
        btmEnergizedPvKw?: number | null
        btmAwardedPvKw?: number | null
      }>
      buyBoxes: Array<{
        __typename?: "BuyBox"
        state?: UsState | null
        ftmMinPortfolioSize?: number | null
        ftmMinProjectSize?: number | null
        ftmSeekingProjects?: boolean | null
        btmMinPortfolioSize?: number | null
        btmMinProjectSize?: number | null
        btmSeekingProjects?: boolean | null
      }>
    } | null
  }
  system: {
    __typename?: "System"
    id: number
    pid: string
    createdAt: string
    totalPvSizeKw: number
    pvSpecs: Array<{
      __typename?: "PVSpec"
      id: number
      createdAt: string
      pvTypes: Array<PvType>
      sizeKwDc: number
      sizeKwAc?: number | null
      helioscope2Id?: number | null
      etbMeterId?: number | null
      helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
      roofImage?: { __typename?: "Document"; viewHref: string } | null
      productionCsv?: { __typename?: "Document"; downloadHref: string } | null
      productionSource?: {
        __typename?: "PVProductionSource"
        id: number
        origin: ProductionOrigin
      } | null
      allocations: Array<{
        __typename?: "PVAllocation"
        id: number
        createdAt: string
        percentage: number
        meter: {
          __typename?: "BillingMeter"
          pid: string
          view: { __typename?: "BillingMeterView"; name: string }
        }
      }>
    }>
    batterySpecs: Array<{
      __typename?: "BatterySpec"
      id: number
      sizeKwh: number
      sizeKwDc: number
      notes?: string | null
      etbMeterName: string
      document?: {
        __typename?: "Document"
        id: number
        pid: string
        fileName: string
        downloadHref: string
      } | null
      meter: {
        __typename?: "BillingMeter"
        pid: string
        view: { __typename?: "BillingMeterView"; name: string }
      }
    }>
  }
  result?: {
    __typename: "RevampFinmodel"
    id: number
    pid: string
    createdAt: string
    type: FinProductType
    intervalsAndCostsXlsxHref: string
    buildingOwnerXlsxHref?: string | null
    offerStatus: OfferStatus
    fmvStr: string
    totalPvProductionKwh: number
    totalPvExportKwh?: number | null
    bauCostPerYear: Array<number>
    derCostPerYear: Array<number>
    goal?: PVoptGoal | null
    isVnem: boolean
    isGreenLease: boolean
    thirdPartySupplier?: {
      __typename?: "ThirdPartySupplier"
      pid: string
      name: string
    } | null
    buildingOwner: {
      __typename?: "BuildingOwnerEconomics"
      noiYearOne?: number | null
      noiLifetime?: number | null
      noiAnnual?: number | null
    }
    ppa?: {
      __typename: "PPAEconomics"
      ppaType: PpaProductType
      ppaCostPerKwh: number
      ppaTermYears: number
      ppaEsc?: number | null
      srecToInvestor: boolean
      offtakerXlsxHref: string
      product: {
        __typename?: "PPAFinProduct"
        productName: string
        financierName: string
      }
      roofRent?: {
        __typename?: "RoofRentEconomics"
        lifetimeUsd: number
        annualUsd: number
        usdPerSqft: number
        roofRentPerYear: Array<number>
      } | null
      tenantFlows?: {
        __typename?: "TenantCashflows"
        npv: number
        discountRate: number
        totalUtilitySavings: number
        totalCapex: number
        totalOpex: number
        totalNet: number
        netCashflowPerYear: Array<number>
      } | null
    } | null
    loan?: {
      __typename: "LoanEconomics"
      loanRecvrXlsxHref: string
      loanTermYears: number
      ownershipTermYears: number
      interestPct: number
      srecToInvestor: boolean
      product: {
        __typename?: "LoanFinProduct"
        productName: string
        financierName: string
        loanDealerFeePct: number
      }
      flows?: {
        __typename?: "LoanRecvrCashflows"
        monthlyPayment: number
        totalRevenue: number
        totalUtilitySavings: number
        totalOpex: number
        totalCapex: number
        totalItc: number
        totalLoanFunding: number
        totalLoanPayments: number
        totalNet: number
        netCashflowPerYear: Array<number>
        greenLeaseTenantFlows?: {
          __typename?: "TenantCashflows"
          totalNet: number
          netCashflowPerYear: Array<number>
          totalCapex: number
          totalOpex: number
          totalUtilitySavings: number
          npv: number
          discountRate: number
        } | null
      } | null
    } | null
    selfInvest?: {
      __typename: "SelfInvestEconomics"
      npv: number
      discountRate: number
      selfInvestXlsxHref: string
      termYears: number
      srecToInvestor: boolean
      irrs: {
        __typename?: "IRRs"
        postTaxItcDepr?: number | null
        postTaxItcDeprMultiple?: number | null
      }
      product: {
        __typename?: "SelfInvestFinProduct"
        productName: string
        financierName: string
      }
      flows?: {
        __typename?: "SelfInvestCashflows"
        totalRevenue: number
        totalUtilitySavings: number
        totalOpex: number
        totalCapex: number
        totalItc: number
        totalNet: number
        netCashflowPerYear: Array<number>
        greenLeaseTenantFlows?: {
          __typename?: "TenantCashflows"
          totalNet: number
          netCashflowPerYear: Array<number>
          totalCapex: number
          totalOpex: number
          totalUtilitySavings: number
          npv: number
          discountRate: number
        } | null
      } | null
    } | null
    meters: Array<{
      __typename?: "RevampMeter"
      name: string
      loadCategory: LoadCategory
      meterSource: MeterSource
      bau: {
        __typename?: "RevampDer"
        totalKwhFlow: {
          __typename?: "KwhFlow"
          bauLoadKwh: number
          importsKwh: number
          exportsKwh: number
          pvProductionKwh: number
          pvToLoadKwh: number
          batteryChargeKwh: number
          batteryDischargeKwh: number
        }
      }
      der?: {
        __typename?: "RevampDer"
        totalKwhFlow: {
          __typename?: "KwhFlow"
          bauLoadKwh: number
          importsKwh: number
          exportsKwh: number
          pvProductionKwh: number
          pvToLoadKwh: number
          batteryChargeKwh: number
          batteryDischargeKwh: number
        }
        averageDayKwhFlow: Array<{
          __typename?: "KwhFlow"
          bauLoadKwh: number
          importsKwh: number
          exportsKwh: number
          pvProductionKwh: number
          pvToLoadKwh: number
          batteryChargeKwh: number
          batteryDischargeKwh: number
        }>
      } | null
    }>
    systems: Array<
      | {
          __typename: "BatterySystem"
          vendor: BatteryVendor
          sizeKw: number
          sizeKwh: number
          assumptions: { __typename?: "BattAssumptions"; battChemName: string }
        }
      | { __typename: "PVSystem"; type: PvType; sizeKw: number }
    >
    utilityCosts: {
      __typename?: "UtilityCost"
      bau: {
        __typename?: "FinmodelCost"
        totalKwh: number
        totalCostUsd: number
        usdPerKwh: number
        items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
        tariffs: Array<{
          __typename?: "RevampTariff"
          id: number
          name: string
          code: string
          startDate: string
          endDate?: string | null
          utility: {
            __typename?: "RevampUtility"
            id: number
            name: string
            shortName: string
          }
        }>
      }
      der: {
        __typename?: "FinmodelCost"
        totalKwh: number
        totalCostUsd: number
        usdPerKwh: number
        items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
        tariffs: Array<{
          __typename?: "RevampTariff"
          id: number
          name: string
          code: string
          startDate: string
          endDate?: string | null
          utility: {
            __typename?: "RevampUtility"
            id: number
            name: string
            shortName: string
          }
        }>
      }
    }
  } | null
}

export type SystemFragment = {
  __typename?: "System"
  id: number
  pid: string
  createdAt: string
  totalPvSizeKw: number
  pvSpecs: Array<{
    __typename?: "PVSpec"
    id: number
    createdAt: string
    pvTypes: Array<PvType>
    sizeKwDc: number
    sizeKwAc?: number | null
    helioscope2Id?: number | null
    etbMeterId?: number | null
    helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
    roofImage?: { __typename?: "Document"; viewHref: string } | null
    productionCsv?: { __typename?: "Document"; downloadHref: string } | null
    productionSource?: {
      __typename?: "PVProductionSource"
      id: number
      origin: ProductionOrigin
    } | null
    allocations: Array<{
      __typename?: "PVAllocation"
      id: number
      createdAt: string
      percentage: number
      meter: {
        __typename?: "BillingMeter"
        pid: string
        view: { __typename?: "BillingMeterView"; name: string }
      }
    }>
  }>
  batterySpecs: Array<{
    __typename?: "BatterySpec"
    id: number
    sizeKwh: number
    sizeKwDc: number
    notes?: string | null
    etbMeterName: string
    document?: {
      __typename?: "Document"
      id: number
      pid: string
      fileName: string
      downloadHref: string
    } | null
    meter: {
      __typename?: "BillingMeter"
      pid: string
      view: { __typename?: "BillingMeterView"; name: string }
    }
  }>
}

export type PvSystemSpecFragment = {
  __typename?: "PVSpec"
  id: number
  createdAt: string
  pvTypes: Array<PvType>
  sizeKwDc: number
  sizeKwAc?: number | null
  helioscope2Id?: number | null
  etbMeterId?: number | null
  helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
  roofImage?: { __typename?: "Document"; viewHref: string } | null
  productionCsv?: { __typename?: "Document"; downloadHref: string } | null
  productionSource?: {
    __typename?: "PVProductionSource"
    id: number
    origin: ProductionOrigin
  } | null
  allocations: Array<{
    __typename?: "PVAllocation"
    id: number
    createdAt: string
    percentage: number
    meter: {
      __typename?: "BillingMeter"
      pid: string
      view: { __typename?: "BillingMeterView"; name: string }
    }
  }>
}

export type BundleRowDetailFragment = {
  __typename?: "BundleRow2"
  id: number
  ppaType?: PpaProductType | null
  state?: BundleState | null
  reason?: CloseReason | null
  customReason?: string | null
  notes?: string | null
  site: {
    __typename?: "RevampSite"
    pid: string
    name?: string | null
    isFavorite: boolean
    isBehindTheMeter?: boolean | null
    isEnergyCommunity: boolean
    isLowIncomeCommunity?: boolean | null
    streetAddress: string
    city: string
    state: string
    zipCode: string
    county: string
    fullAddress: string
    metering?: Metering | null
    assetManager?: string | null
    vnemAllowed: boolean
    doeReferenceType?: BuildingType | null
    usingBillingMeters?: string | null
    numParkingSpaces?: number | null
    yearBuilt?: number | null
    numStories?: number | null
    sqft?: number | null
    roofSqft?: number | null
    usableRoofSqft?: number | null
    usableCarportFt?: number | null
    impliedCarportLinearFt?: number | null
    impliedUsableRoofSqft?: number | null
    impliedUsableRoofSqftExplanation: RoofSqftExplanation
    groundAvailableSqft?: number | null
    hideBuildingFootprint: boolean
    keepoutsFootprintSqft?: number | null
    roofMaxPvKw: number
    carportMaxPvKw: number
    groundmountMaxPvKw?: number | null
    maxPvKwPolicyLimited: boolean
    isMultifamily: boolean
    occupancyType?: BuildingOccupancyType | null
    leaseType?: LeaseType | null
    tenantLeaseTerm?: string | null
    tenantLeaseEnds?: string | null
    tenantInterest?: YesNoUnsure | null
    mortgageLender?: string | null
    buildingClass?: string | null
    hasSubmittedEnergyData: boolean
    meterSet?: {
      __typename?: "MeterSet"
      totalCost: number
      loadKwh?: number | null
      loadOrigin?: LoadOrigin | null
    } | null
    billingMeters: Array<{
      __typename?: "BillingMeter"
      pid: string
      bauMeterPid?: string | null
      view: {
        __typename?: "BillingMeterView"
        name: string
        isArchived: boolean
        calc2:
          | { __typename: "E2Error" }
          | { __typename: "Projected"; annualKwh: number }
      }
    }>
    selectedConfig?: {
      __typename?: "SiteConfig"
      createdAt?: string | null
      createdBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      scenario: {
        __typename?: "RevampScenario"
        pid: string
        name: string
        loadCategory: LoadCategory
        solarLocation: SolarLocation
        includeStorage: boolean
      }
      financing: {
        __typename?: "RevampFinancing"
        id: number
        name: string
        type: FinProductType
        financierName: string
        financierPid: string
        financierLogo?: string | null
        financierLogomark?: string | null
        isThirdParty: boolean
      }
    } | null
    documents: Array<{
      __typename?: "Document"
      pid: string
      downloadHref: string
      fileName: string
      tag?: DocumentTag | null
    }>
    energyThings?: {
      __typename?: "EnergyThings"
      canRooftopSolar: boolean
      canCarportSolar?: boolean | null
      canGroundmountSolar?: boolean | null
      canStorage: boolean
    } | null
    financingThings?: {
      __typename?: "FinancingThings"
      canSelfInvest: boolean
      canLoan: boolean
      canPpa?: boolean | null
      canCommunitySolar?: boolean | null
    } | null
    physicalCheck: {
      __typename?: "PhysicalCheck"
      existingSolar?: boolean | null
      unobstructedFlatRoof?: boolean | null
      badRoof?: boolean | null
    }
    siteDetails: {
      __typename?: "SiteDetails"
      leaseApprovers: Array<string>
      externalLeaseApprovers?: Array<string> | null
      needsTenantApproval?: boolean | null
      roofRightsHolder?: RoofRightsHolder | null
      propertyLenders?: string | null
      propertyInsurer?: string | null
      constructionEmail?: string | null
      propertySiteVisitContacts?: Array<string> | null
      leasePropertyLegalDescription?: string | null
      leaseLegalOwnerName?: string | null
      signatureBlocks?: Array<string> | null
      isFannieMaeLender?: boolean | null
      isFmGlobalInsurer?: boolean | null
      roofReplacedYr?: number | null
      roofCondition?: string | null
      salePlans?: string | null
      buildingLegalName?: string | null
      propertyFundName?: string | null
      leaseSignatory?: string | null
      counselApproval?: CounselApproval | null
    }
    notes: Array<{ __typename?: "Note"; text: string }>
    buildingData?: {
      __typename?: "BuildingData"
      numStories?: number | null
      numUnits?: number | null
      yearBuilt?: number | null
      sqft?: number | null
      roofSqft?: number | null
      numParkingSpaces?: number | null
      occupancyRate?: number | null
      totalBuildings?: number | null
      yearRenovated?: number | null
      parentCompany?: string | null
      lastSalePrice?: number | null
      leedCertified?: string | null
      energyStar?: string | null
      buildingOpex?: string | null
      capRate?: number | null
    } | null
    footprint: {
      __typename?: "Footprint"
      latitude: number
      longitude: number
      bounds?: any | null
      obstructionShape?: any | null
      roofShape?: any | null
      roofShapeGeojson?: any | null
      roofShapeUpdatedAt?: string | null
      roofSetbackShape?: any | null
      roofSetbackShapeGeojson?: any | null
      roofSetbackShapeUpdatedAt?: string | null
      carportShape?: any | null
      carportShapeGeojson?: any | null
      carportShapeUpdatedAt?: string | null
      groundmountShape?: any | null
      groundmountShapeGeojson?: any | null
      groundmountShapeUpdatedAt?: string | null
      keepoutsShape?: any | null
      keepoutsShapeGeojson?: any | null
      keepoutsShapeUpdatedAt?: string | null
      roofShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      roofSetbackShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      carportShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      groundmountShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      keepoutsShapeUpdatedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    }
    thirdPartySupplier?: {
      __typename?: "ThirdPartySupplier"
      pid: string
      name: string
    } | null
    targetUtility?: {
      __typename?: "Utility"
      name: string
      pid: string
      id: number
      eiaGridEsc?: {
        __typename?: "EIAGridEsc"
        cagrBlended: number
        fromYear: number
        toYear: number
      } | null
      hostingCapacityMaps: Array<{
        __typename?: "HostingCapacityMap"
        url: string
        requiresLogin: boolean
        types: Array<HostingCapacityMapType>
      }>
    } | null
  }
  optOut?: {
    __typename: "InvestorOptOut"
    createdAt: string
    archivedAt?: string | null
    reason?: InvestorOptOutReason | null
    customReason?: string | null
    createdBy: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }
    archivedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  } | null
  bids: Array<{
    __typename?: "InvestorBid"
    ppa?: {
      __typename: "PPAInvestorBid"
      pid: string
      name?: string | null
      termYears: number
      ppaPriceY1Usd: number
      ppaPriceEscalator: number
      roofRentY1Usd?: number | null
      roofRentEscalator?: number | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      itcPercentageAssumption: number
      estimatedCod: string
      estimatedNtp: string
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      recOwner: RecOwner
      tariffProvision?: boolean | null
      otherNotes?: string | null
      extraPaymentsNotes?: string | null
      incentivesNotes?: string | null
      interconnectionNotes?: string | null
      interconnectionRepriceProcessNotes?: string | null
      status?: InvestorBidStatus | null
      spec?: { __typename?: "PPABidSpec"; pid: string } | null
      financier: {
        __typename?: "OrgRef"
        pid: string
        name: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }
      system: {
        __typename?: "System"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpec"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes?: string | null
          etbMeterName: string
          document?: {
            __typename?: "Document"
            id: number
            pid: string
            fileName: string
            downloadHref: string
          } | null
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      }
      result?: {
        __typename: "RevampFinmodel"
        id: number
        pid: string
        createdAt: string
        type: FinProductType
        intervalsAndCostsXlsxHref: string
        buildingOwnerXlsxHref?: string | null
        offerStatus: OfferStatus
        fmvStr: string
        totalPvProductionKwh: number
        totalPvExportKwh?: number | null
        bauCostPerYear: Array<number>
        derCostPerYear: Array<number>
        goal?: PVoptGoal | null
        isVnem: boolean
        isGreenLease: boolean
        thirdPartySupplier?: {
          __typename?: "ThirdPartySupplier"
          pid: string
          name: string
        } | null
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        ppa?: {
          __typename: "PPAEconomics"
          ppaType: PpaProductType
          ppaCostPerKwh: number
          ppaTermYears: number
          ppaEsc?: number | null
          srecToInvestor: boolean
          offtakerXlsxHref: string
          product: {
            __typename?: "PPAFinProduct"
            productName: string
            financierName: string
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            roofRentPerYear: Array<number>
          } | null
          tenantFlows?: {
            __typename?: "TenantCashflows"
            npv: number
            discountRate: number
            totalUtilitySavings: number
            totalCapex: number
            totalOpex: number
            totalNet: number
            netCashflowPerYear: Array<number>
          } | null
        } | null
        loan?: {
          __typename: "LoanEconomics"
          loanRecvrXlsxHref: string
          loanTermYears: number
          ownershipTermYears: number
          interestPct: number
          srecToInvestor: boolean
          product: {
            __typename?: "LoanFinProduct"
            productName: string
            financierName: string
            loanDealerFeePct: number
          }
          flows?: {
            __typename?: "LoanRecvrCashflows"
            monthlyPayment: number
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalLoanFunding: number
            totalLoanPayments: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        selfInvest?: {
          __typename: "SelfInvestEconomics"
          npv: number
          discountRate: number
          selfInvestXlsxHref: string
          termYears: number
          srecToInvestor: boolean
          irrs: {
            __typename?: "IRRs"
            postTaxItcDepr?: number | null
            postTaxItcDeprMultiple?: number | null
          }
          product: {
            __typename?: "SelfInvestFinProduct"
            productName: string
            financierName: string
          }
          flows?: {
            __typename?: "SelfInvestCashflows"
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        meters: Array<{
          __typename?: "RevampMeter"
          name: string
          loadCategory: LoadCategory
          meterSource: MeterSource
          bau: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
          }
          der?: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
            averageDayKwhFlow: Array<{
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }>
          } | null
        }>
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        utilityCosts: {
          __typename?: "UtilityCost"
          bau: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
          der: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
        }
      } | null
    } | null
    cs?: {
      __typename: "CSInvestorBid"
      pid: string
      name?: string | null
      termYears: number
      roofRentEscalator: number
      roofRentY1Usd: number
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      itcPercentageAssumption: number
      estimatedAwardDate?: string | null
      estimatedCod: string
      estimatedNtp: string
      recOwner: RecOwner
      tariffProvision?: boolean | null
      incentivesNotes?: string | null
      interconnectionNotes?: string | null
      interconnectionRepriceProcessNotes?: string | null
      extraPaymentsNotes?: string | null
      otherNotes?: string | null
      status?: InvestorBidStatus | null
      spec?: { __typename?: "CSBidSpec"; pid: string } | null
      financier: {
        __typename?: "OrgRef"
        pid: string
        name: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }
      systemLite: {
        __typename?: "SystemLite"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpecLite"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes: string
        }>
      }
      result?: {
        __typename: "RevampCS"
        id: number
        termYears: number
        createdAt: string
        goal?: PVoptGoal | null
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
        }
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        roofRent?: {
          __typename?: "RoofRentEconomics"
          lifetimeUsd: number
          annualUsd: number
          usdPerSqft: number
          npv: number
          discountRate: number
          roofRentPerYear: Array<number>
        } | null
        pricing: {
          __typename?: "CSPrice"
          usdPerKwPerYear: number
          escalator: number
          minPvKw: number
          maxPvKw: number
          utility: { __typename?: "RevampUtility"; id: number; name: string }
        }
        leaseProjections?: {
          __typename?: "CSLeaseProjections"
          systemSizeKw: number
          annualRentLowerRangeUsd: number
          annualRentUpperRangeUsd: number
          methodology: CsLeaseProjectionMethdology
        } | null
      } | null
    } | null
  }>
  specs: Array<{
    __typename?: "BidSpec"
    ppa?: {
      __typename: "PPABidSpec"
      id: number
      pid: string
      name?: string | null
      termYears?: number | null
      note?: string | null
      archivedAt?: string | null
      ppaPriceY1Usd?: number | null
      ppaPriceEscalator?: number | null
      roofRentY1Usd?: number | null
      roofRentEscalator?: number | null
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      itcPercentageAssumption?: number | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      recOwner?: RecOwner | null
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      system?: {
        __typename?: "System"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpec"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes?: string | null
          etbMeterName: string
          document?: {
            __typename?: "Document"
            id: number
            pid: string
            fileName: string
            downloadHref: string
          } | null
          meter: {
            __typename?: "BillingMeter"
            pid: string
            view: { __typename?: "BillingMeterView"; name: string }
          }
        }>
      } | null
    } | null
    cs?: {
      __typename: "CSBidSpec"
      id: number
      pid: string
      name?: string | null
      termYears?: number | null
      note?: string | null
      archivedAt?: string | null
      roofRentY1Usd?: number | null
      roofRentEscalator?: number | null
      buildingOwnerExtraPaymentsUsd?: Array<number> | null
      itcPercentageAssumption?: number | null
      interconnectionCostUsdPerWatt?: number | null
      interconnectionCostUtilityMinUsd?: number | null
      interconnectionCostUtilityMaxUsd?: number | null
      interconnectionCostNonUtilityUsd?: number | null
      recOwner?: RecOwner | null
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
      systemLite?: {
        __typename?: "SystemLite"
        id: number
        pid: string
        createdAt: string
        totalPvSizeKw: number
        pvSpecs: Array<{
          __typename?: "PVSpec"
          id: number
          createdAt: string
          pvTypes: Array<PvType>
          sizeKwDc: number
          sizeKwAc?: number | null
          helioscope2Id?: number | null
          etbMeterId?: number | null
          helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
          roofImage?: { __typename?: "Document"; viewHref: string } | null
          productionCsv?: { __typename?: "Document"; downloadHref: string } | null
          productionSource?: {
            __typename?: "PVProductionSource"
            id: number
            origin: ProductionOrigin
          } | null
          allocations: Array<{
            __typename?: "PVAllocation"
            id: number
            createdAt: string
            percentage: number
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }>
        batterySpecs: Array<{
          __typename?: "BatterySpecLite"
          id: number
          sizeKwh: number
          sizeKwDc: number
          notes: string
        }>
      } | null
    } | null
    optOut?: {
      __typename: "InvestorBidSpecOptOut"
      createdAt: string
      archivedAt?: string | null
      reason?: SpecOptOutReason | null
      customReason?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
  }>
}

export type Helioscope2RefFragment = {
  __typename?: "Helioscope2"
  id: number
  pdf: { __typename?: "Document"; downloadHref: string }
  roofImage: { __typename?: "Document"; viewHref: string }
  productionCsv?: { __typename?: "Document"; downloadHref: string } | null
}

export type BasicBidPackageFragment = {
  __typename?: "BidPackage"
  pid: string
  name: string
  biddingOpenAt?: string | null
  biddingClosedAt?: string | null
  state: BundleState
  type: FinProductType
  totalRows: number
  financiers: Array<{
    __typename?: "OrgRef"
    pid: string
    name: string
    orgSlug: string
    logoUrl: string
    logomarkUrl?: string | null
    profile?: {
      __typename?: "InvestorProfile"
      hq?: string | null
      yearFounded?: number | null
      website?: string | null
      description?: string | null
      committedFunding?: string | null
      distinguishingFeatures?: string | null
      investorBacking?: string | null
      managementTeam: Array<string>
      longTermOwnershipApproach?: string | null
      subscriptionMgmtApproach?: string | null
      experiences: Array<{
        __typename?: "Experience"
        state?: UsState | null
        ftmEnergizedPvKw?: number | null
        ftmAwardedPvKw?: number | null
        btmEnergizedPvKw?: number | null
        btmAwardedPvKw?: number | null
      }>
      buyBoxes: Array<{
        __typename?: "BuyBox"
        state?: UsState | null
        ftmMinPortfolioSize?: number | null
        ftmMinProjectSize?: number | null
        ftmSeekingProjects?: boolean | null
        btmMinPortfolioSize?: number | null
        btmMinProjectSize?: number | null
        btmSeekingProjects?: boolean | null
      }>
    } | null
  }>
}

export type InvestorProfileFragment = {
  __typename?: "InvestorProfile"
  hq?: string | null
  yearFounded?: number | null
  website?: string | null
  description?: string | null
  committedFunding?: string | null
  distinguishingFeatures?: string | null
  investorBacking?: string | null
  managementTeam: Array<string>
  longTermOwnershipApproach?: string | null
  subscriptionMgmtApproach?: string | null
  experiences: Array<{
    __typename?: "Experience"
    state?: UsState | null
    ftmEnergizedPvKw?: number | null
    ftmAwardedPvKw?: number | null
    btmEnergizedPvKw?: number | null
    btmAwardedPvKw?: number | null
  }>
  buyBoxes: Array<{
    __typename?: "BuyBox"
    state?: UsState | null
    ftmMinPortfolioSize?: number | null
    ftmMinProjectSize?: number | null
    ftmSeekingProjects?: boolean | null
    btmMinPortfolioSize?: number | null
    btmMinProjectSize?: number | null
    btmSeekingProjects?: boolean | null
  }>
}

export type BidPackageDetailFragment = {
  __typename?: "BidPackage"
  pid: string
  name: string
  biddingOpenAt?: string | null
  biddingClosedAt?: string | null
  state: BundleState
  type: FinProductType
  totalRows: number
  documents: Array<{
    __typename?: "Document"
    canDelete: boolean
    contentType: string
    dateCreated: string
    fileName: string
    ownerName: string
    pid: string
    tag?: DocumentTag | null
    downloadHref: string
    belongsToBundleParent: boolean
  }>
  financiers: Array<{
    __typename?: "OrgRef"
    pid: string
    name: string
    orgSlug: string
    logoUrl: string
    logomarkUrl?: string | null
    profile?: {
      __typename?: "InvestorProfile"
      hq?: string | null
      yearFounded?: number | null
      website?: string | null
      description?: string | null
      committedFunding?: string | null
      distinguishingFeatures?: string | null
      investorBacking?: string | null
      managementTeam: Array<string>
      longTermOwnershipApproach?: string | null
      subscriptionMgmtApproach?: string | null
      experiences: Array<{
        __typename?: "Experience"
        state?: UsState | null
        ftmEnergizedPvKw?: number | null
        ftmAwardedPvKw?: number | null
        btmEnergizedPvKw?: number | null
        btmAwardedPvKw?: number | null
      }>
      buyBoxes: Array<{
        __typename?: "BuyBox"
        state?: UsState | null
        ftmMinPortfolioSize?: number | null
        ftmMinProjectSize?: number | null
        ftmSeekingProjects?: boolean | null
        btmMinPortfolioSize?: number | null
        btmMinProjectSize?: number | null
        btmSeekingProjects?: boolean | null
      }>
    } | null
  }>
}

export type BidReviewFragment = {
  __typename?: "BidReview"
  recommendedBidPids: Array<string>
  reports: Array<{
    __typename?: "BidReviewReportStats"
    properties: number
    bidders: number
    uniqueBids: number
    avgRoofRentY1Usd: number
    isCustom: boolean
    report: {
      __typename?: "PackageBidReport"
      pid?: string | null
      name?: string | null
      notes?: string | null
      visible: boolean
      totalDevelopers: number
      totalBids: number
      cs?: Array<{
        __typename: "CSSiteBidReport"
        awarded: boolean
        awardedPid?: string | null
        totalBids: number
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          isFavorite: boolean
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
        }
        bids: Array<{
          __typename: "CSInvestorBid"
          name?: string | null
          pid: string
          termYears: number
          roofRentEscalator: number
          roofRentY1Usd: number
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          itcPercentageAssumption: number
          estimatedAwardDate?: string | null
          estimatedCod: string
          estimatedNtp: string
          recOwner: RecOwner
          tariffProvision?: boolean | null
          incentivesNotes?: string | null
          interconnectionNotes?: string | null
          interconnectionRepriceProcessNotes?: string | null
          extraPaymentsNotes?: string | null
          otherNotes?: string | null
          financier: {
            __typename?: "OrgRef"
            pid: string
            name: string
            logoUrl: string
            logomarkUrl?: string | null
            profile?: {
              __typename?: "InvestorProfile"
              hq?: string | null
              yearFounded?: number | null
              website?: string | null
              description?: string | null
              committedFunding?: string | null
              distinguishingFeatures?: string | null
              investorBacking?: string | null
              managementTeam: Array<string>
              longTermOwnershipApproach?: string | null
              subscriptionMgmtApproach?: string | null
              experiences: Array<{
                __typename?: "Experience"
                state?: UsState | null
                ftmEnergizedPvKw?: number | null
                ftmAwardedPvKw?: number | null
                btmEnergizedPvKw?: number | null
                btmAwardedPvKw?: number | null
              }>
              buyBoxes: Array<{
                __typename?: "BuyBox"
                state?: UsState | null
                ftmMinPortfolioSize?: number | null
                ftmMinProjectSize?: number | null
                ftmSeekingProjects?: boolean | null
                btmMinPortfolioSize?: number | null
                btmMinProjectSize?: number | null
                btmSeekingProjects?: boolean | null
              }>
            } | null
          }
          result?: {
            __typename?: "RevampCS"
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiLifetime?: number | null
            }
          } | null
        }>
        noi?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        y1RoofRent?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        systemSize?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        itcPercentageAssumption?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        roofRentEscalator?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        npv?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
      }> | null
      ppa?: Array<{
        __typename: "PPASiteBidReport"
        awarded: boolean
        awardedPid?: string | null
        totalBids: number
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          isFavorite: boolean
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
        }
        bids: Array<{
          __typename: "PPAInvestorBid"
          name?: string | null
          pid: string
          termYears: number
          roofRentEscalator?: number | null
          roofRentY1Usd?: number | null
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          itcPercentageAssumption: number
          estimatedCod: string
          estimatedNtp: string
          recOwner: RecOwner
          tariffProvision?: boolean | null
          incentivesNotes?: string | null
          interconnectionNotes?: string | null
          interconnectionRepriceProcessNotes?: string | null
          extraPaymentsNotes?: string | null
          otherNotes?: string | null
          financier: {
            __typename?: "OrgRef"
            pid: string
            name: string
            logoUrl: string
            logomarkUrl?: string | null
            profile?: {
              __typename?: "InvestorProfile"
              hq?: string | null
              yearFounded?: number | null
              website?: string | null
              description?: string | null
              committedFunding?: string | null
              distinguishingFeatures?: string | null
              investorBacking?: string | null
              managementTeam: Array<string>
              longTermOwnershipApproach?: string | null
              subscriptionMgmtApproach?: string | null
              experiences: Array<{
                __typename?: "Experience"
                state?: UsState | null
                ftmEnergizedPvKw?: number | null
                ftmAwardedPvKw?: number | null
                btmEnergizedPvKw?: number | null
                btmAwardedPvKw?: number | null
              }>
              buyBoxes: Array<{
                __typename?: "BuyBox"
                state?: UsState | null
                ftmMinPortfolioSize?: number | null
                ftmMinProjectSize?: number | null
                ftmSeekingProjects?: boolean | null
                btmMinPortfolioSize?: number | null
                btmMinProjectSize?: number | null
                btmSeekingProjects?: boolean | null
              }>
            } | null
          }
          result?: {
            __typename?: "RevampFinmodel"
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiLifetime?: number | null
            }
          } | null
        }>
        noi?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        y1RoofRent?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        systemSize?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        itcPercentageAssumption?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        ppaPriceEscalator?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        npv?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
      }> | null
    }
  }>
}

export type RateFragment = {
  __typename?: "Rate"
  name: string
  groupName?: string | null
  tariffRateId: number
  chargeClass: string
  chargeType?: ChargeType | null
  transactionType: TransactionType
  chargePeriod: ChargePeriod
  applicabilityKey?: string | null
  applicabilityValues?: Array<string> | null
  quantityKey?: string | null
  applicableBands: Array<{
    __typename?: "RateBand"
    tariffRateBandId: number
    rateUnit: RateUnit
    price: number
    isCredit: boolean
    applicabilityValue?: string | null
  }>
  bands: Array<{
    __typename?: "RateBand"
    tariffRateBandId: number
    rateUnit: RateUnit
    price: number
    isCredit: boolean
    applicabilityValue?: string | null
  }>
  tou?: {
    __typename?: "TimeOfUse"
    touName: string
    touType?: string | null
    touPeriods: Array<{
      __typename?: "Period"
      fromHour?: number | null
      fromMinute?: number | null
      fromDayOfWeek: number
      toHour?: number | null
      toMinute?: number | null
      toDayOfWeek: number
    }>
    season?: {
      __typename?: "Season"
      seasonFromDay: number
      seasonFromMonth: number
      seasonToDay: number
      seasonToMonth: number
    } | null
  } | null
  season?: {
    __typename?: "Season"
    seasonFromDay: number
    seasonFromMonth: number
    seasonToDay: number
    seasonToMonth: number
  } | null
}

export type RateBandFragment = {
  __typename?: "RateBand"
  tariffRateBandId: number
  rateUnit: RateUnit
  price: number
  isCredit: boolean
  applicabilityValue?: string | null
}

export type SeasonFragment = {
  __typename?: "Season"
  seasonFromDay: number
  seasonFromMonth: number
  seasonToDay: number
  seasonToMonth: number
}

type TariffOp_AddRate_Fragment = {
  __typename: "AddRate"
  op: OpType
  rate: {
    __typename?: "CustomRate"
    name?: string | null
    chargeClass: ChargeClass
    chargeType: ChargeType
    transactionType?: TransactionType | null
    price: number
    rateUnit: RateUnit
    chargePeriod: ChargePeriod
  }
}

type TariffOp_OverrideProperty_Fragment = {
  __typename: "OverrideProperty"
  keyName: string
  propertyValue: string
  op: OpType
}

type TariffOp_SubRate_Fragment = {
  __typename: "SubRate"
  chargeClass?: ChargeClass | null
  rateId?: number | null
  op: OpType
}

export type TariffOpFragment =
  | TariffOp_AddRate_Fragment
  | TariffOp_OverrideProperty_Fragment
  | TariffOp_SubRate_Fragment

export type CustomRateFragment = {
  __typename?: "CustomRate"
  name?: string | null
  chargeClass: ChargeClass
  chargeType: ChargeType
  transactionType?: TransactionType | null
  price: number
  rateUnit: RateUnit
  chargePeriod: ChargePeriod
}

export type ChangeLogEntryFragment = {
  __typename?: "ChangeLogEntry"
  source?: ChangeSourceType | null
  sourceId?: string | null
  oldValue?: any | null
  newValue?: any | null
  columnType: ChangelogType
  changedAt: string
}

export type FieldChangeLogHistoryFragment = {
  __typename?: "FieldChangeLogHistory"
  latest?: {
    __typename?: "ChangeLogEntry"
    source?: ChangeSourceType | null
    sourceId?: string | null
    oldValue?: any | null
    newValue?: any | null
    columnType: ChangelogType
    changedAt: string
  } | null
  history: Array<{
    __typename?: "ChangeLogEntry"
    source?: ChangeSourceType | null
    sourceId?: string | null
    oldValue?: any | null
    newValue?: any | null
    columnType: ChangelogType
    changedAt: string
  }>
}

export type SiteFieldChangeLogFragment = {
  __typename?: "SiteFieldChangeLog"
  occupancyType: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  leaseType: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  targetUtilityId: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  tenantLeaseTerm: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
}

export type SiteDetailsFieldChangeLogFragment = {
  __typename?: "SiteDetailsFieldChangeLog"
  buildingLegalName: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  constructionEmail: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  counselApproval: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  externalLeaseApprovers: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  isFannieMaeLender: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  isFmGlobalInsurer: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  leaseApprovers: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  leaseLegalOwnerName: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  leasePropertyLegalDescription: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  leaseSignatory: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  needsTenantApproval: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  propertyFundName: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  propertyInsurer: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  propertyLenders: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  propertySiteVisitContacts: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  roofCondition: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  roofReplacedYr: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  roofRightsHolder: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  salePlannedYear: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  salePlans: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
  signatureBlocks: {
    __typename?: "FieldChangeLogHistory"
    latest?: {
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    } | null
    history: Array<{
      __typename?: "ChangeLogEntry"
      source?: ChangeSourceType | null
      sourceId?: string | null
      oldValue?: any | null
      newValue?: any | null
      columnType: ChangelogType
      changedAt: string
    }>
  }
}

export type InvestorOptOutFragment = {
  __typename: "InvestorOptOut"
  createdAt: string
  archivedAt?: string | null
  reason?: InvestorOptOutReason | null
  customReason?: string | null
  createdBy: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  }
  archivedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type InvestorBidSpecOptOutFragment = {
  __typename: "InvestorBidSpecOptOut"
  createdAt: string
  archivedAt?: string | null
  reason?: SpecOptOutReason | null
  customReason?: string | null
  createdBy: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  }
  archivedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type SetPropertyNameMutationVariables = Exact<{
  propertyPid: Scalars["String"]["input"]
  propertyName: Scalars["String"]["input"]
}>

export type SetPropertyNameMutation = {
  __typename?: "Mutation"
  setPropertyName:
    | { __typename: "Error"; message: string }
    | { __typename: "PortfolioSite"; pid: string; propertyName?: string | null }
}

export type TrackEventMutationVariables = Exact<{
  input: RecordUserEventInput
}>

export type TrackEventMutation = {
  __typename?: "Mutation"
  recordUserEvent?: { __typename: "Error"; message: string } | null
}

export type LogPageViewMutationVariables = Exact<{
  input: LogPageViewInput
}>

export type LogPageViewMutation = {
  __typename?: "Mutation"
  logPageView?: { __typename: "Error"; message: string } | null
}

export type AcceptSelectOffersLicenseAgreementMutationVariables = Exact<{
  [key: string]: never
}>

export type AcceptSelectOffersLicenseAgreementMutation = {
  __typename?: "Mutation"
  acceptLicenseAgreement?: { __typename: "Error"; message: string } | null
}

export type SetOrgSettingsMutationVariables = Exact<{
  orgPid: Scalars["String"]["input"]
  irrFlavor: IrrType
}>

export type SetOrgSettingsMutation = {
  __typename?: "Mutation"
  setOrgSettings:
    | { __typename: "Error" }
    | { __typename: "Org"; pid: string; irrFlavor: IrrType }
}

export type ClaimOpenInviteMutationVariables = Exact<{
  input: ClaimOpenInviteInput
}>

export type ClaimOpenInviteMutation = {
  __typename?: "Mutation"
  claimOpenInvite:
    | {
        __typename: "AuthUser"
        pid?: string | null
        isAuthenticated: boolean
        isAdmin: boolean
        email?: string | null
        name?: string | null
        org?: {
          __typename?: "Org"
          pid: string
          name: string
          logoUrl?: string | null
          irrFlavor: IrrType
        } | null
      }
    | { __typename: "Error"; message: string }
}

export type InviteToOrgMutationVariables = Exact<{
  input: InviteToOrgInput
}>

export type InviteToOrgMutation = {
  __typename?: "Mutation"
  inviteToOrg: { __typename: "Org"; pid: string }
}

export type InviteToPortfolioMutationVariables = Exact<{
  input: InviteToPortfolioInput
}>

export type InviteToPortfolioMutation = {
  __typename?: "Mutation"
  inviteToPortfolio:
    | { __typename: "Error"; message: string }
    | { __typename: "Portfolio"; pid: string }
}

export type CreateAndApplySiteLabelMutationVariables = Exact<{
  input: CreateAndApplySiteLabelInput
}>

export type CreateAndApplySiteLabelMutation = {
  __typename?: "Mutation"
  createAndApplySiteLabel:
    | {
        __typename: "CreateAndApplySiteLabelOutput"
        label: {
          __typename?: "SiteLabel"
          pid: string
          name: string
          themeColor: LabelColor
          sites: Array<string>
          createdBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
          perms: { __typename?: "SiteLabelPerms"; canAdd: boolean; canRemove: boolean }
        }
      }
    | { __typename: "Error"; message: string }
}

export type ApplyLabelToSitesMutationVariables = Exact<{
  input: ApplyLabelToSitesInput
}>

export type ApplyLabelToSitesMutation = {
  __typename?: "Mutation"
  applyLabelToSites?: { __typename: "Error"; message: string } | null
}

export type RemoveLabelFromSitesMutationVariables = Exact<{
  input: RemoveLabelFromSitesInput
}>

export type RemoveLabelFromSitesMutation = {
  __typename?: "Mutation"
  removeLabelFromSites?: { __typename: "Error"; message: string } | null
}

export type DeleteSiteLabelMutationVariables = Exact<{
  input: DeleteSiteLabelInput
}>

export type DeleteSiteLabelMutation = {
  __typename?: "Mutation"
  deleteSiteLabel?: { __typename: "Error"; message: string } | null
}

export type RenameSiteLabelMutationVariables = Exact<{
  input: RenameSiteLabelInput
}>

export type RenameSiteLabelMutation = {
  __typename?: "Mutation"
  renameSiteLabel:
    | { __typename: "Error"; message: string }
    | {
        __typename: "RenameSiteLabelOutput"
        label: {
          __typename?: "SiteLabel"
          pid: string
          name: string
          themeColor: LabelColor
          sites: Array<string>
          createdBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
          perms: { __typename?: "SiteLabelPerms"; canAdd: boolean; canRemove: boolean }
        }
      }
}

export type ChangeSiteLabelColorMutationVariables = Exact<{
  input: ChangeSiteLabelColorInput
}>

export type ChangeSiteLabelColorMutation = {
  __typename?: "Mutation"
  changeSiteLabelColor:
    | {
        __typename: "ChangeSiteLabelColorOutput"
        label: {
          __typename?: "SiteLabel"
          pid: string
          name: string
          themeColor: LabelColor
          sites: Array<string>
          createdBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
          perms: { __typename?: "SiteLabelPerms"; canAdd: boolean; canRemove: boolean }
        }
      }
    | { __typename: "Error"; message: string }
}

export type UploadDocumentMutationVariables = Exact<{
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  bundlePid?: InputMaybe<Scalars["String"]["input"]>
  bundleParentPid?: InputMaybe<Scalars["String"]["input"]>
  file: Scalars["Upload"]["input"]
  tag?: InputMaybe<Scalars["String"]["input"]>
}>

export type UploadDocumentMutation = {
  __typename?: "Mutation"
  documents: {
    __typename?: "DocumentMutations"
    uploadDocument:
      | {
          __typename: "Document"
          csvPeek?: Array<Array<string>> | null
          id: number
          pid: string
          contentType: string
          dateCreated: string
          fileName: string
          ownerName: string
          ownerEmail: string
          downloadHref: string
          viewHref: string
          tag?: DocumentTag | null
        }
      | { __typename: "Error"; message: string }
  }
}

export type DeleteDocumentMutationVariables = Exact<{
  documentPid: Scalars["String"]["input"]
}>

export type DeleteDocumentMutation = {
  __typename?: "Mutation"
  documents: {
    __typename?: "DocumentMutations"
    deleteDocument?: { __typename: "Error"; message: string } | null
  }
}

export type SetDocumentTagMutationVariables = Exact<{
  pid: Scalars["String"]["input"]
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  bundlePid?: InputMaybe<Scalars["String"]["input"]>
  bundleParentPid?: InputMaybe<Scalars["String"]["input"]>
  tag: DocumentTag
}>

export type SetDocumentTagMutation = {
  __typename?: "Mutation"
  documents: {
    __typename?: "DocumentMutations"
    setDocumentTag?:
      | { __typename: "Document"; pid: string; tag?: DocumentTag | null }
      | { __typename: "Error"; message: string }
      | null
  }
}

export type OrgSetIsFavoriteMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  isFavorite: Scalars["Boolean"]["input"]
}>

export type OrgSetIsFavoriteMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    setIsFavorite?: { __typename?: "Error"; message: string } | null
  }
}

export type BundleCreateMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  financierPid: Scalars["String"]["input"]
  type: FinProductType
  note?: InputMaybe<Scalars["String"]["input"]>
  biddingOpenAt?: InputMaybe<Scalars["DateTime"]["input"]>
  biddingClosedAt?: InputMaybe<Scalars["DateTime"]["input"]>
}>

export type BundleCreateMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      create: {
        __typename?: "Bundle"
        pid: string
        createdAt: string
        name: string
        note?: string | null
        state?: BundleState | null
        optedOut: boolean
        biddingOpenAt?: string | null
        biddingClosedAt?: string | null
        hasParent: boolean
        canDelete: boolean
        archived: boolean
        type: FinProductType
        downloadTheBigZipHref: string
        recvr: { __typename?: "BundleOrg"; pid: string; name: string }
        stats: {
          __typename?: "BundleStats"
          numSites: number
          capex?: number | null
          postTaxItcDeprIrr?: number | null
          pvSizeKw: number
        }
        documents: Array<{
          __typename?: "Document"
          canDelete: boolean
          contentType: string
          dateCreated: string
          fileName: string
          ownerName: string
          pid: string
          tag?: DocumentTag | null
          downloadHref: string
          belongsToBundleParent: boolean
        }>
      }
    }
  }
}

export type BundleUpsertSiteMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  scenarioPid: Scalars["String"]["input"]
  finproductId?: InputMaybe<Scalars["Int"]["input"]>
}>

export type BundleUpsertSiteMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      edit: {
        __typename?: "BundleEdit"
        upsertSite: {
          __typename?: "BundleRow"
          site: { __typename?: "RevampSite"; pid: string }
          scenario?: { __typename?: "RevampScenario"; pid: string } | null
          financing?: {
            __typename?: "RevampFinancing"
            id: number
            name: string
          } | null
        }
      }
    }
  }
}

export type BundleRemoveSiteMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type BundleRemoveSiteMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      edit: { __typename?: "BundleEdit"; removeSite?: any | null }
    }
  }
}

export type BundleArchiveBundleMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  archive: Scalars["Boolean"]["input"]
}>

export type BundleArchiveBundleMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      edit: { __typename?: "BundleEdit"; archiveBundle?: any | null }
    }
  }
}

export type SetMeteringMutationVariables = Exact<{
  input: SetMeteringInput
}>

export type SetMeteringMutation = { __typename?: "Mutation"; setMetering?: any | null }

export type SetSiteShapesMutationVariables = Exact<{
  input: SetSiteShapesInput
}>

export type SetSiteShapesMutation = {
  __typename?: "Mutation"
  setSiteShapes: { __typename?: "RevampSite"; pid: string }
}

export type SaveSiteShapesMutationVariables = Exact<{
  input: SaveSiteShapesInput
}>

export type SaveSiteShapesMutation = {
  __typename?: "Mutation"
  saveSiteShapes?: any | null
}

export type UpdatePropertyDataMutationVariables = Exact<{
  input: UpdatePropertyDataInput
  sourceType?: InputMaybe<ChangeSourceType>
  sourceId?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdatePropertyDataMutation = {
  __typename?: "Mutation"
  updatePropertyData?: any | null
}

export type SetSiteStatusMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  status: SiteStatus
  reason?: InputMaybe<StatusReason>
  customReason?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetSiteStatusMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    setStatus?: { __typename?: "Error"; message: string } | null
  }
}

export type NewCsvImportMutationVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}>

export type NewCsvImportMutation = {
  __typename?: "Mutation"
  newCsvImport:
    | { __typename: "CsvImport"; pid: string }
    | { __typename: "Error"; message: string }
}

export type SetCsvImportSchemaMutationVariables = Exact<{
  csvImportPid: Scalars["String"]["input"]
  schemaPid: Scalars["String"]["input"]
}>

export type SetCsvImportSchemaMutation = {
  __typename?: "Mutation"
  setCsvImportSchema: { __typename: "CsvImport" } | { __typename: "Error" }
}

export type UpdateCsvImportColumnMappingsMutationVariables = Exact<{
  csvImportPid: Scalars["String"]["input"]
  columnMappings: ColumnMappingsInput
}>

export type UpdateCsvImportColumnMappingsMutation = {
  __typename?: "Mutation"
  updateCsvImportColumnMappings:
    | {
        __typename: "CsvImport"
        pid: string
        buildingTypes: Array<string>
        guessedBuildingTypeMappings: {
          __typename?: "BuildingTypeMappings"
          office: Array<string>
          multifamily: Array<string>
          hotel: Array<string>
          hospital: Array<string>
          outpatient: Array<string>
          retailStandalone: Array<string>
          retailStripMall: Array<string>
          quickServiceRestaurant: Array<string>
          fullServiceRestaurant: Array<string>
          primarySchool: Array<string>
          secondarySchool: Array<string>
          singleFamilyDetached: Array<string>
          warehouse: Array<string>
          dataCenter: Array<string>
          coldStorage: Array<string>
          industrial: Array<string>
          parkingLot: Array<string>
          supermarket: Array<string>
        }
      }
    | { __typename: "Error"; message: string }
}

export type AddLabelToCsvImportMutationVariables = Exact<{
  csvImportPid: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}>

export type AddLabelToCsvImportMutation = {
  __typename?: "Mutation"
  addLabelToCsvImport:
    | {
        __typename: "CsvImport"
        pid: string
        labels: Array<{
          __typename?: "SiteLabel"
          pid: string
          themeColor: LabelColor
          name: string
        }>
      }
    | { __typename: "Error"; message: string }
}

export type RemoveLabelFromCsvImportMutationVariables = Exact<{
  csvImportPid: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}>

export type RemoveLabelFromCsvImportMutation = {
  __typename?: "Mutation"
  removeLabelFromCsvImport:
    | {
        __typename: "CsvImport"
        pid: string
        labels: Array<{
          __typename?: "SiteLabel"
          pid: string
          themeColor: LabelColor
          name: string
        }>
      }
    | { __typename: "Error"; message: string }
}

export type CreateLabelForCsvImportMutationVariables = Exact<{
  csvImportPid: Scalars["String"]["input"]
  labelName: Scalars["String"]["input"]
  labelColor?: InputMaybe<LabelColor>
}>

export type CreateLabelForCsvImportMutation = {
  __typename?: "Mutation"
  createAndApplyLabelToCsvImport:
    | {
        __typename: "CsvImport"
        pid: string
        labels: Array<{
          __typename?: "SiteLabel"
          pid: string
          themeColor: LabelColor
          name: string
        }>
      }
    | { __typename: "Error"; message: string }
}

export type DeleteLabelForCsvImportMutationVariables = Exact<{
  csvImportPid: Scalars["String"]["input"]
  labelPid: Scalars["String"]["input"]
}>

export type DeleteLabelForCsvImportMutation = {
  __typename?: "Mutation"
  deleteLabelAndRemoveFromCsvImport:
    | {
        __typename: "CsvImport"
        pid: string
        labels: Array<{
          __typename?: "SiteLabel"
          pid: string
          themeColor: LabelColor
          name: string
        }>
      }
    | { __typename: "Error"; message: string }
}

export type UpdateDoeReferenceTypeMappingsMutationVariables = Exact<{
  csvImportPid: Scalars["String"]["input"]
  mappings: DoeReferenceTypeMappingsInput
}>

export type UpdateDoeReferenceTypeMappingsMutation = {
  __typename?: "Mutation"
  updateDoeReferenceTypeMappings:
    | { __typename: "CsvImport"; pid: string }
    | { __typename: "Error"; message: string }
}

export type DropCsvImportRowMutationVariables = Exact<{
  rowId: Scalars["Int"]["input"]
}>

export type DropCsvImportRowMutation = {
  __typename?: "Mutation"
  dropCsvImportRow: {
    __typename?: "CsvImportRow"
    id: number
    droppedAt?: string | null
  }
}

export type AmendCsvImportRowMutationVariables = Exact<{
  rowId: Scalars["Int"]["input"]
  amendments: BuildingDataAmendmentsInput
}>

export type AmendCsvImportRowMutation = {
  __typename?: "Mutation"
  amendCsvImportRow: {
    __typename?: "CsvImportRow"
    id: number
    amendments?: {
      __typename?: "BuildingDataAmendments"
      buildingType?: BuildingType | null
      customerId?: string | null
      latitude?: number | null
      longitude?: number | null
      name?: string | null
      numStories?: number | null
      roofSqft?: number | null
      sqft?: number | null
      yearBuilt?: number | null
      mfUnits?: {
        __typename?: "CleanMultifamilyUnits"
        numUnitsTotal?: number | null
        numUnitsStudio?: number | null
        numUnits1Bd?: number | null
        numUnits2Bd?: number | null
        numUnits3Bd?: number | null
        numUnits4Bd?: number | null
      } | null
    } | null
  }
}

export type SetCsvImportRowBuildingDataMutationVariables = Exact<{
  rowId: Scalars["Int"]["input"]
  buildingDataId: Scalars["Int"]["input"]
}>

export type SetCsvImportRowBuildingDataMutation = {
  __typename?: "Mutation"
  setCsvImportRowBuildingData: {
    __typename?: "CsvImportRow"
    id: number
    buildingData?: {
      __typename?: "BuildingData"
      id: number
      propertyName?: string | null
      fullAddress: string
      streetAddress: string
      city: string
      state: string
      zipCode: string
      buildingType?: BuildingType | null
      sqft?: number | null
      roofSqft?: number | null
      numStories?: number | null
      latitude: number
      longitude: number
      buildingFootprintGeojson?: any | null
      yearBuilt?: number | null
      numUnitsTotal?: number | null
      numUnitsStudio?: number | null
      numUnits1Bd?: number | null
      numUnits2Bd?: number | null
      numUnits3Bd?: number | null
      numUnits4Bd?: number | null
    } | null
  }
}

export type UnsetCsvImportRowBuildingDataMutationVariables = Exact<{
  rowId: Scalars["Int"]["input"]
}>

export type UnsetCsvImportRowBuildingDataMutation = {
  __typename?: "Mutation"
  unsetCsvImportRowBuildingData: {
    __typename?: "CsvImportRow"
    id: number
    buildingData?: {
      __typename?: "BuildingData"
      id: number
      propertyName?: string | null
      fullAddress: string
      streetAddress: string
      city: string
      state: string
      zipCode: string
      buildingType?: BuildingType | null
      sqft?: number | null
      roofSqft?: number | null
      numStories?: number | null
      latitude: number
      longitude: number
      buildingFootprintGeojson?: any | null
      yearBuilt?: number | null
      numUnitsTotal?: number | null
      numUnitsStudio?: number | null
      numUnits1Bd?: number | null
      numUnits2Bd?: number | null
      numUnits3Bd?: number | null
      numUnits4Bd?: number | null
    } | null
    amendments?: {
      __typename?: "BuildingDataAmendments"
      buildingType?: BuildingType | null
      customerId?: string | null
      latitude?: number | null
      longitude?: number | null
      name?: string | null
      numStories?: number | null
      roofSqft?: number | null
      sqft?: number | null
      yearBuilt?: number | null
      mfUnits?: {
        __typename?: "CleanMultifamilyUnits"
        numUnitsTotal?: number | null
        numUnitsStudio?: number | null
        numUnits1Bd?: number | null
        numUnits2Bd?: number | null
        numUnits3Bd?: number | null
        numUnits4Bd?: number | null
      } | null
    } | null
  }
}

export type UpdateSiteConfigMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  finproductId: Scalars["Int"]["input"]
  scenarioPid: Scalars["String"]["input"]
}>

export type UpdateSiteConfigMutation = {
  __typename?: "Mutation"
  siteConfig: { __typename?: "SiteConfigMutations"; updateSelectedConfig?: any | null }
}

export type RequestBidsMutationVariables = Exact<{
  input: RequestBidsInput
}>

export type RequestBidsMutation = { __typename?: "Mutation"; requestBids?: any | null }

export type CreateThirdPartySupplierMutationVariables = Exact<{
  name: Scalars["String"]["input"]
}>

export type CreateThirdPartySupplierMutation = {
  __typename?: "Mutation"
  createThirdPartySupplier: {
    __typename?: "ThirdPartySupplier"
    id: number
    pid: string
    name: string
  }
}

export type MutBillingMeterFragment = {
  __typename: "BillingMeter"
  pid: string
  label: string
  config: {
    __typename?: "BMConfig"
    loadCategory: LoadCategory
    doeReferenceType: BuildingType
  }
}

export type AddMeterMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  loadCategory: LoadCategory
  label?: InputMaybe<Scalars["String"]["input"]>
  doeReferenceType?: InputMaybe<BuildingType>
  tariffPid?: InputMaybe<Scalars["String"]["input"]>
}>

export type AddMeterMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    addMeter: {
      __typename: "BillingMeter"
      pid: string
      label: string
      config: {
        __typename?: "BMConfig"
        loadCategory: LoadCategory
        doeReferenceType: BuildingType
      }
    }
  }
}

export type EditBillingMeterAnnualMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  kwh?: InputMaybe<Scalars["Float"]["input"]>
  kw?: InputMaybe<Scalars["Float"]["input"]>
  costUsd?: InputMaybe<Scalars["Float"]["input"]>
}>

export type EditBillingMeterAnnualMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    editAnnual: {
      __typename: "BillingMeter"
      pid: string
      label: string
      config: {
        __typename?: "BMConfig"
        loadCategory: LoadCategory
        doeReferenceType: BuildingType
      }
    }
  }
}

export type EditBillingMeterLabelMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  label: Scalars["String"]["input"]
}>

export type EditBillingMeterLabelMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    editLabel: {
      __typename: "BillingMeter"
      pid: string
      label: string
      config: {
        __typename?: "BMConfig"
        loadCategory: LoadCategory
        doeReferenceType: BuildingType
      }
    }
  }
}

export type EditBillingMeterDoeReferenceTypeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  doeReferenceType: BuildingType
}>

export type EditBillingMeterDoeReferenceTypeMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    editDoeReferenceType: { __typename: "BillingMeter" }
  }
}

export type EditBillingMeterTariffMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  tariffPid: Scalars["String"]["input"]
}>

export type EditBillingMeterTariffMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    editBauTariff: { __typename: "BillingMeter" }
  }
}

export type AddBillingMeterIntervalsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  input: BillingIntervalsExtraction
}>

export type AddBillingMeterIntervalsMutation = {
  __typename?: "Mutation"
  billingMeters: { __typename?: "BillingMeterMutations"; addIntervals?: any | null }
}

export type AddBillingMeterMonthliesMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  input: MonthlyExtraction
}>

export type AddBillingMeterMonthliesMutation = {
  __typename?: "Mutation"
  billingMeters: { __typename?: "BillingMeterMutations"; addMonthlies?: any | null }
}

export type BillingMeterEditTenantDetailsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  input: MfUnitBreakdownInput
}>

export type BillingMeterEditTenantDetailsMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    editTenantDetails?: any | null
  }
}

export type RemoveBillingMeterIntervalsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  intervalsId: Scalars["Int"]["input"]
}>

export type RemoveBillingMeterIntervalsMutation = {
  __typename?: "Mutation"
  billingMeters: { __typename?: "BillingMeterMutations"; removeIntervals?: any | null }
}

export type SetArchivedBillingMeterMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  archived: Scalars["Boolean"]["input"]
}>

export type SetArchivedBillingMeterMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    editArchived: { __typename: "BillingMeter" }
  }
}

export type EditBillingMeterMonthMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  start: Scalars["Date"]["input"]
  end: Scalars["Date"]["input"]
  totalKwh: Scalars["Float"]["input"]
  peakKw?: InputMaybe<Scalars["Float"]["input"]>
  totalCostUsd?: InputMaybe<Scalars["Float"]["input"]>
  supplyCostUsd?: InputMaybe<Scalars["Float"]["input"]>
  transmissionCostUsd?: InputMaybe<Scalars["Float"]["input"]>
}>

export type EditBillingMeterMonthMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    editMonth: { __typename: "BillingMeter" }
  }
}

export type RemoveBillingMeterMonthMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  meterPid: Scalars["String"]["input"]
  monthId: Scalars["Int"]["input"]
}>

export type RemoveBillingMeterMonthMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    removeMonth: { __typename: "BillingMeter" }
  }
}

export type MoveDocumentBillingMonthMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  billingMonthId: Scalars["Int"]["input"]
  kind: BillType
  fromMeterPid?: InputMaybe<Scalars["String"]["input"]>
  toMeterPid?: InputMaybe<Scalars["String"]["input"]>
}>

export type MoveDocumentBillingMonthMutation = {
  __typename?: "Mutation"
  billingMeters: {
    __typename?: "BillingMeterMutations"
    moveDocumentBillingMonth?: any | null
  }
}

export type CreateBuildingDataFromGooglePlaceMutationVariables = Exact<{
  placeId: Scalars["String"]["input"]
}>

export type CreateBuildingDataFromGooglePlaceMutation = {
  __typename?: "Mutation"
  buildingData: {
    __typename?: "PublicBuildingDataMutations"
    createFromGooglePlace:
      | {
          __typename: "BuildingData"
          id: number
          fullAddress: string
          buildingType?: BuildingType | null
          propertyName?: string | null
          roofSqft?: number | null
          sqft?: number | null
          numStories?: number | null
          latitude: number
          longitude: number
          buildingFootprintGeojson?: any | null
          yearBuilt?: number | null
          numUnitsTotal?: number | null
        }
      | { __typename: "Error"; message: string }
  }
}

export type CreateSiteFromBuildingDataMutationVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
  buildingDataId: Scalars["Int"]["input"]
  amendments: BuildingDataAmendmentsInput
}>

export type CreateSiteFromBuildingDataMutation = {
  __typename?: "Mutation"
  buildingData: {
    __typename?: "PublicBuildingDataMutations"
    createSite:
      | { __typename: "Error"; message: string }
      | { __typename: "SiteRef"; pid: string }
  }
}

export type CreateBundleParentMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  type: FinProductType
  note: Scalars["String"]["input"]
  pricingNote: Scalars["String"]["input"]
  biddingOpenAt?: InputMaybe<Scalars["DateTime"]["input"]>
  biddingClosedAt?: InputMaybe<Scalars["DateTime"]["input"]>
}>

export type CreateBundleParentMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      createParent: {
        __typename?: "BundleParent"
        id: number
        pid: string
        name: string
      }
    }
  }
}

export type EditBundleParentMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  note: Scalars["String"]["input"]
  pricingNote: Scalars["String"]["input"]
  biddingOpenAt?: InputMaybe<Scalars["DateTime"]["input"]>
  biddingClosedAt?: InputMaybe<Scalars["DateTime"]["input"]>
}>

export type EditBundleParentMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        setName?: any | null
        setNote?: any | null
        setPricingNote?: any | null
        setBiddingOpenAt?: any | null
        setBiddingClosedAt?: any | null
      }
    }
  }
}

export type AddBundleParentFinancierMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  financierPids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type AddBundleParentFinancierMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; addFinanciers?: any | null }
    }
  }
}

export type AddBundleParentSiteMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  projectParams: ProjectParamsInput
}>

export type AddBundleParentSiteMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; upsertSite?: any | null }
    }
  }
}

export type CreateBundleParentSystemMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  input: AddSystemInput
}>

export type CreateBundleParentSystemMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        addSystem: {
          __typename?: "SystemUnion"
          system?: { __typename?: "System"; pid: string } | null
          lite?: { __typename?: "SystemLite"; pid: string } | null
        }
      }
    }
  }
}

export type RemoveBundleParentSiteMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type RemoveBundleParentSiteMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; removeSite?: any | null }
    }
  }
}

export type AddInvestorBidMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  input: InvestorBidInput
}>

export type AddInvestorBidMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: {
      __typename?: "PublicBundleMutations"
      addInvestorBid: {
        __typename?: "InvestorBid"
        ppa?: { __typename?: "PPAInvestorBid"; pid: string } | null
        cs?: { __typename?: "CSInvestorBid"; pid: string } | null
      }
    }
  }
}

export type EditInvestorBidMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  bidPid: Scalars["String"]["input"]
  input: InvestorBidInput
}>

export type EditInvestorBidMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: {
      __typename?: "PublicBundleMutations"
      editInvestorBid: {
        __typename?: "InvestorBid"
        ppa?: { __typename?: "PPAInvestorBid"; pid: string } | null
        cs?: { __typename?: "CSInvestorBid"; pid: string } | null
      }
    }
  }
}

export type DuplicateInvestorBidMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  input: DuplicateInvestorBidInput
}>

export type DuplicateInvestorBidMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: {
      __typename?: "PublicBundleMutations"
      duplicateInvestorBid: {
        __typename?: "InvestorBid"
        ppa?: { __typename?: "PPAInvestorBid"; pid: string } | null
        cs?: { __typename?: "CSInvestorBid"; pid: string } | null
      }
    }
  }
}

export type AddSystemMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  input: AddSystemInput
}>

export type AddSystemMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: {
      __typename?: "PublicBundleMutations"
      addSystem: {
        __typename?: "SystemUnion"
        system?: { __typename?: "System"; pid: string } | null
        lite?: { __typename?: "SystemLite"; pid: string } | null
      }
    }
  }
}

export type UpdateEvOverridesMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  projectStartDate?: InputMaybe<Scalars["DateTime"]["input"]>
  discountRate?: InputMaybe<Scalars["Float"]["input"]>
  usdPerKwhMarkup?: InputMaybe<Scalars["Float"]["input"]>
  incentivePct?: InputMaybe<Scalars["Float"]["input"]>
  salesTaxPct?: InputMaybe<Scalars["Float"]["input"]>
  omUsdPerChargerPerYr?: InputMaybe<Scalars["Float"]["input"]>
  rateManagementUsdPerChargerPerYr?: InputMaybe<Scalars["Float"]["input"]>
  cmsUsdPerChargerPerYr?: InputMaybe<Scalars["Float"]["input"]>
  demandUsdPerKw?: InputMaybe<Scalars["Float"]["input"]>
  installType?: InputMaybe<ChargerInstallType>
  termYears?: InputMaybe<Scalars["Int"]["input"]>
  lowEnergyUsdPerKwh?: InputMaybe<Scalars["Float"]["input"]>
  highEnergyUsdPerKwh?: InputMaybe<Scalars["Float"]["input"]>
  onPeakChargingPct?: InputMaybe<Scalars["Float"]["input"]>
  numChargers?: InputMaybe<Scalars["Float"]["input"]>
  chargerLocation?: InputMaybe<ChargerLocation>
  chargerKw?: InputMaybe<Scalars["Float"]["input"]>
  milesDrivenPerYear?: InputMaybe<Scalars["Float"]["input"]>
  milesPerKwh?: InputMaybe<Scalars["Float"]["input"]>
  maxUtilization?: InputMaybe<Scalars["Float"]["input"]>
  transactionFeePct?: InputMaybe<Scalars["Float"]["input"]>
  onSiteChargingPct?: InputMaybe<Scalars["Float"]["input"]>
  yr0NumTenantEvs?: InputMaybe<Scalars["Int"]["input"]>
  evGrowthPct?: InputMaybe<Scalars["Float"]["input"]>
  incentiveCapNumChargers?: InputMaybe<Scalars["Int"]["input"]>
  maxEvAdoptionPct?: InputMaybe<Scalars["Float"]["input"]>
  installCostUsd?: InputMaybe<Scalars["Float"]["input"]>
}>

export type UpdateEvOverridesMutation = {
  __typename?: "Mutation"
  evOverrides: { __typename?: "EVOverrideMutations"; update?: any | null }
}

export type ArchiveSiteMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  reason: StatusReason
}>

export type ArchiveSiteMutation = {
  __typename?: "Mutation"
  archiveSite: { __typename: "Error" } | { __typename: "RevampSite" }
}

export type ResolveSiteFlagMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  flagType: SiteFlagType
}>

export type ResolveSiteFlagMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    flags: {
      __typename?: "SiteFlagMutations"
      resolveSiteFlag?: { __typename: "Error" } | null
    }
  }
}

export type CreatePortfolioMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
}>

export type CreatePortfolioMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    createPortfolio?: { __typename: "Error"; message: string } | null
  }
}

export type GrantRoleMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  input: UserRoleInput
}>

export type GrantRoleMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    roles: {
      __typename?: "UserRoleMutations"
      grantRole?: { __typename: "Error"; message: string } | null
    }
  }
}

export type RevokeRoleMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  input: UserRoleInput
}>

export type RevokeRoleMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    roles: {
      __typename?: "UserRoleMutations"
      revokeRole?: { __typename: "Error"; message: string } | null
    }
  }
}

export type UpdateInvestorProfileMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  hq?: InputMaybe<Scalars["String"]["input"]>
  yearFounded?: InputMaybe<Scalars["Int"]["input"]>
  website?: InputMaybe<Scalars["String"]["input"]>
  managementTeam: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
  description?: InputMaybe<Scalars["String"]["input"]>
  distinguishingFeatures?: InputMaybe<Scalars["String"]["input"]>
  investorBacking?: InputMaybe<Scalars["String"]["input"]>
  longTermOwnershipApproach?: InputMaybe<Scalars["String"]["input"]>
  subscriptionMgmtApproach?: InputMaybe<Scalars["String"]["input"]>
  committedFunding?: InputMaybe<Scalars["String"]["input"]>
  experiences: Array<ExperienceInput> | ExperienceInput
}>

export type UpdateInvestorProfileMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    investorProfile: {
      __typename?: "InvestorProfileMutations"
      updateProfile?: any | null
    }
  }
}

export type UpdateInvestorBuyBoxMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  buyBoxes: Array<BuyBoxInput> | BuyBoxInput
}>

export type UpdateInvestorBuyBoxMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    investorProfile: {
      __typename?: "InvestorProfileMutations"
      updateBuyBox?: any | null
    }
  }
}

export type EvButtonMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  button: Scalars["String"]["input"]
}>

export type EvButtonMutation = {
  __typename?: "Mutation"
  evButton: { __typename?: "EVButtonMutations"; press?: any | null }
}

export type SetBundleParentPreBidMeetingMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  milestone: MilestoneInput
}>

export type SetBundleParentPreBidMeetingMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setPreBidMeeting?: any | null }
    }
  }
}

export type SetBundleParentBidReviewMeetingMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  milestone: MilestoneInput
}>

export type SetBundleParentBidReviewMeetingMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setBidReviewMeeting?: any | null }
    }
  }
}

export type SetArchiveInvestorBidMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  bidPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetArchiveInvestorBidMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: {
      __typename?: "PublicBundleMutations"
      archiveInvestorBid?: any | null
    }
  }
}

export type SetBundleRowOptOutMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  bundleRowId: Scalars["Int"]["input"]
  value: Scalars["Boolean"]["input"]
  reason?: InputMaybe<InvestorOptOutReason>
  customReason?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetBundleRowOptOutMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: { __typename?: "PublicBundleMutations"; toggleOptOut?: any | null }
  }
}

export type SetBundleOptOutMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
  reason?: InputMaybe<InvestorOptOutReason>
  customReason?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetBundleOptOutMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: { __typename?: "PublicBundleMutations"; toggleOptOut?: any | null }
  }
}

export type SetBidSpecOptOutMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  bidSpecPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
  reason?: InputMaybe<SpecOptOutReason>
  customReason?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetBidSpecOptOutMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: {
      __typename?: "PublicBundleMutations"
      toggleSpecOptOut?: any | null
    }
  }
}

export type SubmitBundleBidsMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
}>

export type SubmitBundleBidsMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: { __typename?: "PublicBundleMutations"; submitBids?: any | null }
  }
}

export type AddHelioscopeMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  bundlePid?: InputMaybe<Scalars["String"]["input"]>
  reportPdf: Scalars["Upload"]["input"]
  productionCsv?: InputMaybe<Scalars["Upload"]["input"]>
}>

export type AddHelioscopeMutation = {
  __typename?: "Mutation"
  addHelioscope: {
    __typename?: "Helioscope2"
    id: number
    pdf: { __typename?: "Document"; downloadHref: string }
    roofImage: { __typename?: "Document"; viewHref: string }
    productionCsv?: { __typename?: "Document"; downloadHref: string } | null
  }
}

export type SetArchiveBidSpecMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  specPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetArchiveBidSpecMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; archiveSpec?: any | null }
    }
  }
}

export type SetPackageSiteNotesMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  notes?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetPackageSiteNotesMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setRowNotes?: any | null }
    }
  }
}

export type AddInvestorBidSpecMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  input: BidSpecInput
}>

export type AddInvestorBidSpecMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        addSpec: {
          __typename?: "BidSpec"
          ppa?: { __typename?: "PPABidSpec"; pid: string } | null
          cs?: { __typename?: "CSBidSpec"; pid: string } | null
        }
      }
    }
  }
}

export type EditInvestorBidSpecMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  specPid: Scalars["String"]["input"]
  input: BidSpecInput
}>

export type EditInvestorBidSpecMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        editSpec: {
          __typename?: "BidSpec"
          ppa?: { __typename?: "PPABidSpec"; pid: string } | null
          cs?: { __typename?: "CSBidSpec"; pid: string } | null
        }
      }
    }
  }
}

export type EnqueueTaskMutationVariables = Exact<{
  params: TaskParamsInput
}>

export type EnqueueTaskMutation = {
  __typename?: "Mutation"
  tasks: {
    __typename?: "PublicTaskMutations"
    enqueue:
      | { __typename: "Error"; message: string }
      | { __typename: "Task"; id: number; name: string; status: Status }
  }
}

export type EtbExtractFragment = {
  __typename?: "ETBExtract"
  id: number
  document: {
    __typename?: "Document"
    id: number
    pid: string
    fileName: string
    downloadHref: string
  }
  pv: Array<{
    __typename?: "ETBPV"
    sizeKwDc: number
    sizeKwAc: number
    etbMeterId: number
    etbMeterName: string
  }>
  battery: Array<{
    __typename?: "ETBBattery"
    sizeKwDc: number
    sizeKwh: number
    etbMeterId: number
    etbMeterName: string
  }>
}

export type AddBundleParentEtbMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}>

export type AddBundleParentEtbMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        addEtb: {
          __typename?: "ETBExtract"
          id: number
          document: {
            __typename?: "Document"
            id: number
            pid: string
            fileName: string
            downloadHref: string
          }
          pv: Array<{
            __typename?: "ETBPV"
            sizeKwDc: number
            sizeKwAc: number
            etbMeterId: number
            etbMeterName: string
          }>
          battery: Array<{
            __typename?: "ETBBattery"
            sizeKwDc: number
            sizeKwh: number
            etbMeterId: number
            etbMeterName: string
          }>
        }
      }
    }
  }
}

export type AddBundleEtbMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  upload: Scalars["Upload"]["input"]
}>

export type AddBundleEtbMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: {
      __typename?: "PublicBundleMutations"
      addEtb: {
        __typename?: "ETBExtract"
        id: number
        document: {
          __typename?: "Document"
          id: number
          pid: string
          fileName: string
          downloadHref: string
        }
        pv: Array<{
          __typename?: "ETBPV"
          sizeKwDc: number
          sizeKwAc: number
          etbMeterId: number
          etbMeterName: string
        }>
        battery: Array<{
          __typename?: "ETBBattery"
          sizeKwDc: number
          sizeKwh: number
          etbMeterId: number
          etbMeterName: string
        }>
      }
    }
  }
}

export type SetPackageRowStatusMutationVariables = Exact<{
  bundleParentPid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  status?: InputMaybe<PackageRowStatus>
  closed?: InputMaybe<Scalars["Boolean"]["input"]>
  closeReason?: InputMaybe<PackageRowCloseReason>
  closeCustomReason?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetPackageRowStatusMutation = {
  __typename?: "Mutation"
  setPackageRowStatus?: any | null
}

export type AwardInvestorBidMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bidPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type AwardInvestorBidMutation = {
  __typename?: "Mutation"
  orgBySlug: { __typename?: "OrgMutations"; awardInvestorBid?: any | null }
}

export type RecommendInvestorBidMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bidPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type RecommendInvestorBidMutation = {
  __typename?: "Mutation"
  orgBySlug: { __typename?: "OrgMutations"; recommendInvestorBid?: any | null }
}

export type SetBundleParentHiddenFromFinancierMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetBundleParentHiddenFromFinancierMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        setHiddenFromFinancier?: any | null
      }
    }
  }
}

export type SetBundleParentHiddenFromReceiverMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetBundleParentHiddenFromReceiverMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setHiddenFromRecvr?: any | null }
    }
  }
}

export type SetBundleParentCanAddNewBidsMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetBundleParentCanAddNewBidsMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setCanAddNewBids?: any | null }
    }
  }
}

export type SetBundleParentCanEditBidsMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetBundleParentCanEditBidsMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setCanEditBids?: any | null }
    }
  }
}

export type SetBundleParentShowAllBidsReportMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetBundleParentShowAllBidsReportMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setShowAllBidsReport?: any | null }
    }
  }
}

export type SetBundleParentOpsOwnerMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  opsOwnerPid?: InputMaybe<Scalars["String"]["input"]>
}>

export type SetBundleParentOpsOwnerMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: { __typename?: "BundleParentEdit"; setOpsOwner?: any | null }
    }
  }
}

export type UpdateSiteDetailsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  input: UpdateDetailsInput
  sourceType?: InputMaybe<ChangeSourceType>
  sourceId?: InputMaybe<Scalars["String"]["input"]>
}>

export type UpdateSiteDetailsMutation = {
  __typename?: "Mutation"
  siteDetails: { __typename?: "SiteDetailsMutations"; updateDetails?: any | null }
}

export type CreateCustomBidReportMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  developerNotes: Scalars["String"]["input"]
  buildingOwnerNotes: Scalars["String"]["input"]
}>

export type CreateCustomBidReportMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        createCustomBidReport: {
          __typename?: "CustomBidReport"
          pid: string
          name: string
          notes: string
          buildingOwnerNotes?: string | null
        }
      }
    }
  }
}

export type EditCustomBidReportMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  reportPid: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  developerNotes: Scalars["String"]["input"]
  buildingOwnerNotes: Scalars["String"]["input"]
}>

export type EditCustomBidReportMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        editCustomBidReport: {
          __typename?: "CustomBidReportEdit"
          setName?: any | null
          setDeveloperNotes?: any | null
          setBuildingOwnerNotes?: any | null
        }
      }
    }
  }
}

export type SetCustomBidReportVisibleToDevelopersMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  reportPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetCustomBidReportVisibleToDevelopersMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        editCustomBidReport: {
          __typename?: "CustomBidReportEdit"
          setVisibleToDevelopers?: any | null
        }
      }
    }
  }
}

export type SetCustomBidReportVisibleToBuildingOwnersMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  reportPid: Scalars["String"]["input"]
  value: Scalars["Boolean"]["input"]
}>

export type SetCustomBidReportVisibleToBuildingOwnersMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        editCustomBidReport: {
          __typename?: "CustomBidReportEdit"
          setVisibleToBuildingOwners?: any | null
        }
      }
    }
  }
}

export type DeleteCustomBidReportMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  reportPid: Scalars["String"]["input"]
}>

export type DeleteCustomBidReportMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        editCustomBidReport: { __typename?: "CustomBidReportEdit"; delete?: any | null }
      }
    }
  }
}

export type AddBidToCustomBidReportMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  reportPid: Scalars["String"]["input"]
  bidPid: Scalars["String"]["input"]
}>

export type AddBidToCustomBidReportMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        editCustomBidReport: {
          __typename?: "CustomBidReportEdit"
          upsertBid?: any | null
        }
      }
    }
  }
}

export type RemoveBidFromCustomBidReportMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundleParentPid: Scalars["String"]["input"]
  reportPid: Scalars["String"]["input"]
  bidPid: Scalars["String"]["input"]
}>

export type RemoveBidFromCustomBidReportMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    bundle: {
      __typename?: "BundleMutation"
      editParent: {
        __typename?: "BundleParentEdit"
        editCustomBidReport: {
          __typename?: "CustomBidReportEdit"
          removeBid?: any | null
        }
      }
    }
  }
}

export type UpdateCustomTariffMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  customTariffId: Scalars["Int"]["input"]
  addRateOps: Array<AddRateInput> | AddRateInput
  subRateOps: Array<SubRateInput> | SubRateInput
  propertyOps: Array<OverridePropertyInput> | OverridePropertyInput
  name: Scalars["String"]["input"]
}>

export type UpdateCustomTariffMutation = {
  __typename?: "Mutation"
  customTariffs: {
    __typename?: "CustomTariffMutations"
    update: { __typename?: "CustomTariff"; id: number }
  }
}

export type CreateCustomTariffMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  rateId: Scalars["Int"]["input"]
  addRateOps: Array<AddRateInput> | AddRateInput
  subRateOps: Array<SubRateInput> | SubRateInput
  propertyOps: Array<OverridePropertyInput> | OverridePropertyInput
}>

export type CreateCustomTariffMutation = {
  __typename?: "Mutation"
  customTariffs: {
    __typename?: "CustomTariffMutations"
    create: { __typename?: "CustomTariff"; id: number }
  }
}

export type CreateCustomTariffScratchMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  name: Scalars["String"]["input"]
  tariffClass: TariffClass
  utilityPid: Scalars["String"]["input"]
  addRateOps: Array<AddRateInput> | AddRateInput
}>

export type CreateCustomTariffScratchMutation = {
  __typename?: "Mutation"
  customTariffs: {
    __typename?: "CustomTariffMutations"
    createFromScratch: { __typename?: "CustomTariff"; id: number }
  }
}

export type SetProjectMilestoneMutationVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  milestoneType: MilestoneType
  milestoneInput: ProjectMilestoneInput
}>

export type SetProjectMilestoneMutation = {
  __typename?: "Mutation"
  orgBySlug: {
    __typename?: "OrgMutations"
    financierBundle: { __typename?: "PublicBundleMutations"; setMilestone?: any | null }
  }
}

export type SetIsBehindTheMeterMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  isBehindTheMeter?: InputMaybe<Scalars["Boolean"]["input"]>
}>

export type SetIsBehindTheMeterMutation = {
  __typename?: "Mutation"
  setIsBehindTheMeter?: any | null
}

export type FinalizeEnergyPageUploadsMutationVariables = Exact<{
  sitePid: Scalars["String"]["input"]
}>

export type FinalizeEnergyPageUploadsMutation = {
  __typename?: "Mutation"
  finalizeEnergyPageUpload?: any | null
}

export type CreateEmailDraftMutationVariables = Exact<{
  draftParams: DraftEmailInput
}>

export type CreateEmailDraftMutation = {
  __typename?: "Mutation"
  admin: {
    __typename?: "AdminMutation"
    googleApi: { __typename?: "GoogleApiMutations"; draftEmail?: any | null }
  }
}

export type AddFinmodelOverrideMutationVariables = Exact<{
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  overrideInput: FinmodelMutationInput
}>

export type AddFinmodelOverrideMutation = {
  __typename?: "Mutation"
  finmodel: {
    __typename?: "PublicFinmodelMutations"
    addOverride:
      | { __typename: "Error"; message: string }
      | { __typename: "FinmodelInputOverride"; inputName: string; inputValue: string }
  }
}

export type DeleteFinmodelOverrideMutationVariables = Exact<{
  sitePid?: InputMaybe<Scalars["String"]["input"]>
  portfolioPid?: InputMaybe<Scalars["String"]["input"]>
  inputName: Scalars["String"]["input"]
}>

export type DeleteFinmodelOverrideMutation = {
  __typename?: "Mutation"
  finmodel: {
    __typename?: "PublicFinmodelMutations"
    deleteOverride?:
      | { __typename: "Error"; message: string }
      | { __typename: "FinmodelInputOverride"; inputName: string; inputValue: string }
      | null
  }
}

export type ListUtilitiesQueryVariables = Exact<{
  zipCode: Scalars["String"]["input"]
  state: Scalars["String"]["input"]
}>

export type ListUtilitiesQuery = {
  __typename?: "Query"
  utilitiesForZip:
    | { __typename: "Error"; message: string }
    | {
        __typename: "UtilityList"
        refs: Array<{
          __typename?: "UtilityRef"
          id: number
          pid: string
          name: string
          shortName: string
        }>
      }
  utilitiesForState:
    | { __typename: "Error"; message: string }
    | {
        __typename: "UtilityList"
        refs: Array<{
          __typename?: "UtilityRef"
          id: number
          pid: string
          name: string
          shortName: string
        }>
      }
}

export type OrgSettingsDetailBySlugQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type OrgSettingsDetailBySlugQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    name: string
    slug: string
    irrFlavor: IrrType
    isDeveloper: boolean
    currentUserPermissions: Array<Permission>
    users: Array<{
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }>
    portfolios: Array<{ __typename?: "PortfolioRef"; pid: string; title: string }>
    userRoles: Array<{
      __typename?: "UserRole"
      role: RbacRole
      user: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
    }>
    investorProfile: {
      __typename?: "InvestorProfile"
      hq?: string | null
      yearFounded?: number | null
      website?: string | null
      managementTeam: Array<string>
      description?: string | null
      distinguishingFeatures?: string | null
      investorBacking?: string | null
      longTermOwnershipApproach?: string | null
      subscriptionMgmtApproach?: string | null
      committedFunding?: string | null
      experiences: Array<{
        __typename?: "Experience"
        state?: UsState | null
        ftmEnergizedPvKw?: number | null
        ftmAwardedPvKw?: number | null
        btmEnergizedPvKw?: number | null
        btmAwardedPvKw?: number | null
      }>
      buyBoxes: Array<{
        __typename?: "BuyBox"
        state?: UsState | null
        ftmMinPortfolioSize?: number | null
        ftmMinProjectSize?: number | null
        ftmSeekingProjects?: boolean | null
        btmMinPortfolioSize?: number | null
        btmMinProjectSize?: number | null
        btmSeekingProjects?: boolean | null
        utilityProgramNotes?: string | null
      }>
    }
  } | null
}

export type OrgUsersQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type OrgUsersQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    name: string
    currentUserPermissions: Array<Permission>
    portfolios: Array<{ __typename?: "PortfolioRef"; pid: string; title: string }>
    orgUsers: Array<{
      __typename?: "OrgUser"
      user: { __typename?: "UserRef"; pid: string; name?: string | null; email: string }
      userRoles: Array<{
        __typename?: "UserRole"
        role: RbacRole
        portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
      }>
    }>
    unclaimedInvites: Array<{
      __typename?: "AdminInvitation"
      dateCreated: string
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
      targetUser: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
    }>
  } | null
}

export type PortfolioUsersQueryVariables = Exact<{
  portfolioPid: Scalars["String"]["input"]
}>

export type PortfolioUsersQuery = {
  __typename?: "Query"
  portfolio?: {
    __typename?: "Portfolio"
    pid: string
    title: string
    users: Array<{
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }>
  } | null
}

export type WelcomeQueryVariables = Exact<{
  pid: Scalars["String"]["input"]
}>

export type WelcomeQuery = {
  __typename?: "Query"
  openInvite:
    | { __typename: "Error"; message: string }
    | {
        __typename: "OpenInvite"
        pid: string
        orgSlug: string
        portfolio: { __typename?: "PortfolioAccess"; pid: string; title: string }
      }
}

export type OrgSiteLabelsBySlugQueryVariables = Exact<{
  orgSlug?: InputMaybe<Scalars["String"]["input"]>
}>

export type OrgSiteLabelsBySlugQuery = {
  __typename?: "Query"
  orgLabels: Array<{
    __typename?: "SiteLabel"
    pid: string
    name: string
    themeColor: LabelColor
    sites: Array<string>
  }>
}

export type OrgSiteDocsBySlugQueryVariables = Exact<{
  orgSlug?: InputMaybe<Scalars["String"]["input"]>
}>

export type OrgSiteDocsBySlugQuery = {
  __typename?: "Query"
  orgSiteDocuments: Array<{
    __typename?: "SiteDocuments"
    sitePid: string
    documents: Array<{
      __typename?: "Document"
      id: number
      pid: string
      contentType: string
      dateCreated: string
      fileName: string
      ownerName: string
      ownerEmail: string
      downloadHref: string
      viewHref: string
      tag?: DocumentTag | null
    }>
  }>
}

export type GetVersionQueryVariables = Exact<{ [key: string]: never }>

export type GetVersionQuery = {
  __typename?: "Query"
  schemaVersion: { __typename?: "SchemaVersion"; version: string }
}

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>

export type CurrentUserQuery = {
  __typename?: "Query"
  currentUser: {
    __typename?: "AuthUser"
    pid?: string | null
    isAuthenticated: boolean
    isAdmin: boolean
    email?: string | null
    name?: string | null
    org?: {
      __typename?: "Org"
      pid: string
      slug: string
      name: string
      logoUrl?: string | null
      logomarkUrl?: string | null
      irrFlavor: IrrType
      inactivityTimeoutMs?: number | null
    } | null
    orgs: Array<{ __typename?: "Org"; pid: string; name: string; slug: string }>
  }
}

export type PropertyHubViewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy: OrgSiteTableFilter
  sortBy?: InputMaybe<Array<OrgSiteTableSort> | OrgSiteTableSort>
}>

export type PropertyHubViewQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    sites: {
      __typename?: "OrgSiteTable"
      view: { __typename?: "OrgSiteTableView"; keys: Array<string>; count: number }
    }
  } | null
}

export type PropertyHubRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  keys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type PropertyHubRowsQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    sites: {
      __typename?: "OrgSiteTable"
      rows: Array<{
        __typename?: "OrgSiteTableRow"
        pid: string
        name?: string | null
        city: string
        state: string
        zipCode: string
        streetAddress: string
        county: string
        cbsaName?: string | null
        assetManager?: string | null
        ownerName?: string | null
        customerId?: string | null
        portfolio: string
        status: SiteStatus
        statusReason?: StatusReason | null
        statusCustomReason?: string | null
        isFavorite: boolean
        salePlans?: string | null
        salePlannedYear?: number | null
        mortgageLender?: string | null
        sqft?: number | null
        buildingType?: BuildingType | null
        buildingClass?: string | null
        numStories?: number | null
        numUnitsTotal?: number | null
        yearBuilt?: number | null
        buildingFootprintSqft?: number | null
        buildingFootprintRoofSqftError?: number | null
        buildingSqftRoofSqftError?: number | null
        buildingFootprintCount?: number | null
        existingSolarDetectionScore?: number | null
        inEnergyCommunity: boolean
        inLowIncomeCommunity: boolean
        roofCondition?: string | null
        roofReplacedYr?: number | null
        roofSqft?: number | null
        usableRoofSqft?: number | null
        metering?: Metering | null
        loadOrigin?: LoadOrigin | null
        utilityName?: string | null
        utilityCagr?: number | null
        utilityCagrFromYear?: number | null
        utilityCagrToYear?: number | null
        meterCount: number
        loadKwh?: number | null
        loadUsd?: number | null
        loadUsdPerKwh?: number | null
        soleTariffName?: string | null
        bauCo2EmissionsTons?: number | null
        bauCo2EmissionsTonsPerMwh?: number | null
        ppaOfftaker?: PpaOfftaker | null
        ppaSignatory?: string | null
        occupancyType?: BuildingOccupancyType | null
        tenantLeaseEnds?: string | null
        leaseType?: LeaseType | null
        tenantInterest?: YesNoUnsure | null
        noiRangeMin?: number | null
        noiRangeMax?: number | null
        noiSelfMax?: number | null
        irrSelfMax?: number | null
        solarLocationSelfMax?: SolarLocation | null
        includeStorageSelfMax?: boolean | null
        pvSizeKwSelfMax?: number | null
        storageSizeKwSelfMax?: number | null
        storageSizeKwhSelfMax?: number | null
        leDevFeeSelfMax?: number | null
        gpvSelfMax?: number | null
        lifetimeCapexSelfMax?: number | null
        lifetimeUtilitySavingsSelfMax?: number | null
        co2EmissionsReductionTonnesSelfMax?: number | null
        noiPpaMax?: number | null
        solarLocationPpaMax?: SolarLocation | null
        includeStoragePpaMax?: boolean | null
        pvSizeKwPpaMax?: number | null
        storageSizeKwPpaMax?: number | null
        storageSizeKwhPpaMax?: number | null
        leDevFeePpaMax?: number | null
        gpvPpaMax?: number | null
        lifetimeUtilitySavingsPpaMax?: number | null
        costPerKwhPpaMax?: number | null
        ppaEscPpaMax?: number | null
        yearOneOfftakerSavingsPpaMax?: number | null
        co2EmissionsReductionTonnesPpaMax?: number | null
        noiLoanMax?: number | null
        leDevFeeLoanMax?: number | null
        gpvLoanMax?: number | null
        noiLeaseMax?: number | null
        noiCsMax?: number | null
        pvSizeKwCsMax?: number | null
        roofMaxPvKw: number
        groundMaxPvKw?: number | null
        carportMaxPvKw: number
        marketplaceStatus?: PackageRowStatus | null
        marketplaceClosedAt?: string | null
        marketplaceCloseReason?: PackageRowCloseReason | null
        marketplaceCloseCustomReason?: string | null
        flagSummary?: {
          __typename: "SiteFlagSummary"
          utilityNotFound?: boolean | null
          tariffNotFound?: boolean | null
          improbableEnergyCosts?: boolean | null
          existingSolarLikely?: boolean | null
          duplicateAddressFound?: boolean | null
        } | null
        energyThings?: {
          __typename?: "EnergyThings"
          canRooftopSolar: boolean
          canCarportSolar?: boolean | null
          canGroundmountSolar?: boolean | null
          canStorage: boolean
        } | null
        financingThings?: {
          __typename?: "FinancingThings"
          canSelfInvest: boolean
          canLoan: boolean
          canPpa?: boolean | null
          canLease?: boolean | null
          canCommunitySolar?: boolean | null
        } | null
        physicalCheck?: {
          __typename?: "PhysicalCheck"
          roofIsGood: boolean
          carportIsGood: boolean
          groundmountIsGood: boolean
          existingSolar?: boolean | null
          unobstructedFlatRoof?: boolean | null
          badRoof?: boolean | null
        } | null
      }>
    }
  } | null
}

export type MarketplaceOrgPropertySearchQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type MarketplaceOrgPropertySearchQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    slug: string
    marketplaceSiteSearchTerms: Array<{
      __typename?: "MarketplaceSiteSearchTerm"
      propertyName?: string | null
      address: string
      pid: string
      packagePid: string
    }>
  } | null
}

export type OrgPropertySearchQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type OrgPropertySearchQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    slug: string
    siteSearchTerms: Array<{
      __typename?: "SiteSearchTerm"
      propertyName?: string | null
      address: string
      pid: string
    }>
  } | null
}

export type OrgHomepageQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type OrgHomepageQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    name: string
    logoUrl?: string | null
    portfolioPdfReportHref?: string | null
    mapView: Array<{ __typename?: "MapView"; pid: string; lat: number; lon: number }>
  } | null
}

export type OrgFacetsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type OrgFacetsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    sites: {
      __typename?: "OrgSiteTable"
      view: {
        __typename?: "OrgSiteTableView"
        stats: {
          __typename?: "OrgSiteTableStats"
          portfolios: Array<string>
          coveredStates: Array<string>
          buildingClasses: Array<string>
          buildingTypes: Array<BuildingType>
          counties: Array<string>
          cbsaNames: Array<string>
          assetManagers: Array<string>
          utilityNames: Array<string>
          ownerNames: Array<string>
        }
      }
    }
    finproducts: Array<{
      __typename?: "FinProductRef"
      id: number
      type: FinProductType
      name: string
    }>
  } | null
}

export type OrgSiteTableQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy?: InputMaybe<OrgSiteTableFilter>
  sortBy?: InputMaybe<Array<OrgSiteTableSort> | OrgSiteTableSort>
}>

export type OrgSiteTableQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    name: string
    sites: {
      __typename?: "OrgSiteTable"
      view: {
        __typename?: "OrgSiteTableView"
        keys: Array<string>
        count: number
        stats: {
          __typename?: "OrgSiteTableStats"
          annualNoi: number
          co2EmissionsReductionTonnes: number
          maxPvSizeKw: number
        }
      }
    }
  } | null
}

export type PortfolioPdfReportStatsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type PortfolioPdfReportStatsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    name: string
    mapView: Array<{ __typename?: "MapView"; pid: string; lat: number; lon: number }>
    sites: {
      __typename?: "OrgSiteTable"
      view: {
        __typename?: "OrgSiteTableView"
        keys: Array<string>
        count: number
        stats: {
          __typename?: "OrgSiteTableStats"
          annualNoi: number
          maxPvSizeKw: number
          co2EmissionsReductionTonnes: number
        }
      }
      highlight: { __typename?: "OrgSiteTableView"; keys: Array<string>; count: number }
      cs: {
        __typename?: "OrgSiteTableView"
        count: number
        stats: {
          __typename?: "OrgSiteTableStats"
          csAnnualNoi: number
          csMaxPvSizeKw: number
        }
      }
      csAfter: {
        __typename?: "OrgSiteTableView"
        count: number
        stats: {
          __typename?: "OrgSiteTableStats"
          csAnnualNoi: number
          csMaxPvSizeKw: number
        }
      }
      ppa: {
        __typename?: "OrgSiteTableView"
        count: number
        stats: {
          __typename?: "OrgSiteTableStats"
          ppaAnnualNoi: number
          ppaMaxPvSizeKw: number
          ppaCo2EmissionsReductionTonnes: number
        }
      }
      cash: {
        __typename?: "OrgSiteTableView"
        count: number
        stats: {
          __typename?: "OrgSiteTableStats"
          cashAnnualNoi: number
          cashMaxPvSizeKw: number
          cashCo2EmissionsReductionTonnes: number
        }
      }
    }
    bestCsSite?: {
      __typename?: "BestCommunitySolarSite"
      pid: string
      name: string
      streetAddress?: string | null
      city?: string | null
      state?: string | null
      zipCode?: string | null
      noiCsMax?: number | null
    } | null
  } | null
}

export type OrgSiteTableRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  propertyPids: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type OrgSiteTableRowsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    sites: {
      __typename?: "OrgSiteTable"
      rows: Array<{
        __typename?: "OrgSiteTableRow"
        pid: string
        name?: string | null
        portfolio: string
        isFavorite: boolean
        streetAddress: string
        city: string
        state: string
        zipCode: string
        noiRangeMin?: number | null
        noiRangeMax?: number | null
        latitude: number
        longitude: number
        irrSelfMax?: number | null
        noiLoanMax?: number | null
        noiPpaMax?: number | null
        noiCsMax?: number | null
        energyThings?: {
          __typename?: "EnergyThings"
          canRooftopSolar: boolean
          canCarportSolar?: boolean | null
          canGroundmountSolar?: boolean | null
          canStorage: boolean
        } | null
        financingThings?: {
          __typename?: "FinancingThings"
          canSelfInvest: boolean
          canLoan: boolean
          canPpa?: boolean | null
          canLease?: boolean | null
          canCommunitySolar?: boolean | null
        } | null
        footprint?: {
          __typename?: "Footprint"
          latitude: number
          longitude: number
          roofShape?: any | null
          roofShapeGeojson?: any | null
        } | null
      }>
    }
  } | null
}

export type RevampSiteQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type RevampSiteQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    name: string
    site?: {
      __typename?: "RevampSite"
      status?: SiteStatus | null
      statusDisplayText?: string | null
      pid: string
      name?: string | null
      isFavorite: boolean
      isBehindTheMeter?: boolean | null
      isEnergyCommunity: boolean
      isLowIncomeCommunity?: boolean | null
      streetAddress: string
      city: string
      state: string
      zipCode: string
      county: string
      fullAddress: string
      metering?: Metering | null
      assetManager?: string | null
      vnemAllowed: boolean
      doeReferenceType?: BuildingType | null
      usingBillingMeters?: string | null
      numParkingSpaces?: number | null
      yearBuilt?: number | null
      numStories?: number | null
      sqft?: number | null
      roofSqft?: number | null
      usableRoofSqft?: number | null
      usableCarportFt?: number | null
      impliedCarportLinearFt?: number | null
      impliedUsableRoofSqft?: number | null
      impliedUsableRoofSqftExplanation: RoofSqftExplanation
      groundAvailableSqft?: number | null
      hideBuildingFootprint: boolean
      keepoutsFootprintSqft?: number | null
      roofMaxPvKw: number
      carportMaxPvKw: number
      groundmountMaxPvKw?: number | null
      maxPvKwPolicyLimited: boolean
      isMultifamily: boolean
      occupancyType?: BuildingOccupancyType | null
      leaseType?: LeaseType | null
      tenantLeaseTerm?: string | null
      tenantLeaseEnds?: string | null
      tenantInterest?: YesNoUnsure | null
      mortgageLender?: string | null
      buildingClass?: string | null
      hasSubmittedEnergyData: boolean
      flags: Array<{ __typename?: "SiteFlag"; type: SiteFlagType }>
      feasibility: {
        __typename?: "SolarFeasibility"
        economics?: GaugeRazzleDazzle | null
        physical?: GaugeRazzleDazzle | null
      }
      labels: Array<{
        __typename?: "SiteLabel"
        name: string
        pid: string
        themeColor: LabelColor
      }>
      biddingConfigResult?: { __typename?: "Result"; id: number } | null
      selectedConfigResult?: {
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      } | null
      selectedResults: Array<{
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      }>
      highlightedResults: Array<{
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      }>
      activeResults: Array<{
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      }>
      resultPerLocation: Array<{
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
      }>
      selectedConfig?: {
        __typename?: "SiteConfig"
        createdAt?: string | null
        createdBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          loadCategory: LoadCategory
          solarLocation: SolarLocation
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
        }
      } | null
      documents: Array<{
        __typename?: "Document"
        pid: string
        downloadHref: string
        fileName: string
        tag?: DocumentTag | null
      }>
      energyThings?: {
        __typename?: "EnergyThings"
        canRooftopSolar: boolean
        canCarportSolar?: boolean | null
        canGroundmountSolar?: boolean | null
        canStorage: boolean
      } | null
      financingThings?: {
        __typename?: "FinancingThings"
        canSelfInvest: boolean
        canLoan: boolean
        canPpa?: boolean | null
        canCommunitySolar?: boolean | null
      } | null
      physicalCheck: {
        __typename?: "PhysicalCheck"
        existingSolar?: boolean | null
        unobstructedFlatRoof?: boolean | null
        badRoof?: boolean | null
      }
      siteDetails: {
        __typename?: "SiteDetails"
        leaseApprovers: Array<string>
        externalLeaseApprovers?: Array<string> | null
        needsTenantApproval?: boolean | null
        roofRightsHolder?: RoofRightsHolder | null
        propertyLenders?: string | null
        propertyInsurer?: string | null
        constructionEmail?: string | null
        propertySiteVisitContacts?: Array<string> | null
        leasePropertyLegalDescription?: string | null
        leaseLegalOwnerName?: string | null
        signatureBlocks?: Array<string> | null
        isFannieMaeLender?: boolean | null
        isFmGlobalInsurer?: boolean | null
        roofReplacedYr?: number | null
        roofCondition?: string | null
        salePlans?: string | null
        buildingLegalName?: string | null
        propertyFundName?: string | null
        leaseSignatory?: string | null
        counselApproval?: CounselApproval | null
      }
      notes: Array<{ __typename?: "Note"; text: string }>
      buildingData?: {
        __typename?: "BuildingData"
        numStories?: number | null
        numUnits?: number | null
        yearBuilt?: number | null
        sqft?: number | null
        roofSqft?: number | null
        numParkingSpaces?: number | null
        occupancyRate?: number | null
        totalBuildings?: number | null
        yearRenovated?: number | null
        parentCompany?: string | null
        lastSalePrice?: number | null
        leedCertified?: string | null
        energyStar?: string | null
        buildingOpex?: string | null
        capRate?: number | null
      } | null
      footprint: {
        __typename?: "Footprint"
        latitude: number
        longitude: number
        bounds?: any | null
        obstructionShape?: any | null
        roofShape?: any | null
        roofShapeGeojson?: any | null
        roofShapeUpdatedAt?: string | null
        roofSetbackShape?: any | null
        roofSetbackShapeGeojson?: any | null
        roofSetbackShapeUpdatedAt?: string | null
        carportShape?: any | null
        carportShapeGeojson?: any | null
        carportShapeUpdatedAt?: string | null
        groundmountShape?: any | null
        groundmountShapeGeojson?: any | null
        groundmountShapeUpdatedAt?: string | null
        keepoutsShape?: any | null
        keepoutsShapeGeojson?: any | null
        keepoutsShapeUpdatedAt?: string | null
        roofShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        roofSetbackShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        carportShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        groundmountShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        keepoutsShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      }
      thirdPartySupplier?: {
        __typename?: "ThirdPartySupplier"
        pid: string
        name: string
      } | null
      meterSet?: { __typename?: "MeterSet"; loadOrigin?: LoadOrigin | null } | null
      targetUtility?: {
        __typename?: "Utility"
        name: string
        pid: string
        id: number
        eiaGridEsc?: {
          __typename?: "EIAGridEsc"
          cagrBlended: number
          fromYear: number
          toYear: number
        } | null
        hostingCapacityMaps: Array<{
          __typename?: "HostingCapacityMap"
          url: string
          requiresLogin: boolean
          types: Array<HostingCapacityMapType>
        }>
      } | null
    } | null
  } | null
}

export type ResultDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  resultPid: Scalars["String"]["input"]
}>

export type ResultDetailQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    name: string
    site?: {
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      roofMaxPvKw: number
      footprint: {
        __typename?: "Footprint"
        latitude: number
        longitude: number
        bounds?: any | null
        obstructionShape?: any | null
        roofShape?: any | null
        roofShapeGeojson?: any | null
        roofShapeUpdatedAt?: string | null
        roofSetbackShape?: any | null
        roofSetbackShapeGeojson?: any | null
        roofSetbackShapeUpdatedAt?: string | null
        carportShape?: any | null
        carportShapeGeojson?: any | null
        carportShapeUpdatedAt?: string | null
        groundmountShape?: any | null
        groundmountShapeGeojson?: any | null
        groundmountShapeUpdatedAt?: string | null
        keepoutsShape?: any | null
        keepoutsShapeGeojson?: any | null
        keepoutsShapeUpdatedAt?: string | null
        roofShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        roofSetbackShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        carportShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        groundmountShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        keepoutsShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      }
      result?: {
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      } | null
    } | null
  } | null
}

export type ResultCashFlowQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  resultPid: Scalars["String"]["input"]
}>

export type ResultCashFlowQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      result?: {
        __typename?: "Result"
        result?:
          | { __typename: "PhysicalCheck" }
          | { __typename: "PolicyCheck" }
          | { __typename: "RevampCS" }
          | { __typename: "RevampFinmodel"; buildingOwnerXlsx?: string | null }
          | { __typename: "RevampFinmodelFailure" }
          | { __typename: "Viability" }
          | null
      } | null
    } | null
  } | null
}

export type RevampSiteDocumentsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type RevampSiteDocumentsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    name: string
    site?: {
      __typename?: "RevampSite"
      pid: string
      documents: Array<{
        __typename?: "Document"
        canDelete: boolean
        contentType: string
        dateCreated: string
        fileName: string
        ownerName: string
        pid: string
        tag?: DocumentTag | null
        downloadHref: string
      }>
    } | null
  } | null
}

export type RevampSiteBelowTheFoldQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type RevampSiteBelowTheFoldQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    name: string
    pid: string
    site?: {
      __typename?: "RevampSite"
      pid: string
      recommendedResult?: {
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      } | null
      policies: Array<{
        __typename?: "Policy"
        pid: string
        name: string
        publicName: string
        description: string
        publicDescription: string
        userVisible: boolean
        sources: Array<{
          __typename?: "Source"
          text?: string | null
          url?: string | null
        }>
        application: {
          __typename?: "PolicyApplication"
          status: PolicyApplicationStatus
        }
      }>
    } | null
  } | null
}

export type RevampSiteBillingMetersQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type RevampSiteBillingMetersQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    site?: {
      __typename?: "RevampSite"
      billingMeters: Array<{
        __typename?: "BillingMeter"
        id: number
        pid: string
        view: {
          __typename?: "BillingMeterView"
          name: string
          utilityMeterId?: string | null
          supplyUtilityMeterId?: string | null
          doeReferenceType: BuildingType
          loadCategory: LoadCategory
          isDisabled: boolean
          isArchived: boolean
          numBills: number
          numIntervals: number
          weeklyRollup?: Array<number> | null
          utility?: {
            __typename?: "UtilityRef"
            pid: string
            name: string
            shortName: string
          } | null
          tariff?: {
            __typename?: "Tariff"
            id: number
            pid: string
            name: string
            code: string
          } | null
          tenantDetails?: {
            __typename?: "TenantDetails"
            numUnitsTotal?: number | null
            numUnitsStudio?: number | null
            numUnits1Bd?: number | null
            numUnits2Bd?: number | null
            numUnits3Bd?: number | null
            numUnits4Bd?: number | null
          } | null
          totalAnnualKwh?: {
            __typename?: "FancyFloat"
            source: FancySource
            number: number
          } | null
          peakAnnualKw?: {
            __typename?: "FancyFloat"
            source: FancySource
            number: number
          } | null
          months: Array<{
            __typename?: "BillingMonthView"
            id?: number | null
            start: string
            end: string
            usageKwh: { __typename?: "FancyFloat"; source: FancySource; number: number }
            peakKw?: {
              __typename?: "FancyFloat"
              source: FancySource
              number: number
            } | null
            totalCostUsd?: {
              __typename?: "FancyFloat"
              source: FancySource
              number: number
            } | null
            supplyCostUsd?: {
              __typename?: "FancyFloat"
              source: FancySource
              number: number
            } | null
            transmissionCostUsd?: {
              __typename?: "FancyFloat"
              source: FancySource
              number: number
            } | null
            provider?: {
              __typename?: "Provider"
              id: number
              createdAt: string
              user?: {
                __typename?: "UserRef"
                pid: string
                email: string
                name?: string | null
                isAdmin: boolean
                avatarUrl?: string | null
              } | null
              document?: {
                __typename?: "Document"
                pid: string
                fileName: string
                contentType: string
                downloadHref: string
                viewHref: string
              } | null
              espmConsumption?: {
                __typename?: "ESPMConsumption"
                id: number
                createdAt: string
                lastUpdatedAt: string
                externalConsumptionId: string
                externalData: string
                start: string
                end: string
                usageKwh: number
                costUsd?: number | null
              } | null
            } | null
            supplyProvider?: {
              __typename?: "Provider"
              id: number
              createdAt: string
              user?: {
                __typename?: "UserRef"
                pid: string
                email: string
                name?: string | null
                isAdmin: boolean
                avatarUrl?: string | null
              } | null
              document?: {
                __typename?: "Document"
                pid: string
                fileName: string
                contentType: string
                downloadHref: string
                viewHref: string
              } | null
              espmConsumption?: {
                __typename?: "ESPMConsumption"
                id: number
                createdAt: string
                lastUpdatedAt: string
                externalConsumptionId: string
                externalData: string
                start: string
                end: string
                usageKwh: number
                costUsd?: number | null
              } | null
            } | null
          }>
          calc2:
            | { __typename: "E2Error"; msg: string }
            | {
                __typename: "Projected"
                year: number
                annualKwh: number
                peakKw: number
                annualCostUsd: number
                monthlyUsageKwh: Array<number>
                monthlyCostUsd: Array<number>
                costAndKwhDownloadHref: string
                kwh8760: {
                  __typename?: "Zoned8760"
                  timeZone: string
                  start: string
                  year: number
                }
                tariff: {
                  __typename?: "Tariff"
                  id: number
                  pid: string
                  name: string
                  code: string
                }
                monthlyBills: Array<{
                  __typename?: "MonthlyBill2"
                  start: string
                  end: string
                  sections: Array<{
                    __typename?: "BillGroup"
                    group: string
                    items: Array<{
                      __typename?: "GroupedLineItem"
                      cost: number
                      usage: number
                      name: string
                      rate: number
                      group?: string | null
                      unit?: ChargeUnit | null
                    }>
                  }>
                }>
              }
          intervals: Array<{
            __typename?: "BillingIntervalView"
            id: number
            start?: string | null
            end?: string | null
            timeZone: string
            units: Units
            numbers?: Array<number> | null
            timestamps?: Array<string> | null
            document: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            }
          }>
        }
      }>
    } | null
  } | null
}

export type RevampSiteGridEscalatorQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type RevampSiteGridEscalatorQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    site?: { __typename?: "RevampSite"; gridEscalator?: number | null } | null
  } | null
}

export type SiteMetersQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type SiteMetersQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    site?: {
      __typename?: "RevampSite"
      billingMeters: Array<{
        __typename?: "BillingMeter"
        pid: string
        bauMeterPid?: string | null
        view: {
          __typename?: "BillingMeterView"
          name: string
          isArchived: boolean
          calc2:
            | { __typename: "E2Error" }
            | { __typename: "Projected"; annualKwh: number }
        }
      }>
    } | null
  } | null
}

export type BillingMeterDocumentParseRequestsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type BillingMeterDocumentParseRequestsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    site?: {
      __typename?: "RevampSite"
      documentParseRequests: Array<{
        __typename?: "DocumentParseRequest"
        id: number
        createdAt: string
        status: ParseStatus
        errorClass?: string | null
        errorMessage?: string | null
        document: {
          __typename?: "Document"
          id: number
          pid: string
          fileName: string
          contentType: string
          downloadHref: string
          viewHref: string
          ownerName: string
          ownerEmail: string
          dateCreated: string
        }
        results: Array<{
          __typename?: "ParseResult"
          kind?: BillType | null
          parse: {
            __typename?: "DocumentBillingMonth"
            id: number
            start: string
            end: string
            totalKwh: number
            peakKw?: number | null
            totalCostUsd?: number | null
            supplyCostUsd?: number | null
            transmissionCostUsd?: number | null
            meterId: string
            tariffLabel?: string | null
            kind: BillType
          }
          target?: {
            __typename?: "BillingMeter"
            id: number
            pid: string
            label: string
            utilityMeterId?: string | null
          } | null
        }>
      }>
    } | null
  } | null
}

export type OrgDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type OrgDetailQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    slug: string
    name: string
    logomarkUrl?: string | null
  } | null
}

export type MultiMeterDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type MultiMeterDetailQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    site?: {
      __typename?: "RevampSite"
      meterSet?: {
        __typename?: "MeterSet"
        intervalsBauXlsxHref?: string | null
        loadKwh?: number | null
        loadMaxKw?: number | null
        loadOrigin?: LoadOrigin | null
        totalCost: number
        rollup: Array<{
          __typename?: "DailyRollup"
          season: string
          days: Array<string>
          numbers: Array<number>
        }>
        meters: Array<{
          __typename?: "BauMeter"
          id: number
          pid: string
          userVisibleLabel: string
          loadOrigin: LoadOrigin
          loadCategory: LoadCategory
          tariffUsdPerKwh: number
          totalCost: number
          importsKwh: number
          formattedBill: {
            __typename?: "FormattedBills"
            rate?: {
              __typename?: "TariffRate"
              tariffId?: number | null
              startDate: string
              endDate?: string | null
            } | null
            bills: Array<{
              __typename?: "FormattedBill"
              month: string
              kwhSupplyCharge: number
              kwhCharge: number
              charges: Array<{
                __typename?: "BillSection"
                name: string
                rates: Array<{
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }>
                costs: Array<
                  | {
                      __typename: "CostItem"
                      name: string
                      rateId: number
                      chargeType: ChargeType
                      chargeCategory?: ChargeCategory | null
                      volume: number
                      rate: number
                      cost: number
                      rateObj: {
                        __typename?: "DecodedRate"
                        id: number
                        name: string
                        chargeClass: ChargeClass
                      }
                    }
                  | {
                      __typename: "TaxItem"
                      taxId: number
                      subtotal: number
                      cost: number
                      percentage: number
                    }
                  | null
                >
              }>
              exports: Array<{
                __typename?: "BillSection"
                name: string
                rates: Array<{
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }>
                costs: Array<
                  | {
                      __typename: "CostItem"
                      name: string
                      rateId: number
                      chargeType: ChargeType
                      chargeCategory?: ChargeCategory | null
                      volume: number
                      rate: number
                      cost: number
                      rateObj: {
                        __typename?: "DecodedRate"
                        id: number
                        name: string
                        chargeClass: ChargeClass
                      }
                    }
                  | {
                      __typename: "TaxItem"
                      taxId: number
                      subtotal: number
                      cost: number
                      percentage: number
                    }
                  | null
                >
              }>
            }>
          }
          tariff: { __typename?: "Tariff"; id: number; name: string; code: string }
          rollup: Array<{
            __typename?: "DailyRollup"
            season: string
            days: Array<string>
            numbers: Array<number>
          }>
          intervals: {
            __typename?: "Zoned"
            maxKw: number
            year: number
            units: Units
            totalKwh: number
          }
        }>
      } | null
    } | null
  } | null
}

export type OrgBundlesQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type OrgBundlesQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    pid: string
    name: string
    logoUrl?: string | null
    bundles: Array<{
      __typename?: "Bundle2"
      pid: string
      name: string
      type: FinProductType
      note?: string | null
      pricingNote?: string | null
      state: BundleState
      archivedAt?: string | null
      lastViewed?: string | null
      biddingOpenAt?: string | null
      biddingClosedAt?: string | null
      hasVisibleReports: boolean
      totalBids: number
      rows: Array<{
        __typename?: "BundleRow2"
        id: number
        ppaType?: PpaProductType | null
        state?: BundleState | null
        reason?: CloseReason | null
        customReason?: string | null
        notes?: string | null
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          isFavorite: boolean
          isBehindTheMeter?: boolean | null
          isEnergyCommunity: boolean
          isLowIncomeCommunity?: boolean | null
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
          metering?: Metering | null
          assetManager?: string | null
          vnemAllowed: boolean
          doeReferenceType?: BuildingType | null
          usingBillingMeters?: string | null
          numParkingSpaces?: number | null
          yearBuilt?: number | null
          numStories?: number | null
          sqft?: number | null
          roofSqft?: number | null
          usableRoofSqft?: number | null
          usableCarportFt?: number | null
          impliedCarportLinearFt?: number | null
          impliedUsableRoofSqft?: number | null
          impliedUsableRoofSqftExplanation: RoofSqftExplanation
          groundAvailableSqft?: number | null
          hideBuildingFootprint: boolean
          keepoutsFootprintSqft?: number | null
          roofMaxPvKw: number
          carportMaxPvKw: number
          groundmountMaxPvKw?: number | null
          maxPvKwPolicyLimited: boolean
          isMultifamily: boolean
          occupancyType?: BuildingOccupancyType | null
          leaseType?: LeaseType | null
          tenantLeaseTerm?: string | null
          tenantLeaseEnds?: string | null
          tenantInterest?: YesNoUnsure | null
          mortgageLender?: string | null
          buildingClass?: string | null
          hasSubmittedEnergyData: boolean
          meterSet?: {
            __typename?: "MeterSet"
            totalCost: number
            loadKwh?: number | null
            loadOrigin?: LoadOrigin | null
          } | null
          billingMeters: Array<{
            __typename?: "BillingMeter"
            pid: string
            bauMeterPid?: string | null
            view: {
              __typename?: "BillingMeterView"
              name: string
              isArchived: boolean
              calc2:
                | { __typename: "E2Error" }
                | { __typename: "Projected"; annualKwh: number }
            }
          }>
          selectedConfig?: {
            __typename?: "SiteConfig"
            createdAt?: string | null
            createdBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            scenario: {
              __typename?: "RevampScenario"
              pid: string
              name: string
              loadCategory: LoadCategory
              solarLocation: SolarLocation
              includeStorage: boolean
            }
            financing: {
              __typename?: "RevampFinancing"
              id: number
              name: string
              type: FinProductType
              financierName: string
              financierPid: string
              financierLogo?: string | null
              financierLogomark?: string | null
              isThirdParty: boolean
            }
          } | null
          documents: Array<{
            __typename?: "Document"
            pid: string
            downloadHref: string
            fileName: string
            tag?: DocumentTag | null
          }>
          energyThings?: {
            __typename?: "EnergyThings"
            canRooftopSolar: boolean
            canCarportSolar?: boolean | null
            canGroundmountSolar?: boolean | null
            canStorage: boolean
          } | null
          financingThings?: {
            __typename?: "FinancingThings"
            canSelfInvest: boolean
            canLoan: boolean
            canPpa?: boolean | null
            canCommunitySolar?: boolean | null
          } | null
          physicalCheck: {
            __typename?: "PhysicalCheck"
            existingSolar?: boolean | null
            unobstructedFlatRoof?: boolean | null
            badRoof?: boolean | null
          }
          siteDetails: {
            __typename?: "SiteDetails"
            leaseApprovers: Array<string>
            externalLeaseApprovers?: Array<string> | null
            needsTenantApproval?: boolean | null
            roofRightsHolder?: RoofRightsHolder | null
            propertyLenders?: string | null
            propertyInsurer?: string | null
            constructionEmail?: string | null
            propertySiteVisitContacts?: Array<string> | null
            leasePropertyLegalDescription?: string | null
            leaseLegalOwnerName?: string | null
            signatureBlocks?: Array<string> | null
            isFannieMaeLender?: boolean | null
            isFmGlobalInsurer?: boolean | null
            roofReplacedYr?: number | null
            roofCondition?: string | null
            salePlans?: string | null
            buildingLegalName?: string | null
            propertyFundName?: string | null
            leaseSignatory?: string | null
            counselApproval?: CounselApproval | null
          }
          notes: Array<{ __typename?: "Note"; text: string }>
          buildingData?: {
            __typename?: "BuildingData"
            numStories?: number | null
            numUnits?: number | null
            yearBuilt?: number | null
            sqft?: number | null
            roofSqft?: number | null
            numParkingSpaces?: number | null
            occupancyRate?: number | null
            totalBuildings?: number | null
            yearRenovated?: number | null
            parentCompany?: string | null
            lastSalePrice?: number | null
            leedCertified?: string | null
            energyStar?: string | null
            buildingOpex?: string | null
            capRate?: number | null
          } | null
          footprint: {
            __typename?: "Footprint"
            latitude: number
            longitude: number
            bounds?: any | null
            obstructionShape?: any | null
            roofShape?: any | null
            roofShapeGeojson?: any | null
            roofShapeUpdatedAt?: string | null
            roofSetbackShape?: any | null
            roofSetbackShapeGeojson?: any | null
            roofSetbackShapeUpdatedAt?: string | null
            carportShape?: any | null
            carportShapeGeojson?: any | null
            carportShapeUpdatedAt?: string | null
            groundmountShape?: any | null
            groundmountShapeGeojson?: any | null
            groundmountShapeUpdatedAt?: string | null
            keepoutsShape?: any | null
            keepoutsShapeGeojson?: any | null
            keepoutsShapeUpdatedAt?: string | null
            roofShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            roofSetbackShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            carportShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            groundmountShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            keepoutsShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
          }
          thirdPartySupplier?: {
            __typename?: "ThirdPartySupplier"
            pid: string
            name: string
          } | null
          targetUtility?: {
            __typename?: "Utility"
            name: string
            pid: string
            id: number
            eiaGridEsc?: {
              __typename?: "EIAGridEsc"
              cagrBlended: number
              fromYear: number
              toYear: number
            } | null
            hostingCapacityMaps: Array<{
              __typename?: "HostingCapacityMap"
              url: string
              requiresLogin: boolean
              types: Array<HostingCapacityMapType>
            }>
          } | null
        }
        optOut?: {
          __typename: "InvestorOptOut"
          createdAt: string
          archivedAt?: string | null
          reason?: InvestorOptOutReason | null
          customReason?: string | null
          createdBy: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
        } | null
        bids: Array<{
          __typename?: "InvestorBid"
          ppa?: {
            __typename: "PPAInvestorBid"
            pid: string
            name?: string | null
            termYears: number
            ppaPriceY1Usd: number
            ppaPriceEscalator: number
            roofRentY1Usd?: number | null
            roofRentEscalator?: number | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            itcPercentageAssumption: number
            estimatedCod: string
            estimatedNtp: string
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            recOwner: RecOwner
            tariffProvision?: boolean | null
            otherNotes?: string | null
            extraPaymentsNotes?: string | null
            incentivesNotes?: string | null
            interconnectionNotes?: string | null
            interconnectionRepriceProcessNotes?: string | null
            status?: InvestorBidStatus | null
            spec?: { __typename?: "PPABidSpec"; pid: string } | null
            financier: {
              __typename?: "OrgRef"
              pid: string
              name: string
              logoUrl: string
              logomarkUrl?: string | null
              profile?: {
                __typename?: "InvestorProfile"
                hq?: string | null
                yearFounded?: number | null
                website?: string | null
                description?: string | null
                committedFunding?: string | null
                distinguishingFeatures?: string | null
                investorBacking?: string | null
                managementTeam: Array<string>
                longTermOwnershipApproach?: string | null
                subscriptionMgmtApproach?: string | null
                experiences: Array<{
                  __typename?: "Experience"
                  state?: UsState | null
                  ftmEnergizedPvKw?: number | null
                  ftmAwardedPvKw?: number | null
                  btmEnergizedPvKw?: number | null
                  btmAwardedPvKw?: number | null
                }>
                buyBoxes: Array<{
                  __typename?: "BuyBox"
                  state?: UsState | null
                  ftmMinPortfolioSize?: number | null
                  ftmMinProjectSize?: number | null
                  ftmSeekingProjects?: boolean | null
                  btmMinPortfolioSize?: number | null
                  btmMinProjectSize?: number | null
                  btmSeekingProjects?: boolean | null
                }>
              } | null
            }
            system: {
              __typename?: "System"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpec"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes?: string | null
                etbMeterName: string
                document?: {
                  __typename?: "Document"
                  id: number
                  pid: string
                  fileName: string
                  downloadHref: string
                } | null
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }
            result?: {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              meters: Array<{
                __typename?: "RevampMeter"
                name: string
                loadCategory: LoadCategory
                meterSource: MeterSource
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            } | null
          } | null
          cs?: {
            __typename: "CSInvestorBid"
            pid: string
            name?: string | null
            termYears: number
            roofRentEscalator: number
            roofRentY1Usd: number
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            itcPercentageAssumption: number
            estimatedAwardDate?: string | null
            estimatedCod: string
            estimatedNtp: string
            recOwner: RecOwner
            tariffProvision?: boolean | null
            incentivesNotes?: string | null
            interconnectionNotes?: string | null
            interconnectionRepriceProcessNotes?: string | null
            extraPaymentsNotes?: string | null
            otherNotes?: string | null
            status?: InvestorBidStatus | null
            spec?: { __typename?: "CSBidSpec"; pid: string } | null
            financier: {
              __typename?: "OrgRef"
              pid: string
              name: string
              logoUrl: string
              logomarkUrl?: string | null
              profile?: {
                __typename?: "InvestorProfile"
                hq?: string | null
                yearFounded?: number | null
                website?: string | null
                description?: string | null
                committedFunding?: string | null
                distinguishingFeatures?: string | null
                investorBacking?: string | null
                managementTeam: Array<string>
                longTermOwnershipApproach?: string | null
                subscriptionMgmtApproach?: string | null
                experiences: Array<{
                  __typename?: "Experience"
                  state?: UsState | null
                  ftmEnergizedPvKw?: number | null
                  ftmAwardedPvKw?: number | null
                  btmEnergizedPvKw?: number | null
                  btmAwardedPvKw?: number | null
                }>
                buyBoxes: Array<{
                  __typename?: "BuyBox"
                  state?: UsState | null
                  ftmMinPortfolioSize?: number | null
                  ftmMinProjectSize?: number | null
                  ftmSeekingProjects?: boolean | null
                  btmMinPortfolioSize?: number | null
                  btmMinProjectSize?: number | null
                  btmSeekingProjects?: boolean | null
                }>
              } | null
            }
            systemLite: {
              __typename?: "SystemLite"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpecLite"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes: string
              }>
            }
            result?: {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            } | null
          } | null
        }>
        specs: Array<{
          __typename?: "BidSpec"
          ppa?: {
            __typename: "PPABidSpec"
            id: number
            pid: string
            name?: string | null
            termYears?: number | null
            note?: string | null
            archivedAt?: string | null
            ppaPriceY1Usd?: number | null
            ppaPriceEscalator?: number | null
            roofRentY1Usd?: number | null
            roofRentEscalator?: number | null
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            itcPercentageAssumption?: number | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            recOwner?: RecOwner | null
            archivedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            system?: {
              __typename?: "System"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpec"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes?: string | null
                etbMeterName: string
                document?: {
                  __typename?: "Document"
                  id: number
                  pid: string
                  fileName: string
                  downloadHref: string
                } | null
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            } | null
          } | null
          cs?: {
            __typename: "CSBidSpec"
            id: number
            pid: string
            name?: string | null
            termYears?: number | null
            note?: string | null
            archivedAt?: string | null
            roofRentY1Usd?: number | null
            roofRentEscalator?: number | null
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            itcPercentageAssumption?: number | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            recOwner?: RecOwner | null
            archivedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            systemLite?: {
              __typename?: "SystemLite"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpecLite"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes: string
              }>
            } | null
          } | null
          optOut?: {
            __typename: "InvestorBidSpecOptOut"
            createdAt: string
            archivedAt?: string | null
            reason?: SpecOptOutReason | null
            customReason?: string | null
            createdBy: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            }
            archivedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
          } | null
        }>
      }>
      optOut?: {
        __typename: "InvestorOptOut"
        createdAt: string
        archivedAt?: string | null
        reason?: InvestorOptOutReason | null
        customReason?: string | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      } | null
      recvr: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
      financier: {
        __typename?: "BundleOrg"
        pid: string
        name: string
        orgSlug: string
      }
      bidSubmissionStatus: {
        __typename?: "BundleBidSubmissionSummary"
        bidStatus: BundleBidSubmissionStatus
        submittedBidCount?: number | null
        totalRequestedBids?: number | null
      }
      awardStatus?: {
        __typename?: "BundleAwardStatusSummary"
        awardStatus: BundleAwardStatus
        awardedBidCount?: number | null
        totalPossibleAwards?: number | null
      } | null
    }>
  } | null
}

export type SiteBidsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type SiteBidsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      bidPackages: Array<{
        __typename?: "BidPackage"
        pid: string
        name: string
        biddingOpenAt?: string | null
        biddingClosedAt?: string | null
        state: BundleState
        type: FinProductType
        totalRows: number
        row?: {
          __typename?: "BidPackageRow"
          status?: PackageRowStatus | null
          closedAt?: string | null
          closeReason?: PackageRowCloseReason | null
          closeCustomReason?: string | null
        } | null
        financiers: Array<{
          __typename?: "OrgRef"
          pid: string
          name: string
          orgSlug: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }>
      }>
      selectedConfigResult?: {
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      } | null
      biddingConfigResult?: {
        __typename?: "Result"
        id: number
        pid: string
        createdAt: string
        salesPdfReportHref?: string | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          solarLocation: SolarLocation
          loadCategory: LoadCategory
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
          status: FinProductStatus
        }
        result?:
          | {
              __typename: "PhysicalCheck"
              createdAt: string
              roofIsGood: boolean
              carportIsGood: boolean
              existingSolar?: boolean | null
              badRoof?: boolean | null
              groundmountIsGood: boolean
            }
          | {
              __typename: "PolicyCheck"
              createdAt: string
              productType?: FinProductType | null
              isGood: boolean
              disqualReason?: PolicyReason | null
            }
          | {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            }
          | {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              iterations: Array<{
                __typename?: "RevampIteration"
                cashPurchaseNpv: number
                pvKw: number
                marginalCo2Averted?: number | null
                storagePvKw?: number | null
                storagePvKwh?: number | null
              }>
              meters: Array<{
                __typename?: "RevampMeter"
                loadCategory: LoadCategory
                meterSource: MeterSource
                name: string
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              emissions?: {
                __typename?: "RevampEmissions"
                bauCo2Tons: number
                derCo2Tons: number
                bauAverageDayCo2Tons: Array<number>
                derAverageDayCo2Tons: Array<number>
              } | null
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            }
          | {
              __typename: "RevampFinmodelFailure"
              id: number
              createdAt: string
              fmvStr: string
              details: {
                __typename?: "FailureDetails"
                label: string
                description: string
              }
            }
          | {
              __typename: "Viability"
              isAllowed: boolean
              reason?: ViabilityReason | null
              level: ViabilityLevel
              viabilityType: ViabilityType
            }
          | null
        helioscope?: {
          __typename?: "Helioscope"
          pid: string
          roofPvKw: number
          carportPvKw: number
          groundPvKw: number
          systemProductivityKwhPerKw?: number | null
          roofImageHref: string
          pdfHref: string
          dcNameplateKw?: number | null
          acNameplateKw?: number | null
          loadRatio?: number | null
          moduleType?: string | null
          inverterType?: string | null
          rackingTiltDegrees?: number | null
          rackingManufacturer?: string | null
          rackingConnectionType?: ConnectionType | null
          notes?: string | null
          roofImage: {
            __typename?: "Attachment"
            id: number
            name: string
            downloadHref: string
          }
          pdf: {
            __typename?: "Attachment"
            downloadHref: string
            contentType: string
            name: string
            id: number
          }
        } | null
      } | null
    } | null
  } | null
}

export type FinancierBundleRowQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type FinancierBundleRowQuery = {
  __typename?: "Query"
  isAwardee: boolean
  bundleRowForFinancier?: {
    __typename?: "BundleRow"
    id: number
    helioscopes: Array<{
      __typename?: "Helioscope"
      pid: string
      roofPvKw: number
      carportPvKw: number
      groundPvKw: number
      systemProductivityKwhPerKw?: number | null
      roofImageHref: string
      pdfHref: string
      dcNameplateKw?: number | null
      acNameplateKw?: number | null
      loadRatio?: number | null
      moduleType?: string | null
      inverterType?: string | null
      rackingTiltDegrees?: number | null
      rackingManufacturer?: string | null
      rackingConnectionType?: ConnectionType | null
      notes?: string | null
      roofImage: {
        __typename?: "Attachment"
        id: number
        name: string
        downloadHref: string
      }
      pdf: {
        __typename?: "Attachment"
        downloadHref: string
        contentType: string
        name: string
        id: number
      }
    }>
    site: {
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      isFavorite: boolean
      isBehindTheMeter?: boolean | null
      isEnergyCommunity: boolean
      isLowIncomeCommunity?: boolean | null
      streetAddress: string
      city: string
      state: string
      zipCode: string
      county: string
      fullAddress: string
      metering?: Metering | null
      assetManager?: string | null
      vnemAllowed: boolean
      doeReferenceType?: BuildingType | null
      usingBillingMeters?: string | null
      numParkingSpaces?: number | null
      yearBuilt?: number | null
      numStories?: number | null
      sqft?: number | null
      roofSqft?: number | null
      usableRoofSqft?: number | null
      usableCarportFt?: number | null
      impliedCarportLinearFt?: number | null
      impliedUsableRoofSqft?: number | null
      impliedUsableRoofSqftExplanation: RoofSqftExplanation
      groundAvailableSqft?: number | null
      hideBuildingFootprint: boolean
      keepoutsFootprintSqft?: number | null
      roofMaxPvKw: number
      carportMaxPvKw: number
      groundmountMaxPvKw?: number | null
      maxPvKwPolicyLimited: boolean
      isMultifamily: boolean
      occupancyType?: BuildingOccupancyType | null
      leaseType?: LeaseType | null
      tenantLeaseTerm?: string | null
      tenantLeaseEnds?: string | null
      tenantInterest?: YesNoUnsure | null
      mortgageLender?: string | null
      buildingClass?: string | null
      hasSubmittedEnergyData: boolean
      billingMeters: Array<{
        __typename?: "BillingMeter"
        pid: string
        bauMeterPid?: string | null
        view: {
          __typename?: "BillingMeterView"
          name: string
          isArchived: boolean
          calc2:
            | { __typename: "E2Error" }
            | { __typename: "Projected"; annualKwh: number }
        }
      }>
      selectedConfig?: {
        __typename?: "SiteConfig"
        createdAt?: string | null
        createdBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          loadCategory: LoadCategory
          solarLocation: SolarLocation
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
        }
      } | null
      documents: Array<{
        __typename?: "Document"
        pid: string
        downloadHref: string
        fileName: string
        tag?: DocumentTag | null
      }>
      energyThings?: {
        __typename?: "EnergyThings"
        canRooftopSolar: boolean
        canCarportSolar?: boolean | null
        canGroundmountSolar?: boolean | null
        canStorage: boolean
      } | null
      financingThings?: {
        __typename?: "FinancingThings"
        canSelfInvest: boolean
        canLoan: boolean
        canPpa?: boolean | null
        canCommunitySolar?: boolean | null
      } | null
      physicalCheck: {
        __typename?: "PhysicalCheck"
        existingSolar?: boolean | null
        unobstructedFlatRoof?: boolean | null
        badRoof?: boolean | null
      }
      siteDetails: {
        __typename?: "SiteDetails"
        leaseApprovers: Array<string>
        externalLeaseApprovers?: Array<string> | null
        needsTenantApproval?: boolean | null
        roofRightsHolder?: RoofRightsHolder | null
        propertyLenders?: string | null
        propertyInsurer?: string | null
        constructionEmail?: string | null
        propertySiteVisitContacts?: Array<string> | null
        leasePropertyLegalDescription?: string | null
        leaseLegalOwnerName?: string | null
        signatureBlocks?: Array<string> | null
        isFannieMaeLender?: boolean | null
        isFmGlobalInsurer?: boolean | null
        roofReplacedYr?: number | null
        roofCondition?: string | null
        salePlans?: string | null
        buildingLegalName?: string | null
        propertyFundName?: string | null
        leaseSignatory?: string | null
        counselApproval?: CounselApproval | null
      }
      notes: Array<{ __typename?: "Note"; text: string }>
      buildingData?: {
        __typename?: "BuildingData"
        numStories?: number | null
        numUnits?: number | null
        yearBuilt?: number | null
        sqft?: number | null
        roofSqft?: number | null
        numParkingSpaces?: number | null
        occupancyRate?: number | null
        totalBuildings?: number | null
        yearRenovated?: number | null
        parentCompany?: string | null
        lastSalePrice?: number | null
        leedCertified?: string | null
        energyStar?: string | null
        buildingOpex?: string | null
        capRate?: number | null
      } | null
      footprint: {
        __typename?: "Footprint"
        latitude: number
        longitude: number
        bounds?: any | null
        obstructionShape?: any | null
        roofShape?: any | null
        roofShapeGeojson?: any | null
        roofShapeUpdatedAt?: string | null
        roofSetbackShape?: any | null
        roofSetbackShapeGeojson?: any | null
        roofSetbackShapeUpdatedAt?: string | null
        carportShape?: any | null
        carportShapeGeojson?: any | null
        carportShapeUpdatedAt?: string | null
        groundmountShape?: any | null
        groundmountShapeGeojson?: any | null
        groundmountShapeUpdatedAt?: string | null
        keepoutsShape?: any | null
        keepoutsShapeGeojson?: any | null
        keepoutsShapeUpdatedAt?: string | null
        roofShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        roofSetbackShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        carportShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        groundmountShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        keepoutsShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      }
      thirdPartySupplier?: {
        __typename?: "ThirdPartySupplier"
        pid: string
        name: string
      } | null
      meterSet?: { __typename?: "MeterSet"; loadOrigin?: LoadOrigin | null } | null
      targetUtility?: {
        __typename?: "Utility"
        name: string
        pid: string
        id: number
        eiaGridEsc?: {
          __typename?: "EIAGridEsc"
          cagrBlended: number
          fromYear: number
          toYear: number
        } | null
        hostingCapacityMaps: Array<{
          __typename?: "HostingCapacityMap"
          url: string
          requiresLogin: boolean
          types: Array<HostingCapacityMapType>
        }>
      } | null
    }
    result?: {
      __typename?: "Result"
      id: number
      pid: string
      createdAt: string
      salesPdfReportHref?: string | null
      result?:
        | {
            __typename: "PhysicalCheck"
            createdAt: string
            roofIsGood: boolean
            carportIsGood: boolean
            existingSolar?: boolean | null
            badRoof?: boolean | null
            groundmountIsGood: boolean
          }
        | {
            __typename: "PolicyCheck"
            createdAt: string
            productType?: FinProductType | null
            isGood: boolean
            disqualReason?: PolicyReason | null
          }
        | {
            __typename: "RevampCS"
            id: number
            termYears: number
            createdAt: string
            goal?: PVoptGoal | null
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            financing: {
              __typename?: "RevampFinancing"
              id: number
              name: string
              type: FinProductType
              financierName: string
              financierPid: string
              financierLogo?: string | null
              financierLogomark?: string | null
              isThirdParty: boolean
            }
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              npv: number
              discountRate: number
              roofRentPerYear: Array<number>
            } | null
            pricing: {
              __typename?: "CSPrice"
              usdPerKwPerYear: number
              escalator: number
              minPvKw: number
              maxPvKw: number
              utility: { __typename?: "RevampUtility"; id: number; name: string }
            }
            leaseProjections?: {
              __typename?: "CSLeaseProjections"
              systemSizeKw: number
              annualRentLowerRangeUsd: number
              annualRentUpperRangeUsd: number
              methodology: CsLeaseProjectionMethdology
            } | null
          }
        | {
            __typename: "RevampFinmodel"
            commOpDate: string
            id: number
            pid: string
            createdAt: string
            type: FinProductType
            intervalsAndCostsXlsxHref: string
            buildingOwnerXlsxHref?: string | null
            offerStatus: OfferStatus
            fmvStr: string
            totalPvProductionKwh: number
            totalPvExportKwh?: number | null
            bauCostPerYear: Array<number>
            derCostPerYear: Array<number>
            goal?: PVoptGoal | null
            isVnem: boolean
            isGreenLease: boolean
            investorDetails?: {
              __typename?: "InvestorDetails"
              capex?: number | null
              investorXlsxHref: string
              irrs: { __typename?: "IRRs"; postTaxItcDepr?: number | null }
            } | null
            itcAssumptions: {
              __typename?: "RevampItcAssumptions"
              rate: number
              inLowIncomeCommunity: boolean
              inEnergyCommunity: boolean
              domesticMaterialsAdder: boolean
            }
            iterations: Array<{
              __typename?: "RevampIteration"
              cashPurchaseNpv: number
              pvKw: number
              marginalCo2Averted?: number | null
              storagePvKw?: number | null
              storagePvKwh?: number | null
            }>
            meters: Array<{
              __typename?: "RevampMeter"
              loadCategory: LoadCategory
              meterSource: MeterSource
              name: string
              bau: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
              }
              der?: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
                averageDayKwhFlow: Array<{
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }>
              } | null
            }>
            emissions?: {
              __typename?: "RevampEmissions"
              bauCo2Tons: number
              derCo2Tons: number
              bauAverageDayCo2Tons: Array<number>
              derAverageDayCo2Tons: Array<number>
            } | null
            thirdPartySupplier?: {
              __typename?: "ThirdPartySupplier"
              pid: string
              name: string
            } | null
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            ppa?: {
              __typename: "PPAEconomics"
              ppaType: PpaProductType
              ppaCostPerKwh: number
              ppaTermYears: number
              ppaEsc?: number | null
              srecToInvestor: boolean
              offtakerXlsxHref: string
              product: {
                __typename?: "PPAFinProduct"
                productName: string
                financierName: string
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                roofRentPerYear: Array<number>
              } | null
              tenantFlows?: {
                __typename?: "TenantCashflows"
                npv: number
                discountRate: number
                totalUtilitySavings: number
                totalCapex: number
                totalOpex: number
                totalNet: number
                netCashflowPerYear: Array<number>
              } | null
            } | null
            loan?: {
              __typename: "LoanEconomics"
              loanRecvrXlsxHref: string
              loanTermYears: number
              ownershipTermYears: number
              interestPct: number
              srecToInvestor: boolean
              product: {
                __typename?: "LoanFinProduct"
                productName: string
                financierName: string
                loanDealerFeePct: number
              }
              flows?: {
                __typename?: "LoanRecvrCashflows"
                monthlyPayment: number
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalLoanFunding: number
                totalLoanPayments: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            selfInvest?: {
              __typename: "SelfInvestEconomics"
              npv: number
              discountRate: number
              selfInvestXlsxHref: string
              termYears: number
              srecToInvestor: boolean
              irrs: {
                __typename?: "IRRs"
                postTaxItcDepr?: number | null
                postTaxItcDeprMultiple?: number | null
              }
              product: {
                __typename?: "SelfInvestFinProduct"
                productName: string
                financierName: string
              }
              flows?: {
                __typename?: "SelfInvestCashflows"
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            utilityCosts: {
              __typename?: "UtilityCost"
              bau: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
              der: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
            }
          }
        | {
            __typename: "RevampFinmodelFailure"
            id: number
            createdAt: string
            fmvStr: string
            details: {
              __typename?: "FailureDetails"
              label: string
              description: string
            }
          }
        | {
            __typename: "Viability"
            isAllowed: boolean
            reason?: ViabilityReason | null
            level: ViabilityLevel
            viabilityType: ViabilityType
          }
        | null
      scenario: {
        __typename?: "RevampScenario"
        pid: string
        name: string
        solarLocation: SolarLocation
        loadCategory: LoadCategory
        includeStorage: boolean
      }
      financing: {
        __typename?: "RevampFinancing"
        id: number
        name: string
        type: FinProductType
        financierName: string
        financierPid: string
        financierLogo?: string | null
        financierLogomark?: string | null
        isThirdParty: boolean
        status: FinProductStatus
      }
      helioscope?: {
        __typename?: "Helioscope"
        pid: string
        roofPvKw: number
        carportPvKw: number
        groundPvKw: number
        systemProductivityKwhPerKw?: number | null
        roofImageHref: string
        pdfHref: string
        dcNameplateKw?: number | null
        acNameplateKw?: number | null
        loadRatio?: number | null
        moduleType?: string | null
        inverterType?: string | null
        rackingTiltDegrees?: number | null
        rackingManufacturer?: string | null
        rackingConnectionType?: ConnectionType | null
        notes?: string | null
        roofImage: {
          __typename?: "Attachment"
          id: number
          name: string
          downloadHref: string
        }
        pdf: {
          __typename?: "Attachment"
          downloadHref: string
          contentType: string
          name: string
          id: number
        }
      } | null
    } | null
  } | null
}

export type FinancierMultiMeterDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type FinancierMultiMeterDetailQuery = {
  __typename?: "Query"
  bundleRowForFinancier?: {
    __typename?: "BundleRow"
    site: {
      __typename?: "RevampSite"
      meterSet?: {
        __typename?: "MeterSet"
        intervalsBauXlsxHref?: string | null
        loadKwh?: number | null
        loadMaxKw?: number | null
        loadOrigin?: LoadOrigin | null
        totalCost: number
        rollup: Array<{
          __typename?: "DailyRollup"
          season: string
          days: Array<string>
          numbers: Array<number>
        }>
        meters: Array<{
          __typename?: "BauMeter"
          id: number
          pid: string
          userVisibleLabel: string
          loadOrigin: LoadOrigin
          loadCategory: LoadCategory
          tariffUsdPerKwh: number
          totalCost: number
          importsKwh: number
          formattedBill: {
            __typename?: "FormattedBills"
            rate?: {
              __typename?: "TariffRate"
              tariffId?: number | null
              startDate: string
              endDate?: string | null
            } | null
            bills: Array<{
              __typename?: "FormattedBill"
              month: string
              kwhSupplyCharge: number
              kwhCharge: number
              charges: Array<{
                __typename?: "BillSection"
                name: string
                rates: Array<{
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }>
                costs: Array<
                  | {
                      __typename: "CostItem"
                      name: string
                      rateId: number
                      chargeType: ChargeType
                      chargeCategory?: ChargeCategory | null
                      volume: number
                      rate: number
                      cost: number
                      rateObj: {
                        __typename?: "DecodedRate"
                        id: number
                        name: string
                        chargeClass: ChargeClass
                      }
                    }
                  | {
                      __typename: "TaxItem"
                      taxId: number
                      subtotal: number
                      cost: number
                      percentage: number
                    }
                  | null
                >
              }>
              exports: Array<{
                __typename?: "BillSection"
                name: string
                rates: Array<{
                  __typename?: "DecodedRate"
                  id: number
                  name: string
                  chargeClass: ChargeClass
                }>
                costs: Array<
                  | {
                      __typename: "CostItem"
                      name: string
                      rateId: number
                      chargeType: ChargeType
                      chargeCategory?: ChargeCategory | null
                      volume: number
                      rate: number
                      cost: number
                      rateObj: {
                        __typename?: "DecodedRate"
                        id: number
                        name: string
                        chargeClass: ChargeClass
                      }
                    }
                  | {
                      __typename: "TaxItem"
                      taxId: number
                      subtotal: number
                      cost: number
                      percentage: number
                    }
                  | null
                >
              }>
            }>
          }
          tariff: { __typename?: "Tariff"; id: number; name: string; code: string }
          rollup: Array<{
            __typename?: "DailyRollup"
            season: string
            days: Array<string>
            numbers: Array<number>
          }>
          intervals: {
            __typename?: "Zoned"
            maxKw: number
            year: number
            units: Units
            totalKwh: number
          }
        }>
      } | null
    }
  } | null
}

export type FinancierBundleRowDocumentsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type FinancierBundleRowDocumentsQuery = {
  __typename?: "Query"
  bundleRowForFinancier?: {
    __typename?: "BundleRow"
    site: {
      __typename?: "RevampSite"
      pid: string
      documents: Array<{
        __typename?: "Document"
        id: number
        pid: string
        contentType: string
        dateCreated: string
        fileName: string
        ownerName: string
        ownerEmail: string
        downloadHref: string
        viewHref: string
        tag?: DocumentTag | null
      }>
    }
  } | null
}

export type SidebarDataQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type SidebarDataQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    isDeveloper: boolean
    sites: {
      __typename?: "OrgSiteTable"
      view: { __typename?: "OrgSiteTableView"; count: number }
    }
    shine: {
      __typename?: "ShineOrg"
      stats?: { __typename?: "ShineStats"; numProperties: number } | null
    }
  } | null
}

export type ThirdPartySuppliersQueryVariables = Exact<{ [key: string]: never }>

export type ThirdPartySuppliersQuery = {
  __typename?: "Query"
  thirdPartySuppliers: Array<{
    __typename?: "ThirdPartySupplier"
    id: number
    pid: string
    name: string
  }>
}

export type ShineSiteDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  propertyPid: Scalars["String"]["input"]
}>

export type ShineSiteDetailQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    site?: {
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      fullAddress: string
      footprint: {
        __typename?: "Footprint"
        latitude: number
        longitude: number
        bounds?: any | null
        obstructionShape?: any | null
        roofShape?: any | null
        roofShapeGeojson?: any | null
        roofShapeUpdatedAt?: string | null
        roofSetbackShape?: any | null
        roofSetbackShapeGeojson?: any | null
        roofSetbackShapeUpdatedAt?: string | null
        carportShape?: any | null
        carportShapeGeojson?: any | null
        carportShapeUpdatedAt?: string | null
        groundmountShape?: any | null
        groundmountShapeGeojson?: any | null
        groundmountShapeUpdatedAt?: string | null
        keepoutsShape?: any | null
        keepoutsShapeGeojson?: any | null
        keepoutsShapeUpdatedAt?: string | null
        roofShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        roofSetbackShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        carportShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        groundmountShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        keepoutsShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      }
      shine: {
        __typename?: "ShineSite"
        status: ShineStatus
        stats?: {
          __typename?: "ShineStats"
          numProperties: number
          pvKwInstalled: number
          totalCo2ReducedTonnes: number
          totalGrossRevenue: number
          totalPvProductionKwh: number
        } | null
      }
    } | null
  } | null
}

export type OrgShineQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  duration: ShineDuration
}>

export type OrgShineQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    name: string
    slug: string
    shine: {
      __typename?: "ShineOrg"
      status: ShineStatus
      stats?: {
        __typename?: "ShineStats"
        numProperties: number
        pvKwInstalled: number
        totalCo2ReducedTonnes: number
        totalGrossRevenue: number
        totalPvProductionKwh: number
      } | null
      units: Array<{
        __typename?: "ShineUnit"
        duration: ShineDuration
        start: string
        actualPvProductionKwh: number
        expectedPvProductionKwh: number
        actualGrossRevenue: number
        expectedGrossRevenue: number
        co2EmissionsReductionTonnes: number
      }>
      siteRefs: Array<{
        __typename?: "ShineSiteRef"
        pid: string
        lat: number
        lon: number
        monthlyGrossRevenue: number
        status: ShineStatus
      }>
    }
  } | null
}

export type ShineSiteDetailUnitsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  propertyPid: Scalars["String"]["input"]
  duration: ShineDuration
}>

export type ShineSiteDetailUnitsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    site?: {
      __typename?: "RevampSite"
      pid: string
      shine: {
        __typename?: "ShineSite"
        units: Array<{
          __typename?: "ShineUnit"
          duration: ShineDuration
          start: string
          actualPvProductionKwh: number
          expectedPvProductionKwh: number
          actualGrossRevenue: number
          expectedGrossRevenue: number
          co2EmissionsReductionTonnes: number
        }>
      }
    } | null
  } | null
}

export type SiteSolarPanelVisualQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  propertyPid: Scalars["String"]["input"]
}>

export type SiteSolarPanelVisualQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      visuals: {
        __typename?: "SiteVisuals"
        solarPanels: Array<{
          __typename?: "MapSolarPanel"
          latitude: number
          longitude: number
          angle: number
        }>
      }
    } | null
  } | null
}

export type CsvImportsListQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type CsvImportsListQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    csvImports: {
      __typename?: "CsvImportQuery"
      all: Array<{
        __typename?: "CsvImport"
        pid: string
        fileName?: string | null
        createdAt: string
        createdBy: { __typename?: "UserRef"; email: string }
        portfolio: { __typename?: "PortfolioRef"; pid: string; title: string }
        rowStats: { __typename?: "CsvImportStats"; total: number; imported: number }
      }>
    }
  } | null
}

export type SiteEvQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type SiteEvQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    site?: {
      __typename?: "RevampSite"
      fullAddress: string
      yearBuilt?: number | null
      numParkingSpaces?: number | null
      buildingClass?: string | null
      numUnitsTotal?: number | null
      evCalc?: {
        __typename?: "EVCalc"
        id: number
        createdAt: string
        numChargers: number
        optimalNumChargers: number
        npv: number
        markupUsdPerKwh: number
        timeZone: string
        dayRates: Array<number>
        downloadHourlyRatesHref: string
        xlsx?: string | null
        downloadXlsxHref: string
        yr3Revenue?: number | null
        yr3Cashflow?: number | null
        yr3NumEvs?: number | null
        parkingRatio?: number | null
        projectInputs: {
          __typename?: "EVProjectInputs"
          projectStartDate: string
          installType: ChargerInstallType
          termYears: number
          chargerKw: number
          yr0NumTenantEvs?: number | null
          discountRate: number
        }
        outputs: {
          __typename?: "EVOutputs"
          irr?: number | null
          npv: number
          yr0NumTenantEvs: number
          breakevenYear: number
          numChargersDemandedSeries: Array<number>
          cashflowSeries: Array<number>
          revenueSeries: Array<number>
          incentiveUsd: number
        }
        tariffRate: {
          __typename?: "TariffRate"
          parent: { __typename?: "Tariff"; name: string; code: string }
        }
        utility: { __typename?: "UtilityRef"; shortName: string }
        seasonalDayRates: Array<{
          __typename?: "SeasonalDayRate"
          name: string
          startMonth: number
          endMonth: number
          dayRates: Array<number>
        }>
        optIters: Array<{ __typename?: "EVOptIter"; numChargers: number; npv: number }>
        year3Expenses: Array<{
          __typename?: "EVLineItem"
          label: string
          value: number
        }>
        installCosts: Array<{ __typename?: "EVLineItem"; label: string; value: number }>
      } | null
    } | null
  } | null
}

export type SiteEvIncentivesQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type SiteEvIncentivesQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      evCalc?: {
        __typename?: "EVCalc"
        incentives: Array<{
          __typename?: "EVIncentive"
          programName: string
          state?: string | null
          url: string
          eligibleAreas: string
          incentiveAmount: string
          programConstraints: string
          incentiveCap: string
          calculation: string
        }>
      } | null
    } | null
  } | null
}

export type SiteRecalculatingQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type SiteRecalculatingQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: { __typename?: "RevampSite"; isRecalculating: boolean } | null
  } | null
}

export type ScenarioListQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type ScenarioListQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      fullAddress: string
      scenarios: Array<{
        __typename?: "RevampScenario"
        name: string
        pid: string
        solarLocation: SolarLocation
        loadCategory: LoadCategory
        includeStorage: boolean
      }>
    } | null
  } | null
}

export type SiteFromPortfolioBuildingDataQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  portfolioPid: Scalars["String"]["input"]
  buildingDataId: Scalars["Int"]["input"]
}>

export type SiteFromPortfolioBuildingDataQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    siteFromPortfolioBuildingData?: { __typename: "SiteRef"; pid: string } | null
  } | null
}

export type UtilityTariffsQueryVariables = Exact<{
  utilityPid: Scalars["String"]["input"]
}>

export type UtilityTariffsQuery = {
  __typename?: "Query"
  tariffs2: Array<{
    __typename?: "PublicTariff"
    id: number
    pid: string
    name: string
    code: string
    tariffType?: string | null
    isPreferred?: boolean | null
    isNem2: boolean
    isClosed: boolean
    isPrimaryConnection: boolean
    customTariffId?: number | null
    notes?: string | null
    updatedAt?: string | null
    trashedAt?: string | null
    requiresPv?: boolean | null
    requiresStorage?: boolean | null
    hasTouRates: boolean
    hasNetMetering: boolean
    customerLikelihood: number
    customerCount?: number | null
    customerClass: string
    minMonthlyKw?: number | null
    maxMonthlyKw?: number | null
    minMonthlyKwh?: number | null
    maxMonthlyKwh?: number | null
    latestRateId?: number | null
  }>
}

export type CustomTariffsQueryVariables = Exact<{
  sitePid: Scalars["String"]["input"]
  utilityPid: Scalars["String"]["input"]
}>

export type CustomTariffsQuery = {
  __typename?: "Query"
  customTariffs: Array<{
    __typename?: "PublicTariff"
    id: number
    pid: string
    name: string
    code: string
    tariffType?: string | null
    isPreferred?: boolean | null
    isNem2: boolean
    isClosed: boolean
    isPrimaryConnection: boolean
    customTariffId?: number | null
    notes?: string | null
    updatedAt?: string | null
    trashedAt?: string | null
    requiresPv?: boolean | null
    requiresStorage?: boolean | null
    hasTouRates: boolean
    hasNetMetering: boolean
    customerLikelihood: number
    customerCount?: number | null
    customerClass: string
    minMonthlyKw?: number | null
    maxMonthlyKw?: number | null
    minMonthlyKwh?: number | null
    maxMonthlyKwh?: number | null
    latestRateId?: number | null
  }>
}

export type CustomTariffs2QueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type CustomTariffs2Query = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      customTariffs: Array<{
        __typename?: "CustomTariff"
        name: string
        preOpDetails?: {
          __typename?: "TariffDetails"
          rates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
        } | null
        postOpDetails: {
          __typename?: "TariffDetails"
          rates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
        }
      }>
    } | null
  } | null
}

export type CustomTariffDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  propertyPid: Scalars["String"]["input"]
  tariffId: Scalars["Int"]["input"]
}>

export type CustomTariffDetailQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      customTariff?: {
        __typename?: "CustomTariff"
        id: number
        name: string
        code: string
        customerClass: string
        ops?: Array<
          | {
              __typename: "AddRate"
              op: OpType
              rate: {
                __typename?: "CustomRate"
                name?: string | null
                chargeClass: ChargeClass
                chargeType: ChargeType
                transactionType?: TransactionType | null
                price: number
                rateUnit: RateUnit
                chargePeriod: ChargePeriod
              }
            }
          | {
              __typename: "OverrideProperty"
              keyName: string
              propertyValue: string
              op: OpType
            }
          | {
              __typename: "SubRate"
              chargeClass?: ChargeClass | null
              rateId?: number | null
              op: OpType
            }
        > | null
        preOpDetails?: {
          __typename?: "TariffDetails"
          allRates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
          rates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
        } | null
        postOpDetails: {
          __typename?: "TariffDetails"
          allRates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
          rates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
        }
      } | null
    } | null
  } | null
}

export type CustomTariffPreviewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  propertyPid: Scalars["String"]["input"]
  tariffId: Scalars["Int"]["input"]
  addRateOps: Array<AddRateInput> | AddRateInput
  subRateOps: Array<SubRateInput> | SubRateInput
  propertyOps: Array<OverridePropertyInput> | OverridePropertyInput
}>

export type CustomTariffPreviewQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      customTariff?: {
        __typename?: "CustomTariff"
        id: number
        name: string
        previewDetails?: {
          __typename?: "TariffDetails"
          allRates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
          rates: Array<{
            __typename?: "Rate"
            name: string
            groupName?: string | null
            tariffRateId: number
            chargeClass: string
            chargeType?: ChargeType | null
            transactionType: TransactionType
            chargePeriod: ChargePeriod
            applicabilityKey?: string | null
            applicabilityValues?: Array<string> | null
            quantityKey?: string | null
            applicableBands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            bands: Array<{
              __typename?: "RateBand"
              tariffRateBandId: number
              rateUnit: RateUnit
              price: number
              isCredit: boolean
              applicabilityValue?: string | null
            }>
            tou?: {
              __typename?: "TimeOfUse"
              touName: string
              touType?: string | null
              touPeriods: Array<{
                __typename?: "Period"
                fromHour?: number | null
                fromMinute?: number | null
                fromDayOfWeek: number
                toHour?: number | null
                toMinute?: number | null
                toDayOfWeek: number
              }>
              season?: {
                __typename?: "Season"
                seasonFromDay: number
                seasonFromMonth: number
                seasonToDay: number
                seasonToMonth: number
              } | null
            } | null
            season?: {
              __typename?: "Season"
              seasonFromDay: number
              seasonFromMonth: number
              seasonToDay: number
              seasonToMonth: number
            } | null
          }>
          properties: Array<{
            __typename?: "TariffProperty"
            keyName: string
            dataType: string
            propertyValue?: string | null
            propertyValues: Array<string>
            formulaDetail?: string | null
          }>
        } | null
      } | null
    } | null
  } | null
}

export type CustomTariffBillCalcQueryVariables = Exact<{
  propertyPid: Scalars["String"]["input"]
  customTariffId: Scalars["Int"]["input"]
  bauMeterPid: Scalars["String"]["input"]
  addRateOps: Array<AddRateInput> | AddRateInput
  subRateOps: Array<SubRateInput> | SubRateInput
  propertyOps: Array<OverridePropertyInput> | OverridePropertyInput
}>

export type CustomTariffBillCalcQuery = {
  __typename?: "Query"
  customTariff: {
    __typename?: "CustomTariff"
    billCalc: Array<{
      __typename?: "OpsBillCalc"
      start: string
      end: string
      summary: Array<{
        __typename?: "ChargeTypeCost"
        chargeType?: ChargeType | null
        costUsd: number
      }>
      details: Array<{
        __typename?: "BillGroup"
        group: string
        items: Array<{
          __typename?: "GroupedLineItem"
          cost: number
          usage: number
          name: string
          rate: number
          unit?: ChargeUnit | null
        }>
      }>
    }>
  }
}

export type BundleParentsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type BundleParentsQuery = {
  __typename?: "Query"
  bundleParents: Array<{
    __typename?: "BundleParent"
    id: number
    createdAt: string
    pid: string
    name: string
    type: FinProductType
    note?: string | null
    pricingNote?: string | null
    state: BundleState
    biddingOpenAt?: string | null
    biddingClosedAt?: string | null
    canAddNewBids: boolean
    canEditBids: boolean
    hiddenFromRecvr?: string | null
    hiddenFromFinancier?: string | null
    showAllBidsReport: boolean
    opsOwner?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    recvr: { __typename?: "Org"; pid: string; name: string }
  }>
}

export type BundleParentDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  pid: Scalars["String"]["input"]
}>

export type BundleParentDetailQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    id: number
    createdAt: string
    pid: string
    name: string
    type: FinProductType
    note?: string | null
    pricingNote?: string | null
    state: BundleState
    biddingOpenAt?: string | null
    biddingClosedAt?: string | null
    canAddNewBids: boolean
    canEditBids: boolean
    hiddenFromRecvr?: string | null
    hiddenFromFinancier?: string | null
    showAllBidsReport: boolean
    bundles: Array<{
      __typename?: "Bundle2"
      name: string
      pid: string
      type: FinProductType
      note?: string | null
      pricingNote?: string | null
      state: BundleState
      archivedAt?: string | null
      lastViewed?: string | null
      biddingOpenAt?: string | null
      biddingClosedAt?: string | null
      hasVisibleReports: boolean
      totalBids: number
      rows: Array<{
        __typename?: "BundleRow2"
        id: number
        ppaType?: PpaProductType | null
        state?: BundleState | null
        reason?: CloseReason | null
        customReason?: string | null
        notes?: string | null
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          isFavorite: boolean
          isBehindTheMeter?: boolean | null
          isEnergyCommunity: boolean
          isLowIncomeCommunity?: boolean | null
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
          metering?: Metering | null
          assetManager?: string | null
          vnemAllowed: boolean
          doeReferenceType?: BuildingType | null
          usingBillingMeters?: string | null
          numParkingSpaces?: number | null
          yearBuilt?: number | null
          numStories?: number | null
          sqft?: number | null
          roofSqft?: number | null
          usableRoofSqft?: number | null
          usableCarportFt?: number | null
          impliedCarportLinearFt?: number | null
          impliedUsableRoofSqft?: number | null
          impliedUsableRoofSqftExplanation: RoofSqftExplanation
          groundAvailableSqft?: number | null
          hideBuildingFootprint: boolean
          keepoutsFootprintSqft?: number | null
          roofMaxPvKw: number
          carportMaxPvKw: number
          groundmountMaxPvKw?: number | null
          maxPvKwPolicyLimited: boolean
          isMultifamily: boolean
          occupancyType?: BuildingOccupancyType | null
          leaseType?: LeaseType | null
          tenantLeaseTerm?: string | null
          tenantLeaseEnds?: string | null
          tenantInterest?: YesNoUnsure | null
          mortgageLender?: string | null
          buildingClass?: string | null
          hasSubmittedEnergyData: boolean
          meterSet?: {
            __typename?: "MeterSet"
            totalCost: number
            loadKwh?: number | null
            loadOrigin?: LoadOrigin | null
          } | null
          billingMeters: Array<{
            __typename?: "BillingMeter"
            pid: string
            bauMeterPid?: string | null
            view: {
              __typename?: "BillingMeterView"
              name: string
              isArchived: boolean
              calc2:
                | { __typename: "E2Error" }
                | { __typename: "Projected"; annualKwh: number }
            }
          }>
          selectedConfig?: {
            __typename?: "SiteConfig"
            createdAt?: string | null
            createdBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            scenario: {
              __typename?: "RevampScenario"
              pid: string
              name: string
              loadCategory: LoadCategory
              solarLocation: SolarLocation
              includeStorage: boolean
            }
            financing: {
              __typename?: "RevampFinancing"
              id: number
              name: string
              type: FinProductType
              financierName: string
              financierPid: string
              financierLogo?: string | null
              financierLogomark?: string | null
              isThirdParty: boolean
            }
          } | null
          documents: Array<{
            __typename?: "Document"
            pid: string
            downloadHref: string
            fileName: string
            tag?: DocumentTag | null
          }>
          energyThings?: {
            __typename?: "EnergyThings"
            canRooftopSolar: boolean
            canCarportSolar?: boolean | null
            canGroundmountSolar?: boolean | null
            canStorage: boolean
          } | null
          financingThings?: {
            __typename?: "FinancingThings"
            canSelfInvest: boolean
            canLoan: boolean
            canPpa?: boolean | null
            canCommunitySolar?: boolean | null
          } | null
          physicalCheck: {
            __typename?: "PhysicalCheck"
            existingSolar?: boolean | null
            unobstructedFlatRoof?: boolean | null
            badRoof?: boolean | null
          }
          siteDetails: {
            __typename?: "SiteDetails"
            leaseApprovers: Array<string>
            externalLeaseApprovers?: Array<string> | null
            needsTenantApproval?: boolean | null
            roofRightsHolder?: RoofRightsHolder | null
            propertyLenders?: string | null
            propertyInsurer?: string | null
            constructionEmail?: string | null
            propertySiteVisitContacts?: Array<string> | null
            leasePropertyLegalDescription?: string | null
            leaseLegalOwnerName?: string | null
            signatureBlocks?: Array<string> | null
            isFannieMaeLender?: boolean | null
            isFmGlobalInsurer?: boolean | null
            roofReplacedYr?: number | null
            roofCondition?: string | null
            salePlans?: string | null
            buildingLegalName?: string | null
            propertyFundName?: string | null
            leaseSignatory?: string | null
            counselApproval?: CounselApproval | null
          }
          notes: Array<{ __typename?: "Note"; text: string }>
          buildingData?: {
            __typename?: "BuildingData"
            numStories?: number | null
            numUnits?: number | null
            yearBuilt?: number | null
            sqft?: number | null
            roofSqft?: number | null
            numParkingSpaces?: number | null
            occupancyRate?: number | null
            totalBuildings?: number | null
            yearRenovated?: number | null
            parentCompany?: string | null
            lastSalePrice?: number | null
            leedCertified?: string | null
            energyStar?: string | null
            buildingOpex?: string | null
            capRate?: number | null
          } | null
          footprint: {
            __typename?: "Footprint"
            latitude: number
            longitude: number
            bounds?: any | null
            obstructionShape?: any | null
            roofShape?: any | null
            roofShapeGeojson?: any | null
            roofShapeUpdatedAt?: string | null
            roofSetbackShape?: any | null
            roofSetbackShapeGeojson?: any | null
            roofSetbackShapeUpdatedAt?: string | null
            carportShape?: any | null
            carportShapeGeojson?: any | null
            carportShapeUpdatedAt?: string | null
            groundmountShape?: any | null
            groundmountShapeGeojson?: any | null
            groundmountShapeUpdatedAt?: string | null
            keepoutsShape?: any | null
            keepoutsShapeGeojson?: any | null
            keepoutsShapeUpdatedAt?: string | null
            roofShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            roofSetbackShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            carportShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            groundmountShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            keepoutsShapeUpdatedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
          }
          thirdPartySupplier?: {
            __typename?: "ThirdPartySupplier"
            pid: string
            name: string
          } | null
          targetUtility?: {
            __typename?: "Utility"
            name: string
            pid: string
            id: number
            eiaGridEsc?: {
              __typename?: "EIAGridEsc"
              cagrBlended: number
              fromYear: number
              toYear: number
            } | null
            hostingCapacityMaps: Array<{
              __typename?: "HostingCapacityMap"
              url: string
              requiresLogin: boolean
              types: Array<HostingCapacityMapType>
            }>
          } | null
        }
        optOut?: {
          __typename: "InvestorOptOut"
          createdAt: string
          archivedAt?: string | null
          reason?: InvestorOptOutReason | null
          customReason?: string | null
          createdBy: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
        } | null
        bids: Array<{
          __typename?: "InvestorBid"
          ppa?: {
            __typename: "PPAInvestorBid"
            pid: string
            name?: string | null
            termYears: number
            ppaPriceY1Usd: number
            ppaPriceEscalator: number
            roofRentY1Usd?: number | null
            roofRentEscalator?: number | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            itcPercentageAssumption: number
            estimatedCod: string
            estimatedNtp: string
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            recOwner: RecOwner
            tariffProvision?: boolean | null
            otherNotes?: string | null
            extraPaymentsNotes?: string | null
            incentivesNotes?: string | null
            interconnectionNotes?: string | null
            interconnectionRepriceProcessNotes?: string | null
            status?: InvestorBidStatus | null
            spec?: { __typename?: "PPABidSpec"; pid: string } | null
            financier: {
              __typename?: "OrgRef"
              pid: string
              name: string
              logoUrl: string
              logomarkUrl?: string | null
              profile?: {
                __typename?: "InvestorProfile"
                hq?: string | null
                yearFounded?: number | null
                website?: string | null
                description?: string | null
                committedFunding?: string | null
                distinguishingFeatures?: string | null
                investorBacking?: string | null
                managementTeam: Array<string>
                longTermOwnershipApproach?: string | null
                subscriptionMgmtApproach?: string | null
                experiences: Array<{
                  __typename?: "Experience"
                  state?: UsState | null
                  ftmEnergizedPvKw?: number | null
                  ftmAwardedPvKw?: number | null
                  btmEnergizedPvKw?: number | null
                  btmAwardedPvKw?: number | null
                }>
                buyBoxes: Array<{
                  __typename?: "BuyBox"
                  state?: UsState | null
                  ftmMinPortfolioSize?: number | null
                  ftmMinProjectSize?: number | null
                  ftmSeekingProjects?: boolean | null
                  btmMinPortfolioSize?: number | null
                  btmMinProjectSize?: number | null
                  btmSeekingProjects?: boolean | null
                }>
              } | null
            }
            system: {
              __typename?: "System"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpec"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes?: string | null
                etbMeterName: string
                document?: {
                  __typename?: "Document"
                  id: number
                  pid: string
                  fileName: string
                  downloadHref: string
                } | null
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }
            result?: {
              __typename: "RevampFinmodel"
              id: number
              pid: string
              createdAt: string
              type: FinProductType
              intervalsAndCostsXlsxHref: string
              buildingOwnerXlsxHref?: string | null
              offerStatus: OfferStatus
              fmvStr: string
              totalPvProductionKwh: number
              totalPvExportKwh?: number | null
              bauCostPerYear: Array<number>
              derCostPerYear: Array<number>
              goal?: PVoptGoal | null
              isVnem: boolean
              isGreenLease: boolean
              thirdPartySupplier?: {
                __typename?: "ThirdPartySupplier"
                pid: string
                name: string
              } | null
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              ppa?: {
                __typename: "PPAEconomics"
                ppaType: PpaProductType
                ppaCostPerKwh: number
                ppaTermYears: number
                ppaEsc?: number | null
                srecToInvestor: boolean
                offtakerXlsxHref: string
                product: {
                  __typename?: "PPAFinProduct"
                  productName: string
                  financierName: string
                }
                roofRent?: {
                  __typename?: "RoofRentEconomics"
                  lifetimeUsd: number
                  annualUsd: number
                  usdPerSqft: number
                  roofRentPerYear: Array<number>
                } | null
                tenantFlows?: {
                  __typename?: "TenantCashflows"
                  npv: number
                  discountRate: number
                  totalUtilitySavings: number
                  totalCapex: number
                  totalOpex: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                } | null
              } | null
              loan?: {
                __typename: "LoanEconomics"
                loanRecvrXlsxHref: string
                loanTermYears: number
                ownershipTermYears: number
                interestPct: number
                srecToInvestor: boolean
                product: {
                  __typename?: "LoanFinProduct"
                  productName: string
                  financierName: string
                  loanDealerFeePct: number
                }
                flows?: {
                  __typename?: "LoanRecvrCashflows"
                  monthlyPayment: number
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalLoanFunding: number
                  totalLoanPayments: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              selfInvest?: {
                __typename: "SelfInvestEconomics"
                npv: number
                discountRate: number
                selfInvestXlsxHref: string
                termYears: number
                srecToInvestor: boolean
                irrs: {
                  __typename?: "IRRs"
                  postTaxItcDepr?: number | null
                  postTaxItcDeprMultiple?: number | null
                }
                product: {
                  __typename?: "SelfInvestFinProduct"
                  productName: string
                  financierName: string
                }
                flows?: {
                  __typename?: "SelfInvestCashflows"
                  totalRevenue: number
                  totalUtilitySavings: number
                  totalOpex: number
                  totalCapex: number
                  totalItc: number
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  greenLeaseTenantFlows?: {
                    __typename?: "TenantCashflows"
                    totalNet: number
                    netCashflowPerYear: Array<number>
                    totalCapex: number
                    totalOpex: number
                    totalUtilitySavings: number
                    npv: number
                    discountRate: number
                  } | null
                } | null
              } | null
              meters: Array<{
                __typename?: "RevampMeter"
                name: string
                loadCategory: LoadCategory
                meterSource: MeterSource
                bau: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                }
                der?: {
                  __typename?: "RevampDer"
                  totalKwhFlow: {
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }
                  averageDayKwhFlow: Array<{
                    __typename?: "KwhFlow"
                    bauLoadKwh: number
                    importsKwh: number
                    exportsKwh: number
                    pvProductionKwh: number
                    pvToLoadKwh: number
                    batteryChargeKwh: number
                    batteryDischargeKwh: number
                  }>
                } | null
              }>
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              utilityCosts: {
                __typename?: "UtilityCost"
                bau: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
                der: {
                  __typename?: "FinmodelCost"
                  totalKwh: number
                  totalCostUsd: number
                  usdPerKwh: number
                  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                  tariffs: Array<{
                    __typename?: "RevampTariff"
                    id: number
                    name: string
                    code: string
                    startDate: string
                    endDate?: string | null
                    utility: {
                      __typename?: "RevampUtility"
                      id: number
                      name: string
                      shortName: string
                    }
                  }>
                }
              }
            } | null
          } | null
          cs?: {
            __typename: "CSInvestorBid"
            pid: string
            name?: string | null
            termYears: number
            roofRentEscalator: number
            roofRentY1Usd: number
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            itcPercentageAssumption: number
            estimatedAwardDate?: string | null
            estimatedCod: string
            estimatedNtp: string
            recOwner: RecOwner
            tariffProvision?: boolean | null
            incentivesNotes?: string | null
            interconnectionNotes?: string | null
            interconnectionRepriceProcessNotes?: string | null
            extraPaymentsNotes?: string | null
            otherNotes?: string | null
            status?: InvestorBidStatus | null
            spec?: { __typename?: "CSBidSpec"; pid: string } | null
            financier: {
              __typename?: "OrgRef"
              pid: string
              name: string
              logoUrl: string
              logomarkUrl?: string | null
              profile?: {
                __typename?: "InvestorProfile"
                hq?: string | null
                yearFounded?: number | null
                website?: string | null
                description?: string | null
                committedFunding?: string | null
                distinguishingFeatures?: string | null
                investorBacking?: string | null
                managementTeam: Array<string>
                longTermOwnershipApproach?: string | null
                subscriptionMgmtApproach?: string | null
                experiences: Array<{
                  __typename?: "Experience"
                  state?: UsState | null
                  ftmEnergizedPvKw?: number | null
                  ftmAwardedPvKw?: number | null
                  btmEnergizedPvKw?: number | null
                  btmAwardedPvKw?: number | null
                }>
                buyBoxes: Array<{
                  __typename?: "BuyBox"
                  state?: UsState | null
                  ftmMinPortfolioSize?: number | null
                  ftmMinProjectSize?: number | null
                  ftmSeekingProjects?: boolean | null
                  btmMinPortfolioSize?: number | null
                  btmMinProjectSize?: number | null
                  btmSeekingProjects?: boolean | null
                }>
              } | null
            }
            systemLite: {
              __typename?: "SystemLite"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpecLite"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes: string
              }>
            }
            result?: {
              __typename: "RevampCS"
              id: number
              termYears: number
              createdAt: string
              goal?: PVoptGoal | null
              systems: Array<
                | {
                    __typename: "BatterySystem"
                    vendor: BatteryVendor
                    sizeKw: number
                    sizeKwh: number
                    assumptions: {
                      __typename?: "BattAssumptions"
                      battChemName: string
                    }
                  }
                | { __typename: "PVSystem"; type: PvType; sizeKw: number }
              >
              financing: {
                __typename?: "RevampFinancing"
                id: number
                name: string
                type: FinProductType
                financierName: string
                financierPid: string
                financierLogo?: string | null
                financierLogomark?: string | null
                isThirdParty: boolean
              }
              buildingOwner: {
                __typename?: "BuildingOwnerEconomics"
                noiYearOne?: number | null
                noiLifetime?: number | null
                noiAnnual?: number | null
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                npv: number
                discountRate: number
                roofRentPerYear: Array<number>
              } | null
              pricing: {
                __typename?: "CSPrice"
                usdPerKwPerYear: number
                escalator: number
                minPvKw: number
                maxPvKw: number
                utility: { __typename?: "RevampUtility"; id: number; name: string }
              }
              leaseProjections?: {
                __typename?: "CSLeaseProjections"
                systemSizeKw: number
                annualRentLowerRangeUsd: number
                annualRentUpperRangeUsd: number
                methodology: CsLeaseProjectionMethdology
              } | null
            } | null
          } | null
        }>
        specs: Array<{
          __typename?: "BidSpec"
          ppa?: {
            __typename: "PPABidSpec"
            id: number
            pid: string
            name?: string | null
            termYears?: number | null
            note?: string | null
            archivedAt?: string | null
            ppaPriceY1Usd?: number | null
            ppaPriceEscalator?: number | null
            roofRentY1Usd?: number | null
            roofRentEscalator?: number | null
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            itcPercentageAssumption?: number | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            recOwner?: RecOwner | null
            archivedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            system?: {
              __typename?: "System"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpec"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes?: string | null
                etbMeterName: string
                document?: {
                  __typename?: "Document"
                  id: number
                  pid: string
                  fileName: string
                  downloadHref: string
                } | null
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            } | null
          } | null
          cs?: {
            __typename: "CSBidSpec"
            id: number
            pid: string
            name?: string | null
            termYears?: number | null
            note?: string | null
            archivedAt?: string | null
            roofRentY1Usd?: number | null
            roofRentEscalator?: number | null
            buildingOwnerExtraPaymentsUsd?: Array<number> | null
            itcPercentageAssumption?: number | null
            interconnectionCostUsdPerWatt?: number | null
            interconnectionCostUtilityMinUsd?: number | null
            interconnectionCostUtilityMaxUsd?: number | null
            interconnectionCostNonUtilityUsd?: number | null
            recOwner?: RecOwner | null
            archivedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
            systemLite?: {
              __typename?: "SystemLite"
              id: number
              pid: string
              createdAt: string
              totalPvSizeKw: number
              pvSpecs: Array<{
                __typename?: "PVSpec"
                id: number
                createdAt: string
                pvTypes: Array<PvType>
                sizeKwDc: number
                sizeKwAc?: number | null
                helioscope2Id?: number | null
                etbMeterId?: number | null
                helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
                roofImage?: { __typename?: "Document"; viewHref: string } | null
                productionCsv?: { __typename?: "Document"; downloadHref: string } | null
                productionSource?: {
                  __typename?: "PVProductionSource"
                  id: number
                  origin: ProductionOrigin
                } | null
                allocations: Array<{
                  __typename?: "PVAllocation"
                  id: number
                  createdAt: string
                  percentage: number
                  meter: {
                    __typename?: "BillingMeter"
                    pid: string
                    view: { __typename?: "BillingMeterView"; name: string }
                  }
                }>
              }>
              batterySpecs: Array<{
                __typename?: "BatterySpecLite"
                id: number
                sizeKwh: number
                sizeKwDc: number
                notes: string
              }>
            } | null
          } | null
          optOut?: {
            __typename: "InvestorBidSpecOptOut"
            createdAt: string
            archivedAt?: string | null
            reason?: SpecOptOutReason | null
            customReason?: string | null
            createdBy: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            }
            archivedBy?: {
              __typename?: "UserRef"
              pid: string
              email: string
              name?: string | null
              isAdmin: boolean
              avatarUrl?: string | null
            } | null
          } | null
        }>
      }>
      financier: {
        __typename?: "BundleOrg"
        pid: string
        name: string
        orgSlug: string
      }
      optOut?: {
        __typename: "InvestorOptOut"
        createdAt: string
        archivedAt?: string | null
        reason?: InvestorOptOutReason | null
        customReason?: string | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      } | null
      recvr: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
      bidSubmissionStatus: {
        __typename?: "BundleBidSubmissionSummary"
        bidStatus: BundleBidSubmissionStatus
        submittedBidCount?: number | null
        totalRequestedBids?: number | null
      }
      awardStatus?: {
        __typename?: "BundleAwardStatusSummary"
        awardStatus: BundleAwardStatus
        awardedBidCount?: number | null
        totalPossibleAwards?: number | null
      } | null
    }>
    rows: Array<{
      __typename?: "BundleParentRow"
      notes?: string | null
      status?: PackageRowStatus | null
      closedAt?: string | null
      closeReason?: PackageRowCloseReason | null
      closeCustomReason?: string | null
      specs: Array<{
        __typename?: "BidSpec"
        ppa?: {
          __typename: "PPABidSpec"
          id: number
          pid: string
          name?: string | null
          termYears?: number | null
          note?: string | null
          archivedAt?: string | null
          ppaPriceY1Usd?: number | null
          ppaPriceEscalator?: number | null
          roofRentY1Usd?: number | null
          roofRentEscalator?: number | null
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          itcPercentageAssumption?: number | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          recOwner?: RecOwner | null
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
          system?: {
            __typename?: "System"
            id: number
            pid: string
            createdAt: string
            totalPvSizeKw: number
            pvSpecs: Array<{
              __typename?: "PVSpec"
              id: number
              createdAt: string
              pvTypes: Array<PvType>
              sizeKwDc: number
              sizeKwAc?: number | null
              helioscope2Id?: number | null
              etbMeterId?: number | null
              helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
              roofImage?: { __typename?: "Document"; viewHref: string } | null
              productionCsv?: { __typename?: "Document"; downloadHref: string } | null
              productionSource?: {
                __typename?: "PVProductionSource"
                id: number
                origin: ProductionOrigin
              } | null
              allocations: Array<{
                __typename?: "PVAllocation"
                id: number
                createdAt: string
                percentage: number
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }>
            batterySpecs: Array<{
              __typename?: "BatterySpec"
              id: number
              sizeKwh: number
              sizeKwDc: number
              notes?: string | null
              etbMeterName: string
              document?: {
                __typename?: "Document"
                id: number
                pid: string
                fileName: string
                downloadHref: string
              } | null
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          } | null
        } | null
        cs?: {
          __typename: "CSBidSpec"
          id: number
          pid: string
          name?: string | null
          termYears?: number | null
          note?: string | null
          archivedAt?: string | null
          roofRentY1Usd?: number | null
          roofRentEscalator?: number | null
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          itcPercentageAssumption?: number | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          recOwner?: RecOwner | null
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
          systemLite?: {
            __typename?: "SystemLite"
            id: number
            pid: string
            createdAt: string
            totalPvSizeKw: number
            pvSpecs: Array<{
              __typename?: "PVSpec"
              id: number
              createdAt: string
              pvTypes: Array<PvType>
              sizeKwDc: number
              sizeKwAc?: number | null
              helioscope2Id?: number | null
              etbMeterId?: number | null
              helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
              roofImage?: { __typename?: "Document"; viewHref: string } | null
              productionCsv?: { __typename?: "Document"; downloadHref: string } | null
              productionSource?: {
                __typename?: "PVProductionSource"
                id: number
                origin: ProductionOrigin
              } | null
              allocations: Array<{
                __typename?: "PVAllocation"
                id: number
                createdAt: string
                percentage: number
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }>
            batterySpecs: Array<{
              __typename?: "BatterySpecLite"
              id: number
              sizeKwh: number
              sizeKwDc: number
              notes: string
            }>
          } | null
        } | null
        optOut?: {
          __typename: "InvestorBidSpecOptOut"
          createdAt: string
          archivedAt?: string | null
          reason?: SpecOptOutReason | null
          customReason?: string | null
          createdBy: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
        } | null
      }>
      site: {
        __typename?: "SiteRef"
        pid: string
        name?: string | null
        streetAddress: string
        city: string
        state: string
        zipCode: string
      }
      scenario?: {
        __typename?: "ScenarioRef"
        pid: string
        name: string
        solarLocation: SolarLocation
        includeStorage: boolean
      } | null
      awardedFinancier?: {
        __typename?: "Org"
        pid: string
        name: string
        logoUrl?: string | null
        logomarkUrl?: string | null
      } | null
      recommendedBid?: {
        __typename?: "InvestorBid"
        ppa?: { __typename?: "PPAInvestorBid"; pid: string } | null
        cs?: { __typename?: "CSInvestorBid"; pid: string } | null
      } | null
    }>
    documents: Array<{
      __typename?: "Document"
      id: number
      pid: string
      tag?: DocumentTag | null
      fileName: string
      contentType: string
      dateCreated: string
      downloadHref: string
      canDelete: boolean
      ownerName: string
    }>
    opsOwner?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    recvr: { __typename?: "Org"; pid: string; name: string }
  }
}

export type BundleParentReportsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  pid: Scalars["String"]["input"]
}>

export type BundleParentReportsQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    type: FinProductType
    customReports: Array<{
      __typename?: "CustomBidReport"
      pid: string
      name: string
      notes: string
      buildingOwnerNotes?: string | null
      visibleToDevelopers: boolean
      visibleToBuildingOwners: boolean
      bids: Array<{
        __typename?: "InvestorBid"
        ppa?: {
          __typename?: "PPAInvestorBid"
          pid: string
          financier: { __typename?: "OrgRef"; orgSlug: string }
        } | null
        cs?: {
          __typename?: "CSInvestorBid"
          pid: string
          financier: { __typename?: "OrgRef"; orgSlug: string }
        } | null
      }>
    }>
  }
}

export type BidReportsQueryVariables = Exact<{ [key: string]: never }>

export type BidReportsQuery = {
  __typename?: "Query"
  bidReports: Array<{
    __typename?: "CustomBidReport"
    pid: string
    name: string
    notes: string
    buildingOwnerNotes?: string | null
    parent: { __typename?: "BundleParent"; pid: string }
    bids: Array<{
      __typename?: "InvestorBid"
      ppa?: { __typename?: "PPAInvestorBid"; pid: string } | null
      cs?: { __typename?: "CSInvestorBid"; pid: string } | null
    }>
  }>
}

export type BundleParentBasicsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  pid: Scalars["String"]["input"]
}>

export type BundleParentBasicsQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    publicUrl: string
    totalPvSizeKwDc: number
    id: number
    createdAt: string
    pid: string
    name: string
    type: FinProductType
    note?: string | null
    pricingNote?: string | null
    state: BundleState
    biddingOpenAt?: string | null
    biddingClosedAt?: string | null
    canAddNewBids: boolean
    canEditBids: boolean
    hiddenFromRecvr?: string | null
    hiddenFromFinancier?: string | null
    showAllBidsReport: boolean
    bundles: Array<{
      __typename?: "Bundle2"
      pid: string
      financier: {
        __typename?: "BundleOrg"
        pid: string
        name: string
        orgSlug: string
        orgUsers: Array<{
          __typename?: "OrgUser"
          user: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          userRoles: Array<{ __typename?: "UserRole"; role: RbacRole }>
        }>
      }
    }>
    opsOwner?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    recvr: { __typename?: "Org"; pid: string; name: string }
  }
}

export type EvOverridesQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type EvOverridesQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    site?: {
      __typename?: "RevampSite"
      evOverrides: {
        __typename?: "EVOverrideQueries"
        current?: {
          __typename?: "EVOverrides"
          chargerKw?: number | null
          chargerLocation?: ChargerLocation | null
          cmsUsdPerChargerPerYr?: number | null
          demandUsdPerKw?: number | null
          discountRate?: number | null
          evGrowthPct?: number | null
          highEnergyUsdPerKwh?: number | null
          incentivePct?: number | null
          installType?: ChargerInstallType | null
          lowEnergyUsdPerKwh?: number | null
          maxUtilization?: number | null
          milesDrivenPerYear?: number | null
          milesPerKwh?: number | null
          numChargers?: number | null
          omUsdPerChargerPerYr?: number | null
          onPeakChargingPct?: number | null
          onSiteChargingPct?: number | null
          projectStartDate?: string | null
          rateManagementUsdPerChargerPerYr?: number | null
          salesTaxPct?: number | null
          termYears?: number | null
          transactionFeePct?: number | null
          usdPerKwhMarkup?: number | null
          yr0NumTenantEvs?: number | null
          incentiveCapNumChargers?: number | null
          maxEvAdoptionPct?: number | null
          installCostUsd?: number | null
        } | null
        defaults: {
          __typename?: "EVProjectInputs"
          chargerKw: number
          chargerLocation: ChargerLocation
          cmsUsdPerChargerPerYr: number
          demandUsdPerKw?: number | null
          discountRate: number
          evGrowthPct?: number | null
          highEnergyUsdPerKwh: number
          incentivePct: number
          installType: ChargerInstallType
          lowEnergyUsdPerKwh: number
          maxUtilization: number
          milesDrivenPerYear: number
          milesPerKwh: number
          numChargers?: number | null
          omUsdPerChargerPerYr: number
          onPeakChargingPct: number
          onSiteChargingPct: number
          projectStartDate: string
          rateManagementUsdPerChargerPerYr: number
          salesTaxPct: number
          termYears: number
          transactionFeePct: number
          usdPerKwhMarkup: number
          yr0NumTenantEvs?: number | null
          incentiveCapNumChargers?: number | null
          maxEvAdoptionPct: number
          installCostUsd?: number | null
        }
      }
    } | null
  } | null
}

export type InvestorBundleListQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type InvestorBundleListQuery = {
  __typename?: "Query"
  bundlesForFinancier2: Array<{
    __typename?: "Bundle2"
    pid: string
    name: string
    type: FinProductType
    note?: string | null
    pricingNote?: string | null
    state: BundleState
    archivedAt?: string | null
    lastViewed?: string | null
    biddingOpenAt?: string | null
    biddingClosedAt?: string | null
    hasVisibleReports: boolean
    totalBids: number
    optOut?: {
      __typename: "InvestorOptOut"
      createdAt: string
      archivedAt?: string | null
      reason?: InvestorOptOutReason | null
      customReason?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
    recvr: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
    financier: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
    bidSubmissionStatus: {
      __typename?: "BundleBidSubmissionSummary"
      bidStatus: BundleBidSubmissionStatus
      submittedBidCount?: number | null
      totalRequestedBids?: number | null
    }
    awardStatus?: {
      __typename?: "BundleAwardStatusSummary"
      awardStatus: BundleAwardStatus
      awardedBidCount?: number | null
      totalPossibleAwards?: number | null
    } | null
  }>
}

export type InvestorBundleLiteQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
}>

export type InvestorBundleLiteQuery = {
  __typename?: "Query"
  bundleDetail?: {
    __typename?: "Bundle2"
    pid: string
    name: string
    type: FinProductType
    note?: string | null
    pricingNote?: string | null
    state: BundleState
    archivedAt?: string | null
    lastViewed?: string | null
    biddingOpenAt?: string | null
    biddingClosedAt?: string | null
    hasVisibleReports: boolean
    totalBids: number
    optOut?: {
      __typename: "InvestorOptOut"
      createdAt: string
      archivedAt?: string | null
      reason?: InvestorOptOutReason | null
      customReason?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
    recvr: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
    financier: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
    bidSubmissionStatus: {
      __typename?: "BundleBidSubmissionSummary"
      bidStatus: BundleBidSubmissionStatus
      submittedBidCount?: number | null
      totalRequestedBids?: number | null
    }
    awardStatus?: {
      __typename?: "BundleAwardStatusSummary"
      awardStatus: BundleAwardStatus
      awardedBidCount?: number | null
      totalPossibleAwards?: number | null
    } | null
  } | null
}

export type InvestorBundleDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
}>

export type InvestorBundleDetailQuery = {
  __typename?: "Query"
  bundleDetail?: {
    __typename?: "Bundle2"
    downloadBundleDocsZipHref: string
    downloadHelioscopesDotZipHref?: string | null
    downloadBundleDotXlsxHref: string
    pid: string
    name: string
    type: FinProductType
    note?: string | null
    pricingNote?: string | null
    state: BundleState
    archivedAt?: string | null
    lastViewed?: string | null
    biddingOpenAt?: string | null
    biddingClosedAt?: string | null
    hasVisibleReports: boolean
    totalBids: number
    opsOwner?: {
      __typename?: "UserRef"
      meetingSchedulingUrl?: string | null
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    parentRef?: { __typename?: "BundleParentRef"; pid: string } | null
    documents: Array<{
      __typename?: "Document"
      canDelete: boolean
      contentType: string
      dateCreated: string
      fileName: string
      ownerName: string
      pid: string
      tag?: DocumentTag | null
      downloadHref: string
      viewHref: string
      belongsToBundleParent: boolean
    }>
    rows: Array<{
      __typename?: "BundleRow2"
      id: number
      ppaType?: PpaProductType | null
      state?: BundleState | null
      reason?: CloseReason | null
      customReason?: string | null
      notes?: string | null
      site: {
        __typename?: "RevampSite"
        pid: string
        name?: string | null
        fullAddress: string
        streetAddress: string
        city: string
        state: string
        zipCode: string
        county: string
        cbsaName?: string | null
        doeReferenceType?: BuildingType | null
        yearBuilt?: number | null
        isEnergyCommunity: boolean
        isLowIncomeCommunity?: boolean | null
        sqft?: number | null
        roofSqft?: number | null
        roofMaxPvKw: number
        numStories?: number | null
        buildingClass?: string | null
        buildingData?: { __typename?: "BuildingData"; ownerName?: string | null } | null
        siteDetails: {
          __typename?: "SiteDetails"
          roofReplacedYr?: number | null
          roofCondition?: string | null
        }
        targetUtility?: {
          __typename?: "Utility"
          pid: string
          name: string
          hostingCapacityMaps: Array<{
            __typename?: "HostingCapacityMap"
            url: string
            requiresLogin: boolean
            types: Array<HostingCapacityMapType>
          }>
        } | null
      }
      optOut?: {
        __typename: "InvestorOptOut"
        createdAt: string
        archivedAt?: string | null
        reason?: InvestorOptOutReason | null
        customReason?: string | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      } | null
      bids: Array<{
        __typename?: "InvestorBid"
        ppa?: {
          __typename: "PPAInvestorBid"
          pid: string
          name?: string | null
          termYears: number
          ppaPriceY1Usd: number
          ppaPriceEscalator: number
          roofRentY1Usd?: number | null
          roofRentEscalator?: number | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          itcPercentageAssumption: number
          estimatedCod: string
          estimatedNtp: string
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          recOwner: RecOwner
          tariffProvision?: boolean | null
          otherNotes?: string | null
          extraPaymentsNotes?: string | null
          incentivesNotes?: string | null
          interconnectionNotes?: string | null
          interconnectionRepriceProcessNotes?: string | null
          status?: InvestorBidStatus | null
          spec?: { __typename?: "PPABidSpec"; pid: string } | null
          financier: {
            __typename?: "OrgRef"
            pid: string
            name: string
            logoUrl: string
            logomarkUrl?: string | null
            profile?: {
              __typename?: "InvestorProfile"
              hq?: string | null
              yearFounded?: number | null
              website?: string | null
              description?: string | null
              committedFunding?: string | null
              distinguishingFeatures?: string | null
              investorBacking?: string | null
              managementTeam: Array<string>
              longTermOwnershipApproach?: string | null
              subscriptionMgmtApproach?: string | null
              experiences: Array<{
                __typename?: "Experience"
                state?: UsState | null
                ftmEnergizedPvKw?: number | null
                ftmAwardedPvKw?: number | null
                btmEnergizedPvKw?: number | null
                btmAwardedPvKw?: number | null
              }>
              buyBoxes: Array<{
                __typename?: "BuyBox"
                state?: UsState | null
                ftmMinPortfolioSize?: number | null
                ftmMinProjectSize?: number | null
                ftmSeekingProjects?: boolean | null
                btmMinPortfolioSize?: number | null
                btmMinProjectSize?: number | null
                btmSeekingProjects?: boolean | null
              }>
            } | null
          }
          system: {
            __typename?: "System"
            id: number
            pid: string
            createdAt: string
            totalPvSizeKw: number
            pvSpecs: Array<{
              __typename?: "PVSpec"
              id: number
              createdAt: string
              pvTypes: Array<PvType>
              sizeKwDc: number
              sizeKwAc?: number | null
              helioscope2Id?: number | null
              etbMeterId?: number | null
              helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
              roofImage?: { __typename?: "Document"; viewHref: string } | null
              productionCsv?: { __typename?: "Document"; downloadHref: string } | null
              productionSource?: {
                __typename?: "PVProductionSource"
                id: number
                origin: ProductionOrigin
              } | null
              allocations: Array<{
                __typename?: "PVAllocation"
                id: number
                createdAt: string
                percentage: number
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }>
            batterySpecs: Array<{
              __typename?: "BatterySpec"
              id: number
              sizeKwh: number
              sizeKwDc: number
              notes?: string | null
              etbMeterName: string
              document?: {
                __typename?: "Document"
                id: number
                pid: string
                fileName: string
                downloadHref: string
              } | null
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }
          result?: {
            __typename: "RevampFinmodel"
            id: number
            pid: string
            createdAt: string
            type: FinProductType
            intervalsAndCostsXlsxHref: string
            buildingOwnerXlsxHref?: string | null
            offerStatus: OfferStatus
            fmvStr: string
            totalPvProductionKwh: number
            totalPvExportKwh?: number | null
            bauCostPerYear: Array<number>
            derCostPerYear: Array<number>
            goal?: PVoptGoal | null
            isVnem: boolean
            isGreenLease: boolean
            thirdPartySupplier?: {
              __typename?: "ThirdPartySupplier"
              pid: string
              name: string
            } | null
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            ppa?: {
              __typename: "PPAEconomics"
              ppaType: PpaProductType
              ppaCostPerKwh: number
              ppaTermYears: number
              ppaEsc?: number | null
              srecToInvestor: boolean
              offtakerXlsxHref: string
              product: {
                __typename?: "PPAFinProduct"
                productName: string
                financierName: string
              }
              roofRent?: {
                __typename?: "RoofRentEconomics"
                lifetimeUsd: number
                annualUsd: number
                usdPerSqft: number
                roofRentPerYear: Array<number>
              } | null
              tenantFlows?: {
                __typename?: "TenantCashflows"
                npv: number
                discountRate: number
                totalUtilitySavings: number
                totalCapex: number
                totalOpex: number
                totalNet: number
                netCashflowPerYear: Array<number>
              } | null
            } | null
            loan?: {
              __typename: "LoanEconomics"
              loanRecvrXlsxHref: string
              loanTermYears: number
              ownershipTermYears: number
              interestPct: number
              srecToInvestor: boolean
              product: {
                __typename?: "LoanFinProduct"
                productName: string
                financierName: string
                loanDealerFeePct: number
              }
              flows?: {
                __typename?: "LoanRecvrCashflows"
                monthlyPayment: number
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalLoanFunding: number
                totalLoanPayments: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            selfInvest?: {
              __typename: "SelfInvestEconomics"
              npv: number
              discountRate: number
              selfInvestXlsxHref: string
              termYears: number
              srecToInvestor: boolean
              irrs: {
                __typename?: "IRRs"
                postTaxItcDepr?: number | null
                postTaxItcDeprMultiple?: number | null
              }
              product: {
                __typename?: "SelfInvestFinProduct"
                productName: string
                financierName: string
              }
              flows?: {
                __typename?: "SelfInvestCashflows"
                totalRevenue: number
                totalUtilitySavings: number
                totalOpex: number
                totalCapex: number
                totalItc: number
                totalNet: number
                netCashflowPerYear: Array<number>
                greenLeaseTenantFlows?: {
                  __typename?: "TenantCashflows"
                  totalNet: number
                  netCashflowPerYear: Array<number>
                  totalCapex: number
                  totalOpex: number
                  totalUtilitySavings: number
                  npv: number
                  discountRate: number
                } | null
              } | null
            } | null
            meters: Array<{
              __typename?: "RevampMeter"
              name: string
              loadCategory: LoadCategory
              meterSource: MeterSource
              bau: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
              }
              der?: {
                __typename?: "RevampDer"
                totalKwhFlow: {
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }
                averageDayKwhFlow: Array<{
                  __typename?: "KwhFlow"
                  bauLoadKwh: number
                  importsKwh: number
                  exportsKwh: number
                  pvProductionKwh: number
                  pvToLoadKwh: number
                  batteryChargeKwh: number
                  batteryDischargeKwh: number
                }>
              } | null
            }>
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            utilityCosts: {
              __typename?: "UtilityCost"
              bau: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
              der: {
                __typename?: "FinmodelCost"
                totalKwh: number
                totalCostUsd: number
                usdPerKwh: number
                items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
                tariffs: Array<{
                  __typename?: "RevampTariff"
                  id: number
                  name: string
                  code: string
                  startDate: string
                  endDate?: string | null
                  utility: {
                    __typename?: "RevampUtility"
                    id: number
                    name: string
                    shortName: string
                  }
                }>
              }
            }
          } | null
        } | null
        cs?: {
          __typename: "CSInvestorBid"
          pid: string
          name?: string | null
          termYears: number
          roofRentEscalator: number
          roofRentY1Usd: number
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          itcPercentageAssumption: number
          estimatedAwardDate?: string | null
          estimatedCod: string
          estimatedNtp: string
          recOwner: RecOwner
          tariffProvision?: boolean | null
          incentivesNotes?: string | null
          interconnectionNotes?: string | null
          interconnectionRepriceProcessNotes?: string | null
          extraPaymentsNotes?: string | null
          otherNotes?: string | null
          status?: InvestorBidStatus | null
          spec?: { __typename?: "CSBidSpec"; pid: string } | null
          financier: {
            __typename?: "OrgRef"
            pid: string
            name: string
            logoUrl: string
            logomarkUrl?: string | null
            profile?: {
              __typename?: "InvestorProfile"
              hq?: string | null
              yearFounded?: number | null
              website?: string | null
              description?: string | null
              committedFunding?: string | null
              distinguishingFeatures?: string | null
              investorBacking?: string | null
              managementTeam: Array<string>
              longTermOwnershipApproach?: string | null
              subscriptionMgmtApproach?: string | null
              experiences: Array<{
                __typename?: "Experience"
                state?: UsState | null
                ftmEnergizedPvKw?: number | null
                ftmAwardedPvKw?: number | null
                btmEnergizedPvKw?: number | null
                btmAwardedPvKw?: number | null
              }>
              buyBoxes: Array<{
                __typename?: "BuyBox"
                state?: UsState | null
                ftmMinPortfolioSize?: number | null
                ftmMinProjectSize?: number | null
                ftmSeekingProjects?: boolean | null
                btmMinPortfolioSize?: number | null
                btmMinProjectSize?: number | null
                btmSeekingProjects?: boolean | null
              }>
            } | null
          }
          systemLite: {
            __typename?: "SystemLite"
            id: number
            pid: string
            createdAt: string
            totalPvSizeKw: number
            pvSpecs: Array<{
              __typename?: "PVSpec"
              id: number
              createdAt: string
              pvTypes: Array<PvType>
              sizeKwDc: number
              sizeKwAc?: number | null
              helioscope2Id?: number | null
              etbMeterId?: number | null
              helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
              roofImage?: { __typename?: "Document"; viewHref: string } | null
              productionCsv?: { __typename?: "Document"; downloadHref: string } | null
              productionSource?: {
                __typename?: "PVProductionSource"
                id: number
                origin: ProductionOrigin
              } | null
              allocations: Array<{
                __typename?: "PVAllocation"
                id: number
                createdAt: string
                percentage: number
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }>
            batterySpecs: Array<{
              __typename?: "BatterySpecLite"
              id: number
              sizeKwh: number
              sizeKwDc: number
              notes: string
            }>
          }
          result?: {
            __typename: "RevampCS"
            id: number
            termYears: number
            createdAt: string
            goal?: PVoptGoal | null
            systems: Array<
              | {
                  __typename: "BatterySystem"
                  vendor: BatteryVendor
                  sizeKw: number
                  sizeKwh: number
                  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
                }
              | { __typename: "PVSystem"; type: PvType; sizeKw: number }
            >
            financing: {
              __typename?: "RevampFinancing"
              id: number
              name: string
              type: FinProductType
              financierName: string
              financierPid: string
              financierLogo?: string | null
              financierLogomark?: string | null
              isThirdParty: boolean
            }
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiYearOne?: number | null
              noiLifetime?: number | null
              noiAnnual?: number | null
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              npv: number
              discountRate: number
              roofRentPerYear: Array<number>
            } | null
            pricing: {
              __typename?: "CSPrice"
              usdPerKwPerYear: number
              escalator: number
              minPvKw: number
              maxPvKw: number
              utility: { __typename?: "RevampUtility"; id: number; name: string }
            }
            leaseProjections?: {
              __typename?: "CSLeaseProjections"
              systemSizeKw: number
              annualRentLowerRangeUsd: number
              annualRentUpperRangeUsd: number
              methodology: CsLeaseProjectionMethdology
            } | null
          } | null
        } | null
      }>
      specs: Array<{
        __typename?: "BidSpec"
        ppa?: {
          __typename: "PPABidSpec"
          id: number
          pid: string
          name?: string | null
          termYears?: number | null
          note?: string | null
          archivedAt?: string | null
          ppaPriceY1Usd?: number | null
          ppaPriceEscalator?: number | null
          roofRentY1Usd?: number | null
          roofRentEscalator?: number | null
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          itcPercentageAssumption?: number | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          recOwner?: RecOwner | null
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
          system?: {
            __typename?: "System"
            id: number
            pid: string
            createdAt: string
            totalPvSizeKw: number
            pvSpecs: Array<{
              __typename?: "PVSpec"
              id: number
              createdAt: string
              pvTypes: Array<PvType>
              sizeKwDc: number
              sizeKwAc?: number | null
              helioscope2Id?: number | null
              etbMeterId?: number | null
              helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
              roofImage?: { __typename?: "Document"; viewHref: string } | null
              productionCsv?: { __typename?: "Document"; downloadHref: string } | null
              productionSource?: {
                __typename?: "PVProductionSource"
                id: number
                origin: ProductionOrigin
              } | null
              allocations: Array<{
                __typename?: "PVAllocation"
                id: number
                createdAt: string
                percentage: number
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }>
            batterySpecs: Array<{
              __typename?: "BatterySpec"
              id: number
              sizeKwh: number
              sizeKwDc: number
              notes?: string | null
              etbMeterName: string
              document?: {
                __typename?: "Document"
                id: number
                pid: string
                fileName: string
                downloadHref: string
              } | null
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          } | null
        } | null
        cs?: {
          __typename: "CSBidSpec"
          id: number
          pid: string
          name?: string | null
          termYears?: number | null
          note?: string | null
          archivedAt?: string | null
          roofRentY1Usd?: number | null
          roofRentEscalator?: number | null
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          itcPercentageAssumption?: number | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          recOwner?: RecOwner | null
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
          systemLite?: {
            __typename?: "SystemLite"
            id: number
            pid: string
            createdAt: string
            totalPvSizeKw: number
            pvSpecs: Array<{
              __typename?: "PVSpec"
              id: number
              createdAt: string
              pvTypes: Array<PvType>
              sizeKwDc: number
              sizeKwAc?: number | null
              helioscope2Id?: number | null
              etbMeterId?: number | null
              helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
              roofImage?: { __typename?: "Document"; viewHref: string } | null
              productionCsv?: { __typename?: "Document"; downloadHref: string } | null
              productionSource?: {
                __typename?: "PVProductionSource"
                id: number
                origin: ProductionOrigin
              } | null
              allocations: Array<{
                __typename?: "PVAllocation"
                id: number
                createdAt: string
                percentage: number
                meter: {
                  __typename?: "BillingMeter"
                  pid: string
                  view: { __typename?: "BillingMeterView"; name: string }
                }
              }>
            }>
            batterySpecs: Array<{
              __typename?: "BatterySpecLite"
              id: number
              sizeKwh: number
              sizeKwDc: number
              notes: string
            }>
          } | null
        } | null
        optOut?: {
          __typename: "InvestorBidSpecOptOut"
          createdAt: string
          archivedAt?: string | null
          reason?: SpecOptOutReason | null
          customReason?: string | null
          createdBy: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          archivedBy?: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          } | null
        } | null
      }>
    }>
    bidReports?: Array<{
      __typename?: "PackageBidReport"
      pid?: string | null
      name?: string | null
      notes?: string | null
      visible: boolean
      totalDevelopers: number
      totalBids: number
      cs?: Array<{
        __typename: "CSSiteBidReport"
        awarded: boolean
        awardedPid?: string | null
        totalBids: number
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          isFavorite: boolean
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
        }
        bids: Array<{
          __typename: "CSInvestorBid"
          name?: string | null
          pid: string
          termYears: number
          roofRentEscalator: number
          roofRentY1Usd: number
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          itcPercentageAssumption: number
          estimatedAwardDate?: string | null
          estimatedCod: string
          estimatedNtp: string
          recOwner: RecOwner
          tariffProvision?: boolean | null
          incentivesNotes?: string | null
          interconnectionNotes?: string | null
          interconnectionRepriceProcessNotes?: string | null
          extraPaymentsNotes?: string | null
          otherNotes?: string | null
          financier: {
            __typename?: "OrgRef"
            pid: string
            name: string
            logoUrl: string
            logomarkUrl?: string | null
            profile?: {
              __typename?: "InvestorProfile"
              hq?: string | null
              yearFounded?: number | null
              website?: string | null
              description?: string | null
              committedFunding?: string | null
              distinguishingFeatures?: string | null
              investorBacking?: string | null
              managementTeam: Array<string>
              longTermOwnershipApproach?: string | null
              subscriptionMgmtApproach?: string | null
              experiences: Array<{
                __typename?: "Experience"
                state?: UsState | null
                ftmEnergizedPvKw?: number | null
                ftmAwardedPvKw?: number | null
                btmEnergizedPvKw?: number | null
                btmAwardedPvKw?: number | null
              }>
              buyBoxes: Array<{
                __typename?: "BuyBox"
                state?: UsState | null
                ftmMinPortfolioSize?: number | null
                ftmMinProjectSize?: number | null
                ftmSeekingProjects?: boolean | null
                btmMinPortfolioSize?: number | null
                btmMinProjectSize?: number | null
                btmSeekingProjects?: boolean | null
              }>
            } | null
          }
          result?: {
            __typename?: "RevampCS"
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiLifetime?: number | null
            }
          } | null
        }>
        noi?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        y1RoofRent?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        systemSize?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        itcPercentageAssumption?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        roofRentEscalator?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        npv?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
      }> | null
      ppa?: Array<{
        __typename: "PPASiteBidReport"
        awarded: boolean
        awardedPid?: string | null
        totalBids: number
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          isFavorite: boolean
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
        }
        bids: Array<{
          __typename: "PPAInvestorBid"
          name?: string | null
          pid: string
          termYears: number
          roofRentEscalator?: number | null
          roofRentY1Usd?: number | null
          buildingOwnerExtraPaymentsUsd?: Array<number> | null
          interconnectionCostUsdPerWatt?: number | null
          interconnectionCostUtilityMinUsd?: number | null
          interconnectionCostUtilityMaxUsd?: number | null
          interconnectionCostNonUtilityUsd?: number | null
          itcPercentageAssumption: number
          estimatedCod: string
          estimatedNtp: string
          recOwner: RecOwner
          tariffProvision?: boolean | null
          incentivesNotes?: string | null
          interconnectionNotes?: string | null
          interconnectionRepriceProcessNotes?: string | null
          extraPaymentsNotes?: string | null
          otherNotes?: string | null
          financier: {
            __typename?: "OrgRef"
            pid: string
            name: string
            logoUrl: string
            logomarkUrl?: string | null
            profile?: {
              __typename?: "InvestorProfile"
              hq?: string | null
              yearFounded?: number | null
              website?: string | null
              description?: string | null
              committedFunding?: string | null
              distinguishingFeatures?: string | null
              investorBacking?: string | null
              managementTeam: Array<string>
              longTermOwnershipApproach?: string | null
              subscriptionMgmtApproach?: string | null
              experiences: Array<{
                __typename?: "Experience"
                state?: UsState | null
                ftmEnergizedPvKw?: number | null
                ftmAwardedPvKw?: number | null
                btmEnergizedPvKw?: number | null
                btmAwardedPvKw?: number | null
              }>
              buyBoxes: Array<{
                __typename?: "BuyBox"
                state?: UsState | null
                ftmMinPortfolioSize?: number | null
                ftmMinProjectSize?: number | null
                ftmSeekingProjects?: boolean | null
                btmMinPortfolioSize?: number | null
                btmMinProjectSize?: number | null
                btmSeekingProjects?: boolean | null
              }>
            } | null
          }
          result?: {
            __typename?: "RevampFinmodel"
            buildingOwner: {
              __typename?: "BuildingOwnerEconomics"
              noiLifetime?: number | null
            }
          } | null
        }>
        noi?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        y1RoofRent?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        systemSize?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        itcPercentageAssumption?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        ppaPriceEscalator?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
        npv?: {
          __typename?: "BoxplotStats"
          min: number
          q1: number
          median: number
          q3: number
          max: number
          average: number
        } | null
      }> | null
    }> | null
    optOut?: {
      __typename: "InvestorOptOut"
      createdAt: string
      archivedAt?: string | null
      reason?: InvestorOptOutReason | null
      customReason?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
    recvr: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
    financier: { __typename?: "BundleOrg"; pid: string; name: string; orgSlug: string }
    bidSubmissionStatus: {
      __typename?: "BundleBidSubmissionSummary"
      bidStatus: BundleBidSubmissionStatus
      submittedBidCount?: number | null
      totalRequestedBids?: number | null
    }
    awardStatus?: {
      __typename?: "BundleAwardStatusSummary"
      awardStatus: BundleAwardStatus
      awardedBidCount?: number | null
      totalPossibleAwards?: number | null
    } | null
  } | null
}

export type InvestorBundleRowDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type InvestorBundleRowDetailQuery = {
  __typename?: "Query"
  bundleRowDetail?: {
    __typename?: "BundleRow2"
    id: number
    ppaType?: PpaProductType | null
    state?: BundleState | null
    reason?: CloseReason | null
    customReason?: string | null
    notes?: string | null
    site: {
      __typename?: "RevampSite"
      pid: string
      name?: string | null
      isFavorite: boolean
      isBehindTheMeter?: boolean | null
      isEnergyCommunity: boolean
      isLowIncomeCommunity?: boolean | null
      streetAddress: string
      city: string
      state: string
      zipCode: string
      county: string
      fullAddress: string
      metering?: Metering | null
      assetManager?: string | null
      vnemAllowed: boolean
      doeReferenceType?: BuildingType | null
      usingBillingMeters?: string | null
      numParkingSpaces?: number | null
      yearBuilt?: number | null
      numStories?: number | null
      sqft?: number | null
      roofSqft?: number | null
      usableRoofSqft?: number | null
      usableCarportFt?: number | null
      impliedCarportLinearFt?: number | null
      impliedUsableRoofSqft?: number | null
      impliedUsableRoofSqftExplanation: RoofSqftExplanation
      groundAvailableSqft?: number | null
      hideBuildingFootprint: boolean
      keepoutsFootprintSqft?: number | null
      roofMaxPvKw: number
      carportMaxPvKw: number
      groundmountMaxPvKw?: number | null
      maxPvKwPolicyLimited: boolean
      isMultifamily: boolean
      occupancyType?: BuildingOccupancyType | null
      leaseType?: LeaseType | null
      tenantLeaseTerm?: string | null
      tenantLeaseEnds?: string | null
      tenantInterest?: YesNoUnsure | null
      mortgageLender?: string | null
      buildingClass?: string | null
      hasSubmittedEnergyData: boolean
      meterSet?: {
        __typename?: "MeterSet"
        totalCost: number
        loadKwh?: number | null
        loadOrigin?: LoadOrigin | null
      } | null
      billingMeters: Array<{
        __typename?: "BillingMeter"
        pid: string
        bauMeterPid?: string | null
        view: {
          __typename?: "BillingMeterView"
          name: string
          isArchived: boolean
          calc2:
            | { __typename: "E2Error" }
            | { __typename: "Projected"; annualKwh: number }
        }
      }>
      selectedConfig?: {
        __typename?: "SiteConfig"
        createdAt?: string | null
        createdBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        scenario: {
          __typename?: "RevampScenario"
          pid: string
          name: string
          loadCategory: LoadCategory
          solarLocation: SolarLocation
          includeStorage: boolean
        }
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
        }
      } | null
      documents: Array<{
        __typename?: "Document"
        pid: string
        downloadHref: string
        fileName: string
        tag?: DocumentTag | null
      }>
      energyThings?: {
        __typename?: "EnergyThings"
        canRooftopSolar: boolean
        canCarportSolar?: boolean | null
        canGroundmountSolar?: boolean | null
        canStorage: boolean
      } | null
      financingThings?: {
        __typename?: "FinancingThings"
        canSelfInvest: boolean
        canLoan: boolean
        canPpa?: boolean | null
        canCommunitySolar?: boolean | null
      } | null
      physicalCheck: {
        __typename?: "PhysicalCheck"
        existingSolar?: boolean | null
        unobstructedFlatRoof?: boolean | null
        badRoof?: boolean | null
      }
      siteDetails: {
        __typename?: "SiteDetails"
        leaseApprovers: Array<string>
        externalLeaseApprovers?: Array<string> | null
        needsTenantApproval?: boolean | null
        roofRightsHolder?: RoofRightsHolder | null
        propertyLenders?: string | null
        propertyInsurer?: string | null
        constructionEmail?: string | null
        propertySiteVisitContacts?: Array<string> | null
        leasePropertyLegalDescription?: string | null
        leaseLegalOwnerName?: string | null
        signatureBlocks?: Array<string> | null
        isFannieMaeLender?: boolean | null
        isFmGlobalInsurer?: boolean | null
        roofReplacedYr?: number | null
        roofCondition?: string | null
        salePlans?: string | null
        buildingLegalName?: string | null
        propertyFundName?: string | null
        leaseSignatory?: string | null
        counselApproval?: CounselApproval | null
      }
      notes: Array<{ __typename?: "Note"; text: string }>
      buildingData?: {
        __typename?: "BuildingData"
        numStories?: number | null
        numUnits?: number | null
        yearBuilt?: number | null
        sqft?: number | null
        roofSqft?: number | null
        numParkingSpaces?: number | null
        occupancyRate?: number | null
        totalBuildings?: number | null
        yearRenovated?: number | null
        parentCompany?: string | null
        lastSalePrice?: number | null
        leedCertified?: string | null
        energyStar?: string | null
        buildingOpex?: string | null
        capRate?: number | null
      } | null
      footprint: {
        __typename?: "Footprint"
        latitude: number
        longitude: number
        bounds?: any | null
        obstructionShape?: any | null
        roofShape?: any | null
        roofShapeGeojson?: any | null
        roofShapeUpdatedAt?: string | null
        roofSetbackShape?: any | null
        roofSetbackShapeGeojson?: any | null
        roofSetbackShapeUpdatedAt?: string | null
        carportShape?: any | null
        carportShapeGeojson?: any | null
        carportShapeUpdatedAt?: string | null
        groundmountShape?: any | null
        groundmountShapeGeojson?: any | null
        groundmountShapeUpdatedAt?: string | null
        keepoutsShape?: any | null
        keepoutsShapeGeojson?: any | null
        keepoutsShapeUpdatedAt?: string | null
        roofShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        roofSetbackShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        carportShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        groundmountShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        keepoutsShapeUpdatedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      }
      thirdPartySupplier?: {
        __typename?: "ThirdPartySupplier"
        pid: string
        name: string
      } | null
      targetUtility?: {
        __typename?: "Utility"
        name: string
        pid: string
        id: number
        eiaGridEsc?: {
          __typename?: "EIAGridEsc"
          cagrBlended: number
          fromYear: number
          toYear: number
        } | null
        hostingCapacityMaps: Array<{
          __typename?: "HostingCapacityMap"
          url: string
          requiresLogin: boolean
          types: Array<HostingCapacityMapType>
        }>
      } | null
    }
    optOut?: {
      __typename: "InvestorOptOut"
      createdAt: string
      archivedAt?: string | null
      reason?: InvestorOptOutReason | null
      customReason?: string | null
      createdBy: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      }
      archivedBy?: {
        __typename?: "UserRef"
        pid: string
        email: string
        name?: string | null
        isAdmin: boolean
        avatarUrl?: string | null
      } | null
    } | null
    bids: Array<{
      __typename?: "InvestorBid"
      ppa?: {
        __typename: "PPAInvestorBid"
        pid: string
        name?: string | null
        termYears: number
        ppaPriceY1Usd: number
        ppaPriceEscalator: number
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedCod: string
        estimatedNtp: string
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        recOwner: RecOwner
        tariffProvision?: boolean | null
        otherNotes?: string | null
        extraPaymentsNotes?: string | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        status?: InvestorBidStatus | null
        spec?: { __typename?: "PPABidSpec"; pid: string } | null
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        system: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }
        result?: {
          __typename: "RevampFinmodel"
          id: number
          pid: string
          createdAt: string
          type: FinProductType
          intervalsAndCostsXlsxHref: string
          buildingOwnerXlsxHref?: string | null
          offerStatus: OfferStatus
          fmvStr: string
          totalPvProductionKwh: number
          totalPvExportKwh?: number | null
          bauCostPerYear: Array<number>
          derCostPerYear: Array<number>
          goal?: PVoptGoal | null
          isVnem: boolean
          isGreenLease: boolean
          thirdPartySupplier?: {
            __typename?: "ThirdPartySupplier"
            pid: string
            name: string
          } | null
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          ppa?: {
            __typename: "PPAEconomics"
            ppaType: PpaProductType
            ppaCostPerKwh: number
            ppaTermYears: number
            ppaEsc?: number | null
            srecToInvestor: boolean
            offtakerXlsxHref: string
            product: {
              __typename?: "PPAFinProduct"
              productName: string
              financierName: string
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              roofRentPerYear: Array<number>
            } | null
            tenantFlows?: {
              __typename?: "TenantCashflows"
              npv: number
              discountRate: number
              totalUtilitySavings: number
              totalCapex: number
              totalOpex: number
              totalNet: number
              netCashflowPerYear: Array<number>
            } | null
          } | null
          loan?: {
            __typename: "LoanEconomics"
            loanRecvrXlsxHref: string
            loanTermYears: number
            ownershipTermYears: number
            interestPct: number
            srecToInvestor: boolean
            product: {
              __typename?: "LoanFinProduct"
              productName: string
              financierName: string
              loanDealerFeePct: number
            }
            flows?: {
              __typename?: "LoanRecvrCashflows"
              monthlyPayment: number
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalLoanFunding: number
              totalLoanPayments: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          selfInvest?: {
            __typename: "SelfInvestEconomics"
            npv: number
            discountRate: number
            selfInvestXlsxHref: string
            termYears: number
            srecToInvestor: boolean
            irrs: {
              __typename?: "IRRs"
              postTaxItcDepr?: number | null
              postTaxItcDeprMultiple?: number | null
            }
            product: {
              __typename?: "SelfInvestFinProduct"
              productName: string
              financierName: string
            }
            flows?: {
              __typename?: "SelfInvestCashflows"
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          meters: Array<{
            __typename?: "RevampMeter"
            name: string
            loadCategory: LoadCategory
            meterSource: MeterSource
            bau: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
            }
            der?: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
              averageDayKwhFlow: Array<{
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }>
            } | null
          }>
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          utilityCosts: {
            __typename?: "UtilityCost"
            bau: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
            der: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
          }
        } | null
      } | null
      cs?: {
        __typename: "CSInvestorBid"
        pid: string
        name?: string | null
        termYears: number
        roofRentEscalator: number
        roofRentY1Usd: number
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedAwardDate?: string | null
        estimatedCod: string
        estimatedNtp: string
        recOwner: RecOwner
        tariffProvision?: boolean | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        extraPaymentsNotes?: string | null
        otherNotes?: string | null
        status?: InvestorBidStatus | null
        spec?: { __typename?: "CSBidSpec"; pid: string } | null
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        systemLite: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        }
        result?: {
          __typename: "RevampCS"
          id: number
          termYears: number
          createdAt: string
          goal?: PVoptGoal | null
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          financing: {
            __typename?: "RevampFinancing"
            id: number
            name: string
            type: FinProductType
            financierName: string
            financierPid: string
            financierLogo?: string | null
            financierLogomark?: string | null
            isThirdParty: boolean
          }
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            npv: number
            discountRate: number
            roofRentPerYear: Array<number>
          } | null
          pricing: {
            __typename?: "CSPrice"
            usdPerKwPerYear: number
            escalator: number
            minPvKw: number
            maxPvKw: number
            utility: { __typename?: "RevampUtility"; id: number; name: string }
          }
          leaseProjections?: {
            __typename?: "CSLeaseProjections"
            systemSizeKw: number
            annualRentLowerRangeUsd: number
            annualRentUpperRangeUsd: number
            methodology: CsLeaseProjectionMethdology
          } | null
        } | null
      } | null
    }>
    specs: Array<{
      __typename?: "BidSpec"
      ppa?: {
        __typename: "PPABidSpec"
        id: number
        pid: string
        name?: string | null
        termYears?: number | null
        note?: string | null
        archivedAt?: string | null
        ppaPriceY1Usd?: number | null
        ppaPriceEscalator?: number | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        itcPercentageAssumption?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        recOwner?: RecOwner | null
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        system?: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        } | null
      } | null
      cs?: {
        __typename: "CSBidSpec"
        id: number
        pid: string
        name?: string | null
        termYears?: number | null
        note?: string | null
        archivedAt?: string | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        itcPercentageAssumption?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        recOwner?: RecOwner | null
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
        systemLite?: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        } | null
      } | null
      optOut?: {
        __typename: "InvestorBidSpecOptOut"
        createdAt: string
        archivedAt?: string | null
        reason?: SpecOptOutReason | null
        customReason?: string | null
        createdBy: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        }
        archivedBy?: {
          __typename?: "UserRef"
          pid: string
          email: string
          name?: string | null
          isAdmin: boolean
          avatarUrl?: string | null
        } | null
      } | null
    }>
  } | null
}

export type GetTaskQueryVariables = Exact<{
  taskId: Scalars["Int"]["input"]
}>

export type GetTaskQuery = {
  __typename?: "Query"
  tasks: {
    __typename?: "PublicTaskQueries"
    one:
      | { __typename: "Error" }
      | { __typename: "Task"; id: number; name: string; status: Status }
  }
}

export type CsvImportDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  csvImportPid: Scalars["String"]["input"]
}>

export type CsvImportDetailQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    csvImports: {
      __typename?: "CsvImportQuery"
      one: {
        __typename?: "CsvImport"
        pid: string
        rawCsvWithPidsHref: string
        columnIds: Array<string>
        buildingTypes: Array<string>
        columnMappings: {
          __typename?: "ColumnMappings"
          assetManagerColumnId?: string | null
          buildingTypeColumnId?: string | null
          cityColumnId?: string | null
          customerIdColumnId?: string | null
          latitudeColumnId?: string | null
          longitudeColumnId?: string | null
          nameColumnId?: string | null
          numStoriesColumnId?: string | null
          numUnits1BdColumnId?: string | null
          numUnits2BdColumnId?: string | null
          numUnits3BdColumnId?: string | null
          numUnits4BdColumnId?: string | null
          numUnitsStudioColumnId?: string | null
          numUnitsTotalColumnId?: string | null
          sqftColumnId?: string | null
          stateColumnId?: string | null
          streetAddressColumnId?: string | null
          yearBuiltColumnId?: string | null
          zipCodeColumnId?: string | null
        }
        buildingTypeMappings: {
          __typename?: "BuildingTypeMappings"
          office: Array<string>
          multifamily: Array<string>
          hotel: Array<string>
          hospital: Array<string>
          outpatient: Array<string>
          retailStandalone: Array<string>
          retailStripMall: Array<string>
          quickServiceRestaurant: Array<string>
          fullServiceRestaurant: Array<string>
          primarySchool: Array<string>
          secondarySchool: Array<string>
          singleFamilyDetached: Array<string>
          warehouse: Array<string>
          dataCenter: Array<string>
          coldStorage: Array<string>
          industrial: Array<string>
          parkingLot: Array<string>
          supermarket: Array<string>
        }
        guessedSchema?: {
          __typename?: "CsvSchema"
          pid: string
          origin: SchemaOrigin
        } | null
        labels: Array<{
          __typename?: "SiteLabel"
          pid: string
          themeColor: LabelColor
          name: string
        }>
        rows: Array<{
          __typename?: "CsvImportRow"
          id: number
          droppedAt?: string | null
          buildingData?: {
            __typename?: "BuildingData"
            id: number
            propertyName?: string | null
            fullAddress: string
            streetAddress: string
            city: string
            state: string
            zipCode: string
            buildingType?: BuildingType | null
            sqft?: number | null
            roofSqft?: number | null
            numStories?: number | null
            latitude: number
            longitude: number
            buildingFootprintGeojson?: any | null
            yearBuilt?: number | null
            numUnitsTotal?: number | null
            numUnitsStudio?: number | null
            numUnits1Bd?: number | null
            numUnits2Bd?: number | null
            numUnits3Bd?: number | null
            numUnits4Bd?: number | null
          } | null
          amendments?: {
            __typename?: "BuildingDataAmendments"
            assetManager?: string | null
            buildingType?: BuildingType | null
            customerId?: string | null
            latitude?: number | null
            longitude?: number | null
            name?: string | null
            numStories?: number | null
            roofSqft?: number | null
            sqft?: number | null
            yearBuilt?: number | null
            mfUnits?: {
              __typename?: "CleanMultifamilyUnits"
              numUnitsTotal?: number | null
              numUnitsStudio?: number | null
              numUnits1Bd?: number | null
              numUnits2Bd?: number | null
              numUnits3Bd?: number | null
              numUnits4Bd?: number | null
            } | null
          } | null
          site?: { __typename?: "SiteRef"; pid: string } | null
          dirty: {
            __typename?: "DirtyRowData"
            name?: string | null
            assetManager?: string | null
            customerId?: string | null
            numStories?: string | null
            streetAddress?: string | null
            city?: string | null
            state?: string | null
            zipCode?: string | null
            buildingType?: string | null
            sqft?: string | null
            yearBuilt?: string | null
          }
          errors: Array<{
            __typename?: "RowValidationError"
            type: RowValidationErrorType
            message: string
          }>
          warnings: Array<{
            __typename?: "RowValidationWarning"
            type: RowValidationWarningType
            message: string
          }>
        }>
      }
    }
  } | null
}

export type MarketplacePackagesQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
}>

export type MarketplacePackagesQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    bidPackages: Array<{
      __typename?: "BidPackage"
      pid: string
      name: string
      biddingOpenAt?: string | null
      biddingClosedAt?: string | null
      state: BundleState
      type: FinProductType
      totalRows: number
      financiers: Array<{
        __typename?: "OrgRef"
        pid: string
        name: string
        orgSlug: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }>
    }>
  } | null
}

export type MarketplaceSpecsViewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy: BidSpecsTableFilter
  sortBy?: InputMaybe<Array<BidSpecsTableSort> | BidSpecsTableSort>
}>

export type MarketplaceSpecsViewQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageSpecs: {
      __typename?: "BidSpecsTable"
      view: { __typename?: "BidSpecsTableView"; keys: Array<string>; count: number }
    }
  } | null
}

export type MarketplaceSpecsRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  keys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type MarketplaceSpecsRowsQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageSpecs: {
      __typename?: "BidSpecsTable"
      rows: Array<{
        __typename?: "BidSpecsTableRow"
        pid: string
        sitePid: string
        bidName?: string | null
        bidPackagePid: string
        name?: string | null
        city: string
        state: string
        zipCode: string
        streetAddress: string
        county: string
        cbsaName?: string | null
        assetManager?: string | null
        packageRowStatus?: PackageRowStatus | null
        packageRowClosedAt?: string | null
        packageRowCloseReason?: PackageRowCloseReason | null
        packageRowCloseCustomReason?: string | null
        buildingType?: BuildingType | null
        yearBuilt?: number | null
        sqft?: number | null
        buildingFootprintSqft?: number | null
        roofSqft?: number | null
        usableRoofSqft?: number | null
        numStories?: number | null
        numUnitsTotal?: number | null
        buildingClass?: string | null
        roofReplacedYr?: number | null
        roofCondition?: string | null
        csRoofRentEscalator?: number | null
        ppaRoofRentEscalator?: number | null
        ppaPriceEscalator?: number | null
        csRoofRentY1Usd?: number | null
        ppaRoofRentY1Usd?: number | null
        ppaPriceY1Usd?: number | null
        ppaTermYears?: number | null
        csTermYears?: number | null
        csSystem?: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        } | null
        ppaSystem?: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        } | null
      }>
    }
  } | null
}

export type MarketplaceSitesViewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy: BidPackageSitesTableFilter
  sortBy?: InputMaybe<Array<BidPackageSitesTableSort> | BidPackageSitesTableSort>
}>

export type MarketplaceSitesViewQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageSites: {
      __typename?: "BidPackageSitesTable"
      view: {
        __typename?: "BidPackageSitesTableView"
        keys: Array<number>
        count: number
      }
    }
  } | null
}

export type MarketplaceSitesFacetsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy: BidPackageSitesTableFilter
}>

export type MarketplaceSitesFacetsQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageSites: {
      __typename?: "BidPackageSitesTable"
      view: {
        __typename?: "BidPackageSitesTableView"
        stats: {
          __typename?: "BidPackageSitesTableStats"
          awardedFinanciers: Array<string>
        }
      }
    }
  } | null
}

export type MarketplaceSitesRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type MarketplaceSitesRowsQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageSites: {
      __typename?: "BidPackageSitesTable"
      rows: Array<{
        __typename?: "BidPackageSitesTableRow"
        id: number
        sitePid: string
        bidPackagePid: string
        bidPackageName: string
        name?: string | null
        city: string
        state: string
        zipCode: string
        streetAddress: string
        county: string
        cbsaName?: string | null
        assetManager?: string | null
        packageRowStatus?: PackageRowStatus | null
        packageRowIsClosed: boolean
        packageRowClosedAt?: string | null
        packageRowCloseReason?: PackageRowCloseReason | null
        packageRowCloseCustomReason?: string | null
        buildingType?: BuildingType | null
        yearBuilt?: number | null
        sqft?: number | null
        buildingFootprintSqft?: number | null
        roofSqft?: number | null
        usableRoofSqft?: number | null
        numStories?: number | null
        numUnitsTotal?: number | null
        buildingClass?: string | null
        roofReplacedYr?: number | null
        roofCondition?: string | null
        salePlans?: string | null
        buildingLegalName?: string | null
        propertyFundName?: string | null
        leaseSignatory?: string | null
        counselApproval?: CounselApproval | null
        leaseApprovers?: Array<string> | null
        externalLeaseApprovers?: Array<string> | null
        needsTenantApproval?: boolean | null
        roofRightsHolder?: RoofRightsHolder | null
        propertyLenders?: string | null
        propertyInsurer?: string | null
        constructionEmail?: string | null
        propertySiteVisitContacts?: Array<string> | null
        leasePropertyLegalDescription?: string | null
        leaseLegalOwnerName?: string | null
        signatureBlocks?: Array<string> | null
        isFannieMaeLender?: boolean | null
        isFmGlobalInsurer?: boolean | null
        financierCount?: number | null
        bidCount?: number | null
        ppaNoiMin?: number | null
        ppaNoiAvg?: number | null
        ppaNoiMax?: number | null
        csNoiMin?: number | null
        csNoiAvg?: number | null
        csNoiMax?: number | null
        awardedDeveloper?: string | null
        awardedBidPvSizeKwDc?: number | null
        awardedBidPvSizeKwAc?: number | null
        awardedBidPvTypes?: Array<PvType> | null
        csEstimatedAwardDate?: string | null
        estimatedNtp?: string | null
        estimatedCod?: string | null
        csNpv?: number | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        noiLifetimeUsd?: number | null
        financingType: FinProductType
        targetUtility?: { __typename?: "Utility"; pid: string; name: string } | null
      }>
    }
  } | null
}

export type MarketplaceBidsViewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy: InvestorBidsTableFilter
  sortBy?: InputMaybe<Array<InvestorBidsTableSort> | InvestorBidsTableSort>
}>

export type MarketplaceBidsViewQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageBids: {
      __typename?: "InvestorBidsTable"
      view: { __typename?: "InvestorBidsTableView"; keys: Array<string>; count: number }
    }
  } | null
}

export type MarketplaceBidsFacetsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy: InvestorBidsTableFilter
}>

export type MarketplaceBidsFacetsQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageBids: {
      __typename?: "InvestorBidsTable"
      view: {
        __typename?: "InvestorBidsTableView"
        stats: {
          __typename?: "InvestorBidsTableStats"
          financiers: Array<string>
          siteNames: Array<string>
          siteStates: Array<string>
          siteStreetAddresses: Array<string>
        }
      }
    }
  } | null
}

export type MarketplaceBidsRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  keys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"]
}>

export type MarketplaceBidsRowsQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackageBids: {
      __typename?: "InvestorBidsTable"
      rows: Array<{
        __typename?: "InvestorBidsTableRow"
        pid: string
        bidName?: string | null
        sitePid: string
        bundleRowPid: string
        bundleParentPid: string
        name?: string | null
        streetAddress: string
        city: string
        state: string
        zipCode: string
        latitude: number
        longitude: number
        county: string
        cbsaName?: string | null
        assetManager?: string | null
        packageRowIsClosed: boolean
        packageRowStatus?: PackageRowStatus | null
        packageRowClosedAt?: string | null
        packageRowCloseReason?: PackageRowCloseReason | null
        packageRowCloseCustomReason?: string | null
        isAwardedBid?: boolean | null
        isRecommendedBid?: boolean | null
        bidPackagePid: string
        bidPackageName: string
        biddingOpenAt?: string | null
        biddingClosedAt?: string | null
        termYears: number
        type: FinProductType
        recOwner: RecOwner
        csEstimatedAwardDate?: string | null
        estimatedCod: string
        estimatedNtp: string
        tariffProvision?: boolean | null
        itcPercentageAssumption: number
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        extraPaymentsNotes?: string | null
        incentivesNotes?: string | null
        otherNotes?: string | null
        csRoofRentEscalator?: number | null
        csRoofRentY1Usd?: number | null
        csBuildingOwnerNoiLifetimeUsd?: number | null
        csRoofRentNpv?: number | null
        ppaRoofRentEscalator?: number | null
        ppaRoofRentY1Usd?: number | null
        ppaPriceEscalator?: number | null
        ppaPriceY1Usd?: number | null
        financierPid: string
        financierName: string
        financierLogoUrl: string
        financierLogomarkUrl?: string | null
        ppaBuildingOwnerNoiLifetimeUsd?: number | null
        ppaOfftakerLifetimeSavingsUsd?: number | null
        ppaYearOneOfftakerSavingsUsd?: number | null
        ppaYearOneRoofRentalFee?: number | null
        csSystem?: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        } | null
        ppaSystem?: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        } | null
      }>
    }
  } | null
}

export type MarketplacePackageDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
}>

export type MarketplacePackageDetailQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackage?: {
      __typename?: "BidPackage"
      pid: string
      name: string
      biddingOpenAt?: string | null
      biddingClosedAt?: string | null
      state: BundleState
      type: FinProductType
      totalRows: number
      documents: Array<{
        __typename?: "Document"
        canDelete: boolean
        contentType: string
        dateCreated: string
        fileName: string
        ownerName: string
        pid: string
        tag?: DocumentTag | null
        downloadHref: string
        belongsToBundleParent: boolean
      }>
      financiers: Array<{
        __typename?: "OrgRef"
        pid: string
        name: string
        orgSlug: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }>
    } | null
  } | null
}

export type MarketplacePackageBidReviewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
}>

export type MarketplacePackageBidReviewQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackage?: {
      __typename?: "BidPackage"
      bidReview?: {
        __typename?: "BidReview"
        recommendedBidPids: Array<string>
        reports: Array<{
          __typename?: "BidReviewReportStats"
          properties: number
          bidders: number
          uniqueBids: number
          avgRoofRentY1Usd: number
          isCustom: boolean
          report: {
            __typename?: "PackageBidReport"
            pid?: string | null
            name?: string | null
            notes?: string | null
            visible: boolean
            totalDevelopers: number
            totalBids: number
            cs?: Array<{
              __typename: "CSSiteBidReport"
              awarded: boolean
              awardedPid?: string | null
              totalBids: number
              site: {
                __typename?: "RevampSite"
                pid: string
                name?: string | null
                isFavorite: boolean
                streetAddress: string
                city: string
                state: string
                zipCode: string
                county: string
                fullAddress: string
              }
              bids: Array<{
                __typename: "CSInvestorBid"
                name?: string | null
                pid: string
                termYears: number
                roofRentEscalator: number
                roofRentY1Usd: number
                buildingOwnerExtraPaymentsUsd?: Array<number> | null
                interconnectionCostUsdPerWatt?: number | null
                interconnectionCostUtilityMinUsd?: number | null
                interconnectionCostUtilityMaxUsd?: number | null
                interconnectionCostNonUtilityUsd?: number | null
                itcPercentageAssumption: number
                estimatedAwardDate?: string | null
                estimatedCod: string
                estimatedNtp: string
                recOwner: RecOwner
                tariffProvision?: boolean | null
                incentivesNotes?: string | null
                interconnectionNotes?: string | null
                interconnectionRepriceProcessNotes?: string | null
                extraPaymentsNotes?: string | null
                otherNotes?: string | null
                financier: {
                  __typename?: "OrgRef"
                  pid: string
                  name: string
                  logoUrl: string
                  logomarkUrl?: string | null
                  profile?: {
                    __typename?: "InvestorProfile"
                    hq?: string | null
                    yearFounded?: number | null
                    website?: string | null
                    description?: string | null
                    committedFunding?: string | null
                    distinguishingFeatures?: string | null
                    investorBacking?: string | null
                    managementTeam: Array<string>
                    longTermOwnershipApproach?: string | null
                    subscriptionMgmtApproach?: string | null
                    experiences: Array<{
                      __typename?: "Experience"
                      state?: UsState | null
                      ftmEnergizedPvKw?: number | null
                      ftmAwardedPvKw?: number | null
                      btmEnergizedPvKw?: number | null
                      btmAwardedPvKw?: number | null
                    }>
                    buyBoxes: Array<{
                      __typename?: "BuyBox"
                      state?: UsState | null
                      ftmMinPortfolioSize?: number | null
                      ftmMinProjectSize?: number | null
                      ftmSeekingProjects?: boolean | null
                      btmMinPortfolioSize?: number | null
                      btmMinProjectSize?: number | null
                      btmSeekingProjects?: boolean | null
                    }>
                  } | null
                }
                result?: {
                  __typename?: "RevampCS"
                  buildingOwner: {
                    __typename?: "BuildingOwnerEconomics"
                    noiLifetime?: number | null
                  }
                } | null
              }>
              noi?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              y1RoofRent?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              systemSize?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              itcPercentageAssumption?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              roofRentEscalator?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              npv?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
            }> | null
            ppa?: Array<{
              __typename: "PPASiteBidReport"
              awarded: boolean
              awardedPid?: string | null
              totalBids: number
              site: {
                __typename?: "RevampSite"
                pid: string
                name?: string | null
                isFavorite: boolean
                streetAddress: string
                city: string
                state: string
                zipCode: string
                county: string
                fullAddress: string
              }
              bids: Array<{
                __typename: "PPAInvestorBid"
                name?: string | null
                pid: string
                termYears: number
                roofRentEscalator?: number | null
                roofRentY1Usd?: number | null
                buildingOwnerExtraPaymentsUsd?: Array<number> | null
                interconnectionCostUsdPerWatt?: number | null
                interconnectionCostUtilityMinUsd?: number | null
                interconnectionCostUtilityMaxUsd?: number | null
                interconnectionCostNonUtilityUsd?: number | null
                itcPercentageAssumption: number
                estimatedCod: string
                estimatedNtp: string
                recOwner: RecOwner
                tariffProvision?: boolean | null
                incentivesNotes?: string | null
                interconnectionNotes?: string | null
                interconnectionRepriceProcessNotes?: string | null
                extraPaymentsNotes?: string | null
                otherNotes?: string | null
                financier: {
                  __typename?: "OrgRef"
                  pid: string
                  name: string
                  logoUrl: string
                  logomarkUrl?: string | null
                  profile?: {
                    __typename?: "InvestorProfile"
                    hq?: string | null
                    yearFounded?: number | null
                    website?: string | null
                    description?: string | null
                    committedFunding?: string | null
                    distinguishingFeatures?: string | null
                    investorBacking?: string | null
                    managementTeam: Array<string>
                    longTermOwnershipApproach?: string | null
                    subscriptionMgmtApproach?: string | null
                    experiences: Array<{
                      __typename?: "Experience"
                      state?: UsState | null
                      ftmEnergizedPvKw?: number | null
                      ftmAwardedPvKw?: number | null
                      btmEnergizedPvKw?: number | null
                      btmAwardedPvKw?: number | null
                    }>
                    buyBoxes: Array<{
                      __typename?: "BuyBox"
                      state?: UsState | null
                      ftmMinPortfolioSize?: number | null
                      ftmMinProjectSize?: number | null
                      ftmSeekingProjects?: boolean | null
                      btmMinPortfolioSize?: number | null
                      btmMinProjectSize?: number | null
                      btmSeekingProjects?: boolean | null
                    }>
                  } | null
                }
                result?: {
                  __typename?: "RevampFinmodel"
                  buildingOwner: {
                    __typename?: "BuildingOwnerEconomics"
                    noiLifetime?: number | null
                  }
                } | null
              }>
              noi?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              y1RoofRent?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              systemSize?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              itcPercentageAssumption?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              ppaPriceEscalator?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
              npv?: {
                __typename?: "BoxplotStats"
                min: number
                q1: number
                median: number
                q3: number
                max: number
                average: number
              } | null
            }> | null
          }
        }>
      } | null
    } | null
  } | null
}

export type MarketplacePackageRowDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bundlePid: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type MarketplacePackageRowDetailQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bidPackage?: {
      __typename?: "BidPackage"
      pid: string
      name: string
      biddingOpenAt?: string | null
      biddingClosedAt?: string | null
      state: BundleState
      type: FinProductType
      totalRows: number
      row?: {
        __typename?: "BidPackageRow"
        status?: PackageRowStatus | null
        closedAt?: string | null
        closeReason?: PackageRowCloseReason | null
        closeCustomReason?: string | null
        site?: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          isFavorite: boolean
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
          doeReferenceType?: BuildingType | null
          yearBuilt?: number | null
          sqft?: number | null
          numStories?: number | null
          buildingClass?: string | null
          roofSqft?: number | null
          roofMaxPvKw: number
          targetUtility?: { __typename?: "Utility"; name: string } | null
          siteDetails: {
            __typename?: "SiteDetails"
            roofReplacedYr?: number | null
            roofCondition?: string | null
          }
          meterSet?: {
            __typename?: "MeterSet"
            loadKwh?: number | null
            totalCost: number
          } | null
        } | null
      } | null
      documents: Array<{
        __typename?: "Document"
        canDelete: boolean
        contentType: string
        dateCreated: string
        fileName: string
        ownerName: string
        pid: string
        tag?: DocumentTag | null
        downloadHref: string
        belongsToBundleParent: boolean
      }>
      financiers: Array<{
        __typename?: "OrgRef"
        pid: string
        name: string
        orgSlug: string
        logoUrl: string
        logomarkUrl?: string | null
        profile?: {
          __typename?: "InvestorProfile"
          hq?: string | null
          yearFounded?: number | null
          website?: string | null
          description?: string | null
          committedFunding?: string | null
          distinguishingFeatures?: string | null
          investorBacking?: string | null
          managementTeam: Array<string>
          longTermOwnershipApproach?: string | null
          subscriptionMgmtApproach?: string | null
          experiences: Array<{
            __typename?: "Experience"
            state?: UsState | null
            ftmEnergizedPvKw?: number | null
            ftmAwardedPvKw?: number | null
            btmEnergizedPvKw?: number | null
            btmAwardedPvKw?: number | null
          }>
          buyBoxes: Array<{
            __typename?: "BuyBox"
            state?: UsState | null
            ftmMinPortfolioSize?: number | null
            ftmMinProjectSize?: number | null
            ftmSeekingProjects?: boolean | null
            btmMinPortfolioSize?: number | null
            btmMinProjectSize?: number | null
            btmSeekingProjects?: boolean | null
          }>
        } | null
      }>
    } | null
  } | null
}

export type MarketplaceBidDetailQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  bidPid: Scalars["String"]["input"]
}>

export type MarketplaceBidDetailQuery = {
  __typename?: "Query"
  org?: {
    __typename?: "Org"
    bid?: {
      __typename?: "InvestorBid"
      ppa?: {
        __typename: "PPAInvestorBid"
        pid: string
        name?: string | null
        termYears: number
        ppaPriceY1Usd: number
        ppaPriceEscalator: number
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedCod: string
        estimatedNtp: string
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        recOwner: RecOwner
        tariffProvision?: boolean | null
        otherNotes?: string | null
        extraPaymentsNotes?: string | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        status?: InvestorBidStatus | null
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
          assetManager?: string | null
          doeReferenceType?: BuildingType | null
          yearBuilt?: number | null
          numStories?: number | null
          sqft?: number | null
          roofSqft?: number | null
          roofMaxPvKw: number
          buildingClass?: string | null
          ppaType?: PpaProductType | null
          meterSet?: {
            __typename?: "MeterSet"
            totalCost: number
            loadKwh?: number | null
          } | null
          siteDetails: {
            __typename?: "SiteDetails"
            salePlans?: string | null
            roofCondition?: string | null
            roofReplacedYr?: number | null
          }
          targetUtility?: {
            __typename?: "Utility"
            name: string
            pid: string
            id: number
          } | null
        }
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          orgSlug: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        spec?: { __typename?: "PPABidSpec"; pid: string } | null
        system: {
          __typename?: "System"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpec"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes?: string | null
            etbMeterName: string
            document?: {
              __typename?: "Document"
              id: number
              pid: string
              fileName: string
              downloadHref: string
            } | null
            meter: {
              __typename?: "BillingMeter"
              pid: string
              view: { __typename?: "BillingMeterView"; name: string }
            }
          }>
        }
        result?: {
          __typename: "RevampFinmodel"
          id: number
          pid: string
          createdAt: string
          type: FinProductType
          intervalsAndCostsXlsxHref: string
          buildingOwnerXlsxHref?: string | null
          offerStatus: OfferStatus
          fmvStr: string
          totalPvProductionKwh: number
          totalPvExportKwh?: number | null
          bauCostPerYear: Array<number>
          derCostPerYear: Array<number>
          goal?: PVoptGoal | null
          isVnem: boolean
          isGreenLease: boolean
          thirdPartySupplier?: {
            __typename?: "ThirdPartySupplier"
            pid: string
            name: string
          } | null
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          ppa?: {
            __typename: "PPAEconomics"
            ppaType: PpaProductType
            ppaCostPerKwh: number
            ppaTermYears: number
            ppaEsc?: number | null
            srecToInvestor: boolean
            offtakerXlsxHref: string
            product: {
              __typename?: "PPAFinProduct"
              productName: string
              financierName: string
            }
            roofRent?: {
              __typename?: "RoofRentEconomics"
              lifetimeUsd: number
              annualUsd: number
              usdPerSqft: number
              roofRentPerYear: Array<number>
            } | null
            tenantFlows?: {
              __typename?: "TenantCashflows"
              npv: number
              discountRate: number
              totalUtilitySavings: number
              totalCapex: number
              totalOpex: number
              totalNet: number
              netCashflowPerYear: Array<number>
            } | null
          } | null
          loan?: {
            __typename: "LoanEconomics"
            loanRecvrXlsxHref: string
            loanTermYears: number
            ownershipTermYears: number
            interestPct: number
            srecToInvestor: boolean
            product: {
              __typename?: "LoanFinProduct"
              productName: string
              financierName: string
              loanDealerFeePct: number
            }
            flows?: {
              __typename?: "LoanRecvrCashflows"
              monthlyPayment: number
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalLoanFunding: number
              totalLoanPayments: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          selfInvest?: {
            __typename: "SelfInvestEconomics"
            npv: number
            discountRate: number
            selfInvestXlsxHref: string
            termYears: number
            srecToInvestor: boolean
            irrs: {
              __typename?: "IRRs"
              postTaxItcDepr?: number | null
              postTaxItcDeprMultiple?: number | null
            }
            product: {
              __typename?: "SelfInvestFinProduct"
              productName: string
              financierName: string
            }
            flows?: {
              __typename?: "SelfInvestCashflows"
              totalRevenue: number
              totalUtilitySavings: number
              totalOpex: number
              totalCapex: number
              totalItc: number
              totalNet: number
              netCashflowPerYear: Array<number>
              greenLeaseTenantFlows?: {
                __typename?: "TenantCashflows"
                totalNet: number
                netCashflowPerYear: Array<number>
                totalCapex: number
                totalOpex: number
                totalUtilitySavings: number
                npv: number
                discountRate: number
              } | null
            } | null
          } | null
          meters: Array<{
            __typename?: "RevampMeter"
            name: string
            loadCategory: LoadCategory
            meterSource: MeterSource
            bau: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
            }
            der?: {
              __typename?: "RevampDer"
              totalKwhFlow: {
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }
              averageDayKwhFlow: Array<{
                __typename?: "KwhFlow"
                bauLoadKwh: number
                importsKwh: number
                exportsKwh: number
                pvProductionKwh: number
                pvToLoadKwh: number
                batteryChargeKwh: number
                batteryDischargeKwh: number
              }>
            } | null
          }>
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          utilityCosts: {
            __typename?: "UtilityCost"
            bau: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
            der: {
              __typename?: "FinmodelCost"
              totalKwh: number
              totalCostUsd: number
              usdPerKwh: number
              items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
              tariffs: Array<{
                __typename?: "RevampTariff"
                id: number
                name: string
                code: string
                startDate: string
                endDate?: string | null
                utility: {
                  __typename?: "RevampUtility"
                  id: number
                  name: string
                  shortName: string
                }
              }>
            }
          }
        } | null
      } | null
      cs?: {
        __typename: "CSInvestorBid"
        pid: string
        name?: string | null
        termYears: number
        roofRentEscalator: number
        roofRentY1Usd: number
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        itcPercentageAssumption: number
        estimatedAwardDate?: string | null
        estimatedCod: string
        estimatedNtp: string
        recOwner: RecOwner
        tariffProvision?: boolean | null
        incentivesNotes?: string | null
        interconnectionNotes?: string | null
        interconnectionRepriceProcessNotes?: string | null
        extraPaymentsNotes?: string | null
        otherNotes?: string | null
        status?: InvestorBidStatus | null
        site: {
          __typename?: "RevampSite"
          pid: string
          name?: string | null
          streetAddress: string
          city: string
          state: string
          zipCode: string
          county: string
          fullAddress: string
          assetManager?: string | null
          doeReferenceType?: BuildingType | null
          yearBuilt?: number | null
          numStories?: number | null
          sqft?: number | null
          roofSqft?: number | null
          roofMaxPvKw: number
          buildingClass?: string | null
          ppaType?: PpaProductType | null
          meterSet?: {
            __typename?: "MeterSet"
            totalCost: number
            loadKwh?: number | null
          } | null
          siteDetails: {
            __typename?: "SiteDetails"
            salePlans?: string | null
            roofCondition?: string | null
            roofReplacedYr?: number | null
          }
          targetUtility?: {
            __typename?: "Utility"
            name: string
            pid: string
            id: number
          } | null
        }
        financier: {
          __typename?: "OrgRef"
          pid: string
          name: string
          orgSlug: string
          logoUrl: string
          logomarkUrl?: string | null
          profile?: {
            __typename?: "InvestorProfile"
            hq?: string | null
            yearFounded?: number | null
            website?: string | null
            description?: string | null
            committedFunding?: string | null
            distinguishingFeatures?: string | null
            investorBacking?: string | null
            managementTeam: Array<string>
            longTermOwnershipApproach?: string | null
            subscriptionMgmtApproach?: string | null
            experiences: Array<{
              __typename?: "Experience"
              state?: UsState | null
              ftmEnergizedPvKw?: number | null
              ftmAwardedPvKw?: number | null
              btmEnergizedPvKw?: number | null
              btmAwardedPvKw?: number | null
            }>
            buyBoxes: Array<{
              __typename?: "BuyBox"
              state?: UsState | null
              ftmMinPortfolioSize?: number | null
              ftmMinProjectSize?: number | null
              ftmSeekingProjects?: boolean | null
              btmMinPortfolioSize?: number | null
              btmMinProjectSize?: number | null
              btmSeekingProjects?: boolean | null
            }>
          } | null
        }
        spec?: { __typename?: "CSBidSpec"; pid: string } | null
        systemLite: {
          __typename?: "SystemLite"
          id: number
          pid: string
          createdAt: string
          totalPvSizeKw: number
          pvSpecs: Array<{
            __typename?: "PVSpec"
            id: number
            createdAt: string
            pvTypes: Array<PvType>
            sizeKwDc: number
            sizeKwAc?: number | null
            helioscope2Id?: number | null
            etbMeterId?: number | null
            helioscopePdf?: { __typename?: "Document"; downloadHref: string } | null
            roofImage?: { __typename?: "Document"; viewHref: string } | null
            productionCsv?: { __typename?: "Document"; downloadHref: string } | null
            productionSource?: {
              __typename?: "PVProductionSource"
              id: number
              origin: ProductionOrigin
            } | null
            allocations: Array<{
              __typename?: "PVAllocation"
              id: number
              createdAt: string
              percentage: number
              meter: {
                __typename?: "BillingMeter"
                pid: string
                view: { __typename?: "BillingMeterView"; name: string }
              }
            }>
          }>
          batterySpecs: Array<{
            __typename?: "BatterySpecLite"
            id: number
            sizeKwh: number
            sizeKwDc: number
            notes: string
          }>
        }
        result?: {
          __typename: "RevampCS"
          id: number
          termYears: number
          createdAt: string
          goal?: PVoptGoal | null
          systems: Array<
            | {
                __typename: "BatterySystem"
                vendor: BatteryVendor
                sizeKw: number
                sizeKwh: number
                assumptions: { __typename?: "BattAssumptions"; battChemName: string }
              }
            | { __typename: "PVSystem"; type: PvType; sizeKw: number }
          >
          financing: {
            __typename?: "RevampFinancing"
            id: number
            name: string
            type: FinProductType
            financierName: string
            financierPid: string
            financierLogo?: string | null
            financierLogomark?: string | null
            isThirdParty: boolean
          }
          buildingOwner: {
            __typename?: "BuildingOwnerEconomics"
            noiYearOne?: number | null
            noiLifetime?: number | null
            noiAnnual?: number | null
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            npv: number
            discountRate: number
            roofRentPerYear: Array<number>
          } | null
          pricing: {
            __typename?: "CSPrice"
            usdPerKwPerYear: number
            escalator: number
            minPvKw: number
            maxPvKw: number
            utility: { __typename?: "RevampUtility"; id: number; name: string }
          }
          leaseProjections?: {
            __typename?: "CSLeaseProjections"
            systemSizeKw: number
            annualRentLowerRangeUsd: number
            annualRentUpperRangeUsd: number
            methodology: CsLeaseProjectionMethdology
          } | null
        } | null
      } | null
    } | null
  } | null
}

export type CurrentUserGoogleAccessQueryVariables = Exact<{ [key: string]: never }>

export type CurrentUserGoogleAccessQuery = {
  __typename?: "Query"
  currentUser: {
    __typename?: "AuthUser"
    pid?: string | null
    hasGoogleAccessToken: boolean
  }
}

export type AwardedProjectsTableViewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy?: InputMaybe<AwardedProjectTableFilter>
  sortBy?: InputMaybe<Array<AwardedProjectTableSort> | AwardedProjectTableSort>
}>

export type AwardedProjectsTableViewQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    awardedProjects: {
      __typename?: "AwardedProjectTable"
      view: {
        __typename?: "AwardedProjectTableView"
        keys: Array<number>
        count: number
        stats: {
          __typename?: "AwardedProjectTableStats"
          buildingOwners: Array<string>
        }
      }
    }
  } | null
}

export type AwardedProjectsTableRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type AwardedProjectsTableRowsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    awardedProjects: {
      __typename?: "AwardedProjectTable"
      rows: Array<{
        __typename?: "AwardedProjectTableRow"
        id: number
        orgName: string
        sitePid: string
        name?: string | null
        streetAddress: string
        city: string
        state: string
        zipCode: string
        bundlePid: string
        bidPackagePid: string
        packageRowStatus?: PackageRowStatus | null
        packageRowIsClosed: boolean
        packageRowClosedAt?: string | null
        packageRowCloseReason?: PackageRowCloseReason | null
        packageRowCloseCustomReason?: string | null
        estimatedCod: string
        estimatedNtp: string
        lumenRevenue?: number | null
        csEstimatedAwardDate?: string | null
        pvSizeKwDc?: number | null
        pvSizeKwAc?: number | null
        pvTypes: Array<PvType>
        rofoSignedDate?: string | null
        rofoSignedEstimated?: string | null
        rofoSignedActual?: string | null
        preBidMeetingDate?: string | null
        preBidMeetingEstimated?: string | null
        preBidMeetingActual?: string | null
        biddingOpenedDate?: string | null
        biddingOpenedEstimated?: string | null
        biddingOpenedActual?: string | null
        biddingClosedDate?: string | null
        biddingClosedEstimated?: string | null
        biddingClosedActual?: string | null
        bidsPresentedDate?: string | null
        bidsPresentedEstimated?: string | null
        bidsPresentedActual?: string | null
        ixSubmittedDate?: string | null
        ixSubmittedEstimated?: string | null
        ixSubmittedActual?: string | null
        ixApprovedDate?: string | null
        ixApprovedEstimated?: string | null
        ixApprovedActual?: string | null
        csProgramSubmittedDate?: string | null
        csProgramSubmittedEstimated?: string | null
        csProgramSubmittedActual?: string | null
        csProgramApprovedDate?: string | null
        csProgramApprovedEstimated?: string | null
        csProgramApprovedActual?: string | null
        awardedToDeveloperDate?: string | null
        awardedToDeveloperEstimated?: string | null
        awardedToDeveloperActual?: string | null
        leaseSignedDate?: string | null
        leaseSignedEstimated?: string | null
        leaseSignedActual?: string | null
        ntpDate?: string | null
        ntpEstimated?: string | null
        ntpActual?: string | null
        codDate?: string | null
        codEstimated?: string | null
        codActual?: string | null
      }>
    }
  } | null
}

export type FinancierProjectsTableViewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  filterBy?: InputMaybe<FinancierProjectTableFilter>
  sortBy?: InputMaybe<Array<FinancierProjectTableSort> | FinancierProjectTableSort>
}>

export type FinancierProjectsTableViewQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    pid: string
    financierProjects: {
      __typename?: "FinancierProjectTable"
      view: {
        __typename?: "FinancierProjectTableView"
        keys: Array<number>
        count: number
        stats: {
          __typename?: "FinancierProjectTableStats"
          buildingOwners: Array<string>
        }
      }
    }
  } | null
}

export type FinancierProjectsTableRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type FinancierProjectsTableRowsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    financierProjects: {
      __typename?: "FinancierProjectTable"
      rows: Array<{
        __typename?: "FinancierProjectTableRow"
        id: number
        sitePid: string
        bundlePid: string
        orgName: string
        name?: string | null
        streetAddress: string
        city: string
        state: string
        zipCode: string
        bundleName: string
        bundleType: FinProductType
        bundleBiddingOpenAt?: string | null
        bundleBiddingClosedAt?: string | null
        bundleRowState?: BundleState | null
        bundleRowIsClosed: boolean
        bundleRowCloseReason?: CloseReason | null
        bundleRowCloseCustomReason?: string | null
        bidStatuses: Array<InvestorBidStatus>
        optedOut: boolean
      }>
    }
  } | null
}

export type SiteBidsTableViewQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  filterBy?: InputMaybe<SiteBidsTableFilter>
  sortBy?: InputMaybe<Array<SiteBidsTableSort> | SiteBidsTableSort>
}>

export type SiteBidsTableViewQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    siteBids: {
      __typename?: "SiteBidsTable"
      view: { __typename?: "SiteBidsTableView"; keys: Array<number>; count: number }
    }
  } | null
}

export type SiteBidsTableRowsQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
  keys: Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
}>

export type SiteBidsTableRowsQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    siteBids: {
      __typename?: "SiteBidsTable"
      rows: Array<{
        __typename?: "SiteBidsTableRow"
        id: number
        bidPackagePid: string
        bundlePid: string
        bidPackageName: string
        name?: string | null
        isAwarded: boolean
        isCustom: boolean
        packageRowStatus?: PackageRowStatus | null
        packageRowIsClosed: boolean
        packageRowClosedAt?: string | null
        packageRowCloseReason?: PackageRowCloseReason | null
        packageRowCloseCustomReason?: string | null
        estimatedCod: string
        estimatedNtp: string
        csEstimatedAwardDate?: string | null
        pvSizeKwDc?: number | null
        pvSizeKwAc?: number | null
        pvTypes: Array<PvType>
        termYears?: number | null
        roofRentY1Usd?: number | null
        roofRentEscalator?: number | null
        buildingOwnerExtraPaymentsUsd?: Array<number> | null
        extraPaymentsNotes?: string | null
        buildingOwnerNoiLifetimeUsd?: number | null
        interconnectionCostUtilityMaxUsd?: number | null
        interconnectionCostUtilityMinUsd?: number | null
        interconnectionCostNonUtilityUsd?: number | null
        interconnectionCostUsdPerWatt?: number | null
        interconnectionNotes?: string | null
        itcPercentageAssumption: number
        recOwner: RecOwner
        incentivesNotes?: string | null
        otherNotes?: string | null
      }>
    }
  } | null
}

export type SiteFieldChangeLogQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  sitePid: Scalars["String"]["input"]
}>

export type SiteFieldChangeLogQuery = {
  __typename?: "Query"
  orgBySlug?: {
    __typename?: "Org"
    slug: string
    name: string
    pid: string
    site?: {
      __typename?: "RevampSite"
      pid: string
      fieldHistory: {
        __typename?: "SiteFieldChangeLog"
        occupancyType: {
          __typename?: "FieldChangeLogHistory"
          latest?: {
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          } | null
          history: Array<{
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          }>
        }
        leaseType: {
          __typename?: "FieldChangeLogHistory"
          latest?: {
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          } | null
          history: Array<{
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          }>
        }
        targetUtilityId: {
          __typename?: "FieldChangeLogHistory"
          latest?: {
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          } | null
          history: Array<{
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          }>
        }
        tenantLeaseTerm: {
          __typename?: "FieldChangeLogHistory"
          latest?: {
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          } | null
          history: Array<{
            __typename?: "ChangeLogEntry"
            source?: ChangeSourceType | null
            sourceId?: string | null
            oldValue?: any | null
            newValue?: any | null
            columnType: ChangelogType
            changedAt: string
          }>
        }
      }
      siteDetails: {
        __typename?: "SiteDetails"
        fieldHistory?: {
          __typename?: "SiteDetailsFieldChangeLog"
          buildingLegalName: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          constructionEmail: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          counselApproval: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          externalLeaseApprovers: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          isFannieMaeLender: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          isFmGlobalInsurer: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          leaseApprovers: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          leaseLegalOwnerName: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          leasePropertyLegalDescription: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          leaseSignatory: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          needsTenantApproval: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          propertyFundName: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          propertyInsurer: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          propertyLenders: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          propertySiteVisitContacts: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          roofCondition: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          roofReplacedYr: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          roofRightsHolder: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          salePlannedYear: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          salePlans: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
          signatureBlocks: {
            __typename?: "FieldChangeLogHistory"
            latest?: {
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            } | null
            history: Array<{
              __typename?: "ChangeLogEntry"
              source?: ChangeSourceType | null
              sourceId?: string | null
              oldValue?: any | null
              newValue?: any | null
              columnType: ChangelogType
              changedAt: string
            }>
          }
        } | null
      }
    } | null
  } | null
}

export type AdminUsersQueryVariables = Exact<{ [key: string]: never }>

export type AdminUsersQuery = {
  __typename?: "Query"
  admin: {
    __typename?: "AdminQuery"
    activeAdmins: Array<{
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    }>
  }
}

export type CollectingBidsNoticeQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type CollectingBidsNoticeQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    biddingClosedAt?: string | null
  }
}

export type LeaseExecutionDetailsRequestQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type LeaseExecutionDetailsRequestQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    rows: Array<{
      __typename?: "BundleParentRow"
      id: number
      site: { __typename?: "SiteRef"; pid: string; name?: string | null }
      portfolio?: { __typename?: "PortfolioRef"; pid: string; title: string } | null
      awardedFinancier?: { __typename?: "Org"; name: string } | null
    }>
  }
}

export type DeveloperDiligenceRequestQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type DeveloperDiligenceRequestQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    name: string
    rows: Array<{
      __typename?: "BundleParentRow"
      id: number
      site: { __typename?: "SiteRef"; pid: string; name?: string | null }
      awardedFinancier?: { __typename?: "Org"; name: string } | null
    }>
  }
}

export type GmailSignatureQueryVariables = Exact<{ [key: string]: never }>

export type GmailSignatureQuery = {
  __typename?: "Query"
  googleApi: {
    __typename?: "GoogleApiQuery"
    sendAs: { __typename?: "GmailSendAs"; signature: string }
  }
}

export type ReminderToBidQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type ReminderToBidQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    biddingClosedAt?: string | null
    bundles: Array<{
      __typename?: "Bundle2"
      pid: string
      totalBids: number
      archivedAt?: string | null
      financier: {
        __typename?: "BundleOrg"
        orgSlug: string
        name: string
        orgUsers: Array<{
          __typename?: "OrgUser"
          user: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          userRoles: Array<{ __typename?: "UserRole"; role: RbacRole }>
        }>
      }
    }>
  }
  currentUser: { __typename?: "AuthUser"; pid?: string | null; name?: string | null }
}

export type BidResultForLosersQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type BidResultForLosersQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    name: string
    recvr: { __typename?: "Org"; name: string }
    bundles: Array<{
      __typename?: "Bundle2"
      pid: string
      archivedAt?: string | null
      financier: {
        __typename?: "BundleOrg"
        pid: string
        orgSlug: string
        name: string
        orgUsers: Array<{
          __typename?: "OrgUser"
          user: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          userRoles: Array<{ __typename?: "UserRole"; role: RbacRole }>
        }>
      }
    }>
    rows: Array<{
      __typename?: "BundleParentRow"
      id: number
      awardedFinancier?: { __typename?: "Org"; pid: string } | null
    }>
  }
  currentUser: {
    __typename?: "AuthUser"
    pid?: string | null
    name?: string | null
    meetingSchedulingUrl?: string | null
  }
}

export type BidLaunchNoticeQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type BidLaunchNoticeQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    name: string
    totalPvSizeKwDc: number
    pricingNote?: string | null
    biddingClosedAt?: string | null
    type: FinProductType
    recvr: { __typename?: "Org"; name: string }
    bundles: Array<{
      __typename?: "Bundle2"
      pid: string
      financier: {
        __typename?: "BundleOrg"
        orgSlug: string
        name: string
        orgUsers: Array<{
          __typename?: "OrgUser"
          user: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          userRoles: Array<{ __typename?: "UserRole"; role: RbacRole }>
        }>
      }
    }>
    rows: Array<{
      __typename?: "BundleParentRow"
      id: number
      specs: Array<{
        __typename?: "BidSpec"
        ppa?: {
          __typename?: "PPABidSpec"
          id: number
          system?: {
            __typename?: "System"
            pvSpecs: Array<{ __typename?: "PVSpec"; pvTypes: Array<PvType> }>
          } | null
        } | null
        cs?: {
          __typename?: "CSBidSpec"
          id: number
          systemLite?: {
            __typename?: "SystemLite"
            pvSpecs: Array<{ __typename?: "PVSpec"; pvTypes: Array<PvType> }>
          } | null
        } | null
      }>
      site: { __typename?: "SiteRef"; state: string }
    }>
  }
  currentUser: {
    __typename?: "AuthUser"
    pid?: string | null
    meetingSchedulingUrl?: string | null
  }
}

export type HostAwardNoticeQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type HostAwardNoticeQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    recvr: { __typename?: "Org"; name: string }
    rows: Array<{
      __typename?: "BundleParentRow"
      awardedFinancier?: {
        __typename?: "Org"
        name: string
        orgUsers: Array<{
          __typename?: "OrgUser"
          user: {
            __typename?: "UserRef"
            pid: string
            email: string
            name?: string | null
            isAdmin: boolean
            avatarUrl?: string | null
          }
          userRoles: Array<{ __typename?: "UserRole"; role: RbacRole }>
        }>
      } | null
      portfolio?: { __typename?: "PortfolioRef"; title: string } | null
      site: {
        __typename?: "SiteRef"
        name?: string | null
        buildingType?: BuildingType | null
        state: string
      }
    }>
  }
  currentUser: {
    __typename?: "AuthUser"
    pid?: string | null
    meetingSchedulingUrl?: string | null
  }
}

export type ProjectKickoffNoticeQueryVariables = Exact<{
  orgSlug: Scalars["String"]["input"]
  parentPid: Scalars["String"]["input"]
}>

export type ProjectKickoffNoticeQuery = {
  __typename?: "Query"
  bundleParentDetail: {
    __typename?: "BundleParent"
    pid: string
    rows: Array<{
      __typename?: "BundleParentRow"
      awardedFinancier?: { __typename?: "Org"; name: string } | null
    }>
  }
}

export type RevampFinmodelFragment = {
  __typename: "RevampFinmodel"
  id: number
  pid: string
  createdAt: string
  type: FinProductType
  intervalsAndCostsXlsxHref: string
  buildingOwnerXlsxHref?: string | null
  offerStatus: OfferStatus
  fmvStr: string
  totalPvProductionKwh: number
  totalPvExportKwh?: number | null
  bauCostPerYear: Array<number>
  derCostPerYear: Array<number>
  goal?: PVoptGoal | null
  isVnem: boolean
  isGreenLease: boolean
  thirdPartySupplier?: {
    __typename?: "ThirdPartySupplier"
    pid: string
    name: string
  } | null
  buildingOwner: {
    __typename?: "BuildingOwnerEconomics"
    noiYearOne?: number | null
    noiLifetime?: number | null
    noiAnnual?: number | null
  }
  ppa?: {
    __typename: "PPAEconomics"
    ppaType: PpaProductType
    ppaCostPerKwh: number
    ppaTermYears: number
    ppaEsc?: number | null
    srecToInvestor: boolean
    offtakerXlsxHref: string
    product: {
      __typename?: "PPAFinProduct"
      productName: string
      financierName: string
    }
    roofRent?: {
      __typename?: "RoofRentEconomics"
      lifetimeUsd: number
      annualUsd: number
      usdPerSqft: number
      roofRentPerYear: Array<number>
    } | null
    tenantFlows?: {
      __typename?: "TenantCashflows"
      npv: number
      discountRate: number
      totalUtilitySavings: number
      totalCapex: number
      totalOpex: number
      totalNet: number
      netCashflowPerYear: Array<number>
    } | null
  } | null
  loan?: {
    __typename: "LoanEconomics"
    loanRecvrXlsxHref: string
    loanTermYears: number
    ownershipTermYears: number
    interestPct: number
    srecToInvestor: boolean
    product: {
      __typename?: "LoanFinProduct"
      productName: string
      financierName: string
      loanDealerFeePct: number
    }
    flows?: {
      __typename?: "LoanRecvrCashflows"
      monthlyPayment: number
      totalRevenue: number
      totalUtilitySavings: number
      totalOpex: number
      totalCapex: number
      totalItc: number
      totalLoanFunding: number
      totalLoanPayments: number
      totalNet: number
      netCashflowPerYear: Array<number>
      greenLeaseTenantFlows?: {
        __typename?: "TenantCashflows"
        totalNet: number
        netCashflowPerYear: Array<number>
        totalCapex: number
        totalOpex: number
        totalUtilitySavings: number
        npv: number
        discountRate: number
      } | null
    } | null
  } | null
  selfInvest?: {
    __typename: "SelfInvestEconomics"
    npv: number
    discountRate: number
    selfInvestXlsxHref: string
    termYears: number
    srecToInvestor: boolean
    irrs: {
      __typename?: "IRRs"
      postTaxItcDepr?: number | null
      postTaxItcDeprMultiple?: number | null
    }
    product: {
      __typename?: "SelfInvestFinProduct"
      productName: string
      financierName: string
    }
    flows?: {
      __typename?: "SelfInvestCashflows"
      totalRevenue: number
      totalUtilitySavings: number
      totalOpex: number
      totalCapex: number
      totalItc: number
      totalNet: number
      netCashflowPerYear: Array<number>
      greenLeaseTenantFlows?: {
        __typename?: "TenantCashflows"
        totalNet: number
        netCashflowPerYear: Array<number>
        totalCapex: number
        totalOpex: number
        totalUtilitySavings: number
        npv: number
        discountRate: number
      } | null
    } | null
  } | null
  meters: Array<{
    __typename?: "RevampMeter"
    name: string
    loadCategory: LoadCategory
    meterSource: MeterSource
    bau: {
      __typename?: "RevampDer"
      totalKwhFlow: {
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }
    }
    der?: {
      __typename?: "RevampDer"
      totalKwhFlow: {
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }
      averageDayKwhFlow: Array<{
        __typename?: "KwhFlow"
        bauLoadKwh: number
        importsKwh: number
        exportsKwh: number
        pvProductionKwh: number
        pvToLoadKwh: number
        batteryChargeKwh: number
        batteryDischargeKwh: number
      }>
    } | null
  }>
  systems: Array<
    | {
        __typename: "BatterySystem"
        vendor: BatteryVendor
        sizeKw: number
        sizeKwh: number
        assumptions: { __typename?: "BattAssumptions"; battChemName: string }
      }
    | { __typename: "PVSystem"; type: PvType; sizeKw: number }
  >
  utilityCosts: {
    __typename?: "UtilityCost"
    bau: {
      __typename?: "FinmodelCost"
      totalKwh: number
      totalCostUsd: number
      usdPerKwh: number
      items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
      tariffs: Array<{
        __typename?: "RevampTariff"
        id: number
        name: string
        code: string
        startDate: string
        endDate?: string | null
        utility: {
          __typename?: "RevampUtility"
          id: number
          name: string
          shortName: string
        }
      }>
    }
    der: {
      __typename?: "FinmodelCost"
      totalKwh: number
      totalCostUsd: number
      usdPerKwh: number
      items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
      tariffs: Array<{
        __typename?: "RevampTariff"
        id: number
        name: string
        code: string
        startDate: string
        endDate?: string | null
        utility: {
          __typename?: "RevampUtility"
          id: number
          name: string
          shortName: string
        }
      }>
    }
  }
}

type RevampSystem_BatterySystem_Fragment = {
  __typename: "BatterySystem"
  vendor: BatteryVendor
  sizeKw: number
  sizeKwh: number
  assumptions: { __typename?: "BattAssumptions"; battChemName: string }
}

type RevampSystem_PvSystem_Fragment = {
  __typename: "PVSystem"
  type: PvType
  sizeKw: number
}

export type RevampSystemFragment =
  | RevampSystem_BatterySystem_Fragment
  | RevampSystem_PvSystem_Fragment

export type RevampCsFragment = {
  __typename: "RevampCS"
  id: number
  termYears: number
  createdAt: string
  goal?: PVoptGoal | null
  systems: Array<
    | {
        __typename: "BatterySystem"
        vendor: BatteryVendor
        sizeKw: number
        sizeKwh: number
        assumptions: { __typename?: "BattAssumptions"; battChemName: string }
      }
    | { __typename: "PVSystem"; type: PvType; sizeKw: number }
  >
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
  }
  buildingOwner: {
    __typename?: "BuildingOwnerEconomics"
    noiYearOne?: number | null
    noiLifetime?: number | null
    noiAnnual?: number | null
  }
  roofRent?: {
    __typename?: "RoofRentEconomics"
    lifetimeUsd: number
    annualUsd: number
    usdPerSqft: number
    npv: number
    discountRate: number
    roofRentPerYear: Array<number>
  } | null
  pricing: {
    __typename?: "CSPrice"
    usdPerKwPerYear: number
    escalator: number
    minPvKw: number
    maxPvKw: number
    utility: { __typename?: "RevampUtility"; id: number; name: string }
  }
  leaseProjections?: {
    __typename?: "CSLeaseProjections"
    systemSizeKw: number
    annualRentLowerRangeUsd: number
    annualRentUpperRangeUsd: number
    methodology: CsLeaseProjectionMethdology
  } | null
}

export type FinmodelCostFragment = {
  __typename?: "FinmodelCost"
  totalKwh: number
  totalCostUsd: number
  usdPerKwh: number
  items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
  tariffs: Array<{
    __typename?: "RevampTariff"
    id: number
    name: string
    code: string
    startDate: string
    endDate?: string | null
    utility: {
      __typename?: "RevampUtility"
      id: number
      name: string
      shortName: string
    }
  }>
}

export type PossibleTariffFragment = {
  __typename?: "Tariff"
  id: number
  name: string
  code: string
  customerClass: string
  customerCount?: number | null
  customerLikelihood: number
  isPreferred?: boolean | null
  minMonthlyKw?: number | null
  maxMonthlyKw?: number | null
  minMonthlyKwh?: number | null
  maxMonthlyKwh?: number | null
  masterTariffId?: number | null
  hasNetMetering: boolean
  requiresPv?: boolean | null
  requiresStorage?: boolean | null
  tariffType?: string | null
}

export type ResultRefFragment = {
  __typename?: "Result"
  id: number
  pid: string
  createdAt: string
  scenario: {
    __typename?: "RevampScenario"
    pid: string
    name: string
    solarLocation: SolarLocation
    loadCategory: LoadCategory
    includeStorage: boolean
  }
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
    status: FinProductStatus
  }
}

export type ResultFragment = {
  __typename?: "Result"
  id: number
  pid: string
  createdAt: string
  salesPdfReportHref?: string | null
  scenario: {
    __typename?: "RevampScenario"
    pid: string
    name: string
    solarLocation: SolarLocation
    loadCategory: LoadCategory
    includeStorage: boolean
  }
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
    status: FinProductStatus
  }
  result?:
    | {
        __typename: "PhysicalCheck"
        createdAt: string
        roofIsGood: boolean
        carportIsGood: boolean
        existingSolar?: boolean | null
        badRoof?: boolean | null
        groundmountIsGood: boolean
      }
    | {
        __typename: "PolicyCheck"
        createdAt: string
        productType?: FinProductType | null
        isGood: boolean
        disqualReason?: PolicyReason | null
      }
    | {
        __typename: "RevampCS"
        id: number
        termYears: number
        createdAt: string
        goal?: PVoptGoal | null
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        financing: {
          __typename?: "RevampFinancing"
          id: number
          name: string
          type: FinProductType
          financierName: string
          financierPid: string
          financierLogo?: string | null
          financierLogomark?: string | null
          isThirdParty: boolean
        }
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        roofRent?: {
          __typename?: "RoofRentEconomics"
          lifetimeUsd: number
          annualUsd: number
          usdPerSqft: number
          npv: number
          discountRate: number
          roofRentPerYear: Array<number>
        } | null
        pricing: {
          __typename?: "CSPrice"
          usdPerKwPerYear: number
          escalator: number
          minPvKw: number
          maxPvKw: number
          utility: { __typename?: "RevampUtility"; id: number; name: string }
        }
        leaseProjections?: {
          __typename?: "CSLeaseProjections"
          systemSizeKw: number
          annualRentLowerRangeUsd: number
          annualRentUpperRangeUsd: number
          methodology: CsLeaseProjectionMethdology
        } | null
      }
    | {
        __typename: "RevampFinmodel"
        id: number
        pid: string
        createdAt: string
        type: FinProductType
        intervalsAndCostsXlsxHref: string
        buildingOwnerXlsxHref?: string | null
        offerStatus: OfferStatus
        fmvStr: string
        totalPvProductionKwh: number
        totalPvExportKwh?: number | null
        bauCostPerYear: Array<number>
        derCostPerYear: Array<number>
        goal?: PVoptGoal | null
        isVnem: boolean
        isGreenLease: boolean
        iterations: Array<{
          __typename?: "RevampIteration"
          cashPurchaseNpv: number
          pvKw: number
          marginalCo2Averted?: number | null
          storagePvKw?: number | null
          storagePvKwh?: number | null
        }>
        meters: Array<{
          __typename?: "RevampMeter"
          loadCategory: LoadCategory
          meterSource: MeterSource
          name: string
          bau: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
          }
          der?: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
            averageDayKwhFlow: Array<{
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }>
          } | null
        }>
        emissions?: {
          __typename?: "RevampEmissions"
          bauCo2Tons: number
          derCo2Tons: number
          bauAverageDayCo2Tons: Array<number>
          derAverageDayCo2Tons: Array<number>
        } | null
        thirdPartySupplier?: {
          __typename?: "ThirdPartySupplier"
          pid: string
          name: string
        } | null
        buildingOwner: {
          __typename?: "BuildingOwnerEconomics"
          noiYearOne?: number | null
          noiLifetime?: number | null
          noiAnnual?: number | null
        }
        ppa?: {
          __typename: "PPAEconomics"
          ppaType: PpaProductType
          ppaCostPerKwh: number
          ppaTermYears: number
          ppaEsc?: number | null
          srecToInvestor: boolean
          offtakerXlsxHref: string
          product: {
            __typename?: "PPAFinProduct"
            productName: string
            financierName: string
          }
          roofRent?: {
            __typename?: "RoofRentEconomics"
            lifetimeUsd: number
            annualUsd: number
            usdPerSqft: number
            roofRentPerYear: Array<number>
          } | null
          tenantFlows?: {
            __typename?: "TenantCashflows"
            npv: number
            discountRate: number
            totalUtilitySavings: number
            totalCapex: number
            totalOpex: number
            totalNet: number
            netCashflowPerYear: Array<number>
          } | null
        } | null
        loan?: {
          __typename: "LoanEconomics"
          loanRecvrXlsxHref: string
          loanTermYears: number
          ownershipTermYears: number
          interestPct: number
          srecToInvestor: boolean
          product: {
            __typename?: "LoanFinProduct"
            productName: string
            financierName: string
            loanDealerFeePct: number
          }
          flows?: {
            __typename?: "LoanRecvrCashflows"
            monthlyPayment: number
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalLoanFunding: number
            totalLoanPayments: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        selfInvest?: {
          __typename: "SelfInvestEconomics"
          npv: number
          discountRate: number
          selfInvestXlsxHref: string
          termYears: number
          srecToInvestor: boolean
          irrs: {
            __typename?: "IRRs"
            postTaxItcDepr?: number | null
            postTaxItcDeprMultiple?: number | null
          }
          product: {
            __typename?: "SelfInvestFinProduct"
            productName: string
            financierName: string
          }
          flows?: {
            __typename?: "SelfInvestCashflows"
            totalRevenue: number
            totalUtilitySavings: number
            totalOpex: number
            totalCapex: number
            totalItc: number
            totalNet: number
            netCashflowPerYear: Array<number>
            greenLeaseTenantFlows?: {
              __typename?: "TenantCashflows"
              totalNet: number
              netCashflowPerYear: Array<number>
              totalCapex: number
              totalOpex: number
              totalUtilitySavings: number
              npv: number
              discountRate: number
            } | null
          } | null
        } | null
        systems: Array<
          | {
              __typename: "BatterySystem"
              vendor: BatteryVendor
              sizeKw: number
              sizeKwh: number
              assumptions: { __typename?: "BattAssumptions"; battChemName: string }
            }
          | { __typename: "PVSystem"; type: PvType; sizeKw: number }
        >
        utilityCosts: {
          __typename?: "UtilityCost"
          bau: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
          der: {
            __typename?: "FinmodelCost"
            totalKwh: number
            totalCostUsd: number
            usdPerKwh: number
            items: Array<{ __typename?: "LineItem"; name: string; usd: number }>
            tariffs: Array<{
              __typename?: "RevampTariff"
              id: number
              name: string
              code: string
              startDate: string
              endDate?: string | null
              utility: {
                __typename?: "RevampUtility"
                id: number
                name: string
                shortName: string
              }
            }>
          }
        }
      }
    | {
        __typename: "RevampFinmodelFailure"
        id: number
        createdAt: string
        fmvStr: string
        details: { __typename?: "FailureDetails"; label: string; description: string }
      }
    | {
        __typename: "Viability"
        isAllowed: boolean
        reason?: ViabilityReason | null
        level: ViabilityLevel
        viabilityType: ViabilityType
      }
    | null
  helioscope?: {
    __typename?: "Helioscope"
    pid: string
    roofPvKw: number
    carportPvKw: number
    groundPvKw: number
    systemProductivityKwhPerKw?: number | null
    roofImageHref: string
    pdfHref: string
    dcNameplateKw?: number | null
    acNameplateKw?: number | null
    loadRatio?: number | null
    moduleType?: string | null
    inverterType?: string | null
    rackingTiltDegrees?: number | null
    rackingManufacturer?: string | null
    rackingConnectionType?: ConnectionType | null
    notes?: string | null
    roofImage: {
      __typename?: "Attachment"
      id: number
      name: string
      downloadHref: string
    }
    pdf: {
      __typename?: "Attachment"
      downloadHref: string
      contentType: string
      name: string
      id: number
    }
  } | null
}

export type ResultWithEnergyDataFragment = {
  __typename?: "Result"
  id: number
  result?:
    | { __typename?: "PhysicalCheck" }
    | { __typename?: "PolicyCheck" }
    | { __typename?: "RevampCS" }
    | {
        __typename?: "RevampFinmodel"
        meters: Array<{
          __typename?: "RevampMeter"
          loadCategory: LoadCategory
          meterSource: MeterSource
          bau: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
          }
          der?: {
            __typename?: "RevampDer"
            totalKwhFlow: {
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }
            averageDayKwhFlow: Array<{
              __typename?: "KwhFlow"
              bauLoadKwh: number
              importsKwh: number
              exportsKwh: number
              pvProductionKwh: number
              pvToLoadKwh: number
              batteryChargeKwh: number
              batteryDischargeKwh: number
            }>
          } | null
        }>
        emissions?: {
          __typename?: "RevampEmissions"
          bauCo2Tons: number
          derCo2Tons: number
          bauAverageDayCo2Tons: Array<number>
          derAverageDayCo2Tons: Array<number>
        } | null
      }
    | { __typename?: "RevampFinmodelFailure" }
    | { __typename?: "Viability" }
    | null
}

export type KwhFlowFragment = {
  __typename?: "KwhFlow"
  bauLoadKwh: number
  importsKwh: number
  exportsKwh: number
  pvProductionKwh: number
  pvToLoadKwh: number
  batteryChargeKwh: number
  batteryDischargeKwh: number
}

export type DecodedRateFragment = {
  __typename?: "DecodedRate"
  id: number
  name: string
  chargeClass: ChargeClass
}

export type BillSectionFragment = {
  __typename?: "BillSection"
  name: string
  rates: Array<{
    __typename?: "DecodedRate"
    id: number
    name: string
    chargeClass: ChargeClass
  }>
  costs: Array<
    | {
        __typename: "CostItem"
        name: string
        rateId: number
        chargeType: ChargeType
        chargeCategory?: ChargeCategory | null
        volume: number
        rate: number
        cost: number
        rateObj: {
          __typename?: "DecodedRate"
          id: number
          name: string
          chargeClass: ChargeClass
        }
      }
    | {
        __typename: "TaxItem"
        taxId: number
        subtotal: number
        cost: number
        percentage: number
      }
    | null
  >
}

type CostOrTaxItem_CostItem_Fragment = {
  __typename: "CostItem"
  name: string
  rateId: number
  chargeType: ChargeType
  chargeCategory?: ChargeCategory | null
  volume: number
  rate: number
  cost: number
  rateObj: {
    __typename?: "DecodedRate"
    id: number
    name: string
    chargeClass: ChargeClass
  }
}

type CostOrTaxItem_TaxItem_Fragment = {
  __typename: "TaxItem"
  taxId: number
  subtotal: number
  cost: number
  percentage: number
}

export type CostOrTaxItemFragment =
  | CostOrTaxItem_CostItem_Fragment
  | CostOrTaxItem_TaxItem_Fragment

export type FormattedBillFragment = {
  __typename?: "FormattedBills"
  rate?: {
    __typename?: "TariffRate"
    tariffId?: number | null
    startDate: string
    endDate?: string | null
  } | null
  bills: Array<{
    __typename?: "FormattedBill"
    month: string
    kwhSupplyCharge: number
    kwhCharge: number
    charges: Array<{
      __typename?: "BillSection"
      name: string
      rates: Array<{
        __typename?: "DecodedRate"
        id: number
        name: string
        chargeClass: ChargeClass
      }>
      costs: Array<
        | {
            __typename: "CostItem"
            name: string
            rateId: number
            chargeType: ChargeType
            chargeCategory?: ChargeCategory | null
            volume: number
            rate: number
            cost: number
            rateObj: {
              __typename?: "DecodedRate"
              id: number
              name: string
              chargeClass: ChargeClass
            }
          }
        | {
            __typename: "TaxItem"
            taxId: number
            subtotal: number
            cost: number
            percentage: number
          }
        | null
      >
    }>
    exports: Array<{
      __typename?: "BillSection"
      name: string
      rates: Array<{
        __typename?: "DecodedRate"
        id: number
        name: string
        chargeClass: ChargeClass
      }>
      costs: Array<
        | {
            __typename: "CostItem"
            name: string
            rateId: number
            chargeType: ChargeType
            chargeCategory?: ChargeCategory | null
            volume: number
            rate: number
            cost: number
            rateObj: {
              __typename?: "DecodedRate"
              id: number
              name: string
              chargeClass: ChargeClass
            }
          }
        | {
            __typename: "TaxItem"
            taxId: number
            subtotal: number
            cost: number
            percentage: number
          }
        | null
      >
    }>
  }>
}

export type SiteConfigFragment = {
  __typename?: "SiteConfig"
  createdAt?: string | null
  createdBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  scenario: {
    __typename?: "RevampScenario"
    pid: string
    name: string
    loadCategory: LoadCategory
    solarLocation: SolarLocation
    includeStorage: boolean
  }
  financing: {
    __typename?: "RevampFinancing"
    id: number
    name: string
    type: FinProductType
    financierName: string
    financierPid: string
    financierLogo?: string | null
    financierLogomark?: string | null
    isThirdParty: boolean
  }
}

export type BidRevampSiteFragment = {
  __typename?: "RevampSite"
  pid: string
  name?: string | null
  streetAddress: string
  city: string
  state: string
  zipCode: string
  county: string
  fullAddress: string
  assetManager?: string | null
  doeReferenceType?: BuildingType | null
  yearBuilt?: number | null
  numStories?: number | null
  sqft?: number | null
  roofSqft?: number | null
  roofMaxPvKw: number
  buildingClass?: string | null
  ppaType?: PpaProductType | null
  meterSet?: {
    __typename?: "MeterSet"
    totalCost: number
    loadKwh?: number | null
  } | null
  siteDetails: {
    __typename?: "SiteDetails"
    salePlans?: string | null
    roofCondition?: string | null
    roofReplacedYr?: number | null
  }
  targetUtility?: {
    __typename?: "Utility"
    name: string
    pid: string
    id: number
  } | null
}

export type RevampSiteBasicsFragment = {
  __typename?: "RevampSite"
  pid: string
  name?: string | null
  isFavorite: boolean
  isBehindTheMeter?: boolean | null
  isEnergyCommunity: boolean
  isLowIncomeCommunity?: boolean | null
  streetAddress: string
  city: string
  state: string
  zipCode: string
  county: string
  fullAddress: string
  metering?: Metering | null
  assetManager?: string | null
  vnemAllowed: boolean
  doeReferenceType?: BuildingType | null
  usingBillingMeters?: string | null
  numParkingSpaces?: number | null
  yearBuilt?: number | null
  numStories?: number | null
  sqft?: number | null
  roofSqft?: number | null
  usableRoofSqft?: number | null
  usableCarportFt?: number | null
  impliedCarportLinearFt?: number | null
  impliedUsableRoofSqft?: number | null
  impliedUsableRoofSqftExplanation: RoofSqftExplanation
  groundAvailableSqft?: number | null
  hideBuildingFootprint: boolean
  keepoutsFootprintSqft?: number | null
  roofMaxPvKw: number
  carportMaxPvKw: number
  groundmountMaxPvKw?: number | null
  maxPvKwPolicyLimited: boolean
  isMultifamily: boolean
  occupancyType?: BuildingOccupancyType | null
  leaseType?: LeaseType | null
  tenantLeaseTerm?: string | null
  tenantLeaseEnds?: string | null
  tenantInterest?: YesNoUnsure | null
  mortgageLender?: string | null
  buildingClass?: string | null
  hasSubmittedEnergyData: boolean
  selectedConfig?: {
    __typename?: "SiteConfig"
    createdAt?: string | null
    createdBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    scenario: {
      __typename?: "RevampScenario"
      pid: string
      name: string
      loadCategory: LoadCategory
      solarLocation: SolarLocation
      includeStorage: boolean
    }
    financing: {
      __typename?: "RevampFinancing"
      id: number
      name: string
      type: FinProductType
      financierName: string
      financierPid: string
      financierLogo?: string | null
      financierLogomark?: string | null
      isThirdParty: boolean
    }
  } | null
  documents: Array<{
    __typename?: "Document"
    pid: string
    downloadHref: string
    fileName: string
    tag?: DocumentTag | null
  }>
  energyThings?: {
    __typename?: "EnergyThings"
    canRooftopSolar: boolean
    canCarportSolar?: boolean | null
    canGroundmountSolar?: boolean | null
    canStorage: boolean
  } | null
  financingThings?: {
    __typename?: "FinancingThings"
    canSelfInvest: boolean
    canLoan: boolean
    canPpa?: boolean | null
    canCommunitySolar?: boolean | null
  } | null
  physicalCheck: {
    __typename?: "PhysicalCheck"
    existingSolar?: boolean | null
    unobstructedFlatRoof?: boolean | null
    badRoof?: boolean | null
  }
  siteDetails: {
    __typename?: "SiteDetails"
    leaseApprovers: Array<string>
    externalLeaseApprovers?: Array<string> | null
    needsTenantApproval?: boolean | null
    roofRightsHolder?: RoofRightsHolder | null
    propertyLenders?: string | null
    propertyInsurer?: string | null
    constructionEmail?: string | null
    propertySiteVisitContacts?: Array<string> | null
    leasePropertyLegalDescription?: string | null
    leaseLegalOwnerName?: string | null
    signatureBlocks?: Array<string> | null
    isFannieMaeLender?: boolean | null
    isFmGlobalInsurer?: boolean | null
    roofReplacedYr?: number | null
    roofCondition?: string | null
    salePlans?: string | null
    buildingLegalName?: string | null
    propertyFundName?: string | null
    leaseSignatory?: string | null
    counselApproval?: CounselApproval | null
  }
  notes: Array<{ __typename?: "Note"; text: string }>
  buildingData?: {
    __typename?: "BuildingData"
    numStories?: number | null
    numUnits?: number | null
    yearBuilt?: number | null
    sqft?: number | null
    roofSqft?: number | null
    numParkingSpaces?: number | null
    occupancyRate?: number | null
    totalBuildings?: number | null
    yearRenovated?: number | null
    parentCompany?: string | null
    lastSalePrice?: number | null
    leedCertified?: string | null
    energyStar?: string | null
    buildingOpex?: string | null
    capRate?: number | null
  } | null
  footprint: {
    __typename?: "Footprint"
    latitude: number
    longitude: number
    bounds?: any | null
    obstructionShape?: any | null
    roofShape?: any | null
    roofShapeGeojson?: any | null
    roofShapeUpdatedAt?: string | null
    roofSetbackShape?: any | null
    roofSetbackShapeGeojson?: any | null
    roofSetbackShapeUpdatedAt?: string | null
    carportShape?: any | null
    carportShapeGeojson?: any | null
    carportShapeUpdatedAt?: string | null
    groundmountShape?: any | null
    groundmountShapeGeojson?: any | null
    groundmountShapeUpdatedAt?: string | null
    keepoutsShape?: any | null
    keepoutsShapeGeojson?: any | null
    keepoutsShapeUpdatedAt?: string | null
    roofShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    roofSetbackShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    carportShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    groundmountShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
    keepoutsShapeUpdatedBy?: {
      __typename?: "UserRef"
      pid: string
      email: string
      name?: string | null
      isAdmin: boolean
      avatarUrl?: string | null
    } | null
  }
  thirdPartySupplier?: {
    __typename?: "ThirdPartySupplier"
    pid: string
    name: string
  } | null
  meterSet?: { __typename?: "MeterSet"; loadOrigin?: LoadOrigin | null } | null
  targetUtility?: {
    __typename?: "Utility"
    name: string
    pid: string
    id: number
    eiaGridEsc?: {
      __typename?: "EIAGridEsc"
      cagrBlended: number
      fromYear: number
      toYear: number
    } | null
    hostingCapacityMaps: Array<{
      __typename?: "HostingCapacityMap"
      url: string
      requiresLogin: boolean
      types: Array<HostingCapacityMapType>
    }>
  } | null
}

export type UserRefFragment = {
  __typename?: "UserRef"
  pid: string
  email: string
  name?: string | null
  isAdmin: boolean
  avatarUrl?: string | null
}

export type FootprintFragment = {
  __typename?: "Footprint"
  latitude: number
  longitude: number
  bounds?: any | null
  obstructionShape?: any | null
  roofShape?: any | null
  roofShapeGeojson?: any | null
  roofShapeUpdatedAt?: string | null
  roofSetbackShape?: any | null
  roofSetbackShapeGeojson?: any | null
  roofSetbackShapeUpdatedAt?: string | null
  carportShape?: any | null
  carportShapeGeojson?: any | null
  carportShapeUpdatedAt?: string | null
  groundmountShape?: any | null
  groundmountShapeGeojson?: any | null
  groundmountShapeUpdatedAt?: string | null
  keepoutsShape?: any | null
  keepoutsShapeGeojson?: any | null
  keepoutsShapeUpdatedAt?: string | null
  roofShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  roofSetbackShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  carportShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  groundmountShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
  keepoutsShapeUpdatedBy?: {
    __typename?: "UserRef"
    pid: string
    email: string
    name?: string | null
    isAdmin: boolean
    avatarUrl?: string | null
  } | null
}

export type HelioscopeFragment = {
  __typename?: "Helioscope"
  pid: string
  roofPvKw: number
  carportPvKw: number
  groundPvKw: number
  systemProductivityKwhPerKw?: number | null
  roofImageHref: string
  pdfHref: string
  dcNameplateKw?: number | null
  acNameplateKw?: number | null
  loadRatio?: number | null
  moduleType?: string | null
  inverterType?: string | null
  rackingTiltDegrees?: number | null
  rackingManufacturer?: string | null
  rackingConnectionType?: ConnectionType | null
  notes?: string | null
  roofImage: {
    __typename?: "Attachment"
    id: number
    name: string
    downloadHref: string
  }
  pdf: {
    __typename?: "Attachment"
    downloadHref: string
    contentType: string
    name: string
    id: number
  }
}

export type SiteVisualsFragment = {
  __typename?: "SiteVisuals"
  solarPanels: Array<{
    __typename?: "MapSolarPanel"
    latitude: number
    longitude: number
    angle: number
  }>
}

export type BasicEvCalcFragment = {
  __typename?: "EVCalc"
  id: number
  createdAt: string
  numChargers: number
  optimalNumChargers: number
  npv: number
  markupUsdPerKwh: number
  timeZone: string
  dayRates: Array<number>
  downloadHourlyRatesHref: string
  xlsx?: string | null
  downloadXlsxHref: string
  yr3Revenue?: number | null
  yr3Cashflow?: number | null
  yr3NumEvs?: number | null
  parkingRatio?: number | null
  projectInputs: {
    __typename?: "EVProjectInputs"
    projectStartDate: string
    installType: ChargerInstallType
    termYears: number
    chargerKw: number
    yr0NumTenantEvs?: number | null
    discountRate: number
  }
  outputs: {
    __typename?: "EVOutputs"
    irr?: number | null
    npv: number
    yr0NumTenantEvs: number
    breakevenYear: number
    numChargersDemandedSeries: Array<number>
    cashflowSeries: Array<number>
    revenueSeries: Array<number>
    incentiveUsd: number
  }
  tariffRate: {
    __typename?: "TariffRate"
    parent: { __typename?: "Tariff"; name: string; code: string }
  }
  utility: { __typename?: "UtilityRef"; shortName: string }
  seasonalDayRates: Array<{
    __typename?: "SeasonalDayRate"
    name: string
    startMonth: number
    endMonth: number
    dayRates: Array<number>
  }>
  optIters: Array<{ __typename?: "EVOptIter"; numChargers: number; npv: number }>
  year3Expenses: Array<{ __typename?: "EVLineItem"; label: string; value: number }>
  installCosts: Array<{ __typename?: "EVLineItem"; label: string; value: number }>
}

export type DocumentFragment = {
  __typename?: "Document"
  id: number
  pid: string
  contentType: string
  dateCreated: string
  fileName: string
  ownerName: string
  ownerEmail: string
  downloadHref: string
  viewHref: string
  tag?: DocumentTag | null
}

export const AuthUserFragmentDoc = `
    fragment AuthUser on AuthUser {
  pid
  isAuthenticated
  isAdmin
  email
  name
  org {
    pid
    name
    logoUrl
    irrFlavor
  }
}
    `
export const SiteLabelRefFragmentDoc = `
    fragment SiteLabelRef on SiteLabel {
  pid
  name
  themeColor
  sites
}
    `
export const UserRefFragmentDoc = `
    fragment UserRef on UserRef {
  pid
  email
  name
  isAdmin
  avatarUrl
}
    `
export const SiteLabelDetailFragmentDoc = `
    fragment SiteLabelDetail on SiteLabel {
  ...SiteLabelRef
  createdBy {
    ...UserRef
  }
  perms {
    canAdd
    canRemove
  }
}
    `
export const PolicyBriefFragmentDoc = `
    fragment PolicyBrief on Policy {
  pid
  name
  publicName
  description
  publicDescription
  sources {
    text
    url
  }
  userVisible
  application {
    status
  }
}
    `
export const BundleFragmentDoc = `
    fragment Bundle on Bundle {
  pid
  createdAt
  name
  note
  state
  optedOut
  biddingOpenAt
  biddingClosedAt
  hasParent
  canDelete
  archived
  type
  recvr {
    pid
    name
  }
  stats {
    numSites
    capex
    postTaxItcDeprIrr
    pvSizeKw
  }
  downloadTheBigZipHref
  documents {
    canDelete
    contentType
    dateCreated
    fileName
    ownerName
    pid
    tag
    downloadHref
    belongsToBundleParent
  }
}
    `
export const SiteConfigFragmentDoc = `
    fragment SiteConfig on SiteConfig {
  createdAt
  createdBy {
    ...UserRef
  }
  scenario {
    pid
    name
    loadCategory
    solarLocation
    includeStorage
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
  }
}
    `
export const FootprintFragmentDoc = `
    fragment Footprint on Footprint {
  latitude
  longitude
  bounds
  obstructionShape
  roofShape
  roofShapeGeojson
  roofShapeUpdatedAt
  roofShapeUpdatedBy {
    ...UserRef
  }
  roofSetbackShape
  roofSetbackShapeGeojson
  roofSetbackShapeUpdatedAt
  roofSetbackShapeUpdatedBy {
    ...UserRef
  }
  carportShape
  carportShapeGeojson
  carportShapeUpdatedAt
  carportShapeUpdatedBy {
    ...UserRef
  }
  groundmountShape
  groundmountShapeGeojson
  groundmountShapeUpdatedAt
  groundmountShapeUpdatedBy {
    ...UserRef
  }
  keepoutsShape
  keepoutsShapeGeojson
  keepoutsShapeUpdatedAt
  keepoutsShapeUpdatedBy {
    ...UserRef
  }
}
    `
export const RevampSiteBasicsFragmentDoc = `
    fragment RevampSiteBasics on RevampSite {
  pid
  name
  isFavorite
  isBehindTheMeter
  isEnergyCommunity
  isLowIncomeCommunity
  streetAddress
  city
  state
  zipCode
  county
  fullAddress
  metering
  assetManager
  vnemAllowed
  doeReferenceType
  usingBillingMeters
  numParkingSpaces
  selectedConfig {
    ...SiteConfig
  }
  documents {
    pid
    downloadHref
    fileName
    tag
  }
  energyThings {
    canRooftopSolar
    canCarportSolar
    canGroundmountSolar
    canStorage
  }
  financingThings {
    canSelfInvest
    canLoan
    canPpa
    canCommunitySolar
  }
  physicalCheck {
    existingSolar
    unobstructedFlatRoof
    badRoof
  }
  siteDetails {
    leaseApprovers
    externalLeaseApprovers
    needsTenantApproval
    roofRightsHolder
    propertyLenders
    propertyInsurer
    constructionEmail
    propertySiteVisitContacts
    leasePropertyLegalDescription
    leaseLegalOwnerName
    signatureBlocks
    isFannieMaeLender
    isFmGlobalInsurer
    roofReplacedYr
    roofCondition
    salePlans
    buildingLegalName
    propertyFundName
    leaseSignatory
    counselApproval
  }
  yearBuilt
  numStories
  sqft
  roofSqft
  usableRoofSqft
  usableCarportFt
  impliedCarportLinearFt
  impliedUsableRoofSqft
  impliedUsableRoofSqftExplanation
  groundAvailableSqft
  hideBuildingFootprint
  keepoutsFootprintSqft
  roofMaxPvKw
  carportMaxPvKw
  groundmountMaxPvKw
  maxPvKwPolicyLimited
  isMultifamily
  occupancyType
  leaseType
  tenantLeaseTerm
  tenantLeaseEnds
  tenantInterest
  mortgageLender
  notes {
    text
  }
  buildingClass
  buildingData {
    numStories
    numUnits
    yearBuilt
    sqft
    roofSqft
    numParkingSpaces
    occupancyRate
    totalBuildings
    yearRenovated
    parentCompany
    lastSalePrice
    leedCertified
    energyStar
    buildingOpex
    capRate
  }
  footprint {
    ...Footprint
  }
  thirdPartySupplier {
    pid
    name
  }
  meterSet {
    loadOrigin
  }
  targetUtility {
    name
    pid
    id
    eiaGridEsc {
      cagrBlended
      fromYear
      toYear
    }
    hostingCapacityMaps {
      url
      requiresLogin
      types
    }
  }
  hasSubmittedEnergyData
}
    `
export const BillingMeterOptionFragmentDoc = `
    fragment BillingMeterOption on BillingMeter {
  pid
  bauMeterPid
  view {
    name
    isArchived
    calc2 {
      __typename
      ... on Projected {
        annualKwh
      }
    }
  }
}
    `
export const KwhFlowFragmentDoc = `
    fragment KwhFlow on KwhFlow {
  bauLoadKwh
  importsKwh
  exportsKwh
  pvProductionKwh
  pvToLoadKwh
  batteryChargeKwh
  batteryDischargeKwh
}
    `
export const RevampSystemFragmentDoc = `
    fragment RevampSystem on RevampSystem {
  __typename
  ... on PVSystem {
    type
    sizeKw
  }
  ... on BatterySystem {
    vendor
    sizeKw
    sizeKwh
    assumptions {
      battChemName
    }
  }
}
    `
export const FinmodelCostFragmentDoc = `
    fragment FinmodelCost on FinmodelCost {
  totalKwh
  totalCostUsd
  usdPerKwh
  items {
    name
    usd
  }
  tariffs {
    utility {
      id
      name
      shortName
    }
    id
    name
    code
    startDate
    endDate
  }
}
    `
export const RevampFinmodelFragmentDoc = `
    fragment RevampFinmodel on RevampFinmodel {
  __typename
  id
  pid
  createdAt
  type
  intervalsAndCostsXlsxHref
  buildingOwnerXlsxHref
  offerStatus
  fmvStr
  totalPvProductionKwh
  totalPvExportKwh
  bauCostPerYear
  derCostPerYear
  goal
  isVnem
  isGreenLease
  thirdPartySupplier {
    pid
    name
  }
  buildingOwner {
    noiYearOne
    noiLifetime
    noiAnnual
  }
  ppa {
    __typename
    ppaType
    ppaCostPerKwh
    ppaTermYears
    ppaEsc
    srecToInvestor
    offtakerXlsxHref
    product {
      productName
      financierName
    }
    roofRent {
      lifetimeUsd
      annualUsd
      usdPerSqft
      roofRentPerYear
    }
    tenantFlows {
      npv
      discountRate
      totalUtilitySavings
      totalCapex
      totalOpex
      totalNet
      netCashflowPerYear
    }
  }
  loan {
    __typename
    loanRecvrXlsxHref
    loanTermYears
    ownershipTermYears
    interestPct
    srecToInvestor
    product {
      productName
      financierName
      loanDealerFeePct
    }
    flows {
      monthlyPayment
      totalRevenue
      totalUtilitySavings
      totalOpex
      totalCapex
      totalItc
      totalLoanFunding
      totalLoanPayments
      totalNet
      netCashflowPerYear
      greenLeaseTenantFlows {
        totalNet
        netCashflowPerYear
        totalCapex
        totalOpex
        totalUtilitySavings
        npv
        discountRate
      }
    }
  }
  selfInvest {
    __typename
    npv
    discountRate
    selfInvestXlsxHref
    termYears
    srecToInvestor
    irrs {
      postTaxItcDepr
      postTaxItcDeprMultiple
    }
    product {
      productName
      financierName
    }
    flows {
      totalRevenue
      totalUtilitySavings
      totalOpex
      totalCapex
      totalItc
      totalNet
      netCashflowPerYear
      greenLeaseTenantFlows {
        totalNet
        netCashflowPerYear
        totalCapex
        totalOpex
        totalUtilitySavings
        npv
        discountRate
      }
    }
  }
  meters {
    name
    loadCategory
    meterSource
    bau {
      totalKwhFlow {
        ...KwhFlow
      }
    }
    der {
      totalKwhFlow {
        ...KwhFlow
      }
      averageDayKwhFlow {
        ...KwhFlow
      }
    }
  }
  systems {
    ...RevampSystem
  }
  utilityCosts {
    bau {
      ...FinmodelCost
    }
    der {
      ...FinmodelCost
    }
  }
}
    `
export const RevampCsFragmentDoc = `
    fragment RevampCS on RevampCS {
  __typename
  id
  termYears
  createdAt
  goal
  systems {
    ...RevampSystem
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
  }
  buildingOwner {
    noiYearOne
    noiLifetime
    noiAnnual
  }
  roofRent {
    lifetimeUsd
    annualUsd
    usdPerSqft
    npv
    discountRate
    roofRentPerYear
  }
  pricing {
    utility {
      id
      name
    }
    usdPerKwPerYear
    escalator
    minPvKw
    maxPvKw
  }
  leaseProjections {
    systemSizeKw
    annualRentLowerRangeUsd
    annualRentUpperRangeUsd
    methodology
  }
}
    `
export const HelioscopeFragmentDoc = `
    fragment Helioscope on Helioscope {
  pid
  roofPvKw
  carportPvKw
  groundPvKw
  systemProductivityKwhPerKw
  roofImage {
    id
    name
    downloadHref
  }
  pdf {
    downloadHref
    contentType
    name
    id
  }
  roofImageHref
  pdfHref
  dcNameplateKw
  acNameplateKw
  loadRatio
  moduleType
  inverterType
  rackingTiltDegrees
  rackingManufacturer
  rackingConnectionType
  notes
}
    `
export const ResultFragmentDoc = `
    fragment Result on Result {
  id
  pid
  createdAt
  salesPdfReportHref
  scenario {
    pid
    name
    solarLocation
    loadCategory
    includeStorage
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
    status
  }
  result {
    __typename
    ... on PhysicalCheck {
      createdAt
      roofIsGood
      carportIsGood
      existingSolar
      badRoof
      groundmountIsGood
    }
    ... on PolicyCheck {
      createdAt
      productType
      isGood
      disqualReason
    }
    ... on RevampFinmodelFailure {
      id
      createdAt
      fmvStr
      details {
        label
        description
      }
    }
    ... on RevampFinmodel {
      ...RevampFinmodel
      iterations {
        cashPurchaseNpv
        pvKw
        marginalCo2Averted
        storagePvKw
        storagePvKwh
      }
      meters {
        loadCategory
        meterSource
        bau {
          totalKwhFlow {
            ...KwhFlow
          }
        }
        der {
          totalKwhFlow {
            ...KwhFlow
          }
          averageDayKwhFlow {
            ...KwhFlow
          }
        }
      }
      emissions {
        bauCo2Tons
        derCo2Tons
        bauAverageDayCo2Tons
        derAverageDayCo2Tons
      }
    }
    ... on RevampCS {
      ...RevampCS
    }
    ... on Viability {
      isAllowed
      viabilityType: type
      reason
      level
    }
  }
  helioscope {
    ...Helioscope
  }
}
    `
export const BundleRowFragmentDoc = `
    fragment BundleRow on BundleRow {
  id
  site {
    ...RevampSiteBasics
    billingMeters {
      ...BillingMeterOption
    }
  }
  result {
    ...Result
    result {
      ... on RevampFinmodel {
        commOpDate
        investorDetails {
          irrs {
            postTaxItcDepr
          }
          capex
          investorXlsxHref
        }
        itcAssumptions {
          rate
          inLowIncomeCommunity
          inEnergyCommunity
          domesticMaterialsAdder
        }
      }
    }
  }
}
    `
export const BundleTableRowFragmentDoc = `
    fragment BundleTableRow on BundleRow {
  id
  state
  reason
  site {
    pid
    name
    fullAddress
    streetAddress
    city
    state
    zipCode
    targetUtility {
      name
      hostingCapacityMaps {
        url
        requiresLogin
        types
      }
    }
    siteDetails {
      roofReplacedYr
      roofCondition
    }
    doeReferenceType
    yearBuilt
    sqft
    roofSqft
    roofMaxPvKw
    numStories
    buildingClass
    isLowIncomeCommunity
    isEnergyCommunity
  }
  helioscope {
    pdfHref
    systemProductivityKwhPerKw
  }
  result {
    id
    result {
      __typename
      ... on RevampFinmodel {
        buildingOwnerXlsxHref
        commOpDate
        goal
        investorDetails {
          irrs {
            postTaxItcDepr
          }
          capex
          investorXlsxHref
        }
        buildingOwner {
          noiAnnual
        }
        utilityCosts {
          der {
            totalKwh
            usdPerKwh
            tariffs {
              name
              code
            }
          }
        }
        systems {
          ...RevampSystem
        }
        ppa {
          __typename
          ppaType
          ppaCostPerKwh
          ppaTermYears
          ppaEsc
          roofRent {
            annualUsd
          }
          srecToInvestor
          offtakerXlsxHref
          product {
            productName
            financierName
          }
        }
        loan {
          __typename
          loanRecvrXlsxHref
          loanTermYears
          ownershipTermYears
          interestPct
          product {
            productName
            financierName
            loanDealerFeePct
          }
        }
      }
      ... on RevampCS {
        id
        termYears
        goal
        systems {
          ...RevampSystem
        }
        roofRent {
          lifetimeUsd
          annualUsd
          usdPerSqft
        }
      }
    }
  }
}
    `
export const DecodedRateFragmentDoc = `
    fragment DecodedRate on DecodedRate {
  id
  name
  chargeClass
}
    `
export const CostOrTaxItemFragmentDoc = `
    fragment CostOrTaxItem on CostItemTaxItem {
  __typename
  ... on CostItem {
    rateObj {
      ...DecodedRate
    }
    name
    rateId
    chargeType
    chargeCategory
    volume
    rate
    cost
  }
  ... on TaxItem {
    taxId
    subtotal
    cost
    percentage
  }
}
    `
export const BillSectionFragmentDoc = `
    fragment BillSection on BillSection {
  name
  rates {
    ...DecodedRate
  }
  costs {
    ...CostOrTaxItem
  }
}
    `
export const FormattedBillFragmentDoc = `
    fragment FormattedBill on FormattedBills {
  rate {
    tariffId
    startDate
    endDate
  }
  bills {
    month
    charges {
      ...BillSection
    }
    exports {
      ...BillSection
    }
    kwhSupplyCharge
    kwhCharge
  }
}
    `
export const SiteBauMeterFragmentDoc = `
    fragment SiteBauMeter on BauMeter {
  id
  pid
  userVisibleLabel
  loadOrigin
  loadCategory
  formattedBill {
    ...FormattedBill
  }
  tariff {
    id
    name
    code
  }
  rollup {
    season
    days
    numbers
  }
  intervals {
    maxKw
    year
    units
    totalKwh
  }
  tariffUsdPerKwh
  totalCost
  importsKwh
}
    `
export const SiteMeterSetFragmentDoc = `
    fragment SiteMeterSet on RevampSite {
  meterSet {
    intervalsBauXlsxHref
    loadKwh
    loadMaxKw
    loadOrigin
    totalCost
    rollup {
      season
      days
      numbers
    }
    meters {
      ...SiteBauMeter
    }
  }
}
    `
export const ShineStatsFragmentDoc = `
    fragment ShineStats on ShineStats {
  numProperties
  pvKwInstalled
  totalCo2ReducedTonnes
  totalGrossRevenue
  totalPvProductionKwh
}
    `
export const ShineUnitFragmentDoc = `
    fragment ShineUnit on ShineUnit {
  duration
  start
  actualPvProductionKwh
  expectedPvProductionKwh
  actualGrossRevenue
  expectedGrossRevenue
  co2EmissionsReductionTonnes
}
    `
export const CleanRowDataFragmentDoc = `
    fragment CleanRowData on CleanRowData {
  customerId
  streetAddress
  city
  state
  zipCode
  buildingType
  sqft
}
    `
export const DirtyRowDataFragmentDoc = `
    fragment DirtyRowData on DirtyRowData {
  name
  assetManager
  customerId
  numStories
  streetAddress
  city
  state
  zipCode
  buildingType
  sqft
  yearBuilt
}
    `
export const CsvImportRowFragmentDoc = `
    fragment CsvImportRow on CsvImportRow {
  id
  site {
    pid
    name
  }
  dirty {
    ...DirtyRowData
  }
}
    `
export const CsvImportLabelsFragmentDoc = `
    fragment CsvImportLabels on CsvImport {
  pid
  labels {
    pid
    themeColor
    name
  }
}
    `
export const FancyFloatFragmentDoc = `
    fragment FancyFloat on FancyFloat {
  source
  number
}
    `
export const ProviderFragmentDoc = `
    fragment Provider on Provider {
  id
  createdAt
  user {
    ...UserRef
  }
  document {
    pid
    fileName
    contentType
    downloadHref
    viewHref
  }
  espmConsumption {
    id
    createdAt
    lastUpdatedAt
    externalConsumptionId
    externalData
    start
    end
    usageKwh
    costUsd
  }
}
    `
export const BillingMonthViewFragmentDoc = `
    fragment BillingMonthView on BillingMonthView {
  id
  start
  end
  usageKwh {
    ...FancyFloat
  }
  peakKw {
    ...FancyFloat
  }
  totalCostUsd {
    ...FancyFloat
  }
  supplyCostUsd {
    ...FancyFloat
  }
  transmissionCostUsd {
    ...FancyFloat
  }
  provider {
    ...Provider
  }
  supplyProvider {
    ...Provider
  }
}
    `
export const GroupedLineItemFragmentDoc = `
    fragment GroupedLineItem on GroupedLineItem {
  cost
  usage
  name
  rate
  group
  unit
}
    `
export const BillGroupFragmentDoc = `
    fragment BillGroup on BillGroup {
  group
  items {
    ...GroupedLineItem
  }
}
    `
export const BillingMeterProjectedFragmentDoc = `
    fragment BillingMeterProjected on Projected {
  year
  annualKwh
  peakKw
  annualCostUsd
  monthlyUsageKwh
  monthlyCostUsd
  kwh8760 {
    timeZone
    start
    year
  }
  costAndKwhDownloadHref
  tariff {
    id
    pid
    name
    code
  }
  monthlyBills {
    start
    end
    sections {
      ...BillGroup
    }
  }
}
    `
export const BillingIntervalViewFragmentDoc = `
    fragment BillingIntervalView on BillingIntervalView {
  id
  start
  end
  timeZone
  units
  numbers
  timestamps
  document {
    id
    pid
    fileName
    downloadHref
  }
}
    `
export const BillingMeterFragmentDoc = `
    fragment BillingMeter on BillingMeter {
  id
  pid
  view {
    name
    utilityMeterId
    supplyUtilityMeterId
    doeReferenceType
    loadCategory
    isDisabled
    isArchived
    utility {
      pid
      name
      shortName
    }
    tariff {
      id
      pid
      name
      code
    }
    tenantDetails {
      numUnitsTotal
      numUnitsStudio
      numUnits1Bd
      numUnits2Bd
      numUnits3Bd
      numUnits4Bd
    }
    numBills
    numIntervals
    totalAnnualKwh {
      ...FancyFloat
    }
    peakAnnualKw {
      ...FancyFloat
    }
    weeklyRollup
    months {
      ...BillingMonthView
    }
    calc2 {
      __typename
      ... on E2Error {
        msg
      }
      ... on Projected {
        ...BillingMeterProjected
      }
    }
    intervals {
      ...BillingIntervalView
    }
  }
}
    `
export const PublicTariffFragmentDoc = `
    fragment PublicTariff on PublicTariff {
  id
  pid
  name
  code
  tariffType
  isPreferred
  isNem2
  isClosed
  isPrimaryConnection
  customTariffId
  notes
  updatedAt
  trashedAt
  requiresPv
  requiresStorage
  hasTouRates
  hasNetMetering
  customerLikelihood
  customerCount
  customerClass
  minMonthlyKw
  maxMonthlyKw
  minMonthlyKwh
  maxMonthlyKwh
  latestRateId
}
    `
export const BasicBundleParentFragmentDoc = `
    fragment BasicBundleParent on BundleParent {
  id
  createdAt
  pid
  name
  type
  note
  pricingNote
  state
  biddingOpenAt
  biddingClosedAt
  opsOwner {
    ...UserRef
  }
  recvr {
    pid
    name
  }
  canAddNewBids
  canEditBids
  hiddenFromRecvr
  hiddenFromFinancier
  showAllBidsReport
}
    `
export const PvSystemSpecFragmentDoc = `
    fragment PvSystemSpec on PVSpec {
  id
  createdAt
  pvTypes
  sizeKwDc
  sizeKwAc
  helioscope2Id
  etbMeterId
  helioscopePdf {
    downloadHref
  }
  roofImage {
    viewHref
  }
  productionCsv {
    downloadHref
  }
  productionSource {
    id
    origin
  }
  allocations {
    id
    createdAt
    percentage
    meter {
      pid
      view {
        name
      }
    }
  }
}
    `
export const SystemFragmentDoc = `
    fragment System on System {
  id
  pid
  createdAt
  totalPvSizeKw
  pvSpecs {
    ...PvSystemSpec
  }
  batterySpecs {
    id
    sizeKwh
    sizeKwDc
    notes
    etbMeterName
    document {
      id
      pid
      fileName
      downloadHref
    }
    meter {
      pid
      view {
        name
      }
    }
  }
}
    `
export const PpaBidSpecFragmentDoc = `
    fragment PpaBidSpec on PPABidSpec {
  __typename
  id
  pid
  name
  termYears
  note
  archivedAt
  archivedBy {
    ...UserRef
  }
  ppaPriceY1Usd
  ppaPriceEscalator
  roofRentY1Usd
  roofRentEscalator
  buildingOwnerExtraPaymentsUsd
  itcPercentageAssumption
  interconnectionCostUsdPerWatt
  interconnectionCostUtilityMinUsd
  interconnectionCostUtilityMaxUsd
  interconnectionCostNonUtilityUsd
  recOwner
  system {
    ...System
  }
}
    `
export const SystemLiteFragmentDoc = `
    fragment SystemLite on SystemLite {
  id
  pid
  createdAt
  totalPvSizeKw
  pvSpecs {
    ...PvSystemSpec
  }
  batterySpecs {
    id
    sizeKwh
    sizeKwDc
    notes
  }
}
    `
export const CsBidSpecFragmentDoc = `
    fragment CsBidSpec on CSBidSpec {
  __typename
  id
  pid
  name
  termYears
  note
  archivedAt
  archivedBy {
    ...UserRef
  }
  roofRentY1Usd
  roofRentEscalator
  buildingOwnerExtraPaymentsUsd
  itcPercentageAssumption
  interconnectionCostUsdPerWatt
  interconnectionCostUtilityMinUsd
  interconnectionCostUtilityMaxUsd
  interconnectionCostNonUtilityUsd
  recOwner
  systemLite {
    ...SystemLite
  }
}
    `
export const InvestorBidSpecOptOutFragmentDoc = `
    fragment InvestorBidSpecOptOut on InvestorBidSpecOptOut {
  __typename
  createdAt
  createdBy {
    ...UserRef
  }
  archivedAt
  archivedBy {
    ...UserRef
  }
  reason
  customReason
}
    `
export const BidSpecFragmentDoc = `
    fragment BidSpec on BidSpec {
  ppa {
    ...PpaBidSpec
  }
  cs {
    ...CsBidSpec
  }
  optOut {
    ...InvestorBidSpecOptOut
  }
}
    `
export const BundleParentFragmentDoc = `
    fragment BundleParent on BundleParent {
  ...BasicBundleParent
  bundles {
    name
    pid
    financier {
      pid
      name
      orgSlug
    }
  }
  rows {
    specs {
      ...BidSpec
    }
    site {
      pid
      name
      streetAddress
      city
      state
      zipCode
    }
    notes
    status
    closedAt
    closeReason
    closeCustomReason
    scenario {
      pid
      name
      solarLocation
      includeStorage
    }
    awardedFinancier {
      pid
      name
      logoUrl
      logomarkUrl
    }
    recommendedBid {
      ppa {
        pid
      }
      cs {
        pid
      }
    }
  }
  documents {
    id
    pid
    tag
    fileName
    contentType
    dateCreated
    downloadHref
    canDelete
    ownerName
  }
}
    `
export const CustomBidReportFragmentDoc = `
    fragment CustomBidReport on CustomBidReport {
  pid
  name
  notes
  buildingOwnerNotes
  visibleToDevelopers
  visibleToBuildingOwners
  bids {
    ppa {
      pid
      financier {
        orgSlug
      }
    }
    cs {
      pid
      financier {
        orgSlug
      }
    }
  }
}
    `
export const DocumentParseRequestFragmentDoc = `
    fragment DocumentParseRequest on DocumentParseRequest {
  id
  createdAt
  status
  errorClass
  errorMessage
  document {
    id
    pid
    fileName
    contentType
    downloadHref
    viewHref
    ownerName
    ownerEmail
    dateCreated
  }
  results {
    parse {
      id
      start
      end
      totalKwh
      peakKw
      totalCostUsd
      supplyCostUsd
      transmissionCostUsd
      meterId
      tariffLabel
      kind
    }
    target {
      id
      pid
      label
      utilityMeterId
    }
    kind
  }
}
    `
export const InvestorOptOutFragmentDoc = `
    fragment InvestorOptOut on InvestorOptOut {
  __typename
  createdAt
  createdBy {
    ...UserRef
  }
  archivedAt
  archivedBy {
    ...UserRef
  }
  reason
  customReason
}
    `
export const BundleListItemFragmentDoc = `
    fragment BundleListItem on Bundle2 {
  pid
  name
  type
  note
  pricingNote
  state
  archivedAt
  lastViewed
  biddingOpenAt
  biddingClosedAt
  hasVisibleReports
  optOut {
    ...InvestorOptOut
  }
  totalBids
  recvr {
    pid
    name
    orgSlug
  }
  financier {
    pid
    name
    orgSlug
  }
  bidSubmissionStatus {
    bidStatus
    submittedBidCount
    totalRequestedBids
  }
  awardStatus {
    awardStatus
    awardedBidCount
    totalPossibleAwards
  }
}
    `
export const InvestorProfileFragmentDoc = `
    fragment InvestorProfile on InvestorProfile {
  hq
  yearFounded
  website
  description
  committedFunding
  distinguishingFeatures
  investorBacking
  managementTeam
  longTermOwnershipApproach
  subscriptionMgmtApproach
  experiences {
    state
    ftmEnergizedPvKw
    ftmAwardedPvKw
    btmEnergizedPvKw
    btmAwardedPvKw
  }
  buyBoxes {
    state
    ftmMinPortfolioSize
    ftmMinProjectSize
    ftmSeekingProjects
    btmMinPortfolioSize
    btmMinProjectSize
    btmSeekingProjects
  }
}
    `
export const PpaInvestorBidFragmentDoc = `
    fragment PpaInvestorBid on PPAInvestorBid {
  __typename
  pid
  spec {
    pid
  }
  financier {
    pid
    name
    logoUrl
    logomarkUrl
    profile {
      ...InvestorProfile
    }
  }
  name
  termYears
  ppaPriceY1Usd
  ppaPriceEscalator
  roofRentY1Usd
  roofRentEscalator
  interconnectionCostUsdPerWatt
  interconnectionCostUtilityMinUsd
  interconnectionCostUtilityMaxUsd
  interconnectionCostNonUtilityUsd
  itcPercentageAssumption
  estimatedCod
  estimatedNtp
  buildingOwnerExtraPaymentsUsd
  recOwner
  tariffProvision
  otherNotes
  extraPaymentsNotes
  incentivesNotes
  interconnectionNotes
  interconnectionRepriceProcessNotes
  status
  system {
    ...System
  }
  result {
    ...RevampFinmodel
  }
}
    `
export const CsInvestorBidFragmentDoc = `
    fragment CsInvestorBid on CSInvestorBid {
  __typename
  pid
  spec {
    pid
  }
  financier {
    pid
    name
    logoUrl
    logomarkUrl
    profile {
      ...InvestorProfile
    }
  }
  name
  termYears
  roofRentEscalator
  roofRentY1Usd
  buildingOwnerExtraPaymentsUsd
  interconnectionCostUsdPerWatt
  interconnectionCostUtilityMinUsd
  interconnectionCostUtilityMaxUsd
  interconnectionCostNonUtilityUsd
  itcPercentageAssumption
  estimatedAwardDate
  estimatedCod
  estimatedNtp
  recOwner
  tariffProvision
  incentivesNotes
  interconnectionNotes
  interconnectionRepriceProcessNotes
  extraPaymentsNotes
  otherNotes
  status
  systemLite {
    ...SystemLite
  }
  result {
    ...RevampCS
  }
}
    `
export const InvestorBidFragmentDoc = `
    fragment InvestorBid on InvestorBid {
  ppa {
    ...PpaInvestorBid
  }
  cs {
    ...CsInvestorBid
  }
}
    `
export const BundleDetailRowFragmentDoc = `
    fragment BundleDetailRow on BundleRow2 {
  id
  ppaType
  state
  reason
  customReason
  notes
  optOut {
    ...InvestorOptOut
  }
  bids {
    ...InvestorBid
  }
  specs {
    ...BidSpec
  }
}
    `
export const BoxplotStatsFragmentDoc = `
    fragment BoxplotStats on BoxplotStats {
  min
  q1
  median
  q3
  max
  average
}
    `
export const CsSiteBidReportFragmentDoc = `
    fragment CSSiteBidReport on CSSiteBidReport {
  __typename
  site {
    pid
    name
    isFavorite
    streetAddress
    city
    state
    zipCode
    county
    fullAddress
  }
  awarded
  awardedPid
  totalBids
  bids {
    __typename
    name
    pid
    financier {
      pid
      name
      logoUrl
      logomarkUrl
      profile {
        ...InvestorProfile
      }
    }
    name
    termYears
    roofRentEscalator
    roofRentY1Usd
    buildingOwnerExtraPaymentsUsd
    interconnectionCostUsdPerWatt
    interconnectionCostUtilityMinUsd
    interconnectionCostUtilityMaxUsd
    interconnectionCostNonUtilityUsd
    itcPercentageAssumption
    estimatedAwardDate
    estimatedCod
    estimatedNtp
    recOwner
    tariffProvision
    incentivesNotes
    interconnectionNotes
    interconnectionRepriceProcessNotes
    extraPaymentsNotes
    otherNotes
    result {
      buildingOwner {
        noiLifetime
      }
    }
  }
  noi {
    ...BoxplotStats
  }
  y1RoofRent {
    ...BoxplotStats
  }
  systemSize {
    ...BoxplotStats
  }
  itcPercentageAssumption {
    ...BoxplotStats
  }
  roofRentEscalator {
    ...BoxplotStats
  }
  npv {
    ...BoxplotStats
  }
}
    `
export const PpaSiteBidReportFragmentDoc = `
    fragment PPASiteBidReport on PPASiteBidReport {
  __typename
  site {
    pid
    name
    isFavorite
    streetAddress
    city
    state
    zipCode
    county
    fullAddress
  }
  awarded
  awardedPid
  totalBids
  bids {
    __typename
    name
    pid
    financier {
      pid
      name
      logoUrl
      logomarkUrl
      profile {
        ...InvestorProfile
      }
    }
    name
    termYears
    roofRentEscalator
    roofRentY1Usd
    buildingOwnerExtraPaymentsUsd
    interconnectionCostUsdPerWatt
    interconnectionCostUtilityMinUsd
    interconnectionCostUtilityMaxUsd
    interconnectionCostNonUtilityUsd
    itcPercentageAssumption
    estimatedCod
    estimatedNtp
    recOwner
    tariffProvision
    incentivesNotes
    interconnectionNotes
    interconnectionRepriceProcessNotes
    extraPaymentsNotes
    otherNotes
    result {
      buildingOwner {
        noiLifetime
      }
    }
  }
  noi {
    ...BoxplotStats
  }
  y1RoofRent {
    ...BoxplotStats
  }
  systemSize {
    ...BoxplotStats
  }
  itcPercentageAssumption {
    ...BoxplotStats
  }
  ppaPriceEscalator {
    ...BoxplotStats
  }
  npv {
    ...BoxplotStats
  }
}
    `
export const BidReportFragmentDoc = `
    fragment BidReport on PackageBidReport {
  pid
  name
  notes
  visible
  totalDevelopers
  totalBids
  cs {
    ...CSSiteBidReport
  }
  ppa {
    ...PPASiteBidReport
  }
}
    `
export const BundleDetailFragmentDoc = `
    fragment BundleDetail on Bundle2 {
  ...BundleListItem
  opsOwner {
    ...UserRef
    meetingSchedulingUrl
  }
  parentRef {
    pid
  }
  documents {
    canDelete
    contentType
    dateCreated
    fileName
    ownerName
    pid
    tag
    downloadHref
    viewHref
    belongsToBundleParent
  }
  downloadBundleDocsZipHref
  downloadHelioscopesDotZipHref
  downloadBundleDotXlsxHref
  rows {
    ...BundleDetailRow
    site {
      pid
      name
      fullAddress
      streetAddress
      city
      state
      zipCode
      county
      cbsaName
      buildingData {
        ownerName
      }
      doeReferenceType
      siteDetails {
        roofReplacedYr
        roofCondition
      }
      yearBuilt
      targetUtility {
        pid
        name
        hostingCapacityMaps {
          url
          requiresLogin
          types
        }
      }
      isEnergyCommunity
      isLowIncomeCommunity
      sqft
      roofSqft
      roofMaxPvKw
      numStories
      buildingClass
    }
  }
  bidReports {
    ...BidReport
  }
}
    `
export const BundleRowDetailFragmentDoc = `
    fragment BundleRowDetail on BundleRow2 {
  ...BundleDetailRow
  site {
    ...RevampSiteBasics
    meterSet {
      totalCost
      loadKwh
    }
    billingMeters {
      ...BillingMeterOption
    }
  }
}
    `
export const Helioscope2RefFragmentDoc = `
    fragment Helioscope2Ref on Helioscope2 {
  id
  pdf {
    downloadHref
  }
  roofImage {
    viewHref
  }
  productionCsv {
    downloadHref
  }
}
    `
export const BasicBidPackageFragmentDoc = `
    fragment BasicBidPackage on BidPackage {
  pid
  name
  biddingOpenAt
  biddingClosedAt
  state
  type
  totalRows
  financiers {
    pid
    name
    orgSlug
    logoUrl
    logomarkUrl
    profile {
      ...InvestorProfile
    }
  }
}
    `
export const BidPackageDetailFragmentDoc = `
    fragment BidPackageDetail on BidPackage {
  ...BasicBidPackage
  documents {
    canDelete
    contentType
    dateCreated
    fileName
    ownerName
    pid
    tag
    downloadHref
    belongsToBundleParent
  }
}
    `
export const BidReviewFragmentDoc = `
    fragment BidReview on BidReview {
  recommendedBidPids
  reports {
    properties
    bidders
    uniqueBids
    avgRoofRentY1Usd
    isCustom
    report {
      ...BidReport
    }
  }
}
    `
export const RateBandFragmentDoc = `
    fragment RateBand on RateBand {
  tariffRateBandId
  rateUnit
  price
  isCredit
  applicabilityValue
}
    `
export const SeasonFragmentDoc = `
    fragment Season on Season {
  seasonFromDay
  seasonFromMonth
  seasonToDay
  seasonToMonth
}
    `
export const RateFragmentDoc = `
    fragment Rate on Rate {
  name
  groupName
  tariffRateId
  chargeClass
  chargeType
  transactionType
  chargePeriod
  applicabilityKey
  applicabilityValues
  quantityKey
  applicableBands {
    ...RateBand
  }
  bands {
    ...RateBand
  }
  tou {
    touName
    touType
    touPeriods {
      fromHour
      fromMinute
      fromDayOfWeek
      toHour
      toMinute
      toDayOfWeek
    }
    season {
      ...Season
    }
  }
  season {
    ...Season
  }
}
    `
export const CustomRateFragmentDoc = `
    fragment CustomRate on CustomRate {
  name
  chargeClass
  chargeType
  transactionType
  price
  rateUnit
  chargePeriod
}
    `
export const TariffOpFragmentDoc = `
    fragment TariffOp on AddRateSubRateOverrideProperty {
  __typename
  ... on AddRate {
    rate {
      ...CustomRate
    }
    op
  }
  ... on SubRate {
    chargeClass
    rateId
    op
  }
  ... on OverrideProperty {
    keyName
    propertyValue
    op
  }
}
    `
export const ChangeLogEntryFragmentDoc = `
    fragment ChangeLogEntry on ChangeLogEntry {
  source
  sourceId
  oldValue
  newValue
  columnType
  changedAt
}
    `
export const FieldChangeLogHistoryFragmentDoc = `
    fragment FieldChangeLogHistory on FieldChangeLogHistory {
  latest {
    ...ChangeLogEntry
  }
  history {
    ...ChangeLogEntry
  }
}
    `
export const SiteFieldChangeLogFragmentDoc = `
    fragment SiteFieldChangeLog on SiteFieldChangeLog {
  occupancyType {
    ...FieldChangeLogHistory
  }
  leaseType {
    ...FieldChangeLogHistory
  }
  targetUtilityId {
    ...FieldChangeLogHistory
  }
  tenantLeaseTerm {
    ...FieldChangeLogHistory
  }
}
    `
export const SiteDetailsFieldChangeLogFragmentDoc = `
    fragment SiteDetailsFieldChangeLog on SiteDetailsFieldChangeLog {
  buildingLegalName {
    ...FieldChangeLogHistory
  }
  constructionEmail {
    ...FieldChangeLogHistory
  }
  counselApproval {
    ...FieldChangeLogHistory
  }
  externalLeaseApprovers {
    ...FieldChangeLogHistory
  }
  isFannieMaeLender {
    ...FieldChangeLogHistory
  }
  isFmGlobalInsurer {
    ...FieldChangeLogHistory
  }
  leaseApprovers {
    ...FieldChangeLogHistory
  }
  leaseLegalOwnerName {
    ...FieldChangeLogHistory
  }
  leasePropertyLegalDescription {
    ...FieldChangeLogHistory
  }
  leaseSignatory {
    ...FieldChangeLogHistory
  }
  needsTenantApproval {
    ...FieldChangeLogHistory
  }
  propertyFundName {
    ...FieldChangeLogHistory
  }
  propertyInsurer {
    ...FieldChangeLogHistory
  }
  propertyLenders {
    ...FieldChangeLogHistory
  }
  propertySiteVisitContacts {
    ...FieldChangeLogHistory
  }
  roofCondition {
    ...FieldChangeLogHistory
  }
  roofReplacedYr {
    ...FieldChangeLogHistory
  }
  roofRightsHolder {
    ...FieldChangeLogHistory
  }
  salePlannedYear {
    ...FieldChangeLogHistory
  }
  salePlans {
    ...FieldChangeLogHistory
  }
  signatureBlocks {
    ...FieldChangeLogHistory
  }
}
    `
export const MutBillingMeterFragmentDoc = `
    fragment MutBillingMeter on BillingMeter {
  __typename
  ... on BillingMeter {
    pid
    label
    config {
      loadCategory
      doeReferenceType
    }
  }
}
    `
export const EtbExtractFragmentDoc = `
    fragment EtbExtract on ETBExtract {
  id
  document {
    id
    pid
    fileName
    downloadHref
  }
  pv {
    sizeKwDc
    sizeKwAc
    etbMeterId
    etbMeterName
  }
  battery {
    sizeKwDc
    sizeKwh
    etbMeterId
    etbMeterName
  }
}
    `
export const PossibleTariffFragmentDoc = `
    fragment PossibleTariff on Tariff {
  id
  name
  code
  customerClass
  customerCount
  customerLikelihood
  isPreferred
  minMonthlyKw
  maxMonthlyKw
  minMonthlyKwh
  maxMonthlyKwh
  masterTariffId
  hasNetMetering
  requiresPv
  requiresStorage
  tariffType
}
    `
export const ResultRefFragmentDoc = `
    fragment ResultRef on Result {
  id
  pid
  createdAt
  scenario {
    pid
    name
    solarLocation
    loadCategory
    includeStorage
  }
  financing {
    id
    name
    type
    financierName
    financierPid
    financierLogo
    financierLogomark
    isThirdParty
    status
  }
}
    `
export const ResultWithEnergyDataFragmentDoc = `
    fragment ResultWithEnergyData on Result {
  id
  result {
    ... on RevampFinmodel {
      meters {
        loadCategory
        meterSource
        bau {
          totalKwhFlow {
            ...KwhFlow
          }
        }
        der {
          totalKwhFlow {
            ...KwhFlow
          }
          averageDayKwhFlow {
            ...KwhFlow
          }
        }
      }
      emissions {
        bauCo2Tons
        derCo2Tons
        bauAverageDayCo2Tons
        derAverageDayCo2Tons
      }
    }
  }
}
    `
export const BidRevampSiteFragmentDoc = `
    fragment BidRevampSite on RevampSite {
  pid
  name
  streetAddress
  city
  state
  zipCode
  county
  fullAddress
  assetManager
  doeReferenceType
  meterSet {
    totalCost
    loadKwh
  }
  yearBuilt
  numStories
  sqft
  roofSqft
  siteDetails {
    salePlans
    roofCondition
    roofReplacedYr
  }
  roofMaxPvKw
  buildingClass
  targetUtility {
    name
    pid
    id
  }
  ppaType
}
    `
export const SiteVisualsFragmentDoc = `
    fragment SiteVisuals on SiteVisuals {
  solarPanels {
    latitude
    longitude
    angle
  }
}
    `
export const BasicEvCalcFragmentDoc = `
    fragment BasicEVCalc on EVCalc {
  id
  createdAt
  projectInputs {
    projectStartDate
    installType
    termYears
    chargerKw
    yr0NumTenantEvs
    discountRate
  }
  outputs {
    irr
    npv
    yr0NumTenantEvs
    breakevenYear
    numChargersDemandedSeries
    cashflowSeries
    revenueSeries
    incentiveUsd
  }
  numChargers
  optimalNumChargers
  npv
  markupUsdPerKwh
  tariffRate {
    parent {
      name
      code
    }
  }
  utility {
    shortName
  }
  timeZone
  dayRates
  seasonalDayRates {
    name
    startMonth
    endMonth
    dayRates
  }
  downloadHourlyRatesHref
  xlsx
  downloadXlsxHref
  optIters {
    numChargers
    npv
  }
  yr3Revenue
  yr3Cashflow
  yr3NumEvs
  parkingRatio
  year3Expenses {
    label
    value
  }
  installCosts {
    label
    value
  }
}
    `
export const DocumentFragmentDoc = `
    fragment Document on Document {
  id
  pid
  contentType
  dateCreated
  fileName
  ownerName
  ownerEmail
  downloadHref
  viewHref
  tag
}
    `
export const SetPropertyNameDocument = `
    mutation SetPropertyName($propertyPid: String!, $propertyName: String!) {
  setPropertyName(sitePid: $propertyPid, propertyName: $propertyName) {
    __typename
    ... on PortfolioSite {
      pid
      propertyName
    }
    ... on Error {
      message
    }
  }
}
    `

export const useSetPropertyNameMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetPropertyNameMutation,
    TError,
    SetPropertyNameMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetPropertyNameMutation,
    TError,
    SetPropertyNameMutationVariables,
    TContext
  >({
    mutationKey: ["SetPropertyName"],
    mutationFn: (variables?: SetPropertyNameMutationVariables) =>
      publicFetcher<SetPropertyNameMutation, SetPropertyNameMutationVariables>(
        SetPropertyNameDocument,
        variables,
      )(),
    ...options,
  })
}

useSetPropertyNameMutation.fetcher = (
  variables: SetPropertyNameMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetPropertyNameMutation, SetPropertyNameMutationVariables>(
    SetPropertyNameDocument,
    variables,
    options,
  )

export const TrackEventDocument = `
    mutation TrackEvent($input: RecordUserEventInput!) {
  recordUserEvent(input: $input) {
    __typename
    message
  }
}
    `

export const useTrackEventMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    TrackEventMutation,
    TError,
    TrackEventMutationVariables,
    TContext
  >,
) => {
  return useMutation<TrackEventMutation, TError, TrackEventMutationVariables, TContext>(
    {
      mutationKey: ["TrackEvent"],
      mutationFn: (variables?: TrackEventMutationVariables) =>
        publicFetcher<TrackEventMutation, TrackEventMutationVariables>(
          TrackEventDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useTrackEventMutation.fetcher = (
  variables: TrackEventMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<TrackEventMutation, TrackEventMutationVariables>(
    TrackEventDocument,
    variables,
    options,
  )

export const LogPageViewDocument = `
    mutation LogPageView($input: LogPageViewInput!) {
  logPageView(input: $input) {
    __typename
    message
  }
}
    `

export const useLogPageViewMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    LogPageViewMutation,
    TError,
    LogPageViewMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    LogPageViewMutation,
    TError,
    LogPageViewMutationVariables,
    TContext
  >({
    mutationKey: ["LogPageView"],
    mutationFn: (variables?: LogPageViewMutationVariables) =>
      publicFetcher<LogPageViewMutation, LogPageViewMutationVariables>(
        LogPageViewDocument,
        variables,
      )(),
    ...options,
  })
}

useLogPageViewMutation.fetcher = (
  variables: LogPageViewMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<LogPageViewMutation, LogPageViewMutationVariables>(
    LogPageViewDocument,
    variables,
    options,
  )

export const AcceptSelectOffersLicenseAgreementDocument = `
    mutation AcceptSelectOffersLicenseAgreement {
  acceptLicenseAgreement(version: 1, agreementType: SELECT_OFFERS) {
    __typename
    message
  }
}
    `

export const useAcceptSelectOffersLicenseAgreementMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AcceptSelectOffersLicenseAgreementMutation,
    TError,
    AcceptSelectOffersLicenseAgreementMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AcceptSelectOffersLicenseAgreementMutation,
    TError,
    AcceptSelectOffersLicenseAgreementMutationVariables,
    TContext
  >({
    mutationKey: ["AcceptSelectOffersLicenseAgreement"],
    mutationFn: (variables?: AcceptSelectOffersLicenseAgreementMutationVariables) =>
      publicFetcher<
        AcceptSelectOffersLicenseAgreementMutation,
        AcceptSelectOffersLicenseAgreementMutationVariables
      >(AcceptSelectOffersLicenseAgreementDocument, variables)(),
    ...options,
  })
}

useAcceptSelectOffersLicenseAgreementMutation.fetcher = (
  variables?: AcceptSelectOffersLicenseAgreementMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    AcceptSelectOffersLicenseAgreementMutation,
    AcceptSelectOffersLicenseAgreementMutationVariables
  >(AcceptSelectOffersLicenseAgreementDocument, variables, options)

export const SetOrgSettingsDocument = `
    mutation SetOrgSettings($orgPid: String!, $irrFlavor: IRRType!) {
  setOrgSettings(orgPid: $orgPid, irrFlavor: $irrFlavor) {
    __typename
    ... on Org {
      pid
      irrFlavor
    }
  }
}
    `

export const useSetOrgSettingsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetOrgSettingsMutation,
    TError,
    SetOrgSettingsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetOrgSettingsMutation,
    TError,
    SetOrgSettingsMutationVariables,
    TContext
  >({
    mutationKey: ["SetOrgSettings"],
    mutationFn: (variables?: SetOrgSettingsMutationVariables) =>
      publicFetcher<SetOrgSettingsMutation, SetOrgSettingsMutationVariables>(
        SetOrgSettingsDocument,
        variables,
      )(),
    ...options,
  })
}

useSetOrgSettingsMutation.fetcher = (
  variables: SetOrgSettingsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetOrgSettingsMutation, SetOrgSettingsMutationVariables>(
    SetOrgSettingsDocument,
    variables,
    options,
  )

export const ClaimOpenInviteDocument = `
    mutation ClaimOpenInvite($input: ClaimOpenInviteInput!) {
  claimOpenInvite(input: $input) {
    __typename
    ... on AuthUser {
      ...AuthUser
    }
    ... on Error {
      message
    }
  }
}
    ${AuthUserFragmentDoc}`

export const useClaimOpenInviteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ClaimOpenInviteMutation,
    TError,
    ClaimOpenInviteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ClaimOpenInviteMutation,
    TError,
    ClaimOpenInviteMutationVariables,
    TContext
  >({
    mutationKey: ["ClaimOpenInvite"],
    mutationFn: (variables?: ClaimOpenInviteMutationVariables) =>
      publicFetcher<ClaimOpenInviteMutation, ClaimOpenInviteMutationVariables>(
        ClaimOpenInviteDocument,
        variables,
      )(),
    ...options,
  })
}

useClaimOpenInviteMutation.fetcher = (
  variables: ClaimOpenInviteMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ClaimOpenInviteMutation, ClaimOpenInviteMutationVariables>(
    ClaimOpenInviteDocument,
    variables,
    options,
  )

export const InviteToOrgDocument = `
    mutation InviteToOrg($input: InviteToOrgInput!) {
  inviteToOrg(input: $input) {
    __typename
    pid
  }
}
    `

export const useInviteToOrgMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    InviteToOrgMutation,
    TError,
    InviteToOrgMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    InviteToOrgMutation,
    TError,
    InviteToOrgMutationVariables,
    TContext
  >({
    mutationKey: ["InviteToOrg"],
    mutationFn: (variables?: InviteToOrgMutationVariables) =>
      publicFetcher<InviteToOrgMutation, InviteToOrgMutationVariables>(
        InviteToOrgDocument,
        variables,
      )(),
    ...options,
  })
}

useInviteToOrgMutation.fetcher = (
  variables: InviteToOrgMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<InviteToOrgMutation, InviteToOrgMutationVariables>(
    InviteToOrgDocument,
    variables,
    options,
  )

export const InviteToPortfolioDocument = `
    mutation InviteToPortfolio($input: InviteToPortfolioInput!) {
  inviteToPortfolio(input: $input) {
    __typename
    ... on Portfolio {
      pid
    }
    ... on Error {
      message
    }
  }
}
    `

export const useInviteToPortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    InviteToPortfolioMutation,
    TError,
    InviteToPortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    InviteToPortfolioMutation,
    TError,
    InviteToPortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["InviteToPortfolio"],
    mutationFn: (variables?: InviteToPortfolioMutationVariables) =>
      publicFetcher<InviteToPortfolioMutation, InviteToPortfolioMutationVariables>(
        InviteToPortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useInviteToPortfolioMutation.fetcher = (
  variables: InviteToPortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<InviteToPortfolioMutation, InviteToPortfolioMutationVariables>(
    InviteToPortfolioDocument,
    variables,
    options,
  )

export const CreateAndApplySiteLabelDocument = `
    mutation CreateAndApplySiteLabel($input: CreateAndApplySiteLabelInput!) {
  createAndApplySiteLabel(input: $input) {
    __typename
    ... on Error {
      message
    }
    ... on CreateAndApplySiteLabelOutput {
      label {
        ...SiteLabelDetail
      }
    }
  }
}
    ${SiteLabelDetailFragmentDoc}
${SiteLabelRefFragmentDoc}
${UserRefFragmentDoc}`

export const useCreateAndApplySiteLabelMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateAndApplySiteLabelMutation,
    TError,
    CreateAndApplySiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateAndApplySiteLabelMutation,
    TError,
    CreateAndApplySiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["CreateAndApplySiteLabel"],
    mutationFn: (variables?: CreateAndApplySiteLabelMutationVariables) =>
      publicFetcher<
        CreateAndApplySiteLabelMutation,
        CreateAndApplySiteLabelMutationVariables
      >(CreateAndApplySiteLabelDocument, variables)(),
    ...options,
  })
}

useCreateAndApplySiteLabelMutation.fetcher = (
  variables: CreateAndApplySiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    CreateAndApplySiteLabelMutation,
    CreateAndApplySiteLabelMutationVariables
  >(CreateAndApplySiteLabelDocument, variables, options)

export const ApplyLabelToSitesDocument = `
    mutation ApplyLabelToSites($input: ApplyLabelToSitesInput!) {
  applyLabelToSites(input: $input) {
    __typename
    ... on Error {
      message
    }
  }
}
    `

export const useApplyLabelToSitesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ApplyLabelToSitesMutation,
    TError,
    ApplyLabelToSitesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ApplyLabelToSitesMutation,
    TError,
    ApplyLabelToSitesMutationVariables,
    TContext
  >({
    mutationKey: ["ApplyLabelToSites"],
    mutationFn: (variables?: ApplyLabelToSitesMutationVariables) =>
      publicFetcher<ApplyLabelToSitesMutation, ApplyLabelToSitesMutationVariables>(
        ApplyLabelToSitesDocument,
        variables,
      )(),
    ...options,
  })
}

useApplyLabelToSitesMutation.fetcher = (
  variables: ApplyLabelToSitesMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ApplyLabelToSitesMutation, ApplyLabelToSitesMutationVariables>(
    ApplyLabelToSitesDocument,
    variables,
    options,
  )

export const RemoveLabelFromSitesDocument = `
    mutation RemoveLabelFromSites($input: RemoveLabelFromSitesInput!) {
  removeLabelFromSites(input: $input) {
    __typename
    ... on Error {
      message
    }
  }
}
    `

export const useRemoveLabelFromSitesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RemoveLabelFromSitesMutation,
    TError,
    RemoveLabelFromSitesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveLabelFromSitesMutation,
    TError,
    RemoveLabelFromSitesMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveLabelFromSites"],
    mutationFn: (variables?: RemoveLabelFromSitesMutationVariables) =>
      publicFetcher<
        RemoveLabelFromSitesMutation,
        RemoveLabelFromSitesMutationVariables
      >(RemoveLabelFromSitesDocument, variables)(),
    ...options,
  })
}

useRemoveLabelFromSitesMutation.fetcher = (
  variables: RemoveLabelFromSitesMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RemoveLabelFromSitesMutation, RemoveLabelFromSitesMutationVariables>(
    RemoveLabelFromSitesDocument,
    variables,
    options,
  )

export const DeleteSiteLabelDocument = `
    mutation DeleteSiteLabel($input: DeleteSiteLabelInput!) {
  deleteSiteLabel(input: $input) {
    __typename
    ... on Error {
      message
    }
  }
}
    `

export const useDeleteSiteLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteSiteLabelMutation,
    TError,
    DeleteSiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteSiteLabelMutation,
    TError,
    DeleteSiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteSiteLabel"],
    mutationFn: (variables?: DeleteSiteLabelMutationVariables) =>
      publicFetcher<DeleteSiteLabelMutation, DeleteSiteLabelMutationVariables>(
        DeleteSiteLabelDocument,
        variables,
      )(),
    ...options,
  })
}

useDeleteSiteLabelMutation.fetcher = (
  variables: DeleteSiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<DeleteSiteLabelMutation, DeleteSiteLabelMutationVariables>(
    DeleteSiteLabelDocument,
    variables,
    options,
  )

export const RenameSiteLabelDocument = `
    mutation RenameSiteLabel($input: RenameSiteLabelInput!) {
  renameSiteLabel(input: $input) {
    __typename
    ... on Error {
      message
    }
    ... on RenameSiteLabelOutput {
      label {
        ...SiteLabelDetail
      }
    }
  }
}
    ${SiteLabelDetailFragmentDoc}
${SiteLabelRefFragmentDoc}
${UserRefFragmentDoc}`

export const useRenameSiteLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RenameSiteLabelMutation,
    TError,
    RenameSiteLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RenameSiteLabelMutation,
    TError,
    RenameSiteLabelMutationVariables,
    TContext
  >({
    mutationKey: ["RenameSiteLabel"],
    mutationFn: (variables?: RenameSiteLabelMutationVariables) =>
      publicFetcher<RenameSiteLabelMutation, RenameSiteLabelMutationVariables>(
        RenameSiteLabelDocument,
        variables,
      )(),
    ...options,
  })
}

useRenameSiteLabelMutation.fetcher = (
  variables: RenameSiteLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RenameSiteLabelMutation, RenameSiteLabelMutationVariables>(
    RenameSiteLabelDocument,
    variables,
    options,
  )

export const ChangeSiteLabelColorDocument = `
    mutation ChangeSiteLabelColor($input: ChangeSiteLabelColorInput!) {
  changeSiteLabelColor(input: $input) {
    __typename
    ... on Error {
      message
    }
    ... on ChangeSiteLabelColorOutput {
      label {
        ...SiteLabelDetail
      }
    }
  }
}
    ${SiteLabelDetailFragmentDoc}
${SiteLabelRefFragmentDoc}
${UserRefFragmentDoc}`

export const useChangeSiteLabelColorMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ChangeSiteLabelColorMutation,
    TError,
    ChangeSiteLabelColorMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ChangeSiteLabelColorMutation,
    TError,
    ChangeSiteLabelColorMutationVariables,
    TContext
  >({
    mutationKey: ["ChangeSiteLabelColor"],
    mutationFn: (variables?: ChangeSiteLabelColorMutationVariables) =>
      publicFetcher<
        ChangeSiteLabelColorMutation,
        ChangeSiteLabelColorMutationVariables
      >(ChangeSiteLabelColorDocument, variables)(),
    ...options,
  })
}

useChangeSiteLabelColorMutation.fetcher = (
  variables: ChangeSiteLabelColorMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ChangeSiteLabelColorMutation, ChangeSiteLabelColorMutationVariables>(
    ChangeSiteLabelColorDocument,
    variables,
    options,
  )

export const UploadDocumentDocument = `
    mutation UploadDocument($sitePid: String, $bundlePid: String, $bundleParentPid: String, $file: Upload!, $tag: String) {
  documents {
    uploadDocument(
      sitePid: $sitePid
      bundlePid: $bundlePid
      bundleParentPid: $bundleParentPid
      upload: $file
      tag: $tag
    ) {
      __typename
      ... on Document {
        ...Document
        csvPeek
      }
      ... on Error {
        message
      }
    }
  }
}
    ${DocumentFragmentDoc}`

export const useUploadDocumentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UploadDocumentMutation,
    TError,
    UploadDocumentMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UploadDocumentMutation,
    TError,
    UploadDocumentMutationVariables,
    TContext
  >({
    mutationKey: ["UploadDocument"],
    mutationFn: (variables?: UploadDocumentMutationVariables) =>
      publicFetcher<UploadDocumentMutation, UploadDocumentMutationVariables>(
        UploadDocumentDocument,
        variables,
      )(),
    ...options,
  })
}

useUploadDocumentMutation.fetcher = (
  variables: UploadDocumentMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UploadDocumentMutation, UploadDocumentMutationVariables>(
    UploadDocumentDocument,
    variables,
    options,
  )

export const DeleteDocumentDocument = `
    mutation DeleteDocument($documentPid: String!) {
  documents {
    deleteDocument(documentPid: $documentPid) {
      __typename
      ... on Error {
        message
      }
    }
  }
}
    `

export const useDeleteDocumentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteDocumentMutation,
    TError,
    DeleteDocumentMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteDocumentMutation,
    TError,
    DeleteDocumentMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteDocument"],
    mutationFn: (variables?: DeleteDocumentMutationVariables) =>
      publicFetcher<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
        DeleteDocumentDocument,
        variables,
      )(),
    ...options,
  })
}

useDeleteDocumentMutation.fetcher = (
  variables: DeleteDocumentMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<DeleteDocumentMutation, DeleteDocumentMutationVariables>(
    DeleteDocumentDocument,
    variables,
    options,
  )

export const SetDocumentTagDocument = `
    mutation SetDocumentTag($pid: String!, $sitePid: String, $bundlePid: String, $bundleParentPid: String, $tag: DocumentTag!) {
  documents {
    setDocumentTag(
      pid: $pid
      sitePid: $sitePid
      bundlePid: $bundlePid
      bundleParentPid: $bundleParentPid
      tag: $tag
    ) {
      __typename
      ... on Document {
        pid
        tag
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const useSetDocumentTagMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetDocumentTagMutation,
    TError,
    SetDocumentTagMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetDocumentTagMutation,
    TError,
    SetDocumentTagMutationVariables,
    TContext
  >({
    mutationKey: ["SetDocumentTag"],
    mutationFn: (variables?: SetDocumentTagMutationVariables) =>
      publicFetcher<SetDocumentTagMutation, SetDocumentTagMutationVariables>(
        SetDocumentTagDocument,
        variables,
      )(),
    ...options,
  })
}

useSetDocumentTagMutation.fetcher = (
  variables: SetDocumentTagMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetDocumentTagMutation, SetDocumentTagMutationVariables>(
    SetDocumentTagDocument,
    variables,
    options,
  )

export const OrgSetIsFavoriteDocument = `
    mutation OrgSetIsFavorite($orgSlug: String!, $sitePids: [String!]!, $isFavorite: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    setIsFavorite(sitePids: $sitePids, isFavorite: $isFavorite) {
      message
    }
  }
}
    `

export const useOrgSetIsFavoriteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    OrgSetIsFavoriteMutation,
    TError,
    OrgSetIsFavoriteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    OrgSetIsFavoriteMutation,
    TError,
    OrgSetIsFavoriteMutationVariables,
    TContext
  >({
    mutationKey: ["OrgSetIsFavorite"],
    mutationFn: (variables?: OrgSetIsFavoriteMutationVariables) =>
      publicFetcher<OrgSetIsFavoriteMutation, OrgSetIsFavoriteMutationVariables>(
        OrgSetIsFavoriteDocument,
        variables,
      )(),
    ...options,
  })
}

useOrgSetIsFavoriteMutation.fetcher = (
  variables: OrgSetIsFavoriteMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgSetIsFavoriteMutation, OrgSetIsFavoriteMutationVariables>(
    OrgSetIsFavoriteDocument,
    variables,
    options,
  )

export const BundleCreateDocument = `
    mutation BundleCreate($orgSlug: String!, $name: String!, $financierPid: String!, $type: FinProductType!, $note: String, $biddingOpenAt: DateTime, $biddingClosedAt: DateTime) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      create(
        name: $name
        financierPid: $financierPid
        type: $type
        note: $note
        biddingOpenAt: $biddingOpenAt
        biddingClosedAt: $biddingClosedAt
      ) {
        ...Bundle
      }
    }
  }
}
    ${BundleFragmentDoc}`

export const useBundleCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    BundleCreateMutation,
    TError,
    BundleCreateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BundleCreateMutation,
    TError,
    BundleCreateMutationVariables,
    TContext
  >({
    mutationKey: ["BundleCreate"],
    mutationFn: (variables?: BundleCreateMutationVariables) =>
      publicFetcher<BundleCreateMutation, BundleCreateMutationVariables>(
        BundleCreateDocument,
        variables,
      )(),
    ...options,
  })
}

useBundleCreateMutation.fetcher = (
  variables: BundleCreateMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleCreateMutation, BundleCreateMutationVariables>(
    BundleCreateDocument,
    variables,
    options,
  )

export const BundleUpsertSiteDocument = `
    mutation BundleUpsertSite($orgSlug: String!, $bundlePid: String!, $sitePid: String!, $scenarioPid: String!, $finproductId: Int) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      edit(pid: $bundlePid) {
        upsertSite(
          sitePid: $sitePid
          scenarioPid: $scenarioPid
          finproductId: $finproductId
        ) {
          site {
            pid
          }
          scenario {
            pid
          }
          financing {
            id
            name
          }
        }
      }
    }
  }
}
    `

export const useBundleUpsertSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    BundleUpsertSiteMutation,
    TError,
    BundleUpsertSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BundleUpsertSiteMutation,
    TError,
    BundleUpsertSiteMutationVariables,
    TContext
  >({
    mutationKey: ["BundleUpsertSite"],
    mutationFn: (variables?: BundleUpsertSiteMutationVariables) =>
      publicFetcher<BundleUpsertSiteMutation, BundleUpsertSiteMutationVariables>(
        BundleUpsertSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useBundleUpsertSiteMutation.fetcher = (
  variables: BundleUpsertSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleUpsertSiteMutation, BundleUpsertSiteMutationVariables>(
    BundleUpsertSiteDocument,
    variables,
    options,
  )

export const BundleRemoveSiteDocument = `
    mutation BundleRemoveSite($orgSlug: String!, $bundlePid: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      edit(pid: $bundlePid) {
        removeSite(sitePid: $sitePid)
      }
    }
  }
}
    `

export const useBundleRemoveSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    BundleRemoveSiteMutation,
    TError,
    BundleRemoveSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BundleRemoveSiteMutation,
    TError,
    BundleRemoveSiteMutationVariables,
    TContext
  >({
    mutationKey: ["BundleRemoveSite"],
    mutationFn: (variables?: BundleRemoveSiteMutationVariables) =>
      publicFetcher<BundleRemoveSiteMutation, BundleRemoveSiteMutationVariables>(
        BundleRemoveSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useBundleRemoveSiteMutation.fetcher = (
  variables: BundleRemoveSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleRemoveSiteMutation, BundleRemoveSiteMutationVariables>(
    BundleRemoveSiteDocument,
    variables,
    options,
  )

export const BundleArchiveBundleDocument = `
    mutation BundleArchiveBundle($orgSlug: String!, $bundlePid: String!, $archive: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      edit(pid: $bundlePid) {
        archiveBundle(archive: $archive)
      }
    }
  }
}
    `

export const useBundleArchiveBundleMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    BundleArchiveBundleMutation,
    TError,
    BundleArchiveBundleMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BundleArchiveBundleMutation,
    TError,
    BundleArchiveBundleMutationVariables,
    TContext
  >({
    mutationKey: ["BundleArchiveBundle"],
    mutationFn: (variables?: BundleArchiveBundleMutationVariables) =>
      publicFetcher<BundleArchiveBundleMutation, BundleArchiveBundleMutationVariables>(
        BundleArchiveBundleDocument,
        variables,
      )(),
    ...options,
  })
}

useBundleArchiveBundleMutation.fetcher = (
  variables: BundleArchiveBundleMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleArchiveBundleMutation, BundleArchiveBundleMutationVariables>(
    BundleArchiveBundleDocument,
    variables,
    options,
  )

export const SetMeteringDocument = `
    mutation SetMetering($input: SetMeteringInput!) {
  setMetering(input: $input)
}
    `

export const useSetMeteringMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetMeteringMutation,
    TError,
    SetMeteringMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetMeteringMutation,
    TError,
    SetMeteringMutationVariables,
    TContext
  >({
    mutationKey: ["SetMetering"],
    mutationFn: (variables?: SetMeteringMutationVariables) =>
      publicFetcher<SetMeteringMutation, SetMeteringMutationVariables>(
        SetMeteringDocument,
        variables,
      )(),
    ...options,
  })
}

useSetMeteringMutation.fetcher = (
  variables: SetMeteringMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetMeteringMutation, SetMeteringMutationVariables>(
    SetMeteringDocument,
    variables,
    options,
  )

export const SetSiteShapesDocument = `
    mutation SetSiteShapes($input: SetSiteShapesInput!) {
  setSiteShapes(input: $input) {
    pid
  }
}
    `

export const useSetSiteShapesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetSiteShapesMutation,
    TError,
    SetSiteShapesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetSiteShapesMutation,
    TError,
    SetSiteShapesMutationVariables,
    TContext
  >({
    mutationKey: ["SetSiteShapes"],
    mutationFn: (variables?: SetSiteShapesMutationVariables) =>
      publicFetcher<SetSiteShapesMutation, SetSiteShapesMutationVariables>(
        SetSiteShapesDocument,
        variables,
      )(),
    ...options,
  })
}

useSetSiteShapesMutation.fetcher = (
  variables: SetSiteShapesMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetSiteShapesMutation, SetSiteShapesMutationVariables>(
    SetSiteShapesDocument,
    variables,
    options,
  )

export const SaveSiteShapesDocument = `
    mutation SaveSiteShapes($input: SaveSiteShapesInput!) {
  saveSiteShapes(input: $input)
}
    `

export const useSaveSiteShapesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SaveSiteShapesMutation,
    TError,
    SaveSiteShapesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SaveSiteShapesMutation,
    TError,
    SaveSiteShapesMutationVariables,
    TContext
  >({
    mutationKey: ["SaveSiteShapes"],
    mutationFn: (variables?: SaveSiteShapesMutationVariables) =>
      publicFetcher<SaveSiteShapesMutation, SaveSiteShapesMutationVariables>(
        SaveSiteShapesDocument,
        variables,
      )(),
    ...options,
  })
}

useSaveSiteShapesMutation.fetcher = (
  variables: SaveSiteShapesMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SaveSiteShapesMutation, SaveSiteShapesMutationVariables>(
    SaveSiteShapesDocument,
    variables,
    options,
  )

export const UpdatePropertyDataDocument = `
    mutation UpdatePropertyData($input: UpdatePropertyDataInput!, $sourceType: ChangeSourceType, $sourceId: String) {
  updatePropertyData(input: $input, sourceType: $sourceType, sourceId: $sourceId)
}
    `

export const useUpdatePropertyDataMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdatePropertyDataMutation,
    TError,
    UpdatePropertyDataMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdatePropertyDataMutation,
    TError,
    UpdatePropertyDataMutationVariables,
    TContext
  >({
    mutationKey: ["UpdatePropertyData"],
    mutationFn: (variables?: UpdatePropertyDataMutationVariables) =>
      publicFetcher<UpdatePropertyDataMutation, UpdatePropertyDataMutationVariables>(
        UpdatePropertyDataDocument,
        variables,
      )(),
    ...options,
  })
}

useUpdatePropertyDataMutation.fetcher = (
  variables: UpdatePropertyDataMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UpdatePropertyDataMutation, UpdatePropertyDataMutationVariables>(
    UpdatePropertyDataDocument,
    variables,
    options,
  )

export const SetSiteStatusDocument = `
    mutation SetSiteStatus($orgSlug: String!, $sitePids: [String!]!, $status: SiteStatus!, $reason: StatusReason, $customReason: String) {
  orgBySlug(slug: $orgSlug) {
    setStatus(
      status: $status
      sitePids: $sitePids
      reason: $reason
      customReason: $customReason
    ) {
      message
    }
  }
}
    `

export const useSetSiteStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetSiteStatusMutation,
    TError,
    SetSiteStatusMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetSiteStatusMutation,
    TError,
    SetSiteStatusMutationVariables,
    TContext
  >({
    mutationKey: ["SetSiteStatus"],
    mutationFn: (variables?: SetSiteStatusMutationVariables) =>
      publicFetcher<SetSiteStatusMutation, SetSiteStatusMutationVariables>(
        SetSiteStatusDocument,
        variables,
      )(),
    ...options,
  })
}

useSetSiteStatusMutation.fetcher = (
  variables: SetSiteStatusMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetSiteStatusMutation, SetSiteStatusMutationVariables>(
    SetSiteStatusDocument,
    variables,
    options,
  )

export const NewCsvImportDocument = `
    mutation NewCsvImport($portfolioPid: String!, $upload: Upload!) {
  newCsvImport(portfolioPid: $portfolioPid, upload: $upload) {
    __typename
    ... on CsvImport {
      pid
    }
    ... on Error {
      message
    }
  }
}
    `

export const useNewCsvImportMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    NewCsvImportMutation,
    TError,
    NewCsvImportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    NewCsvImportMutation,
    TError,
    NewCsvImportMutationVariables,
    TContext
  >({
    mutationKey: ["NewCsvImport"],
    mutationFn: (variables?: NewCsvImportMutationVariables) =>
      publicFetcher<NewCsvImportMutation, NewCsvImportMutationVariables>(
        NewCsvImportDocument,
        variables,
      )(),
    ...options,
  })
}

useNewCsvImportMutation.fetcher = (
  variables: NewCsvImportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<NewCsvImportMutation, NewCsvImportMutationVariables>(
    NewCsvImportDocument,
    variables,
    options,
  )

export const SetCsvImportSchemaDocument = `
    mutation SetCsvImportSchema($csvImportPid: String!, $schemaPid: String!) {
  setCsvImportSchema(csvImportPid: $csvImportPid, schemaPid: $schemaPid) {
    __typename
  }
}
    `

export const useSetCsvImportSchemaMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetCsvImportSchemaMutation,
    TError,
    SetCsvImportSchemaMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCsvImportSchemaMutation,
    TError,
    SetCsvImportSchemaMutationVariables,
    TContext
  >({
    mutationKey: ["SetCsvImportSchema"],
    mutationFn: (variables?: SetCsvImportSchemaMutationVariables) =>
      publicFetcher<SetCsvImportSchemaMutation, SetCsvImportSchemaMutationVariables>(
        SetCsvImportSchemaDocument,
        variables,
      )(),
    ...options,
  })
}

useSetCsvImportSchemaMutation.fetcher = (
  variables: SetCsvImportSchemaMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetCsvImportSchemaMutation, SetCsvImportSchemaMutationVariables>(
    SetCsvImportSchemaDocument,
    variables,
    options,
  )

export const UpdateCsvImportColumnMappingsDocument = `
    mutation UpdateCsvImportColumnMappings($csvImportPid: String!, $columnMappings: ColumnMappingsInput!) {
  updateCsvImportColumnMappings(
    pid: $csvImportPid
    columnMappings: $columnMappings
  ) {
    __typename
    ... on CsvImport {
      pid
      buildingTypes
      guessedBuildingTypeMappings {
        office
        multifamily
        hotel
        hospital
        outpatient
        retailStandalone
        retailStripMall
        quickServiceRestaurant
        fullServiceRestaurant
        primarySchool
        secondarySchool
        singleFamilyDetached
        warehouse
        dataCenter
        coldStorage
        industrial
        parkingLot
        supermarket
      }
    }
    ... on Error {
      message
    }
  }
}
    `

export const useUpdateCsvImportColumnMappingsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCsvImportColumnMappingsMutation,
    TError,
    UpdateCsvImportColumnMappingsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateCsvImportColumnMappingsMutation,
    TError,
    UpdateCsvImportColumnMappingsMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateCsvImportColumnMappings"],
    mutationFn: (variables?: UpdateCsvImportColumnMappingsMutationVariables) =>
      publicFetcher<
        UpdateCsvImportColumnMappingsMutation,
        UpdateCsvImportColumnMappingsMutationVariables
      >(UpdateCsvImportColumnMappingsDocument, variables)(),
    ...options,
  })
}

useUpdateCsvImportColumnMappingsMutation.fetcher = (
  variables: UpdateCsvImportColumnMappingsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    UpdateCsvImportColumnMappingsMutation,
    UpdateCsvImportColumnMappingsMutationVariables
  >(UpdateCsvImportColumnMappingsDocument, variables, options)

export const AddLabelToCsvImportDocument = `
    mutation AddLabelToCsvImport($csvImportPid: String!, $labelPid: String!) {
  addLabelToCsvImport(csvImportPid: $csvImportPid, labelPid: $labelPid) {
    __typename
    ... on CsvImport {
      ...CsvImportLabels
    }
    ... on Error {
      message
    }
  }
}
    ${CsvImportLabelsFragmentDoc}`

export const useAddLabelToCsvImportMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddLabelToCsvImportMutation,
    TError,
    AddLabelToCsvImportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddLabelToCsvImportMutation,
    TError,
    AddLabelToCsvImportMutationVariables,
    TContext
  >({
    mutationKey: ["AddLabelToCsvImport"],
    mutationFn: (variables?: AddLabelToCsvImportMutationVariables) =>
      publicFetcher<AddLabelToCsvImportMutation, AddLabelToCsvImportMutationVariables>(
        AddLabelToCsvImportDocument,
        variables,
      )(),
    ...options,
  })
}

useAddLabelToCsvImportMutation.fetcher = (
  variables: AddLabelToCsvImportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddLabelToCsvImportMutation, AddLabelToCsvImportMutationVariables>(
    AddLabelToCsvImportDocument,
    variables,
    options,
  )

export const RemoveLabelFromCsvImportDocument = `
    mutation RemoveLabelFromCsvImport($csvImportPid: String!, $labelPid: String!) {
  removeLabelFromCsvImport(csvImportPid: $csvImportPid, labelPid: $labelPid) {
    __typename
    ... on CsvImport {
      ...CsvImportLabels
    }
    ... on Error {
      message
    }
  }
}
    ${CsvImportLabelsFragmentDoc}`

export const useRemoveLabelFromCsvImportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveLabelFromCsvImportMutation,
    TError,
    RemoveLabelFromCsvImportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveLabelFromCsvImportMutation,
    TError,
    RemoveLabelFromCsvImportMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveLabelFromCsvImport"],
    mutationFn: (variables?: RemoveLabelFromCsvImportMutationVariables) =>
      publicFetcher<
        RemoveLabelFromCsvImportMutation,
        RemoveLabelFromCsvImportMutationVariables
      >(RemoveLabelFromCsvImportDocument, variables)(),
    ...options,
  })
}

useRemoveLabelFromCsvImportMutation.fetcher = (
  variables: RemoveLabelFromCsvImportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    RemoveLabelFromCsvImportMutation,
    RemoveLabelFromCsvImportMutationVariables
  >(RemoveLabelFromCsvImportDocument, variables, options)

export const CreateLabelForCsvImportDocument = `
    mutation CreateLabelForCsvImport($csvImportPid: String!, $labelName: String!, $labelColor: LabelColor) {
  createAndApplyLabelToCsvImport(
    csvImportPid: $csvImportPid
    labelName: $labelName
    labelColor: $labelColor
  ) {
    __typename
    ... on CsvImport {
      ...CsvImportLabels
    }
    ... on Error {
      message
    }
  }
}
    ${CsvImportLabelsFragmentDoc}`

export const useCreateLabelForCsvImportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateLabelForCsvImportMutation,
    TError,
    CreateLabelForCsvImportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateLabelForCsvImportMutation,
    TError,
    CreateLabelForCsvImportMutationVariables,
    TContext
  >({
    mutationKey: ["CreateLabelForCsvImport"],
    mutationFn: (variables?: CreateLabelForCsvImportMutationVariables) =>
      publicFetcher<
        CreateLabelForCsvImportMutation,
        CreateLabelForCsvImportMutationVariables
      >(CreateLabelForCsvImportDocument, variables)(),
    ...options,
  })
}

useCreateLabelForCsvImportMutation.fetcher = (
  variables: CreateLabelForCsvImportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    CreateLabelForCsvImportMutation,
    CreateLabelForCsvImportMutationVariables
  >(CreateLabelForCsvImportDocument, variables, options)

export const DeleteLabelForCsvImportDocument = `
    mutation DeleteLabelForCsvImport($csvImportPid: String!, $labelPid: String!) {
  deleteLabelAndRemoveFromCsvImport(
    csvImportPid: $csvImportPid
    labelPid: $labelPid
  ) {
    __typename
    ... on CsvImport {
      ...CsvImportLabels
    }
    ... on Error {
      message
    }
  }
}
    ${CsvImportLabelsFragmentDoc}`

export const useDeleteLabelForCsvImportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteLabelForCsvImportMutation,
    TError,
    DeleteLabelForCsvImportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteLabelForCsvImportMutation,
    TError,
    DeleteLabelForCsvImportMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteLabelForCsvImport"],
    mutationFn: (variables?: DeleteLabelForCsvImportMutationVariables) =>
      publicFetcher<
        DeleteLabelForCsvImportMutation,
        DeleteLabelForCsvImportMutationVariables
      >(DeleteLabelForCsvImportDocument, variables)(),
    ...options,
  })
}

useDeleteLabelForCsvImportMutation.fetcher = (
  variables: DeleteLabelForCsvImportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    DeleteLabelForCsvImportMutation,
    DeleteLabelForCsvImportMutationVariables
  >(DeleteLabelForCsvImportDocument, variables, options)

export const UpdateDoeReferenceTypeMappingsDocument = `
    mutation UpdateDoeReferenceTypeMappings($csvImportPid: String!, $mappings: DoeReferenceTypeMappingsInput!) {
  updateDoeReferenceTypeMappings(csvImportPid: $csvImportPid, mappings: $mappings) {
    __typename
    ... on CsvImport {
      pid
    }
    ... on Error {
      message
    }
  }
}
    `

export const useUpdateDoeReferenceTypeMappingsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateDoeReferenceTypeMappingsMutation,
    TError,
    UpdateDoeReferenceTypeMappingsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateDoeReferenceTypeMappingsMutation,
    TError,
    UpdateDoeReferenceTypeMappingsMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateDoeReferenceTypeMappings"],
    mutationFn: (variables?: UpdateDoeReferenceTypeMappingsMutationVariables) =>
      publicFetcher<
        UpdateDoeReferenceTypeMappingsMutation,
        UpdateDoeReferenceTypeMappingsMutationVariables
      >(UpdateDoeReferenceTypeMappingsDocument, variables)(),
    ...options,
  })
}

useUpdateDoeReferenceTypeMappingsMutation.fetcher = (
  variables: UpdateDoeReferenceTypeMappingsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    UpdateDoeReferenceTypeMappingsMutation,
    UpdateDoeReferenceTypeMappingsMutationVariables
  >(UpdateDoeReferenceTypeMappingsDocument, variables, options)

export const DropCsvImportRowDocument = `
    mutation DropCsvImportRow($rowId: Int!) {
  dropCsvImportRow(rowId: $rowId) {
    id
    droppedAt
  }
}
    `

export const useDropCsvImportRowMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DropCsvImportRowMutation,
    TError,
    DropCsvImportRowMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DropCsvImportRowMutation,
    TError,
    DropCsvImportRowMutationVariables,
    TContext
  >({
    mutationKey: ["DropCsvImportRow"],
    mutationFn: (variables?: DropCsvImportRowMutationVariables) =>
      publicFetcher<DropCsvImportRowMutation, DropCsvImportRowMutationVariables>(
        DropCsvImportRowDocument,
        variables,
      )(),
    ...options,
  })
}

useDropCsvImportRowMutation.fetcher = (
  variables: DropCsvImportRowMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<DropCsvImportRowMutation, DropCsvImportRowMutationVariables>(
    DropCsvImportRowDocument,
    variables,
    options,
  )

export const AmendCsvImportRowDocument = `
    mutation AmendCsvImportRow($rowId: Int!, $amendments: BuildingDataAmendmentsInput!) {
  amendCsvImportRow(rowId: $rowId, amendments: $amendments) {
    id
    amendments {
      buildingType
      customerId
      latitude
      longitude
      name
      numStories
      roofSqft
      sqft
      yearBuilt
      mfUnits {
        numUnitsTotal
        numUnitsStudio
        numUnits1Bd
        numUnits2Bd
        numUnits3Bd
        numUnits4Bd
      }
    }
  }
}
    `

export const useAmendCsvImportRowMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AmendCsvImportRowMutation,
    TError,
    AmendCsvImportRowMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AmendCsvImportRowMutation,
    TError,
    AmendCsvImportRowMutationVariables,
    TContext
  >({
    mutationKey: ["AmendCsvImportRow"],
    mutationFn: (variables?: AmendCsvImportRowMutationVariables) =>
      publicFetcher<AmendCsvImportRowMutation, AmendCsvImportRowMutationVariables>(
        AmendCsvImportRowDocument,
        variables,
      )(),
    ...options,
  })
}

useAmendCsvImportRowMutation.fetcher = (
  variables: AmendCsvImportRowMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AmendCsvImportRowMutation, AmendCsvImportRowMutationVariables>(
    AmendCsvImportRowDocument,
    variables,
    options,
  )

export const SetCsvImportRowBuildingDataDocument = `
    mutation SetCsvImportRowBuildingData($rowId: Int!, $buildingDataId: Int!) {
  setCsvImportRowBuildingData(rowId: $rowId, buildingDataId: $buildingDataId) {
    id
    buildingData {
      id
      propertyName
      fullAddress
      streetAddress
      city
      state
      zipCode
      buildingType
      sqft
      roofSqft
      numStories
      latitude
      longitude
      buildingFootprintGeojson
      yearBuilt
      numUnitsTotal
      numUnitsStudio
      numUnits1Bd
      numUnits2Bd
      numUnits3Bd
      numUnits4Bd
    }
  }
}
    `

export const useSetCsvImportRowBuildingDataMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetCsvImportRowBuildingDataMutation,
    TError,
    SetCsvImportRowBuildingDataMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCsvImportRowBuildingDataMutation,
    TError,
    SetCsvImportRowBuildingDataMutationVariables,
    TContext
  >({
    mutationKey: ["SetCsvImportRowBuildingData"],
    mutationFn: (variables?: SetCsvImportRowBuildingDataMutationVariables) =>
      publicFetcher<
        SetCsvImportRowBuildingDataMutation,
        SetCsvImportRowBuildingDataMutationVariables
      >(SetCsvImportRowBuildingDataDocument, variables)(),
    ...options,
  })
}

useSetCsvImportRowBuildingDataMutation.fetcher = (
  variables: SetCsvImportRowBuildingDataMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetCsvImportRowBuildingDataMutation,
    SetCsvImportRowBuildingDataMutationVariables
  >(SetCsvImportRowBuildingDataDocument, variables, options)

export const UnsetCsvImportRowBuildingDataDocument = `
    mutation UnsetCsvImportRowBuildingData($rowId: Int!) {
  unsetCsvImportRowBuildingData(rowId: $rowId) {
    id
    buildingData {
      id
      propertyName
      fullAddress
      streetAddress
      city
      state
      zipCode
      buildingType
      sqft
      roofSqft
      numStories
      latitude
      longitude
      buildingFootprintGeojson
      yearBuilt
      numUnitsTotal
      numUnitsStudio
      numUnits1Bd
      numUnits2Bd
      numUnits3Bd
      numUnits4Bd
    }
    amendments {
      buildingType
      customerId
      latitude
      longitude
      name
      numStories
      roofSqft
      sqft
      yearBuilt
      mfUnits {
        numUnitsTotal
        numUnitsStudio
        numUnits1Bd
        numUnits2Bd
        numUnits3Bd
        numUnits4Bd
      }
    }
  }
}
    `

export const useUnsetCsvImportRowBuildingDataMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UnsetCsvImportRowBuildingDataMutation,
    TError,
    UnsetCsvImportRowBuildingDataMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UnsetCsvImportRowBuildingDataMutation,
    TError,
    UnsetCsvImportRowBuildingDataMutationVariables,
    TContext
  >({
    mutationKey: ["UnsetCsvImportRowBuildingData"],
    mutationFn: (variables?: UnsetCsvImportRowBuildingDataMutationVariables) =>
      publicFetcher<
        UnsetCsvImportRowBuildingDataMutation,
        UnsetCsvImportRowBuildingDataMutationVariables
      >(UnsetCsvImportRowBuildingDataDocument, variables)(),
    ...options,
  })
}

useUnsetCsvImportRowBuildingDataMutation.fetcher = (
  variables: UnsetCsvImportRowBuildingDataMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    UnsetCsvImportRowBuildingDataMutation,
    UnsetCsvImportRowBuildingDataMutationVariables
  >(UnsetCsvImportRowBuildingDataDocument, variables, options)

export const UpdateSiteConfigDocument = `
    mutation UpdateSiteConfig($sitePid: String!, $finproductId: Int!, $scenarioPid: String!) {
  siteConfig {
    updateSelectedConfig(
      sitePid: $sitePid
      finproductId: $finproductId
      scenarioPid: $scenarioPid
    )
  }
}
    `

export const useUpdateSiteConfigMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateSiteConfigMutation,
    TError,
    UpdateSiteConfigMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateSiteConfigMutation,
    TError,
    UpdateSiteConfigMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateSiteConfig"],
    mutationFn: (variables?: UpdateSiteConfigMutationVariables) =>
      publicFetcher<UpdateSiteConfigMutation, UpdateSiteConfigMutationVariables>(
        UpdateSiteConfigDocument,
        variables,
      )(),
    ...options,
  })
}

useUpdateSiteConfigMutation.fetcher = (
  variables: UpdateSiteConfigMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UpdateSiteConfigMutation, UpdateSiteConfigMutationVariables>(
    UpdateSiteConfigDocument,
    variables,
    options,
  )

export const RequestBidsDocument = `
    mutation RequestBids($input: RequestBidsInput!) {
  requestBids(input: $input)
}
    `

export const useRequestBidsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RequestBidsMutation,
    TError,
    RequestBidsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RequestBidsMutation,
    TError,
    RequestBidsMutationVariables,
    TContext
  >({
    mutationKey: ["RequestBids"],
    mutationFn: (variables?: RequestBidsMutationVariables) =>
      publicFetcher<RequestBidsMutation, RequestBidsMutationVariables>(
        RequestBidsDocument,
        variables,
      )(),
    ...options,
  })
}

useRequestBidsMutation.fetcher = (
  variables: RequestBidsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RequestBidsMutation, RequestBidsMutationVariables>(
    RequestBidsDocument,
    variables,
    options,
  )

export const CreateThirdPartySupplierDocument = `
    mutation CreateThirdPartySupplier($name: String!) {
  createThirdPartySupplier(name: $name) {
    id
    pid
    name
  }
}
    `

export const useCreateThirdPartySupplierMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateThirdPartySupplierMutation,
    TError,
    CreateThirdPartySupplierMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateThirdPartySupplierMutation,
    TError,
    CreateThirdPartySupplierMutationVariables,
    TContext
  >({
    mutationKey: ["CreateThirdPartySupplier"],
    mutationFn: (variables?: CreateThirdPartySupplierMutationVariables) =>
      publicFetcher<
        CreateThirdPartySupplierMutation,
        CreateThirdPartySupplierMutationVariables
      >(CreateThirdPartySupplierDocument, variables)(),
    ...options,
  })
}

useCreateThirdPartySupplierMutation.fetcher = (
  variables: CreateThirdPartySupplierMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    CreateThirdPartySupplierMutation,
    CreateThirdPartySupplierMutationVariables
  >(CreateThirdPartySupplierDocument, variables, options)

export const AddMeterDocument = `
    mutation AddMeter($sitePid: String!, $loadCategory: LoadCategory!, $label: String, $doeReferenceType: BuildingType, $tariffPid: String) {
  billingMeters(sitePid: $sitePid) {
    addMeter(
      loadCategory: $loadCategory
      label: $label
      doeReferenceType: $doeReferenceType
      tariffPid: $tariffPid
    ) {
      ...MutBillingMeter
    }
  }
}
    ${MutBillingMeterFragmentDoc}`

export const useAddMeterMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddMeterMutation,
    TError,
    AddMeterMutationVariables,
    TContext
  >,
) => {
  return useMutation<AddMeterMutation, TError, AddMeterMutationVariables, TContext>({
    mutationKey: ["AddMeter"],
    mutationFn: (variables?: AddMeterMutationVariables) =>
      publicFetcher<AddMeterMutation, AddMeterMutationVariables>(
        AddMeterDocument,
        variables,
      )(),
    ...options,
  })
}

useAddMeterMutation.fetcher = (
  variables: AddMeterMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddMeterMutation, AddMeterMutationVariables>(
    AddMeterDocument,
    variables,
    options,
  )

export const EditBillingMeterAnnualDocument = `
    mutation EditBillingMeterAnnual($sitePid: String!, $meterPid: String!, $kwh: Float, $kw: Float, $costUsd: Float) {
  billingMeters(sitePid: $sitePid) {
    editAnnual(meterPid: $meterPid, kwh: $kwh, kw: $kw, costUsd: $costUsd) {
      ...MutBillingMeter
    }
  }
}
    ${MutBillingMeterFragmentDoc}`

export const useEditBillingMeterAnnualMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditBillingMeterAnnualMutation,
    TError,
    EditBillingMeterAnnualMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditBillingMeterAnnualMutation,
    TError,
    EditBillingMeterAnnualMutationVariables,
    TContext
  >({
    mutationKey: ["EditBillingMeterAnnual"],
    mutationFn: (variables?: EditBillingMeterAnnualMutationVariables) =>
      publicFetcher<
        EditBillingMeterAnnualMutation,
        EditBillingMeterAnnualMutationVariables
      >(EditBillingMeterAnnualDocument, variables)(),
    ...options,
  })
}

useEditBillingMeterAnnualMutation.fetcher = (
  variables: EditBillingMeterAnnualMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    EditBillingMeterAnnualMutation,
    EditBillingMeterAnnualMutationVariables
  >(EditBillingMeterAnnualDocument, variables, options)

export const EditBillingMeterLabelDocument = `
    mutation EditBillingMeterLabel($sitePid: String!, $meterPid: String!, $label: String!) {
  billingMeters(sitePid: $sitePid) {
    editLabel(meterPid: $meterPid, label: $label) {
      ...MutBillingMeter
    }
  }
}
    ${MutBillingMeterFragmentDoc}`

export const useEditBillingMeterLabelMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditBillingMeterLabelMutation,
    TError,
    EditBillingMeterLabelMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditBillingMeterLabelMutation,
    TError,
    EditBillingMeterLabelMutationVariables,
    TContext
  >({
    mutationKey: ["EditBillingMeterLabel"],
    mutationFn: (variables?: EditBillingMeterLabelMutationVariables) =>
      publicFetcher<
        EditBillingMeterLabelMutation,
        EditBillingMeterLabelMutationVariables
      >(EditBillingMeterLabelDocument, variables)(),
    ...options,
  })
}

useEditBillingMeterLabelMutation.fetcher = (
  variables: EditBillingMeterLabelMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EditBillingMeterLabelMutation, EditBillingMeterLabelMutationVariables>(
    EditBillingMeterLabelDocument,
    variables,
    options,
  )

export const EditBillingMeterDoeReferenceTypeDocument = `
    mutation EditBillingMeterDoeReferenceType($sitePid: String!, $meterPid: String!, $doeReferenceType: BuildingType!) {
  billingMeters(sitePid: $sitePid) {
    editDoeReferenceType(meterPid: $meterPid, doeReferenceType: $doeReferenceType) {
      __typename
    }
  }
}
    `

export const useEditBillingMeterDoeReferenceTypeMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    EditBillingMeterDoeReferenceTypeMutation,
    TError,
    EditBillingMeterDoeReferenceTypeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditBillingMeterDoeReferenceTypeMutation,
    TError,
    EditBillingMeterDoeReferenceTypeMutationVariables,
    TContext
  >({
    mutationKey: ["EditBillingMeterDoeReferenceType"],
    mutationFn: (variables?: EditBillingMeterDoeReferenceTypeMutationVariables) =>
      publicFetcher<
        EditBillingMeterDoeReferenceTypeMutation,
        EditBillingMeterDoeReferenceTypeMutationVariables
      >(EditBillingMeterDoeReferenceTypeDocument, variables)(),
    ...options,
  })
}

useEditBillingMeterDoeReferenceTypeMutation.fetcher = (
  variables: EditBillingMeterDoeReferenceTypeMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    EditBillingMeterDoeReferenceTypeMutation,
    EditBillingMeterDoeReferenceTypeMutationVariables
  >(EditBillingMeterDoeReferenceTypeDocument, variables, options)

export const EditBillingMeterTariffDocument = `
    mutation EditBillingMeterTariff($sitePid: String!, $meterPid: String!, $tariffPid: String!) {
  billingMeters(sitePid: $sitePid) {
    editBauTariff(meterPid: $meterPid, tariffPid: $tariffPid) {
      __typename
    }
  }
}
    `

export const useEditBillingMeterTariffMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditBillingMeterTariffMutation,
    TError,
    EditBillingMeterTariffMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditBillingMeterTariffMutation,
    TError,
    EditBillingMeterTariffMutationVariables,
    TContext
  >({
    mutationKey: ["EditBillingMeterTariff"],
    mutationFn: (variables?: EditBillingMeterTariffMutationVariables) =>
      publicFetcher<
        EditBillingMeterTariffMutation,
        EditBillingMeterTariffMutationVariables
      >(EditBillingMeterTariffDocument, variables)(),
    ...options,
  })
}

useEditBillingMeterTariffMutation.fetcher = (
  variables: EditBillingMeterTariffMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    EditBillingMeterTariffMutation,
    EditBillingMeterTariffMutationVariables
  >(EditBillingMeterTariffDocument, variables, options)

export const AddBillingMeterIntervalsDocument = `
    mutation AddBillingMeterIntervals($sitePid: String!, $input: BillingIntervalsExtraction!) {
  billingMeters(sitePid: $sitePid) {
    addIntervals(input: $input)
  }
}
    `

export const useAddBillingMeterIntervalsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddBillingMeterIntervalsMutation,
    TError,
    AddBillingMeterIntervalsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddBillingMeterIntervalsMutation,
    TError,
    AddBillingMeterIntervalsMutationVariables,
    TContext
  >({
    mutationKey: ["AddBillingMeterIntervals"],
    mutationFn: (variables?: AddBillingMeterIntervalsMutationVariables) =>
      publicFetcher<
        AddBillingMeterIntervalsMutation,
        AddBillingMeterIntervalsMutationVariables
      >(AddBillingMeterIntervalsDocument, variables)(),
    ...options,
  })
}

useAddBillingMeterIntervalsMutation.fetcher = (
  variables: AddBillingMeterIntervalsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    AddBillingMeterIntervalsMutation,
    AddBillingMeterIntervalsMutationVariables
  >(AddBillingMeterIntervalsDocument, variables, options)

export const AddBillingMeterMonthliesDocument = `
    mutation AddBillingMeterMonthlies($sitePid: String!, $input: MonthlyExtraction!) {
  billingMeters(sitePid: $sitePid) {
    addMonthlies(input: $input)
  }
}
    `

export const useAddBillingMeterMonthliesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddBillingMeterMonthliesMutation,
    TError,
    AddBillingMeterMonthliesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddBillingMeterMonthliesMutation,
    TError,
    AddBillingMeterMonthliesMutationVariables,
    TContext
  >({
    mutationKey: ["AddBillingMeterMonthlies"],
    mutationFn: (variables?: AddBillingMeterMonthliesMutationVariables) =>
      publicFetcher<
        AddBillingMeterMonthliesMutation,
        AddBillingMeterMonthliesMutationVariables
      >(AddBillingMeterMonthliesDocument, variables)(),
    ...options,
  })
}

useAddBillingMeterMonthliesMutation.fetcher = (
  variables: AddBillingMeterMonthliesMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    AddBillingMeterMonthliesMutation,
    AddBillingMeterMonthliesMutationVariables
  >(AddBillingMeterMonthliesDocument, variables, options)

export const BillingMeterEditTenantDetailsDocument = `
    mutation BillingMeterEditTenantDetails($sitePid: String!, $meterPid: String!, $input: MFUnitBreakdownInput!) {
  billingMeters(sitePid: $sitePid) {
    editTenantDetails(meterPid: $meterPid, input: $input)
  }
}
    `

export const useBillingMeterEditTenantDetailsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    BillingMeterEditTenantDetailsMutation,
    TError,
    BillingMeterEditTenantDetailsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    BillingMeterEditTenantDetailsMutation,
    TError,
    BillingMeterEditTenantDetailsMutationVariables,
    TContext
  >({
    mutationKey: ["BillingMeterEditTenantDetails"],
    mutationFn: (variables?: BillingMeterEditTenantDetailsMutationVariables) =>
      publicFetcher<
        BillingMeterEditTenantDetailsMutation,
        BillingMeterEditTenantDetailsMutationVariables
      >(BillingMeterEditTenantDetailsDocument, variables)(),
    ...options,
  })
}

useBillingMeterEditTenantDetailsMutation.fetcher = (
  variables: BillingMeterEditTenantDetailsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    BillingMeterEditTenantDetailsMutation,
    BillingMeterEditTenantDetailsMutationVariables
  >(BillingMeterEditTenantDetailsDocument, variables, options)

export const RemoveBillingMeterIntervalsDocument = `
    mutation RemoveBillingMeterIntervals($sitePid: String!, $meterPid: String!, $intervalsId: Int!) {
  billingMeters(sitePid: $sitePid) {
    removeIntervals(meterPid: $meterPid, intervalsId: $intervalsId)
  }
}
    `

export const useRemoveBillingMeterIntervalsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveBillingMeterIntervalsMutation,
    TError,
    RemoveBillingMeterIntervalsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveBillingMeterIntervalsMutation,
    TError,
    RemoveBillingMeterIntervalsMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveBillingMeterIntervals"],
    mutationFn: (variables?: RemoveBillingMeterIntervalsMutationVariables) =>
      publicFetcher<
        RemoveBillingMeterIntervalsMutation,
        RemoveBillingMeterIntervalsMutationVariables
      >(RemoveBillingMeterIntervalsDocument, variables)(),
    ...options,
  })
}

useRemoveBillingMeterIntervalsMutation.fetcher = (
  variables: RemoveBillingMeterIntervalsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    RemoveBillingMeterIntervalsMutation,
    RemoveBillingMeterIntervalsMutationVariables
  >(RemoveBillingMeterIntervalsDocument, variables, options)

export const SetArchivedBillingMeterDocument = `
    mutation SetArchivedBillingMeter($sitePid: String!, $meterPid: String!, $archived: Boolean!) {
  billingMeters(sitePid: $sitePid) {
    editArchived(meterPid: $meterPid, archived: $archived) {
      __typename
    }
  }
}
    `

export const useSetArchivedBillingMeterMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetArchivedBillingMeterMutation,
    TError,
    SetArchivedBillingMeterMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetArchivedBillingMeterMutation,
    TError,
    SetArchivedBillingMeterMutationVariables,
    TContext
  >({
    mutationKey: ["SetArchivedBillingMeter"],
    mutationFn: (variables?: SetArchivedBillingMeterMutationVariables) =>
      publicFetcher<
        SetArchivedBillingMeterMutation,
        SetArchivedBillingMeterMutationVariables
      >(SetArchivedBillingMeterDocument, variables)(),
    ...options,
  })
}

useSetArchivedBillingMeterMutation.fetcher = (
  variables: SetArchivedBillingMeterMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetArchivedBillingMeterMutation,
    SetArchivedBillingMeterMutationVariables
  >(SetArchivedBillingMeterDocument, variables, options)

export const EditBillingMeterMonthDocument = `
    mutation EditBillingMeterMonth($sitePid: String!, $meterPid: String!, $start: Date!, $end: Date!, $totalKwh: Float!, $peakKw: Float, $totalCostUsd: Float, $supplyCostUsd: Float, $transmissionCostUsd: Float) {
  billingMeters(sitePid: $sitePid) {
    editMonth(
      meterPid: $meterPid
      start: $start
      end: $end
      totalKwh: $totalKwh
      peakKw: $peakKw
      totalCostUsd: $totalCostUsd
      supplyCostUsd: $supplyCostUsd
      transmissionCostUsd: $transmissionCostUsd
    ) {
      __typename
    }
  }
}
    `

export const useEditBillingMeterMonthMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditBillingMeterMonthMutation,
    TError,
    EditBillingMeterMonthMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditBillingMeterMonthMutation,
    TError,
    EditBillingMeterMonthMutationVariables,
    TContext
  >({
    mutationKey: ["EditBillingMeterMonth"],
    mutationFn: (variables?: EditBillingMeterMonthMutationVariables) =>
      publicFetcher<
        EditBillingMeterMonthMutation,
        EditBillingMeterMonthMutationVariables
      >(EditBillingMeterMonthDocument, variables)(),
    ...options,
  })
}

useEditBillingMeterMonthMutation.fetcher = (
  variables: EditBillingMeterMonthMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EditBillingMeterMonthMutation, EditBillingMeterMonthMutationVariables>(
    EditBillingMeterMonthDocument,
    variables,
    options,
  )

export const RemoveBillingMeterMonthDocument = `
    mutation RemoveBillingMeterMonth($sitePid: String!, $meterPid: String!, $monthId: Int!) {
  billingMeters(sitePid: $sitePid) {
    removeMonth(meterPid: $meterPid, monthId: $monthId) {
      __typename
    }
  }
}
    `

export const useRemoveBillingMeterMonthMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveBillingMeterMonthMutation,
    TError,
    RemoveBillingMeterMonthMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveBillingMeterMonthMutation,
    TError,
    RemoveBillingMeterMonthMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveBillingMeterMonth"],
    mutationFn: (variables?: RemoveBillingMeterMonthMutationVariables) =>
      publicFetcher<
        RemoveBillingMeterMonthMutation,
        RemoveBillingMeterMonthMutationVariables
      >(RemoveBillingMeterMonthDocument, variables)(),
    ...options,
  })
}

useRemoveBillingMeterMonthMutation.fetcher = (
  variables: RemoveBillingMeterMonthMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    RemoveBillingMeterMonthMutation,
    RemoveBillingMeterMonthMutationVariables
  >(RemoveBillingMeterMonthDocument, variables, options)

export const MoveDocumentBillingMonthDocument = `
    mutation MoveDocumentBillingMonth($sitePid: String!, $billingMonthId: Int!, $kind: BillType!, $fromMeterPid: String, $toMeterPid: String) {
  billingMeters(sitePid: $sitePid) {
    moveDocumentBillingMonth(
      dbmId: $billingMonthId
      kind: $kind
      fromMeterPid: $fromMeterPid
      toMeterPid: $toMeterPid
    )
  }
}
    `

export const useMoveDocumentBillingMonthMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    MoveDocumentBillingMonthMutation,
    TError,
    MoveDocumentBillingMonthMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    MoveDocumentBillingMonthMutation,
    TError,
    MoveDocumentBillingMonthMutationVariables,
    TContext
  >({
    mutationKey: ["MoveDocumentBillingMonth"],
    mutationFn: (variables?: MoveDocumentBillingMonthMutationVariables) =>
      publicFetcher<
        MoveDocumentBillingMonthMutation,
        MoveDocumentBillingMonthMutationVariables
      >(MoveDocumentBillingMonthDocument, variables)(),
    ...options,
  })
}

useMoveDocumentBillingMonthMutation.fetcher = (
  variables: MoveDocumentBillingMonthMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    MoveDocumentBillingMonthMutation,
    MoveDocumentBillingMonthMutationVariables
  >(MoveDocumentBillingMonthDocument, variables, options)

export const CreateBuildingDataFromGooglePlaceDocument = `
    mutation CreateBuildingDataFromGooglePlace($placeId: String!) {
  buildingData {
    createFromGooglePlace(placeId: $placeId) {
      __typename
      ... on BuildingData {
        id
        fullAddress
        buildingType
        propertyName
        roofSqft
        sqft
        numStories
        latitude
        longitude
        buildingFootprintGeojson
        yearBuilt
        numUnitsTotal
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const useCreateBuildingDataFromGooglePlaceMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateBuildingDataFromGooglePlaceMutation,
    TError,
    CreateBuildingDataFromGooglePlaceMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateBuildingDataFromGooglePlaceMutation,
    TError,
    CreateBuildingDataFromGooglePlaceMutationVariables,
    TContext
  >({
    mutationKey: ["CreateBuildingDataFromGooglePlace"],
    mutationFn: (variables?: CreateBuildingDataFromGooglePlaceMutationVariables) =>
      publicFetcher<
        CreateBuildingDataFromGooglePlaceMutation,
        CreateBuildingDataFromGooglePlaceMutationVariables
      >(CreateBuildingDataFromGooglePlaceDocument, variables)(),
    ...options,
  })
}

useCreateBuildingDataFromGooglePlaceMutation.fetcher = (
  variables: CreateBuildingDataFromGooglePlaceMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    CreateBuildingDataFromGooglePlaceMutation,
    CreateBuildingDataFromGooglePlaceMutationVariables
  >(CreateBuildingDataFromGooglePlaceDocument, variables, options)

export const CreateSiteFromBuildingDataDocument = `
    mutation CreateSiteFromBuildingData($portfolioPid: String!, $buildingDataId: Int!, $amendments: BuildingDataAmendmentsInput!) {
  buildingData {
    createSite(
      portfolioPid: $portfolioPid
      buildingDataId: $buildingDataId
      amendments: $amendments
    ) {
      __typename
      ... on SiteRef {
        pid
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const useCreateSiteFromBuildingDataMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateSiteFromBuildingDataMutation,
    TError,
    CreateSiteFromBuildingDataMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateSiteFromBuildingDataMutation,
    TError,
    CreateSiteFromBuildingDataMutationVariables,
    TContext
  >({
    mutationKey: ["CreateSiteFromBuildingData"],
    mutationFn: (variables?: CreateSiteFromBuildingDataMutationVariables) =>
      publicFetcher<
        CreateSiteFromBuildingDataMutation,
        CreateSiteFromBuildingDataMutationVariables
      >(CreateSiteFromBuildingDataDocument, variables)(),
    ...options,
  })
}

useCreateSiteFromBuildingDataMutation.fetcher = (
  variables: CreateSiteFromBuildingDataMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    CreateSiteFromBuildingDataMutation,
    CreateSiteFromBuildingDataMutationVariables
  >(CreateSiteFromBuildingDataDocument, variables, options)

export const CreateBundleParentDocument = `
    mutation CreateBundleParent($orgSlug: String!, $name: String!, $type: FinProductType!, $note: String!, $pricingNote: String!, $biddingOpenAt: DateTime, $biddingClosedAt: DateTime) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      createParent(
        name: $name
        type: $type
        note: $note
        pricingNote: $pricingNote
        biddingOpenAt: $biddingOpenAt
        biddingClosedAt: $biddingClosedAt
      ) {
        id
        pid
        name
      }
    }
  }
}
    `

export const useCreateBundleParentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateBundleParentMutation,
    TError,
    CreateBundleParentMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateBundleParentMutation,
    TError,
    CreateBundleParentMutationVariables,
    TContext
  >({
    mutationKey: ["CreateBundleParent"],
    mutationFn: (variables?: CreateBundleParentMutationVariables) =>
      publicFetcher<CreateBundleParentMutation, CreateBundleParentMutationVariables>(
        CreateBundleParentDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateBundleParentMutation.fetcher = (
  variables: CreateBundleParentMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CreateBundleParentMutation, CreateBundleParentMutationVariables>(
    CreateBundleParentDocument,
    variables,
    options,
  )

export const EditBundleParentDocument = `
    mutation EditBundleParent($orgSlug: String!, $bundleParentPid: String!, $name: String!, $note: String!, $pricingNote: String!, $biddingOpenAt: DateTime, $biddingClosedAt: DateTime) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setName(name: $name)
        setNote(note: $note)
        setPricingNote(pricingNote: $pricingNote)
        setBiddingOpenAt(biddingOpenAt: $biddingOpenAt)
        setBiddingClosedAt(biddingClosedAt: $biddingClosedAt)
      }
    }
  }
}
    `

export const useEditBundleParentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditBundleParentMutation,
    TError,
    EditBundleParentMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditBundleParentMutation,
    TError,
    EditBundleParentMutationVariables,
    TContext
  >({
    mutationKey: ["EditBundleParent"],
    mutationFn: (variables?: EditBundleParentMutationVariables) =>
      publicFetcher<EditBundleParentMutation, EditBundleParentMutationVariables>(
        EditBundleParentDocument,
        variables,
      )(),
    ...options,
  })
}

useEditBundleParentMutation.fetcher = (
  variables: EditBundleParentMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EditBundleParentMutation, EditBundleParentMutationVariables>(
    EditBundleParentDocument,
    variables,
    options,
  )

export const AddBundleParentFinancierDocument = `
    mutation AddBundleParentFinancier($orgSlug: String!, $bundleParentPid: String!, $financierPids: [String!]!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        addFinanciers(financierPids: $financierPids)
      }
    }
  }
}
    `

export const useAddBundleParentFinancierMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddBundleParentFinancierMutation,
    TError,
    AddBundleParentFinancierMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddBundleParentFinancierMutation,
    TError,
    AddBundleParentFinancierMutationVariables,
    TContext
  >({
    mutationKey: ["AddBundleParentFinancier"],
    mutationFn: (variables?: AddBundleParentFinancierMutationVariables) =>
      publicFetcher<
        AddBundleParentFinancierMutation,
        AddBundleParentFinancierMutationVariables
      >(AddBundleParentFinancierDocument, variables)(),
    ...options,
  })
}

useAddBundleParentFinancierMutation.fetcher = (
  variables: AddBundleParentFinancierMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    AddBundleParentFinancierMutation,
    AddBundleParentFinancierMutationVariables
  >(AddBundleParentFinancierDocument, variables, options)

export const AddBundleParentSiteDocument = `
    mutation AddBundleParentSite($orgSlug: String!, $bundleParentPid: String!, $sitePid: String!, $projectParams: ProjectParamsInput!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        upsertSite(sitePid: $sitePid, projectParams: $projectParams)
      }
    }
  }
}
    `

export const useAddBundleParentSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddBundleParentSiteMutation,
    TError,
    AddBundleParentSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddBundleParentSiteMutation,
    TError,
    AddBundleParentSiteMutationVariables,
    TContext
  >({
    mutationKey: ["AddBundleParentSite"],
    mutationFn: (variables?: AddBundleParentSiteMutationVariables) =>
      publicFetcher<AddBundleParentSiteMutation, AddBundleParentSiteMutationVariables>(
        AddBundleParentSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useAddBundleParentSiteMutation.fetcher = (
  variables: AddBundleParentSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddBundleParentSiteMutation, AddBundleParentSiteMutationVariables>(
    AddBundleParentSiteDocument,
    variables,
    options,
  )

export const CreateBundleParentSystemDocument = `
    mutation CreateBundleParentSystem($orgSlug: String!, $bundleParentPid: String!, $sitePid: String!, $input: AddSystemInput!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        addSystem(sitePid: $sitePid, input: $input) {
          system {
            pid
          }
          lite {
            pid
          }
        }
      }
    }
  }
}
    `

export const useCreateBundleParentSystemMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateBundleParentSystemMutation,
    TError,
    CreateBundleParentSystemMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateBundleParentSystemMutation,
    TError,
    CreateBundleParentSystemMutationVariables,
    TContext
  >({
    mutationKey: ["CreateBundleParentSystem"],
    mutationFn: (variables?: CreateBundleParentSystemMutationVariables) =>
      publicFetcher<
        CreateBundleParentSystemMutation,
        CreateBundleParentSystemMutationVariables
      >(CreateBundleParentSystemDocument, variables)(),
    ...options,
  })
}

useCreateBundleParentSystemMutation.fetcher = (
  variables: CreateBundleParentSystemMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    CreateBundleParentSystemMutation,
    CreateBundleParentSystemMutationVariables
  >(CreateBundleParentSystemDocument, variables, options)

export const RemoveBundleParentSiteDocument = `
    mutation RemoveBundleParentSite($orgSlug: String!, $bundleParentPid: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        removeSite(sitePid: $sitePid)
      }
    }
  }
}
    `

export const useRemoveBundleParentSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RemoveBundleParentSiteMutation,
    TError,
    RemoveBundleParentSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveBundleParentSiteMutation,
    TError,
    RemoveBundleParentSiteMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveBundleParentSite"],
    mutationFn: (variables?: RemoveBundleParentSiteMutationVariables) =>
      publicFetcher<
        RemoveBundleParentSiteMutation,
        RemoveBundleParentSiteMutationVariables
      >(RemoveBundleParentSiteDocument, variables)(),
    ...options,
  })
}

useRemoveBundleParentSiteMutation.fetcher = (
  variables: RemoveBundleParentSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    RemoveBundleParentSiteMutation,
    RemoveBundleParentSiteMutationVariables
  >(RemoveBundleParentSiteDocument, variables, options)

export const AddInvestorBidDocument = `
    mutation AddInvestorBid($orgSlug: String!, $bundlePid: String!, $input: InvestorBidInput!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      addInvestorBid(input: $input) {
        ppa {
          pid
        }
        cs {
          pid
        }
      }
    }
  }
}
    `

export const useAddInvestorBidMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddInvestorBidMutation,
    TError,
    AddInvestorBidMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddInvestorBidMutation,
    TError,
    AddInvestorBidMutationVariables,
    TContext
  >({
    mutationKey: ["AddInvestorBid"],
    mutationFn: (variables?: AddInvestorBidMutationVariables) =>
      publicFetcher<AddInvestorBidMutation, AddInvestorBidMutationVariables>(
        AddInvestorBidDocument,
        variables,
      )(),
    ...options,
  })
}

useAddInvestorBidMutation.fetcher = (
  variables: AddInvestorBidMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddInvestorBidMutation, AddInvestorBidMutationVariables>(
    AddInvestorBidDocument,
    variables,
    options,
  )

export const EditInvestorBidDocument = `
    mutation EditInvestorBid($orgSlug: String!, $bundlePid: String!, $bidPid: String!, $input: InvestorBidInput!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      editInvestorBid(bidPid: $bidPid, input: $input) {
        ppa {
          pid
        }
        cs {
          pid
        }
      }
    }
  }
}
    `

export const useEditInvestorBidMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditInvestorBidMutation,
    TError,
    EditInvestorBidMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditInvestorBidMutation,
    TError,
    EditInvestorBidMutationVariables,
    TContext
  >({
    mutationKey: ["EditInvestorBid"],
    mutationFn: (variables?: EditInvestorBidMutationVariables) =>
      publicFetcher<EditInvestorBidMutation, EditInvestorBidMutationVariables>(
        EditInvestorBidDocument,
        variables,
      )(),
    ...options,
  })
}

useEditInvestorBidMutation.fetcher = (
  variables: EditInvestorBidMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EditInvestorBidMutation, EditInvestorBidMutationVariables>(
    EditInvestorBidDocument,
    variables,
    options,
  )

export const DuplicateInvestorBidDocument = `
    mutation DuplicateInvestorBid($orgSlug: String!, $bundlePid: String!, $input: DuplicateInvestorBidInput!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      duplicateInvestorBid(input: $input) {
        ppa {
          pid
        }
        cs {
          pid
        }
      }
    }
  }
}
    `

export const useDuplicateInvestorBidMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DuplicateInvestorBidMutation,
    TError,
    DuplicateInvestorBidMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DuplicateInvestorBidMutation,
    TError,
    DuplicateInvestorBidMutationVariables,
    TContext
  >({
    mutationKey: ["DuplicateInvestorBid"],
    mutationFn: (variables?: DuplicateInvestorBidMutationVariables) =>
      publicFetcher<
        DuplicateInvestorBidMutation,
        DuplicateInvestorBidMutationVariables
      >(DuplicateInvestorBidDocument, variables)(),
    ...options,
  })
}

useDuplicateInvestorBidMutation.fetcher = (
  variables: DuplicateInvestorBidMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<DuplicateInvestorBidMutation, DuplicateInvestorBidMutationVariables>(
    DuplicateInvestorBidDocument,
    variables,
    options,
  )

export const AddSystemDocument = `
    mutation AddSystem($orgSlug: String!, $bundlePid: String!, $sitePid: String!, $input: AddSystemInput!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      addSystem(sitePid: $sitePid, input: $input) {
        system {
          pid
        }
        lite {
          pid
        }
      }
    }
  }
}
    `

export const useAddSystemMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddSystemMutation,
    TError,
    AddSystemMutationVariables,
    TContext
  >,
) => {
  return useMutation<AddSystemMutation, TError, AddSystemMutationVariables, TContext>({
    mutationKey: ["AddSystem"],
    mutationFn: (variables?: AddSystemMutationVariables) =>
      publicFetcher<AddSystemMutation, AddSystemMutationVariables>(
        AddSystemDocument,
        variables,
      )(),
    ...options,
  })
}

useAddSystemMutation.fetcher = (
  variables: AddSystemMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddSystemMutation, AddSystemMutationVariables>(
    AddSystemDocument,
    variables,
    options,
  )

export const UpdateEvOverridesDocument = `
    mutation UpdateEVOverrides($sitePid: String!, $projectStartDate: DateTime, $discountRate: Float, $usdPerKwhMarkup: Float, $incentivePct: Float, $salesTaxPct: Float, $omUsdPerChargerPerYr: Float, $rateManagementUsdPerChargerPerYr: Float, $cmsUsdPerChargerPerYr: Float, $demandUsdPerKw: Float, $installType: ChargerInstallType, $termYears: Int, $lowEnergyUsdPerKwh: Float, $highEnergyUsdPerKwh: Float, $onPeakChargingPct: Float, $numChargers: Float, $chargerLocation: ChargerLocation, $chargerKw: Float, $milesDrivenPerYear: Float, $milesPerKwh: Float, $maxUtilization: Float, $transactionFeePct: Float, $onSiteChargingPct: Float, $yr0NumTenantEvs: Int, $evGrowthPct: Float, $incentiveCapNumChargers: Int, $maxEvAdoptionPct: Float, $installCostUsd: Float) {
  evOverrides(sitePid: $sitePid) {
    update(
      projectStartDate: $projectStartDate
      discountRate: $discountRate
      usdPerKwhMarkup: $usdPerKwhMarkup
      incentivePct: $incentivePct
      salesTaxPct: $salesTaxPct
      omUsdPerChargerPerYr: $omUsdPerChargerPerYr
      rateManagementUsdPerChargerPerYr: $rateManagementUsdPerChargerPerYr
      cmsUsdPerChargerPerYr: $cmsUsdPerChargerPerYr
      demandUsdPerKw: $demandUsdPerKw
      installType: $installType
      termYears: $termYears
      lowEnergyUsdPerKwh: $lowEnergyUsdPerKwh
      highEnergyUsdPerKwh: $highEnergyUsdPerKwh
      onPeakChargingPct: $onPeakChargingPct
      numChargers: $numChargers
      chargerLocation: $chargerLocation
      chargerKw: $chargerKw
      milesDrivenPerYear: $milesDrivenPerYear
      milesPerKwh: $milesPerKwh
      maxUtilization: $maxUtilization
      transactionFeePct: $transactionFeePct
      onSiteChargingPct: $onSiteChargingPct
      yr0NumTenantEvs: $yr0NumTenantEvs
      evGrowthPct: $evGrowthPct
      incentiveCapNumChargers: $incentiveCapNumChargers
      maxEvAdoptionPct: $maxEvAdoptionPct
      installCostUsd: $installCostUsd
    )
  }
}
    `

export const useUpdateEvOverridesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateEvOverridesMutation,
    TError,
    UpdateEvOverridesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateEvOverridesMutation,
    TError,
    UpdateEvOverridesMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateEVOverrides"],
    mutationFn: (variables?: UpdateEvOverridesMutationVariables) =>
      publicFetcher<UpdateEvOverridesMutation, UpdateEvOverridesMutationVariables>(
        UpdateEvOverridesDocument,
        variables,
      )(),
    ...options,
  })
}

useUpdateEvOverridesMutation.fetcher = (
  variables: UpdateEvOverridesMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UpdateEvOverridesMutation, UpdateEvOverridesMutationVariables>(
    UpdateEvOverridesDocument,
    variables,
    options,
  )

export const ArchiveSiteDocument = `
    mutation ArchiveSite($sitePid: String!, $reason: StatusReason!) {
  archiveSite(sitePid: $sitePid, reason: $reason) {
    __typename
  }
}
    `

export const useArchiveSiteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ArchiveSiteMutation,
    TError,
    ArchiveSiteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ArchiveSiteMutation,
    TError,
    ArchiveSiteMutationVariables,
    TContext
  >({
    mutationKey: ["ArchiveSite"],
    mutationFn: (variables?: ArchiveSiteMutationVariables) =>
      publicFetcher<ArchiveSiteMutation, ArchiveSiteMutationVariables>(
        ArchiveSiteDocument,
        variables,
      )(),
    ...options,
  })
}

useArchiveSiteMutation.fetcher = (
  variables: ArchiveSiteMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ArchiveSiteMutation, ArchiveSiteMutationVariables>(
    ArchiveSiteDocument,
    variables,
    options,
  )

export const ResolveSiteFlagDocument = `
    mutation ResolveSiteFlag($orgSlug: String!, $sitePid: String!, $flagType: SiteFlagType!) {
  orgBySlug(slug: $orgSlug) {
    flags {
      resolveSiteFlag(sitePid: $sitePid, flagType: $flagType) {
        __typename
      }
    }
  }
}
    `

export const useResolveSiteFlagMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ResolveSiteFlagMutation,
    TError,
    ResolveSiteFlagMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    ResolveSiteFlagMutation,
    TError,
    ResolveSiteFlagMutationVariables,
    TContext
  >({
    mutationKey: ["ResolveSiteFlag"],
    mutationFn: (variables?: ResolveSiteFlagMutationVariables) =>
      publicFetcher<ResolveSiteFlagMutation, ResolveSiteFlagMutationVariables>(
        ResolveSiteFlagDocument,
        variables,
      )(),
    ...options,
  })
}

useResolveSiteFlagMutation.fetcher = (
  variables: ResolveSiteFlagMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ResolveSiteFlagMutation, ResolveSiteFlagMutationVariables>(
    ResolveSiteFlagDocument,
    variables,
    options,
  )

export const CreatePortfolioDocument = `
    mutation CreatePortfolio($orgSlug: String!, $name: String!) {
  orgBySlug(slug: $orgSlug) {
    createPortfolio(name: $name) {
      __typename
      ... on Error {
        message
      }
    }
  }
}
    `

export const useCreatePortfolioMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreatePortfolioMutation,
    TError,
    CreatePortfolioMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreatePortfolioMutation,
    TError,
    CreatePortfolioMutationVariables,
    TContext
  >({
    mutationKey: ["CreatePortfolio"],
    mutationFn: (variables?: CreatePortfolioMutationVariables) =>
      publicFetcher<CreatePortfolioMutation, CreatePortfolioMutationVariables>(
        CreatePortfolioDocument,
        variables,
      )(),
    ...options,
  })
}

useCreatePortfolioMutation.fetcher = (
  variables: CreatePortfolioMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CreatePortfolioMutation, CreatePortfolioMutationVariables>(
    CreatePortfolioDocument,
    variables,
    options,
  )

export const GrantRoleDocument = `
    mutation GrantRole($orgSlug: String!, $input: UserRoleInput!) {
  orgBySlug(slug: $orgSlug) {
    roles {
      grantRole(input: $input) {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
}
    `

export const useGrantRoleMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    GrantRoleMutation,
    TError,
    GrantRoleMutationVariables,
    TContext
  >,
) => {
  return useMutation<GrantRoleMutation, TError, GrantRoleMutationVariables, TContext>({
    mutationKey: ["GrantRole"],
    mutationFn: (variables?: GrantRoleMutationVariables) =>
      publicFetcher<GrantRoleMutation, GrantRoleMutationVariables>(
        GrantRoleDocument,
        variables,
      )(),
    ...options,
  })
}

useGrantRoleMutation.fetcher = (
  variables: GrantRoleMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<GrantRoleMutation, GrantRoleMutationVariables>(
    GrantRoleDocument,
    variables,
    options,
  )

export const RevokeRoleDocument = `
    mutation RevokeRole($orgSlug: String!, $input: UserRoleInput!) {
  orgBySlug(slug: $orgSlug) {
    roles {
      revokeRole(input: $input) {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
}
    `

export const useRevokeRoleMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RevokeRoleMutation,
    TError,
    RevokeRoleMutationVariables,
    TContext
  >,
) => {
  return useMutation<RevokeRoleMutation, TError, RevokeRoleMutationVariables, TContext>(
    {
      mutationKey: ["RevokeRole"],
      mutationFn: (variables?: RevokeRoleMutationVariables) =>
        publicFetcher<RevokeRoleMutation, RevokeRoleMutationVariables>(
          RevokeRoleDocument,
          variables,
        )(),
      ...options,
    },
  )
}

useRevokeRoleMutation.fetcher = (
  variables: RevokeRoleMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RevokeRoleMutation, RevokeRoleMutationVariables>(
    RevokeRoleDocument,
    variables,
    options,
  )

export const UpdateInvestorProfileDocument = `
    mutation UpdateInvestorProfile($orgSlug: String!, $hq: String, $yearFounded: Int, $website: String, $managementTeam: [String!]!, $description: String, $distinguishingFeatures: String, $investorBacking: String, $longTermOwnershipApproach: String, $subscriptionMgmtApproach: String, $committedFunding: String, $experiences: [ExperienceInput!]!) {
  orgBySlug(slug: $orgSlug) {
    investorProfile {
      updateProfile(
        hq: $hq
        yearFounded: $yearFounded
        website: $website
        managementTeam: $managementTeam
        description: $description
        distinguishingFeatures: $distinguishingFeatures
        investorBacking: $investorBacking
        longTermOwnershipApproach: $longTermOwnershipApproach
        subscriptionMgmtApproach: $subscriptionMgmtApproach
        committedFunding: $committedFunding
        experiences: $experiences
      )
    }
  }
}
    `

export const useUpdateInvestorProfileMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateInvestorProfileMutation,
    TError,
    UpdateInvestorProfileMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateInvestorProfileMutation,
    TError,
    UpdateInvestorProfileMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateInvestorProfile"],
    mutationFn: (variables?: UpdateInvestorProfileMutationVariables) =>
      publicFetcher<
        UpdateInvestorProfileMutation,
        UpdateInvestorProfileMutationVariables
      >(UpdateInvestorProfileDocument, variables)(),
    ...options,
  })
}

useUpdateInvestorProfileMutation.fetcher = (
  variables: UpdateInvestorProfileMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UpdateInvestorProfileMutation, UpdateInvestorProfileMutationVariables>(
    UpdateInvestorProfileDocument,
    variables,
    options,
  )

export const UpdateInvestorBuyBoxDocument = `
    mutation UpdateInvestorBuyBox($orgSlug: String!, $buyBoxes: [BuyBoxInput!]!) {
  orgBySlug(slug: $orgSlug) {
    investorProfile {
      updateBuyBox(buyBoxes: $buyBoxes)
    }
  }
}
    `

export const useUpdateInvestorBuyBoxMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateInvestorBuyBoxMutation,
    TError,
    UpdateInvestorBuyBoxMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateInvestorBuyBoxMutation,
    TError,
    UpdateInvestorBuyBoxMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateInvestorBuyBox"],
    mutationFn: (variables?: UpdateInvestorBuyBoxMutationVariables) =>
      publicFetcher<
        UpdateInvestorBuyBoxMutation,
        UpdateInvestorBuyBoxMutationVariables
      >(UpdateInvestorBuyBoxDocument, variables)(),
    ...options,
  })
}

useUpdateInvestorBuyBoxMutation.fetcher = (
  variables: UpdateInvestorBuyBoxMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UpdateInvestorBuyBoxMutation, UpdateInvestorBuyBoxMutationVariables>(
    UpdateInvestorBuyBoxDocument,
    variables,
    options,
  )

export const EvButtonDocument = `
    mutation EVButton($sitePid: String!, $button: String!) {
  evButton(sitePid: $sitePid) {
    press(button: $button)
  }
}
    `

export const useEvButtonMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EvButtonMutation,
    TError,
    EvButtonMutationVariables,
    TContext
  >,
) => {
  return useMutation<EvButtonMutation, TError, EvButtonMutationVariables, TContext>({
    mutationKey: ["EVButton"],
    mutationFn: (variables?: EvButtonMutationVariables) =>
      publicFetcher<EvButtonMutation, EvButtonMutationVariables>(
        EvButtonDocument,
        variables,
      )(),
    ...options,
  })
}

useEvButtonMutation.fetcher = (
  variables: EvButtonMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EvButtonMutation, EvButtonMutationVariables>(
    EvButtonDocument,
    variables,
    options,
  )

export const SetBundleParentPreBidMeetingDocument = `
    mutation SetBundleParentPreBidMeeting($orgSlug: String!, $bundleParentPid: String!, $milestone: MilestoneInput!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setPreBidMeeting(milestone: $milestone)
      }
    }
  }
}
    `

export const useSetBundleParentPreBidMeetingMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentPreBidMeetingMutation,
    TError,
    SetBundleParentPreBidMeetingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentPreBidMeetingMutation,
    TError,
    SetBundleParentPreBidMeetingMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentPreBidMeeting"],
    mutationFn: (variables?: SetBundleParentPreBidMeetingMutationVariables) =>
      publicFetcher<
        SetBundleParentPreBidMeetingMutation,
        SetBundleParentPreBidMeetingMutationVariables
      >(SetBundleParentPreBidMeetingDocument, variables)(),
    ...options,
  })
}

useSetBundleParentPreBidMeetingMutation.fetcher = (
  variables: SetBundleParentPreBidMeetingMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentPreBidMeetingMutation,
    SetBundleParentPreBidMeetingMutationVariables
  >(SetBundleParentPreBidMeetingDocument, variables, options)

export const SetBundleParentBidReviewMeetingDocument = `
    mutation SetBundleParentBidReviewMeeting($orgSlug: String!, $bundleParentPid: String!, $milestone: MilestoneInput!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setBidReviewMeeting(milestone: $milestone)
      }
    }
  }
}
    `

export const useSetBundleParentBidReviewMeetingMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentBidReviewMeetingMutation,
    TError,
    SetBundleParentBidReviewMeetingMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentBidReviewMeetingMutation,
    TError,
    SetBundleParentBidReviewMeetingMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentBidReviewMeeting"],
    mutationFn: (variables?: SetBundleParentBidReviewMeetingMutationVariables) =>
      publicFetcher<
        SetBundleParentBidReviewMeetingMutation,
        SetBundleParentBidReviewMeetingMutationVariables
      >(SetBundleParentBidReviewMeetingDocument, variables)(),
    ...options,
  })
}

useSetBundleParentBidReviewMeetingMutation.fetcher = (
  variables: SetBundleParentBidReviewMeetingMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentBidReviewMeetingMutation,
    SetBundleParentBidReviewMeetingMutationVariables
  >(SetBundleParentBidReviewMeetingDocument, variables, options)

export const SetArchiveInvestorBidDocument = `
    mutation SetArchiveInvestorBid($orgSlug: String!, $bundlePid: String!, $bidPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      archiveInvestorBid(archive: $value, bidPid: $bidPid)
    }
  }
}
    `

export const useSetArchiveInvestorBidMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetArchiveInvestorBidMutation,
    TError,
    SetArchiveInvestorBidMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetArchiveInvestorBidMutation,
    TError,
    SetArchiveInvestorBidMutationVariables,
    TContext
  >({
    mutationKey: ["SetArchiveInvestorBid"],
    mutationFn: (variables?: SetArchiveInvestorBidMutationVariables) =>
      publicFetcher<
        SetArchiveInvestorBidMutation,
        SetArchiveInvestorBidMutationVariables
      >(SetArchiveInvestorBidDocument, variables)(),
    ...options,
  })
}

useSetArchiveInvestorBidMutation.fetcher = (
  variables: SetArchiveInvestorBidMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetArchiveInvestorBidMutation, SetArchiveInvestorBidMutationVariables>(
    SetArchiveInvestorBidDocument,
    variables,
    options,
  )

export const SetBundleRowOptOutDocument = `
    mutation SetBundleRowOptOut($orgSlug: String!, $bundlePid: String!, $bundleRowId: Int!, $value: Boolean!, $reason: InvestorOptOutReason, $customReason: String) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      toggleOptOut(
        optOut: $value
        input: {bundleRowId: $bundleRowId}
        reason: $reason
        customReason: $customReason
      )
    }
  }
}
    `

export const useSetBundleRowOptOutMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetBundleRowOptOutMutation,
    TError,
    SetBundleRowOptOutMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleRowOptOutMutation,
    TError,
    SetBundleRowOptOutMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleRowOptOut"],
    mutationFn: (variables?: SetBundleRowOptOutMutationVariables) =>
      publicFetcher<SetBundleRowOptOutMutation, SetBundleRowOptOutMutationVariables>(
        SetBundleRowOptOutDocument,
        variables,
      )(),
    ...options,
  })
}

useSetBundleRowOptOutMutation.fetcher = (
  variables: SetBundleRowOptOutMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetBundleRowOptOutMutation, SetBundleRowOptOutMutationVariables>(
    SetBundleRowOptOutDocument,
    variables,
    options,
  )

export const SetBundleOptOutDocument = `
    mutation SetBundleOptOut($orgSlug: String!, $bundlePid: String!, $value: Boolean!, $reason: InvestorOptOutReason, $customReason: String) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      toggleOptOut(
        optOut: $value
        input: {bundlePid: $bundlePid}
        reason: $reason
        customReason: $customReason
      )
    }
  }
}
    `

export const useSetBundleOptOutMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetBundleOptOutMutation,
    TError,
    SetBundleOptOutMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleOptOutMutation,
    TError,
    SetBundleOptOutMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleOptOut"],
    mutationFn: (variables?: SetBundleOptOutMutationVariables) =>
      publicFetcher<SetBundleOptOutMutation, SetBundleOptOutMutationVariables>(
        SetBundleOptOutDocument,
        variables,
      )(),
    ...options,
  })
}

useSetBundleOptOutMutation.fetcher = (
  variables: SetBundleOptOutMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetBundleOptOutMutation, SetBundleOptOutMutationVariables>(
    SetBundleOptOutDocument,
    variables,
    options,
  )

export const SetBidSpecOptOutDocument = `
    mutation SetBidSpecOptOut($orgSlug: String!, $bundlePid: String!, $bidSpecPid: String!, $value: Boolean!, $reason: SpecOptOutReason, $customReason: String) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      toggleSpecOptOut(
        optOut: $value
        bidSpecPid: $bidSpecPid
        reason: $reason
        customReason: $customReason
      )
    }
  }
}
    `

export const useSetBidSpecOptOutMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetBidSpecOptOutMutation,
    TError,
    SetBidSpecOptOutMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBidSpecOptOutMutation,
    TError,
    SetBidSpecOptOutMutationVariables,
    TContext
  >({
    mutationKey: ["SetBidSpecOptOut"],
    mutationFn: (variables?: SetBidSpecOptOutMutationVariables) =>
      publicFetcher<SetBidSpecOptOutMutation, SetBidSpecOptOutMutationVariables>(
        SetBidSpecOptOutDocument,
        variables,
      )(),
    ...options,
  })
}

useSetBidSpecOptOutMutation.fetcher = (
  variables: SetBidSpecOptOutMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetBidSpecOptOutMutation, SetBidSpecOptOutMutationVariables>(
    SetBidSpecOptOutDocument,
    variables,
    options,
  )

export const SubmitBundleBidsDocument = `
    mutation SubmitBundleBids($orgSlug: String!, $bundlePid: String!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      submitBids(pricingTermsAgreed: true)
    }
  }
}
    `

export const useSubmitBundleBidsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SubmitBundleBidsMutation,
    TError,
    SubmitBundleBidsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SubmitBundleBidsMutation,
    TError,
    SubmitBundleBidsMutationVariables,
    TContext
  >({
    mutationKey: ["SubmitBundleBids"],
    mutationFn: (variables?: SubmitBundleBidsMutationVariables) =>
      publicFetcher<SubmitBundleBidsMutation, SubmitBundleBidsMutationVariables>(
        SubmitBundleBidsDocument,
        variables,
      )(),
    ...options,
  })
}

useSubmitBundleBidsMutation.fetcher = (
  variables: SubmitBundleBidsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SubmitBundleBidsMutation, SubmitBundleBidsMutationVariables>(
    SubmitBundleBidsDocument,
    variables,
    options,
  )

export const AddHelioscopeDocument = `
    mutation AddHelioscope($sitePid: String!, $bundlePid: String, $reportPdf: Upload!, $productionCsv: Upload) {
  addHelioscope(
    sitePid: $sitePid
    bundlePid: $bundlePid
    reportPdf: $reportPdf
    productionCsv: $productionCsv
  ) {
    ...Helioscope2Ref
  }
}
    ${Helioscope2RefFragmentDoc}`

export const useAddHelioscopeMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddHelioscopeMutation,
    TError,
    AddHelioscopeMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddHelioscopeMutation,
    TError,
    AddHelioscopeMutationVariables,
    TContext
  >({
    mutationKey: ["AddHelioscope"],
    mutationFn: (variables?: AddHelioscopeMutationVariables) =>
      publicFetcher<AddHelioscopeMutation, AddHelioscopeMutationVariables>(
        AddHelioscopeDocument,
        variables,
      )(),
    ...options,
  })
}

useAddHelioscopeMutation.fetcher = (
  variables: AddHelioscopeMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddHelioscopeMutation, AddHelioscopeMutationVariables>(
    AddHelioscopeDocument,
    variables,
    options,
  )

export const SetArchiveBidSpecDocument = `
    mutation SetArchiveBidSpec($orgSlug: String!, $bundleParentPid: String!, $specPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        archiveSpec(specPid: $specPid, archive: $value)
      }
    }
  }
}
    `

export const useSetArchiveBidSpecMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetArchiveBidSpecMutation,
    TError,
    SetArchiveBidSpecMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetArchiveBidSpecMutation,
    TError,
    SetArchiveBidSpecMutationVariables,
    TContext
  >({
    mutationKey: ["SetArchiveBidSpec"],
    mutationFn: (variables?: SetArchiveBidSpecMutationVariables) =>
      publicFetcher<SetArchiveBidSpecMutation, SetArchiveBidSpecMutationVariables>(
        SetArchiveBidSpecDocument,
        variables,
      )(),
    ...options,
  })
}

useSetArchiveBidSpecMutation.fetcher = (
  variables: SetArchiveBidSpecMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetArchiveBidSpecMutation, SetArchiveBidSpecMutationVariables>(
    SetArchiveBidSpecDocument,
    variables,
    options,
  )

export const SetPackageSiteNotesDocument = `
    mutation SetPackageSiteNotes($orgSlug: String!, $bundleParentPid: String!, $sitePid: String!, $notes: String) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setRowNotes(sitePid: $sitePid, notes: $notes)
      }
    }
  }
}
    `

export const useSetPackageSiteNotesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetPackageSiteNotesMutation,
    TError,
    SetPackageSiteNotesMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetPackageSiteNotesMutation,
    TError,
    SetPackageSiteNotesMutationVariables,
    TContext
  >({
    mutationKey: ["SetPackageSiteNotes"],
    mutationFn: (variables?: SetPackageSiteNotesMutationVariables) =>
      publicFetcher<SetPackageSiteNotesMutation, SetPackageSiteNotesMutationVariables>(
        SetPackageSiteNotesDocument,
        variables,
      )(),
    ...options,
  })
}

useSetPackageSiteNotesMutation.fetcher = (
  variables: SetPackageSiteNotesMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetPackageSiteNotesMutation, SetPackageSiteNotesMutationVariables>(
    SetPackageSiteNotesDocument,
    variables,
    options,
  )

export const AddInvestorBidSpecDocument = `
    mutation AddInvestorBidSpec($orgSlug: String!, $bundleParentPid: String!, $sitePid: String!, $input: BidSpecInput!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        addSpec(sitePid: $sitePid, input: $input) {
          ppa {
            pid
          }
          cs {
            pid
          }
        }
      }
    }
  }
}
    `

export const useAddInvestorBidSpecMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddInvestorBidSpecMutation,
    TError,
    AddInvestorBidSpecMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddInvestorBidSpecMutation,
    TError,
    AddInvestorBidSpecMutationVariables,
    TContext
  >({
    mutationKey: ["AddInvestorBidSpec"],
    mutationFn: (variables?: AddInvestorBidSpecMutationVariables) =>
      publicFetcher<AddInvestorBidSpecMutation, AddInvestorBidSpecMutationVariables>(
        AddInvestorBidSpecDocument,
        variables,
      )(),
    ...options,
  })
}

useAddInvestorBidSpecMutation.fetcher = (
  variables: AddInvestorBidSpecMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddInvestorBidSpecMutation, AddInvestorBidSpecMutationVariables>(
    AddInvestorBidSpecDocument,
    variables,
    options,
  )

export const EditInvestorBidSpecDocument = `
    mutation EditInvestorBidSpec($orgSlug: String!, $bundleParentPid: String!, $sitePid: String!, $specPid: String!, $input: BidSpecInput!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        editSpec(specPid: $specPid, sitePid: $sitePid, input: $input) {
          ppa {
            pid
          }
          cs {
            pid
          }
        }
      }
    }
  }
}
    `

export const useEditInvestorBidSpecMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditInvestorBidSpecMutation,
    TError,
    EditInvestorBidSpecMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditInvestorBidSpecMutation,
    TError,
    EditInvestorBidSpecMutationVariables,
    TContext
  >({
    mutationKey: ["EditInvestorBidSpec"],
    mutationFn: (variables?: EditInvestorBidSpecMutationVariables) =>
      publicFetcher<EditInvestorBidSpecMutation, EditInvestorBidSpecMutationVariables>(
        EditInvestorBidSpecDocument,
        variables,
      )(),
    ...options,
  })
}

useEditInvestorBidSpecMutation.fetcher = (
  variables: EditInvestorBidSpecMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EditInvestorBidSpecMutation, EditInvestorBidSpecMutationVariables>(
    EditInvestorBidSpecDocument,
    variables,
    options,
  )

export const EnqueueTaskDocument = `
    mutation EnqueueTask($params: TaskParamsInput!) {
  tasks {
    enqueue(params: $params) {
      __typename
      ... on Task {
        id
        name
        status
      }
      ... on Error {
        message
      }
    }
  }
}
    `

export const useEnqueueTaskMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EnqueueTaskMutation,
    TError,
    EnqueueTaskMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EnqueueTaskMutation,
    TError,
    EnqueueTaskMutationVariables,
    TContext
  >({
    mutationKey: ["EnqueueTask"],
    mutationFn: (variables?: EnqueueTaskMutationVariables) =>
      publicFetcher<EnqueueTaskMutation, EnqueueTaskMutationVariables>(
        EnqueueTaskDocument,
        variables,
      )(),
    ...options,
  })
}

useEnqueueTaskMutation.fetcher = (
  variables: EnqueueTaskMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EnqueueTaskMutation, EnqueueTaskMutationVariables>(
    EnqueueTaskDocument,
    variables,
    options,
  )

export const AddBundleParentEtbDocument = `
    mutation AddBundleParentEtb($orgSlug: String!, $bundleParentPid: String!, $sitePid: String!, $upload: Upload!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        addEtb(sitePid: $sitePid, upload: $upload) {
          ...EtbExtract
        }
      }
    }
  }
}
    ${EtbExtractFragmentDoc}`

export const useAddBundleParentEtbMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddBundleParentEtbMutation,
    TError,
    AddBundleParentEtbMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddBundleParentEtbMutation,
    TError,
    AddBundleParentEtbMutationVariables,
    TContext
  >({
    mutationKey: ["AddBundleParentEtb"],
    mutationFn: (variables?: AddBundleParentEtbMutationVariables) =>
      publicFetcher<AddBundleParentEtbMutation, AddBundleParentEtbMutationVariables>(
        AddBundleParentEtbDocument,
        variables,
      )(),
    ...options,
  })
}

useAddBundleParentEtbMutation.fetcher = (
  variables: AddBundleParentEtbMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddBundleParentEtbMutation, AddBundleParentEtbMutationVariables>(
    AddBundleParentEtbDocument,
    variables,
    options,
  )

export const AddBundleEtbDocument = `
    mutation AddBundleEtb($orgSlug: String!, $bundlePid: String!, $sitePid: String!, $upload: Upload!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      addEtb(sitePid: $sitePid, upload: $upload) {
        ...EtbExtract
      }
    }
  }
}
    ${EtbExtractFragmentDoc}`

export const useAddBundleEtbMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddBundleEtbMutation,
    TError,
    AddBundleEtbMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddBundleEtbMutation,
    TError,
    AddBundleEtbMutationVariables,
    TContext
  >({
    mutationKey: ["AddBundleEtb"],
    mutationFn: (variables?: AddBundleEtbMutationVariables) =>
      publicFetcher<AddBundleEtbMutation, AddBundleEtbMutationVariables>(
        AddBundleEtbDocument,
        variables,
      )(),
    ...options,
  })
}

useAddBundleEtbMutation.fetcher = (
  variables: AddBundleEtbMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddBundleEtbMutation, AddBundleEtbMutationVariables>(
    AddBundleEtbDocument,
    variables,
    options,
  )

export const SetPackageRowStatusDocument = `
    mutation SetPackageRowStatus($bundleParentPid: String!, $sitePid: String!, $status: PackageRowStatus, $closed: Boolean, $closeReason: PackageRowCloseReason, $closeCustomReason: String) {
  setPackageRowStatus(
    bundleParentPid: $bundleParentPid
    sitePid: $sitePid
    status: $status
    closed: $closed
    closeReason: $closeReason
    customCloseReason: $closeCustomReason
  )
}
    `

export const useSetPackageRowStatusMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetPackageRowStatusMutation,
    TError,
    SetPackageRowStatusMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetPackageRowStatusMutation,
    TError,
    SetPackageRowStatusMutationVariables,
    TContext
  >({
    mutationKey: ["SetPackageRowStatus"],
    mutationFn: (variables?: SetPackageRowStatusMutationVariables) =>
      publicFetcher<SetPackageRowStatusMutation, SetPackageRowStatusMutationVariables>(
        SetPackageRowStatusDocument,
        variables,
      )(),
    ...options,
  })
}

useSetPackageRowStatusMutation.fetcher = (
  variables: SetPackageRowStatusMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetPackageRowStatusMutation, SetPackageRowStatusMutationVariables>(
    SetPackageRowStatusDocument,
    variables,
    options,
  )

export const AwardInvestorBidDocument = `
    mutation AwardInvestorBid($orgSlug: String!, $bidPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    awardInvestorBid(bidPid: $bidPid, value: $value)
  }
}
    `

export const useAwardInvestorBidMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AwardInvestorBidMutation,
    TError,
    AwardInvestorBidMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AwardInvestorBidMutation,
    TError,
    AwardInvestorBidMutationVariables,
    TContext
  >({
    mutationKey: ["AwardInvestorBid"],
    mutationFn: (variables?: AwardInvestorBidMutationVariables) =>
      publicFetcher<AwardInvestorBidMutation, AwardInvestorBidMutationVariables>(
        AwardInvestorBidDocument,
        variables,
      )(),
    ...options,
  })
}

useAwardInvestorBidMutation.fetcher = (
  variables: AwardInvestorBidMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AwardInvestorBidMutation, AwardInvestorBidMutationVariables>(
    AwardInvestorBidDocument,
    variables,
    options,
  )

export const RecommendInvestorBidDocument = `
    mutation RecommendInvestorBid($orgSlug: String!, $bidPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    recommendInvestorBid(bidPid: $bidPid, value: $value)
  }
}
    `

export const useRecommendInvestorBidMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RecommendInvestorBidMutation,
    TError,
    RecommendInvestorBidMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RecommendInvestorBidMutation,
    TError,
    RecommendInvestorBidMutationVariables,
    TContext
  >({
    mutationKey: ["RecommendInvestorBid"],
    mutationFn: (variables?: RecommendInvestorBidMutationVariables) =>
      publicFetcher<
        RecommendInvestorBidMutation,
        RecommendInvestorBidMutationVariables
      >(RecommendInvestorBidDocument, variables)(),
    ...options,
  })
}

useRecommendInvestorBidMutation.fetcher = (
  variables: RecommendInvestorBidMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RecommendInvestorBidMutation, RecommendInvestorBidMutationVariables>(
    RecommendInvestorBidDocument,
    variables,
    options,
  )

export const SetBundleParentHiddenFromFinancierDocument = `
    mutation SetBundleParentHiddenFromFinancier($orgSlug: String!, $bundleParentPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setHiddenFromFinancier(hidden: $value)
      }
    }
  }
}
    `

export const useSetBundleParentHiddenFromFinancierMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentHiddenFromFinancierMutation,
    TError,
    SetBundleParentHiddenFromFinancierMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentHiddenFromFinancierMutation,
    TError,
    SetBundleParentHiddenFromFinancierMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentHiddenFromFinancier"],
    mutationFn: (variables?: SetBundleParentHiddenFromFinancierMutationVariables) =>
      publicFetcher<
        SetBundleParentHiddenFromFinancierMutation,
        SetBundleParentHiddenFromFinancierMutationVariables
      >(SetBundleParentHiddenFromFinancierDocument, variables)(),
    ...options,
  })
}

useSetBundleParentHiddenFromFinancierMutation.fetcher = (
  variables: SetBundleParentHiddenFromFinancierMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentHiddenFromFinancierMutation,
    SetBundleParentHiddenFromFinancierMutationVariables
  >(SetBundleParentHiddenFromFinancierDocument, variables, options)

export const SetBundleParentHiddenFromReceiverDocument = `
    mutation SetBundleParentHiddenFromReceiver($orgSlug: String!, $bundleParentPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setHiddenFromRecvr(hidden: $value)
      }
    }
  }
}
    `

export const useSetBundleParentHiddenFromReceiverMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentHiddenFromReceiverMutation,
    TError,
    SetBundleParentHiddenFromReceiverMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentHiddenFromReceiverMutation,
    TError,
    SetBundleParentHiddenFromReceiverMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentHiddenFromReceiver"],
    mutationFn: (variables?: SetBundleParentHiddenFromReceiverMutationVariables) =>
      publicFetcher<
        SetBundleParentHiddenFromReceiverMutation,
        SetBundleParentHiddenFromReceiverMutationVariables
      >(SetBundleParentHiddenFromReceiverDocument, variables)(),
    ...options,
  })
}

useSetBundleParentHiddenFromReceiverMutation.fetcher = (
  variables: SetBundleParentHiddenFromReceiverMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentHiddenFromReceiverMutation,
    SetBundleParentHiddenFromReceiverMutationVariables
  >(SetBundleParentHiddenFromReceiverDocument, variables, options)

export const SetBundleParentCanAddNewBidsDocument = `
    mutation SetBundleParentCanAddNewBids($orgSlug: String!, $bundleParentPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setCanAddNewBids(can: $value)
      }
    }
  }
}
    `

export const useSetBundleParentCanAddNewBidsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentCanAddNewBidsMutation,
    TError,
    SetBundleParentCanAddNewBidsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentCanAddNewBidsMutation,
    TError,
    SetBundleParentCanAddNewBidsMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentCanAddNewBids"],
    mutationFn: (variables?: SetBundleParentCanAddNewBidsMutationVariables) =>
      publicFetcher<
        SetBundleParentCanAddNewBidsMutation,
        SetBundleParentCanAddNewBidsMutationVariables
      >(SetBundleParentCanAddNewBidsDocument, variables)(),
    ...options,
  })
}

useSetBundleParentCanAddNewBidsMutation.fetcher = (
  variables: SetBundleParentCanAddNewBidsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentCanAddNewBidsMutation,
    SetBundleParentCanAddNewBidsMutationVariables
  >(SetBundleParentCanAddNewBidsDocument, variables, options)

export const SetBundleParentCanEditBidsDocument = `
    mutation SetBundleParentCanEditBids($orgSlug: String!, $bundleParentPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setCanEditBids(can: $value)
      }
    }
  }
}
    `

export const useSetBundleParentCanEditBidsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentCanEditBidsMutation,
    TError,
    SetBundleParentCanEditBidsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentCanEditBidsMutation,
    TError,
    SetBundleParentCanEditBidsMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentCanEditBids"],
    mutationFn: (variables?: SetBundleParentCanEditBidsMutationVariables) =>
      publicFetcher<
        SetBundleParentCanEditBidsMutation,
        SetBundleParentCanEditBidsMutationVariables
      >(SetBundleParentCanEditBidsDocument, variables)(),
    ...options,
  })
}

useSetBundleParentCanEditBidsMutation.fetcher = (
  variables: SetBundleParentCanEditBidsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentCanEditBidsMutation,
    SetBundleParentCanEditBidsMutationVariables
  >(SetBundleParentCanEditBidsDocument, variables, options)

export const SetBundleParentShowAllBidsReportDocument = `
    mutation SetBundleParentShowAllBidsReport($orgSlug: String!, $bundleParentPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setShowAllBidsReport(value: $value)
      }
    }
  }
}
    `

export const useSetBundleParentShowAllBidsReportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentShowAllBidsReportMutation,
    TError,
    SetBundleParentShowAllBidsReportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentShowAllBidsReportMutation,
    TError,
    SetBundleParentShowAllBidsReportMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentShowAllBidsReport"],
    mutationFn: (variables?: SetBundleParentShowAllBidsReportMutationVariables) =>
      publicFetcher<
        SetBundleParentShowAllBidsReportMutation,
        SetBundleParentShowAllBidsReportMutationVariables
      >(SetBundleParentShowAllBidsReportDocument, variables)(),
    ...options,
  })
}

useSetBundleParentShowAllBidsReportMutation.fetcher = (
  variables: SetBundleParentShowAllBidsReportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentShowAllBidsReportMutation,
    SetBundleParentShowAllBidsReportMutationVariables
  >(SetBundleParentShowAllBidsReportDocument, variables, options)

export const SetBundleParentOpsOwnerDocument = `
    mutation SetBundleParentOpsOwner($orgSlug: String!, $bundleParentPid: String!, $opsOwnerPid: String) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        setOpsOwner(opsOwnerPid: $opsOwnerPid)
      }
    }
  }
}
    `

export const useSetBundleParentOpsOwnerMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetBundleParentOpsOwnerMutation,
    TError,
    SetBundleParentOpsOwnerMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetBundleParentOpsOwnerMutation,
    TError,
    SetBundleParentOpsOwnerMutationVariables,
    TContext
  >({
    mutationKey: ["SetBundleParentOpsOwner"],
    mutationFn: (variables?: SetBundleParentOpsOwnerMutationVariables) =>
      publicFetcher<
        SetBundleParentOpsOwnerMutation,
        SetBundleParentOpsOwnerMutationVariables
      >(SetBundleParentOpsOwnerDocument, variables)(),
    ...options,
  })
}

useSetBundleParentOpsOwnerMutation.fetcher = (
  variables: SetBundleParentOpsOwnerMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetBundleParentOpsOwnerMutation,
    SetBundleParentOpsOwnerMutationVariables
  >(SetBundleParentOpsOwnerDocument, variables, options)

export const UpdateSiteDetailsDocument = `
    mutation UpdateSiteDetails($sitePid: String!, $input: UpdateDetailsInput!, $sourceType: ChangeSourceType, $sourceId: String) {
  siteDetails(sitePid: $sitePid) {
    updateDetails(input: $input, sourceType: $sourceType, sourceId: $sourceId)
  }
}
    `

export const useUpdateSiteDetailsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateSiteDetailsMutation,
    TError,
    UpdateSiteDetailsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateSiteDetailsMutation,
    TError,
    UpdateSiteDetailsMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateSiteDetails"],
    mutationFn: (variables?: UpdateSiteDetailsMutationVariables) =>
      publicFetcher<UpdateSiteDetailsMutation, UpdateSiteDetailsMutationVariables>(
        UpdateSiteDetailsDocument,
        variables,
      )(),
    ...options,
  })
}

useUpdateSiteDetailsMutation.fetcher = (
  variables: UpdateSiteDetailsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UpdateSiteDetailsMutation, UpdateSiteDetailsMutationVariables>(
    UpdateSiteDetailsDocument,
    variables,
    options,
  )

export const CreateCustomBidReportDocument = `
    mutation CreateCustomBidReport($orgSlug: String!, $bundleParentPid: String!, $name: String!, $developerNotes: String!, $buildingOwnerNotes: String!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        createCustomBidReport(
          name: $name
          developerNotes: $developerNotes
          buildingOwnerNotes: $buildingOwnerNotes
        ) {
          pid
          name
          notes
          buildingOwnerNotes
        }
      }
    }
  }
}
    `

export const useCreateCustomBidReportMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateCustomBidReportMutation,
    TError,
    CreateCustomBidReportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateCustomBidReportMutation,
    TError,
    CreateCustomBidReportMutationVariables,
    TContext
  >({
    mutationKey: ["CreateCustomBidReport"],
    mutationFn: (variables?: CreateCustomBidReportMutationVariables) =>
      publicFetcher<
        CreateCustomBidReportMutation,
        CreateCustomBidReportMutationVariables
      >(CreateCustomBidReportDocument, variables)(),
    ...options,
  })
}

useCreateCustomBidReportMutation.fetcher = (
  variables: CreateCustomBidReportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CreateCustomBidReportMutation, CreateCustomBidReportMutationVariables>(
    CreateCustomBidReportDocument,
    variables,
    options,
  )

export const EditCustomBidReportDocument = `
    mutation EditCustomBidReport($orgSlug: String!, $bundleParentPid: String!, $reportPid: String!, $name: String!, $developerNotes: String!, $buildingOwnerNotes: String!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        editCustomBidReport(pid: $reportPid) {
          setName(value: $name)
          setDeveloperNotes(value: $developerNotes)
          setBuildingOwnerNotes(value: $buildingOwnerNotes)
        }
      }
    }
  }
}
    `

export const useEditCustomBidReportMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditCustomBidReportMutation,
    TError,
    EditCustomBidReportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    EditCustomBidReportMutation,
    TError,
    EditCustomBidReportMutationVariables,
    TContext
  >({
    mutationKey: ["EditCustomBidReport"],
    mutationFn: (variables?: EditCustomBidReportMutationVariables) =>
      publicFetcher<EditCustomBidReportMutation, EditCustomBidReportMutationVariables>(
        EditCustomBidReportDocument,
        variables,
      )(),
    ...options,
  })
}

useEditCustomBidReportMutation.fetcher = (
  variables: EditCustomBidReportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EditCustomBidReportMutation, EditCustomBidReportMutationVariables>(
    EditCustomBidReportDocument,
    variables,
    options,
  )

export const SetCustomBidReportVisibleToDevelopersDocument = `
    mutation SetCustomBidReportVisibleToDevelopers($orgSlug: String!, $bundleParentPid: String!, $reportPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        editCustomBidReport(pid: $reportPid) {
          setVisibleToDevelopers(value: $value)
        }
      }
    }
  }
}
    `

export const useSetCustomBidReportVisibleToDevelopersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetCustomBidReportVisibleToDevelopersMutation,
    TError,
    SetCustomBidReportVisibleToDevelopersMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCustomBidReportVisibleToDevelopersMutation,
    TError,
    SetCustomBidReportVisibleToDevelopersMutationVariables,
    TContext
  >({
    mutationKey: ["SetCustomBidReportVisibleToDevelopers"],
    mutationFn: (variables?: SetCustomBidReportVisibleToDevelopersMutationVariables) =>
      publicFetcher<
        SetCustomBidReportVisibleToDevelopersMutation,
        SetCustomBidReportVisibleToDevelopersMutationVariables
      >(SetCustomBidReportVisibleToDevelopersDocument, variables)(),
    ...options,
  })
}

useSetCustomBidReportVisibleToDevelopersMutation.fetcher = (
  variables: SetCustomBidReportVisibleToDevelopersMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetCustomBidReportVisibleToDevelopersMutation,
    SetCustomBidReportVisibleToDevelopersMutationVariables
  >(SetCustomBidReportVisibleToDevelopersDocument, variables, options)

export const SetCustomBidReportVisibleToBuildingOwnersDocument = `
    mutation SetCustomBidReportVisibleToBuildingOwners($orgSlug: String!, $bundleParentPid: String!, $reportPid: String!, $value: Boolean!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        editCustomBidReport(pid: $reportPid) {
          setVisibleToBuildingOwners(value: $value)
        }
      }
    }
  }
}
    `

export const useSetCustomBidReportVisibleToBuildingOwnersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetCustomBidReportVisibleToBuildingOwnersMutation,
    TError,
    SetCustomBidReportVisibleToBuildingOwnersMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetCustomBidReportVisibleToBuildingOwnersMutation,
    TError,
    SetCustomBidReportVisibleToBuildingOwnersMutationVariables,
    TContext
  >({
    mutationKey: ["SetCustomBidReportVisibleToBuildingOwners"],
    mutationFn: (
      variables?: SetCustomBidReportVisibleToBuildingOwnersMutationVariables,
    ) =>
      publicFetcher<
        SetCustomBidReportVisibleToBuildingOwnersMutation,
        SetCustomBidReportVisibleToBuildingOwnersMutationVariables
      >(SetCustomBidReportVisibleToBuildingOwnersDocument, variables)(),
    ...options,
  })
}

useSetCustomBidReportVisibleToBuildingOwnersMutation.fetcher = (
  variables: SetCustomBidReportVisibleToBuildingOwnersMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SetCustomBidReportVisibleToBuildingOwnersMutation,
    SetCustomBidReportVisibleToBuildingOwnersMutationVariables
  >(SetCustomBidReportVisibleToBuildingOwnersDocument, variables, options)

export const DeleteCustomBidReportDocument = `
    mutation DeleteCustomBidReport($orgSlug: String!, $bundleParentPid: String!, $reportPid: String!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        editCustomBidReport(pid: $reportPid) {
          delete
        }
      }
    }
  }
}
    `

export const useDeleteCustomBidReportMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteCustomBidReportMutation,
    TError,
    DeleteCustomBidReportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteCustomBidReportMutation,
    TError,
    DeleteCustomBidReportMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteCustomBidReport"],
    mutationFn: (variables?: DeleteCustomBidReportMutationVariables) =>
      publicFetcher<
        DeleteCustomBidReportMutation,
        DeleteCustomBidReportMutationVariables
      >(DeleteCustomBidReportDocument, variables)(),
    ...options,
  })
}

useDeleteCustomBidReportMutation.fetcher = (
  variables: DeleteCustomBidReportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<DeleteCustomBidReportMutation, DeleteCustomBidReportMutationVariables>(
    DeleteCustomBidReportDocument,
    variables,
    options,
  )

export const AddBidToCustomBidReportDocument = `
    mutation AddBidToCustomBidReport($orgSlug: String!, $bundleParentPid: String!, $reportPid: String!, $bidPid: String!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        editCustomBidReport(pid: $reportPid) {
          upsertBid(bidPid: $bidPid)
        }
      }
    }
  }
}
    `

export const useAddBidToCustomBidReportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddBidToCustomBidReportMutation,
    TError,
    AddBidToCustomBidReportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddBidToCustomBidReportMutation,
    TError,
    AddBidToCustomBidReportMutationVariables,
    TContext
  >({
    mutationKey: ["AddBidToCustomBidReport"],
    mutationFn: (variables?: AddBidToCustomBidReportMutationVariables) =>
      publicFetcher<
        AddBidToCustomBidReportMutation,
        AddBidToCustomBidReportMutationVariables
      >(AddBidToCustomBidReportDocument, variables)(),
    ...options,
  })
}

useAddBidToCustomBidReportMutation.fetcher = (
  variables: AddBidToCustomBidReportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    AddBidToCustomBidReportMutation,
    AddBidToCustomBidReportMutationVariables
  >(AddBidToCustomBidReportDocument, variables, options)

export const RemoveBidFromCustomBidReportDocument = `
    mutation RemoveBidFromCustomBidReport($orgSlug: String!, $bundleParentPid: String!, $reportPid: String!, $bidPid: String!) {
  orgBySlug(slug: $orgSlug) {
    bundle {
      editParent(pid: $bundleParentPid) {
        editCustomBidReport(pid: $reportPid) {
          removeBid(bidPid: $bidPid)
        }
      }
    }
  }
}
    `

export const useRemoveBidFromCustomBidReportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveBidFromCustomBidReportMutation,
    TError,
    RemoveBidFromCustomBidReportMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    RemoveBidFromCustomBidReportMutation,
    TError,
    RemoveBidFromCustomBidReportMutationVariables,
    TContext
  >({
    mutationKey: ["RemoveBidFromCustomBidReport"],
    mutationFn: (variables?: RemoveBidFromCustomBidReportMutationVariables) =>
      publicFetcher<
        RemoveBidFromCustomBidReportMutation,
        RemoveBidFromCustomBidReportMutationVariables
      >(RemoveBidFromCustomBidReportDocument, variables)(),
    ...options,
  })
}

useRemoveBidFromCustomBidReportMutation.fetcher = (
  variables: RemoveBidFromCustomBidReportMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    RemoveBidFromCustomBidReportMutation,
    RemoveBidFromCustomBidReportMutationVariables
  >(RemoveBidFromCustomBidReportDocument, variables, options)

export const UpdateCustomTariffDocument = `
    mutation UpdateCustomTariff($sitePid: String!, $customTariffId: Int!, $addRateOps: [AddRateInput!]!, $subRateOps: [SubRateInput!]!, $propertyOps: [OverridePropertyInput!]!, $name: String!) {
  customTariffs(sitePid: $sitePid) {
    update(
      customTariffId: $customTariffId
      addRateOps: $addRateOps
      subRateOps: $subRateOps
      propertyOps: $propertyOps
      name: $name
    ) {
      id
    }
  }
}
    `

export const useUpdateCustomTariffMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateCustomTariffMutation,
    TError,
    UpdateCustomTariffMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateCustomTariffMutation,
    TError,
    UpdateCustomTariffMutationVariables,
    TContext
  >({
    mutationKey: ["UpdateCustomTariff"],
    mutationFn: (variables?: UpdateCustomTariffMutationVariables) =>
      publicFetcher<UpdateCustomTariffMutation, UpdateCustomTariffMutationVariables>(
        UpdateCustomTariffDocument,
        variables,
      )(),
    ...options,
  })
}

useUpdateCustomTariffMutation.fetcher = (
  variables: UpdateCustomTariffMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UpdateCustomTariffMutation, UpdateCustomTariffMutationVariables>(
    UpdateCustomTariffDocument,
    variables,
    options,
  )

export const CreateCustomTariffDocument = `
    mutation CreateCustomTariff($sitePid: String!, $name: String!, $rateId: Int!, $addRateOps: [AddRateInput!]!, $subRateOps: [SubRateInput!]!, $propertyOps: [OverridePropertyInput!]!) {
  customTariffs(sitePid: $sitePid) {
    create(
      name: $name
      rateId: $rateId
      addRateOps: $addRateOps
      subRateOps: $subRateOps
      propertyOps: $propertyOps
    ) {
      id
    }
  }
}
    `

export const useCreateCustomTariffMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateCustomTariffMutation,
    TError,
    CreateCustomTariffMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateCustomTariffMutation,
    TError,
    CreateCustomTariffMutationVariables,
    TContext
  >({
    mutationKey: ["CreateCustomTariff"],
    mutationFn: (variables?: CreateCustomTariffMutationVariables) =>
      publicFetcher<CreateCustomTariffMutation, CreateCustomTariffMutationVariables>(
        CreateCustomTariffDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateCustomTariffMutation.fetcher = (
  variables: CreateCustomTariffMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CreateCustomTariffMutation, CreateCustomTariffMutationVariables>(
    CreateCustomTariffDocument,
    variables,
    options,
  )

export const CreateCustomTariffScratchDocument = `
    mutation CreateCustomTariffScratch($sitePid: String!, $name: String!, $tariffClass: TariffClass!, $utilityPid: String!, $addRateOps: [AddRateInput!]!) {
  customTariffs(sitePid: $sitePid) {
    createFromScratch(
      name: $name
      tariffClass: $tariffClass
      utilityPid: $utilityPid
      addRateOps: $addRateOps
    ) {
      id
    }
  }
}
    `

export const useCreateCustomTariffScratchMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateCustomTariffScratchMutation,
    TError,
    CreateCustomTariffScratchMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateCustomTariffScratchMutation,
    TError,
    CreateCustomTariffScratchMutationVariables,
    TContext
  >({
    mutationKey: ["CreateCustomTariffScratch"],
    mutationFn: (variables?: CreateCustomTariffScratchMutationVariables) =>
      publicFetcher<
        CreateCustomTariffScratchMutation,
        CreateCustomTariffScratchMutationVariables
      >(CreateCustomTariffScratchDocument, variables)(),
    ...options,
  })
}

useCreateCustomTariffScratchMutation.fetcher = (
  variables: CreateCustomTariffScratchMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    CreateCustomTariffScratchMutation,
    CreateCustomTariffScratchMutationVariables
  >(CreateCustomTariffScratchDocument, variables, options)

export const SetProjectMilestoneDocument = `
    mutation SetProjectMilestone($orgSlug: String!, $bundlePid: String!, $sitePid: String!, $milestoneType: MilestoneType!, $milestoneInput: ProjectMilestoneInput!) {
  orgBySlug(slug: $orgSlug) {
    financierBundle(bundlePid: $bundlePid) {
      setMilestone(
        sitePid: $sitePid
        milestoneType: $milestoneType
        milestoneInput: $milestoneInput
      )
    }
  }
}
    `

export const useSetProjectMilestoneMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetProjectMilestoneMutation,
    TError,
    SetProjectMilestoneMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetProjectMilestoneMutation,
    TError,
    SetProjectMilestoneMutationVariables,
    TContext
  >({
    mutationKey: ["SetProjectMilestone"],
    mutationFn: (variables?: SetProjectMilestoneMutationVariables) =>
      publicFetcher<SetProjectMilestoneMutation, SetProjectMilestoneMutationVariables>(
        SetProjectMilestoneDocument,
        variables,
      )(),
    ...options,
  })
}

useSetProjectMilestoneMutation.fetcher = (
  variables: SetProjectMilestoneMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetProjectMilestoneMutation, SetProjectMilestoneMutationVariables>(
    SetProjectMilestoneDocument,
    variables,
    options,
  )

export const SetIsBehindTheMeterDocument = `
    mutation SetIsBehindTheMeter($sitePid: String!, $isBehindTheMeter: Boolean) {
  setIsBehindTheMeter(sitePid: $sitePid, isBehindTheMeter: $isBehindTheMeter)
}
    `

export const useSetIsBehindTheMeterMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SetIsBehindTheMeterMutation,
    TError,
    SetIsBehindTheMeterMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    SetIsBehindTheMeterMutation,
    TError,
    SetIsBehindTheMeterMutationVariables,
    TContext
  >({
    mutationKey: ["SetIsBehindTheMeter"],
    mutationFn: (variables?: SetIsBehindTheMeterMutationVariables) =>
      publicFetcher<SetIsBehindTheMeterMutation, SetIsBehindTheMeterMutationVariables>(
        SetIsBehindTheMeterDocument,
        variables,
      )(),
    ...options,
  })
}

useSetIsBehindTheMeterMutation.fetcher = (
  variables: SetIsBehindTheMeterMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SetIsBehindTheMeterMutation, SetIsBehindTheMeterMutationVariables>(
    SetIsBehindTheMeterDocument,
    variables,
    options,
  )

export const FinalizeEnergyPageUploadsDocument = `
    mutation FinalizeEnergyPageUploads($sitePid: String!) {
  finalizeEnergyPageUpload(sitePid: $sitePid)
}
    `

export const useFinalizeEnergyPageUploadsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    FinalizeEnergyPageUploadsMutation,
    TError,
    FinalizeEnergyPageUploadsMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    FinalizeEnergyPageUploadsMutation,
    TError,
    FinalizeEnergyPageUploadsMutationVariables,
    TContext
  >({
    mutationKey: ["FinalizeEnergyPageUploads"],
    mutationFn: (variables?: FinalizeEnergyPageUploadsMutationVariables) =>
      publicFetcher<
        FinalizeEnergyPageUploadsMutation,
        FinalizeEnergyPageUploadsMutationVariables
      >(FinalizeEnergyPageUploadsDocument, variables)(),
    ...options,
  })
}

useFinalizeEnergyPageUploadsMutation.fetcher = (
  variables: FinalizeEnergyPageUploadsMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    FinalizeEnergyPageUploadsMutation,
    FinalizeEnergyPageUploadsMutationVariables
  >(FinalizeEnergyPageUploadsDocument, variables, options)

export const CreateEmailDraftDocument = `
    mutation CreateEmailDraft($draftParams: DraftEmailInput!) {
  admin {
    googleApi {
      draftEmail(draftParams: $draftParams)
    }
  }
}
    `

export const useCreateEmailDraftMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateEmailDraftMutation,
    TError,
    CreateEmailDraftMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateEmailDraftMutation,
    TError,
    CreateEmailDraftMutationVariables,
    TContext
  >({
    mutationKey: ["CreateEmailDraft"],
    mutationFn: (variables?: CreateEmailDraftMutationVariables) =>
      publicFetcher<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>(
        CreateEmailDraftDocument,
        variables,
      )(),
    ...options,
  })
}

useCreateEmailDraftMutation.fetcher = (
  variables: CreateEmailDraftMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>(
    CreateEmailDraftDocument,
    variables,
    options,
  )

export const AddFinmodelOverrideDocument = `
    mutation AddFinmodelOverride($sitePid: String, $portfolioPid: String, $overrideInput: FinmodelMutationInput!) {
  finmodel {
    addOverride(
      sitePid: $sitePid
      portfolioPid: $portfolioPid
      overrideInput: $overrideInput
    ) {
      __typename
      ... on Error {
        message
      }
      ... on FinmodelInputOverride {
        inputName
        inputValue
      }
    }
  }
}
    `

export const useAddFinmodelOverrideMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddFinmodelOverrideMutation,
    TError,
    AddFinmodelOverrideMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    AddFinmodelOverrideMutation,
    TError,
    AddFinmodelOverrideMutationVariables,
    TContext
  >({
    mutationKey: ["AddFinmodelOverride"],
    mutationFn: (variables?: AddFinmodelOverrideMutationVariables) =>
      publicFetcher<AddFinmodelOverrideMutation, AddFinmodelOverrideMutationVariables>(
        AddFinmodelOverrideDocument,
        variables,
      )(),
    ...options,
  })
}

useAddFinmodelOverrideMutation.fetcher = (
  variables: AddFinmodelOverrideMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AddFinmodelOverrideMutation, AddFinmodelOverrideMutationVariables>(
    AddFinmodelOverrideDocument,
    variables,
    options,
  )

export const DeleteFinmodelOverrideDocument = `
    mutation DeleteFinmodelOverride($sitePid: String, $portfolioPid: String, $inputName: String!) {
  finmodel {
    deleteOverride(
      sitePid: $sitePid
      portfolioPid: $portfolioPid
      inputName: $inputName
    ) {
      __typename
      ... on Error {
        message
      }
      ... on FinmodelInputOverride {
        inputName
        inputValue
      }
    }
  }
}
    `

export const useDeleteFinmodelOverrideMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteFinmodelOverrideMutation,
    TError,
    DeleteFinmodelOverrideMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteFinmodelOverrideMutation,
    TError,
    DeleteFinmodelOverrideMutationVariables,
    TContext
  >({
    mutationKey: ["DeleteFinmodelOverride"],
    mutationFn: (variables?: DeleteFinmodelOverrideMutationVariables) =>
      publicFetcher<
        DeleteFinmodelOverrideMutation,
        DeleteFinmodelOverrideMutationVariables
      >(DeleteFinmodelOverrideDocument, variables)(),
    ...options,
  })
}

useDeleteFinmodelOverrideMutation.fetcher = (
  variables: DeleteFinmodelOverrideMutationVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    DeleteFinmodelOverrideMutation,
    DeleteFinmodelOverrideMutationVariables
  >(DeleteFinmodelOverrideDocument, variables, options)

export const ListUtilitiesDocument = `
    query ListUtilities($zipCode: String!, $state: String!) {
  utilitiesForZip(zipCode: $zipCode) {
    __typename
    ... on UtilityList {
      refs {
        id
        pid
        name
        shortName
      }
    }
    ... on Error {
      message
    }
  }
  utilitiesForState(state: $state) {
    __typename
    ... on UtilityList {
      refs {
        id
        pid
        name
        shortName
      }
    }
    ... on Error {
      message
    }
  }
}
    `

export const useListUtilitiesQuery = <TData = ListUtilitiesQuery, TError = unknown>(
  variables: ListUtilitiesQueryVariables,
  options?: Omit<UseQueryOptions<ListUtilitiesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ListUtilitiesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ListUtilitiesQuery, TError, TData>({
    queryKey: ["ListUtilities", variables],
    queryFn: publicFetcher<ListUtilitiesQuery, ListUtilitiesQueryVariables>(
      ListUtilitiesDocument,
      variables,
    ),
    ...options,
  })
}

useListUtilitiesQuery.getKey = (variables: ListUtilitiesQueryVariables) => [
  "ListUtilities",
  variables,
]

useListUtilitiesQuery.rootKey = "ListUtilities"

export const useSuspenseListUtilitiesQuery = <
  TData = ListUtilitiesQuery,
  TError = unknown,
>(
  variables: ListUtilitiesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ListUtilitiesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ListUtilitiesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ListUtilitiesQuery, TError, TData>({
    queryKey: ["ListUtilitiesSuspense", variables],
    queryFn: publicFetcher<ListUtilitiesQuery, ListUtilitiesQueryVariables>(
      ListUtilitiesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseListUtilitiesQuery.getKey = (variables: ListUtilitiesQueryVariables) => [
  "ListUtilitiesSuspense",
  variables,
]

useSuspenseListUtilitiesQuery.rootKey = "ListUtilities"

export const useInfiniteListUtilitiesQuery = <
  TData = InfiniteData<ListUtilitiesQuery>,
  TError = unknown,
>(
  variables: ListUtilitiesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ListUtilitiesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ListUtilitiesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ListUtilitiesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ListUtilities.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ListUtilitiesQuery, ListUtilitiesQueryVariables>(
            ListUtilitiesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteListUtilitiesQuery.getKey = (variables: ListUtilitiesQueryVariables) => [
  "ListUtilities.infinite",
  variables,
]

useInfiniteListUtilitiesQuery.rootKey = "ListUtilities.infinite"

export const useSuspenseInfiniteListUtilitiesQuery = <
  TData = InfiniteData<ListUtilitiesQuery>,
  TError = unknown,
>(
  variables: ListUtilitiesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ListUtilitiesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ListUtilitiesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ListUtilitiesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ListUtilities.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<ListUtilitiesQuery, ListUtilitiesQueryVariables>(
            ListUtilitiesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteListUtilitiesQuery.getKey = (
  variables: ListUtilitiesQueryVariables,
) => ["ListUtilities.infiniteSuspense", variables]

useSuspenseInfiniteListUtilitiesQuery.rootKey = "ListUtilities.infinite"

useListUtilitiesQuery.fetcher = (
  variables: ListUtilitiesQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ListUtilitiesQuery, ListUtilitiesQueryVariables>(
    ListUtilitiesDocument,
    variables,
    options,
  )

export const OrgSettingsDetailBySlugDocument = `
    query OrgSettingsDetailBySlug($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    name
    slug
    irrFlavor
    isDeveloper
    currentUserPermissions
    users {
      ...UserRef
    }
    portfolios {
      pid
      title
    }
    userRoles {
      user {
        ...UserRef
      }
      role
    }
    investorProfile {
      hq
      yearFounded
      website
      managementTeam
      description
      distinguishingFeatures
      investorBacking
      longTermOwnershipApproach
      subscriptionMgmtApproach
      committedFunding
      experiences {
        state
        ftmEnergizedPvKw
        ftmAwardedPvKw
        btmEnergizedPvKw
        btmAwardedPvKw
      }
      buyBoxes {
        state
        ftmMinPortfolioSize
        ftmMinProjectSize
        ftmSeekingProjects
        btmMinPortfolioSize
        btmMinProjectSize
        btmSeekingProjects
        utilityProgramNotes
      }
    }
  }
}
    ${UserRefFragmentDoc}`

export const useOrgSettingsDetailBySlugQuery = <
  TData = OrgSettingsDetailBySlugQuery,
  TError = unknown,
>(
  variables: OrgSettingsDetailBySlugQueryVariables,
  options?: Omit<
    UseQueryOptions<OrgSettingsDetailBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<OrgSettingsDetailBySlugQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgSettingsDetailBySlugQuery, TError, TData>({
    queryKey: ["OrgSettingsDetailBySlug", variables],
    queryFn: publicFetcher<
      OrgSettingsDetailBySlugQuery,
      OrgSettingsDetailBySlugQueryVariables
    >(OrgSettingsDetailBySlugDocument, variables),
    ...options,
  })
}

useOrgSettingsDetailBySlugQuery.getKey = (
  variables: OrgSettingsDetailBySlugQueryVariables,
) => ["OrgSettingsDetailBySlug", variables]

useOrgSettingsDetailBySlugQuery.rootKey = "OrgSettingsDetailBySlug"

export const useSuspenseOrgSettingsDetailBySlugQuery = <
  TData = OrgSettingsDetailBySlugQuery,
  TError = unknown,
>(
  variables: OrgSettingsDetailBySlugQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgSettingsDetailBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      OrgSettingsDetailBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgSettingsDetailBySlugQuery, TError, TData>({
    queryKey: ["OrgSettingsDetailBySlugSuspense", variables],
    queryFn: publicFetcher<
      OrgSettingsDetailBySlugQuery,
      OrgSettingsDetailBySlugQueryVariables
    >(OrgSettingsDetailBySlugDocument, variables),
    ...options,
  })
}

useSuspenseOrgSettingsDetailBySlugQuery.getKey = (
  variables: OrgSettingsDetailBySlugQueryVariables,
) => ["OrgSettingsDetailBySlugSuspense", variables]

useSuspenseOrgSettingsDetailBySlugQuery.rootKey = "OrgSettingsDetailBySlug"

export const useInfiniteOrgSettingsDetailBySlugQuery = <
  TData = InfiniteData<OrgSettingsDetailBySlugQuery>,
  TError = unknown,
>(
  variables: OrgSettingsDetailBySlugQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgSettingsDetailBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      OrgSettingsDetailBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgSettingsDetailBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgSettingsDetailBySlug.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            OrgSettingsDetailBySlugQuery,
            OrgSettingsDetailBySlugQueryVariables
          >(OrgSettingsDetailBySlugDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgSettingsDetailBySlugQuery.getKey = (
  variables: OrgSettingsDetailBySlugQueryVariables,
) => ["OrgSettingsDetailBySlug.infinite", variables]

useInfiniteOrgSettingsDetailBySlugQuery.rootKey = "OrgSettingsDetailBySlug.infinite"

export const useSuspenseInfiniteOrgSettingsDetailBySlugQuery = <
  TData = InfiniteData<OrgSettingsDetailBySlugQuery>,
  TError = unknown,
>(
  variables: OrgSettingsDetailBySlugQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgSettingsDetailBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgSettingsDetailBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgSettingsDetailBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "OrgSettingsDetailBySlug.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            OrgSettingsDetailBySlugQuery,
            OrgSettingsDetailBySlugQueryVariables
          >(OrgSettingsDetailBySlugDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgSettingsDetailBySlugQuery.getKey = (
  variables: OrgSettingsDetailBySlugQueryVariables,
) => ["OrgSettingsDetailBySlug.infiniteSuspense", variables]

useSuspenseInfiniteOrgSettingsDetailBySlugQuery.rootKey =
  "OrgSettingsDetailBySlug.infinite"

useOrgSettingsDetailBySlugQuery.fetcher = (
  variables: OrgSettingsDetailBySlugQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgSettingsDetailBySlugQuery, OrgSettingsDetailBySlugQueryVariables>(
    OrgSettingsDetailBySlugDocument,
    variables,
    options,
  )

export const OrgUsersDocument = `
    query OrgUsers($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    name
    currentUserPermissions
    portfolios {
      pid
      title
    }
    orgUsers {
      user {
        pid
        name
        email
      }
      userRoles {
        role
        portfolio {
          pid
          title
        }
      }
    }
    unclaimedInvites {
      dateCreated
      createdBy {
        ...UserRef
      }
      portfolio {
        pid
        title
      }
      targetUser {
        ...UserRef
      }
    }
  }
}
    ${UserRefFragmentDoc}`

export const useOrgUsersQuery = <TData = OrgUsersQuery, TError = unknown>(
  variables: OrgUsersQueryVariables,
  options?: Omit<UseQueryOptions<OrgUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgUsersQuery, TError, TData>({
    queryKey: ["OrgUsers", variables],
    queryFn: publicFetcher<OrgUsersQuery, OrgUsersQueryVariables>(
      OrgUsersDocument,
      variables,
    ),
    ...options,
  })
}

useOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => ["OrgUsers", variables]

useOrgUsersQuery.rootKey = "OrgUsers"

export const useSuspenseOrgUsersQuery = <TData = OrgUsersQuery, TError = unknown>(
  variables: OrgUsersQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<OrgUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgUsersQuery, TError, TData>({
    queryKey: ["OrgUsersSuspense", variables],
    queryFn: publicFetcher<OrgUsersQuery, OrgUsersQueryVariables>(
      OrgUsersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => [
  "OrgUsersSuspense",
  variables,
]

useSuspenseOrgUsersQuery.rootKey = "OrgUsers"

export const useInfiniteOrgUsersQuery = <
  TData = InfiniteData<OrgUsersQuery>,
  TError = unknown,
>(
  variables: OrgUsersQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgUsers.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgUsersQuery, OrgUsersQueryVariables>(OrgUsersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => [
  "OrgUsers.infinite",
  variables,
]

useInfiniteOrgUsersQuery.rootKey = "OrgUsers.infinite"

export const useSuspenseInfiniteOrgUsersQuery = <
  TData = InfiniteData<OrgUsersQuery>,
  TError = unknown,
>(
  variables: OrgUsersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<OrgUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgUsers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgUsersQuery, OrgUsersQueryVariables>(OrgUsersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgUsersQuery.getKey = (variables: OrgUsersQueryVariables) => [
  "OrgUsers.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgUsersQuery.rootKey = "OrgUsers.infinite"

useOrgUsersQuery.fetcher = (
  variables: OrgUsersQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgUsersQuery, OrgUsersQueryVariables>(
    OrgUsersDocument,
    variables,
    options,
  )

export const PortfolioUsersDocument = `
    query PortfolioUsers($portfolioPid: String!) {
  portfolio(pid: $portfolioPid) {
    pid
    title
    users {
      ...UserRef
    }
  }
}
    ${UserRefFragmentDoc}`

export const usePortfolioUsersQuery = <TData = PortfolioUsersQuery, TError = unknown>(
  variables: PortfolioUsersQueryVariables,
  options?: Omit<UseQueryOptions<PortfolioUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<PortfolioUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PortfolioUsersQuery, TError, TData>({
    queryKey: ["PortfolioUsers", variables],
    queryFn: publicFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
      PortfolioUsersDocument,
      variables,
    ),
    ...options,
  })
}

usePortfolioUsersQuery.getKey = (variables: PortfolioUsersQueryVariables) => [
  "PortfolioUsers",
  variables,
]

usePortfolioUsersQuery.rootKey = "PortfolioUsers"

export const useSuspensePortfolioUsersQuery = <
  TData = PortfolioUsersQuery,
  TError = unknown,
>(
  variables: PortfolioUsersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PortfolioUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<PortfolioUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<PortfolioUsersQuery, TError, TData>({
    queryKey: ["PortfolioUsersSuspense", variables],
    queryFn: publicFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
      PortfolioUsersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspensePortfolioUsersQuery.getKey = (variables: PortfolioUsersQueryVariables) => [
  "PortfolioUsersSuspense",
  variables,
]

useSuspensePortfolioUsersQuery.rootKey = "PortfolioUsers"

export const useInfinitePortfolioUsersQuery = <
  TData = InfiniteData<PortfolioUsersQuery>,
  TError = unknown,
>(
  variables: PortfolioUsersQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PortfolioUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<PortfolioUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<PortfolioUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioUsers.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
            PortfolioUsersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePortfolioUsersQuery.getKey = (variables: PortfolioUsersQueryVariables) => [
  "PortfolioUsers.infinite",
  variables,
]

useInfinitePortfolioUsersQuery.rootKey = "PortfolioUsers.infinite"

export const useSuspenseInfinitePortfolioUsersQuery = <
  TData = InfiniteData<PortfolioUsersQuery>,
  TError = unknown,
>(
  variables: PortfolioUsersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PortfolioUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PortfolioUsersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PortfolioUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioUsers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
            PortfolioUsersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePortfolioUsersQuery.getKey = (
  variables: PortfolioUsersQueryVariables,
) => ["PortfolioUsers.infiniteSuspense", variables]

useSuspenseInfinitePortfolioUsersQuery.rootKey = "PortfolioUsers.infinite"

usePortfolioUsersQuery.fetcher = (
  variables: PortfolioUsersQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<PortfolioUsersQuery, PortfolioUsersQueryVariables>(
    PortfolioUsersDocument,
    variables,
    options,
  )

export const WelcomeDocument = `
    query Welcome($pid: String!) {
  openInvite(pid: $pid) {
    __typename
    ... on OpenInvite {
      pid
      orgSlug
      portfolio {
        pid
        title
      }
    }
    ... on Error {
      message
    }
  }
}
    `

export const useWelcomeQuery = <TData = WelcomeQuery, TError = unknown>(
  variables: WelcomeQueryVariables,
  options?: Omit<UseQueryOptions<WelcomeQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<WelcomeQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<WelcomeQuery, TError, TData>({
    queryKey: ["Welcome", variables],
    queryFn: publicFetcher<WelcomeQuery, WelcomeQueryVariables>(
      WelcomeDocument,
      variables,
    ),
    ...options,
  })
}

useWelcomeQuery.getKey = (variables: WelcomeQueryVariables) => ["Welcome", variables]

useWelcomeQuery.rootKey = "Welcome"

export const useSuspenseWelcomeQuery = <TData = WelcomeQuery, TError = unknown>(
  variables: WelcomeQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<WelcomeQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<WelcomeQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<WelcomeQuery, TError, TData>({
    queryKey: ["WelcomeSuspense", variables],
    queryFn: publicFetcher<WelcomeQuery, WelcomeQueryVariables>(
      WelcomeDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseWelcomeQuery.getKey = (variables: WelcomeQueryVariables) => [
  "WelcomeSuspense",
  variables,
]

useSuspenseWelcomeQuery.rootKey = "Welcome"

export const useInfiniteWelcomeQuery = <
  TData = InfiniteData<WelcomeQuery>,
  TError = unknown,
>(
  variables: WelcomeQueryVariables,
  options: Omit<UseInfiniteQueryOptions<WelcomeQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<WelcomeQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<WelcomeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["Welcome.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<WelcomeQuery, WelcomeQueryVariables>(WelcomeDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteWelcomeQuery.getKey = (variables: WelcomeQueryVariables) => [
  "Welcome.infinite",
  variables,
]

useInfiniteWelcomeQuery.rootKey = "Welcome.infinite"

export const useSuspenseInfiniteWelcomeQuery = <
  TData = InfiniteData<WelcomeQuery>,
  TError = unknown,
>(
  variables: WelcomeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<WelcomeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<WelcomeQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<WelcomeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["Welcome.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<WelcomeQuery, WelcomeQueryVariables>(WelcomeDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteWelcomeQuery.getKey = (variables: WelcomeQueryVariables) => [
  "Welcome.infiniteSuspense",
  variables,
]

useSuspenseInfiniteWelcomeQuery.rootKey = "Welcome.infinite"

useWelcomeQuery.fetcher = (
  variables: WelcomeQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<WelcomeQuery, WelcomeQueryVariables>(
    WelcomeDocument,
    variables,
    options,
  )

export const OrgSiteLabelsBySlugDocument = `
    query OrgSiteLabelsBySlug($orgSlug: String) {
  orgLabels(slug: $orgSlug) {
    ...SiteLabelRef
  }
}
    ${SiteLabelRefFragmentDoc}`

export const useOrgSiteLabelsBySlugQuery = <
  TData = OrgSiteLabelsBySlugQuery,
  TError = unknown,
>(
  variables?: OrgSiteLabelsBySlugQueryVariables,
  options?: Omit<
    UseQueryOptions<OrgSiteLabelsBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<OrgSiteLabelsBySlugQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgSiteLabelsBySlugQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OrgSiteLabelsBySlug"]
        : ["OrgSiteLabelsBySlug", variables],
    queryFn: publicFetcher<OrgSiteLabelsBySlugQuery, OrgSiteLabelsBySlugQueryVariables>(
      OrgSiteLabelsBySlugDocument,
      variables,
    ),
    ...options,
  })
}

useOrgSiteLabelsBySlugQuery.getKey = (variables?: OrgSiteLabelsBySlugQueryVariables) =>
  variables === undefined ? ["OrgSiteLabelsBySlug"] : ["OrgSiteLabelsBySlug", variables]

useOrgSiteLabelsBySlugQuery.rootKey = "OrgSiteLabelsBySlug"

export const useSuspenseOrgSiteLabelsBySlugQuery = <
  TData = OrgSiteLabelsBySlugQuery,
  TError = unknown,
>(
  variables?: OrgSiteLabelsBySlugQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgSiteLabelsBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      OrgSiteLabelsBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgSiteLabelsBySlugQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OrgSiteLabelsBySlugSuspense"]
        : ["OrgSiteLabelsBySlugSuspense", variables],
    queryFn: publicFetcher<OrgSiteLabelsBySlugQuery, OrgSiteLabelsBySlugQueryVariables>(
      OrgSiteLabelsBySlugDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgSiteLabelsBySlugQuery.getKey = (
  variables?: OrgSiteLabelsBySlugQueryVariables,
) =>
  variables === undefined
    ? ["OrgSiteLabelsBySlugSuspense"]
    : ["OrgSiteLabelsBySlugSuspense", variables]

useSuspenseOrgSiteLabelsBySlugQuery.rootKey = "OrgSiteLabelsBySlug"

export const useInfiniteOrgSiteLabelsBySlugQuery = <
  TData = InfiniteData<OrgSiteLabelsBySlugQuery>,
  TError = unknown,
>(
  variables: OrgSiteLabelsBySlugQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgSiteLabelsBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      OrgSiteLabelsBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgSiteLabelsBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgSiteLabelsBySlug.infinite"]
            : ["OrgSiteLabelsBySlug.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteLabelsBySlugQuery, OrgSiteLabelsBySlugQueryVariables>(
            OrgSiteLabelsBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgSiteLabelsBySlugQuery.getKey = (
  variables?: OrgSiteLabelsBySlugQueryVariables,
) =>
  variables === undefined
    ? ["OrgSiteLabelsBySlug.infinite"]
    : ["OrgSiteLabelsBySlug.infinite", variables]

useInfiniteOrgSiteLabelsBySlugQuery.rootKey = "OrgSiteLabelsBySlug.infinite"

export const useSuspenseInfiniteOrgSiteLabelsBySlugQuery = <
  TData = InfiniteData<OrgSiteLabelsBySlugQuery>,
  TError = unknown,
>(
  variables: OrgSiteLabelsBySlugQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgSiteLabelsBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgSiteLabelsBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgSiteLabelsBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgSiteLabelsBySlug.infiniteSuspense"]
            : ["OrgSiteLabelsBySlug.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteLabelsBySlugQuery, OrgSiteLabelsBySlugQueryVariables>(
            OrgSiteLabelsBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgSiteLabelsBySlugQuery.getKey = (
  variables?: OrgSiteLabelsBySlugQueryVariables,
) =>
  variables === undefined
    ? ["OrgSiteLabelsBySlug.infiniteSuspense"]
    : ["OrgSiteLabelsBySlug.infiniteSuspense", variables]

useSuspenseInfiniteOrgSiteLabelsBySlugQuery.rootKey = "OrgSiteLabelsBySlug.infinite"

useOrgSiteLabelsBySlugQuery.fetcher = (
  variables?: OrgSiteLabelsBySlugQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgSiteLabelsBySlugQuery, OrgSiteLabelsBySlugQueryVariables>(
    OrgSiteLabelsBySlugDocument,
    variables,
    options,
  )

export const OrgSiteDocsBySlugDocument = `
    query OrgSiteDocsBySlug($orgSlug: String) {
  orgSiteDocuments(slug: $orgSlug) {
    sitePid
    documents {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`

export const useOrgSiteDocsBySlugQuery = <
  TData = OrgSiteDocsBySlugQuery,
  TError = unknown,
>(
  variables?: OrgSiteDocsBySlugQueryVariables,
  options?: Omit<UseQueryOptions<OrgSiteDocsBySlugQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgSiteDocsBySlugQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgSiteDocsBySlugQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OrgSiteDocsBySlug"]
        : ["OrgSiteDocsBySlug", variables],
    queryFn: publicFetcher<OrgSiteDocsBySlugQuery, OrgSiteDocsBySlugQueryVariables>(
      OrgSiteDocsBySlugDocument,
      variables,
    ),
    ...options,
  })
}

useOrgSiteDocsBySlugQuery.getKey = (variables?: OrgSiteDocsBySlugQueryVariables) =>
  variables === undefined ? ["OrgSiteDocsBySlug"] : ["OrgSiteDocsBySlug", variables]

useOrgSiteDocsBySlugQuery.rootKey = "OrgSiteDocsBySlug"

export const useSuspenseOrgSiteDocsBySlugQuery = <
  TData = OrgSiteDocsBySlugQuery,
  TError = unknown,
>(
  variables?: OrgSiteDocsBySlugQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgSiteDocsBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      OrgSiteDocsBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgSiteDocsBySlugQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["OrgSiteDocsBySlugSuspense"]
        : ["OrgSiteDocsBySlugSuspense", variables],
    queryFn: publicFetcher<OrgSiteDocsBySlugQuery, OrgSiteDocsBySlugQueryVariables>(
      OrgSiteDocsBySlugDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgSiteDocsBySlugQuery.getKey = (
  variables?: OrgSiteDocsBySlugQueryVariables,
) =>
  variables === undefined
    ? ["OrgSiteDocsBySlugSuspense"]
    : ["OrgSiteDocsBySlugSuspense", variables]

useSuspenseOrgSiteDocsBySlugQuery.rootKey = "OrgSiteDocsBySlug"

export const useInfiniteOrgSiteDocsBySlugQuery = <
  TData = InfiniteData<OrgSiteDocsBySlugQuery>,
  TError = unknown,
>(
  variables: OrgSiteDocsBySlugQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgSiteDocsBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      OrgSiteDocsBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgSiteDocsBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgSiteDocsBySlug.infinite"]
            : ["OrgSiteDocsBySlug.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteDocsBySlugQuery, OrgSiteDocsBySlugQueryVariables>(
            OrgSiteDocsBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgSiteDocsBySlugQuery.getKey = (
  variables?: OrgSiteDocsBySlugQueryVariables,
) =>
  variables === undefined
    ? ["OrgSiteDocsBySlug.infinite"]
    : ["OrgSiteDocsBySlug.infinite", variables]

useInfiniteOrgSiteDocsBySlugQuery.rootKey = "OrgSiteDocsBySlug.infinite"

export const useSuspenseInfiniteOrgSiteDocsBySlugQuery = <
  TData = InfiniteData<OrgSiteDocsBySlugQuery>,
  TError = unknown,
>(
  variables: OrgSiteDocsBySlugQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgSiteDocsBySlugQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgSiteDocsBySlugQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgSiteDocsBySlugQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["OrgSiteDocsBySlug.infiniteSuspense"]
            : ["OrgSiteDocsBySlug.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteDocsBySlugQuery, OrgSiteDocsBySlugQueryVariables>(
            OrgSiteDocsBySlugDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgSiteDocsBySlugQuery.getKey = (
  variables?: OrgSiteDocsBySlugQueryVariables,
) =>
  variables === undefined
    ? ["OrgSiteDocsBySlug.infiniteSuspense"]
    : ["OrgSiteDocsBySlug.infiniteSuspense", variables]

useSuspenseInfiniteOrgSiteDocsBySlugQuery.rootKey = "OrgSiteDocsBySlug.infinite"

useOrgSiteDocsBySlugQuery.fetcher = (
  variables?: OrgSiteDocsBySlugQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgSiteDocsBySlugQuery, OrgSiteDocsBySlugQueryVariables>(
    OrgSiteDocsBySlugDocument,
    variables,
    options,
  )

export const GetVersionDocument = `
    query GetVersion {
  schemaVersion {
    version
  }
}
    `

export const useGetVersionQuery = <TData = GetVersionQuery, TError = unknown>(
  variables?: GetVersionQueryVariables,
  options?: Omit<UseQueryOptions<GetVersionQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GetVersionQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetVersionQuery, TError, TData>({
    queryKey: variables === undefined ? ["GetVersion"] : ["GetVersion", variables],
    queryFn: publicFetcher<GetVersionQuery, GetVersionQueryVariables>(
      GetVersionDocument,
      variables,
    ),
    ...options,
  })
}

useGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined ? ["GetVersion"] : ["GetVersion", variables]

useGetVersionQuery.rootKey = "GetVersion"

export const useSuspenseGetVersionQuery = <TData = GetVersionQuery, TError = unknown>(
  variables?: GetVersionQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GetVersionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<GetVersionQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GetVersionQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["GetVersionSuspense"]
        : ["GetVersionSuspense", variables],
    queryFn: publicFetcher<GetVersionQuery, GetVersionQueryVariables>(
      GetVersionDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined ? ["GetVersionSuspense"] : ["GetVersionSuspense", variables]

useSuspenseGetVersionQuery.rootKey = "GetVersion"

export const useInfiniteGetVersionQuery = <
  TData = InfiniteData<GetVersionQuery>,
  TError = unknown,
>(
  variables: GetVersionQueryVariables,
  options: Omit<UseInfiniteQueryOptions<GetVersionQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<GetVersionQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GetVersionQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GetVersion.infinite"]
            : ["GetVersion.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<GetVersionQuery, GetVersionQueryVariables>(GetVersionDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined ? ["GetVersion.infinite"] : ["GetVersion.infinite", variables]

useInfiniteGetVersionQuery.rootKey = "GetVersion.infinite"

export const useSuspenseInfiniteGetVersionQuery = <
  TData = InfiniteData<GetVersionQuery>,
  TError = unknown,
>(
  variables: GetVersionQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetVersionQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GetVersionQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetVersionQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GetVersion.infiniteSuspense"]
            : ["GetVersion.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<GetVersionQuery, GetVersionQueryVariables>(GetVersionDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetVersionQuery.getKey = (variables?: GetVersionQueryVariables) =>
  variables === undefined
    ? ["GetVersion.infiniteSuspense"]
    : ["GetVersion.infiniteSuspense", variables]

useSuspenseInfiniteGetVersionQuery.rootKey = "GetVersion.infinite"

useGetVersionQuery.fetcher = (
  variables?: GetVersionQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<GetVersionQuery, GetVersionQueryVariables>(
    GetVersionDocument,
    variables,
    options,
  )

export const CurrentUserDocument = `
    query CurrentUser {
  currentUser {
    pid
    isAuthenticated
    isAdmin
    email
    name
    org {
      pid
      slug
      name
      logoUrl
      logomarkUrl
      irrFlavor
      inactivityTimeoutMs
    }
    orgs {
      pid
      name
      slug
    }
  }
}
    `

export const useCurrentUserQuery = <TData = CurrentUserQuery, TError = unknown>(
  variables?: CurrentUserQueryVariables,
  options?: Omit<UseQueryOptions<CurrentUserQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CurrentUserQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CurrentUserQuery, TError, TData>({
    queryKey: variables === undefined ? ["CurrentUser"] : ["CurrentUser", variables],
    queryFn: publicFetcher<CurrentUserQuery, CurrentUserQueryVariables>(
      CurrentUserDocument,
      variables,
    ),
    ...options,
  })
}

useCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) =>
  variables === undefined ? ["CurrentUser"] : ["CurrentUser", variables]

useCurrentUserQuery.rootKey = "CurrentUser"

export const useSuspenseCurrentUserQuery = <TData = CurrentUserQuery, TError = unknown>(
  variables?: CurrentUserQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CurrentUserQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CurrentUserQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CurrentUserQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["CurrentUserSuspense"]
        : ["CurrentUserSuspense", variables],
    queryFn: publicFetcher<CurrentUserQuery, CurrentUserQueryVariables>(
      CurrentUserDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) =>
  variables === undefined ? ["CurrentUserSuspense"] : ["CurrentUserSuspense", variables]

useSuspenseCurrentUserQuery.rootKey = "CurrentUser"

export const useInfiniteCurrentUserQuery = <
  TData = InfiniteData<CurrentUserQuery>,
  TError = unknown,
>(
  variables: CurrentUserQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CurrentUserQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CurrentUserQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["CurrentUser.infinite"]
            : ["CurrentUser.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CurrentUserQuery, CurrentUserQueryVariables>(
            CurrentUserDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) =>
  variables === undefined
    ? ["CurrentUser.infinite"]
    : ["CurrentUser.infinite", variables]

useInfiniteCurrentUserQuery.rootKey = "CurrentUser.infinite"

export const useSuspenseInfiniteCurrentUserQuery = <
  TData = InfiniteData<CurrentUserQuery>,
  TError = unknown,
>(
  variables: CurrentUserQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CurrentUserQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CurrentUserQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CurrentUserQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["CurrentUser.infiniteSuspense"]
            : ["CurrentUser.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<CurrentUserQuery, CurrentUserQueryVariables>(
            CurrentUserDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) =>
  variables === undefined
    ? ["CurrentUser.infiniteSuspense"]
    : ["CurrentUser.infiniteSuspense", variables]

useSuspenseInfiniteCurrentUserQuery.rootKey = "CurrentUser.infinite"

useCurrentUserQuery.fetcher = (
  variables?: CurrentUserQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CurrentUserQuery, CurrentUserQueryVariables>(
    CurrentUserDocument,
    variables,
    options,
  )

export const PropertyHubViewDocument = `
    query PropertyHubView($orgSlug: String!, $filterBy: OrgSiteTableFilter!, $sortBy: [OrgSiteTableSort!]) {
  org: orgBySlug(slug: $orgSlug) {
    sites {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
      }
    }
  }
}
    `

export const usePropertyHubViewQuery = <TData = PropertyHubViewQuery, TError = unknown>(
  variables: PropertyHubViewQueryVariables,
  options?: Omit<UseQueryOptions<PropertyHubViewQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<PropertyHubViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PropertyHubViewQuery, TError, TData>({
    queryKey: ["PropertyHubView", variables],
    queryFn: publicFetcher<PropertyHubViewQuery, PropertyHubViewQueryVariables>(
      PropertyHubViewDocument,
      variables,
    ),
    ...options,
  })
}

usePropertyHubViewQuery.getKey = (variables: PropertyHubViewQueryVariables) => [
  "PropertyHubView",
  variables,
]

usePropertyHubViewQuery.rootKey = "PropertyHubView"

export const useSuspensePropertyHubViewQuery = <
  TData = PropertyHubViewQuery,
  TError = unknown,
>(
  variables: PropertyHubViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PropertyHubViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<PropertyHubViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<PropertyHubViewQuery, TError, TData>({
    queryKey: ["PropertyHubViewSuspense", variables],
    queryFn: publicFetcher<PropertyHubViewQuery, PropertyHubViewQueryVariables>(
      PropertyHubViewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspensePropertyHubViewQuery.getKey = (variables: PropertyHubViewQueryVariables) => [
  "PropertyHubViewSuspense",
  variables,
]

useSuspensePropertyHubViewQuery.rootKey = "PropertyHubView"

export const useInfinitePropertyHubViewQuery = <
  TData = InfiniteData<PropertyHubViewQuery>,
  TError = unknown,
>(
  variables: PropertyHubViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PropertyHubViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<PropertyHubViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<PropertyHubViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PropertyHubView.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<PropertyHubViewQuery, PropertyHubViewQueryVariables>(
            PropertyHubViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePropertyHubViewQuery.getKey = (variables: PropertyHubViewQueryVariables) => [
  "PropertyHubView.infinite",
  variables,
]

useInfinitePropertyHubViewQuery.rootKey = "PropertyHubView.infinite"

export const useSuspenseInfinitePropertyHubViewQuery = <
  TData = InfiniteData<PropertyHubViewQuery>,
  TError = unknown,
>(
  variables: PropertyHubViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PropertyHubViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PropertyHubViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PropertyHubViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PropertyHubView.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<PropertyHubViewQuery, PropertyHubViewQueryVariables>(
            PropertyHubViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePropertyHubViewQuery.getKey = (
  variables: PropertyHubViewQueryVariables,
) => ["PropertyHubView.infiniteSuspense", variables]

useSuspenseInfinitePropertyHubViewQuery.rootKey = "PropertyHubView.infinite"

usePropertyHubViewQuery.fetcher = (
  variables: PropertyHubViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<PropertyHubViewQuery, PropertyHubViewQueryVariables>(
    PropertyHubViewDocument,
    variables,
    options,
  )

export const PropertyHubRowsDocument = `
    query PropertyHubRows($orgSlug: String!, $keys: [String!]!) {
  org: orgBySlug(slug: $orgSlug) {
    sites {
      rows(keys: $keys) {
        pid
        name
        city
        state
        zipCode
        streetAddress
        county
        cbsaName
        assetManager
        ownerName
        customerId
        portfolio
        status
        statusReason
        statusCustomReason
        isFavorite
        flagSummary {
          __typename
          utilityNotFound
          tariffNotFound
          improbableEnergyCosts
          existingSolarLikely
          duplicateAddressFound
        }
        salePlans
        salePlannedYear
        mortgageLender
        sqft
        buildingType
        buildingClass
        numStories
        numUnitsTotal
        yearBuilt
        buildingFootprintSqft
        buildingFootprintRoofSqftError
        buildingSqftRoofSqftError
        buildingFootprintCount
        existingSolarDetectionScore
        inEnergyCommunity
        inLowIncomeCommunity
        roofCondition
        roofReplacedYr
        roofSqft
        usableRoofSqft
        metering
        loadOrigin
        utilityName
        utilityCagr
        utilityCagrFromYear
        utilityCagrToYear
        meterCount
        loadKwh
        loadUsd
        loadUsdPerKwh
        soleTariffName
        bauCo2EmissionsTons
        bauCo2EmissionsTonsPerMwh
        ppaOfftaker
        ppaSignatory
        occupancyType
        tenantLeaseEnds
        leaseType
        tenantInterest
        energyThings {
          canRooftopSolar
          canCarportSolar
          canGroundmountSolar
          canStorage
        }
        financingThings {
          canSelfInvest
          canLoan
          canPpa
          canLease
          canCommunitySolar
        }
        noiRangeMin
        noiRangeMax
        noiSelfMax
        irrSelfMax
        solarLocationSelfMax
        includeStorageSelfMax
        pvSizeKwSelfMax
        storageSizeKwSelfMax
        storageSizeKwhSelfMax
        leDevFeeSelfMax
        gpvSelfMax
        lifetimeCapexSelfMax
        lifetimeUtilitySavingsSelfMax
        co2EmissionsReductionTonnesSelfMax
        noiPpaMax
        solarLocationPpaMax
        includeStoragePpaMax
        pvSizeKwPpaMax
        storageSizeKwPpaMax
        storageSizeKwhPpaMax
        leDevFeePpaMax
        gpvPpaMax
        lifetimeUtilitySavingsPpaMax
        costPerKwhPpaMax
        ppaEscPpaMax
        yearOneOfftakerSavingsPpaMax
        co2EmissionsReductionTonnesPpaMax
        noiLoanMax
        leDevFeeLoanMax
        gpvLoanMax
        noiLeaseMax
        noiCsMax
        pvSizeKwCsMax
        roofMaxPvKw
        groundMaxPvKw
        carportMaxPvKw
        physicalCheck {
          roofIsGood
          carportIsGood
          groundmountIsGood
          existingSolar
          unobstructedFlatRoof
          badRoof
        }
        marketplaceStatus
        marketplaceClosedAt
        marketplaceCloseReason
        marketplaceCloseCustomReason
      }
    }
  }
}
    `

export const usePropertyHubRowsQuery = <TData = PropertyHubRowsQuery, TError = unknown>(
  variables: PropertyHubRowsQueryVariables,
  options?: Omit<UseQueryOptions<PropertyHubRowsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<PropertyHubRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PropertyHubRowsQuery, TError, TData>({
    queryKey: ["PropertyHubRows", variables],
    queryFn: publicFetcher<PropertyHubRowsQuery, PropertyHubRowsQueryVariables>(
      PropertyHubRowsDocument,
      variables,
    ),
    ...options,
  })
}

usePropertyHubRowsQuery.getKey = (variables: PropertyHubRowsQueryVariables) => [
  "PropertyHubRows",
  variables,
]

usePropertyHubRowsQuery.rootKey = "PropertyHubRows"

export const useSuspensePropertyHubRowsQuery = <
  TData = PropertyHubRowsQuery,
  TError = unknown,
>(
  variables: PropertyHubRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PropertyHubRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<PropertyHubRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<PropertyHubRowsQuery, TError, TData>({
    queryKey: ["PropertyHubRowsSuspense", variables],
    queryFn: publicFetcher<PropertyHubRowsQuery, PropertyHubRowsQueryVariables>(
      PropertyHubRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspensePropertyHubRowsQuery.getKey = (variables: PropertyHubRowsQueryVariables) => [
  "PropertyHubRowsSuspense",
  variables,
]

useSuspensePropertyHubRowsQuery.rootKey = "PropertyHubRows"

export const useInfinitePropertyHubRowsQuery = <
  TData = InfiniteData<PropertyHubRowsQuery>,
  TError = unknown,
>(
  variables: PropertyHubRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PropertyHubRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<PropertyHubRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<PropertyHubRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PropertyHubRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<PropertyHubRowsQuery, PropertyHubRowsQueryVariables>(
            PropertyHubRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePropertyHubRowsQuery.getKey = (variables: PropertyHubRowsQueryVariables) => [
  "PropertyHubRows.infinite",
  variables,
]

useInfinitePropertyHubRowsQuery.rootKey = "PropertyHubRows.infinite"

export const useSuspenseInfinitePropertyHubRowsQuery = <
  TData = InfiniteData<PropertyHubRowsQuery>,
  TError = unknown,
>(
  variables: PropertyHubRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PropertyHubRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PropertyHubRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PropertyHubRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PropertyHubRows.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<PropertyHubRowsQuery, PropertyHubRowsQueryVariables>(
            PropertyHubRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePropertyHubRowsQuery.getKey = (
  variables: PropertyHubRowsQueryVariables,
) => ["PropertyHubRows.infiniteSuspense", variables]

useSuspenseInfinitePropertyHubRowsQuery.rootKey = "PropertyHubRows.infinite"

usePropertyHubRowsQuery.fetcher = (
  variables: PropertyHubRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<PropertyHubRowsQuery, PropertyHubRowsQueryVariables>(
    PropertyHubRowsDocument,
    variables,
    options,
  )

export const MarketplaceOrgPropertySearchDocument = `
    query MarketplaceOrgPropertySearch($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    slug
    marketplaceSiteSearchTerms {
      propertyName
      address
      pid
      packagePid
    }
  }
}
    `

export const useMarketplaceOrgPropertySearchQuery = <
  TData = MarketplaceOrgPropertySearchQuery,
  TError = unknown,
>(
  variables: MarketplaceOrgPropertySearchQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceOrgPropertySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MarketplaceOrgPropertySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<MarketplaceOrgPropertySearchQuery, TError, TData>({
    queryKey: ["MarketplaceOrgPropertySearch", variables],
    queryFn: publicFetcher<
      MarketplaceOrgPropertySearchQuery,
      MarketplaceOrgPropertySearchQueryVariables
    >(MarketplaceOrgPropertySearchDocument, variables),
    ...options,
  })
}

useMarketplaceOrgPropertySearchQuery.getKey = (
  variables: MarketplaceOrgPropertySearchQueryVariables,
) => ["MarketplaceOrgPropertySearch", variables]

useMarketplaceOrgPropertySearchQuery.rootKey = "MarketplaceOrgPropertySearch"

export const useSuspenseMarketplaceOrgPropertySearchQuery = <
  TData = MarketplaceOrgPropertySearchQuery,
  TError = unknown,
>(
  variables: MarketplaceOrgPropertySearchQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceOrgPropertySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceOrgPropertySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceOrgPropertySearchQuery, TError, TData>({
    queryKey: ["MarketplaceOrgPropertySearchSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceOrgPropertySearchQuery,
      MarketplaceOrgPropertySearchQueryVariables
    >(MarketplaceOrgPropertySearchDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceOrgPropertySearchQuery.getKey = (
  variables: MarketplaceOrgPropertySearchQueryVariables,
) => ["MarketplaceOrgPropertySearchSuspense", variables]

useSuspenseMarketplaceOrgPropertySearchQuery.rootKey = "MarketplaceOrgPropertySearch"

export const useInfiniteMarketplaceOrgPropertySearchQuery = <
  TData = InfiniteData<MarketplaceOrgPropertySearchQuery>,
  TError = unknown,
>(
  variables: MarketplaceOrgPropertySearchQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceOrgPropertySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceOrgPropertySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceOrgPropertySearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceOrgPropertySearch.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplaceOrgPropertySearchQuery,
            MarketplaceOrgPropertySearchQueryVariables
          >(MarketplaceOrgPropertySearchDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceOrgPropertySearchQuery.getKey = (
  variables: MarketplaceOrgPropertySearchQueryVariables,
) => ["MarketplaceOrgPropertySearch.infinite", variables]

useInfiniteMarketplaceOrgPropertySearchQuery.rootKey =
  "MarketplaceOrgPropertySearch.infinite"

export const useSuspenseInfiniteMarketplaceOrgPropertySearchQuery = <
  TData = InfiniteData<MarketplaceOrgPropertySearchQuery>,
  TError = unknown,
>(
  variables: MarketplaceOrgPropertySearchQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceOrgPropertySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceOrgPropertySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceOrgPropertySearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceOrgPropertySearch.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplaceOrgPropertySearchQuery,
            MarketplaceOrgPropertySearchQueryVariables
          >(MarketplaceOrgPropertySearchDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceOrgPropertySearchQuery.getKey = (
  variables: MarketplaceOrgPropertySearchQueryVariables,
) => ["MarketplaceOrgPropertySearch.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceOrgPropertySearchQuery.rootKey =
  "MarketplaceOrgPropertySearch.infinite"

useMarketplaceOrgPropertySearchQuery.fetcher = (
  variables: MarketplaceOrgPropertySearchQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    MarketplaceOrgPropertySearchQuery,
    MarketplaceOrgPropertySearchQueryVariables
  >(MarketplaceOrgPropertySearchDocument, variables, options)

export const OrgPropertySearchDocument = `
    query OrgPropertySearch($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    slug
    siteSearchTerms {
      propertyName
      address
      pid
    }
  }
}
    `

export const useOrgPropertySearchQuery = <
  TData = OrgPropertySearchQuery,
  TError = unknown,
>(
  variables: OrgPropertySearchQueryVariables,
  options?: Omit<UseQueryOptions<OrgPropertySearchQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgPropertySearchQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgPropertySearchQuery, TError, TData>({
    queryKey: ["OrgPropertySearch", variables],
    queryFn: publicFetcher<OrgPropertySearchQuery, OrgPropertySearchQueryVariables>(
      OrgPropertySearchDocument,
      variables,
    ),
    ...options,
  })
}

useOrgPropertySearchQuery.getKey = (variables: OrgPropertySearchQueryVariables) => [
  "OrgPropertySearch",
  variables,
]

useOrgPropertySearchQuery.rootKey = "OrgPropertySearch"

export const useSuspenseOrgPropertySearchQuery = <
  TData = OrgPropertySearchQuery,
  TError = unknown,
>(
  variables: OrgPropertySearchQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgPropertySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      OrgPropertySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgPropertySearchQuery, TError, TData>({
    queryKey: ["OrgPropertySearchSuspense", variables],
    queryFn: publicFetcher<OrgPropertySearchQuery, OrgPropertySearchQueryVariables>(
      OrgPropertySearchDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgPropertySearchQuery.getKey = (
  variables: OrgPropertySearchQueryVariables,
) => ["OrgPropertySearchSuspense", variables]

useSuspenseOrgPropertySearchQuery.rootKey = "OrgPropertySearch"

export const useInfiniteOrgPropertySearchQuery = <
  TData = InfiniteData<OrgPropertySearchQuery>,
  TError = unknown,
>(
  variables: OrgPropertySearchQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgPropertySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      OrgPropertySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgPropertySearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgPropertySearch.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgPropertySearchQuery, OrgPropertySearchQueryVariables>(
            OrgPropertySearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgPropertySearchQuery.getKey = (
  variables: OrgPropertySearchQueryVariables,
) => ["OrgPropertySearch.infinite", variables]

useInfiniteOrgPropertySearchQuery.rootKey = "OrgPropertySearch.infinite"

export const useSuspenseInfiniteOrgPropertySearchQuery = <
  TData = InfiniteData<OrgPropertySearchQuery>,
  TError = unknown,
>(
  variables: OrgPropertySearchQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgPropertySearchQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgPropertySearchQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgPropertySearchQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgPropertySearch.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgPropertySearchQuery, OrgPropertySearchQueryVariables>(
            OrgPropertySearchDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgPropertySearchQuery.getKey = (
  variables: OrgPropertySearchQueryVariables,
) => ["OrgPropertySearch.infiniteSuspense", variables]

useSuspenseInfiniteOrgPropertySearchQuery.rootKey = "OrgPropertySearch.infinite"

useOrgPropertySearchQuery.fetcher = (
  variables: OrgPropertySearchQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgPropertySearchQuery, OrgPropertySearchQueryVariables>(
    OrgPropertySearchDocument,
    variables,
    options,
  )

export const OrgHomepageDocument = `
    query OrgHomepage($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    name
    logoUrl
    portfolioPdfReportHref
    mapView {
      pid
      lat
      lon
    }
  }
}
    `

export const useOrgHomepageQuery = <TData = OrgHomepageQuery, TError = unknown>(
  variables: OrgHomepageQueryVariables,
  options?: Omit<UseQueryOptions<OrgHomepageQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgHomepageQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgHomepageQuery, TError, TData>({
    queryKey: ["OrgHomepage", variables],
    queryFn: publicFetcher<OrgHomepageQuery, OrgHomepageQueryVariables>(
      OrgHomepageDocument,
      variables,
    ),
    ...options,
  })
}

useOrgHomepageQuery.getKey = (variables: OrgHomepageQueryVariables) => [
  "OrgHomepage",
  variables,
]

useOrgHomepageQuery.rootKey = "OrgHomepage"

export const useSuspenseOrgHomepageQuery = <TData = OrgHomepageQuery, TError = unknown>(
  variables: OrgHomepageQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgHomepageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OrgHomepageQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgHomepageQuery, TError, TData>({
    queryKey: ["OrgHomepageSuspense", variables],
    queryFn: publicFetcher<OrgHomepageQuery, OrgHomepageQueryVariables>(
      OrgHomepageDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgHomepageQuery.getKey = (variables: OrgHomepageQueryVariables) => [
  "OrgHomepageSuspense",
  variables,
]

useSuspenseOrgHomepageQuery.rootKey = "OrgHomepage"

export const useInfiniteOrgHomepageQuery = <
  TData = InfiniteData<OrgHomepageQuery>,
  TError = unknown,
>(
  variables: OrgHomepageQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgHomepageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<OrgHomepageQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgHomepageQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgHomepage.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgHomepageQuery, OrgHomepageQueryVariables>(
            OrgHomepageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgHomepageQuery.getKey = (variables: OrgHomepageQueryVariables) => [
  "OrgHomepage.infinite",
  variables,
]

useInfiniteOrgHomepageQuery.rootKey = "OrgHomepage.infinite"

export const useSuspenseInfiniteOrgHomepageQuery = <
  TData = InfiniteData<OrgHomepageQuery>,
  TError = unknown,
>(
  variables: OrgHomepageQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgHomepageQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgHomepageQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgHomepageQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgHomepage.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgHomepageQuery, OrgHomepageQueryVariables>(
            OrgHomepageDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgHomepageQuery.getKey = (variables: OrgHomepageQueryVariables) => [
  "OrgHomepage.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgHomepageQuery.rootKey = "OrgHomepage.infinite"

useOrgHomepageQuery.fetcher = (
  variables: OrgHomepageQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgHomepageQuery, OrgHomepageQueryVariables>(
    OrgHomepageDocument,
    variables,
    options,
  )

export const OrgFacetsDocument = `
    query OrgFacets($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    sites {
      view {
        stats {
          portfolios
          coveredStates
          buildingClasses
          buildingTypes
          counties
          cbsaNames
          assetManagers
          utilityNames
          ownerNames
        }
      }
    }
    finproducts {
      id
      type
      name
    }
  }
}
    `

export const useOrgFacetsQuery = <TData = OrgFacetsQuery, TError = unknown>(
  variables: OrgFacetsQueryVariables,
  options?: Omit<UseQueryOptions<OrgFacetsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgFacetsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgFacetsQuery, TError, TData>({
    queryKey: ["OrgFacets", variables],
    queryFn: publicFetcher<OrgFacetsQuery, OrgFacetsQueryVariables>(
      OrgFacetsDocument,
      variables,
    ),
    ...options,
  })
}

useOrgFacetsQuery.getKey = (variables: OrgFacetsQueryVariables) => [
  "OrgFacets",
  variables,
]

useOrgFacetsQuery.rootKey = "OrgFacets"

export const useSuspenseOrgFacetsQuery = <TData = OrgFacetsQuery, TError = unknown>(
  variables: OrgFacetsQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<OrgFacetsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<OrgFacetsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgFacetsQuery, TError, TData>({
    queryKey: ["OrgFacetsSuspense", variables],
    queryFn: publicFetcher<OrgFacetsQuery, OrgFacetsQueryVariables>(
      OrgFacetsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgFacetsQuery.getKey = (variables: OrgFacetsQueryVariables) => [
  "OrgFacetsSuspense",
  variables,
]

useSuspenseOrgFacetsQuery.rootKey = "OrgFacets"

export const useInfiniteOrgFacetsQuery = <
  TData = InfiniteData<OrgFacetsQuery>,
  TError = unknown,
>(
  variables: OrgFacetsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgFacetsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgFacetsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgFacetsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgFacets.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgFacetsQuery, OrgFacetsQueryVariables>(OrgFacetsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgFacetsQuery.getKey = (variables: OrgFacetsQueryVariables) => [
  "OrgFacets.infinite",
  variables,
]

useInfiniteOrgFacetsQuery.rootKey = "OrgFacets.infinite"

export const useSuspenseInfiniteOrgFacetsQuery = <
  TData = InfiniteData<OrgFacetsQuery>,
  TError = unknown,
>(
  variables: OrgFacetsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgFacetsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgFacetsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgFacets.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgFacetsQuery, OrgFacetsQueryVariables>(OrgFacetsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgFacetsQuery.getKey = (variables: OrgFacetsQueryVariables) => [
  "OrgFacets.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgFacetsQuery.rootKey = "OrgFacets.infinite"

useOrgFacetsQuery.fetcher = (
  variables: OrgFacetsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgFacetsQuery, OrgFacetsQueryVariables>(
    OrgFacetsDocument,
    variables,
    options,
  )

export const OrgSiteTableDocument = `
    query OrgSiteTable($orgSlug: String!, $filterBy: OrgSiteTableFilter, $sortBy: [OrgSiteTableSort!]) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    name
    sites {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
        stats {
          annualNoi
          co2EmissionsReductionTonnes
          maxPvSizeKw
        }
      }
    }
  }
}
    `

export const useOrgSiteTableQuery = <TData = OrgSiteTableQuery, TError = unknown>(
  variables: OrgSiteTableQueryVariables,
  options?: Omit<UseQueryOptions<OrgSiteTableQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgSiteTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgSiteTableQuery, TError, TData>({
    queryKey: ["OrgSiteTable", variables],
    queryFn: publicFetcher<OrgSiteTableQuery, OrgSiteTableQueryVariables>(
      OrgSiteTableDocument,
      variables,
    ),
    ...options,
  })
}

useOrgSiteTableQuery.getKey = (variables: OrgSiteTableQueryVariables) => [
  "OrgSiteTable",
  variables,
]

useOrgSiteTableQuery.rootKey = "OrgSiteTable"

export const useSuspenseOrgSiteTableQuery = <
  TData = OrgSiteTableQuery,
  TError = unknown,
>(
  variables: OrgSiteTableQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgSiteTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OrgSiteTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgSiteTableQuery, TError, TData>({
    queryKey: ["OrgSiteTableSuspense", variables],
    queryFn: publicFetcher<OrgSiteTableQuery, OrgSiteTableQueryVariables>(
      OrgSiteTableDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgSiteTableQuery.getKey = (variables: OrgSiteTableQueryVariables) => [
  "OrgSiteTableSuspense",
  variables,
]

useSuspenseOrgSiteTableQuery.rootKey = "OrgSiteTable"

export const useInfiniteOrgSiteTableQuery = <
  TData = InfiniteData<OrgSiteTableQuery>,
  TError = unknown,
>(
  variables: OrgSiteTableQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgSiteTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<OrgSiteTableQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgSiteTableQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgSiteTable.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteTableQuery, OrgSiteTableQueryVariables>(
            OrgSiteTableDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgSiteTableQuery.getKey = (variables: OrgSiteTableQueryVariables) => [
  "OrgSiteTable.infinite",
  variables,
]

useInfiniteOrgSiteTableQuery.rootKey = "OrgSiteTable.infinite"

export const useSuspenseInfiniteOrgSiteTableQuery = <
  TData = InfiniteData<OrgSiteTableQuery>,
  TError = unknown,
>(
  variables: OrgSiteTableQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgSiteTableQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgSiteTableQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgSiteTableQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgSiteTable.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteTableQuery, OrgSiteTableQueryVariables>(
            OrgSiteTableDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgSiteTableQuery.getKey = (
  variables: OrgSiteTableQueryVariables,
) => ["OrgSiteTable.infiniteSuspense", variables]

useSuspenseInfiniteOrgSiteTableQuery.rootKey = "OrgSiteTable.infinite"

useOrgSiteTableQuery.fetcher = (
  variables: OrgSiteTableQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgSiteTableQuery, OrgSiteTableQueryVariables>(
    OrgSiteTableDocument,
    variables,
    options,
  )

export const PortfolioPdfReportStatsDocument = `
    query PortfolioPdfReportStats($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    name
    mapView {
      pid
      lat
      lon
    }
    sites {
      view(
        filterBy: {status: {value: ACTIVE}}
        sortBy: [{attr: NOI_CS_MAX, order: DESC}]
      ) {
        keys
        count
        stats {
          annualNoi
          maxPvSizeKw
          co2EmissionsReductionTonnes
        }
      }
      highlight: view(
        filterBy: {status: {value: ACTIVE}, irrSelfMax: {gte: 0.1}, noiPpaMax: {gte: 0}, noiCsMax: {gte: 0}}
        sortBy: [{attr: NOI_CS_MAX, order: DESC}]
      ) {
        keys
        count
      }
      cs: view(
        filterBy: {status: {value: ACTIVE}, noiCsMax: {gte: 20000}}
        sortBy: []
      ) {
        count
        stats {
          csAnnualNoi
          csMaxPvSizeKw
        }
      }
      csAfter: view(
        filterBy: {status: {value: ACTIVE}, noiCsMax: {gte: 33333}}
        sortBy: []
      ) {
        count
        stats {
          csAnnualNoi
          csMaxPvSizeKw
        }
      }
      ppa: view(filterBy: {status: {value: ACTIVE}, noiPpaMax: {gte: 0}}, sortBy: []) {
        count
        stats {
          ppaAnnualNoi
          ppaMaxPvSizeKw
          ppaCo2EmissionsReductionTonnes
        }
      }
      cash: view(
        filterBy: {status: {value: ACTIVE}, irrSelfMax: {gte: 0.1}}
        sortBy: []
      ) {
        count
        stats {
          cashAnnualNoi
          cashMaxPvSizeKw
          cashCo2EmissionsReductionTonnes
        }
      }
    }
    bestCsSite {
      pid
      name
      streetAddress
      city
      state
      zipCode
      noiCsMax
    }
  }
}
    `

export const usePortfolioPdfReportStatsQuery = <
  TData = PortfolioPdfReportStatsQuery,
  TError = unknown,
>(
  variables: PortfolioPdfReportStatsQueryVariables,
  options?: Omit<
    UseQueryOptions<PortfolioPdfReportStatsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<PortfolioPdfReportStatsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<PortfolioPdfReportStatsQuery, TError, TData>({
    queryKey: ["PortfolioPdfReportStats", variables],
    queryFn: publicFetcher<
      PortfolioPdfReportStatsQuery,
      PortfolioPdfReportStatsQueryVariables
    >(PortfolioPdfReportStatsDocument, variables),
    ...options,
  })
}

usePortfolioPdfReportStatsQuery.getKey = (
  variables: PortfolioPdfReportStatsQueryVariables,
) => ["PortfolioPdfReportStats", variables]

usePortfolioPdfReportStatsQuery.rootKey = "PortfolioPdfReportStats"

export const useSuspensePortfolioPdfReportStatsQuery = <
  TData = PortfolioPdfReportStatsQuery,
  TError = unknown,
>(
  variables: PortfolioPdfReportStatsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<PortfolioPdfReportStatsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      PortfolioPdfReportStatsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<PortfolioPdfReportStatsQuery, TError, TData>({
    queryKey: ["PortfolioPdfReportStatsSuspense", variables],
    queryFn: publicFetcher<
      PortfolioPdfReportStatsQuery,
      PortfolioPdfReportStatsQueryVariables
    >(PortfolioPdfReportStatsDocument, variables),
    ...options,
  })
}

useSuspensePortfolioPdfReportStatsQuery.getKey = (
  variables: PortfolioPdfReportStatsQueryVariables,
) => ["PortfolioPdfReportStatsSuspense", variables]

useSuspensePortfolioPdfReportStatsQuery.rootKey = "PortfolioPdfReportStats"

export const useInfinitePortfolioPdfReportStatsQuery = <
  TData = InfiniteData<PortfolioPdfReportStatsQuery>,
  TError = unknown,
>(
  variables: PortfolioPdfReportStatsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<PortfolioPdfReportStatsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      PortfolioPdfReportStatsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<PortfolioPdfReportStatsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["PortfolioPdfReportStats.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            PortfolioPdfReportStatsQuery,
            PortfolioPdfReportStatsQueryVariables
          >(PortfolioPdfReportStatsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfinitePortfolioPdfReportStatsQuery.getKey = (
  variables: PortfolioPdfReportStatsQueryVariables,
) => ["PortfolioPdfReportStats.infinite", variables]

useInfinitePortfolioPdfReportStatsQuery.rootKey = "PortfolioPdfReportStats.infinite"

export const useSuspenseInfinitePortfolioPdfReportStatsQuery = <
  TData = InfiniteData<PortfolioPdfReportStatsQuery>,
  TError = unknown,
>(
  variables: PortfolioPdfReportStatsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<PortfolioPdfReportStatsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      PortfolioPdfReportStatsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<PortfolioPdfReportStatsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "PortfolioPdfReportStats.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            PortfolioPdfReportStatsQuery,
            PortfolioPdfReportStatsQueryVariables
          >(PortfolioPdfReportStatsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfinitePortfolioPdfReportStatsQuery.getKey = (
  variables: PortfolioPdfReportStatsQueryVariables,
) => ["PortfolioPdfReportStats.infiniteSuspense", variables]

useSuspenseInfinitePortfolioPdfReportStatsQuery.rootKey =
  "PortfolioPdfReportStats.infinite"

usePortfolioPdfReportStatsQuery.fetcher = (
  variables: PortfolioPdfReportStatsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<PortfolioPdfReportStatsQuery, PortfolioPdfReportStatsQueryVariables>(
    PortfolioPdfReportStatsDocument,
    variables,
    options,
  )

export const OrgSiteTableRowsDocument = `
    query OrgSiteTableRows($orgSlug: String!, $propertyPids: [String!]!) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    sites {
      rows(keys: $propertyPids) {
        pid
        name
        portfolio
        isFavorite
        streetAddress
        city
        state
        zipCode
        noiRangeMin
        noiRangeMax
        latitude
        longitude
        irrSelfMax
        noiLoanMax
        noiPpaMax
        noiCsMax
        energyThings {
          canRooftopSolar
          canCarportSolar
          canGroundmountSolar
          canStorage
        }
        financingThings {
          canSelfInvest
          canLoan
          canPpa
          canLease
          canCommunitySolar
        }
        footprint {
          latitude
          longitude
          roofShape
          roofShapeGeojson
        }
      }
    }
  }
}
    `

export const useOrgSiteTableRowsQuery = <
  TData = OrgSiteTableRowsQuery,
  TError = unknown,
>(
  variables: OrgSiteTableRowsQueryVariables,
  options?: Omit<UseQueryOptions<OrgSiteTableRowsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgSiteTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgSiteTableRowsQuery, TError, TData>({
    queryKey: ["OrgSiteTableRows", variables],
    queryFn: publicFetcher<OrgSiteTableRowsQuery, OrgSiteTableRowsQueryVariables>(
      OrgSiteTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useOrgSiteTableRowsQuery.getKey = (variables: OrgSiteTableRowsQueryVariables) => [
  "OrgSiteTableRows",
  variables,
]

useOrgSiteTableRowsQuery.rootKey = "OrgSiteTableRows"

export const useSuspenseOrgSiteTableRowsQuery = <
  TData = OrgSiteTableRowsQuery,
  TError = unknown,
>(
  variables: OrgSiteTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgSiteTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OrgSiteTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgSiteTableRowsQuery, TError, TData>({
    queryKey: ["OrgSiteTableRowsSuspense", variables],
    queryFn: publicFetcher<OrgSiteTableRowsQuery, OrgSiteTableRowsQueryVariables>(
      OrgSiteTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgSiteTableRowsQuery.getKey = (
  variables: OrgSiteTableRowsQueryVariables,
) => ["OrgSiteTableRowsSuspense", variables]

useSuspenseOrgSiteTableRowsQuery.rootKey = "OrgSiteTableRows"

export const useInfiniteOrgSiteTableRowsQuery = <
  TData = InfiniteData<OrgSiteTableRowsQuery>,
  TError = unknown,
>(
  variables: OrgSiteTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<OrgSiteTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<OrgSiteTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgSiteTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgSiteTableRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteTableRowsQuery, OrgSiteTableRowsQueryVariables>(
            OrgSiteTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgSiteTableRowsQuery.getKey = (
  variables: OrgSiteTableRowsQueryVariables,
) => ["OrgSiteTableRows.infinite", variables]

useInfiniteOrgSiteTableRowsQuery.rootKey = "OrgSiteTableRows.infinite"

export const useSuspenseInfiniteOrgSiteTableRowsQuery = <
  TData = InfiniteData<OrgSiteTableRowsQuery>,
  TError = unknown,
>(
  variables: OrgSiteTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgSiteTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgSiteTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgSiteTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgSiteTableRows.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgSiteTableRowsQuery, OrgSiteTableRowsQueryVariables>(
            OrgSiteTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgSiteTableRowsQuery.getKey = (
  variables: OrgSiteTableRowsQueryVariables,
) => ["OrgSiteTableRows.infiniteSuspense", variables]

useSuspenseInfiniteOrgSiteTableRowsQuery.rootKey = "OrgSiteTableRows.infinite"

useOrgSiteTableRowsQuery.fetcher = (
  variables: OrgSiteTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgSiteTableRowsQuery, OrgSiteTableRowsQueryVariables>(
    OrgSiteTableRowsDocument,
    variables,
    options,
  )

export const RevampSiteDocument = `
    query RevampSite($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    name
    site(pid: $sitePid) {
      ...RevampSiteBasics
      status
      statusDisplayText
      flags {
        type
      }
      feasibility {
        economics
        physical
      }
      labels {
        name
        pid
        themeColor
      }
      biddingConfigResult {
        id
      }
      selectedConfigResult {
        ...Result
      }
      selectedResults {
        ...Result
      }
      highlightedResults {
        ...Result
      }
      activeResults {
        ...Result
      }
      resultPerLocation {
        ...ResultRef
        helioscope {
          ...Helioscope
        }
      }
    }
  }
}
    ${RevampSiteBasicsFragmentDoc}
${SiteConfigFragmentDoc}
${UserRefFragmentDoc}
${FootprintFragmentDoc}
${ResultFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${RevampCsFragmentDoc}
${HelioscopeFragmentDoc}
${ResultRefFragmentDoc}`

export const useRevampSiteQuery = <TData = RevampSiteQuery, TError = unknown>(
  variables: RevampSiteQueryVariables,
  options?: Omit<UseQueryOptions<RevampSiteQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<RevampSiteQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<RevampSiteQuery, TError, TData>({
    queryKey: ["RevampSite", variables],
    queryFn: publicFetcher<RevampSiteQuery, RevampSiteQueryVariables>(
      RevampSiteDocument,
      variables,
    ),
    ...options,
  })
}

useRevampSiteQuery.getKey = (variables: RevampSiteQueryVariables) => [
  "RevampSite",
  variables,
]

useRevampSiteQuery.rootKey = "RevampSite"

export const useSuspenseRevampSiteQuery = <TData = RevampSiteQuery, TError = unknown>(
  variables: RevampSiteQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<RevampSiteQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<RevampSiteQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<RevampSiteQuery, TError, TData>({
    queryKey: ["RevampSiteSuspense", variables],
    queryFn: publicFetcher<RevampSiteQuery, RevampSiteQueryVariables>(
      RevampSiteDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseRevampSiteQuery.getKey = (variables: RevampSiteQueryVariables) => [
  "RevampSiteSuspense",
  variables,
]

useSuspenseRevampSiteQuery.rootKey = "RevampSite"

export const useInfiniteRevampSiteQuery = <
  TData = InfiniteData<RevampSiteQuery>,
  TError = unknown,
>(
  variables: RevampSiteQueryVariables,
  options: Omit<UseInfiniteQueryOptions<RevampSiteQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<RevampSiteQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<RevampSiteQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["RevampSite.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<RevampSiteQuery, RevampSiteQueryVariables>(RevampSiteDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteRevampSiteQuery.getKey = (variables: RevampSiteQueryVariables) => [
  "RevampSite.infinite",
  variables,
]

useInfiniteRevampSiteQuery.rootKey = "RevampSite.infinite"

export const useSuspenseInfiniteRevampSiteQuery = <
  TData = InfiniteData<RevampSiteQuery>,
  TError = unknown,
>(
  variables: RevampSiteQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<RevampSiteQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      RevampSiteQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<RevampSiteQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["RevampSite.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<RevampSiteQuery, RevampSiteQueryVariables>(RevampSiteDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteRevampSiteQuery.getKey = (variables: RevampSiteQueryVariables) => [
  "RevampSite.infiniteSuspense",
  variables,
]

useSuspenseInfiniteRevampSiteQuery.rootKey = "RevampSite.infinite"

useRevampSiteQuery.fetcher = (
  variables: RevampSiteQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RevampSiteQuery, RevampSiteQueryVariables>(
    RevampSiteDocument,
    variables,
    options,
  )

export const ResultDetailDocument = `
    query ResultDetail($orgSlug: String!, $sitePid: String!, $resultPid: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    name
    site(pid: $sitePid) {
      pid
      name
      roofMaxPvKw
      footprint {
        ...Footprint
      }
      result(pid: $resultPid) {
        ...Result
      }
    }
  }
}
    ${FootprintFragmentDoc}
${UserRefFragmentDoc}
${ResultFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${RevampCsFragmentDoc}
${HelioscopeFragmentDoc}`

export const useResultDetailQuery = <TData = ResultDetailQuery, TError = unknown>(
  variables: ResultDetailQueryVariables,
  options?: Omit<UseQueryOptions<ResultDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ResultDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ResultDetailQuery, TError, TData>({
    queryKey: ["ResultDetail", variables],
    queryFn: publicFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
      ResultDetailDocument,
      variables,
    ),
    ...options,
  })
}

useResultDetailQuery.getKey = (variables: ResultDetailQueryVariables) => [
  "ResultDetail",
  variables,
]

useResultDetailQuery.rootKey = "ResultDetail"

export const useSuspenseResultDetailQuery = <
  TData = ResultDetailQuery,
  TError = unknown,
>(
  variables: ResultDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ResultDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ResultDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ResultDetailQuery, TError, TData>({
    queryKey: ["ResultDetailSuspense", variables],
    queryFn: publicFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
      ResultDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseResultDetailQuery.getKey = (variables: ResultDetailQueryVariables) => [
  "ResultDetailSuspense",
  variables,
]

useSuspenseResultDetailQuery.rootKey = "ResultDetail"

export const useInfiniteResultDetailQuery = <
  TData = InfiniteData<ResultDetailQuery>,
  TError = unknown,
>(
  variables: ResultDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ResultDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ResultDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ResultDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
            ResultDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteResultDetailQuery.getKey = (variables: ResultDetailQueryVariables) => [
  "ResultDetail.infinite",
  variables,
]

useInfiniteResultDetailQuery.rootKey = "ResultDetail.infinite"

export const useSuspenseInfiniteResultDetailQuery = <
  TData = InfiniteData<ResultDetailQuery>,
  TError = unknown,
>(
  variables: ResultDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ResultDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ResultDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ResultDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
            ResultDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteResultDetailQuery.getKey = (
  variables: ResultDetailQueryVariables,
) => ["ResultDetail.infiniteSuspense", variables]

useSuspenseInfiniteResultDetailQuery.rootKey = "ResultDetail.infinite"

useResultDetailQuery.fetcher = (
  variables: ResultDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ResultDetailQuery, ResultDetailQueryVariables>(
    ResultDetailDocument,
    variables,
    options,
  )

export const ResultCashFlowDocument = `
    query ResultCashFlow($orgSlug: String!, $sitePid: String!, $resultPid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $sitePid) {
      result(pid: $resultPid) {
        result {
          __typename
          ... on RevampFinmodel {
            buildingOwnerXlsx
          }
        }
      }
    }
  }
}
    `

export const useResultCashFlowQuery = <TData = ResultCashFlowQuery, TError = unknown>(
  variables: ResultCashFlowQueryVariables,
  options?: Omit<UseQueryOptions<ResultCashFlowQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ResultCashFlowQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ResultCashFlowQuery, TError, TData>({
    queryKey: ["ResultCashFlow", variables],
    queryFn: publicFetcher<ResultCashFlowQuery, ResultCashFlowQueryVariables>(
      ResultCashFlowDocument,
      variables,
    ),
    ...options,
  })
}

useResultCashFlowQuery.getKey = (variables: ResultCashFlowQueryVariables) => [
  "ResultCashFlow",
  variables,
]

useResultCashFlowQuery.rootKey = "ResultCashFlow"

export const useSuspenseResultCashFlowQuery = <
  TData = ResultCashFlowQuery,
  TError = unknown,
>(
  variables: ResultCashFlowQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ResultCashFlowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ResultCashFlowQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ResultCashFlowQuery, TError, TData>({
    queryKey: ["ResultCashFlowSuspense", variables],
    queryFn: publicFetcher<ResultCashFlowQuery, ResultCashFlowQueryVariables>(
      ResultCashFlowDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseResultCashFlowQuery.getKey = (variables: ResultCashFlowQueryVariables) => [
  "ResultCashFlowSuspense",
  variables,
]

useSuspenseResultCashFlowQuery.rootKey = "ResultCashFlow"

export const useInfiniteResultCashFlowQuery = <
  TData = InfiniteData<ResultCashFlowQuery>,
  TError = unknown,
>(
  variables: ResultCashFlowQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ResultCashFlowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ResultCashFlowQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ResultCashFlowQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultCashFlow.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ResultCashFlowQuery, ResultCashFlowQueryVariables>(
            ResultCashFlowDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteResultCashFlowQuery.getKey = (variables: ResultCashFlowQueryVariables) => [
  "ResultCashFlow.infinite",
  variables,
]

useInfiniteResultCashFlowQuery.rootKey = "ResultCashFlow.infinite"

export const useSuspenseInfiniteResultCashFlowQuery = <
  TData = InfiniteData<ResultCashFlowQuery>,
  TError = unknown,
>(
  variables: ResultCashFlowQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ResultCashFlowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ResultCashFlowQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ResultCashFlowQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ResultCashFlow.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<ResultCashFlowQuery, ResultCashFlowQueryVariables>(
            ResultCashFlowDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteResultCashFlowQuery.getKey = (
  variables: ResultCashFlowQueryVariables,
) => ["ResultCashFlow.infiniteSuspense", variables]

useSuspenseInfiniteResultCashFlowQuery.rootKey = "ResultCashFlow.infinite"

useResultCashFlowQuery.fetcher = (
  variables: ResultCashFlowQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ResultCashFlowQuery, ResultCashFlowQueryVariables>(
    ResultCashFlowDocument,
    variables,
    options,
  )

export const RevampSiteDocumentsDocument = `
    query RevampSiteDocuments($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    name
    site(pid: $sitePid) {
      pid
      documents {
        canDelete
        contentType
        dateCreated
        fileName
        ownerName
        pid
        tag
        downloadHref
      }
    }
  }
}
    `

export const useRevampSiteDocumentsQuery = <
  TData = RevampSiteDocumentsQuery,
  TError = unknown,
>(
  variables: RevampSiteDocumentsQueryVariables,
  options?: Omit<
    UseQueryOptions<RevampSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<RevampSiteDocumentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<RevampSiteDocumentsQuery, TError, TData>({
    queryKey: ["RevampSiteDocuments", variables],
    queryFn: publicFetcher<RevampSiteDocumentsQuery, RevampSiteDocumentsQueryVariables>(
      RevampSiteDocumentsDocument,
      variables,
    ),
    ...options,
  })
}

useRevampSiteDocumentsQuery.getKey = (variables: RevampSiteDocumentsQueryVariables) => [
  "RevampSiteDocuments",
  variables,
]

useRevampSiteDocumentsQuery.rootKey = "RevampSiteDocuments"

export const useSuspenseRevampSiteDocumentsQuery = <
  TData = RevampSiteDocumentsQuery,
  TError = unknown,
>(
  variables: RevampSiteDocumentsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<RevampSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      RevampSiteDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<RevampSiteDocumentsQuery, TError, TData>({
    queryKey: ["RevampSiteDocumentsSuspense", variables],
    queryFn: publicFetcher<RevampSiteDocumentsQuery, RevampSiteDocumentsQueryVariables>(
      RevampSiteDocumentsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseRevampSiteDocumentsQuery.getKey = (
  variables: RevampSiteDocumentsQueryVariables,
) => ["RevampSiteDocumentsSuspense", variables]

useSuspenseRevampSiteDocumentsQuery.rootKey = "RevampSiteDocuments"

export const useInfiniteRevampSiteDocumentsQuery = <
  TData = InfiniteData<RevampSiteDocumentsQuery>,
  TError = unknown,
>(
  variables: RevampSiteDocumentsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<RevampSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      RevampSiteDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<RevampSiteDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["RevampSiteDocuments.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<RevampSiteDocumentsQuery, RevampSiteDocumentsQueryVariables>(
            RevampSiteDocumentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteRevampSiteDocumentsQuery.getKey = (
  variables: RevampSiteDocumentsQueryVariables,
) => ["RevampSiteDocuments.infinite", variables]

useInfiniteRevampSiteDocumentsQuery.rootKey = "RevampSiteDocuments.infinite"

export const useSuspenseInfiniteRevampSiteDocumentsQuery = <
  TData = InfiniteData<RevampSiteDocumentsQuery>,
  TError = unknown,
>(
  variables: RevampSiteDocumentsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<RevampSiteDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      RevampSiteDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<RevampSiteDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "RevampSiteDocuments.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<RevampSiteDocumentsQuery, RevampSiteDocumentsQueryVariables>(
            RevampSiteDocumentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteRevampSiteDocumentsQuery.getKey = (
  variables: RevampSiteDocumentsQueryVariables,
) => ["RevampSiteDocuments.infiniteSuspense", variables]

useSuspenseInfiniteRevampSiteDocumentsQuery.rootKey = "RevampSiteDocuments.infinite"

useRevampSiteDocumentsQuery.fetcher = (
  variables: RevampSiteDocumentsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RevampSiteDocumentsQuery, RevampSiteDocumentsQueryVariables>(
    RevampSiteDocumentsDocument,
    variables,
    options,
  )

export const RevampSiteBelowTheFoldDocument = `
    query RevampSiteBelowTheFold($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    name
    pid
    site(pid: $sitePid) {
      pid
      recommendedResult {
        ...Result
        ...ResultWithEnergyData
      }
      policies {
        ...PolicyBrief
      }
    }
  }
}
    ${ResultFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${RevampCsFragmentDoc}
${HelioscopeFragmentDoc}
${ResultWithEnergyDataFragmentDoc}
${PolicyBriefFragmentDoc}`

export const useRevampSiteBelowTheFoldQuery = <
  TData = RevampSiteBelowTheFoldQuery,
  TError = unknown,
>(
  variables: RevampSiteBelowTheFoldQueryVariables,
  options?: Omit<
    UseQueryOptions<RevampSiteBelowTheFoldQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<RevampSiteBelowTheFoldQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<RevampSiteBelowTheFoldQuery, TError, TData>({
    queryKey: ["RevampSiteBelowTheFold", variables],
    queryFn: publicFetcher<
      RevampSiteBelowTheFoldQuery,
      RevampSiteBelowTheFoldQueryVariables
    >(RevampSiteBelowTheFoldDocument, variables),
    ...options,
  })
}

useRevampSiteBelowTheFoldQuery.getKey = (
  variables: RevampSiteBelowTheFoldQueryVariables,
) => ["RevampSiteBelowTheFold", variables]

useRevampSiteBelowTheFoldQuery.rootKey = "RevampSiteBelowTheFold"

export const useSuspenseRevampSiteBelowTheFoldQuery = <
  TData = RevampSiteBelowTheFoldQuery,
  TError = unknown,
>(
  variables: RevampSiteBelowTheFoldQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<RevampSiteBelowTheFoldQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      RevampSiteBelowTheFoldQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<RevampSiteBelowTheFoldQuery, TError, TData>({
    queryKey: ["RevampSiteBelowTheFoldSuspense", variables],
    queryFn: publicFetcher<
      RevampSiteBelowTheFoldQuery,
      RevampSiteBelowTheFoldQueryVariables
    >(RevampSiteBelowTheFoldDocument, variables),
    ...options,
  })
}

useSuspenseRevampSiteBelowTheFoldQuery.getKey = (
  variables: RevampSiteBelowTheFoldQueryVariables,
) => ["RevampSiteBelowTheFoldSuspense", variables]

useSuspenseRevampSiteBelowTheFoldQuery.rootKey = "RevampSiteBelowTheFold"

export const useInfiniteRevampSiteBelowTheFoldQuery = <
  TData = InfiniteData<RevampSiteBelowTheFoldQuery>,
  TError = unknown,
>(
  variables: RevampSiteBelowTheFoldQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<RevampSiteBelowTheFoldQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      RevampSiteBelowTheFoldQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<RevampSiteBelowTheFoldQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["RevampSiteBelowTheFold.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            RevampSiteBelowTheFoldQuery,
            RevampSiteBelowTheFoldQueryVariables
          >(RevampSiteBelowTheFoldDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteRevampSiteBelowTheFoldQuery.getKey = (
  variables: RevampSiteBelowTheFoldQueryVariables,
) => ["RevampSiteBelowTheFold.infinite", variables]

useInfiniteRevampSiteBelowTheFoldQuery.rootKey = "RevampSiteBelowTheFold.infinite"

export const useSuspenseInfiniteRevampSiteBelowTheFoldQuery = <
  TData = InfiniteData<RevampSiteBelowTheFoldQuery>,
  TError = unknown,
>(
  variables: RevampSiteBelowTheFoldQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<RevampSiteBelowTheFoldQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      RevampSiteBelowTheFoldQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<RevampSiteBelowTheFoldQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "RevampSiteBelowTheFold.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            RevampSiteBelowTheFoldQuery,
            RevampSiteBelowTheFoldQueryVariables
          >(RevampSiteBelowTheFoldDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteRevampSiteBelowTheFoldQuery.getKey = (
  variables: RevampSiteBelowTheFoldQueryVariables,
) => ["RevampSiteBelowTheFold.infiniteSuspense", variables]

useSuspenseInfiniteRevampSiteBelowTheFoldQuery.rootKey =
  "RevampSiteBelowTheFold.infinite"

useRevampSiteBelowTheFoldQuery.fetcher = (
  variables: RevampSiteBelowTheFoldQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RevampSiteBelowTheFoldQuery, RevampSiteBelowTheFoldQueryVariables>(
    RevampSiteBelowTheFoldDocument,
    variables,
    options,
  )

export const RevampSiteBillingMetersDocument = `
    query RevampSiteBillingMeters($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    site(pid: $sitePid) {
      billingMeters {
        ...BillingMeter
      }
    }
  }
}
    ${BillingMeterFragmentDoc}
${FancyFloatFragmentDoc}
${BillingMonthViewFragmentDoc}
${ProviderFragmentDoc}
${UserRefFragmentDoc}
${BillingMeterProjectedFragmentDoc}
${BillGroupFragmentDoc}
${GroupedLineItemFragmentDoc}
${BillingIntervalViewFragmentDoc}`

export const useRevampSiteBillingMetersQuery = <
  TData = RevampSiteBillingMetersQuery,
  TError = unknown,
>(
  variables: RevampSiteBillingMetersQueryVariables,
  options?: Omit<
    UseQueryOptions<RevampSiteBillingMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<RevampSiteBillingMetersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<RevampSiteBillingMetersQuery, TError, TData>({
    queryKey: ["RevampSiteBillingMeters", variables],
    queryFn: publicFetcher<
      RevampSiteBillingMetersQuery,
      RevampSiteBillingMetersQueryVariables
    >(RevampSiteBillingMetersDocument, variables),
    ...options,
  })
}

useRevampSiteBillingMetersQuery.getKey = (
  variables: RevampSiteBillingMetersQueryVariables,
) => ["RevampSiteBillingMeters", variables]

useRevampSiteBillingMetersQuery.rootKey = "RevampSiteBillingMeters"

export const useSuspenseRevampSiteBillingMetersQuery = <
  TData = RevampSiteBillingMetersQuery,
  TError = unknown,
>(
  variables: RevampSiteBillingMetersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<RevampSiteBillingMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      RevampSiteBillingMetersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<RevampSiteBillingMetersQuery, TError, TData>({
    queryKey: ["RevampSiteBillingMetersSuspense", variables],
    queryFn: publicFetcher<
      RevampSiteBillingMetersQuery,
      RevampSiteBillingMetersQueryVariables
    >(RevampSiteBillingMetersDocument, variables),
    ...options,
  })
}

useSuspenseRevampSiteBillingMetersQuery.getKey = (
  variables: RevampSiteBillingMetersQueryVariables,
) => ["RevampSiteBillingMetersSuspense", variables]

useSuspenseRevampSiteBillingMetersQuery.rootKey = "RevampSiteBillingMeters"

export const useInfiniteRevampSiteBillingMetersQuery = <
  TData = InfiniteData<RevampSiteBillingMetersQuery>,
  TError = unknown,
>(
  variables: RevampSiteBillingMetersQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<RevampSiteBillingMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      RevampSiteBillingMetersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<RevampSiteBillingMetersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["RevampSiteBillingMeters.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            RevampSiteBillingMetersQuery,
            RevampSiteBillingMetersQueryVariables
          >(RevampSiteBillingMetersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteRevampSiteBillingMetersQuery.getKey = (
  variables: RevampSiteBillingMetersQueryVariables,
) => ["RevampSiteBillingMeters.infinite", variables]

useInfiniteRevampSiteBillingMetersQuery.rootKey = "RevampSiteBillingMeters.infinite"

export const useSuspenseInfiniteRevampSiteBillingMetersQuery = <
  TData = InfiniteData<RevampSiteBillingMetersQuery>,
  TError = unknown,
>(
  variables: RevampSiteBillingMetersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<RevampSiteBillingMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      RevampSiteBillingMetersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<RevampSiteBillingMetersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "RevampSiteBillingMeters.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            RevampSiteBillingMetersQuery,
            RevampSiteBillingMetersQueryVariables
          >(RevampSiteBillingMetersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteRevampSiteBillingMetersQuery.getKey = (
  variables: RevampSiteBillingMetersQueryVariables,
) => ["RevampSiteBillingMeters.infiniteSuspense", variables]

useSuspenseInfiniteRevampSiteBillingMetersQuery.rootKey =
  "RevampSiteBillingMeters.infinite"

useRevampSiteBillingMetersQuery.fetcher = (
  variables: RevampSiteBillingMetersQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RevampSiteBillingMetersQuery, RevampSiteBillingMetersQueryVariables>(
    RevampSiteBillingMetersDocument,
    variables,
    options,
  )

export const RevampSiteGridEscalatorDocument = `
    query RevampSiteGridEscalator($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    site(pid: $sitePid) {
      gridEscalator
    }
  }
}
    `

export const useRevampSiteGridEscalatorQuery = <
  TData = RevampSiteGridEscalatorQuery,
  TError = unknown,
>(
  variables: RevampSiteGridEscalatorQueryVariables,
  options?: Omit<
    UseQueryOptions<RevampSiteGridEscalatorQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<RevampSiteGridEscalatorQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<RevampSiteGridEscalatorQuery, TError, TData>({
    queryKey: ["RevampSiteGridEscalator", variables],
    queryFn: publicFetcher<
      RevampSiteGridEscalatorQuery,
      RevampSiteGridEscalatorQueryVariables
    >(RevampSiteGridEscalatorDocument, variables),
    ...options,
  })
}

useRevampSiteGridEscalatorQuery.getKey = (
  variables: RevampSiteGridEscalatorQueryVariables,
) => ["RevampSiteGridEscalator", variables]

useRevampSiteGridEscalatorQuery.rootKey = "RevampSiteGridEscalator"

export const useSuspenseRevampSiteGridEscalatorQuery = <
  TData = RevampSiteGridEscalatorQuery,
  TError = unknown,
>(
  variables: RevampSiteGridEscalatorQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<RevampSiteGridEscalatorQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      RevampSiteGridEscalatorQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<RevampSiteGridEscalatorQuery, TError, TData>({
    queryKey: ["RevampSiteGridEscalatorSuspense", variables],
    queryFn: publicFetcher<
      RevampSiteGridEscalatorQuery,
      RevampSiteGridEscalatorQueryVariables
    >(RevampSiteGridEscalatorDocument, variables),
    ...options,
  })
}

useSuspenseRevampSiteGridEscalatorQuery.getKey = (
  variables: RevampSiteGridEscalatorQueryVariables,
) => ["RevampSiteGridEscalatorSuspense", variables]

useSuspenseRevampSiteGridEscalatorQuery.rootKey = "RevampSiteGridEscalator"

export const useInfiniteRevampSiteGridEscalatorQuery = <
  TData = InfiniteData<RevampSiteGridEscalatorQuery>,
  TError = unknown,
>(
  variables: RevampSiteGridEscalatorQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<RevampSiteGridEscalatorQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      RevampSiteGridEscalatorQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<RevampSiteGridEscalatorQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["RevampSiteGridEscalator.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            RevampSiteGridEscalatorQuery,
            RevampSiteGridEscalatorQueryVariables
          >(RevampSiteGridEscalatorDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteRevampSiteGridEscalatorQuery.getKey = (
  variables: RevampSiteGridEscalatorQueryVariables,
) => ["RevampSiteGridEscalator.infinite", variables]

useInfiniteRevampSiteGridEscalatorQuery.rootKey = "RevampSiteGridEscalator.infinite"

export const useSuspenseInfiniteRevampSiteGridEscalatorQuery = <
  TData = InfiniteData<RevampSiteGridEscalatorQuery>,
  TError = unknown,
>(
  variables: RevampSiteGridEscalatorQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<RevampSiteGridEscalatorQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      RevampSiteGridEscalatorQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<RevampSiteGridEscalatorQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "RevampSiteGridEscalator.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            RevampSiteGridEscalatorQuery,
            RevampSiteGridEscalatorQueryVariables
          >(RevampSiteGridEscalatorDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteRevampSiteGridEscalatorQuery.getKey = (
  variables: RevampSiteGridEscalatorQueryVariables,
) => ["RevampSiteGridEscalator.infiniteSuspense", variables]

useSuspenseInfiniteRevampSiteGridEscalatorQuery.rootKey =
  "RevampSiteGridEscalator.infinite"

useRevampSiteGridEscalatorQuery.fetcher = (
  variables: RevampSiteGridEscalatorQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<RevampSiteGridEscalatorQuery, RevampSiteGridEscalatorQueryVariables>(
    RevampSiteGridEscalatorDocument,
    variables,
    options,
  )

export const SiteMetersDocument = `
    query SiteMeters($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    site(pid: $sitePid) {
      billingMeters {
        ...BillingMeterOption
      }
    }
  }
}
    ${BillingMeterOptionFragmentDoc}`

export const useSiteMetersQuery = <TData = SiteMetersQuery, TError = unknown>(
  variables: SiteMetersQueryVariables,
  options?: Omit<UseQueryOptions<SiteMetersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteMetersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteMetersQuery, TError, TData>({
    queryKey: ["SiteMeters", variables],
    queryFn: publicFetcher<SiteMetersQuery, SiteMetersQueryVariables>(
      SiteMetersDocument,
      variables,
    ),
    ...options,
  })
}

useSiteMetersQuery.getKey = (variables: SiteMetersQueryVariables) => [
  "SiteMeters",
  variables,
]

useSiteMetersQuery.rootKey = "SiteMeters"

export const useSuspenseSiteMetersQuery = <TData = SiteMetersQuery, TError = unknown>(
  variables: SiteMetersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteMetersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteMetersQuery, TError, TData>({
    queryKey: ["SiteMetersSuspense", variables],
    queryFn: publicFetcher<SiteMetersQuery, SiteMetersQueryVariables>(
      SiteMetersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteMetersQuery.getKey = (variables: SiteMetersQueryVariables) => [
  "SiteMetersSuspense",
  variables,
]

useSuspenseSiteMetersQuery.rootKey = "SiteMeters"

export const useInfiniteSiteMetersQuery = <
  TData = InfiniteData<SiteMetersQuery>,
  TError = unknown,
>(
  variables: SiteMetersQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SiteMetersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SiteMetersQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteMetersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteMeters.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteMetersQuery, SiteMetersQueryVariables>(SiteMetersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteMetersQuery.getKey = (variables: SiteMetersQueryVariables) => [
  "SiteMeters.infinite",
  variables,
]

useInfiniteSiteMetersQuery.rootKey = "SiteMeters.infinite"

export const useSuspenseInfiniteSiteMetersQuery = <
  TData = InfiniteData<SiteMetersQuery>,
  TError = unknown,
>(
  variables: SiteMetersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteMetersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteMetersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteMetersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteMeters.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteMetersQuery, SiteMetersQueryVariables>(SiteMetersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteMetersQuery.getKey = (variables: SiteMetersQueryVariables) => [
  "SiteMeters.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteMetersQuery.rootKey = "SiteMeters.infinite"

useSiteMetersQuery.fetcher = (
  variables: SiteMetersQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteMetersQuery, SiteMetersQueryVariables>(
    SiteMetersDocument,
    variables,
    options,
  )

export const BillingMeterDocumentParseRequestsDocument = `
    query BillingMeterDocumentParseRequests($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    site(pid: $sitePid) {
      documentParseRequests {
        ...DocumentParseRequest
      }
    }
  }
}
    ${DocumentParseRequestFragmentDoc}`

export const useBillingMeterDocumentParseRequestsQuery = <
  TData = BillingMeterDocumentParseRequestsQuery,
  TError = unknown,
>(
  variables: BillingMeterDocumentParseRequestsQueryVariables,
  options?: Omit<
    UseQueryOptions<BillingMeterDocumentParseRequestsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      BillingMeterDocumentParseRequestsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<BillingMeterDocumentParseRequestsQuery, TError, TData>({
    queryKey: ["BillingMeterDocumentParseRequests", variables],
    queryFn: publicFetcher<
      BillingMeterDocumentParseRequestsQuery,
      BillingMeterDocumentParseRequestsQueryVariables
    >(BillingMeterDocumentParseRequestsDocument, variables),
    ...options,
  })
}

useBillingMeterDocumentParseRequestsQuery.getKey = (
  variables: BillingMeterDocumentParseRequestsQueryVariables,
) => ["BillingMeterDocumentParseRequests", variables]

useBillingMeterDocumentParseRequestsQuery.rootKey = "BillingMeterDocumentParseRequests"

export const useSuspenseBillingMeterDocumentParseRequestsQuery = <
  TData = BillingMeterDocumentParseRequestsQuery,
  TError = unknown,
>(
  variables: BillingMeterDocumentParseRequestsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BillingMeterDocumentParseRequestsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BillingMeterDocumentParseRequestsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BillingMeterDocumentParseRequestsQuery, TError, TData>({
    queryKey: ["BillingMeterDocumentParseRequestsSuspense", variables],
    queryFn: publicFetcher<
      BillingMeterDocumentParseRequestsQuery,
      BillingMeterDocumentParseRequestsQueryVariables
    >(BillingMeterDocumentParseRequestsDocument, variables),
    ...options,
  })
}

useSuspenseBillingMeterDocumentParseRequestsQuery.getKey = (
  variables: BillingMeterDocumentParseRequestsQueryVariables,
) => ["BillingMeterDocumentParseRequestsSuspense", variables]

useSuspenseBillingMeterDocumentParseRequestsQuery.rootKey =
  "BillingMeterDocumentParseRequests"

export const useInfiniteBillingMeterDocumentParseRequestsQuery = <
  TData = InfiniteData<BillingMeterDocumentParseRequestsQuery>,
  TError = unknown,
>(
  variables: BillingMeterDocumentParseRequestsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BillingMeterDocumentParseRequestsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BillingMeterDocumentParseRequestsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BillingMeterDocumentParseRequestsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "BillingMeterDocumentParseRequests.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            BillingMeterDocumentParseRequestsQuery,
            BillingMeterDocumentParseRequestsQueryVariables
          >(BillingMeterDocumentParseRequestsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBillingMeterDocumentParseRequestsQuery.getKey = (
  variables: BillingMeterDocumentParseRequestsQueryVariables,
) => ["BillingMeterDocumentParseRequests.infinite", variables]

useInfiniteBillingMeterDocumentParseRequestsQuery.rootKey =
  "BillingMeterDocumentParseRequests.infinite"

export const useSuspenseInfiniteBillingMeterDocumentParseRequestsQuery = <
  TData = InfiniteData<BillingMeterDocumentParseRequestsQuery>,
  TError = unknown,
>(
  variables: BillingMeterDocumentParseRequestsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<
      BillingMeterDocumentParseRequestsQuery,
      TError,
      TData
    >,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BillingMeterDocumentParseRequestsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<
    BillingMeterDocumentParseRequestsQuery,
    TError,
    TData
  >(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "BillingMeterDocumentParseRequests.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            BillingMeterDocumentParseRequestsQuery,
            BillingMeterDocumentParseRequestsQueryVariables
          >(BillingMeterDocumentParseRequestsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBillingMeterDocumentParseRequestsQuery.getKey = (
  variables: BillingMeterDocumentParseRequestsQueryVariables,
) => ["BillingMeterDocumentParseRequests.infiniteSuspense", variables]

useSuspenseInfiniteBillingMeterDocumentParseRequestsQuery.rootKey =
  "BillingMeterDocumentParseRequests.infinite"

useBillingMeterDocumentParseRequestsQuery.fetcher = (
  variables: BillingMeterDocumentParseRequestsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    BillingMeterDocumentParseRequestsQuery,
    BillingMeterDocumentParseRequestsQueryVariables
  >(BillingMeterDocumentParseRequestsDocument, variables, options)

export const OrgDetailDocument = `
    query OrgDetail($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    pid
    slug
    name
    logomarkUrl
  }
}
    `

export const useOrgDetailQuery = <TData = OrgDetailQuery, TError = unknown>(
  variables: OrgDetailQueryVariables,
  options?: Omit<UseQueryOptions<OrgDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgDetailQuery, TError, TData>({
    queryKey: ["OrgDetail", variables],
    queryFn: publicFetcher<OrgDetailQuery, OrgDetailQueryVariables>(
      OrgDetailDocument,
      variables,
    ),
    ...options,
  })
}

useOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetail",
  variables,
]

useOrgDetailQuery.rootKey = "OrgDetail"

export const useSuspenseOrgDetailQuery = <TData = OrgDetailQuery, TError = unknown>(
  variables: OrgDetailQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<OrgDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<OrgDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgDetailQuery, TError, TData>({
    queryKey: ["OrgDetailSuspense", variables],
    queryFn: publicFetcher<OrgDetailQuery, OrgDetailQueryVariables>(
      OrgDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetailSuspense",
  variables,
]

useSuspenseOrgDetailQuery.rootKey = "OrgDetail"

export const useInfiniteOrgDetailQuery = <
  TData = InfiniteData<OrgDetailQuery>,
  TError = unknown,
>(
  variables: OrgDetailQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgDetailQuery, OrgDetailQueryVariables>(OrgDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetail.infinite",
  variables,
]

useInfiniteOrgDetailQuery.rootKey = "OrgDetail.infinite"

export const useSuspenseInfiniteOrgDetailQuery = <
  TData = InfiniteData<OrgDetailQuery>,
  TError = unknown,
>(
  variables: OrgDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgDetailQuery, OrgDetailQueryVariables>(OrgDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgDetailQuery.getKey = (variables: OrgDetailQueryVariables) => [
  "OrgDetail.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgDetailQuery.rootKey = "OrgDetail.infinite"

useOrgDetailQuery.fetcher = (
  variables: OrgDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgDetailQuery, OrgDetailQueryVariables>(
    OrgDetailDocument,
    variables,
    options,
  )

export const MultiMeterDetailDocument = `
    query MultiMeterDetail($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    site(pid: $sitePid) {
      ...SiteMeterSet
    }
  }
}
    ${SiteMeterSetFragmentDoc}
${SiteBauMeterFragmentDoc}
${FormattedBillFragmentDoc}
${BillSectionFragmentDoc}
${DecodedRateFragmentDoc}
${CostOrTaxItemFragmentDoc}`

export const useMultiMeterDetailQuery = <
  TData = MultiMeterDetailQuery,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options?: Omit<UseQueryOptions<MultiMeterDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<MultiMeterDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MultiMeterDetailQuery, TError, TData>({
    queryKey: ["MultiMeterDetail", variables],
    queryFn: publicFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
      MultiMeterDetailDocument,
      variables,
    ),
    ...options,
  })
}

useMultiMeterDetailQuery.getKey = (variables: MultiMeterDetailQueryVariables) => [
  "MultiMeterDetail",
  variables,
]

useMultiMeterDetailQuery.rootKey = "MultiMeterDetail"

export const useSuspenseMultiMeterDetailQuery = <
  TData = MultiMeterDetailQuery,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<MultiMeterDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<MultiMeterDetailQuery, TError, TData>({
    queryKey: ["MultiMeterDetailSuspense", variables],
    queryFn: publicFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
      MultiMeterDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMultiMeterDetailQuery.getKey = (
  variables: MultiMeterDetailQueryVariables,
) => ["MultiMeterDetailSuspense", variables]

useSuspenseMultiMeterDetailQuery.rootKey = "MultiMeterDetail"

export const useInfiniteMultiMeterDetailQuery = <
  TData = InfiniteData<MultiMeterDetailQuery>,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<MultiMeterDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<MultiMeterDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MultiMeterDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
            MultiMeterDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMultiMeterDetailQuery.getKey = (
  variables: MultiMeterDetailQueryVariables,
) => ["MultiMeterDetail.infinite", variables]

useInfiniteMultiMeterDetailQuery.rootKey = "MultiMeterDetail.infinite"

export const useSuspenseInfiniteMultiMeterDetailQuery = <
  TData = InfiniteData<MultiMeterDetailQuery>,
  TError = unknown,
>(
  variables: MultiMeterDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MultiMeterDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MultiMeterDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MultiMeterDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
            MultiMeterDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMultiMeterDetailQuery.getKey = (
  variables: MultiMeterDetailQueryVariables,
) => ["MultiMeterDetail.infiniteSuspense", variables]

useSuspenseInfiniteMultiMeterDetailQuery.rootKey = "MultiMeterDetail.infinite"

useMultiMeterDetailQuery.fetcher = (
  variables: MultiMeterDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MultiMeterDetailQuery, MultiMeterDetailQueryVariables>(
    MultiMeterDetailDocument,
    variables,
    options,
  )

export const OrgBundlesDocument = `
    query OrgBundles($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    pid
    name
    logoUrl
    bundles {
      ...BundleListItem
      rows {
        ...BundleRowDetail
      }
    }
  }
}
    ${BundleListItemFragmentDoc}
${InvestorOptOutFragmentDoc}
${UserRefFragmentDoc}
${BundleRowDetailFragmentDoc}
${BundleDetailRowFragmentDoc}
${InvestorBidFragmentDoc}
${PpaInvestorBidFragmentDoc}
${InvestorProfileFragmentDoc}
${SystemFragmentDoc}
${PvSystemSpecFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${CsInvestorBidFragmentDoc}
${SystemLiteFragmentDoc}
${RevampCsFragmentDoc}
${BidSpecFragmentDoc}
${PpaBidSpecFragmentDoc}
${CsBidSpecFragmentDoc}
${InvestorBidSpecOptOutFragmentDoc}
${RevampSiteBasicsFragmentDoc}
${SiteConfigFragmentDoc}
${FootprintFragmentDoc}
${BillingMeterOptionFragmentDoc}`

export const useOrgBundlesQuery = <TData = OrgBundlesQuery, TError = unknown>(
  variables: OrgBundlesQueryVariables,
  options?: Omit<UseQueryOptions<OrgBundlesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgBundlesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgBundlesQuery, TError, TData>({
    queryKey: ["OrgBundles", variables],
    queryFn: publicFetcher<OrgBundlesQuery, OrgBundlesQueryVariables>(
      OrgBundlesDocument,
      variables,
    ),
    ...options,
  })
}

useOrgBundlesQuery.getKey = (variables: OrgBundlesQueryVariables) => [
  "OrgBundles",
  variables,
]

useOrgBundlesQuery.rootKey = "OrgBundles"

export const useSuspenseOrgBundlesQuery = <TData = OrgBundlesQuery, TError = unknown>(
  variables: OrgBundlesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<OrgBundlesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<OrgBundlesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgBundlesQuery, TError, TData>({
    queryKey: ["OrgBundlesSuspense", variables],
    queryFn: publicFetcher<OrgBundlesQuery, OrgBundlesQueryVariables>(
      OrgBundlesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgBundlesQuery.getKey = (variables: OrgBundlesQueryVariables) => [
  "OrgBundlesSuspense",
  variables,
]

useSuspenseOrgBundlesQuery.rootKey = "OrgBundles"

export const useInfiniteOrgBundlesQuery = <
  TData = InfiniteData<OrgBundlesQuery>,
  TError = unknown,
>(
  variables: OrgBundlesQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgBundlesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgBundlesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgBundlesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgBundles.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgBundlesQuery, OrgBundlesQueryVariables>(OrgBundlesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgBundlesQuery.getKey = (variables: OrgBundlesQueryVariables) => [
  "OrgBundles.infinite",
  variables,
]

useInfiniteOrgBundlesQuery.rootKey = "OrgBundles.infinite"

export const useSuspenseInfiniteOrgBundlesQuery = <
  TData = InfiniteData<OrgBundlesQuery>,
  TError = unknown,
>(
  variables: OrgBundlesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgBundlesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      OrgBundlesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgBundlesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgBundles.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgBundlesQuery, OrgBundlesQueryVariables>(OrgBundlesDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgBundlesQuery.getKey = (variables: OrgBundlesQueryVariables) => [
  "OrgBundles.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgBundlesQuery.rootKey = "OrgBundles.infinite"

useOrgBundlesQuery.fetcher = (
  variables: OrgBundlesQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgBundlesQuery, OrgBundlesQueryVariables>(
    OrgBundlesDocument,
    variables,
    options,
  )

export const SiteBidsDocument = `
    query SiteBids($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $sitePid) {
      bidPackages {
        ...BasicBidPackage
        row(pid: $sitePid) {
          status
          closedAt
          closeReason
          closeCustomReason
        }
      }
      selectedConfigResult {
        ...Result
      }
      biddingConfigResult {
        ...Result
      }
    }
  }
}
    ${BasicBidPackageFragmentDoc}
${InvestorProfileFragmentDoc}
${ResultFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${RevampCsFragmentDoc}
${HelioscopeFragmentDoc}`

export const useSiteBidsQuery = <TData = SiteBidsQuery, TError = unknown>(
  variables: SiteBidsQueryVariables,
  options?: Omit<UseQueryOptions<SiteBidsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteBidsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteBidsQuery, TError, TData>({
    queryKey: ["SiteBids", variables],
    queryFn: publicFetcher<SiteBidsQuery, SiteBidsQueryVariables>(
      SiteBidsDocument,
      variables,
    ),
    ...options,
  })
}

useSiteBidsQuery.getKey = (variables: SiteBidsQueryVariables) => ["SiteBids", variables]

useSiteBidsQuery.rootKey = "SiteBids"

export const useSuspenseSiteBidsQuery = <TData = SiteBidsQuery, TError = unknown>(
  variables: SiteBidsQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<SiteBidsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<SiteBidsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteBidsQuery, TError, TData>({
    queryKey: ["SiteBidsSuspense", variables],
    queryFn: publicFetcher<SiteBidsQuery, SiteBidsQueryVariables>(
      SiteBidsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteBidsQuery.getKey = (variables: SiteBidsQueryVariables) => [
  "SiteBidsSuspense",
  variables,
]

useSuspenseSiteBidsQuery.rootKey = "SiteBids"

export const useInfiniteSiteBidsQuery = <
  TData = InfiniteData<SiteBidsQuery>,
  TError = unknown,
>(
  variables: SiteBidsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SiteBidsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SiteBidsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteBidsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBids.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteBidsQuery, SiteBidsQueryVariables>(SiteBidsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteBidsQuery.getKey = (variables: SiteBidsQueryVariables) => [
  "SiteBids.infinite",
  variables,
]

useInfiniteSiteBidsQuery.rootKey = "SiteBids.infinite"

export const useSuspenseInfiniteSiteBidsQuery = <
  TData = InfiniteData<SiteBidsQuery>,
  TError = unknown,
>(
  variables: SiteBidsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteBidsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<SiteBidsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteBidsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBids.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteBidsQuery, SiteBidsQueryVariables>(SiteBidsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteBidsQuery.getKey = (variables: SiteBidsQueryVariables) => [
  "SiteBids.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteBidsQuery.rootKey = "SiteBids.infinite"

useSiteBidsQuery.fetcher = (
  variables: SiteBidsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteBidsQuery, SiteBidsQueryVariables>(
    SiteBidsDocument,
    variables,
    options,
  )

export const FinancierBundleRowDocument = `
    query FinancierBundleRow($orgSlug: String!, $bundlePid: String!, $sitePid: String!) {
  bundleRowForFinancier(
    orgSlug: $orgSlug
    bundlePid: $bundlePid
    sitePid: $sitePid
  ) {
    ...BundleRow
    helioscopes {
      ...Helioscope
    }
  }
  isAwardee(orgSlug: $orgSlug, bundlePid: $bundlePid, sitePid: $sitePid)
}
    ${BundleRowFragmentDoc}
${RevampSiteBasicsFragmentDoc}
${SiteConfigFragmentDoc}
${UserRefFragmentDoc}
${FootprintFragmentDoc}
${BillingMeterOptionFragmentDoc}
${ResultFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${RevampCsFragmentDoc}
${HelioscopeFragmentDoc}`

export const useFinancierBundleRowQuery = <
  TData = FinancierBundleRowQuery,
  TError = unknown,
>(
  variables: FinancierBundleRowQueryVariables,
  options?: Omit<
    UseQueryOptions<FinancierBundleRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<FinancierBundleRowQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<FinancierBundleRowQuery, TError, TData>({
    queryKey: ["FinancierBundleRow", variables],
    queryFn: publicFetcher<FinancierBundleRowQuery, FinancierBundleRowQueryVariables>(
      FinancierBundleRowDocument,
      variables,
    ),
    ...options,
  })
}

useFinancierBundleRowQuery.getKey = (variables: FinancierBundleRowQueryVariables) => [
  "FinancierBundleRow",
  variables,
]

useFinancierBundleRowQuery.rootKey = "FinancierBundleRow"

export const useSuspenseFinancierBundleRowQuery = <
  TData = FinancierBundleRowQuery,
  TError = unknown,
>(
  variables: FinancierBundleRowQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinancierBundleRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinancierBundleRowQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinancierBundleRowQuery, TError, TData>({
    queryKey: ["FinancierBundleRowSuspense", variables],
    queryFn: publicFetcher<FinancierBundleRowQuery, FinancierBundleRowQueryVariables>(
      FinancierBundleRowDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseFinancierBundleRowQuery.getKey = (
  variables: FinancierBundleRowQueryVariables,
) => ["FinancierBundleRowSuspense", variables]

useSuspenseFinancierBundleRowQuery.rootKey = "FinancierBundleRow"

export const useInfiniteFinancierBundleRowQuery = <
  TData = InfiniteData<FinancierBundleRowQuery>,
  TError = unknown,
>(
  variables: FinancierBundleRowQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinancierBundleRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinancierBundleRowQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinancierBundleRowQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinancierBundleRow.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<FinancierBundleRowQuery, FinancierBundleRowQueryVariables>(
            FinancierBundleRowDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinancierBundleRowQuery.getKey = (
  variables: FinancierBundleRowQueryVariables,
) => ["FinancierBundleRow.infinite", variables]

useInfiniteFinancierBundleRowQuery.rootKey = "FinancierBundleRow.infinite"

export const useSuspenseInfiniteFinancierBundleRowQuery = <
  TData = InfiniteData<FinancierBundleRowQuery>,
  TError = unknown,
>(
  variables: FinancierBundleRowQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinancierBundleRowQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinancierBundleRowQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinancierBundleRowQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinancierBundleRow.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<FinancierBundleRowQuery, FinancierBundleRowQueryVariables>(
            FinancierBundleRowDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinancierBundleRowQuery.getKey = (
  variables: FinancierBundleRowQueryVariables,
) => ["FinancierBundleRow.infiniteSuspense", variables]

useSuspenseInfiniteFinancierBundleRowQuery.rootKey = "FinancierBundleRow.infinite"

useFinancierBundleRowQuery.fetcher = (
  variables: FinancierBundleRowQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<FinancierBundleRowQuery, FinancierBundleRowQueryVariables>(
    FinancierBundleRowDocument,
    variables,
    options,
  )

export const FinancierMultiMeterDetailDocument = `
    query FinancierMultiMeterDetail($orgSlug: String!, $bundlePid: String!, $sitePid: String!) {
  bundleRowForFinancier(
    orgSlug: $orgSlug
    bundlePid: $bundlePid
    sitePid: $sitePid
  ) {
    site {
      ...SiteMeterSet
    }
  }
}
    ${SiteMeterSetFragmentDoc}
${SiteBauMeterFragmentDoc}
${FormattedBillFragmentDoc}
${BillSectionFragmentDoc}
${DecodedRateFragmentDoc}
${CostOrTaxItemFragmentDoc}`

export const useFinancierMultiMeterDetailQuery = <
  TData = FinancierMultiMeterDetailQuery,
  TError = unknown,
>(
  variables: FinancierMultiMeterDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<FinancierMultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      FinancierMultiMeterDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<FinancierMultiMeterDetailQuery, TError, TData>({
    queryKey: ["FinancierMultiMeterDetail", variables],
    queryFn: publicFetcher<
      FinancierMultiMeterDetailQuery,
      FinancierMultiMeterDetailQueryVariables
    >(FinancierMultiMeterDetailDocument, variables),
    ...options,
  })
}

useFinancierMultiMeterDetailQuery.getKey = (
  variables: FinancierMultiMeterDetailQueryVariables,
) => ["FinancierMultiMeterDetail", variables]

useFinancierMultiMeterDetailQuery.rootKey = "FinancierMultiMeterDetail"

export const useSuspenseFinancierMultiMeterDetailQuery = <
  TData = FinancierMultiMeterDetailQuery,
  TError = unknown,
>(
  variables: FinancierMultiMeterDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinancierMultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinancierMultiMeterDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinancierMultiMeterDetailQuery, TError, TData>({
    queryKey: ["FinancierMultiMeterDetailSuspense", variables],
    queryFn: publicFetcher<
      FinancierMultiMeterDetailQuery,
      FinancierMultiMeterDetailQueryVariables
    >(FinancierMultiMeterDetailDocument, variables),
    ...options,
  })
}

useSuspenseFinancierMultiMeterDetailQuery.getKey = (
  variables: FinancierMultiMeterDetailQueryVariables,
) => ["FinancierMultiMeterDetailSuspense", variables]

useSuspenseFinancierMultiMeterDetailQuery.rootKey = "FinancierMultiMeterDetail"

export const useInfiniteFinancierMultiMeterDetailQuery = <
  TData = InfiniteData<FinancierMultiMeterDetailQuery>,
  TError = unknown,
>(
  variables: FinancierMultiMeterDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinancierMultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinancierMultiMeterDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinancierMultiMeterDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinancierMultiMeterDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierMultiMeterDetailQuery,
            FinancierMultiMeterDetailQueryVariables
          >(FinancierMultiMeterDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinancierMultiMeterDetailQuery.getKey = (
  variables: FinancierMultiMeterDetailQueryVariables,
) => ["FinancierMultiMeterDetail.infinite", variables]

useInfiniteFinancierMultiMeterDetailQuery.rootKey = "FinancierMultiMeterDetail.infinite"

export const useSuspenseInfiniteFinancierMultiMeterDetailQuery = <
  TData = InfiniteData<FinancierMultiMeterDetailQuery>,
  TError = unknown,
>(
  variables: FinancierMultiMeterDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinancierMultiMeterDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinancierMultiMeterDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinancierMultiMeterDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinancierMultiMeterDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierMultiMeterDetailQuery,
            FinancierMultiMeterDetailQueryVariables
          >(FinancierMultiMeterDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinancierMultiMeterDetailQuery.getKey = (
  variables: FinancierMultiMeterDetailQueryVariables,
) => ["FinancierMultiMeterDetail.infiniteSuspense", variables]

useSuspenseInfiniteFinancierMultiMeterDetailQuery.rootKey =
  "FinancierMultiMeterDetail.infinite"

useFinancierMultiMeterDetailQuery.fetcher = (
  variables: FinancierMultiMeterDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    FinancierMultiMeterDetailQuery,
    FinancierMultiMeterDetailQueryVariables
  >(FinancierMultiMeterDetailDocument, variables, options)

export const FinancierBundleRowDocumentsDocument = `
    query FinancierBundleRowDocuments($orgSlug: String!, $bundlePid: String!, $sitePid: String!) {
  bundleRowForFinancier(
    orgSlug: $orgSlug
    bundlePid: $bundlePid
    sitePid: $sitePid
  ) {
    site {
      pid
      documents {
        ...Document
      }
    }
  }
}
    ${DocumentFragmentDoc}`

export const useFinancierBundleRowDocumentsQuery = <
  TData = FinancierBundleRowDocumentsQuery,
  TError = unknown,
>(
  variables: FinancierBundleRowDocumentsQueryVariables,
  options?: Omit<
    UseQueryOptions<FinancierBundleRowDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      FinancierBundleRowDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<FinancierBundleRowDocumentsQuery, TError, TData>({
    queryKey: ["FinancierBundleRowDocuments", variables],
    queryFn: publicFetcher<
      FinancierBundleRowDocumentsQuery,
      FinancierBundleRowDocumentsQueryVariables
    >(FinancierBundleRowDocumentsDocument, variables),
    ...options,
  })
}

useFinancierBundleRowDocumentsQuery.getKey = (
  variables: FinancierBundleRowDocumentsQueryVariables,
) => ["FinancierBundleRowDocuments", variables]

useFinancierBundleRowDocumentsQuery.rootKey = "FinancierBundleRowDocuments"

export const useSuspenseFinancierBundleRowDocumentsQuery = <
  TData = FinancierBundleRowDocumentsQuery,
  TError = unknown,
>(
  variables: FinancierBundleRowDocumentsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinancierBundleRowDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinancierBundleRowDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinancierBundleRowDocumentsQuery, TError, TData>({
    queryKey: ["FinancierBundleRowDocumentsSuspense", variables],
    queryFn: publicFetcher<
      FinancierBundleRowDocumentsQuery,
      FinancierBundleRowDocumentsQueryVariables
    >(FinancierBundleRowDocumentsDocument, variables),
    ...options,
  })
}

useSuspenseFinancierBundleRowDocumentsQuery.getKey = (
  variables: FinancierBundleRowDocumentsQueryVariables,
) => ["FinancierBundleRowDocumentsSuspense", variables]

useSuspenseFinancierBundleRowDocumentsQuery.rootKey = "FinancierBundleRowDocuments"

export const useInfiniteFinancierBundleRowDocumentsQuery = <
  TData = InfiniteData<FinancierBundleRowDocumentsQuery>,
  TError = unknown,
>(
  variables: FinancierBundleRowDocumentsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinancierBundleRowDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinancierBundleRowDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinancierBundleRowDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinancierBundleRowDocuments.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierBundleRowDocumentsQuery,
            FinancierBundleRowDocumentsQueryVariables
          >(FinancierBundleRowDocumentsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinancierBundleRowDocumentsQuery.getKey = (
  variables: FinancierBundleRowDocumentsQueryVariables,
) => ["FinancierBundleRowDocuments.infinite", variables]

useInfiniteFinancierBundleRowDocumentsQuery.rootKey =
  "FinancierBundleRowDocuments.infinite"

export const useSuspenseInfiniteFinancierBundleRowDocumentsQuery = <
  TData = InfiniteData<FinancierBundleRowDocumentsQuery>,
  TError = unknown,
>(
  variables: FinancierBundleRowDocumentsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinancierBundleRowDocumentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinancierBundleRowDocumentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinancierBundleRowDocumentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinancierBundleRowDocuments.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierBundleRowDocumentsQuery,
            FinancierBundleRowDocumentsQueryVariables
          >(FinancierBundleRowDocumentsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinancierBundleRowDocumentsQuery.getKey = (
  variables: FinancierBundleRowDocumentsQueryVariables,
) => ["FinancierBundleRowDocuments.infiniteSuspense", variables]

useSuspenseInfiniteFinancierBundleRowDocumentsQuery.rootKey =
  "FinancierBundleRowDocuments.infinite"

useFinancierBundleRowDocumentsQuery.fetcher = (
  variables: FinancierBundleRowDocumentsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    FinancierBundleRowDocumentsQuery,
    FinancierBundleRowDocumentsQueryVariables
  >(FinancierBundleRowDocumentsDocument, variables, options)

export const SidebarDataDocument = `
    query SidebarData($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    sites {
      view {
        count
      }
    }
    shine {
      stats {
        numProperties
      }
    }
    isDeveloper
  }
}
    `

export const useSidebarDataQuery = <TData = SidebarDataQuery, TError = unknown>(
  variables: SidebarDataQueryVariables,
  options?: Omit<UseQueryOptions<SidebarDataQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SidebarDataQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SidebarDataQuery, TError, TData>({
    queryKey: ["SidebarData", variables],
    queryFn: publicFetcher<SidebarDataQuery, SidebarDataQueryVariables>(
      SidebarDataDocument,
      variables,
    ),
    ...options,
  })
}

useSidebarDataQuery.getKey = (variables: SidebarDataQueryVariables) => [
  "SidebarData",
  variables,
]

useSidebarDataQuery.rootKey = "SidebarData"

export const useSuspenseSidebarDataQuery = <TData = SidebarDataQuery, TError = unknown>(
  variables: SidebarDataQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SidebarDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SidebarDataQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SidebarDataQuery, TError, TData>({
    queryKey: ["SidebarDataSuspense", variables],
    queryFn: publicFetcher<SidebarDataQuery, SidebarDataQueryVariables>(
      SidebarDataDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSidebarDataQuery.getKey = (variables: SidebarDataQueryVariables) => [
  "SidebarDataSuspense",
  variables,
]

useSuspenseSidebarDataQuery.rootKey = "SidebarData"

export const useInfiniteSidebarDataQuery = <
  TData = InfiniteData<SidebarDataQuery>,
  TError = unknown,
>(
  variables: SidebarDataQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SidebarDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SidebarDataQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SidebarDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SidebarData.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SidebarDataQuery, SidebarDataQueryVariables>(
            SidebarDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSidebarDataQuery.getKey = (variables: SidebarDataQueryVariables) => [
  "SidebarData.infinite",
  variables,
]

useInfiniteSidebarDataQuery.rootKey = "SidebarData.infinite"

export const useSuspenseInfiniteSidebarDataQuery = <
  TData = InfiniteData<SidebarDataQuery>,
  TError = unknown,
>(
  variables: SidebarDataQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SidebarDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SidebarDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SidebarDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SidebarData.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SidebarDataQuery, SidebarDataQueryVariables>(
            SidebarDataDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSidebarDataQuery.getKey = (variables: SidebarDataQueryVariables) => [
  "SidebarData.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSidebarDataQuery.rootKey = "SidebarData.infinite"

useSidebarDataQuery.fetcher = (
  variables: SidebarDataQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SidebarDataQuery, SidebarDataQueryVariables>(
    SidebarDataDocument,
    variables,
    options,
  )

export const ThirdPartySuppliersDocument = `
    query ThirdPartySuppliers {
  thirdPartySuppliers {
    id
    pid
    name
  }
}
    `

export const useThirdPartySuppliersQuery = <
  TData = ThirdPartySuppliersQuery,
  TError = unknown,
>(
  variables?: ThirdPartySuppliersQueryVariables,
  options?: Omit<
    UseQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<ThirdPartySuppliersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ThirdPartySuppliersQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ThirdPartySuppliers"]
        : ["ThirdPartySuppliers", variables],
    queryFn: publicFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
      ThirdPartySuppliersDocument,
      variables,
    ),
    ...options,
  })
}

useThirdPartySuppliersQuery.getKey = (variables?: ThirdPartySuppliersQueryVariables) =>
  variables === undefined ? ["ThirdPartySuppliers"] : ["ThirdPartySuppliers", variables]

useThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers"

export const useSuspenseThirdPartySuppliersQuery = <
  TData = ThirdPartySuppliersQuery,
  TError = unknown,
>(
  variables?: ThirdPartySuppliersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      ThirdPartySuppliersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<ThirdPartySuppliersQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["ThirdPartySuppliersSuspense"]
        : ["ThirdPartySuppliersSuspense", variables],
    queryFn: publicFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
      ThirdPartySuppliersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseThirdPartySuppliersQuery.getKey = (
  variables?: ThirdPartySuppliersQueryVariables,
) =>
  variables === undefined
    ? ["ThirdPartySuppliersSuspense"]
    : ["ThirdPartySuppliersSuspense", variables]

useSuspenseThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers"

export const useInfiniteThirdPartySuppliersQuery = <
  TData = InfiniteData<ThirdPartySuppliersQuery>,
  TError = unknown,
>(
  variables: ThirdPartySuppliersQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      ThirdPartySuppliersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<ThirdPartySuppliersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ThirdPartySuppliers.infinite"]
            : ["ThirdPartySuppliers.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
            ThirdPartySuppliersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteThirdPartySuppliersQuery.getKey = (
  variables?: ThirdPartySuppliersQueryVariables,
) =>
  variables === undefined
    ? ["ThirdPartySuppliers.infinite"]
    : ["ThirdPartySuppliers.infinite", variables]

useInfiniteThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers.infinite"

export const useSuspenseInfiniteThirdPartySuppliersQuery = <
  TData = InfiniteData<ThirdPartySuppliersQuery>,
  TError = unknown,
>(
  variables: ThirdPartySuppliersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ThirdPartySuppliersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ThirdPartySuppliersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ThirdPartySuppliersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["ThirdPartySuppliers.infiniteSuspense"]
            : ["ThirdPartySuppliers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
            ThirdPartySuppliersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteThirdPartySuppliersQuery.getKey = (
  variables?: ThirdPartySuppliersQueryVariables,
) =>
  variables === undefined
    ? ["ThirdPartySuppliers.infiniteSuspense"]
    : ["ThirdPartySuppliers.infiniteSuspense", variables]

useSuspenseInfiniteThirdPartySuppliersQuery.rootKey = "ThirdPartySuppliers.infinite"

useThirdPartySuppliersQuery.fetcher = (
  variables?: ThirdPartySuppliersQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ThirdPartySuppliersQuery, ThirdPartySuppliersQueryVariables>(
    ThirdPartySuppliersDocument,
    variables,
    options,
  )

export const ShineSiteDetailDocument = `
    query ShineSiteDetail($orgSlug: String!, $propertyPid: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    site(pid: $propertyPid) {
      pid
      name
      fullAddress
      footprint {
        ...Footprint
      }
      shine {
        status
        stats {
          ...ShineStats
        }
      }
    }
  }
}
    ${FootprintFragmentDoc}
${UserRefFragmentDoc}
${ShineStatsFragmentDoc}`

export const useShineSiteDetailQuery = <TData = ShineSiteDetailQuery, TError = unknown>(
  variables: ShineSiteDetailQueryVariables,
  options?: Omit<UseQueryOptions<ShineSiteDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ShineSiteDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ShineSiteDetailQuery, TError, TData>({
    queryKey: ["ShineSiteDetail", variables],
    queryFn: publicFetcher<ShineSiteDetailQuery, ShineSiteDetailQueryVariables>(
      ShineSiteDetailDocument,
      variables,
    ),
    ...options,
  })
}

useShineSiteDetailQuery.getKey = (variables: ShineSiteDetailQueryVariables) => [
  "ShineSiteDetail",
  variables,
]

useShineSiteDetailQuery.rootKey = "ShineSiteDetail"

export const useSuspenseShineSiteDetailQuery = <
  TData = ShineSiteDetailQuery,
  TError = unknown,
>(
  variables: ShineSiteDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ShineSiteDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ShineSiteDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ShineSiteDetailQuery, TError, TData>({
    queryKey: ["ShineSiteDetailSuspense", variables],
    queryFn: publicFetcher<ShineSiteDetailQuery, ShineSiteDetailQueryVariables>(
      ShineSiteDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseShineSiteDetailQuery.getKey = (variables: ShineSiteDetailQueryVariables) => [
  "ShineSiteDetailSuspense",
  variables,
]

useSuspenseShineSiteDetailQuery.rootKey = "ShineSiteDetail"

export const useInfiniteShineSiteDetailQuery = <
  TData = InfiniteData<ShineSiteDetailQuery>,
  TError = unknown,
>(
  variables: ShineSiteDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ShineSiteDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ShineSiteDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ShineSiteDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ShineSiteDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ShineSiteDetailQuery, ShineSiteDetailQueryVariables>(
            ShineSiteDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteShineSiteDetailQuery.getKey = (variables: ShineSiteDetailQueryVariables) => [
  "ShineSiteDetail.infinite",
  variables,
]

useInfiniteShineSiteDetailQuery.rootKey = "ShineSiteDetail.infinite"

export const useSuspenseInfiniteShineSiteDetailQuery = <
  TData = InfiniteData<ShineSiteDetailQuery>,
  TError = unknown,
>(
  variables: ShineSiteDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ShineSiteDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ShineSiteDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ShineSiteDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ShineSiteDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<ShineSiteDetailQuery, ShineSiteDetailQueryVariables>(
            ShineSiteDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteShineSiteDetailQuery.getKey = (
  variables: ShineSiteDetailQueryVariables,
) => ["ShineSiteDetail.infiniteSuspense", variables]

useSuspenseInfiniteShineSiteDetailQuery.rootKey = "ShineSiteDetail.infinite"

useShineSiteDetailQuery.fetcher = (
  variables: ShineSiteDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ShineSiteDetailQuery, ShineSiteDetailQueryVariables>(
    ShineSiteDetailDocument,
    variables,
    options,
  )

export const OrgShineDocument = `
    query OrgShine($orgSlug: String!, $duration: ShineDuration!) {
  orgBySlug(slug: $orgSlug) {
    name
    slug
    shine {
      status
      stats {
        ...ShineStats
      }
      units(duration: $duration) {
        ...ShineUnit
      }
      siteRefs {
        pid
        lat
        lon
        monthlyGrossRevenue
        status
      }
    }
  }
}
    ${ShineStatsFragmentDoc}
${ShineUnitFragmentDoc}`

export const useOrgShineQuery = <TData = OrgShineQuery, TError = unknown>(
  variables: OrgShineQueryVariables,
  options?: Omit<UseQueryOptions<OrgShineQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<OrgShineQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<OrgShineQuery, TError, TData>({
    queryKey: ["OrgShine", variables],
    queryFn: publicFetcher<OrgShineQuery, OrgShineQueryVariables>(
      OrgShineDocument,
      variables,
    ),
    ...options,
  })
}

useOrgShineQuery.getKey = (variables: OrgShineQueryVariables) => ["OrgShine", variables]

useOrgShineQuery.rootKey = "OrgShine"

export const useSuspenseOrgShineQuery = <TData = OrgShineQuery, TError = unknown>(
  variables: OrgShineQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<OrgShineQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<OrgShineQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<OrgShineQuery, TError, TData>({
    queryKey: ["OrgShineSuspense", variables],
    queryFn: publicFetcher<OrgShineQuery, OrgShineQueryVariables>(
      OrgShineDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseOrgShineQuery.getKey = (variables: OrgShineQueryVariables) => [
  "OrgShineSuspense",
  variables,
]

useSuspenseOrgShineQuery.rootKey = "OrgShine"

export const useInfiniteOrgShineQuery = <
  TData = InfiniteData<OrgShineQuery>,
  TError = unknown,
>(
  variables: OrgShineQueryVariables,
  options: Omit<UseInfiniteQueryOptions<OrgShineQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<OrgShineQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<OrgShineQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgShine.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgShineQuery, OrgShineQueryVariables>(OrgShineDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteOrgShineQuery.getKey = (variables: OrgShineQueryVariables) => [
  "OrgShine.infinite",
  variables,
]

useInfiniteOrgShineQuery.rootKey = "OrgShine.infinite"

export const useSuspenseInfiniteOrgShineQuery = <
  TData = InfiniteData<OrgShineQuery>,
  TError = unknown,
>(
  variables: OrgShineQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<OrgShineQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<OrgShineQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<OrgShineQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["OrgShine.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<OrgShineQuery, OrgShineQueryVariables>(OrgShineDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteOrgShineQuery.getKey = (variables: OrgShineQueryVariables) => [
  "OrgShine.infiniteSuspense",
  variables,
]

useSuspenseInfiniteOrgShineQuery.rootKey = "OrgShine.infinite"

useOrgShineQuery.fetcher = (
  variables: OrgShineQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<OrgShineQuery, OrgShineQueryVariables>(
    OrgShineDocument,
    variables,
    options,
  )

export const ShineSiteDetailUnitsDocument = `
    query ShineSiteDetailUnits($orgSlug: String!, $propertyPid: String!, $duration: ShineDuration!) {
  orgBySlug(slug: $orgSlug) {
    slug
    site(pid: $propertyPid) {
      pid
      shine {
        units(duration: $duration) {
          ...ShineUnit
        }
      }
    }
  }
}
    ${ShineUnitFragmentDoc}`

export const useShineSiteDetailUnitsQuery = <
  TData = ShineSiteDetailUnitsQuery,
  TError = unknown,
>(
  variables: ShineSiteDetailUnitsQueryVariables,
  options?: Omit<
    UseQueryOptions<ShineSiteDetailUnitsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<ShineSiteDetailUnitsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ShineSiteDetailUnitsQuery, TError, TData>({
    queryKey: ["ShineSiteDetailUnits", variables],
    queryFn: publicFetcher<
      ShineSiteDetailUnitsQuery,
      ShineSiteDetailUnitsQueryVariables
    >(ShineSiteDetailUnitsDocument, variables),
    ...options,
  })
}

useShineSiteDetailUnitsQuery.getKey = (
  variables: ShineSiteDetailUnitsQueryVariables,
) => ["ShineSiteDetailUnits", variables]

useShineSiteDetailUnitsQuery.rootKey = "ShineSiteDetailUnits"

export const useSuspenseShineSiteDetailUnitsQuery = <
  TData = ShineSiteDetailUnitsQuery,
  TError = unknown,
>(
  variables: ShineSiteDetailUnitsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ShineSiteDetailUnitsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      ShineSiteDetailUnitsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<ShineSiteDetailUnitsQuery, TError, TData>({
    queryKey: ["ShineSiteDetailUnitsSuspense", variables],
    queryFn: publicFetcher<
      ShineSiteDetailUnitsQuery,
      ShineSiteDetailUnitsQueryVariables
    >(ShineSiteDetailUnitsDocument, variables),
    ...options,
  })
}

useSuspenseShineSiteDetailUnitsQuery.getKey = (
  variables: ShineSiteDetailUnitsQueryVariables,
) => ["ShineSiteDetailUnitsSuspense", variables]

useSuspenseShineSiteDetailUnitsQuery.rootKey = "ShineSiteDetailUnits"

export const useInfiniteShineSiteDetailUnitsQuery = <
  TData = InfiniteData<ShineSiteDetailUnitsQuery>,
  TError = unknown,
>(
  variables: ShineSiteDetailUnitsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ShineSiteDetailUnitsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      ShineSiteDetailUnitsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<ShineSiteDetailUnitsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ShineSiteDetailUnits.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ShineSiteDetailUnitsQuery, ShineSiteDetailUnitsQueryVariables>(
            ShineSiteDetailUnitsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteShineSiteDetailUnitsQuery.getKey = (
  variables: ShineSiteDetailUnitsQueryVariables,
) => ["ShineSiteDetailUnits.infinite", variables]

useInfiniteShineSiteDetailUnitsQuery.rootKey = "ShineSiteDetailUnits.infinite"

export const useSuspenseInfiniteShineSiteDetailUnitsQuery = <
  TData = InfiniteData<ShineSiteDetailUnitsQuery>,
  TError = unknown,
>(
  variables: ShineSiteDetailUnitsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ShineSiteDetailUnitsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ShineSiteDetailUnitsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ShineSiteDetailUnitsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "ShineSiteDetailUnits.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<ShineSiteDetailUnitsQuery, ShineSiteDetailUnitsQueryVariables>(
            ShineSiteDetailUnitsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteShineSiteDetailUnitsQuery.getKey = (
  variables: ShineSiteDetailUnitsQueryVariables,
) => ["ShineSiteDetailUnits.infiniteSuspense", variables]

useSuspenseInfiniteShineSiteDetailUnitsQuery.rootKey = "ShineSiteDetailUnits.infinite"

useShineSiteDetailUnitsQuery.fetcher = (
  variables: ShineSiteDetailUnitsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ShineSiteDetailUnitsQuery, ShineSiteDetailUnitsQueryVariables>(
    ShineSiteDetailUnitsDocument,
    variables,
    options,
  )

export const SiteSolarPanelVisualDocument = `
    query SiteSolarPanelVisual($orgSlug: String!, $propertyPid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $propertyPid) {
      visuals {
        ...SiteVisuals
      }
    }
  }
}
    ${SiteVisualsFragmentDoc}`

export const useSiteSolarPanelVisualQuery = <
  TData = SiteSolarPanelVisualQuery,
  TError = unknown,
>(
  variables: SiteSolarPanelVisualQueryVariables,
  options?: Omit<
    UseQueryOptions<SiteSolarPanelVisualQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<SiteSolarPanelVisualQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteSolarPanelVisualQuery, TError, TData>({
    queryKey: ["SiteSolarPanelVisual", variables],
    queryFn: publicFetcher<
      SiteSolarPanelVisualQuery,
      SiteSolarPanelVisualQueryVariables
    >(SiteSolarPanelVisualDocument, variables),
    ...options,
  })
}

useSiteSolarPanelVisualQuery.getKey = (
  variables: SiteSolarPanelVisualQueryVariables,
) => ["SiteSolarPanelVisual", variables]

useSiteSolarPanelVisualQuery.rootKey = "SiteSolarPanelVisual"

export const useSuspenseSiteSolarPanelVisualQuery = <
  TData = SiteSolarPanelVisualQuery,
  TError = unknown,
>(
  variables: SiteSolarPanelVisualQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteSolarPanelVisualQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteSolarPanelVisualQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteSolarPanelVisualQuery, TError, TData>({
    queryKey: ["SiteSolarPanelVisualSuspense", variables],
    queryFn: publicFetcher<
      SiteSolarPanelVisualQuery,
      SiteSolarPanelVisualQueryVariables
    >(SiteSolarPanelVisualDocument, variables),
    ...options,
  })
}

useSuspenseSiteSolarPanelVisualQuery.getKey = (
  variables: SiteSolarPanelVisualQueryVariables,
) => ["SiteSolarPanelVisualSuspense", variables]

useSuspenseSiteSolarPanelVisualQuery.rootKey = "SiteSolarPanelVisual"

export const useInfiniteSiteSolarPanelVisualQuery = <
  TData = InfiniteData<SiteSolarPanelVisualQuery>,
  TError = unknown,
>(
  variables: SiteSolarPanelVisualQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteSolarPanelVisualQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteSolarPanelVisualQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteSolarPanelVisualQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteSolarPanelVisual.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteSolarPanelVisualQuery, SiteSolarPanelVisualQueryVariables>(
            SiteSolarPanelVisualDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteSolarPanelVisualQuery.getKey = (
  variables: SiteSolarPanelVisualQueryVariables,
) => ["SiteSolarPanelVisual.infinite", variables]

useInfiniteSiteSolarPanelVisualQuery.rootKey = "SiteSolarPanelVisual.infinite"

export const useSuspenseInfiniteSiteSolarPanelVisualQuery = <
  TData = InfiniteData<SiteSolarPanelVisualQuery>,
  TError = unknown,
>(
  variables: SiteSolarPanelVisualQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteSolarPanelVisualQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteSolarPanelVisualQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteSolarPanelVisualQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "SiteSolarPanelVisual.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<SiteSolarPanelVisualQuery, SiteSolarPanelVisualQueryVariables>(
            SiteSolarPanelVisualDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteSolarPanelVisualQuery.getKey = (
  variables: SiteSolarPanelVisualQueryVariables,
) => ["SiteSolarPanelVisual.infiniteSuspense", variables]

useSuspenseInfiniteSiteSolarPanelVisualQuery.rootKey = "SiteSolarPanelVisual.infinite"

useSiteSolarPanelVisualQuery.fetcher = (
  variables: SiteSolarPanelVisualQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteSolarPanelVisualQuery, SiteSolarPanelVisualQueryVariables>(
    SiteSolarPanelVisualDocument,
    variables,
    options,
  )

export const CsvImportsListDocument = `
    query CsvImportsList($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    csvImports {
      all {
        pid
        fileName
        createdAt
        createdBy {
          email
        }
        portfolio {
          pid
          title
        }
        rowStats {
          total
          imported
        }
      }
    }
  }
}
    `

export const useCsvImportsListQuery = <TData = CsvImportsListQuery, TError = unknown>(
  variables: CsvImportsListQueryVariables,
  options?: Omit<UseQueryOptions<CsvImportsListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CsvImportsListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CsvImportsListQuery, TError, TData>({
    queryKey: ["CsvImportsList", variables],
    queryFn: publicFetcher<CsvImportsListQuery, CsvImportsListQueryVariables>(
      CsvImportsListDocument,
      variables,
    ),
    ...options,
  })
}

useCsvImportsListQuery.getKey = (variables: CsvImportsListQueryVariables) => [
  "CsvImportsList",
  variables,
]

useCsvImportsListQuery.rootKey = "CsvImportsList"

export const useSuspenseCsvImportsListQuery = <
  TData = CsvImportsListQuery,
  TError = unknown,
>(
  variables: CsvImportsListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CsvImportsListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CsvImportsListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CsvImportsListQuery, TError, TData>({
    queryKey: ["CsvImportsListSuspense", variables],
    queryFn: publicFetcher<CsvImportsListQuery, CsvImportsListQueryVariables>(
      CsvImportsListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCsvImportsListQuery.getKey = (variables: CsvImportsListQueryVariables) => [
  "CsvImportsListSuspense",
  variables,
]

useSuspenseCsvImportsListQuery.rootKey = "CsvImportsList"

export const useInfiniteCsvImportsListQuery = <
  TData = InfiniteData<CsvImportsListQuery>,
  TError = unknown,
>(
  variables: CsvImportsListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CsvImportsListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CsvImportsListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CsvImportsListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CsvImportsList.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CsvImportsListQuery, CsvImportsListQueryVariables>(
            CsvImportsListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCsvImportsListQuery.getKey = (variables: CsvImportsListQueryVariables) => [
  "CsvImportsList.infinite",
  variables,
]

useInfiniteCsvImportsListQuery.rootKey = "CsvImportsList.infinite"

export const useSuspenseInfiniteCsvImportsListQuery = <
  TData = InfiniteData<CsvImportsListQuery>,
  TError = unknown,
>(
  variables: CsvImportsListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CsvImportsListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CsvImportsListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CsvImportsListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CsvImportsList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<CsvImportsListQuery, CsvImportsListQueryVariables>(
            CsvImportsListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCsvImportsListQuery.getKey = (
  variables: CsvImportsListQueryVariables,
) => ["CsvImportsList.infiniteSuspense", variables]

useSuspenseInfiniteCsvImportsListQuery.rootKey = "CsvImportsList.infinite"

useCsvImportsListQuery.fetcher = (
  variables: CsvImportsListQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CsvImportsListQuery, CsvImportsListQueryVariables>(
    CsvImportsListDocument,
    variables,
    options,
  )

export const SiteEvDocument = `
    query SiteEV($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    site(pid: $sitePid) {
      evCalc {
        ...BasicEVCalc
      }
      fullAddress
      yearBuilt
      numParkingSpaces
      buildingClass
      numUnitsTotal
    }
  }
}
    ${BasicEvCalcFragmentDoc}`

export const useSiteEvQuery = <TData = SiteEvQuery, TError = unknown>(
  variables: SiteEvQueryVariables,
  options?: Omit<UseQueryOptions<SiteEvQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteEvQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteEvQuery, TError, TData>({
    queryKey: ["SiteEV", variables],
    queryFn: publicFetcher<SiteEvQuery, SiteEvQueryVariables>(
      SiteEvDocument,
      variables,
    ),
    ...options,
  })
}

useSiteEvQuery.getKey = (variables: SiteEvQueryVariables) => ["SiteEV", variables]

useSiteEvQuery.rootKey = "SiteEV"

export const useSuspenseSiteEvQuery = <TData = SiteEvQuery, TError = unknown>(
  variables: SiteEvQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<SiteEvQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<SiteEvQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteEvQuery, TError, TData>({
    queryKey: ["SiteEVSuspense", variables],
    queryFn: publicFetcher<SiteEvQuery, SiteEvQueryVariables>(
      SiteEvDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteEvQuery.getKey = (variables: SiteEvQueryVariables) => [
  "SiteEVSuspense",
  variables,
]

useSuspenseSiteEvQuery.rootKey = "SiteEV"

export const useInfiniteSiteEvQuery = <
  TData = InfiniteData<SiteEvQuery>,
  TError = unknown,
>(
  variables: SiteEvQueryVariables,
  options: Omit<UseInfiniteQueryOptions<SiteEvQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<SiteEvQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteEvQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteEV.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteEvQuery, SiteEvQueryVariables>(SiteEvDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteEvQuery.getKey = (variables: SiteEvQueryVariables) => [
  "SiteEV.infinite",
  variables,
]

useInfiniteSiteEvQuery.rootKey = "SiteEV.infinite"

export const useSuspenseInfiniteSiteEvQuery = <
  TData = InfiniteData<SiteEvQuery>,
  TError = unknown,
>(
  variables: SiteEvQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteEvQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<SiteEvQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteEvQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteEV.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteEvQuery, SiteEvQueryVariables>(SiteEvDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteEvQuery.getKey = (variables: SiteEvQueryVariables) => [
  "SiteEV.infiniteSuspense",
  variables,
]

useSuspenseInfiniteSiteEvQuery.rootKey = "SiteEV.infinite"

useSiteEvQuery.fetcher = (
  variables: SiteEvQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteEvQuery, SiteEvQueryVariables>(SiteEvDocument, variables, options)

export const SiteEvIncentivesDocument = `
    query SiteEvIncentives($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $sitePid) {
      evCalc {
        incentives {
          programName
          state
          url
          eligibleAreas
          incentiveAmount
          programConstraints
          incentiveCap
          calculation
        }
      }
    }
  }
}
    `

export const useSiteEvIncentivesQuery = <
  TData = SiteEvIncentivesQuery,
  TError = unknown,
>(
  variables: SiteEvIncentivesQueryVariables,
  options?: Omit<UseQueryOptions<SiteEvIncentivesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteEvIncentivesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteEvIncentivesQuery, TError, TData>({
    queryKey: ["SiteEvIncentives", variables],
    queryFn: publicFetcher<SiteEvIncentivesQuery, SiteEvIncentivesQueryVariables>(
      SiteEvIncentivesDocument,
      variables,
    ),
    ...options,
  })
}

useSiteEvIncentivesQuery.getKey = (variables: SiteEvIncentivesQueryVariables) => [
  "SiteEvIncentives",
  variables,
]

useSiteEvIncentivesQuery.rootKey = "SiteEvIncentives"

export const useSuspenseSiteEvIncentivesQuery = <
  TData = SiteEvIncentivesQuery,
  TError = unknown,
>(
  variables: SiteEvIncentivesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteEvIncentivesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<SiteEvIncentivesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteEvIncentivesQuery, TError, TData>({
    queryKey: ["SiteEvIncentivesSuspense", variables],
    queryFn: publicFetcher<SiteEvIncentivesQuery, SiteEvIncentivesQueryVariables>(
      SiteEvIncentivesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteEvIncentivesQuery.getKey = (
  variables: SiteEvIncentivesQueryVariables,
) => ["SiteEvIncentivesSuspense", variables]

useSuspenseSiteEvIncentivesQuery.rootKey = "SiteEvIncentives"

export const useInfiniteSiteEvIncentivesQuery = <
  TData = InfiniteData<SiteEvIncentivesQuery>,
  TError = unknown,
>(
  variables: SiteEvIncentivesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteEvIncentivesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<SiteEvIncentivesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteEvIncentivesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteEvIncentives.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteEvIncentivesQuery, SiteEvIncentivesQueryVariables>(
            SiteEvIncentivesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteEvIncentivesQuery.getKey = (
  variables: SiteEvIncentivesQueryVariables,
) => ["SiteEvIncentives.infinite", variables]

useInfiniteSiteEvIncentivesQuery.rootKey = "SiteEvIncentives.infinite"

export const useSuspenseInfiniteSiteEvIncentivesQuery = <
  TData = InfiniteData<SiteEvIncentivesQuery>,
  TError = unknown,
>(
  variables: SiteEvIncentivesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteEvIncentivesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteEvIncentivesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteEvIncentivesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteEvIncentives.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteEvIncentivesQuery, SiteEvIncentivesQueryVariables>(
            SiteEvIncentivesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteEvIncentivesQuery.getKey = (
  variables: SiteEvIncentivesQueryVariables,
) => ["SiteEvIncentives.infiniteSuspense", variables]

useSuspenseInfiniteSiteEvIncentivesQuery.rootKey = "SiteEvIncentives.infinite"

useSiteEvIncentivesQuery.fetcher = (
  variables: SiteEvIncentivesQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteEvIncentivesQuery, SiteEvIncentivesQueryVariables>(
    SiteEvIncentivesDocument,
    variables,
    options,
  )

export const SiteRecalculatingDocument = `
    query SiteRecalculating($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $sitePid) {
      isRecalculating
    }
  }
}
    `

export const useSiteRecalculatingQuery = <
  TData = SiteRecalculatingQuery,
  TError = unknown,
>(
  variables: SiteRecalculatingQueryVariables,
  options?: Omit<UseQueryOptions<SiteRecalculatingQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteRecalculatingQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteRecalculatingQuery, TError, TData>({
    queryKey: ["SiteRecalculating", variables],
    queryFn: publicFetcher<SiteRecalculatingQuery, SiteRecalculatingQueryVariables>(
      SiteRecalculatingDocument,
      variables,
    ),
    ...options,
  })
}

useSiteRecalculatingQuery.getKey = (variables: SiteRecalculatingQueryVariables) => [
  "SiteRecalculating",
  variables,
]

useSiteRecalculatingQuery.rootKey = "SiteRecalculating"

export const useSuspenseSiteRecalculatingQuery = <
  TData = SiteRecalculatingQuery,
  TError = unknown,
>(
  variables: SiteRecalculatingQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteRecalculatingQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteRecalculatingQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteRecalculatingQuery, TError, TData>({
    queryKey: ["SiteRecalculatingSuspense", variables],
    queryFn: publicFetcher<SiteRecalculatingQuery, SiteRecalculatingQueryVariables>(
      SiteRecalculatingDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteRecalculatingQuery.getKey = (
  variables: SiteRecalculatingQueryVariables,
) => ["SiteRecalculatingSuspense", variables]

useSuspenseSiteRecalculatingQuery.rootKey = "SiteRecalculating"

export const useInfiniteSiteRecalculatingQuery = <
  TData = InfiniteData<SiteRecalculatingQuery>,
  TError = unknown,
>(
  variables: SiteRecalculatingQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteRecalculatingQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteRecalculatingQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteRecalculatingQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteRecalculating.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteRecalculatingQuery, SiteRecalculatingQueryVariables>(
            SiteRecalculatingDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteRecalculatingQuery.getKey = (
  variables: SiteRecalculatingQueryVariables,
) => ["SiteRecalculating.infinite", variables]

useInfiniteSiteRecalculatingQuery.rootKey = "SiteRecalculating.infinite"

export const useSuspenseInfiniteSiteRecalculatingQuery = <
  TData = InfiniteData<SiteRecalculatingQuery>,
  TError = unknown,
>(
  variables: SiteRecalculatingQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteRecalculatingQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteRecalculatingQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteRecalculatingQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteRecalculating.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteRecalculatingQuery, SiteRecalculatingQueryVariables>(
            SiteRecalculatingDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteRecalculatingQuery.getKey = (
  variables: SiteRecalculatingQueryVariables,
) => ["SiteRecalculating.infiniteSuspense", variables]

useSuspenseInfiniteSiteRecalculatingQuery.rootKey = "SiteRecalculating.infinite"

useSiteRecalculatingQuery.fetcher = (
  variables: SiteRecalculatingQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteRecalculatingQuery, SiteRecalculatingQueryVariables>(
    SiteRecalculatingDocument,
    variables,
    options,
  )

export const ScenarioListDocument = `
    query ScenarioList($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $sitePid) {
      fullAddress
      scenarios {
        name
        pid
        solarLocation
        loadCategory
        includeStorage
      }
    }
  }
}
    `

export const useScenarioListQuery = <TData = ScenarioListQuery, TError = unknown>(
  variables: ScenarioListQueryVariables,
  options?: Omit<UseQueryOptions<ScenarioListQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ScenarioListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ScenarioListQuery, TError, TData>({
    queryKey: ["ScenarioList", variables],
    queryFn: publicFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
      ScenarioListDocument,
      variables,
    ),
    ...options,
  })
}

useScenarioListQuery.getKey = (variables: ScenarioListQueryVariables) => [
  "ScenarioList",
  variables,
]

useScenarioListQuery.rootKey = "ScenarioList"

export const useSuspenseScenarioListQuery = <
  TData = ScenarioListQuery,
  TError = unknown,
>(
  variables: ScenarioListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ScenarioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ScenarioListQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ScenarioListQuery, TError, TData>({
    queryKey: ["ScenarioListSuspense", variables],
    queryFn: publicFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
      ScenarioListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseScenarioListQuery.getKey = (variables: ScenarioListQueryVariables) => [
  "ScenarioListSuspense",
  variables,
]

useSuspenseScenarioListQuery.rootKey = "ScenarioList"

export const useInfiniteScenarioListQuery = <
  TData = InfiniteData<ScenarioListQuery>,
  TError = unknown,
>(
  variables: ScenarioListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ScenarioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ScenarioListQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ScenarioListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ScenarioList.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
            ScenarioListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteScenarioListQuery.getKey = (variables: ScenarioListQueryVariables) => [
  "ScenarioList.infinite",
  variables,
]

useInfiniteScenarioListQuery.rootKey = "ScenarioList.infinite"

export const useSuspenseInfiniteScenarioListQuery = <
  TData = InfiniteData<ScenarioListQuery>,
  TError = unknown,
>(
  variables: ScenarioListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ScenarioListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ScenarioListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ScenarioListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ScenarioList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
            ScenarioListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteScenarioListQuery.getKey = (
  variables: ScenarioListQueryVariables,
) => ["ScenarioList.infiniteSuspense", variables]

useSuspenseInfiniteScenarioListQuery.rootKey = "ScenarioList.infinite"

useScenarioListQuery.fetcher = (
  variables: ScenarioListQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ScenarioListQuery, ScenarioListQueryVariables>(
    ScenarioListDocument,
    variables,
    options,
  )

export const SiteFromPortfolioBuildingDataDocument = `
    query SiteFromPortfolioBuildingData($orgSlug: String!, $portfolioPid: String!, $buildingDataId: Int!) {
  orgBySlug(slug: $orgSlug) {
    siteFromPortfolioBuildingData(
      portfolioPid: $portfolioPid
      buildingDataId: $buildingDataId
    ) {
      __typename
      ... on SiteRef {
        pid
      }
    }
  }
}
    `

export const useSiteFromPortfolioBuildingDataQuery = <
  TData = SiteFromPortfolioBuildingDataQuery,
  TError = unknown,
>(
  variables: SiteFromPortfolioBuildingDataQueryVariables,
  options?: Omit<
    UseQueryOptions<SiteFromPortfolioBuildingDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      SiteFromPortfolioBuildingDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<SiteFromPortfolioBuildingDataQuery, TError, TData>({
    queryKey: ["SiteFromPortfolioBuildingData", variables],
    queryFn: publicFetcher<
      SiteFromPortfolioBuildingDataQuery,
      SiteFromPortfolioBuildingDataQueryVariables
    >(SiteFromPortfolioBuildingDataDocument, variables),
    ...options,
  })
}

useSiteFromPortfolioBuildingDataQuery.getKey = (
  variables: SiteFromPortfolioBuildingDataQueryVariables,
) => ["SiteFromPortfolioBuildingData", variables]

useSiteFromPortfolioBuildingDataQuery.rootKey = "SiteFromPortfolioBuildingData"

export const useSuspenseSiteFromPortfolioBuildingDataQuery = <
  TData = SiteFromPortfolioBuildingDataQuery,
  TError = unknown,
>(
  variables: SiteFromPortfolioBuildingDataQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteFromPortfolioBuildingDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteFromPortfolioBuildingDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteFromPortfolioBuildingDataQuery, TError, TData>({
    queryKey: ["SiteFromPortfolioBuildingDataSuspense", variables],
    queryFn: publicFetcher<
      SiteFromPortfolioBuildingDataQuery,
      SiteFromPortfolioBuildingDataQueryVariables
    >(SiteFromPortfolioBuildingDataDocument, variables),
    ...options,
  })
}

useSuspenseSiteFromPortfolioBuildingDataQuery.getKey = (
  variables: SiteFromPortfolioBuildingDataQueryVariables,
) => ["SiteFromPortfolioBuildingDataSuspense", variables]

useSuspenseSiteFromPortfolioBuildingDataQuery.rootKey = "SiteFromPortfolioBuildingData"

export const useInfiniteSiteFromPortfolioBuildingDataQuery = <
  TData = InfiniteData<SiteFromPortfolioBuildingDataQuery>,
  TError = unknown,
>(
  variables: SiteFromPortfolioBuildingDataQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteFromPortfolioBuildingDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteFromPortfolioBuildingDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteFromPortfolioBuildingDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "SiteFromPortfolioBuildingData.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            SiteFromPortfolioBuildingDataQuery,
            SiteFromPortfolioBuildingDataQueryVariables
          >(SiteFromPortfolioBuildingDataDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteFromPortfolioBuildingDataQuery.getKey = (
  variables: SiteFromPortfolioBuildingDataQueryVariables,
) => ["SiteFromPortfolioBuildingData.infinite", variables]

useInfiniteSiteFromPortfolioBuildingDataQuery.rootKey =
  "SiteFromPortfolioBuildingData.infinite"

export const useSuspenseInfiniteSiteFromPortfolioBuildingDataQuery = <
  TData = InfiniteData<SiteFromPortfolioBuildingDataQuery>,
  TError = unknown,
>(
  variables: SiteFromPortfolioBuildingDataQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteFromPortfolioBuildingDataQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteFromPortfolioBuildingDataQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteFromPortfolioBuildingDataQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "SiteFromPortfolioBuildingData.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            SiteFromPortfolioBuildingDataQuery,
            SiteFromPortfolioBuildingDataQueryVariables
          >(SiteFromPortfolioBuildingDataDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteFromPortfolioBuildingDataQuery.getKey = (
  variables: SiteFromPortfolioBuildingDataQueryVariables,
) => ["SiteFromPortfolioBuildingData.infiniteSuspense", variables]

useSuspenseInfiniteSiteFromPortfolioBuildingDataQuery.rootKey =
  "SiteFromPortfolioBuildingData.infinite"

useSiteFromPortfolioBuildingDataQuery.fetcher = (
  variables: SiteFromPortfolioBuildingDataQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    SiteFromPortfolioBuildingDataQuery,
    SiteFromPortfolioBuildingDataQueryVariables
  >(SiteFromPortfolioBuildingDataDocument, variables, options)

export const UtilityTariffsDocument = `
    query UtilityTariffs($utilityPid: String!) {
  tariffs2(utilityPid: $utilityPid) {
    ...PublicTariff
  }
}
    ${PublicTariffFragmentDoc}`

export const useUtilityTariffsQuery = <TData = UtilityTariffsQuery, TError = unknown>(
  variables: UtilityTariffsQueryVariables,
  options?: Omit<UseQueryOptions<UtilityTariffsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<UtilityTariffsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<UtilityTariffsQuery, TError, TData>({
    queryKey: ["UtilityTariffs", variables],
    queryFn: publicFetcher<UtilityTariffsQuery, UtilityTariffsQueryVariables>(
      UtilityTariffsDocument,
      variables,
    ),
    ...options,
  })
}

useUtilityTariffsQuery.getKey = (variables: UtilityTariffsQueryVariables) => [
  "UtilityTariffs",
  variables,
]

useUtilityTariffsQuery.rootKey = "UtilityTariffs"

export const useSuspenseUtilityTariffsQuery = <
  TData = UtilityTariffsQuery,
  TError = unknown,
>(
  variables: UtilityTariffsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<UtilityTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<UtilityTariffsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<UtilityTariffsQuery, TError, TData>({
    queryKey: ["UtilityTariffsSuspense", variables],
    queryFn: publicFetcher<UtilityTariffsQuery, UtilityTariffsQueryVariables>(
      UtilityTariffsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseUtilityTariffsQuery.getKey = (variables: UtilityTariffsQueryVariables) => [
  "UtilityTariffsSuspense",
  variables,
]

useSuspenseUtilityTariffsQuery.rootKey = "UtilityTariffs"

export const useInfiniteUtilityTariffsQuery = <
  TData = InfiniteData<UtilityTariffsQuery>,
  TError = unknown,
>(
  variables: UtilityTariffsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<UtilityTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<UtilityTariffsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<UtilityTariffsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["UtilityTariffs.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<UtilityTariffsQuery, UtilityTariffsQueryVariables>(
            UtilityTariffsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteUtilityTariffsQuery.getKey = (variables: UtilityTariffsQueryVariables) => [
  "UtilityTariffs.infinite",
  variables,
]

useInfiniteUtilityTariffsQuery.rootKey = "UtilityTariffs.infinite"

export const useSuspenseInfiniteUtilityTariffsQuery = <
  TData = InfiniteData<UtilityTariffsQuery>,
  TError = unknown,
>(
  variables: UtilityTariffsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<UtilityTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      UtilityTariffsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<UtilityTariffsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["UtilityTariffs.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<UtilityTariffsQuery, UtilityTariffsQueryVariables>(
            UtilityTariffsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteUtilityTariffsQuery.getKey = (
  variables: UtilityTariffsQueryVariables,
) => ["UtilityTariffs.infiniteSuspense", variables]

useSuspenseInfiniteUtilityTariffsQuery.rootKey = "UtilityTariffs.infinite"

useUtilityTariffsQuery.fetcher = (
  variables: UtilityTariffsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<UtilityTariffsQuery, UtilityTariffsQueryVariables>(
    UtilityTariffsDocument,
    variables,
    options,
  )

export const CustomTariffsDocument = `
    query CustomTariffs($sitePid: String!, $utilityPid: String!) {
  customTariffs(sitePid: $sitePid, utilityPid: $utilityPid) {
    ...PublicTariff
  }
}
    ${PublicTariffFragmentDoc}`

export const useCustomTariffsQuery = <TData = CustomTariffsQuery, TError = unknown>(
  variables: CustomTariffsQueryVariables,
  options?: Omit<UseQueryOptions<CustomTariffsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CustomTariffsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CustomTariffsQuery, TError, TData>({
    queryKey: ["CustomTariffs", variables],
    queryFn: publicFetcher<CustomTariffsQuery, CustomTariffsQueryVariables>(
      CustomTariffsDocument,
      variables,
    ),
    ...options,
  })
}

useCustomTariffsQuery.getKey = (variables: CustomTariffsQueryVariables) => [
  "CustomTariffs",
  variables,
]

useCustomTariffsQuery.rootKey = "CustomTariffs"

export const useSuspenseCustomTariffsQuery = <
  TData = CustomTariffsQuery,
  TError = unknown,
>(
  variables: CustomTariffsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CustomTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CustomTariffsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CustomTariffsQuery, TError, TData>({
    queryKey: ["CustomTariffsSuspense", variables],
    queryFn: publicFetcher<CustomTariffsQuery, CustomTariffsQueryVariables>(
      CustomTariffsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCustomTariffsQuery.getKey = (variables: CustomTariffsQueryVariables) => [
  "CustomTariffsSuspense",
  variables,
]

useSuspenseCustomTariffsQuery.rootKey = "CustomTariffs"

export const useInfiniteCustomTariffsQuery = <
  TData = InfiniteData<CustomTariffsQuery>,
  TError = unknown,
>(
  variables: CustomTariffsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CustomTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CustomTariffsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CustomTariffsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffs.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffsQuery, CustomTariffsQueryVariables>(
            CustomTariffsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCustomTariffsQuery.getKey = (variables: CustomTariffsQueryVariables) => [
  "CustomTariffs.infinite",
  variables,
]

useInfiniteCustomTariffsQuery.rootKey = "CustomTariffs.infinite"

export const useSuspenseInfiniteCustomTariffsQuery = <
  TData = InfiniteData<CustomTariffsQuery>,
  TError = unknown,
>(
  variables: CustomTariffsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CustomTariffsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CustomTariffsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CustomTariffsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffs.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffsQuery, CustomTariffsQueryVariables>(
            CustomTariffsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCustomTariffsQuery.getKey = (
  variables: CustomTariffsQueryVariables,
) => ["CustomTariffs.infiniteSuspense", variables]

useSuspenseInfiniteCustomTariffsQuery.rootKey = "CustomTariffs.infinite"

useCustomTariffsQuery.fetcher = (
  variables: CustomTariffsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CustomTariffsQuery, CustomTariffsQueryVariables>(
    CustomTariffsDocument,
    variables,
    options,
  )

export const CustomTariffs2Document = `
    query CustomTariffs2($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $sitePid) {
      customTariffs {
        name
        preOpDetails {
          rates {
            ...Rate
          }
        }
        postOpDetails {
          rates {
            ...Rate
          }
        }
      }
    }
  }
}
    ${RateFragmentDoc}
${RateBandFragmentDoc}
${SeasonFragmentDoc}`

export const useCustomTariffs2Query = <TData = CustomTariffs2Query, TError = unknown>(
  variables: CustomTariffs2QueryVariables,
  options?: Omit<UseQueryOptions<CustomTariffs2Query, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CustomTariffs2Query, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CustomTariffs2Query, TError, TData>({
    queryKey: ["CustomTariffs2", variables],
    queryFn: publicFetcher<CustomTariffs2Query, CustomTariffs2QueryVariables>(
      CustomTariffs2Document,
      variables,
    ),
    ...options,
  })
}

useCustomTariffs2Query.getKey = (variables: CustomTariffs2QueryVariables) => [
  "CustomTariffs2",
  variables,
]

useCustomTariffs2Query.rootKey = "CustomTariffs2"

export const useSuspenseCustomTariffs2Query = <
  TData = CustomTariffs2Query,
  TError = unknown,
>(
  variables: CustomTariffs2QueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CustomTariffs2Query, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CustomTariffs2Query, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CustomTariffs2Query, TError, TData>({
    queryKey: ["CustomTariffs2Suspense", variables],
    queryFn: publicFetcher<CustomTariffs2Query, CustomTariffs2QueryVariables>(
      CustomTariffs2Document,
      variables,
    ),
    ...options,
  })
}

useSuspenseCustomTariffs2Query.getKey = (variables: CustomTariffs2QueryVariables) => [
  "CustomTariffs2Suspense",
  variables,
]

useSuspenseCustomTariffs2Query.rootKey = "CustomTariffs2"

export const useInfiniteCustomTariffs2Query = <
  TData = InfiniteData<CustomTariffs2Query>,
  TError = unknown,
>(
  variables: CustomTariffs2QueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CustomTariffs2Query, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CustomTariffs2Query, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CustomTariffs2Query, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffs2.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffs2Query, CustomTariffs2QueryVariables>(
            CustomTariffs2Document,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCustomTariffs2Query.getKey = (variables: CustomTariffs2QueryVariables) => [
  "CustomTariffs2.infinite",
  variables,
]

useInfiniteCustomTariffs2Query.rootKey = "CustomTariffs2.infinite"

export const useSuspenseInfiniteCustomTariffs2Query = <
  TData = InfiniteData<CustomTariffs2Query>,
  TError = unknown,
>(
  variables: CustomTariffs2QueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CustomTariffs2Query, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CustomTariffs2Query,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CustomTariffs2Query, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffs2.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffs2Query, CustomTariffs2QueryVariables>(
            CustomTariffs2Document,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCustomTariffs2Query.getKey = (
  variables: CustomTariffs2QueryVariables,
) => ["CustomTariffs2.infiniteSuspense", variables]

useSuspenseInfiniteCustomTariffs2Query.rootKey = "CustomTariffs2.infinite"

useCustomTariffs2Query.fetcher = (
  variables: CustomTariffs2QueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CustomTariffs2Query, CustomTariffs2QueryVariables>(
    CustomTariffs2Document,
    variables,
    options,
  )

export const CustomTariffDetailDocument = `
    query CustomTariffDetail($orgSlug: String!, $propertyPid: String!, $tariffId: Int!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $propertyPid) {
      customTariff(tariffId: $tariffId) {
        id
        name
        code
        customerClass
        ops {
          ...TariffOp
        }
        preOpDetails {
          allRates {
            ...Rate
          }
          rates {
            ...Rate
          }
        }
        postOpDetails {
          allRates {
            ...Rate
          }
          rates {
            ...Rate
          }
        }
      }
    }
  }
}
    ${TariffOpFragmentDoc}
${CustomRateFragmentDoc}
${RateFragmentDoc}
${RateBandFragmentDoc}
${SeasonFragmentDoc}`

export const useCustomTariffDetailQuery = <
  TData = CustomTariffDetailQuery,
  TError = unknown,
>(
  variables: CustomTariffDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<CustomTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<CustomTariffDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CustomTariffDetailQuery, TError, TData>({
    queryKey: ["CustomTariffDetail", variables],
    queryFn: publicFetcher<CustomTariffDetailQuery, CustomTariffDetailQueryVariables>(
      CustomTariffDetailDocument,
      variables,
    ),
    ...options,
  })
}

useCustomTariffDetailQuery.getKey = (variables: CustomTariffDetailQueryVariables) => [
  "CustomTariffDetail",
  variables,
]

useCustomTariffDetailQuery.rootKey = "CustomTariffDetail"

export const useSuspenseCustomTariffDetailQuery = <
  TData = CustomTariffDetailQuery,
  TError = unknown,
>(
  variables: CustomTariffDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CustomTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CustomTariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<CustomTariffDetailQuery, TError, TData>({
    queryKey: ["CustomTariffDetailSuspense", variables],
    queryFn: publicFetcher<CustomTariffDetailQuery, CustomTariffDetailQueryVariables>(
      CustomTariffDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCustomTariffDetailQuery.getKey = (
  variables: CustomTariffDetailQueryVariables,
) => ["CustomTariffDetailSuspense", variables]

useSuspenseCustomTariffDetailQuery.rootKey = "CustomTariffDetail"

export const useInfiniteCustomTariffDetailQuery = <
  TData = InfiniteData<CustomTariffDetailQuery>,
  TError = unknown,
>(
  variables: CustomTariffDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CustomTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CustomTariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<CustomTariffDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffDetailQuery, CustomTariffDetailQueryVariables>(
            CustomTariffDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCustomTariffDetailQuery.getKey = (
  variables: CustomTariffDetailQueryVariables,
) => ["CustomTariffDetail.infinite", variables]

useInfiniteCustomTariffDetailQuery.rootKey = "CustomTariffDetail.infinite"

export const useSuspenseInfiniteCustomTariffDetailQuery = <
  TData = InfiniteData<CustomTariffDetailQuery>,
  TError = unknown,
>(
  variables: CustomTariffDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CustomTariffDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CustomTariffDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CustomTariffDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffDetailQuery, CustomTariffDetailQueryVariables>(
            CustomTariffDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCustomTariffDetailQuery.getKey = (
  variables: CustomTariffDetailQueryVariables,
) => ["CustomTariffDetail.infiniteSuspense", variables]

useSuspenseInfiniteCustomTariffDetailQuery.rootKey = "CustomTariffDetail.infinite"

useCustomTariffDetailQuery.fetcher = (
  variables: CustomTariffDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CustomTariffDetailQuery, CustomTariffDetailQueryVariables>(
    CustomTariffDetailDocument,
    variables,
    options,
  )

export const CustomTariffPreviewDocument = `
    query CustomTariffPreview($orgSlug: String!, $propertyPid: String!, $tariffId: Int!, $addRateOps: [AddRateInput!]!, $subRateOps: [SubRateInput!]!, $propertyOps: [OverridePropertyInput!]!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $propertyPid) {
      customTariff(tariffId: $tariffId) {
        id
        name
        previewDetails(
          addRateOps: $addRateOps
          subRateOps: $subRateOps
          propertyOps: $propertyOps
        ) {
          allRates {
            ...Rate
          }
          rates {
            ...Rate
          }
          properties {
            keyName
            dataType
            propertyValue
            propertyValues
            formulaDetail
          }
        }
      }
    }
  }
}
    ${RateFragmentDoc}
${RateBandFragmentDoc}
${SeasonFragmentDoc}`

export const useCustomTariffPreviewQuery = <
  TData = CustomTariffPreviewQuery,
  TError = unknown,
>(
  variables: CustomTariffPreviewQueryVariables,
  options?: Omit<
    UseQueryOptions<CustomTariffPreviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<CustomTariffPreviewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CustomTariffPreviewQuery, TError, TData>({
    queryKey: ["CustomTariffPreview", variables],
    queryFn: publicFetcher<CustomTariffPreviewQuery, CustomTariffPreviewQueryVariables>(
      CustomTariffPreviewDocument,
      variables,
    ),
    ...options,
  })
}

useCustomTariffPreviewQuery.getKey = (variables: CustomTariffPreviewQueryVariables) => [
  "CustomTariffPreview",
  variables,
]

useCustomTariffPreviewQuery.rootKey = "CustomTariffPreview"

export const useSuspenseCustomTariffPreviewQuery = <
  TData = CustomTariffPreviewQuery,
  TError = unknown,
>(
  variables: CustomTariffPreviewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CustomTariffPreviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CustomTariffPreviewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<CustomTariffPreviewQuery, TError, TData>({
    queryKey: ["CustomTariffPreviewSuspense", variables],
    queryFn: publicFetcher<CustomTariffPreviewQuery, CustomTariffPreviewQueryVariables>(
      CustomTariffPreviewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCustomTariffPreviewQuery.getKey = (
  variables: CustomTariffPreviewQueryVariables,
) => ["CustomTariffPreviewSuspense", variables]

useSuspenseCustomTariffPreviewQuery.rootKey = "CustomTariffPreview"

export const useInfiniteCustomTariffPreviewQuery = <
  TData = InfiniteData<CustomTariffPreviewQuery>,
  TError = unknown,
>(
  variables: CustomTariffPreviewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CustomTariffPreviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CustomTariffPreviewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<CustomTariffPreviewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffPreview.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffPreviewQuery, CustomTariffPreviewQueryVariables>(
            CustomTariffPreviewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCustomTariffPreviewQuery.getKey = (
  variables: CustomTariffPreviewQueryVariables,
) => ["CustomTariffPreview.infinite", variables]

useInfiniteCustomTariffPreviewQuery.rootKey = "CustomTariffPreview.infinite"

export const useSuspenseInfiniteCustomTariffPreviewQuery = <
  TData = InfiniteData<CustomTariffPreviewQuery>,
  TError = unknown,
>(
  variables: CustomTariffPreviewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CustomTariffPreviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CustomTariffPreviewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CustomTariffPreviewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "CustomTariffPreview.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffPreviewQuery, CustomTariffPreviewQueryVariables>(
            CustomTariffPreviewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCustomTariffPreviewQuery.getKey = (
  variables: CustomTariffPreviewQueryVariables,
) => ["CustomTariffPreview.infiniteSuspense", variables]

useSuspenseInfiniteCustomTariffPreviewQuery.rootKey = "CustomTariffPreview.infinite"

useCustomTariffPreviewQuery.fetcher = (
  variables: CustomTariffPreviewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CustomTariffPreviewQuery, CustomTariffPreviewQueryVariables>(
    CustomTariffPreviewDocument,
    variables,
    options,
  )

export const CustomTariffBillCalcDocument = `
    query CustomTariffBillCalc($propertyPid: String!, $customTariffId: Int!, $bauMeterPid: String!, $addRateOps: [AddRateInput!]!, $subRateOps: [SubRateInput!]!, $propertyOps: [OverridePropertyInput!]!) {
  customTariff(sitePid: $propertyPid, customTariffId: $customTariffId) {
    billCalc(
      bauMeterPid: $bauMeterPid
      addRateOps: $addRateOps
      subRateOps: $subRateOps
      propertyOps: $propertyOps
    ) {
      start
      end
      summary {
        chargeType
        costUsd
      }
      details {
        group
        items {
          cost
          usage
          name
          rate
          unit
        }
      }
    }
  }
}
    `

export const useCustomTariffBillCalcQuery = <
  TData = CustomTariffBillCalcQuery,
  TError = unknown,
>(
  variables: CustomTariffBillCalcQueryVariables,
  options?: Omit<
    UseQueryOptions<CustomTariffBillCalcQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<CustomTariffBillCalcQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CustomTariffBillCalcQuery, TError, TData>({
    queryKey: ["CustomTariffBillCalc", variables],
    queryFn: publicFetcher<
      CustomTariffBillCalcQuery,
      CustomTariffBillCalcQueryVariables
    >(CustomTariffBillCalcDocument, variables),
    ...options,
  })
}

useCustomTariffBillCalcQuery.getKey = (
  variables: CustomTariffBillCalcQueryVariables,
) => ["CustomTariffBillCalc", variables]

useCustomTariffBillCalcQuery.rootKey = "CustomTariffBillCalc"

export const useSuspenseCustomTariffBillCalcQuery = <
  TData = CustomTariffBillCalcQuery,
  TError = unknown,
>(
  variables: CustomTariffBillCalcQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CustomTariffBillCalcQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CustomTariffBillCalcQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<CustomTariffBillCalcQuery, TError, TData>({
    queryKey: ["CustomTariffBillCalcSuspense", variables],
    queryFn: publicFetcher<
      CustomTariffBillCalcQuery,
      CustomTariffBillCalcQueryVariables
    >(CustomTariffBillCalcDocument, variables),
    ...options,
  })
}

useSuspenseCustomTariffBillCalcQuery.getKey = (
  variables: CustomTariffBillCalcQueryVariables,
) => ["CustomTariffBillCalcSuspense", variables]

useSuspenseCustomTariffBillCalcQuery.rootKey = "CustomTariffBillCalc"

export const useInfiniteCustomTariffBillCalcQuery = <
  TData = InfiniteData<CustomTariffBillCalcQuery>,
  TError = unknown,
>(
  variables: CustomTariffBillCalcQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CustomTariffBillCalcQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CustomTariffBillCalcQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<CustomTariffBillCalcQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CustomTariffBillCalc.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffBillCalcQuery, CustomTariffBillCalcQueryVariables>(
            CustomTariffBillCalcDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCustomTariffBillCalcQuery.getKey = (
  variables: CustomTariffBillCalcQueryVariables,
) => ["CustomTariffBillCalc.infinite", variables]

useInfiniteCustomTariffBillCalcQuery.rootKey = "CustomTariffBillCalc.infinite"

export const useSuspenseInfiniteCustomTariffBillCalcQuery = <
  TData = InfiniteData<CustomTariffBillCalcQuery>,
  TError = unknown,
>(
  variables: CustomTariffBillCalcQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CustomTariffBillCalcQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CustomTariffBillCalcQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CustomTariffBillCalcQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "CustomTariffBillCalc.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<CustomTariffBillCalcQuery, CustomTariffBillCalcQueryVariables>(
            CustomTariffBillCalcDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCustomTariffBillCalcQuery.getKey = (
  variables: CustomTariffBillCalcQueryVariables,
) => ["CustomTariffBillCalc.infiniteSuspense", variables]

useSuspenseInfiniteCustomTariffBillCalcQuery.rootKey = "CustomTariffBillCalc.infinite"

useCustomTariffBillCalcQuery.fetcher = (
  variables: CustomTariffBillCalcQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CustomTariffBillCalcQuery, CustomTariffBillCalcQueryVariables>(
    CustomTariffBillCalcDocument,
    variables,
    options,
  )

export const BundleParentsDocument = `
    query BundleParents($orgSlug: String!) {
  bundleParents(orgSlug: $orgSlug) {
    ...BasicBundleParent
  }
}
    ${BasicBundleParentFragmentDoc}
${UserRefFragmentDoc}`

export const useBundleParentsQuery = <TData = BundleParentsQuery, TError = unknown>(
  variables: BundleParentsQueryVariables,
  options?: Omit<UseQueryOptions<BundleParentsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<BundleParentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BundleParentsQuery, TError, TData>({
    queryKey: ["BundleParents", variables],
    queryFn: publicFetcher<BundleParentsQuery, BundleParentsQueryVariables>(
      BundleParentsDocument,
      variables,
    ),
    ...options,
  })
}

useBundleParentsQuery.getKey = (variables: BundleParentsQueryVariables) => [
  "BundleParents",
  variables,
]

useBundleParentsQuery.rootKey = "BundleParents"

export const useSuspenseBundleParentsQuery = <
  TData = BundleParentsQuery,
  TError = unknown,
>(
  variables: BundleParentsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BundleParentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<BundleParentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<BundleParentsQuery, TError, TData>({
    queryKey: ["BundleParentsSuspense", variables],
    queryFn: publicFetcher<BundleParentsQuery, BundleParentsQueryVariables>(
      BundleParentsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBundleParentsQuery.getKey = (variables: BundleParentsQueryVariables) => [
  "BundleParentsSuspense",
  variables,
]

useSuspenseBundleParentsQuery.rootKey = "BundleParents"

export const useInfiniteBundleParentsQuery = <
  TData = InfiniteData<BundleParentsQuery>,
  TError = unknown,
>(
  variables: BundleParentsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BundleParentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<BundleParentsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<BundleParentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BundleParents.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<BundleParentsQuery, BundleParentsQueryVariables>(
            BundleParentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBundleParentsQuery.getKey = (variables: BundleParentsQueryVariables) => [
  "BundleParents.infinite",
  variables,
]

useInfiniteBundleParentsQuery.rootKey = "BundleParents.infinite"

export const useSuspenseInfiniteBundleParentsQuery = <
  TData = InfiniteData<BundleParentsQuery>,
  TError = unknown,
>(
  variables: BundleParentsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BundleParentsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BundleParentsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BundleParentsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BundleParents.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<BundleParentsQuery, BundleParentsQueryVariables>(
            BundleParentsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBundleParentsQuery.getKey = (
  variables: BundleParentsQueryVariables,
) => ["BundleParents.infiniteSuspense", variables]

useSuspenseInfiniteBundleParentsQuery.rootKey = "BundleParents.infinite"

useBundleParentsQuery.fetcher = (
  variables: BundleParentsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleParentsQuery, BundleParentsQueryVariables>(
    BundleParentsDocument,
    variables,
    options,
  )

export const BundleParentDetailDocument = `
    query BundleParentDetail($orgSlug: String!, $pid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $pid) {
    ...BundleParent
    bundles {
      ...BundleListItem
      rows {
        ...BundleRowDetail
      }
    }
  }
}
    ${BundleParentFragmentDoc}
${BasicBundleParentFragmentDoc}
${UserRefFragmentDoc}
${BidSpecFragmentDoc}
${PpaBidSpecFragmentDoc}
${SystemFragmentDoc}
${PvSystemSpecFragmentDoc}
${CsBidSpecFragmentDoc}
${SystemLiteFragmentDoc}
${InvestorBidSpecOptOutFragmentDoc}
${BundleListItemFragmentDoc}
${InvestorOptOutFragmentDoc}
${BundleRowDetailFragmentDoc}
${BundleDetailRowFragmentDoc}
${InvestorBidFragmentDoc}
${PpaInvestorBidFragmentDoc}
${InvestorProfileFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${CsInvestorBidFragmentDoc}
${RevampCsFragmentDoc}
${RevampSiteBasicsFragmentDoc}
${SiteConfigFragmentDoc}
${FootprintFragmentDoc}
${BillingMeterOptionFragmentDoc}`

export const useBundleParentDetailQuery = <
  TData = BundleParentDetailQuery,
  TError = unknown,
>(
  variables: BundleParentDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<BundleParentDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<BundleParentDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BundleParentDetailQuery, TError, TData>({
    queryKey: ["BundleParentDetail", variables],
    queryFn: publicFetcher<BundleParentDetailQuery, BundleParentDetailQueryVariables>(
      BundleParentDetailDocument,
      variables,
    ),
    ...options,
  })
}

useBundleParentDetailQuery.getKey = (variables: BundleParentDetailQueryVariables) => [
  "BundleParentDetail",
  variables,
]

useBundleParentDetailQuery.rootKey = "BundleParentDetail"

export const useSuspenseBundleParentDetailQuery = <
  TData = BundleParentDetailQuery,
  TError = unknown,
>(
  variables: BundleParentDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BundleParentDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BundleParentDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BundleParentDetailQuery, TError, TData>({
    queryKey: ["BundleParentDetailSuspense", variables],
    queryFn: publicFetcher<BundleParentDetailQuery, BundleParentDetailQueryVariables>(
      BundleParentDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBundleParentDetailQuery.getKey = (
  variables: BundleParentDetailQueryVariables,
) => ["BundleParentDetailSuspense", variables]

useSuspenseBundleParentDetailQuery.rootKey = "BundleParentDetail"

export const useInfiniteBundleParentDetailQuery = <
  TData = InfiniteData<BundleParentDetailQuery>,
  TError = unknown,
>(
  variables: BundleParentDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BundleParentDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BundleParentDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BundleParentDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BundleParentDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<BundleParentDetailQuery, BundleParentDetailQueryVariables>(
            BundleParentDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBundleParentDetailQuery.getKey = (
  variables: BundleParentDetailQueryVariables,
) => ["BundleParentDetail.infinite", variables]

useInfiniteBundleParentDetailQuery.rootKey = "BundleParentDetail.infinite"

export const useSuspenseInfiniteBundleParentDetailQuery = <
  TData = InfiniteData<BundleParentDetailQuery>,
  TError = unknown,
>(
  variables: BundleParentDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BundleParentDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BundleParentDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BundleParentDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BundleParentDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<BundleParentDetailQuery, BundleParentDetailQueryVariables>(
            BundleParentDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBundleParentDetailQuery.getKey = (
  variables: BundleParentDetailQueryVariables,
) => ["BundleParentDetail.infiniteSuspense", variables]

useSuspenseInfiniteBundleParentDetailQuery.rootKey = "BundleParentDetail.infinite"

useBundleParentDetailQuery.fetcher = (
  variables: BundleParentDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleParentDetailQuery, BundleParentDetailQueryVariables>(
    BundleParentDetailDocument,
    variables,
    options,
  )

export const BundleParentReportsDocument = `
    query BundleParentReports($orgSlug: String!, $pid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $pid) {
    pid
    type
    customReports {
      ...CustomBidReport
    }
  }
}
    ${CustomBidReportFragmentDoc}`

export const useBundleParentReportsQuery = <
  TData = BundleParentReportsQuery,
  TError = unknown,
>(
  variables: BundleParentReportsQueryVariables,
  options?: Omit<
    UseQueryOptions<BundleParentReportsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<BundleParentReportsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BundleParentReportsQuery, TError, TData>({
    queryKey: ["BundleParentReports", variables],
    queryFn: publicFetcher<BundleParentReportsQuery, BundleParentReportsQueryVariables>(
      BundleParentReportsDocument,
      variables,
    ),
    ...options,
  })
}

useBundleParentReportsQuery.getKey = (variables: BundleParentReportsQueryVariables) => [
  "BundleParentReports",
  variables,
]

useBundleParentReportsQuery.rootKey = "BundleParentReports"

export const useSuspenseBundleParentReportsQuery = <
  TData = BundleParentReportsQuery,
  TError = unknown,
>(
  variables: BundleParentReportsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BundleParentReportsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BundleParentReportsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BundleParentReportsQuery, TError, TData>({
    queryKey: ["BundleParentReportsSuspense", variables],
    queryFn: publicFetcher<BundleParentReportsQuery, BundleParentReportsQueryVariables>(
      BundleParentReportsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBundleParentReportsQuery.getKey = (
  variables: BundleParentReportsQueryVariables,
) => ["BundleParentReportsSuspense", variables]

useSuspenseBundleParentReportsQuery.rootKey = "BundleParentReports"

export const useInfiniteBundleParentReportsQuery = <
  TData = InfiniteData<BundleParentReportsQuery>,
  TError = unknown,
>(
  variables: BundleParentReportsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BundleParentReportsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BundleParentReportsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BundleParentReportsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BundleParentReports.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<BundleParentReportsQuery, BundleParentReportsQueryVariables>(
            BundleParentReportsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBundleParentReportsQuery.getKey = (
  variables: BundleParentReportsQueryVariables,
) => ["BundleParentReports.infinite", variables]

useInfiniteBundleParentReportsQuery.rootKey = "BundleParentReports.infinite"

export const useSuspenseInfiniteBundleParentReportsQuery = <
  TData = InfiniteData<BundleParentReportsQuery>,
  TError = unknown,
>(
  variables: BundleParentReportsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BundleParentReportsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BundleParentReportsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BundleParentReportsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "BundleParentReports.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<BundleParentReportsQuery, BundleParentReportsQueryVariables>(
            BundleParentReportsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBundleParentReportsQuery.getKey = (
  variables: BundleParentReportsQueryVariables,
) => ["BundleParentReports.infiniteSuspense", variables]

useSuspenseInfiniteBundleParentReportsQuery.rootKey = "BundleParentReports.infinite"

useBundleParentReportsQuery.fetcher = (
  variables: BundleParentReportsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleParentReportsQuery, BundleParentReportsQueryVariables>(
    BundleParentReportsDocument,
    variables,
    options,
  )

export const BidReportsDocument = `
    query BidReports {
  bidReports {
    pid
    name
    notes
    buildingOwnerNotes
    parent {
      pid
    }
    bids {
      ppa {
        pid
      }
      cs {
        pid
      }
    }
  }
}
    `

export const useBidReportsQuery = <TData = BidReportsQuery, TError = unknown>(
  variables?: BidReportsQueryVariables,
  options?: Omit<UseQueryOptions<BidReportsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<BidReportsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BidReportsQuery, TError, TData>({
    queryKey: variables === undefined ? ["BidReports"] : ["BidReports", variables],
    queryFn: publicFetcher<BidReportsQuery, BidReportsQueryVariables>(
      BidReportsDocument,
      variables,
    ),
    ...options,
  })
}

useBidReportsQuery.getKey = (variables?: BidReportsQueryVariables) =>
  variables === undefined ? ["BidReports"] : ["BidReports", variables]

useBidReportsQuery.rootKey = "BidReports"

export const useSuspenseBidReportsQuery = <TData = BidReportsQuery, TError = unknown>(
  variables?: BidReportsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BidReportsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<BidReportsQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<BidReportsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["BidReportsSuspense"]
        : ["BidReportsSuspense", variables],
    queryFn: publicFetcher<BidReportsQuery, BidReportsQueryVariables>(
      BidReportsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBidReportsQuery.getKey = (variables?: BidReportsQueryVariables) =>
  variables === undefined ? ["BidReportsSuspense"] : ["BidReportsSuspense", variables]

useSuspenseBidReportsQuery.rootKey = "BidReports"

export const useInfiniteBidReportsQuery = <
  TData = InfiniteData<BidReportsQuery>,
  TError = unknown,
>(
  variables: BidReportsQueryVariables,
  options: Omit<UseInfiniteQueryOptions<BidReportsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<BidReportsQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<BidReportsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["BidReports.infinite"]
            : ["BidReports.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<BidReportsQuery, BidReportsQueryVariables>(BidReportsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBidReportsQuery.getKey = (variables?: BidReportsQueryVariables) =>
  variables === undefined ? ["BidReports.infinite"] : ["BidReports.infinite", variables]

useInfiniteBidReportsQuery.rootKey = "BidReports.infinite"

export const useSuspenseInfiniteBidReportsQuery = <
  TData = InfiniteData<BidReportsQuery>,
  TError = unknown,
>(
  variables: BidReportsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BidReportsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BidReportsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BidReportsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["BidReports.infiniteSuspense"]
            : ["BidReports.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<BidReportsQuery, BidReportsQueryVariables>(BidReportsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBidReportsQuery.getKey = (variables?: BidReportsQueryVariables) =>
  variables === undefined
    ? ["BidReports.infiniteSuspense"]
    : ["BidReports.infiniteSuspense", variables]

useSuspenseInfiniteBidReportsQuery.rootKey = "BidReports.infinite"

useBidReportsQuery.fetcher = (
  variables?: BidReportsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BidReportsQuery, BidReportsQueryVariables>(
    BidReportsDocument,
    variables,
    options,
  )

export const BundleParentBasicsDocument = `
    query BundleParentBasics($orgSlug: String!, $pid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $pid) {
    ...BasicBundleParent
    publicUrl
    totalPvSizeKwDc
    bundles {
      pid
      financier {
        pid
        name
        orgSlug
        orgUsers {
          user {
            ...UserRef
          }
          userRoles {
            role
          }
        }
      }
    }
  }
}
    ${BasicBundleParentFragmentDoc}
${UserRefFragmentDoc}`

export const useBundleParentBasicsQuery = <
  TData = BundleParentBasicsQuery,
  TError = unknown,
>(
  variables: BundleParentBasicsQueryVariables,
  options?: Omit<
    UseQueryOptions<BundleParentBasicsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<BundleParentBasicsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BundleParentBasicsQuery, TError, TData>({
    queryKey: ["BundleParentBasics", variables],
    queryFn: publicFetcher<BundleParentBasicsQuery, BundleParentBasicsQueryVariables>(
      BundleParentBasicsDocument,
      variables,
    ),
    ...options,
  })
}

useBundleParentBasicsQuery.getKey = (variables: BundleParentBasicsQueryVariables) => [
  "BundleParentBasics",
  variables,
]

useBundleParentBasicsQuery.rootKey = "BundleParentBasics"

export const useSuspenseBundleParentBasicsQuery = <
  TData = BundleParentBasicsQuery,
  TError = unknown,
>(
  variables: BundleParentBasicsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BundleParentBasicsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BundleParentBasicsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BundleParentBasicsQuery, TError, TData>({
    queryKey: ["BundleParentBasicsSuspense", variables],
    queryFn: publicFetcher<BundleParentBasicsQuery, BundleParentBasicsQueryVariables>(
      BundleParentBasicsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBundleParentBasicsQuery.getKey = (
  variables: BundleParentBasicsQueryVariables,
) => ["BundleParentBasicsSuspense", variables]

useSuspenseBundleParentBasicsQuery.rootKey = "BundleParentBasics"

export const useInfiniteBundleParentBasicsQuery = <
  TData = InfiniteData<BundleParentBasicsQuery>,
  TError = unknown,
>(
  variables: BundleParentBasicsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BundleParentBasicsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BundleParentBasicsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BundleParentBasicsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BundleParentBasics.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<BundleParentBasicsQuery, BundleParentBasicsQueryVariables>(
            BundleParentBasicsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBundleParentBasicsQuery.getKey = (
  variables: BundleParentBasicsQueryVariables,
) => ["BundleParentBasics.infinite", variables]

useInfiniteBundleParentBasicsQuery.rootKey = "BundleParentBasics.infinite"

export const useSuspenseInfiniteBundleParentBasicsQuery = <
  TData = InfiniteData<BundleParentBasicsQuery>,
  TError = unknown,
>(
  variables: BundleParentBasicsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BundleParentBasicsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BundleParentBasicsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BundleParentBasicsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BundleParentBasics.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<BundleParentBasicsQuery, BundleParentBasicsQueryVariables>(
            BundleParentBasicsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBundleParentBasicsQuery.getKey = (
  variables: BundleParentBasicsQueryVariables,
) => ["BundleParentBasics.infiniteSuspense", variables]

useSuspenseInfiniteBundleParentBasicsQuery.rootKey = "BundleParentBasics.infinite"

useBundleParentBasicsQuery.fetcher = (
  variables: BundleParentBasicsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BundleParentBasicsQuery, BundleParentBasicsQueryVariables>(
    BundleParentBasicsDocument,
    variables,
    options,
  )

export const EvOverridesDocument = `
    query EVOverrides($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    site(pid: $sitePid) {
      evOverrides {
        current {
          chargerKw
          chargerLocation
          cmsUsdPerChargerPerYr
          demandUsdPerKw
          discountRate
          evGrowthPct
          highEnergyUsdPerKwh
          incentivePct
          installType
          lowEnergyUsdPerKwh
          maxUtilization
          milesDrivenPerYear
          milesPerKwh
          numChargers
          omUsdPerChargerPerYr
          onPeakChargingPct
          onSiteChargingPct
          projectStartDate
          rateManagementUsdPerChargerPerYr
          salesTaxPct
          termYears
          transactionFeePct
          usdPerKwhMarkup
          yr0NumTenantEvs
          incentiveCapNumChargers
          maxEvAdoptionPct
          installCostUsd
        }
        defaults {
          chargerKw
          chargerLocation
          cmsUsdPerChargerPerYr
          demandUsdPerKw
          discountRate
          evGrowthPct
          highEnergyUsdPerKwh
          incentivePct
          installType
          lowEnergyUsdPerKwh
          maxUtilization
          milesDrivenPerYear
          milesPerKwh
          numChargers
          omUsdPerChargerPerYr
          onPeakChargingPct
          onSiteChargingPct
          projectStartDate
          rateManagementUsdPerChargerPerYr
          salesTaxPct
          termYears
          transactionFeePct
          usdPerKwhMarkup
          yr0NumTenantEvs
          incentiveCapNumChargers
          maxEvAdoptionPct
          installCostUsd
        }
      }
    }
  }
}
    `

export const useEvOverridesQuery = <TData = EvOverridesQuery, TError = unknown>(
  variables: EvOverridesQueryVariables,
  options?: Omit<UseQueryOptions<EvOverridesQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<EvOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<EvOverridesQuery, TError, TData>({
    queryKey: ["EVOverrides", variables],
    queryFn: publicFetcher<EvOverridesQuery, EvOverridesQueryVariables>(
      EvOverridesDocument,
      variables,
    ),
    ...options,
  })
}

useEvOverridesQuery.getKey = (variables: EvOverridesQueryVariables) => [
  "EVOverrides",
  variables,
]

useEvOverridesQuery.rootKey = "EVOverrides"

export const useSuspenseEvOverridesQuery = <TData = EvOverridesQuery, TError = unknown>(
  variables: EvOverridesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<EvOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<EvOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<EvOverridesQuery, TError, TData>({
    queryKey: ["EVOverridesSuspense", variables],
    queryFn: publicFetcher<EvOverridesQuery, EvOverridesQueryVariables>(
      EvOverridesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseEvOverridesQuery.getKey = (variables: EvOverridesQueryVariables) => [
  "EVOverridesSuspense",
  variables,
]

useSuspenseEvOverridesQuery.rootKey = "EVOverrides"

export const useInfiniteEvOverridesQuery = <
  TData = InfiniteData<EvOverridesQuery>,
  TError = unknown,
>(
  variables: EvOverridesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<EvOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<EvOverridesQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<EvOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["EVOverrides.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<EvOverridesQuery, EvOverridesQueryVariables>(
            EvOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteEvOverridesQuery.getKey = (variables: EvOverridesQueryVariables) => [
  "EVOverrides.infinite",
  variables,
]

useInfiniteEvOverridesQuery.rootKey = "EVOverrides.infinite"

export const useSuspenseInfiniteEvOverridesQuery = <
  TData = InfiniteData<EvOverridesQuery>,
  TError = unknown,
>(
  variables: EvOverridesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<EvOverridesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      EvOverridesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<EvOverridesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["EVOverrides.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<EvOverridesQuery, EvOverridesQueryVariables>(
            EvOverridesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteEvOverridesQuery.getKey = (variables: EvOverridesQueryVariables) => [
  "EVOverrides.infiniteSuspense",
  variables,
]

useSuspenseInfiniteEvOverridesQuery.rootKey = "EVOverrides.infinite"

useEvOverridesQuery.fetcher = (
  variables: EvOverridesQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<EvOverridesQuery, EvOverridesQueryVariables>(
    EvOverridesDocument,
    variables,
    options,
  )

export const InvestorBundleListDocument = `
    query InvestorBundleList($orgSlug: String!) {
  bundlesForFinancier2(slug: $orgSlug) {
    ...BundleListItem
  }
}
    ${BundleListItemFragmentDoc}
${InvestorOptOutFragmentDoc}
${UserRefFragmentDoc}`

export const useInvestorBundleListQuery = <
  TData = InvestorBundleListQuery,
  TError = unknown,
>(
  variables: InvestorBundleListQueryVariables,
  options?: Omit<
    UseQueryOptions<InvestorBundleListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<InvestorBundleListQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<InvestorBundleListQuery, TError, TData>({
    queryKey: ["InvestorBundleList", variables],
    queryFn: publicFetcher<InvestorBundleListQuery, InvestorBundleListQueryVariables>(
      InvestorBundleListDocument,
      variables,
    ),
    ...options,
  })
}

useInvestorBundleListQuery.getKey = (variables: InvestorBundleListQueryVariables) => [
  "InvestorBundleList",
  variables,
]

useInvestorBundleListQuery.rootKey = "InvestorBundleList"

export const useSuspenseInvestorBundleListQuery = <
  TData = InvestorBundleListQuery,
  TError = unknown,
>(
  variables: InvestorBundleListQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<InvestorBundleListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      InvestorBundleListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<InvestorBundleListQuery, TError, TData>({
    queryKey: ["InvestorBundleListSuspense", variables],
    queryFn: publicFetcher<InvestorBundleListQuery, InvestorBundleListQueryVariables>(
      InvestorBundleListDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseInvestorBundleListQuery.getKey = (
  variables: InvestorBundleListQueryVariables,
) => ["InvestorBundleListSuspense", variables]

useSuspenseInvestorBundleListQuery.rootKey = "InvestorBundleList"

export const useInfiniteInvestorBundleListQuery = <
  TData = InfiniteData<InvestorBundleListQuery>,
  TError = unknown,
>(
  variables: InvestorBundleListQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<InvestorBundleListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      InvestorBundleListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<InvestorBundleListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["InvestorBundleList.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<InvestorBundleListQuery, InvestorBundleListQueryVariables>(
            InvestorBundleListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteInvestorBundleListQuery.getKey = (
  variables: InvestorBundleListQueryVariables,
) => ["InvestorBundleList.infinite", variables]

useInfiniteInvestorBundleListQuery.rootKey = "InvestorBundleList.infinite"

export const useSuspenseInfiniteInvestorBundleListQuery = <
  TData = InfiniteData<InvestorBundleListQuery>,
  TError = unknown,
>(
  variables: InvestorBundleListQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<InvestorBundleListQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      InvestorBundleListQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<InvestorBundleListQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["InvestorBundleList.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<InvestorBundleListQuery, InvestorBundleListQueryVariables>(
            InvestorBundleListDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteInvestorBundleListQuery.getKey = (
  variables: InvestorBundleListQueryVariables,
) => ["InvestorBundleList.infiniteSuspense", variables]

useSuspenseInfiniteInvestorBundleListQuery.rootKey = "InvestorBundleList.infinite"

useInvestorBundleListQuery.fetcher = (
  variables: InvestorBundleListQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<InvestorBundleListQuery, InvestorBundleListQueryVariables>(
    InvestorBundleListDocument,
    variables,
    options,
  )

export const InvestorBundleLiteDocument = `
    query InvestorBundleLite($orgSlug: String!, $bundlePid: String!) {
  bundleDetail(slug: $orgSlug, bundlePid: $bundlePid) {
    ...BundleListItem
  }
}
    ${BundleListItemFragmentDoc}
${InvestorOptOutFragmentDoc}
${UserRefFragmentDoc}`

export const useInvestorBundleLiteQuery = <
  TData = InvestorBundleLiteQuery,
  TError = unknown,
>(
  variables: InvestorBundleLiteQueryVariables,
  options?: Omit<
    UseQueryOptions<InvestorBundleLiteQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<InvestorBundleLiteQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<InvestorBundleLiteQuery, TError, TData>({
    queryKey: ["InvestorBundleLite", variables],
    queryFn: publicFetcher<InvestorBundleLiteQuery, InvestorBundleLiteQueryVariables>(
      InvestorBundleLiteDocument,
      variables,
    ),
    ...options,
  })
}

useInvestorBundleLiteQuery.getKey = (variables: InvestorBundleLiteQueryVariables) => [
  "InvestorBundleLite",
  variables,
]

useInvestorBundleLiteQuery.rootKey = "InvestorBundleLite"

export const useSuspenseInvestorBundleLiteQuery = <
  TData = InvestorBundleLiteQuery,
  TError = unknown,
>(
  variables: InvestorBundleLiteQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<InvestorBundleLiteQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      InvestorBundleLiteQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<InvestorBundleLiteQuery, TError, TData>({
    queryKey: ["InvestorBundleLiteSuspense", variables],
    queryFn: publicFetcher<InvestorBundleLiteQuery, InvestorBundleLiteQueryVariables>(
      InvestorBundleLiteDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseInvestorBundleLiteQuery.getKey = (
  variables: InvestorBundleLiteQueryVariables,
) => ["InvestorBundleLiteSuspense", variables]

useSuspenseInvestorBundleLiteQuery.rootKey = "InvestorBundleLite"

export const useInfiniteInvestorBundleLiteQuery = <
  TData = InfiniteData<InvestorBundleLiteQuery>,
  TError = unknown,
>(
  variables: InvestorBundleLiteQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<InvestorBundleLiteQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      InvestorBundleLiteQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<InvestorBundleLiteQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["InvestorBundleLite.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<InvestorBundleLiteQuery, InvestorBundleLiteQueryVariables>(
            InvestorBundleLiteDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteInvestorBundleLiteQuery.getKey = (
  variables: InvestorBundleLiteQueryVariables,
) => ["InvestorBundleLite.infinite", variables]

useInfiniteInvestorBundleLiteQuery.rootKey = "InvestorBundleLite.infinite"

export const useSuspenseInfiniteInvestorBundleLiteQuery = <
  TData = InfiniteData<InvestorBundleLiteQuery>,
  TError = unknown,
>(
  variables: InvestorBundleLiteQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<InvestorBundleLiteQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      InvestorBundleLiteQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<InvestorBundleLiteQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["InvestorBundleLite.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<InvestorBundleLiteQuery, InvestorBundleLiteQueryVariables>(
            InvestorBundleLiteDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteInvestorBundleLiteQuery.getKey = (
  variables: InvestorBundleLiteQueryVariables,
) => ["InvestorBundleLite.infiniteSuspense", variables]

useSuspenseInfiniteInvestorBundleLiteQuery.rootKey = "InvestorBundleLite.infinite"

useInvestorBundleLiteQuery.fetcher = (
  variables: InvestorBundleLiteQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<InvestorBundleLiteQuery, InvestorBundleLiteQueryVariables>(
    InvestorBundleLiteDocument,
    variables,
    options,
  )

export const InvestorBundleDetailDocument = `
    query InvestorBundleDetail($orgSlug: String!, $bundlePid: String!) {
  bundleDetail(slug: $orgSlug, bundlePid: $bundlePid) {
    ...BundleDetail
  }
}
    ${BundleDetailFragmentDoc}
${BundleListItemFragmentDoc}
${InvestorOptOutFragmentDoc}
${UserRefFragmentDoc}
${BundleDetailRowFragmentDoc}
${InvestorBidFragmentDoc}
${PpaInvestorBidFragmentDoc}
${InvestorProfileFragmentDoc}
${SystemFragmentDoc}
${PvSystemSpecFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${CsInvestorBidFragmentDoc}
${SystemLiteFragmentDoc}
${RevampCsFragmentDoc}
${BidSpecFragmentDoc}
${PpaBidSpecFragmentDoc}
${CsBidSpecFragmentDoc}
${InvestorBidSpecOptOutFragmentDoc}
${BidReportFragmentDoc}
${CsSiteBidReportFragmentDoc}
${BoxplotStatsFragmentDoc}
${PpaSiteBidReportFragmentDoc}`

export const useInvestorBundleDetailQuery = <
  TData = InvestorBundleDetailQuery,
  TError = unknown,
>(
  variables: InvestorBundleDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<InvestorBundleDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<InvestorBundleDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<InvestorBundleDetailQuery, TError, TData>({
    queryKey: ["InvestorBundleDetail", variables],
    queryFn: publicFetcher<
      InvestorBundleDetailQuery,
      InvestorBundleDetailQueryVariables
    >(InvestorBundleDetailDocument, variables),
    ...options,
  })
}

useInvestorBundleDetailQuery.getKey = (
  variables: InvestorBundleDetailQueryVariables,
) => ["InvestorBundleDetail", variables]

useInvestorBundleDetailQuery.rootKey = "InvestorBundleDetail"

export const useSuspenseInvestorBundleDetailQuery = <
  TData = InvestorBundleDetailQuery,
  TError = unknown,
>(
  variables: InvestorBundleDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<InvestorBundleDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      InvestorBundleDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<InvestorBundleDetailQuery, TError, TData>({
    queryKey: ["InvestorBundleDetailSuspense", variables],
    queryFn: publicFetcher<
      InvestorBundleDetailQuery,
      InvestorBundleDetailQueryVariables
    >(InvestorBundleDetailDocument, variables),
    ...options,
  })
}

useSuspenseInvestorBundleDetailQuery.getKey = (
  variables: InvestorBundleDetailQueryVariables,
) => ["InvestorBundleDetailSuspense", variables]

useSuspenseInvestorBundleDetailQuery.rootKey = "InvestorBundleDetail"

export const useInfiniteInvestorBundleDetailQuery = <
  TData = InfiniteData<InvestorBundleDetailQuery>,
  TError = unknown,
>(
  variables: InvestorBundleDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<InvestorBundleDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      InvestorBundleDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<InvestorBundleDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["InvestorBundleDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<InvestorBundleDetailQuery, InvestorBundleDetailQueryVariables>(
            InvestorBundleDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteInvestorBundleDetailQuery.getKey = (
  variables: InvestorBundleDetailQueryVariables,
) => ["InvestorBundleDetail.infinite", variables]

useInfiniteInvestorBundleDetailQuery.rootKey = "InvestorBundleDetail.infinite"

export const useSuspenseInfiniteInvestorBundleDetailQuery = <
  TData = InfiniteData<InvestorBundleDetailQuery>,
  TError = unknown,
>(
  variables: InvestorBundleDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<InvestorBundleDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      InvestorBundleDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<InvestorBundleDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "InvestorBundleDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<InvestorBundleDetailQuery, InvestorBundleDetailQueryVariables>(
            InvestorBundleDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteInvestorBundleDetailQuery.getKey = (
  variables: InvestorBundleDetailQueryVariables,
) => ["InvestorBundleDetail.infiniteSuspense", variables]

useSuspenseInfiniteInvestorBundleDetailQuery.rootKey = "InvestorBundleDetail.infinite"

useInvestorBundleDetailQuery.fetcher = (
  variables: InvestorBundleDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<InvestorBundleDetailQuery, InvestorBundleDetailQueryVariables>(
    InvestorBundleDetailDocument,
    variables,
    options,
  )

export const InvestorBundleRowDetailDocument = `
    query InvestorBundleRowDetail($orgSlug: String!, $bundlePid: String!, $sitePid: String!) {
  bundleRowDetail(orgSlug: $orgSlug, bundlePid: $bundlePid, sitePid: $sitePid) {
    ...BundleRowDetail
  }
}
    ${BundleRowDetailFragmentDoc}
${BundleDetailRowFragmentDoc}
${InvestorOptOutFragmentDoc}
${UserRefFragmentDoc}
${InvestorBidFragmentDoc}
${PpaInvestorBidFragmentDoc}
${InvestorProfileFragmentDoc}
${SystemFragmentDoc}
${PvSystemSpecFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${CsInvestorBidFragmentDoc}
${SystemLiteFragmentDoc}
${RevampCsFragmentDoc}
${BidSpecFragmentDoc}
${PpaBidSpecFragmentDoc}
${CsBidSpecFragmentDoc}
${InvestorBidSpecOptOutFragmentDoc}
${RevampSiteBasicsFragmentDoc}
${SiteConfigFragmentDoc}
${FootprintFragmentDoc}
${BillingMeterOptionFragmentDoc}`

export const useInvestorBundleRowDetailQuery = <
  TData = InvestorBundleRowDetailQuery,
  TError = unknown,
>(
  variables: InvestorBundleRowDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<InvestorBundleRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<InvestorBundleRowDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<InvestorBundleRowDetailQuery, TError, TData>({
    queryKey: ["InvestorBundleRowDetail", variables],
    queryFn: publicFetcher<
      InvestorBundleRowDetailQuery,
      InvestorBundleRowDetailQueryVariables
    >(InvestorBundleRowDetailDocument, variables),
    ...options,
  })
}

useInvestorBundleRowDetailQuery.getKey = (
  variables: InvestorBundleRowDetailQueryVariables,
) => ["InvestorBundleRowDetail", variables]

useInvestorBundleRowDetailQuery.rootKey = "InvestorBundleRowDetail"

export const useSuspenseInvestorBundleRowDetailQuery = <
  TData = InvestorBundleRowDetailQuery,
  TError = unknown,
>(
  variables: InvestorBundleRowDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<InvestorBundleRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      InvestorBundleRowDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<InvestorBundleRowDetailQuery, TError, TData>({
    queryKey: ["InvestorBundleRowDetailSuspense", variables],
    queryFn: publicFetcher<
      InvestorBundleRowDetailQuery,
      InvestorBundleRowDetailQueryVariables
    >(InvestorBundleRowDetailDocument, variables),
    ...options,
  })
}

useSuspenseInvestorBundleRowDetailQuery.getKey = (
  variables: InvestorBundleRowDetailQueryVariables,
) => ["InvestorBundleRowDetailSuspense", variables]

useSuspenseInvestorBundleRowDetailQuery.rootKey = "InvestorBundleRowDetail"

export const useInfiniteInvestorBundleRowDetailQuery = <
  TData = InfiniteData<InvestorBundleRowDetailQuery>,
  TError = unknown,
>(
  variables: InvestorBundleRowDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<InvestorBundleRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      InvestorBundleRowDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<InvestorBundleRowDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["InvestorBundleRowDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            InvestorBundleRowDetailQuery,
            InvestorBundleRowDetailQueryVariables
          >(InvestorBundleRowDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteInvestorBundleRowDetailQuery.getKey = (
  variables: InvestorBundleRowDetailQueryVariables,
) => ["InvestorBundleRowDetail.infinite", variables]

useInfiniteInvestorBundleRowDetailQuery.rootKey = "InvestorBundleRowDetail.infinite"

export const useSuspenseInfiniteInvestorBundleRowDetailQuery = <
  TData = InfiniteData<InvestorBundleRowDetailQuery>,
  TError = unknown,
>(
  variables: InvestorBundleRowDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<InvestorBundleRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      InvestorBundleRowDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<InvestorBundleRowDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "InvestorBundleRowDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            InvestorBundleRowDetailQuery,
            InvestorBundleRowDetailQueryVariables
          >(InvestorBundleRowDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteInvestorBundleRowDetailQuery.getKey = (
  variables: InvestorBundleRowDetailQueryVariables,
) => ["InvestorBundleRowDetail.infiniteSuspense", variables]

useSuspenseInfiniteInvestorBundleRowDetailQuery.rootKey =
  "InvestorBundleRowDetail.infinite"

useInvestorBundleRowDetailQuery.fetcher = (
  variables: InvestorBundleRowDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<InvestorBundleRowDetailQuery, InvestorBundleRowDetailQueryVariables>(
    InvestorBundleRowDetailDocument,
    variables,
    options,
  )

export const GetTaskDocument = `
    query GetTask($taskId: Int!) {
  tasks {
    one(taskId: $taskId) {
      __typename
      ... on Task {
        id
        name
        status
      }
    }
  }
}
    `

export const useGetTaskQuery = <TData = GetTaskQuery, TError = unknown>(
  variables: GetTaskQueryVariables,
  options?: Omit<UseQueryOptions<GetTaskQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GetTaskQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GetTaskQuery, TError, TData>({
    queryKey: ["GetTask", variables],
    queryFn: publicFetcher<GetTaskQuery, GetTaskQueryVariables>(
      GetTaskDocument,
      variables,
    ),
    ...options,
  })
}

useGetTaskQuery.getKey = (variables: GetTaskQueryVariables) => ["GetTask", variables]

useGetTaskQuery.rootKey = "GetTask"

export const useSuspenseGetTaskQuery = <TData = GetTaskQuery, TError = unknown>(
  variables: GetTaskQueryVariables,
  options?: Omit<UseSuspenseQueryOptions<GetTaskQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseSuspenseQueryOptions<GetTaskQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GetTaskQuery, TError, TData>({
    queryKey: ["GetTaskSuspense", variables],
    queryFn: publicFetcher<GetTaskQuery, GetTaskQueryVariables>(
      GetTaskDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGetTaskQuery.getKey = (variables: GetTaskQueryVariables) => [
  "GetTaskSuspense",
  variables,
]

useSuspenseGetTaskQuery.rootKey = "GetTask"

export const useInfiniteGetTaskQuery = <
  TData = InfiniteData<GetTaskQuery>,
  TError = unknown,
>(
  variables: GetTaskQueryVariables,
  options: Omit<UseInfiniteQueryOptions<GetTaskQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<GetTaskQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GetTaskQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetTask.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGetTaskQuery.getKey = (variables: GetTaskQueryVariables) => [
  "GetTask.infinite",
  variables,
]

useInfiniteGetTaskQuery.rootKey = "GetTask.infinite"

export const useSuspenseInfiniteGetTaskQuery = <
  TData = InfiniteData<GetTaskQuery>,
  TError = unknown,
>(
  variables: GetTaskQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GetTaskQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<GetTaskQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GetTaskQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["GetTask.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<GetTaskQuery, GetTaskQueryVariables>(GetTaskDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGetTaskQuery.getKey = (variables: GetTaskQueryVariables) => [
  "GetTask.infiniteSuspense",
  variables,
]

useSuspenseInfiniteGetTaskQuery.rootKey = "GetTask.infinite"

useGetTaskQuery.fetcher = (
  variables: GetTaskQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<GetTaskQuery, GetTaskQueryVariables>(
    GetTaskDocument,
    variables,
    options,
  )

export const CsvImportDetailDocument = `
    query CsvImportDetail($orgSlug: String!, $csvImportPid: String!) {
  orgBySlug(slug: $orgSlug) {
    csvImports {
      one(pid: $csvImportPid) {
        pid
        rawCsvWithPidsHref
        columnIds
        columnMappings {
          assetManagerColumnId
          buildingTypeColumnId
          cityColumnId
          customerIdColumnId
          latitudeColumnId
          longitudeColumnId
          nameColumnId
          numStoriesColumnId
          numUnits1BdColumnId
          numUnits2BdColumnId
          numUnits3BdColumnId
          numUnits4BdColumnId
          numUnitsStudioColumnId
          numUnitsTotalColumnId
          sqftColumnId
          stateColumnId
          streetAddressColumnId
          yearBuiltColumnId
          zipCodeColumnId
        }
        buildingTypes
        buildingTypeMappings {
          office
          multifamily
          hotel
          hospital
          outpatient
          retailStandalone
          retailStripMall
          quickServiceRestaurant
          fullServiceRestaurant
          primarySchool
          secondarySchool
          singleFamilyDetached
          warehouse
          dataCenter
          coldStorage
          industrial
          parkingLot
          supermarket
        }
        guessedSchema {
          pid
          origin
        }
        labels {
          pid
          themeColor
          name
        }
        rows {
          id
          droppedAt
          buildingData {
            id
            propertyName
            fullAddress
            streetAddress
            city
            state
            zipCode
            buildingType
            sqft
            roofSqft
            numStories
            latitude
            longitude
            buildingFootprintGeojson
            yearBuilt
            numUnitsTotal
            numUnitsStudio
            numUnits1Bd
            numUnits2Bd
            numUnits3Bd
            numUnits4Bd
          }
          amendments {
            assetManager
            buildingType
            customerId
            latitude
            longitude
            name
            numStories
            roofSqft
            sqft
            yearBuilt
            mfUnits {
              numUnitsTotal
              numUnitsStudio
              numUnits1Bd
              numUnits2Bd
              numUnits3Bd
              numUnits4Bd
            }
          }
          site {
            pid
          }
          dirty {
            ...DirtyRowData
          }
          errors {
            type
            message
          }
          warnings {
            type
            message
          }
        }
      }
    }
  }
}
    ${DirtyRowDataFragmentDoc}`

export const useCsvImportDetailQuery = <TData = CsvImportDetailQuery, TError = unknown>(
  variables: CsvImportDetailQueryVariables,
  options?: Omit<UseQueryOptions<CsvImportDetailQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<CsvImportDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CsvImportDetailQuery, TError, TData>({
    queryKey: ["CsvImportDetail", variables],
    queryFn: publicFetcher<CsvImportDetailQuery, CsvImportDetailQueryVariables>(
      CsvImportDetailDocument,
      variables,
    ),
    ...options,
  })
}

useCsvImportDetailQuery.getKey = (variables: CsvImportDetailQueryVariables) => [
  "CsvImportDetail",
  variables,
]

useCsvImportDetailQuery.rootKey = "CsvImportDetail"

export const useSuspenseCsvImportDetailQuery = <
  TData = CsvImportDetailQuery,
  TError = unknown,
>(
  variables: CsvImportDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CsvImportDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<CsvImportDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<CsvImportDetailQuery, TError, TData>({
    queryKey: ["CsvImportDetailSuspense", variables],
    queryFn: publicFetcher<CsvImportDetailQuery, CsvImportDetailQueryVariables>(
      CsvImportDetailDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseCsvImportDetailQuery.getKey = (variables: CsvImportDetailQueryVariables) => [
  "CsvImportDetailSuspense",
  variables,
]

useSuspenseCsvImportDetailQuery.rootKey = "CsvImportDetail"

export const useInfiniteCsvImportDetailQuery = <
  TData = InfiniteData<CsvImportDetailQuery>,
  TError = unknown,
>(
  variables: CsvImportDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CsvImportDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<CsvImportDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<CsvImportDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CsvImportDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CsvImportDetailQuery, CsvImportDetailQueryVariables>(
            CsvImportDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCsvImportDetailQuery.getKey = (variables: CsvImportDetailQueryVariables) => [
  "CsvImportDetail.infinite",
  variables,
]

useInfiniteCsvImportDetailQuery.rootKey = "CsvImportDetail.infinite"

export const useSuspenseInfiniteCsvImportDetailQuery = <
  TData = InfiniteData<CsvImportDetailQuery>,
  TError = unknown,
>(
  variables: CsvImportDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CsvImportDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CsvImportDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CsvImportDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CsvImportDetail.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<CsvImportDetailQuery, CsvImportDetailQueryVariables>(
            CsvImportDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCsvImportDetailQuery.getKey = (
  variables: CsvImportDetailQueryVariables,
) => ["CsvImportDetail.infiniteSuspense", variables]

useSuspenseInfiniteCsvImportDetailQuery.rootKey = "CsvImportDetail.infinite"

useCsvImportDetailQuery.fetcher = (
  variables: CsvImportDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CsvImportDetailQuery, CsvImportDetailQueryVariables>(
    CsvImportDetailDocument,
    variables,
    options,
  )

export const MarketplacePackagesDocument = `
    query MarketplacePackages($orgSlug: String!) {
  orgBySlug(slug: $orgSlug) {
    bidPackages {
      ...BasicBidPackage
    }
  }
}
    ${BasicBidPackageFragmentDoc}
${InvestorProfileFragmentDoc}`

export const useMarketplacePackagesQuery = <
  TData = MarketplacePackagesQuery,
  TError = unknown,
>(
  variables: MarketplacePackagesQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplacePackagesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplacePackagesQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplacePackagesQuery, TError, TData>({
    queryKey: ["MarketplacePackages", variables],
    queryFn: publicFetcher<MarketplacePackagesQuery, MarketplacePackagesQueryVariables>(
      MarketplacePackagesDocument,
      variables,
    ),
    ...options,
  })
}

useMarketplacePackagesQuery.getKey = (variables: MarketplacePackagesQueryVariables) => [
  "MarketplacePackages",
  variables,
]

useMarketplacePackagesQuery.rootKey = "MarketplacePackages"

export const useSuspenseMarketplacePackagesQuery = <
  TData = MarketplacePackagesQuery,
  TError = unknown,
>(
  variables: MarketplacePackagesQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplacePackagesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplacePackagesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplacePackagesQuery, TError, TData>({
    queryKey: ["MarketplacePackagesSuspense", variables],
    queryFn: publicFetcher<MarketplacePackagesQuery, MarketplacePackagesQueryVariables>(
      MarketplacePackagesDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMarketplacePackagesQuery.getKey = (
  variables: MarketplacePackagesQueryVariables,
) => ["MarketplacePackagesSuspense", variables]

useSuspenseMarketplacePackagesQuery.rootKey = "MarketplacePackages"

export const useInfiniteMarketplacePackagesQuery = <
  TData = InfiniteData<MarketplacePackagesQuery>,
  TError = unknown,
>(
  variables: MarketplacePackagesQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplacePackagesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplacePackagesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplacePackagesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplacePackages.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplacePackagesQuery, MarketplacePackagesQueryVariables>(
            MarketplacePackagesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplacePackagesQuery.getKey = (
  variables: MarketplacePackagesQueryVariables,
) => ["MarketplacePackages.infinite", variables]

useInfiniteMarketplacePackagesQuery.rootKey = "MarketplacePackages.infinite"

export const useSuspenseInfiniteMarketplacePackagesQuery = <
  TData = InfiniteData<MarketplacePackagesQuery>,
  TError = unknown,
>(
  variables: MarketplacePackagesQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplacePackagesQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplacePackagesQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplacePackagesQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplacePackages.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplacePackagesQuery, MarketplacePackagesQueryVariables>(
            MarketplacePackagesDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplacePackagesQuery.getKey = (
  variables: MarketplacePackagesQueryVariables,
) => ["MarketplacePackages.infiniteSuspense", variables]

useSuspenseInfiniteMarketplacePackagesQuery.rootKey = "MarketplacePackages.infinite"

useMarketplacePackagesQuery.fetcher = (
  variables: MarketplacePackagesQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplacePackagesQuery, MarketplacePackagesQueryVariables>(
    MarketplacePackagesDocument,
    variables,
    options,
  )

export const MarketplaceSpecsViewDocument = `
    query MarketplaceSpecsView($orgSlug: String!, $filterBy: BidSpecsTableFilter!, $sortBy: [BidSpecsTableSort!]) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageSpecs {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
      }
    }
  }
}
    `

export const useMarketplaceSpecsViewQuery = <
  TData = MarketplaceSpecsViewQuery,
  TError = unknown,
>(
  variables: MarketplaceSpecsViewQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceSpecsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceSpecsViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceSpecsViewQuery, TError, TData>({
    queryKey: ["MarketplaceSpecsView", variables],
    queryFn: publicFetcher<
      MarketplaceSpecsViewQuery,
      MarketplaceSpecsViewQueryVariables
    >(MarketplaceSpecsViewDocument, variables),
    ...options,
  })
}

useMarketplaceSpecsViewQuery.getKey = (
  variables: MarketplaceSpecsViewQueryVariables,
) => ["MarketplaceSpecsView", variables]

useMarketplaceSpecsViewQuery.rootKey = "MarketplaceSpecsView"

export const useSuspenseMarketplaceSpecsViewQuery = <
  TData = MarketplaceSpecsViewQuery,
  TError = unknown,
>(
  variables: MarketplaceSpecsViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceSpecsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceSpecsViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceSpecsViewQuery, TError, TData>({
    queryKey: ["MarketplaceSpecsViewSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceSpecsViewQuery,
      MarketplaceSpecsViewQueryVariables
    >(MarketplaceSpecsViewDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceSpecsViewQuery.getKey = (
  variables: MarketplaceSpecsViewQueryVariables,
) => ["MarketplaceSpecsViewSuspense", variables]

useSuspenseMarketplaceSpecsViewQuery.rootKey = "MarketplaceSpecsView"

export const useInfiniteMarketplaceSpecsViewQuery = <
  TData = InfiniteData<MarketplaceSpecsViewQuery>,
  TError = unknown,
>(
  variables: MarketplaceSpecsViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceSpecsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceSpecsViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceSpecsViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceSpecsView.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSpecsViewQuery, MarketplaceSpecsViewQueryVariables>(
            MarketplaceSpecsViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceSpecsViewQuery.getKey = (
  variables: MarketplaceSpecsViewQueryVariables,
) => ["MarketplaceSpecsView.infinite", variables]

useInfiniteMarketplaceSpecsViewQuery.rootKey = "MarketplaceSpecsView.infinite"

export const useSuspenseInfiniteMarketplaceSpecsViewQuery = <
  TData = InfiniteData<MarketplaceSpecsViewQuery>,
  TError = unknown,
>(
  variables: MarketplaceSpecsViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceSpecsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceSpecsViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceSpecsViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceSpecsView.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSpecsViewQuery, MarketplaceSpecsViewQueryVariables>(
            MarketplaceSpecsViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceSpecsViewQuery.getKey = (
  variables: MarketplaceSpecsViewQueryVariables,
) => ["MarketplaceSpecsView.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceSpecsViewQuery.rootKey = "MarketplaceSpecsView.infinite"

useMarketplaceSpecsViewQuery.fetcher = (
  variables: MarketplaceSpecsViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceSpecsViewQuery, MarketplaceSpecsViewQueryVariables>(
    MarketplaceSpecsViewDocument,
    variables,
    options,
  )

export const MarketplaceSpecsRowsDocument = `
    query MarketplaceSpecsRows($orgSlug: String!, $keys: [String!]!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageSpecs {
      rows(keys: $keys) {
        pid
        sitePid
        bidName
        bidPackagePid
        name
        city
        state
        zipCode
        streetAddress
        county
        cbsaName
        assetManager
        packageRowStatus
        packageRowClosedAt
        packageRowCloseReason
        packageRowCloseCustomReason
        buildingType
        yearBuilt
        sqft
        buildingFootprintSqft
        roofSqft
        usableRoofSqft
        numStories
        numUnitsTotal
        buildingClass
        roofReplacedYr
        roofCondition
        csSystem {
          ...SystemLite
        }
        ppaSystem {
          ...System
        }
        csRoofRentEscalator
        ppaRoofRentEscalator
        ppaPriceEscalator
        csRoofRentY1Usd
        ppaRoofRentY1Usd
        ppaPriceY1Usd
        ppaTermYears
        csTermYears
      }
    }
  }
}
    ${SystemLiteFragmentDoc}
${PvSystemSpecFragmentDoc}
${SystemFragmentDoc}`

export const useMarketplaceSpecsRowsQuery = <
  TData = MarketplaceSpecsRowsQuery,
  TError = unknown,
>(
  variables: MarketplaceSpecsRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceSpecsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceSpecsRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceSpecsRowsQuery, TError, TData>({
    queryKey: ["MarketplaceSpecsRows", variables],
    queryFn: publicFetcher<
      MarketplaceSpecsRowsQuery,
      MarketplaceSpecsRowsQueryVariables
    >(MarketplaceSpecsRowsDocument, variables),
    ...options,
  })
}

useMarketplaceSpecsRowsQuery.getKey = (
  variables: MarketplaceSpecsRowsQueryVariables,
) => ["MarketplaceSpecsRows", variables]

useMarketplaceSpecsRowsQuery.rootKey = "MarketplaceSpecsRows"

export const useSuspenseMarketplaceSpecsRowsQuery = <
  TData = MarketplaceSpecsRowsQuery,
  TError = unknown,
>(
  variables: MarketplaceSpecsRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceSpecsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceSpecsRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceSpecsRowsQuery, TError, TData>({
    queryKey: ["MarketplaceSpecsRowsSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceSpecsRowsQuery,
      MarketplaceSpecsRowsQueryVariables
    >(MarketplaceSpecsRowsDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceSpecsRowsQuery.getKey = (
  variables: MarketplaceSpecsRowsQueryVariables,
) => ["MarketplaceSpecsRowsSuspense", variables]

useSuspenseMarketplaceSpecsRowsQuery.rootKey = "MarketplaceSpecsRows"

export const useInfiniteMarketplaceSpecsRowsQuery = <
  TData = InfiniteData<MarketplaceSpecsRowsQuery>,
  TError = unknown,
>(
  variables: MarketplaceSpecsRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceSpecsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceSpecsRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceSpecsRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceSpecsRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSpecsRowsQuery, MarketplaceSpecsRowsQueryVariables>(
            MarketplaceSpecsRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceSpecsRowsQuery.getKey = (
  variables: MarketplaceSpecsRowsQueryVariables,
) => ["MarketplaceSpecsRows.infinite", variables]

useInfiniteMarketplaceSpecsRowsQuery.rootKey = "MarketplaceSpecsRows.infinite"

export const useSuspenseInfiniteMarketplaceSpecsRowsQuery = <
  TData = InfiniteData<MarketplaceSpecsRowsQuery>,
  TError = unknown,
>(
  variables: MarketplaceSpecsRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceSpecsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceSpecsRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceSpecsRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceSpecsRows.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSpecsRowsQuery, MarketplaceSpecsRowsQueryVariables>(
            MarketplaceSpecsRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceSpecsRowsQuery.getKey = (
  variables: MarketplaceSpecsRowsQueryVariables,
) => ["MarketplaceSpecsRows.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceSpecsRowsQuery.rootKey = "MarketplaceSpecsRows.infinite"

useMarketplaceSpecsRowsQuery.fetcher = (
  variables: MarketplaceSpecsRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceSpecsRowsQuery, MarketplaceSpecsRowsQueryVariables>(
    MarketplaceSpecsRowsDocument,
    variables,
    options,
  )

export const MarketplaceSitesViewDocument = `
    query MarketplaceSitesView($orgSlug: String!, $filterBy: BidPackageSitesTableFilter!, $sortBy: [BidPackageSitesTableSort!]) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageSites {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
      }
    }
  }
}
    `

export const useMarketplaceSitesViewQuery = <
  TData = MarketplaceSitesViewQuery,
  TError = unknown,
>(
  variables: MarketplaceSitesViewQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceSitesViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceSitesViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceSitesViewQuery, TError, TData>({
    queryKey: ["MarketplaceSitesView", variables],
    queryFn: publicFetcher<
      MarketplaceSitesViewQuery,
      MarketplaceSitesViewQueryVariables
    >(MarketplaceSitesViewDocument, variables),
    ...options,
  })
}

useMarketplaceSitesViewQuery.getKey = (
  variables: MarketplaceSitesViewQueryVariables,
) => ["MarketplaceSitesView", variables]

useMarketplaceSitesViewQuery.rootKey = "MarketplaceSitesView"

export const useSuspenseMarketplaceSitesViewQuery = <
  TData = MarketplaceSitesViewQuery,
  TError = unknown,
>(
  variables: MarketplaceSitesViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceSitesViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceSitesViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceSitesViewQuery, TError, TData>({
    queryKey: ["MarketplaceSitesViewSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceSitesViewQuery,
      MarketplaceSitesViewQueryVariables
    >(MarketplaceSitesViewDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceSitesViewQuery.getKey = (
  variables: MarketplaceSitesViewQueryVariables,
) => ["MarketplaceSitesViewSuspense", variables]

useSuspenseMarketplaceSitesViewQuery.rootKey = "MarketplaceSitesView"

export const useInfiniteMarketplaceSitesViewQuery = <
  TData = InfiniteData<MarketplaceSitesViewQuery>,
  TError = unknown,
>(
  variables: MarketplaceSitesViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceSitesViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceSitesViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceSitesViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceSitesView.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSitesViewQuery, MarketplaceSitesViewQueryVariables>(
            MarketplaceSitesViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceSitesViewQuery.getKey = (
  variables: MarketplaceSitesViewQueryVariables,
) => ["MarketplaceSitesView.infinite", variables]

useInfiniteMarketplaceSitesViewQuery.rootKey = "MarketplaceSitesView.infinite"

export const useSuspenseInfiniteMarketplaceSitesViewQuery = <
  TData = InfiniteData<MarketplaceSitesViewQuery>,
  TError = unknown,
>(
  variables: MarketplaceSitesViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceSitesViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceSitesViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceSitesViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceSitesView.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSitesViewQuery, MarketplaceSitesViewQueryVariables>(
            MarketplaceSitesViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceSitesViewQuery.getKey = (
  variables: MarketplaceSitesViewQueryVariables,
) => ["MarketplaceSitesView.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceSitesViewQuery.rootKey = "MarketplaceSitesView.infinite"

useMarketplaceSitesViewQuery.fetcher = (
  variables: MarketplaceSitesViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceSitesViewQuery, MarketplaceSitesViewQueryVariables>(
    MarketplaceSitesViewDocument,
    variables,
    options,
  )

export const MarketplaceSitesFacetsDocument = `
    query MarketplaceSitesFacets($orgSlug: String!, $filterBy: BidPackageSitesTableFilter!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageSites {
      view(filterBy: $filterBy) {
        stats {
          awardedFinanciers
        }
      }
    }
  }
}
    `

export const useMarketplaceSitesFacetsQuery = <
  TData = MarketplaceSitesFacetsQuery,
  TError = unknown,
>(
  variables: MarketplaceSitesFacetsQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceSitesFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceSitesFacetsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceSitesFacetsQuery, TError, TData>({
    queryKey: ["MarketplaceSitesFacets", variables],
    queryFn: publicFetcher<
      MarketplaceSitesFacetsQuery,
      MarketplaceSitesFacetsQueryVariables
    >(MarketplaceSitesFacetsDocument, variables),
    ...options,
  })
}

useMarketplaceSitesFacetsQuery.getKey = (
  variables: MarketplaceSitesFacetsQueryVariables,
) => ["MarketplaceSitesFacets", variables]

useMarketplaceSitesFacetsQuery.rootKey = "MarketplaceSitesFacets"

export const useSuspenseMarketplaceSitesFacetsQuery = <
  TData = MarketplaceSitesFacetsQuery,
  TError = unknown,
>(
  variables: MarketplaceSitesFacetsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceSitesFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceSitesFacetsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceSitesFacetsQuery, TError, TData>({
    queryKey: ["MarketplaceSitesFacetsSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceSitesFacetsQuery,
      MarketplaceSitesFacetsQueryVariables
    >(MarketplaceSitesFacetsDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceSitesFacetsQuery.getKey = (
  variables: MarketplaceSitesFacetsQueryVariables,
) => ["MarketplaceSitesFacetsSuspense", variables]

useSuspenseMarketplaceSitesFacetsQuery.rootKey = "MarketplaceSitesFacets"

export const useInfiniteMarketplaceSitesFacetsQuery = <
  TData = InfiniteData<MarketplaceSitesFacetsQuery>,
  TError = unknown,
>(
  variables: MarketplaceSitesFacetsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceSitesFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceSitesFacetsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceSitesFacetsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceSitesFacets.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplaceSitesFacetsQuery,
            MarketplaceSitesFacetsQueryVariables
          >(MarketplaceSitesFacetsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceSitesFacetsQuery.getKey = (
  variables: MarketplaceSitesFacetsQueryVariables,
) => ["MarketplaceSitesFacets.infinite", variables]

useInfiniteMarketplaceSitesFacetsQuery.rootKey = "MarketplaceSitesFacets.infinite"

export const useSuspenseInfiniteMarketplaceSitesFacetsQuery = <
  TData = InfiniteData<MarketplaceSitesFacetsQuery>,
  TError = unknown,
>(
  variables: MarketplaceSitesFacetsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceSitesFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceSitesFacetsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceSitesFacetsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceSitesFacets.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplaceSitesFacetsQuery,
            MarketplaceSitesFacetsQueryVariables
          >(MarketplaceSitesFacetsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceSitesFacetsQuery.getKey = (
  variables: MarketplaceSitesFacetsQueryVariables,
) => ["MarketplaceSitesFacets.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceSitesFacetsQuery.rootKey =
  "MarketplaceSitesFacets.infinite"

useMarketplaceSitesFacetsQuery.fetcher = (
  variables: MarketplaceSitesFacetsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceSitesFacetsQuery, MarketplaceSitesFacetsQueryVariables>(
    MarketplaceSitesFacetsDocument,
    variables,
    options,
  )

export const MarketplaceSitesRowsDocument = `
    query MarketplaceSitesRows($orgSlug: String!, $keys: [Int!]!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageSites {
      rows(keys: $keys) {
        id
        sitePid
        bidPackagePid
        bidPackageName
        name
        city
        state
        zipCode
        streetAddress
        county
        cbsaName
        assetManager
        packageRowStatus
        packageRowIsClosed
        packageRowClosedAt
        packageRowCloseReason
        packageRowCloseCustomReason
        buildingType
        yearBuilt
        sqft
        buildingFootprintSqft
        roofSqft
        usableRoofSqft
        numStories
        numUnitsTotal
        buildingClass
        roofReplacedYr
        roofCondition
        salePlans
        buildingLegalName
        propertyFundName
        leaseSignatory
        counselApproval
        leaseApprovers
        externalLeaseApprovers
        needsTenantApproval
        roofRightsHolder
        propertyLenders
        propertyInsurer
        constructionEmail
        propertySiteVisitContacts
        leasePropertyLegalDescription
        leaseLegalOwnerName
        signatureBlocks
        isFannieMaeLender
        isFmGlobalInsurer
        financierCount
        bidCount
        ppaNoiMin
        ppaNoiAvg
        ppaNoiMax
        csNoiMin
        csNoiAvg
        csNoiMax
        targetUtility {
          pid
          name
        }
        awardedDeveloper
        awardedBidPvSizeKwDc
        awardedBidPvSizeKwAc
        awardedBidPvTypes
        csEstimatedAwardDate
        estimatedNtp
        estimatedCod
        csNpv
        roofRentY1Usd
        roofRentEscalator
        noiLifetimeUsd
        financingType
      }
    }
  }
}
    `

export const useMarketplaceSitesRowsQuery = <
  TData = MarketplaceSitesRowsQuery,
  TError = unknown,
>(
  variables: MarketplaceSitesRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceSitesRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceSitesRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceSitesRowsQuery, TError, TData>({
    queryKey: ["MarketplaceSitesRows", variables],
    queryFn: publicFetcher<
      MarketplaceSitesRowsQuery,
      MarketplaceSitesRowsQueryVariables
    >(MarketplaceSitesRowsDocument, variables),
    ...options,
  })
}

useMarketplaceSitesRowsQuery.getKey = (
  variables: MarketplaceSitesRowsQueryVariables,
) => ["MarketplaceSitesRows", variables]

useMarketplaceSitesRowsQuery.rootKey = "MarketplaceSitesRows"

export const useSuspenseMarketplaceSitesRowsQuery = <
  TData = MarketplaceSitesRowsQuery,
  TError = unknown,
>(
  variables: MarketplaceSitesRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceSitesRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceSitesRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceSitesRowsQuery, TError, TData>({
    queryKey: ["MarketplaceSitesRowsSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceSitesRowsQuery,
      MarketplaceSitesRowsQueryVariables
    >(MarketplaceSitesRowsDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceSitesRowsQuery.getKey = (
  variables: MarketplaceSitesRowsQueryVariables,
) => ["MarketplaceSitesRowsSuspense", variables]

useSuspenseMarketplaceSitesRowsQuery.rootKey = "MarketplaceSitesRows"

export const useInfiniteMarketplaceSitesRowsQuery = <
  TData = InfiniteData<MarketplaceSitesRowsQuery>,
  TError = unknown,
>(
  variables: MarketplaceSitesRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceSitesRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceSitesRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceSitesRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceSitesRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSitesRowsQuery, MarketplaceSitesRowsQueryVariables>(
            MarketplaceSitesRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceSitesRowsQuery.getKey = (
  variables: MarketplaceSitesRowsQueryVariables,
) => ["MarketplaceSitesRows.infinite", variables]

useInfiniteMarketplaceSitesRowsQuery.rootKey = "MarketplaceSitesRows.infinite"

export const useSuspenseInfiniteMarketplaceSitesRowsQuery = <
  TData = InfiniteData<MarketplaceSitesRowsQuery>,
  TError = unknown,
>(
  variables: MarketplaceSitesRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceSitesRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceSitesRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceSitesRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceSitesRows.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceSitesRowsQuery, MarketplaceSitesRowsQueryVariables>(
            MarketplaceSitesRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceSitesRowsQuery.getKey = (
  variables: MarketplaceSitesRowsQueryVariables,
) => ["MarketplaceSitesRows.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceSitesRowsQuery.rootKey = "MarketplaceSitesRows.infinite"

useMarketplaceSitesRowsQuery.fetcher = (
  variables: MarketplaceSitesRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceSitesRowsQuery, MarketplaceSitesRowsQueryVariables>(
    MarketplaceSitesRowsDocument,
    variables,
    options,
  )

export const MarketplaceBidsViewDocument = `
    query MarketplaceBidsView($orgSlug: String!, $filterBy: InvestorBidsTableFilter!, $sortBy: [InvestorBidsTableSort!]) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageBids {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
      }
    }
  }
}
    `

export const useMarketplaceBidsViewQuery = <
  TData = MarketplaceBidsViewQuery,
  TError = unknown,
>(
  variables: MarketplaceBidsViewQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceBidsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceBidsViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceBidsViewQuery, TError, TData>({
    queryKey: ["MarketplaceBidsView", variables],
    queryFn: publicFetcher<MarketplaceBidsViewQuery, MarketplaceBidsViewQueryVariables>(
      MarketplaceBidsViewDocument,
      variables,
    ),
    ...options,
  })
}

useMarketplaceBidsViewQuery.getKey = (variables: MarketplaceBidsViewQueryVariables) => [
  "MarketplaceBidsView",
  variables,
]

useMarketplaceBidsViewQuery.rootKey = "MarketplaceBidsView"

export const useSuspenseMarketplaceBidsViewQuery = <
  TData = MarketplaceBidsViewQuery,
  TError = unknown,
>(
  variables: MarketplaceBidsViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceBidsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceBidsViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceBidsViewQuery, TError, TData>({
    queryKey: ["MarketplaceBidsViewSuspense", variables],
    queryFn: publicFetcher<MarketplaceBidsViewQuery, MarketplaceBidsViewQueryVariables>(
      MarketplaceBidsViewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMarketplaceBidsViewQuery.getKey = (
  variables: MarketplaceBidsViewQueryVariables,
) => ["MarketplaceBidsViewSuspense", variables]

useSuspenseMarketplaceBidsViewQuery.rootKey = "MarketplaceBidsView"

export const useInfiniteMarketplaceBidsViewQuery = <
  TData = InfiniteData<MarketplaceBidsViewQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidsViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceBidsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceBidsViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceBidsViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceBidsView.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceBidsViewQuery, MarketplaceBidsViewQueryVariables>(
            MarketplaceBidsViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceBidsViewQuery.getKey = (
  variables: MarketplaceBidsViewQueryVariables,
) => ["MarketplaceBidsView.infinite", variables]

useInfiniteMarketplaceBidsViewQuery.rootKey = "MarketplaceBidsView.infinite"

export const useSuspenseInfiniteMarketplaceBidsViewQuery = <
  TData = InfiniteData<MarketplaceBidsViewQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidsViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceBidsViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceBidsViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceBidsViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceBidsView.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceBidsViewQuery, MarketplaceBidsViewQueryVariables>(
            MarketplaceBidsViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceBidsViewQuery.getKey = (
  variables: MarketplaceBidsViewQueryVariables,
) => ["MarketplaceBidsView.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceBidsViewQuery.rootKey = "MarketplaceBidsView.infinite"

useMarketplaceBidsViewQuery.fetcher = (
  variables: MarketplaceBidsViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceBidsViewQuery, MarketplaceBidsViewQueryVariables>(
    MarketplaceBidsViewDocument,
    variables,
    options,
  )

export const MarketplaceBidsFacetsDocument = `
    query MarketplaceBidsFacets($orgSlug: String!, $filterBy: InvestorBidsTableFilter!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageBids {
      view(filterBy: $filterBy) {
        stats {
          financiers
          siteNames
          siteStates
          siteStreetAddresses
        }
      }
    }
  }
}
    `

export const useMarketplaceBidsFacetsQuery = <
  TData = MarketplaceBidsFacetsQuery,
  TError = unknown,
>(
  variables: MarketplaceBidsFacetsQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceBidsFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceBidsFacetsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceBidsFacetsQuery, TError, TData>({
    queryKey: ["MarketplaceBidsFacets", variables],
    queryFn: publicFetcher<
      MarketplaceBidsFacetsQuery,
      MarketplaceBidsFacetsQueryVariables
    >(MarketplaceBidsFacetsDocument, variables),
    ...options,
  })
}

useMarketplaceBidsFacetsQuery.getKey = (
  variables: MarketplaceBidsFacetsQueryVariables,
) => ["MarketplaceBidsFacets", variables]

useMarketplaceBidsFacetsQuery.rootKey = "MarketplaceBidsFacets"

export const useSuspenseMarketplaceBidsFacetsQuery = <
  TData = MarketplaceBidsFacetsQuery,
  TError = unknown,
>(
  variables: MarketplaceBidsFacetsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceBidsFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceBidsFacetsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceBidsFacetsQuery, TError, TData>({
    queryKey: ["MarketplaceBidsFacetsSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceBidsFacetsQuery,
      MarketplaceBidsFacetsQueryVariables
    >(MarketplaceBidsFacetsDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceBidsFacetsQuery.getKey = (
  variables: MarketplaceBidsFacetsQueryVariables,
) => ["MarketplaceBidsFacetsSuspense", variables]

useSuspenseMarketplaceBidsFacetsQuery.rootKey = "MarketplaceBidsFacets"

export const useInfiniteMarketplaceBidsFacetsQuery = <
  TData = InfiniteData<MarketplaceBidsFacetsQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidsFacetsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceBidsFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceBidsFacetsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceBidsFacetsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceBidsFacets.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplaceBidsFacetsQuery,
            MarketplaceBidsFacetsQueryVariables
          >(MarketplaceBidsFacetsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceBidsFacetsQuery.getKey = (
  variables: MarketplaceBidsFacetsQueryVariables,
) => ["MarketplaceBidsFacets.infinite", variables]

useInfiniteMarketplaceBidsFacetsQuery.rootKey = "MarketplaceBidsFacets.infinite"

export const useSuspenseInfiniteMarketplaceBidsFacetsQuery = <
  TData = InfiniteData<MarketplaceBidsFacetsQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidsFacetsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceBidsFacetsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceBidsFacetsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceBidsFacetsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceBidsFacets.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplaceBidsFacetsQuery,
            MarketplaceBidsFacetsQueryVariables
          >(MarketplaceBidsFacetsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceBidsFacetsQuery.getKey = (
  variables: MarketplaceBidsFacetsQueryVariables,
) => ["MarketplaceBidsFacets.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceBidsFacetsQuery.rootKey = "MarketplaceBidsFacets.infinite"

useMarketplaceBidsFacetsQuery.fetcher = (
  variables: MarketplaceBidsFacetsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceBidsFacetsQuery, MarketplaceBidsFacetsQueryVariables>(
    MarketplaceBidsFacetsDocument,
    variables,
    options,
  )

export const MarketplaceBidsRowsDocument = `
    query MarketplaceBidsRows($orgSlug: String!, $keys: [String!]!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackageBids {
      rows(keys: $keys) {
        pid
        bidName
        sitePid
        bundleRowPid
        bundleParentPid
        name
        streetAddress
        city
        state
        zipCode
        latitude
        longitude
        county
        cbsaName
        assetManager
        packageRowIsClosed
        packageRowStatus
        packageRowClosedAt
        packageRowCloseReason
        packageRowCloseCustomReason
        isAwardedBid
        isRecommendedBid
        bidPackagePid
        bidPackageName
        biddingOpenAt
        biddingClosedAt
        termYears
        type
        recOwner
        csEstimatedAwardDate
        estimatedCod
        estimatedNtp
        tariffProvision
        itcPercentageAssumption
        interconnectionCostUsdPerWatt
        interconnectionCostUtilityMinUsd
        interconnectionCostUtilityMaxUsd
        interconnectionCostNonUtilityUsd
        buildingOwnerExtraPaymentsUsd
        interconnectionNotes
        interconnectionRepriceProcessNotes
        extraPaymentsNotes
        incentivesNotes
        otherNotes
        csRoofRentEscalator
        csRoofRentY1Usd
        csBuildingOwnerNoiLifetimeUsd
        csRoofRentNpv
        csSystem {
          id
          ...SystemLite
        }
        ppaRoofRentEscalator
        ppaRoofRentY1Usd
        ppaPriceEscalator
        ppaPriceY1Usd
        ppaSystem {
          id
          ...System
        }
        financierPid
        financierName
        financierLogoUrl
        financierLogomarkUrl
        ppaBuildingOwnerNoiLifetimeUsd
        ppaOfftakerLifetimeSavingsUsd
        ppaYearOneOfftakerSavingsUsd
        ppaYearOneRoofRentalFee
      }
    }
  }
}
    ${SystemLiteFragmentDoc}
${PvSystemSpecFragmentDoc}
${SystemFragmentDoc}`

export const useMarketplaceBidsRowsQuery = <
  TData = MarketplaceBidsRowsQuery,
  TError = unknown,
>(
  variables: MarketplaceBidsRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceBidsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceBidsRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceBidsRowsQuery, TError, TData>({
    queryKey: ["MarketplaceBidsRows", variables],
    queryFn: publicFetcher<MarketplaceBidsRowsQuery, MarketplaceBidsRowsQueryVariables>(
      MarketplaceBidsRowsDocument,
      variables,
    ),
    ...options,
  })
}

useMarketplaceBidsRowsQuery.getKey = (variables: MarketplaceBidsRowsQueryVariables) => [
  "MarketplaceBidsRows",
  variables,
]

useMarketplaceBidsRowsQuery.rootKey = "MarketplaceBidsRows"

export const useSuspenseMarketplaceBidsRowsQuery = <
  TData = MarketplaceBidsRowsQuery,
  TError = unknown,
>(
  variables: MarketplaceBidsRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceBidsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceBidsRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceBidsRowsQuery, TError, TData>({
    queryKey: ["MarketplaceBidsRowsSuspense", variables],
    queryFn: publicFetcher<MarketplaceBidsRowsQuery, MarketplaceBidsRowsQueryVariables>(
      MarketplaceBidsRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseMarketplaceBidsRowsQuery.getKey = (
  variables: MarketplaceBidsRowsQueryVariables,
) => ["MarketplaceBidsRowsSuspense", variables]

useSuspenseMarketplaceBidsRowsQuery.rootKey = "MarketplaceBidsRows"

export const useInfiniteMarketplaceBidsRowsQuery = <
  TData = InfiniteData<MarketplaceBidsRowsQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidsRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceBidsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceBidsRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceBidsRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceBidsRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceBidsRowsQuery, MarketplaceBidsRowsQueryVariables>(
            MarketplaceBidsRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceBidsRowsQuery.getKey = (
  variables: MarketplaceBidsRowsQueryVariables,
) => ["MarketplaceBidsRows.infinite", variables]

useInfiniteMarketplaceBidsRowsQuery.rootKey = "MarketplaceBidsRows.infinite"

export const useSuspenseInfiniteMarketplaceBidsRowsQuery = <
  TData = InfiniteData<MarketplaceBidsRowsQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidsRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceBidsRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceBidsRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceBidsRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceBidsRows.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceBidsRowsQuery, MarketplaceBidsRowsQueryVariables>(
            MarketplaceBidsRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceBidsRowsQuery.getKey = (
  variables: MarketplaceBidsRowsQueryVariables,
) => ["MarketplaceBidsRows.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceBidsRowsQuery.rootKey = "MarketplaceBidsRows.infinite"

useMarketplaceBidsRowsQuery.fetcher = (
  variables: MarketplaceBidsRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceBidsRowsQuery, MarketplaceBidsRowsQueryVariables>(
    MarketplaceBidsRowsDocument,
    variables,
    options,
  )

export const MarketplacePackageDetailDocument = `
    query MarketplacePackageDetail($orgSlug: String!, $bundlePid: String!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackage(pid: $bundlePid) {
      ...BidPackageDetail
    }
  }
}
    ${BidPackageDetailFragmentDoc}
${BasicBidPackageFragmentDoc}
${InvestorProfileFragmentDoc}`

export const useMarketplacePackageDetailQuery = <
  TData = MarketplacePackageDetailQuery,
  TError = unknown,
>(
  variables: MarketplacePackageDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplacePackageDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplacePackageDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplacePackageDetailQuery, TError, TData>({
    queryKey: ["MarketplacePackageDetail", variables],
    queryFn: publicFetcher<
      MarketplacePackageDetailQuery,
      MarketplacePackageDetailQueryVariables
    >(MarketplacePackageDetailDocument, variables),
    ...options,
  })
}

useMarketplacePackageDetailQuery.getKey = (
  variables: MarketplacePackageDetailQueryVariables,
) => ["MarketplacePackageDetail", variables]

useMarketplacePackageDetailQuery.rootKey = "MarketplacePackageDetail"

export const useSuspenseMarketplacePackageDetailQuery = <
  TData = MarketplacePackageDetailQuery,
  TError = unknown,
>(
  variables: MarketplacePackageDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplacePackageDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplacePackageDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplacePackageDetailQuery, TError, TData>({
    queryKey: ["MarketplacePackageDetailSuspense", variables],
    queryFn: publicFetcher<
      MarketplacePackageDetailQuery,
      MarketplacePackageDetailQueryVariables
    >(MarketplacePackageDetailDocument, variables),
    ...options,
  })
}

useSuspenseMarketplacePackageDetailQuery.getKey = (
  variables: MarketplacePackageDetailQueryVariables,
) => ["MarketplacePackageDetailSuspense", variables]

useSuspenseMarketplacePackageDetailQuery.rootKey = "MarketplacePackageDetail"

export const useInfiniteMarketplacePackageDetailQuery = <
  TData = InfiniteData<MarketplacePackageDetailQuery>,
  TError = unknown,
>(
  variables: MarketplacePackageDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplacePackageDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplacePackageDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplacePackageDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplacePackageDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplacePackageDetailQuery,
            MarketplacePackageDetailQueryVariables
          >(MarketplacePackageDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplacePackageDetailQuery.getKey = (
  variables: MarketplacePackageDetailQueryVariables,
) => ["MarketplacePackageDetail.infinite", variables]

useInfiniteMarketplacePackageDetailQuery.rootKey = "MarketplacePackageDetail.infinite"

export const useSuspenseInfiniteMarketplacePackageDetailQuery = <
  TData = InfiniteData<MarketplacePackageDetailQuery>,
  TError = unknown,
>(
  variables: MarketplacePackageDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplacePackageDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplacePackageDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplacePackageDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplacePackageDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplacePackageDetailQuery,
            MarketplacePackageDetailQueryVariables
          >(MarketplacePackageDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplacePackageDetailQuery.getKey = (
  variables: MarketplacePackageDetailQueryVariables,
) => ["MarketplacePackageDetail.infiniteSuspense", variables]

useSuspenseInfiniteMarketplacePackageDetailQuery.rootKey =
  "MarketplacePackageDetail.infinite"

useMarketplacePackageDetailQuery.fetcher = (
  variables: MarketplacePackageDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplacePackageDetailQuery, MarketplacePackageDetailQueryVariables>(
    MarketplacePackageDetailDocument,
    variables,
    options,
  )

export const MarketplacePackageBidReviewDocument = `
    query MarketplacePackageBidReview($orgSlug: String!, $bundlePid: String!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackage(pid: $bundlePid) {
      bidReview {
        ...BidReview
      }
    }
  }
}
    ${BidReviewFragmentDoc}
${BidReportFragmentDoc}
${CsSiteBidReportFragmentDoc}
${InvestorProfileFragmentDoc}
${BoxplotStatsFragmentDoc}
${PpaSiteBidReportFragmentDoc}`

export const useMarketplacePackageBidReviewQuery = <
  TData = MarketplacePackageBidReviewQuery,
  TError = unknown,
>(
  variables: MarketplacePackageBidReviewQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplacePackageBidReviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MarketplacePackageBidReviewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<MarketplacePackageBidReviewQuery, TError, TData>({
    queryKey: ["MarketplacePackageBidReview", variables],
    queryFn: publicFetcher<
      MarketplacePackageBidReviewQuery,
      MarketplacePackageBidReviewQueryVariables
    >(MarketplacePackageBidReviewDocument, variables),
    ...options,
  })
}

useMarketplacePackageBidReviewQuery.getKey = (
  variables: MarketplacePackageBidReviewQueryVariables,
) => ["MarketplacePackageBidReview", variables]

useMarketplacePackageBidReviewQuery.rootKey = "MarketplacePackageBidReview"

export const useSuspenseMarketplacePackageBidReviewQuery = <
  TData = MarketplacePackageBidReviewQuery,
  TError = unknown,
>(
  variables: MarketplacePackageBidReviewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplacePackageBidReviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplacePackageBidReviewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplacePackageBidReviewQuery, TError, TData>({
    queryKey: ["MarketplacePackageBidReviewSuspense", variables],
    queryFn: publicFetcher<
      MarketplacePackageBidReviewQuery,
      MarketplacePackageBidReviewQueryVariables
    >(MarketplacePackageBidReviewDocument, variables),
    ...options,
  })
}

useSuspenseMarketplacePackageBidReviewQuery.getKey = (
  variables: MarketplacePackageBidReviewQueryVariables,
) => ["MarketplacePackageBidReviewSuspense", variables]

useSuspenseMarketplacePackageBidReviewQuery.rootKey = "MarketplacePackageBidReview"

export const useInfiniteMarketplacePackageBidReviewQuery = <
  TData = InfiniteData<MarketplacePackageBidReviewQuery>,
  TError = unknown,
>(
  variables: MarketplacePackageBidReviewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplacePackageBidReviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplacePackageBidReviewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplacePackageBidReviewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplacePackageBidReview.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplacePackageBidReviewQuery,
            MarketplacePackageBidReviewQueryVariables
          >(MarketplacePackageBidReviewDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplacePackageBidReviewQuery.getKey = (
  variables: MarketplacePackageBidReviewQueryVariables,
) => ["MarketplacePackageBidReview.infinite", variables]

useInfiniteMarketplacePackageBidReviewQuery.rootKey =
  "MarketplacePackageBidReview.infinite"

export const useSuspenseInfiniteMarketplacePackageBidReviewQuery = <
  TData = InfiniteData<MarketplacePackageBidReviewQuery>,
  TError = unknown,
>(
  variables: MarketplacePackageBidReviewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplacePackageBidReviewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplacePackageBidReviewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplacePackageBidReviewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplacePackageBidReview.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplacePackageBidReviewQuery,
            MarketplacePackageBidReviewQueryVariables
          >(MarketplacePackageBidReviewDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplacePackageBidReviewQuery.getKey = (
  variables: MarketplacePackageBidReviewQueryVariables,
) => ["MarketplacePackageBidReview.infiniteSuspense", variables]

useSuspenseInfiniteMarketplacePackageBidReviewQuery.rootKey =
  "MarketplacePackageBidReview.infinite"

useMarketplacePackageBidReviewQuery.fetcher = (
  variables: MarketplacePackageBidReviewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    MarketplacePackageBidReviewQuery,
    MarketplacePackageBidReviewQueryVariables
  >(MarketplacePackageBidReviewDocument, variables, options)

export const MarketplacePackageRowDetailDocument = `
    query MarketplacePackageRowDetail($orgSlug: String!, $bundlePid: String!, $sitePid: String!) {
  org: orgBySlug(slug: $orgSlug) {
    bidPackage(pid: $bundlePid) {
      ...BidPackageDetail
      row(pid: $sitePid) {
        status
        closedAt
        closeReason
        closeCustomReason
        site {
          pid
          name
          isFavorite
          streetAddress
          city
          state
          zipCode
          county
          fullAddress
          targetUtility {
            name
          }
          doeReferenceType
          yearBuilt
          sqft
          numStories
          buildingClass
          roofSqft
          siteDetails {
            roofReplacedYr
            roofCondition
          }
          roofMaxPvKw
          meterSet {
            loadKwh
            totalCost
          }
        }
      }
    }
  }
}
    ${BidPackageDetailFragmentDoc}
${BasicBidPackageFragmentDoc}
${InvestorProfileFragmentDoc}`

export const useMarketplacePackageRowDetailQuery = <
  TData = MarketplacePackageRowDetailQuery,
  TError = unknown,
>(
  variables: MarketplacePackageRowDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplacePackageRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      MarketplacePackageRowDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<MarketplacePackageRowDetailQuery, TError, TData>({
    queryKey: ["MarketplacePackageRowDetail", variables],
    queryFn: publicFetcher<
      MarketplacePackageRowDetailQuery,
      MarketplacePackageRowDetailQueryVariables
    >(MarketplacePackageRowDetailDocument, variables),
    ...options,
  })
}

useMarketplacePackageRowDetailQuery.getKey = (
  variables: MarketplacePackageRowDetailQueryVariables,
) => ["MarketplacePackageRowDetail", variables]

useMarketplacePackageRowDetailQuery.rootKey = "MarketplacePackageRowDetail"

export const useSuspenseMarketplacePackageRowDetailQuery = <
  TData = MarketplacePackageRowDetailQuery,
  TError = unknown,
>(
  variables: MarketplacePackageRowDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplacePackageRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplacePackageRowDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplacePackageRowDetailQuery, TError, TData>({
    queryKey: ["MarketplacePackageRowDetailSuspense", variables],
    queryFn: publicFetcher<
      MarketplacePackageRowDetailQuery,
      MarketplacePackageRowDetailQueryVariables
    >(MarketplacePackageRowDetailDocument, variables),
    ...options,
  })
}

useSuspenseMarketplacePackageRowDetailQuery.getKey = (
  variables: MarketplacePackageRowDetailQueryVariables,
) => ["MarketplacePackageRowDetailSuspense", variables]

useSuspenseMarketplacePackageRowDetailQuery.rootKey = "MarketplacePackageRowDetail"

export const useInfiniteMarketplacePackageRowDetailQuery = <
  TData = InfiniteData<MarketplacePackageRowDetailQuery>,
  TError = unknown,
>(
  variables: MarketplacePackageRowDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplacePackageRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplacePackageRowDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplacePackageRowDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplacePackageRowDetail.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplacePackageRowDetailQuery,
            MarketplacePackageRowDetailQueryVariables
          >(MarketplacePackageRowDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplacePackageRowDetailQuery.getKey = (
  variables: MarketplacePackageRowDetailQueryVariables,
) => ["MarketplacePackageRowDetail.infinite", variables]

useInfiniteMarketplacePackageRowDetailQuery.rootKey =
  "MarketplacePackageRowDetail.infinite"

export const useSuspenseInfiniteMarketplacePackageRowDetailQuery = <
  TData = InfiniteData<MarketplacePackageRowDetailQuery>,
  TError = unknown,
>(
  variables: MarketplacePackageRowDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplacePackageRowDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplacePackageRowDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplacePackageRowDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplacePackageRowDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            MarketplacePackageRowDetailQuery,
            MarketplacePackageRowDetailQueryVariables
          >(MarketplacePackageRowDetailDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplacePackageRowDetailQuery.getKey = (
  variables: MarketplacePackageRowDetailQueryVariables,
) => ["MarketplacePackageRowDetail.infiniteSuspense", variables]

useSuspenseInfiniteMarketplacePackageRowDetailQuery.rootKey =
  "MarketplacePackageRowDetail.infinite"

useMarketplacePackageRowDetailQuery.fetcher = (
  variables: MarketplacePackageRowDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    MarketplacePackageRowDetailQuery,
    MarketplacePackageRowDetailQueryVariables
  >(MarketplacePackageRowDetailDocument, variables, options)

export const MarketplaceBidDetailDocument = `
    query MarketplaceBidDetail($orgSlug: String!, $bidPid: String!) {
  org: orgBySlug(slug: $orgSlug) {
    bid(pid: $bidPid) {
      ...InvestorBid
      ppa {
        site {
          ...BidRevampSite
        }
        financier {
          pid
          name
          orgSlug
          logoUrl
          logomarkUrl
        }
      }
      cs {
        site {
          ...BidRevampSite
        }
        financier {
          pid
          name
          orgSlug
          logoUrl
          logomarkUrl
        }
      }
    }
  }
}
    ${InvestorBidFragmentDoc}
${PpaInvestorBidFragmentDoc}
${InvestorProfileFragmentDoc}
${SystemFragmentDoc}
${PvSystemSpecFragmentDoc}
${RevampFinmodelFragmentDoc}
${KwhFlowFragmentDoc}
${RevampSystemFragmentDoc}
${FinmodelCostFragmentDoc}
${CsInvestorBidFragmentDoc}
${SystemLiteFragmentDoc}
${RevampCsFragmentDoc}
${BidRevampSiteFragmentDoc}`

export const useMarketplaceBidDetailQuery = <
  TData = MarketplaceBidDetailQuery,
  TError = unknown,
>(
  variables: MarketplaceBidDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<MarketplaceBidDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<MarketplaceBidDetailQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<MarketplaceBidDetailQuery, TError, TData>({
    queryKey: ["MarketplaceBidDetail", variables],
    queryFn: publicFetcher<
      MarketplaceBidDetailQuery,
      MarketplaceBidDetailQueryVariables
    >(MarketplaceBidDetailDocument, variables),
    ...options,
  })
}

useMarketplaceBidDetailQuery.getKey = (
  variables: MarketplaceBidDetailQueryVariables,
) => ["MarketplaceBidDetail", variables]

useMarketplaceBidDetailQuery.rootKey = "MarketplaceBidDetail"

export const useSuspenseMarketplaceBidDetailQuery = <
  TData = MarketplaceBidDetailQuery,
  TError = unknown,
>(
  variables: MarketplaceBidDetailQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<MarketplaceBidDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      MarketplaceBidDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<MarketplaceBidDetailQuery, TError, TData>({
    queryKey: ["MarketplaceBidDetailSuspense", variables],
    queryFn: publicFetcher<
      MarketplaceBidDetailQuery,
      MarketplaceBidDetailQueryVariables
    >(MarketplaceBidDetailDocument, variables),
    ...options,
  })
}

useSuspenseMarketplaceBidDetailQuery.getKey = (
  variables: MarketplaceBidDetailQueryVariables,
) => ["MarketplaceBidDetailSuspense", variables]

useSuspenseMarketplaceBidDetailQuery.rootKey = "MarketplaceBidDetail"

export const useInfiniteMarketplaceBidDetailQuery = <
  TData = InfiniteData<MarketplaceBidDetailQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidDetailQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<MarketplaceBidDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      MarketplaceBidDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<MarketplaceBidDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["MarketplaceBidDetail.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceBidDetailQuery, MarketplaceBidDetailQueryVariables>(
            MarketplaceBidDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteMarketplaceBidDetailQuery.getKey = (
  variables: MarketplaceBidDetailQueryVariables,
) => ["MarketplaceBidDetail.infinite", variables]

useInfiniteMarketplaceBidDetailQuery.rootKey = "MarketplaceBidDetail.infinite"

export const useSuspenseInfiniteMarketplaceBidDetailQuery = <
  TData = InfiniteData<MarketplaceBidDetailQuery>,
  TError = unknown,
>(
  variables: MarketplaceBidDetailQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<MarketplaceBidDetailQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      MarketplaceBidDetailQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<MarketplaceBidDetailQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "MarketplaceBidDetail.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<MarketplaceBidDetailQuery, MarketplaceBidDetailQueryVariables>(
            MarketplaceBidDetailDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteMarketplaceBidDetailQuery.getKey = (
  variables: MarketplaceBidDetailQueryVariables,
) => ["MarketplaceBidDetail.infiniteSuspense", variables]

useSuspenseInfiniteMarketplaceBidDetailQuery.rootKey = "MarketplaceBidDetail.infinite"

useMarketplaceBidDetailQuery.fetcher = (
  variables: MarketplaceBidDetailQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<MarketplaceBidDetailQuery, MarketplaceBidDetailQueryVariables>(
    MarketplaceBidDetailDocument,
    variables,
    options,
  )

export const CurrentUserGoogleAccessDocument = `
    query CurrentUserGoogleAccess {
  currentUser {
    pid
    hasGoogleAccessToken
  }
}
    `

export const useCurrentUserGoogleAccessQuery = <
  TData = CurrentUserGoogleAccessQuery,
  TError = unknown,
>(
  variables?: CurrentUserGoogleAccessQueryVariables,
  options?: Omit<
    UseQueryOptions<CurrentUserGoogleAccessQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<CurrentUserGoogleAccessQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CurrentUserGoogleAccessQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["CurrentUserGoogleAccess"]
        : ["CurrentUserGoogleAccess", variables],
    queryFn: publicFetcher<
      CurrentUserGoogleAccessQuery,
      CurrentUserGoogleAccessQueryVariables
    >(CurrentUserGoogleAccessDocument, variables),
    ...options,
  })
}

useCurrentUserGoogleAccessQuery.getKey = (
  variables?: CurrentUserGoogleAccessQueryVariables,
) =>
  variables === undefined
    ? ["CurrentUserGoogleAccess"]
    : ["CurrentUserGoogleAccess", variables]

useCurrentUserGoogleAccessQuery.rootKey = "CurrentUserGoogleAccess"

export const useSuspenseCurrentUserGoogleAccessQuery = <
  TData = CurrentUserGoogleAccessQuery,
  TError = unknown,
>(
  variables?: CurrentUserGoogleAccessQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CurrentUserGoogleAccessQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CurrentUserGoogleAccessQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<CurrentUserGoogleAccessQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["CurrentUserGoogleAccessSuspense"]
        : ["CurrentUserGoogleAccessSuspense", variables],
    queryFn: publicFetcher<
      CurrentUserGoogleAccessQuery,
      CurrentUserGoogleAccessQueryVariables
    >(CurrentUserGoogleAccessDocument, variables),
    ...options,
  })
}

useSuspenseCurrentUserGoogleAccessQuery.getKey = (
  variables?: CurrentUserGoogleAccessQueryVariables,
) =>
  variables === undefined
    ? ["CurrentUserGoogleAccessSuspense"]
    : ["CurrentUserGoogleAccessSuspense", variables]

useSuspenseCurrentUserGoogleAccessQuery.rootKey = "CurrentUserGoogleAccess"

export const useInfiniteCurrentUserGoogleAccessQuery = <
  TData = InfiniteData<CurrentUserGoogleAccessQuery>,
  TError = unknown,
>(
  variables: CurrentUserGoogleAccessQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CurrentUserGoogleAccessQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CurrentUserGoogleAccessQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<CurrentUserGoogleAccessQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["CurrentUserGoogleAccess.infinite"]
            : ["CurrentUserGoogleAccess.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            CurrentUserGoogleAccessQuery,
            CurrentUserGoogleAccessQueryVariables
          >(CurrentUserGoogleAccessDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCurrentUserGoogleAccessQuery.getKey = (
  variables?: CurrentUserGoogleAccessQueryVariables,
) =>
  variables === undefined
    ? ["CurrentUserGoogleAccess.infinite"]
    : ["CurrentUserGoogleAccess.infinite", variables]

useInfiniteCurrentUserGoogleAccessQuery.rootKey = "CurrentUserGoogleAccess.infinite"

export const useSuspenseInfiniteCurrentUserGoogleAccessQuery = <
  TData = InfiniteData<CurrentUserGoogleAccessQuery>,
  TError = unknown,
>(
  variables: CurrentUserGoogleAccessQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CurrentUserGoogleAccessQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CurrentUserGoogleAccessQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CurrentUserGoogleAccessQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["CurrentUserGoogleAccess.infiniteSuspense"]
            : ["CurrentUserGoogleAccess.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<
            CurrentUserGoogleAccessQuery,
            CurrentUserGoogleAccessQueryVariables
          >(CurrentUserGoogleAccessDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCurrentUserGoogleAccessQuery.getKey = (
  variables?: CurrentUserGoogleAccessQueryVariables,
) =>
  variables === undefined
    ? ["CurrentUserGoogleAccess.infiniteSuspense"]
    : ["CurrentUserGoogleAccess.infiniteSuspense", variables]

useSuspenseInfiniteCurrentUserGoogleAccessQuery.rootKey =
  "CurrentUserGoogleAccess.infinite"

useCurrentUserGoogleAccessQuery.fetcher = (
  variables?: CurrentUserGoogleAccessQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CurrentUserGoogleAccessQuery, CurrentUserGoogleAccessQueryVariables>(
    CurrentUserGoogleAccessDocument,
    variables,
    options,
  )

export const AwardedProjectsTableViewDocument = `
    query AwardedProjectsTableView($orgSlug: String!, $filterBy: AwardedProjectTableFilter, $sortBy: [AwardedProjectTableSort!]) {
  orgBySlug(slug: $orgSlug) {
    pid
    awardedProjects {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
        stats {
          buildingOwners
        }
      }
    }
  }
}
    `

export const useAwardedProjectsTableViewQuery = <
  TData = AwardedProjectsTableViewQuery,
  TError = unknown,
>(
  variables: AwardedProjectsTableViewQueryVariables,
  options?: Omit<
    UseQueryOptions<AwardedProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AwardedProjectsTableViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AwardedProjectsTableViewQuery, TError, TData>({
    queryKey: ["AwardedProjectsTableView", variables],
    queryFn: publicFetcher<
      AwardedProjectsTableViewQuery,
      AwardedProjectsTableViewQueryVariables
    >(AwardedProjectsTableViewDocument, variables),
    ...options,
  })
}

useAwardedProjectsTableViewQuery.getKey = (
  variables: AwardedProjectsTableViewQueryVariables,
) => ["AwardedProjectsTableView", variables]

useAwardedProjectsTableViewQuery.rootKey = "AwardedProjectsTableView"

export const useSuspenseAwardedProjectsTableViewQuery = <
  TData = AwardedProjectsTableViewQuery,
  TError = unknown,
>(
  variables: AwardedProjectsTableViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AwardedProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AwardedProjectsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AwardedProjectsTableViewQuery, TError, TData>({
    queryKey: ["AwardedProjectsTableViewSuspense", variables],
    queryFn: publicFetcher<
      AwardedProjectsTableViewQuery,
      AwardedProjectsTableViewQueryVariables
    >(AwardedProjectsTableViewDocument, variables),
    ...options,
  })
}

useSuspenseAwardedProjectsTableViewQuery.getKey = (
  variables: AwardedProjectsTableViewQueryVariables,
) => ["AwardedProjectsTableViewSuspense", variables]

useSuspenseAwardedProjectsTableViewQuery.rootKey = "AwardedProjectsTableView"

export const useInfiniteAwardedProjectsTableViewQuery = <
  TData = InfiniteData<AwardedProjectsTableViewQuery>,
  TError = unknown,
>(
  variables: AwardedProjectsTableViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AwardedProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AwardedProjectsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AwardedProjectsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AwardedProjectsTableView.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            AwardedProjectsTableViewQuery,
            AwardedProjectsTableViewQueryVariables
          >(AwardedProjectsTableViewDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAwardedProjectsTableViewQuery.getKey = (
  variables: AwardedProjectsTableViewQueryVariables,
) => ["AwardedProjectsTableView.infinite", variables]

useInfiniteAwardedProjectsTableViewQuery.rootKey = "AwardedProjectsTableView.infinite"

export const useSuspenseInfiniteAwardedProjectsTableViewQuery = <
  TData = InfiniteData<AwardedProjectsTableViewQuery>,
  TError = unknown,
>(
  variables: AwardedProjectsTableViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AwardedProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AwardedProjectsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AwardedProjectsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "AwardedProjectsTableView.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            AwardedProjectsTableViewQuery,
            AwardedProjectsTableViewQueryVariables
          >(AwardedProjectsTableViewDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAwardedProjectsTableViewQuery.getKey = (
  variables: AwardedProjectsTableViewQueryVariables,
) => ["AwardedProjectsTableView.infiniteSuspense", variables]

useSuspenseInfiniteAwardedProjectsTableViewQuery.rootKey =
  "AwardedProjectsTableView.infinite"

useAwardedProjectsTableViewQuery.fetcher = (
  variables: AwardedProjectsTableViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AwardedProjectsTableViewQuery, AwardedProjectsTableViewQueryVariables>(
    AwardedProjectsTableViewDocument,
    variables,
    options,
  )

export const AwardedProjectsTableRowsDocument = `
    query AwardedProjectsTableRows($orgSlug: String!, $keys: [Int!]!) {
  orgBySlug(slug: $orgSlug) {
    awardedProjects {
      rows(keys: $keys) {
        id
        orgName
        sitePid
        name
        streetAddress
        city
        state
        zipCode
        bundlePid
        bidPackagePid
        packageRowStatus
        packageRowIsClosed
        packageRowClosedAt
        packageRowCloseReason
        packageRowCloseCustomReason
        estimatedCod
        estimatedNtp
        lumenRevenue
        csEstimatedAwardDate
        pvSizeKwDc
        pvSizeKwAc
        pvTypes
        rofoSignedDate
        rofoSignedEstimated
        rofoSignedActual
        preBidMeetingDate
        preBidMeetingEstimated
        preBidMeetingActual
        biddingOpenedDate
        biddingOpenedEstimated
        biddingOpenedActual
        biddingClosedDate
        biddingClosedEstimated
        biddingClosedActual
        bidsPresentedDate
        bidsPresentedEstimated
        bidsPresentedActual
        ixSubmittedDate
        ixSubmittedEstimated
        ixSubmittedActual
        ixApprovedDate
        ixApprovedEstimated
        ixApprovedActual
        csProgramSubmittedDate
        csProgramSubmittedEstimated
        csProgramSubmittedActual
        csProgramApprovedDate
        csProgramApprovedEstimated
        csProgramApprovedActual
        awardedToDeveloperDate
        awardedToDeveloperEstimated
        awardedToDeveloperActual
        leaseSignedDate
        leaseSignedEstimated
        leaseSignedActual
        ntpDate
        ntpEstimated
        ntpActual
        codDate
        codEstimated
        codActual
      }
    }
  }
}
    `

export const useAwardedProjectsTableRowsQuery = <
  TData = AwardedProjectsTableRowsQuery,
  TError = unknown,
>(
  variables: AwardedProjectsTableRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<AwardedProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<AwardedProjectsTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AwardedProjectsTableRowsQuery, TError, TData>({
    queryKey: ["AwardedProjectsTableRows", variables],
    queryFn: publicFetcher<
      AwardedProjectsTableRowsQuery,
      AwardedProjectsTableRowsQueryVariables
    >(AwardedProjectsTableRowsDocument, variables),
    ...options,
  })
}

useAwardedProjectsTableRowsQuery.getKey = (
  variables: AwardedProjectsTableRowsQueryVariables,
) => ["AwardedProjectsTableRows", variables]

useAwardedProjectsTableRowsQuery.rootKey = "AwardedProjectsTableRows"

export const useSuspenseAwardedProjectsTableRowsQuery = <
  TData = AwardedProjectsTableRowsQuery,
  TError = unknown,
>(
  variables: AwardedProjectsTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AwardedProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      AwardedProjectsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<AwardedProjectsTableRowsQuery, TError, TData>({
    queryKey: ["AwardedProjectsTableRowsSuspense", variables],
    queryFn: publicFetcher<
      AwardedProjectsTableRowsQuery,
      AwardedProjectsTableRowsQueryVariables
    >(AwardedProjectsTableRowsDocument, variables),
    ...options,
  })
}

useSuspenseAwardedProjectsTableRowsQuery.getKey = (
  variables: AwardedProjectsTableRowsQueryVariables,
) => ["AwardedProjectsTableRowsSuspense", variables]

useSuspenseAwardedProjectsTableRowsQuery.rootKey = "AwardedProjectsTableRows"

export const useInfiniteAwardedProjectsTableRowsQuery = <
  TData = InfiniteData<AwardedProjectsTableRowsQuery>,
  TError = unknown,
>(
  variables: AwardedProjectsTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<AwardedProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      AwardedProjectsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<AwardedProjectsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["AwardedProjectsTableRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            AwardedProjectsTableRowsQuery,
            AwardedProjectsTableRowsQueryVariables
          >(AwardedProjectsTableRowsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAwardedProjectsTableRowsQuery.getKey = (
  variables: AwardedProjectsTableRowsQueryVariables,
) => ["AwardedProjectsTableRows.infinite", variables]

useInfiniteAwardedProjectsTableRowsQuery.rootKey = "AwardedProjectsTableRows.infinite"

export const useSuspenseInfiniteAwardedProjectsTableRowsQuery = <
  TData = InfiniteData<AwardedProjectsTableRowsQuery>,
  TError = unknown,
>(
  variables: AwardedProjectsTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AwardedProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AwardedProjectsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AwardedProjectsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "AwardedProjectsTableRows.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            AwardedProjectsTableRowsQuery,
            AwardedProjectsTableRowsQueryVariables
          >(AwardedProjectsTableRowsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAwardedProjectsTableRowsQuery.getKey = (
  variables: AwardedProjectsTableRowsQueryVariables,
) => ["AwardedProjectsTableRows.infiniteSuspense", variables]

useSuspenseInfiniteAwardedProjectsTableRowsQuery.rootKey =
  "AwardedProjectsTableRows.infinite"

useAwardedProjectsTableRowsQuery.fetcher = (
  variables: AwardedProjectsTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AwardedProjectsTableRowsQuery, AwardedProjectsTableRowsQueryVariables>(
    AwardedProjectsTableRowsDocument,
    variables,
    options,
  )

export const FinancierProjectsTableViewDocument = `
    query FinancierProjectsTableView($orgSlug: String!, $filterBy: FinancierProjectTableFilter, $sortBy: [FinancierProjectTableSort!]) {
  orgBySlug(slug: $orgSlug) {
    pid
    financierProjects {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
        stats {
          buildingOwners
        }
      }
    }
  }
}
    `

export const useFinancierProjectsTableViewQuery = <
  TData = FinancierProjectsTableViewQuery,
  TError = unknown,
>(
  variables: FinancierProjectsTableViewQueryVariables,
  options?: Omit<
    UseQueryOptions<FinancierProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      FinancierProjectsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<FinancierProjectsTableViewQuery, TError, TData>({
    queryKey: ["FinancierProjectsTableView", variables],
    queryFn: publicFetcher<
      FinancierProjectsTableViewQuery,
      FinancierProjectsTableViewQueryVariables
    >(FinancierProjectsTableViewDocument, variables),
    ...options,
  })
}

useFinancierProjectsTableViewQuery.getKey = (
  variables: FinancierProjectsTableViewQueryVariables,
) => ["FinancierProjectsTableView", variables]

useFinancierProjectsTableViewQuery.rootKey = "FinancierProjectsTableView"

export const useSuspenseFinancierProjectsTableViewQuery = <
  TData = FinancierProjectsTableViewQuery,
  TError = unknown,
>(
  variables: FinancierProjectsTableViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinancierProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinancierProjectsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinancierProjectsTableViewQuery, TError, TData>({
    queryKey: ["FinancierProjectsTableViewSuspense", variables],
    queryFn: publicFetcher<
      FinancierProjectsTableViewQuery,
      FinancierProjectsTableViewQueryVariables
    >(FinancierProjectsTableViewDocument, variables),
    ...options,
  })
}

useSuspenseFinancierProjectsTableViewQuery.getKey = (
  variables: FinancierProjectsTableViewQueryVariables,
) => ["FinancierProjectsTableViewSuspense", variables]

useSuspenseFinancierProjectsTableViewQuery.rootKey = "FinancierProjectsTableView"

export const useInfiniteFinancierProjectsTableViewQuery = <
  TData = InfiniteData<FinancierProjectsTableViewQuery>,
  TError = unknown,
>(
  variables: FinancierProjectsTableViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinancierProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinancierProjectsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinancierProjectsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinancierProjectsTableView.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierProjectsTableViewQuery,
            FinancierProjectsTableViewQueryVariables
          >(FinancierProjectsTableViewDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinancierProjectsTableViewQuery.getKey = (
  variables: FinancierProjectsTableViewQueryVariables,
) => ["FinancierProjectsTableView.infinite", variables]

useInfiniteFinancierProjectsTableViewQuery.rootKey =
  "FinancierProjectsTableView.infinite"

export const useSuspenseInfiniteFinancierProjectsTableViewQuery = <
  TData = InfiniteData<FinancierProjectsTableViewQuery>,
  TError = unknown,
>(
  variables: FinancierProjectsTableViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinancierProjectsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinancierProjectsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinancierProjectsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinancierProjectsTableView.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierProjectsTableViewQuery,
            FinancierProjectsTableViewQueryVariables
          >(FinancierProjectsTableViewDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinancierProjectsTableViewQuery.getKey = (
  variables: FinancierProjectsTableViewQueryVariables,
) => ["FinancierProjectsTableView.infiniteSuspense", variables]

useSuspenseInfiniteFinancierProjectsTableViewQuery.rootKey =
  "FinancierProjectsTableView.infinite"

useFinancierProjectsTableViewQuery.fetcher = (
  variables: FinancierProjectsTableViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    FinancierProjectsTableViewQuery,
    FinancierProjectsTableViewQueryVariables
  >(FinancierProjectsTableViewDocument, variables, options)

export const FinancierProjectsTableRowsDocument = `
    query FinancierProjectsTableRows($orgSlug: String!, $keys: [Int!]!) {
  orgBySlug(slug: $orgSlug) {
    financierProjects {
      rows(keys: $keys) {
        id
        sitePid
        bundlePid
        orgName
        name
        streetAddress
        city
        state
        zipCode
        bundleName
        bundleType
        bundleBiddingOpenAt
        bundleBiddingClosedAt
        bundleRowState
        bundleRowIsClosed
        bundleRowCloseReason
        bundleRowCloseCustomReason
        bidStatuses
        optedOut
      }
    }
  }
}
    `

export const useFinancierProjectsTableRowsQuery = <
  TData = FinancierProjectsTableRowsQuery,
  TError = unknown,
>(
  variables: FinancierProjectsTableRowsQueryVariables,
  options?: Omit<
    UseQueryOptions<FinancierProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      FinancierProjectsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<FinancierProjectsTableRowsQuery, TError, TData>({
    queryKey: ["FinancierProjectsTableRows", variables],
    queryFn: publicFetcher<
      FinancierProjectsTableRowsQuery,
      FinancierProjectsTableRowsQueryVariables
    >(FinancierProjectsTableRowsDocument, variables),
    ...options,
  })
}

useFinancierProjectsTableRowsQuery.getKey = (
  variables: FinancierProjectsTableRowsQueryVariables,
) => ["FinancierProjectsTableRows", variables]

useFinancierProjectsTableRowsQuery.rootKey = "FinancierProjectsTableRows"

export const useSuspenseFinancierProjectsTableRowsQuery = <
  TData = FinancierProjectsTableRowsQuery,
  TError = unknown,
>(
  variables: FinancierProjectsTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<FinancierProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      FinancierProjectsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<FinancierProjectsTableRowsQuery, TError, TData>({
    queryKey: ["FinancierProjectsTableRowsSuspense", variables],
    queryFn: publicFetcher<
      FinancierProjectsTableRowsQuery,
      FinancierProjectsTableRowsQueryVariables
    >(FinancierProjectsTableRowsDocument, variables),
    ...options,
  })
}

useSuspenseFinancierProjectsTableRowsQuery.getKey = (
  variables: FinancierProjectsTableRowsQueryVariables,
) => ["FinancierProjectsTableRowsSuspense", variables]

useSuspenseFinancierProjectsTableRowsQuery.rootKey = "FinancierProjectsTableRows"

export const useInfiniteFinancierProjectsTableRowsQuery = <
  TData = InfiniteData<FinancierProjectsTableRowsQuery>,
  TError = unknown,
>(
  variables: FinancierProjectsTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<FinancierProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      FinancierProjectsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<FinancierProjectsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["FinancierProjectsTableRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierProjectsTableRowsQuery,
            FinancierProjectsTableRowsQueryVariables
          >(FinancierProjectsTableRowsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteFinancierProjectsTableRowsQuery.getKey = (
  variables: FinancierProjectsTableRowsQueryVariables,
) => ["FinancierProjectsTableRows.infinite", variables]

useInfiniteFinancierProjectsTableRowsQuery.rootKey =
  "FinancierProjectsTableRows.infinite"

export const useSuspenseInfiniteFinancierProjectsTableRowsQuery = <
  TData = InfiniteData<FinancierProjectsTableRowsQuery>,
  TError = unknown,
>(
  variables: FinancierProjectsTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<FinancierProjectsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      FinancierProjectsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<FinancierProjectsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "FinancierProjectsTableRows.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            FinancierProjectsTableRowsQuery,
            FinancierProjectsTableRowsQueryVariables
          >(FinancierProjectsTableRowsDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteFinancierProjectsTableRowsQuery.getKey = (
  variables: FinancierProjectsTableRowsQueryVariables,
) => ["FinancierProjectsTableRows.infiniteSuspense", variables]

useSuspenseInfiniteFinancierProjectsTableRowsQuery.rootKey =
  "FinancierProjectsTableRows.infinite"

useFinancierProjectsTableRowsQuery.fetcher = (
  variables: FinancierProjectsTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    FinancierProjectsTableRowsQuery,
    FinancierProjectsTableRowsQueryVariables
  >(FinancierProjectsTableRowsDocument, variables, options)

export const SiteBidsTableViewDocument = `
    query SiteBidsTableView($orgSlug: String!, $sitePid: String!, $filterBy: SiteBidsTableFilter, $sortBy: [SiteBidsTableSort!]) {
  orgBySlug(slug: $orgSlug) {
    siteBids(sitePid: $sitePid) {
      view(filterBy: $filterBy, sortBy: $sortBy) {
        keys
        count
      }
    }
  }
}
    `

export const useSiteBidsTableViewQuery = <
  TData = SiteBidsTableViewQuery,
  TError = unknown,
>(
  variables: SiteBidsTableViewQueryVariables,
  options?: Omit<UseQueryOptions<SiteBidsTableViewQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteBidsTableViewQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteBidsTableViewQuery, TError, TData>({
    queryKey: ["SiteBidsTableView", variables],
    queryFn: publicFetcher<SiteBidsTableViewQuery, SiteBidsTableViewQueryVariables>(
      SiteBidsTableViewDocument,
      variables,
    ),
    ...options,
  })
}

useSiteBidsTableViewQuery.getKey = (variables: SiteBidsTableViewQueryVariables) => [
  "SiteBidsTableView",
  variables,
]

useSiteBidsTableViewQuery.rootKey = "SiteBidsTableView"

export const useSuspenseSiteBidsTableViewQuery = <
  TData = SiteBidsTableViewQuery,
  TError = unknown,
>(
  variables: SiteBidsTableViewQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteBidsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteBidsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteBidsTableViewQuery, TError, TData>({
    queryKey: ["SiteBidsTableViewSuspense", variables],
    queryFn: publicFetcher<SiteBidsTableViewQuery, SiteBidsTableViewQueryVariables>(
      SiteBidsTableViewDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteBidsTableViewQuery.getKey = (
  variables: SiteBidsTableViewQueryVariables,
) => ["SiteBidsTableViewSuspense", variables]

useSuspenseSiteBidsTableViewQuery.rootKey = "SiteBidsTableView"

export const useInfiniteSiteBidsTableViewQuery = <
  TData = InfiniteData<SiteBidsTableViewQuery>,
  TError = unknown,
>(
  variables: SiteBidsTableViewQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteBidsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteBidsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteBidsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBidsTableView.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteBidsTableViewQuery, SiteBidsTableViewQueryVariables>(
            SiteBidsTableViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteBidsTableViewQuery.getKey = (
  variables: SiteBidsTableViewQueryVariables,
) => ["SiteBidsTableView.infinite", variables]

useInfiniteSiteBidsTableViewQuery.rootKey = "SiteBidsTableView.infinite"

export const useSuspenseInfiniteSiteBidsTableViewQuery = <
  TData = InfiniteData<SiteBidsTableViewQuery>,
  TError = unknown,
>(
  variables: SiteBidsTableViewQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteBidsTableViewQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteBidsTableViewQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteBidsTableViewQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBidsTableView.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteBidsTableViewQuery, SiteBidsTableViewQueryVariables>(
            SiteBidsTableViewDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteBidsTableViewQuery.getKey = (
  variables: SiteBidsTableViewQueryVariables,
) => ["SiteBidsTableView.infiniteSuspense", variables]

useSuspenseInfiniteSiteBidsTableViewQuery.rootKey = "SiteBidsTableView.infinite"

useSiteBidsTableViewQuery.fetcher = (
  variables: SiteBidsTableViewQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteBidsTableViewQuery, SiteBidsTableViewQueryVariables>(
    SiteBidsTableViewDocument,
    variables,
    options,
  )

export const SiteBidsTableRowsDocument = `
    query SiteBidsTableRows($orgSlug: String!, $sitePid: String!, $keys: [Int!]!) {
  orgBySlug(slug: $orgSlug) {
    siteBids(sitePid: $sitePid) {
      rows(keys: $keys) {
        id
        bidPackagePid
        bundlePid
        bidPackageName
        name
        isAwarded
        isCustom
        packageRowStatus
        packageRowIsClosed
        packageRowClosedAt
        packageRowCloseReason
        packageRowCloseCustomReason
        estimatedCod
        estimatedNtp
        csEstimatedAwardDate
        pvSizeKwDc
        pvSizeKwAc
        pvTypes
        termYears
        roofRentY1Usd
        roofRentEscalator
        buildingOwnerExtraPaymentsUsd
        extraPaymentsNotes
        buildingOwnerNoiLifetimeUsd
        interconnectionCostUtilityMaxUsd
        interconnectionCostUtilityMinUsd
        interconnectionCostNonUtilityUsd
        interconnectionCostUsdPerWatt
        interconnectionNotes
        itcPercentageAssumption
        recOwner
        incentivesNotes
        otherNotes
      }
    }
  }
}
    `

export const useSiteBidsTableRowsQuery = <
  TData = SiteBidsTableRowsQuery,
  TError = unknown,
>(
  variables: SiteBidsTableRowsQueryVariables,
  options?: Omit<UseQueryOptions<SiteBidsTableRowsQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<SiteBidsTableRowsQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteBidsTableRowsQuery, TError, TData>({
    queryKey: ["SiteBidsTableRows", variables],
    queryFn: publicFetcher<SiteBidsTableRowsQuery, SiteBidsTableRowsQueryVariables>(
      SiteBidsTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSiteBidsTableRowsQuery.getKey = (variables: SiteBidsTableRowsQueryVariables) => [
  "SiteBidsTableRows",
  variables,
]

useSiteBidsTableRowsQuery.rootKey = "SiteBidsTableRows"

export const useSuspenseSiteBidsTableRowsQuery = <
  TData = SiteBidsTableRowsQuery,
  TError = unknown,
>(
  variables: SiteBidsTableRowsQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteBidsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteBidsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteBidsTableRowsQuery, TError, TData>({
    queryKey: ["SiteBidsTableRowsSuspense", variables],
    queryFn: publicFetcher<SiteBidsTableRowsQuery, SiteBidsTableRowsQueryVariables>(
      SiteBidsTableRowsDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteBidsTableRowsQuery.getKey = (
  variables: SiteBidsTableRowsQueryVariables,
) => ["SiteBidsTableRowsSuspense", variables]

useSuspenseSiteBidsTableRowsQuery.rootKey = "SiteBidsTableRows"

export const useInfiniteSiteBidsTableRowsQuery = <
  TData = InfiniteData<SiteBidsTableRowsQuery>,
  TError = unknown,
>(
  variables: SiteBidsTableRowsQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteBidsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteBidsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteBidsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBidsTableRows.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteBidsTableRowsQuery, SiteBidsTableRowsQueryVariables>(
            SiteBidsTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteBidsTableRowsQuery.getKey = (
  variables: SiteBidsTableRowsQueryVariables,
) => ["SiteBidsTableRows.infinite", variables]

useInfiniteSiteBidsTableRowsQuery.rootKey = "SiteBidsTableRows.infinite"

export const useSuspenseInfiniteSiteBidsTableRowsQuery = <
  TData = InfiniteData<SiteBidsTableRowsQuery>,
  TError = unknown,
>(
  variables: SiteBidsTableRowsQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteBidsTableRowsQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteBidsTableRowsQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteBidsTableRowsQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteBidsTableRows.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteBidsTableRowsQuery, SiteBidsTableRowsQueryVariables>(
            SiteBidsTableRowsDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteBidsTableRowsQuery.getKey = (
  variables: SiteBidsTableRowsQueryVariables,
) => ["SiteBidsTableRows.infiniteSuspense", variables]

useSuspenseInfiniteSiteBidsTableRowsQuery.rootKey = "SiteBidsTableRows.infinite"

useSiteBidsTableRowsQuery.fetcher = (
  variables: SiteBidsTableRowsQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteBidsTableRowsQuery, SiteBidsTableRowsQueryVariables>(
    SiteBidsTableRowsDocument,
    variables,
    options,
  )

export const SiteFieldChangeLogDocument = `
    query SiteFieldChangeLog($orgSlug: String!, $sitePid: String!) {
  orgBySlug(slug: $orgSlug) {
    slug
    name
    pid
    site(pid: $sitePid) {
      pid
      fieldHistory {
        ...SiteFieldChangeLog
      }
      siteDetails {
        fieldHistory {
          ...SiteDetailsFieldChangeLog
        }
      }
    }
  }
}
    ${SiteFieldChangeLogFragmentDoc}
${FieldChangeLogHistoryFragmentDoc}
${ChangeLogEntryFragmentDoc}
${SiteDetailsFieldChangeLogFragmentDoc}`

export const useSiteFieldChangeLogQuery = <
  TData = SiteFieldChangeLogQuery,
  TError = unknown,
>(
  variables: SiteFieldChangeLogQueryVariables,
  options?: Omit<
    UseQueryOptions<SiteFieldChangeLogQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<SiteFieldChangeLogQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<SiteFieldChangeLogQuery, TError, TData>({
    queryKey: ["SiteFieldChangeLog", variables],
    queryFn: publicFetcher<SiteFieldChangeLogQuery, SiteFieldChangeLogQueryVariables>(
      SiteFieldChangeLogDocument,
      variables,
    ),
    ...options,
  })
}

useSiteFieldChangeLogQuery.getKey = (variables: SiteFieldChangeLogQueryVariables) => [
  "SiteFieldChangeLog",
  variables,
]

useSiteFieldChangeLogQuery.rootKey = "SiteFieldChangeLog"

export const useSuspenseSiteFieldChangeLogQuery = <
  TData = SiteFieldChangeLogQuery,
  TError = unknown,
>(
  variables: SiteFieldChangeLogQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<SiteFieldChangeLogQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      SiteFieldChangeLogQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<SiteFieldChangeLogQuery, TError, TData>({
    queryKey: ["SiteFieldChangeLogSuspense", variables],
    queryFn: publicFetcher<SiteFieldChangeLogQuery, SiteFieldChangeLogQueryVariables>(
      SiteFieldChangeLogDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseSiteFieldChangeLogQuery.getKey = (
  variables: SiteFieldChangeLogQueryVariables,
) => ["SiteFieldChangeLogSuspense", variables]

useSuspenseSiteFieldChangeLogQuery.rootKey = "SiteFieldChangeLog"

export const useInfiniteSiteFieldChangeLogQuery = <
  TData = InfiniteData<SiteFieldChangeLogQuery>,
  TError = unknown,
>(
  variables: SiteFieldChangeLogQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<SiteFieldChangeLogQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      SiteFieldChangeLogQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<SiteFieldChangeLogQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteFieldChangeLog.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteFieldChangeLogQuery, SiteFieldChangeLogQueryVariables>(
            SiteFieldChangeLogDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteSiteFieldChangeLogQuery.getKey = (
  variables: SiteFieldChangeLogQueryVariables,
) => ["SiteFieldChangeLog.infinite", variables]

useInfiniteSiteFieldChangeLogQuery.rootKey = "SiteFieldChangeLog.infinite"

export const useSuspenseInfiniteSiteFieldChangeLogQuery = <
  TData = InfiniteData<SiteFieldChangeLogQuery>,
  TError = unknown,
>(
  variables: SiteFieldChangeLogQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<SiteFieldChangeLogQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      SiteFieldChangeLogQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<SiteFieldChangeLogQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["SiteFieldChangeLog.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<SiteFieldChangeLogQuery, SiteFieldChangeLogQueryVariables>(
            SiteFieldChangeLogDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteSiteFieldChangeLogQuery.getKey = (
  variables: SiteFieldChangeLogQueryVariables,
) => ["SiteFieldChangeLog.infiniteSuspense", variables]

useSuspenseInfiniteSiteFieldChangeLogQuery.rootKey = "SiteFieldChangeLog.infinite"

useSiteFieldChangeLogQuery.fetcher = (
  variables: SiteFieldChangeLogQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<SiteFieldChangeLogQuery, SiteFieldChangeLogQueryVariables>(
    SiteFieldChangeLogDocument,
    variables,
    options,
  )

export const AdminUsersDocument = `
    query AdminUsers {
  admin {
    activeAdmins {
      ...UserRef
    }
  }
}
    ${UserRefFragmentDoc}`

export const useAdminUsersQuery = <TData = AdminUsersQuery, TError = unknown>(
  variables?: AdminUsersQueryVariables,
  options?: Omit<UseQueryOptions<AdminUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<AdminUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<AdminUsersQuery, TError, TData>({
    queryKey: variables === undefined ? ["AdminUsers"] : ["AdminUsers", variables],
    queryFn: publicFetcher<AdminUsersQuery, AdminUsersQueryVariables>(
      AdminUsersDocument,
      variables,
    ),
    ...options,
  })
}

useAdminUsersQuery.getKey = (variables?: AdminUsersQueryVariables) =>
  variables === undefined ? ["AdminUsers"] : ["AdminUsers", variables]

useAdminUsersQuery.rootKey = "AdminUsers"

export const useSuspenseAdminUsersQuery = <TData = AdminUsersQuery, TError = unknown>(
  variables?: AdminUsersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<AdminUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<AdminUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<AdminUsersQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["AdminUsersSuspense"]
        : ["AdminUsersSuspense", variables],
    queryFn: publicFetcher<AdminUsersQuery, AdminUsersQueryVariables>(
      AdminUsersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseAdminUsersQuery.getKey = (variables?: AdminUsersQueryVariables) =>
  variables === undefined ? ["AdminUsersSuspense"] : ["AdminUsersSuspense", variables]

useSuspenseAdminUsersQuery.rootKey = "AdminUsers"

export const useInfiniteAdminUsersQuery = <
  TData = InfiniteData<AdminUsersQuery>,
  TError = unknown,
>(
  variables: AdminUsersQueryVariables,
  options: Omit<UseInfiniteQueryOptions<AdminUsersQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseInfiniteQueryOptions<AdminUsersQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<AdminUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminUsers.infinite"]
            : ["AdminUsers.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteAdminUsersQuery.getKey = (variables?: AdminUsersQueryVariables) =>
  variables === undefined ? ["AdminUsers.infinite"] : ["AdminUsers.infinite", variables]

useInfiniteAdminUsersQuery.rootKey = "AdminUsers.infinite"

export const useSuspenseInfiniteAdminUsersQuery = <
  TData = InfiniteData<AdminUsersQuery>,
  TError = unknown,
>(
  variables: AdminUsersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<AdminUsersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      AdminUsersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<AdminUsersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["AdminUsers.infiniteSuspense"]
            : ["AdminUsers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteAdminUsersQuery.getKey = (variables?: AdminUsersQueryVariables) =>
  variables === undefined
    ? ["AdminUsers.infiniteSuspense"]
    : ["AdminUsers.infiniteSuspense", variables]

useSuspenseInfiniteAdminUsersQuery.rootKey = "AdminUsers.infinite"

useAdminUsersQuery.fetcher = (
  variables?: AdminUsersQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<AdminUsersQuery, AdminUsersQueryVariables>(
    AdminUsersDocument,
    variables,
    options,
  )

export const CollectingBidsNoticeDocument = `
    query CollectingBidsNotice($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    biddingClosedAt
  }
}
    `

export const useCollectingBidsNoticeQuery = <
  TData = CollectingBidsNoticeQuery,
  TError = unknown,
>(
  variables: CollectingBidsNoticeQueryVariables,
  options?: Omit<
    UseQueryOptions<CollectingBidsNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<CollectingBidsNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<CollectingBidsNoticeQuery, TError, TData>({
    queryKey: ["CollectingBidsNotice", variables],
    queryFn: publicFetcher<
      CollectingBidsNoticeQuery,
      CollectingBidsNoticeQueryVariables
    >(CollectingBidsNoticeDocument, variables),
    ...options,
  })
}

useCollectingBidsNoticeQuery.getKey = (
  variables: CollectingBidsNoticeQueryVariables,
) => ["CollectingBidsNotice", variables]

useCollectingBidsNoticeQuery.rootKey = "CollectingBidsNotice"

export const useSuspenseCollectingBidsNoticeQuery = <
  TData = CollectingBidsNoticeQuery,
  TError = unknown,
>(
  variables: CollectingBidsNoticeQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<CollectingBidsNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      CollectingBidsNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<CollectingBidsNoticeQuery, TError, TData>({
    queryKey: ["CollectingBidsNoticeSuspense", variables],
    queryFn: publicFetcher<
      CollectingBidsNoticeQuery,
      CollectingBidsNoticeQueryVariables
    >(CollectingBidsNoticeDocument, variables),
    ...options,
  })
}

useSuspenseCollectingBidsNoticeQuery.getKey = (
  variables: CollectingBidsNoticeQueryVariables,
) => ["CollectingBidsNoticeSuspense", variables]

useSuspenseCollectingBidsNoticeQuery.rootKey = "CollectingBidsNotice"

export const useInfiniteCollectingBidsNoticeQuery = <
  TData = InfiniteData<CollectingBidsNoticeQuery>,
  TError = unknown,
>(
  variables: CollectingBidsNoticeQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<CollectingBidsNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      CollectingBidsNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<CollectingBidsNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["CollectingBidsNotice.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<CollectingBidsNoticeQuery, CollectingBidsNoticeQueryVariables>(
            CollectingBidsNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteCollectingBidsNoticeQuery.getKey = (
  variables: CollectingBidsNoticeQueryVariables,
) => ["CollectingBidsNotice.infinite", variables]

useInfiniteCollectingBidsNoticeQuery.rootKey = "CollectingBidsNotice.infinite"

export const useSuspenseInfiniteCollectingBidsNoticeQuery = <
  TData = InfiniteData<CollectingBidsNoticeQuery>,
  TError = unknown,
>(
  variables: CollectingBidsNoticeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<CollectingBidsNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      CollectingBidsNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<CollectingBidsNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "CollectingBidsNotice.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<CollectingBidsNoticeQuery, CollectingBidsNoticeQueryVariables>(
            CollectingBidsNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteCollectingBidsNoticeQuery.getKey = (
  variables: CollectingBidsNoticeQueryVariables,
) => ["CollectingBidsNotice.infiniteSuspense", variables]

useSuspenseInfiniteCollectingBidsNoticeQuery.rootKey = "CollectingBidsNotice.infinite"

useCollectingBidsNoticeQuery.fetcher = (
  variables: CollectingBidsNoticeQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<CollectingBidsNoticeQuery, CollectingBidsNoticeQueryVariables>(
    CollectingBidsNoticeDocument,
    variables,
    options,
  )

export const LeaseExecutionDetailsRequestDocument = `
    query LeaseExecutionDetailsRequest($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    rows {
      id
      site {
        pid
        name
      }
      portfolio {
        pid
        title
      }
      awardedFinancier {
        name
      }
    }
  }
}
    `

export const useLeaseExecutionDetailsRequestQuery = <
  TData = LeaseExecutionDetailsRequestQuery,
  TError = unknown,
>(
  variables: LeaseExecutionDetailsRequestQueryVariables,
  options?: Omit<
    UseQueryOptions<LeaseExecutionDetailsRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      LeaseExecutionDetailsRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<LeaseExecutionDetailsRequestQuery, TError, TData>({
    queryKey: ["LeaseExecutionDetailsRequest", variables],
    queryFn: publicFetcher<
      LeaseExecutionDetailsRequestQuery,
      LeaseExecutionDetailsRequestQueryVariables
    >(LeaseExecutionDetailsRequestDocument, variables),
    ...options,
  })
}

useLeaseExecutionDetailsRequestQuery.getKey = (
  variables: LeaseExecutionDetailsRequestQueryVariables,
) => ["LeaseExecutionDetailsRequest", variables]

useLeaseExecutionDetailsRequestQuery.rootKey = "LeaseExecutionDetailsRequest"

export const useSuspenseLeaseExecutionDetailsRequestQuery = <
  TData = LeaseExecutionDetailsRequestQuery,
  TError = unknown,
>(
  variables: LeaseExecutionDetailsRequestQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<LeaseExecutionDetailsRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      LeaseExecutionDetailsRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<LeaseExecutionDetailsRequestQuery, TError, TData>({
    queryKey: ["LeaseExecutionDetailsRequestSuspense", variables],
    queryFn: publicFetcher<
      LeaseExecutionDetailsRequestQuery,
      LeaseExecutionDetailsRequestQueryVariables
    >(LeaseExecutionDetailsRequestDocument, variables),
    ...options,
  })
}

useSuspenseLeaseExecutionDetailsRequestQuery.getKey = (
  variables: LeaseExecutionDetailsRequestQueryVariables,
) => ["LeaseExecutionDetailsRequestSuspense", variables]

useSuspenseLeaseExecutionDetailsRequestQuery.rootKey = "LeaseExecutionDetailsRequest"

export const useInfiniteLeaseExecutionDetailsRequestQuery = <
  TData = InfiniteData<LeaseExecutionDetailsRequestQuery>,
  TError = unknown,
>(
  variables: LeaseExecutionDetailsRequestQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<LeaseExecutionDetailsRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      LeaseExecutionDetailsRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<LeaseExecutionDetailsRequestQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "LeaseExecutionDetailsRequest.infinite",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            LeaseExecutionDetailsRequestQuery,
            LeaseExecutionDetailsRequestQueryVariables
          >(LeaseExecutionDetailsRequestDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteLeaseExecutionDetailsRequestQuery.getKey = (
  variables: LeaseExecutionDetailsRequestQueryVariables,
) => ["LeaseExecutionDetailsRequest.infinite", variables]

useInfiniteLeaseExecutionDetailsRequestQuery.rootKey =
  "LeaseExecutionDetailsRequest.infinite"

export const useSuspenseInfiniteLeaseExecutionDetailsRequestQuery = <
  TData = InfiniteData<LeaseExecutionDetailsRequestQuery>,
  TError = unknown,
>(
  variables: LeaseExecutionDetailsRequestQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<LeaseExecutionDetailsRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      LeaseExecutionDetailsRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<LeaseExecutionDetailsRequestQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "LeaseExecutionDetailsRequest.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            LeaseExecutionDetailsRequestQuery,
            LeaseExecutionDetailsRequestQueryVariables
          >(LeaseExecutionDetailsRequestDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteLeaseExecutionDetailsRequestQuery.getKey = (
  variables: LeaseExecutionDetailsRequestQueryVariables,
) => ["LeaseExecutionDetailsRequest.infiniteSuspense", variables]

useSuspenseInfiniteLeaseExecutionDetailsRequestQuery.rootKey =
  "LeaseExecutionDetailsRequest.infinite"

useLeaseExecutionDetailsRequestQuery.fetcher = (
  variables: LeaseExecutionDetailsRequestQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    LeaseExecutionDetailsRequestQuery,
    LeaseExecutionDetailsRequestQueryVariables
  >(LeaseExecutionDetailsRequestDocument, variables, options)

export const DeveloperDiligenceRequestDocument = `
    query DeveloperDiligenceRequest($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    name
    rows {
      id
      site {
        pid
        name
      }
      awardedFinancier {
        name
      }
    }
  }
}
    `

export const useDeveloperDiligenceRequestQuery = <
  TData = DeveloperDiligenceRequestQuery,
  TError = unknown,
>(
  variables: DeveloperDiligenceRequestQueryVariables,
  options?: Omit<
    UseQueryOptions<DeveloperDiligenceRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<
      DeveloperDiligenceRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useQuery<DeveloperDiligenceRequestQuery, TError, TData>({
    queryKey: ["DeveloperDiligenceRequest", variables],
    queryFn: publicFetcher<
      DeveloperDiligenceRequestQuery,
      DeveloperDiligenceRequestQueryVariables
    >(DeveloperDiligenceRequestDocument, variables),
    ...options,
  })
}

useDeveloperDiligenceRequestQuery.getKey = (
  variables: DeveloperDiligenceRequestQueryVariables,
) => ["DeveloperDiligenceRequest", variables]

useDeveloperDiligenceRequestQuery.rootKey = "DeveloperDiligenceRequest"

export const useSuspenseDeveloperDiligenceRequestQuery = <
  TData = DeveloperDiligenceRequestQuery,
  TError = unknown,
>(
  variables: DeveloperDiligenceRequestQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<DeveloperDiligenceRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      DeveloperDiligenceRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<DeveloperDiligenceRequestQuery, TError, TData>({
    queryKey: ["DeveloperDiligenceRequestSuspense", variables],
    queryFn: publicFetcher<
      DeveloperDiligenceRequestQuery,
      DeveloperDiligenceRequestQueryVariables
    >(DeveloperDiligenceRequestDocument, variables),
    ...options,
  })
}

useSuspenseDeveloperDiligenceRequestQuery.getKey = (
  variables: DeveloperDiligenceRequestQueryVariables,
) => ["DeveloperDiligenceRequestSuspense", variables]

useSuspenseDeveloperDiligenceRequestQuery.rootKey = "DeveloperDiligenceRequest"

export const useInfiniteDeveloperDiligenceRequestQuery = <
  TData = InfiniteData<DeveloperDiligenceRequestQuery>,
  TError = unknown,
>(
  variables: DeveloperDiligenceRequestQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<DeveloperDiligenceRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      DeveloperDiligenceRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<DeveloperDiligenceRequestQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["DeveloperDiligenceRequest.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<
            DeveloperDiligenceRequestQuery,
            DeveloperDiligenceRequestQueryVariables
          >(DeveloperDiligenceRequestDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteDeveloperDiligenceRequestQuery.getKey = (
  variables: DeveloperDiligenceRequestQueryVariables,
) => ["DeveloperDiligenceRequest.infinite", variables]

useInfiniteDeveloperDiligenceRequestQuery.rootKey = "DeveloperDiligenceRequest.infinite"

export const useSuspenseInfiniteDeveloperDiligenceRequestQuery = <
  TData = InfiniteData<DeveloperDiligenceRequestQuery>,
  TError = unknown,
>(
  variables: DeveloperDiligenceRequestQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<DeveloperDiligenceRequestQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      DeveloperDiligenceRequestQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<DeveloperDiligenceRequestQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "DeveloperDiligenceRequest.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<
            DeveloperDiligenceRequestQuery,
            DeveloperDiligenceRequestQueryVariables
          >(DeveloperDiligenceRequestDocument, {
            ...variables,
            ...(metaData.pageParam ?? {}),
          })(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteDeveloperDiligenceRequestQuery.getKey = (
  variables: DeveloperDiligenceRequestQueryVariables,
) => ["DeveloperDiligenceRequest.infiniteSuspense", variables]

useSuspenseInfiniteDeveloperDiligenceRequestQuery.rootKey =
  "DeveloperDiligenceRequest.infinite"

useDeveloperDiligenceRequestQuery.fetcher = (
  variables: DeveloperDiligenceRequestQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<
    DeveloperDiligenceRequestQuery,
    DeveloperDiligenceRequestQueryVariables
  >(DeveloperDiligenceRequestDocument, variables, options)

export const GmailSignatureDocument = `
    query GmailSignature {
  googleApi {
    sendAs {
      signature
    }
  }
}
    `

export const useGmailSignatureQuery = <TData = GmailSignatureQuery, TError = unknown>(
  variables?: GmailSignatureQueryVariables,
  options?: Omit<UseQueryOptions<GmailSignatureQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<GmailSignatureQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<GmailSignatureQuery, TError, TData>({
    queryKey:
      variables === undefined ? ["GmailSignature"] : ["GmailSignature", variables],
    queryFn: publicFetcher<GmailSignatureQuery, GmailSignatureQueryVariables>(
      GmailSignatureDocument,
      variables,
    ),
    ...options,
  })
}

useGmailSignatureQuery.getKey = (variables?: GmailSignatureQueryVariables) =>
  variables === undefined ? ["GmailSignature"] : ["GmailSignature", variables]

useGmailSignatureQuery.rootKey = "GmailSignature"

export const useSuspenseGmailSignatureQuery = <
  TData = GmailSignatureQuery,
  TError = unknown,
>(
  variables?: GmailSignatureQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<GmailSignatureQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<GmailSignatureQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<GmailSignatureQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ["GmailSignatureSuspense"]
        : ["GmailSignatureSuspense", variables],
    queryFn: publicFetcher<GmailSignatureQuery, GmailSignatureQueryVariables>(
      GmailSignatureDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseGmailSignatureQuery.getKey = (variables?: GmailSignatureQueryVariables) =>
  variables === undefined
    ? ["GmailSignatureSuspense"]
    : ["GmailSignatureSuspense", variables]

useSuspenseGmailSignatureQuery.rootKey = "GmailSignature"

export const useInfiniteGmailSignatureQuery = <
  TData = InfiniteData<GmailSignatureQuery>,
  TError = unknown,
>(
  variables: GmailSignatureQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<GmailSignatureQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<GmailSignatureQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<GmailSignatureQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GmailSignature.infinite"]
            : ["GmailSignature.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<GmailSignatureQuery, GmailSignatureQueryVariables>(
            GmailSignatureDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteGmailSignatureQuery.getKey = (variables?: GmailSignatureQueryVariables) =>
  variables === undefined
    ? ["GmailSignature.infinite"]
    : ["GmailSignature.infinite", variables]

useInfiniteGmailSignatureQuery.rootKey = "GmailSignature.infinite"

export const useSuspenseInfiniteGmailSignatureQuery = <
  TData = InfiniteData<GmailSignatureQuery>,
  TError = unknown,
>(
  variables: GmailSignatureQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<GmailSignatureQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      GmailSignatureQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<GmailSignatureQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey:
          (optionsQueryKey ?? variables === undefined)
            ? ["GmailSignature.infiniteSuspense"]
            : ["GmailSignature.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<GmailSignatureQuery, GmailSignatureQueryVariables>(
            GmailSignatureDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteGmailSignatureQuery.getKey = (
  variables?: GmailSignatureQueryVariables,
) =>
  variables === undefined
    ? ["GmailSignature.infiniteSuspense"]
    : ["GmailSignature.infiniteSuspense", variables]

useSuspenseInfiniteGmailSignatureQuery.rootKey = "GmailSignature.infinite"

useGmailSignatureQuery.fetcher = (
  variables?: GmailSignatureQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<GmailSignatureQuery, GmailSignatureQueryVariables>(
    GmailSignatureDocument,
    variables,
    options,
  )

export const ReminderToBidDocument = `
    query ReminderToBid($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    biddingClosedAt
    bundles {
      pid
      financier {
        orgSlug
        name
        orgUsers {
          user {
            ...UserRef
          }
          userRoles {
            role
          }
        }
      }
      totalBids
      archivedAt
    }
  }
  currentUser {
    pid
    name
  }
}
    ${UserRefFragmentDoc}`

export const useReminderToBidQuery = <TData = ReminderToBidQuery, TError = unknown>(
  variables: ReminderToBidQueryVariables,
  options?: Omit<UseQueryOptions<ReminderToBidQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<ReminderToBidQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ReminderToBidQuery, TError, TData>({
    queryKey: ["ReminderToBid", variables],
    queryFn: publicFetcher<ReminderToBidQuery, ReminderToBidQueryVariables>(
      ReminderToBidDocument,
      variables,
    ),
    ...options,
  })
}

useReminderToBidQuery.getKey = (variables: ReminderToBidQueryVariables) => [
  "ReminderToBid",
  variables,
]

useReminderToBidQuery.rootKey = "ReminderToBid"

export const useSuspenseReminderToBidQuery = <
  TData = ReminderToBidQuery,
  TError = unknown,
>(
  variables: ReminderToBidQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ReminderToBidQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<ReminderToBidQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<ReminderToBidQuery, TError, TData>({
    queryKey: ["ReminderToBidSuspense", variables],
    queryFn: publicFetcher<ReminderToBidQuery, ReminderToBidQueryVariables>(
      ReminderToBidDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseReminderToBidQuery.getKey = (variables: ReminderToBidQueryVariables) => [
  "ReminderToBidSuspense",
  variables,
]

useSuspenseReminderToBidQuery.rootKey = "ReminderToBid"

export const useInfiniteReminderToBidQuery = <
  TData = InfiniteData<ReminderToBidQuery>,
  TError = unknown,
>(
  variables: ReminderToBidQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ReminderToBidQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<ReminderToBidQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<ReminderToBidQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ReminderToBid.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ReminderToBidQuery, ReminderToBidQueryVariables>(
            ReminderToBidDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteReminderToBidQuery.getKey = (variables: ReminderToBidQueryVariables) => [
  "ReminderToBid.infinite",
  variables,
]

useInfiniteReminderToBidQuery.rootKey = "ReminderToBid.infinite"

export const useSuspenseInfiniteReminderToBidQuery = <
  TData = InfiniteData<ReminderToBidQuery>,
  TError = unknown,
>(
  variables: ReminderToBidQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ReminderToBidQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ReminderToBidQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ReminderToBidQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ReminderToBid.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<ReminderToBidQuery, ReminderToBidQueryVariables>(
            ReminderToBidDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteReminderToBidQuery.getKey = (
  variables: ReminderToBidQueryVariables,
) => ["ReminderToBid.infiniteSuspense", variables]

useSuspenseInfiniteReminderToBidQuery.rootKey = "ReminderToBid.infinite"

useReminderToBidQuery.fetcher = (
  variables: ReminderToBidQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ReminderToBidQuery, ReminderToBidQueryVariables>(
    ReminderToBidDocument,
    variables,
    options,
  )

export const BidResultForLosersDocument = `
    query BidResultForLosers($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    name
    recvr {
      name
    }
    bundles {
      pid
      financier {
        pid
        orgSlug
        name
        orgUsers {
          user {
            ...UserRef
          }
          userRoles {
            role
          }
        }
      }
      archivedAt
    }
    rows {
      id
      awardedFinancier {
        pid
      }
    }
  }
  currentUser {
    pid
    name
    meetingSchedulingUrl
  }
}
    ${UserRefFragmentDoc}`

export const useBidResultForLosersQuery = <
  TData = BidResultForLosersQuery,
  TError = unknown,
>(
  variables: BidResultForLosersQueryVariables,
  options?: Omit<
    UseQueryOptions<BidResultForLosersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<BidResultForLosersQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BidResultForLosersQuery, TError, TData>({
    queryKey: ["BidResultForLosers", variables],
    queryFn: publicFetcher<BidResultForLosersQuery, BidResultForLosersQueryVariables>(
      BidResultForLosersDocument,
      variables,
    ),
    ...options,
  })
}

useBidResultForLosersQuery.getKey = (variables: BidResultForLosersQueryVariables) => [
  "BidResultForLosers",
  variables,
]

useBidResultForLosersQuery.rootKey = "BidResultForLosers"

export const useSuspenseBidResultForLosersQuery = <
  TData = BidResultForLosersQuery,
  TError = unknown,
>(
  variables: BidResultForLosersQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BidResultForLosersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      BidResultForLosersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<BidResultForLosersQuery, TError, TData>({
    queryKey: ["BidResultForLosersSuspense", variables],
    queryFn: publicFetcher<BidResultForLosersQuery, BidResultForLosersQueryVariables>(
      BidResultForLosersDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBidResultForLosersQuery.getKey = (
  variables: BidResultForLosersQueryVariables,
) => ["BidResultForLosersSuspense", variables]

useSuspenseBidResultForLosersQuery.rootKey = "BidResultForLosers"

export const useInfiniteBidResultForLosersQuery = <
  TData = InfiniteData<BidResultForLosersQuery>,
  TError = unknown,
>(
  variables: BidResultForLosersQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BidResultForLosersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      BidResultForLosersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<BidResultForLosersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BidResultForLosers.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<BidResultForLosersQuery, BidResultForLosersQueryVariables>(
            BidResultForLosersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBidResultForLosersQuery.getKey = (
  variables: BidResultForLosersQueryVariables,
) => ["BidResultForLosers.infinite", variables]

useInfiniteBidResultForLosersQuery.rootKey = "BidResultForLosers.infinite"

export const useSuspenseInfiniteBidResultForLosersQuery = <
  TData = InfiniteData<BidResultForLosersQuery>,
  TError = unknown,
>(
  variables: BidResultForLosersQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BidResultForLosersQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BidResultForLosersQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BidResultForLosersQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BidResultForLosers.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<BidResultForLosersQuery, BidResultForLosersQueryVariables>(
            BidResultForLosersDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBidResultForLosersQuery.getKey = (
  variables: BidResultForLosersQueryVariables,
) => ["BidResultForLosers.infiniteSuspense", variables]

useSuspenseInfiniteBidResultForLosersQuery.rootKey = "BidResultForLosers.infinite"

useBidResultForLosersQuery.fetcher = (
  variables: BidResultForLosersQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BidResultForLosersQuery, BidResultForLosersQueryVariables>(
    BidResultForLosersDocument,
    variables,
    options,
  )

export const BidLaunchNoticeDocument = `
    query BidLaunchNotice($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    name
    totalPvSizeKwDc
    pricingNote
    biddingClosedAt
    type
    recvr {
      name
    }
    bundles {
      pid
      financier {
        orgSlug
        name
        orgUsers {
          user {
            ...UserRef
          }
          userRoles {
            role
          }
        }
      }
    }
    rows {
      id
      specs {
        ppa {
          id
          system {
            pvSpecs {
              pvTypes
            }
          }
        }
        cs {
          id
          systemLite {
            pvSpecs {
              pvTypes
            }
          }
        }
      }
      site {
        state
      }
    }
  }
  currentUser {
    pid
    meetingSchedulingUrl
  }
}
    ${UserRefFragmentDoc}`

export const useBidLaunchNoticeQuery = <TData = BidLaunchNoticeQuery, TError = unknown>(
  variables: BidLaunchNoticeQueryVariables,
  options?: Omit<UseQueryOptions<BidLaunchNoticeQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<BidLaunchNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<BidLaunchNoticeQuery, TError, TData>({
    queryKey: ["BidLaunchNotice", variables],
    queryFn: publicFetcher<BidLaunchNoticeQuery, BidLaunchNoticeQueryVariables>(
      BidLaunchNoticeDocument,
      variables,
    ),
    ...options,
  })
}

useBidLaunchNoticeQuery.getKey = (variables: BidLaunchNoticeQueryVariables) => [
  "BidLaunchNotice",
  variables,
]

useBidLaunchNoticeQuery.rootKey = "BidLaunchNotice"

export const useSuspenseBidLaunchNoticeQuery = <
  TData = BidLaunchNoticeQuery,
  TError = unknown,
>(
  variables: BidLaunchNoticeQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<BidLaunchNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<BidLaunchNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<BidLaunchNoticeQuery, TError, TData>({
    queryKey: ["BidLaunchNoticeSuspense", variables],
    queryFn: publicFetcher<BidLaunchNoticeQuery, BidLaunchNoticeQueryVariables>(
      BidLaunchNoticeDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseBidLaunchNoticeQuery.getKey = (variables: BidLaunchNoticeQueryVariables) => [
  "BidLaunchNoticeSuspense",
  variables,
]

useSuspenseBidLaunchNoticeQuery.rootKey = "BidLaunchNotice"

export const useInfiniteBidLaunchNoticeQuery = <
  TData = InfiniteData<BidLaunchNoticeQuery>,
  TError = unknown,
>(
  variables: BidLaunchNoticeQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<BidLaunchNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<BidLaunchNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<BidLaunchNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BidLaunchNotice.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<BidLaunchNoticeQuery, BidLaunchNoticeQueryVariables>(
            BidLaunchNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteBidLaunchNoticeQuery.getKey = (variables: BidLaunchNoticeQueryVariables) => [
  "BidLaunchNotice.infinite",
  variables,
]

useInfiniteBidLaunchNoticeQuery.rootKey = "BidLaunchNotice.infinite"

export const useSuspenseInfiniteBidLaunchNoticeQuery = <
  TData = InfiniteData<BidLaunchNoticeQuery>,
  TError = unknown,
>(
  variables: BidLaunchNoticeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<BidLaunchNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      BidLaunchNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<BidLaunchNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["BidLaunchNotice.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<BidLaunchNoticeQuery, BidLaunchNoticeQueryVariables>(
            BidLaunchNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteBidLaunchNoticeQuery.getKey = (
  variables: BidLaunchNoticeQueryVariables,
) => ["BidLaunchNotice.infiniteSuspense", variables]

useSuspenseInfiniteBidLaunchNoticeQuery.rootKey = "BidLaunchNotice.infinite"

useBidLaunchNoticeQuery.fetcher = (
  variables: BidLaunchNoticeQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<BidLaunchNoticeQuery, BidLaunchNoticeQueryVariables>(
    BidLaunchNoticeDocument,
    variables,
    options,
  )

export const HostAwardNoticeDocument = `
    query HostAwardNotice($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    recvr {
      name
    }
    rows {
      awardedFinancier {
        name
        orgUsers {
          user {
            ...UserRef
          }
          userRoles {
            role
          }
        }
      }
      portfolio {
        title
      }
      site {
        name
        buildingType
        state
      }
    }
  }
  currentUser {
    pid
    meetingSchedulingUrl
  }
}
    ${UserRefFragmentDoc}`

export const useHostAwardNoticeQuery = <TData = HostAwardNoticeQuery, TError = unknown>(
  variables: HostAwardNoticeQueryVariables,
  options?: Omit<UseQueryOptions<HostAwardNoticeQuery, TError, TData>, "queryKey"> & {
    queryKey?: UseQueryOptions<HostAwardNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<HostAwardNoticeQuery, TError, TData>({
    queryKey: ["HostAwardNotice", variables],
    queryFn: publicFetcher<HostAwardNoticeQuery, HostAwardNoticeQueryVariables>(
      HostAwardNoticeDocument,
      variables,
    ),
    ...options,
  })
}

useHostAwardNoticeQuery.getKey = (variables: HostAwardNoticeQueryVariables) => [
  "HostAwardNotice",
  variables,
]

useHostAwardNoticeQuery.rootKey = "HostAwardNotice"

export const useSuspenseHostAwardNoticeQuery = <
  TData = HostAwardNoticeQuery,
  TError = unknown,
>(
  variables: HostAwardNoticeQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<HostAwardNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<HostAwardNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useSuspenseQuery<HostAwardNoticeQuery, TError, TData>({
    queryKey: ["HostAwardNoticeSuspense", variables],
    queryFn: publicFetcher<HostAwardNoticeQuery, HostAwardNoticeQueryVariables>(
      HostAwardNoticeDocument,
      variables,
    ),
    ...options,
  })
}

useSuspenseHostAwardNoticeQuery.getKey = (variables: HostAwardNoticeQueryVariables) => [
  "HostAwardNoticeSuspense",
  variables,
]

useSuspenseHostAwardNoticeQuery.rootKey = "HostAwardNotice"

export const useInfiniteHostAwardNoticeQuery = <
  TData = InfiniteData<HostAwardNoticeQuery>,
  TError = unknown,
>(
  variables: HostAwardNoticeQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<HostAwardNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<HostAwardNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useInfiniteQuery<HostAwardNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["HostAwardNotice.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<HostAwardNoticeQuery, HostAwardNoticeQueryVariables>(
            HostAwardNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteHostAwardNoticeQuery.getKey = (variables: HostAwardNoticeQueryVariables) => [
  "HostAwardNotice.infinite",
  variables,
]

useInfiniteHostAwardNoticeQuery.rootKey = "HostAwardNotice.infinite"

export const useSuspenseInfiniteHostAwardNoticeQuery = <
  TData = InfiniteData<HostAwardNoticeQuery>,
  TError = unknown,
>(
  variables: HostAwardNoticeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<HostAwardNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      HostAwardNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<HostAwardNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["HostAwardNotice.infiniteSuspense", variables],
        queryFn: (metaData) =>
          publicFetcher<HostAwardNoticeQuery, HostAwardNoticeQueryVariables>(
            HostAwardNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteHostAwardNoticeQuery.getKey = (
  variables: HostAwardNoticeQueryVariables,
) => ["HostAwardNotice.infiniteSuspense", variables]

useSuspenseInfiniteHostAwardNoticeQuery.rootKey = "HostAwardNotice.infinite"

useHostAwardNoticeQuery.fetcher = (
  variables: HostAwardNoticeQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<HostAwardNoticeQuery, HostAwardNoticeQueryVariables>(
    HostAwardNoticeDocument,
    variables,
    options,
  )

export const ProjectKickoffNoticeDocument = `
    query ProjectKickoffNotice($orgSlug: String!, $parentPid: String!) {
  bundleParentDetail(orgSlug: $orgSlug, parentPid: $parentPid) {
    pid
    rows {
      awardedFinancier {
        name
      }
    }
  }
}
    `

export const useProjectKickoffNoticeQuery = <
  TData = ProjectKickoffNoticeQuery,
  TError = unknown,
>(
  variables: ProjectKickoffNoticeQueryVariables,
  options?: Omit<
    UseQueryOptions<ProjectKickoffNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseQueryOptions<ProjectKickoffNoticeQuery, TError, TData>["queryKey"]
  },
) => {
  return useQuery<ProjectKickoffNoticeQuery, TError, TData>({
    queryKey: ["ProjectKickoffNotice", variables],
    queryFn: publicFetcher<
      ProjectKickoffNoticeQuery,
      ProjectKickoffNoticeQueryVariables
    >(ProjectKickoffNoticeDocument, variables),
    ...options,
  })
}

useProjectKickoffNoticeQuery.getKey = (
  variables: ProjectKickoffNoticeQueryVariables,
) => ["ProjectKickoffNotice", variables]

useProjectKickoffNoticeQuery.rootKey = "ProjectKickoffNotice"

export const useSuspenseProjectKickoffNoticeQuery = <
  TData = ProjectKickoffNoticeQuery,
  TError = unknown,
>(
  variables: ProjectKickoffNoticeQueryVariables,
  options?: Omit<
    UseSuspenseQueryOptions<ProjectKickoffNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseQueryOptions<
      ProjectKickoffNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseQuery<ProjectKickoffNoticeQuery, TError, TData>({
    queryKey: ["ProjectKickoffNoticeSuspense", variables],
    queryFn: publicFetcher<
      ProjectKickoffNoticeQuery,
      ProjectKickoffNoticeQueryVariables
    >(ProjectKickoffNoticeDocument, variables),
    ...options,
  })
}

useSuspenseProjectKickoffNoticeQuery.getKey = (
  variables: ProjectKickoffNoticeQueryVariables,
) => ["ProjectKickoffNoticeSuspense", variables]

useSuspenseProjectKickoffNoticeQuery.rootKey = "ProjectKickoffNotice"

export const useInfiniteProjectKickoffNoticeQuery = <
  TData = InfiniteData<ProjectKickoffNoticeQuery>,
  TError = unknown,
>(
  variables: ProjectKickoffNoticeQueryVariables,
  options: Omit<
    UseInfiniteQueryOptions<ProjectKickoffNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseInfiniteQueryOptions<
      ProjectKickoffNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useInfiniteQuery<ProjectKickoffNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? ["ProjectKickoffNotice.infinite", variables],
        queryFn: (metaData) =>
          publicFetcher<ProjectKickoffNoticeQuery, ProjectKickoffNoticeQueryVariables>(
            ProjectKickoffNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useInfiniteProjectKickoffNoticeQuery.getKey = (
  variables: ProjectKickoffNoticeQueryVariables,
) => ["ProjectKickoffNotice.infinite", variables]

useInfiniteProjectKickoffNoticeQuery.rootKey = "ProjectKickoffNotice.infinite"

export const useSuspenseInfiniteProjectKickoffNoticeQuery = <
  TData = InfiniteData<ProjectKickoffNoticeQuery>,
  TError = unknown,
>(
  variables: ProjectKickoffNoticeQueryVariables,
  options: Omit<
    UseSuspenseInfiniteQueryOptions<ProjectKickoffNoticeQuery, TError, TData>,
    "queryKey"
  > & {
    queryKey?: UseSuspenseInfiniteQueryOptions<
      ProjectKickoffNoticeQuery,
      TError,
      TData
    >["queryKey"]
  },
) => {
  return useSuspenseInfiniteQuery<ProjectKickoffNoticeQuery, TError, TData>(
    (() => {
      const { queryKey: optionsQueryKey, ...restOptions } = options
      return {
        queryKey: optionsQueryKey ?? [
          "ProjectKickoffNotice.infiniteSuspense",
          variables,
        ],
        queryFn: (metaData) =>
          publicFetcher<ProjectKickoffNoticeQuery, ProjectKickoffNoticeQueryVariables>(
            ProjectKickoffNoticeDocument,
            { ...variables, ...(metaData.pageParam ?? {}) },
          )(),
        ...restOptions,
      }
    })(),
  )
}

useSuspenseInfiniteProjectKickoffNoticeQuery.getKey = (
  variables: ProjectKickoffNoticeQueryVariables,
) => ["ProjectKickoffNotice.infiniteSuspense", variables]

useSuspenseInfiniteProjectKickoffNoticeQuery.rootKey = "ProjectKickoffNotice.infinite"

useProjectKickoffNoticeQuery.fetcher = (
  variables: ProjectKickoffNoticeQueryVariables,
  options?: RequestInit["headers"],
) =>
  publicFetcher<ProjectKickoffNoticeQuery, ProjectKickoffNoticeQueryVariables>(
    ProjectKickoffNoticeDocument,
    variables,
    options,
  )
